{
  "actions": [
    {
      "id": "finale-summons",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Tell the court you have carried the last of its errands",
      "intention": "ask",
      "text": "That is the last errand I carry for this court. What is left on your table?",
      "reply": "Something that came down the towpath this morning under a Senate seal. Advocate Idrin Vasko of Caldris claims our granary against the bread-fund bonds, and the Senate court will hear him. His clerk says the Silt Stair has done business with the dead this season, and he brought a list of where. His witness is Leth An. Ildren Vos read Leth’s hands while he still worked in the kilns, and Vasko bought the reading. She will stand in the basilica and tell the court what a dead porter’s fingers meant. If the court believes her, the granary is Vasko’s by the next barge. I cannot send a clerk to argue with a corpse. I can send you.",
      "journal": "Advocate Vasko claims the Silt Stair’s granary before the Senate court in Caldris. His witness is Leth An, dead, as Ildren Vos reads his hands. Someone living who knew Leth, and proof of what her reading can and cannot show, might answer him.",
      "prerequisites": {
        "all": [
          "convergence:n03"
        ],
        "any": [
          "errand:z01:done",
          "errand:z02:done",
          "errand:z06:done"
        ],
        "none": [
          "errand:z01:underway",
          "errand:z02:underway",
          "errand:z06:underway",
          "campaign:B4",
          "campaign:B6"
        ]
      },
      "effects": {
        "add": [
          "campaign:B4",
          "finale:hearing"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "finale-quiet",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Tell the court you have carried the last of its errands",
      "intention": "ask",
      "text": "That is the last errand I carry for this court. What is left on your table?",
      "reply": "Letters, grain counts, and a complaint about the smell from the kilns. Nothing that wants a court. Advocate Idrin Vasko’s clerk came down the towpath asking whether anyone here had paid for a dead man’s word this season. Nobody had, so he took the next barge home. The one question left is the one we started with: this season’s grain. This season’s grain can feed the landing through the winter, or it can fill the barges Caldris counts on. It cannot do both.",
      "journal": "Nothing came down the river that needs a court. Advocate Vasko’s clerk came asking whether the Silt Stair had bought a dead man’s word this season, and found nothing. The court must decide where this season’s grain goes: to the landing’s own winter, or up the towpath to Caldris.",
      "prerequisites": {
        "all": [],
        "any": [
          "errand:z01:done",
          "errand:z02:done",
          "errand:z06:done"
        ],
        "none": [
          "errand:z01:underway",
          "errand:z02:underway",
          "errand:z06:underway",
          "campaign:B4",
          "campaign:B6",
          "convergence:n03",
          "fact:operation-supported",
          "fact:witnesses-intimidated",
          "pressure:z01:advocate-paid",
          "pressure:z02:dead-testimony",
          "pressure:z06:coffins-uninspected",
          "pressure:z01:sealed-over-drowned",
          "pressure:z06:roll-countersigned"
        ]
      },
      "effects": {
        "add": [
          "campaign:B4",
          "finale:containment",
          "finale:kind"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "finale-contain",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Tell the court you have carried the last of its errands",
      "intention": "ask",
      "text": "That is the last errand I carry for this court. What is left on your table?",
      "reply": "Letters, grain counts, and a clerk. Advocate Idrin Vasko’s clerk sat on our steps all yesterday, copying the grain count and asking what our granary is pledged against. He knows what was done for the dead this season, and where. Ildren Vos reads for his master. Vasko brings no claim he cannot win, so he is waiting for one he can. That leaves this season’s grain. Keep it here and the landing eats, but we owe Caldris a season, and a debt is something he can buy. Send it up the towpath and the landing rations, but the pledge is paid, and there is nothing for him to claim.",
      "journal": "Nothing is before a court yet, but Advocate Vasko is waiting for a claim on the Silt Stair, and his clerk knows what was done for the dead this season. If the court keeps its grain, it owes Caldris a debt Vasko can buy. If it sends the grain, the pledge is paid and he has nothing to claim.",
      "prerequisites": {
        "all": [
          "campaign:B2"
        ],
        "any": [
          "fact:operation-supported",
          "fact:witnesses-intimidated",
          "pressure:z01:advocate-paid",
          "pressure:z02:dead-testimony",
          "pressure:z06:coffins-uninspected",
          "pressure:z01:sealed-over-drowned",
          "pressure:z06:roll-countersigned"
        ],
        "none": [
          "errand:z01:underway",
          "errand:z02:underway",
          "errand:z06:underway",
          "campaign:B4",
          "campaign:B6",
          "convergence:n03"
        ]
      },
      "effects": {
        "add": [
          "campaign:B4",
          "finale:containment"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "n03-vasko",
      "beatId": "beat:z01-basilica",
      "speakerId": "z01-advocate",
      "label": "Ask Vasko what exactly he claims",
      "intention": "ask",
      "text": "The Silt Stair’s granary. On what?",
      "reply": "On the bread-fund bonds, which the Silt Stair’s grain was pledged to cover. Leth An carried sacks into that granary for nine years and counted every one. Ildren Vos has read the count in his hands: the granary, pledged. Bring the court whatever you like. It has heard the dead for as long as I have practised before it, and it has never yet caught one lying.",
      "journal": "Vasko claims the Silt Stair’s granary on the bread-fund bonds. His proof is Ildren Vos’s reading of Leth An’s counting hand, which she says is the granary’s pledge.",
      "prerequisites": {
        "all": [
          "finale:hearing"
        ],
        "any": [],
        "none": [
          "finale:claim-heard",
          "campaign:B5"
        ]
      },
      "effects": {
        "add": [
          "finale:claim-heard"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "n03-withdraw",
      "beatId": "beat:z01-basilica",
      "speakerId": "z01-advocate",
      "label": "Pay Vasko to withdraw his claim — 15 cuts; the reading stays on the court’s roll as good evidence",
      "intention": "offer",
      "text": "What would it cost you to withdraw?",
      "reply": "{Cuts}, and I tell the court the Silt Stair and I have come to terms. The reading stays on the roll, of course. It was good evidence yesterday, and it will be good evidence tomorrow.",
      "journal": "Paid {cuts} to Advocate Vasko to withdraw his claim on the Silt Stair’s granary. The granary stays with the Silt Stair. Leth An’s reading stays on the Senate court’s roll as good evidence.",
      "prerequisites": {
        "all": [
          "finale:hearing",
          "finale:claim-heard"
        ],
        "any": [],
        "none": [
          "campaign:B5"
        ]
      },
      "effects": {
        "add": [
          "campaign:B5",
          "finale:n03:bought"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 15,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "n03-annex-watch",
      "beatId": "beat:z01-archive-stair",
      "speakerId": null,
      "label": "Pay the annex keeper to let you stand at the back while Ildren Vos rehearses — 4 cuts",
      "intention": "offer",
      "text": "{Cuts} for a place at the back of the annex. I was never here.",
      "reply": "Behind the grille, in the burial annex, Ildren Vos has set up her trestles. She does not have Leth with her. She has his count, drawn in wax. Vasko’s clerk reads a question from a tablet: what did the granary pledge? Vos lifts two fingers, lowers them, lifts them again. The clerk writes the answer on the same tablet before her hand is down. It is the answer he read out with the question.",
      "journal": "Paid {cuts} to watch Ildren Vos rehearse Leth An’s reading in the burial annex. Vasko’s clerk reads the question and the answer from one tablet. The hand only counts.",
      "prerequisites": {
        "all": [
          "finale:hearing"
        ],
        "any": [],
        "none": [
          "finale:reading-watched",
          "finale:ledger-seized",
          "campaign:B5"
        ]
      },
      "effects": {
        "add": [
          "finale:reading-watched"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 4,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "n03-annex-seize",
      "beatId": "beat:z01-archive-stair",
      "speakerId": null,
      "label": "Take Vos’s reading book from the advocate’s doorman by force",
      "intention": "threaten",
      "text": "Stand aside. I am taking the book.",
      "reply": "The doorman puts the book behind him and brings his fists up.",
      "journal": "Went for Ildren Vos’s reading book at the burial annex, through the advocate’s doorman.",
      "prerequisites": {
        "all": [
          "finale:hearing"
        ],
        "any": [],
        "none": [
          "finale:ledger-seized",
          "finale:reading-watched",
          "campaign:B5"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "fight",
      "afterResolution": true,
      "encounter": "n03-annex-doorman"
    },
    {
      "id": "n03-nessa",
      "beatId": "beat:lower-landing",
      "speakerId": "nessa",
      "label": "Ask Nessa to go up the towpath and tell the Senate court what Leth’s count meant — pay her passage, 4 cuts",
      "intention": "offer",
      "text": "Vasko says Leth An’s hands pledged the granary. Will you tell the Senate court what they meant? {Cuts} pays your passage.",
      "reply": "Leth counted every sack twice, two fingers, because the tally slab was never where it should be. I checked his tallies for nine years. It was never a pledge. It was a tired man not trusting himself. I will say it in their basilica, and I will say it slowly.",
      "journal": "Paid {cuts} for Nessa Tal’s passage to Caldris. She will tell the Senate court that Leth An’s count was a porter’s habit, not a pledge.",
      "prerequisites": {
        "all": [
          "finale:hearing"
        ],
        "any": [],
        "none": [
          "finale:nessa-witness",
          "campaign:B5"
        ]
      },
      "effects": {
        "add": [
          "finale:nessa-witness"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 4,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "n03-court-sits",
      "beatId": "beat:z01-basilica",
      "speakerId": null,
      "label": "Take a place on the benches as the Senate court sits for Vasko’s claim",
      "intention": "ask",
      "text": "I will hear this from the benches.",
      "reply": "The benches fill from the back: bondholders, porters’ widows, a clerk from each dais. The reading clerk unrolls Vasko’s claim and reads out first what brought it before the court. {reckoning:finale-summons} Then Ildren Vos sets Leth An’s count on her trestle, drawn in wax, and lifts two fingers. “Granary,” she says. “Pledged.” The reading clerk asks whether the Silt Stair answers her. The court will wait one sitting for its answer.",
      "journal": "The Senate court sat for Vasko’s claim. The reading clerk read out what the Silt Stair’s season had done for the dead, and Ildren Vos read Leth An’s two fingers as the granary’s pledge. The court waits one sitting for the Silt Stair’s answer.",
      "prerequisites": {
        "all": [
          "finale:hearing"
        ],
        "any": [],
        "none": [
          "finale:court-sat",
          "campaign:B5"
        ]
      },
      "effects": {
        "add": [
          "finale:court-sat"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "n03-hearing",
      "beatId": "beat:z01-basilica",
      "speakerId": null,
      "label": "Put Nessa Tal, and what you know of Vos’s reading, before the Senate court",
      "intention": "offer",
      "text": "Hear a living witness before you hear the dead one.",
      "reply": "Nessa Tal comes down from the back bench in her dust-coloured shawl and stands beside Ildren Vos’s trestle.",
      "journal": "The Senate court at Caldris struck Leth An’s reading from its roll and dismissed Vasko’s claim. The Silt Stair keeps its granary. A living witness was heard over a dead one.",
      "prerequisites": {
        "all": [
          "finale:hearing",
          "finale:nessa-witness",
          "finale:court-sat"
        ],
        "any": [
          "finale:reading-watched",
          "finale:ledger-seized"
        ],
        "none": [
          "campaign:B5"
        ]
      },
      "effects": {
        "add": [
          "campaign:B5",
          "finale:n03:struck"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "spoken": [
        {
          "speakerId": "nessa",
          "text": "Leth An counted every sack twice, two fingers, because the tally slab was never where it should be. I checked his tallies for nine years. That hand is a tired man not trusting himself. It never pledged anything."
        },
        {
          "speaker": "The reading clerk",
          "text": "Ildren Vos. Did the hand say granary?"
        },
        {
          "speakerId": "z02-vos",
          "text": "The hand counted."
        },
        {
          "speaker": "The reading clerk",
          "text": "Then who said granary?"
        },
        {
          "speakerId": "z01-advocate",
          "text": "The court has heard the dead for as long as I have practised before it."
        },
        {
          "speaker": "The reading clerk",
          "text": "And today it heard the living. The reading is struck from the roll. The claim is dismissed."
        }
      ]
    },
    {
      "id": "n03-hearing-alone",
      "beatId": "beat:z01-basilica",
      "speakerId": null,
      "label": "Put the seized reading book before the Senate court, with no living witness",
      "intention": "offer",
      "text": "This is Vos’s book. Read what the clerk wrote before the hand moved.",
      "reply": "The reading clerk turns the pages of Ildren Vos’s book, taken from her annex by force.",
      "journal": "The Senate court read the book you took by force and still found for Vasko: nobody living stood up to say what Leth An’s count meant. The Silt Stair’s granary goes to the bondholders.",
      "prerequisites": {
        "all": [
          "finale:hearing",
          "finale:ledger-seized",
          "finale:court-sat"
        ],
        "any": [],
        "none": [
          "finale:nessa-witness",
          "campaign:B5"
        ]
      },
      "effects": {
        "add": [
          "campaign:B5",
          "finale:n03:lost"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "spoken": [
        {
          "speaker": "The reading clerk",
          "text": "It shows what the advocate’s clerk asked. It does not show what the hand meant. Who here knew the man?"
        },
        {
          "speakerId": "z01-advocate",
          "text": "Nobody, it seems. Only Leth An, and he has answered."
        },
        {
          "speaker": "The reading clerk",
          "text": "The court finds for the advocate. The book goes on the complaint against a person unknown."
        }
      ]
    },
    {
      "id": "n03-concede",
      "beatId": "beat:z01-basilica",
      "speakerId": null,
      "label": "Let Vasko’s claim be heard with no answer",
      "intention": "ask",
      "text": "Let him have his hearing.",
      "reply": "Nobody answers Ildren Vos. The reading clerk writes the finding into the roll.",
      "journal": "The Senate court at Caldris found for Vasko on Leth An’s reading. The Silt Stair’s granary stands surety for the bread-fund bonds, and its grain goes up the towpath to the bondholders.",
      "prerequisites": {
        "all": [
          "finale:hearing",
          "finale:court-sat"
        ],
        "any": [],
        "none": [
          "finale:ledger-seized",
          "campaign:B5"
        ]
      },
      "effects": {
        "add": [
          "campaign:B5",
          "finale:n03:lost"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "spoken": [
        {
          "speaker": "The reading clerk",
          "text": "The Silt Stair’s granary stands surety for the bread-fund bonds. The bondholders may take its grain from the next barge."
        },
        {
          "speakerId": "z01-advocate",
          "text": "The court has my thanks. Both of its daises."
        }
      ]
    },
    {
      "id": "containment-keep",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Keep this season’s grain at the Silt Stair — Caldris will count the barges short",
      "intention": "offer",
      "text": "Keep the grain here. The landing eats first this winter.",
      "reply": "Then I write to Caldris that our barges come light, and why, and they write back that we owe them. We will owe them. The landing will eat. I will chalk the grain count on the court door every morning, so nobody can say we hid it.",
      "journal": "Told the court to keep this season’s grain at the Silt Stair. The landing eats through the winter. Caldris counts the Silt Stair’s barges short, and the court owes it.",
      "prerequisites": {
        "all": [
          "finale:containment"
        ],
        "any": [],
        "none": [
          "campaign:B5"
        ]
      },
      "effects": {
        "add": [
          "campaign:B5",
          "finale:containment:kept"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "containment-send",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Send the grain up the towpath to Caldris as promised — the landing rations its bread",
      "intention": "offer",
      "text": "Send it upriver. Caldris counts on it.",
      "reply": "Then the barges go full and the landing rations. Bread stays at {bread}, and the queue at the market stays where it is. Caldris will count our grain as honest. That is worth something next year. This winter it is worth less.",
      "journal": "Told the court to send this season’s grain up the towpath to Caldris. The barges go full, and the landing rations its bread through the winter.",
      "prerequisites": {
        "all": [
          "finale:containment"
        ],
        "any": [],
        "none": [
          "campaign:B5"
        ]
      },
      "effects": {
        "add": [
          "campaign:B5",
          "finale:containment:sent"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "finale-depart",
      "beatId": "z04-dry-cut",
      "speakerId": null,
      "label": "Walk out of the basin through the Dry Cut",
      "intention": "leave",
      "text": "Past the staple, and on.",
      "reply": "The cut runs on past the staple, narrow and dry, and climbs. By first light you are on the chalk above the basin with the river behind you. Nobody at the landing sees you go. Everything you did down there stays done.",
      "journal": "Left the Orsene basin through the Dry Cut.",
      "prerequisites": {
        "all": [
          "campaign:B5",
          "fact:local-aftermath-observed"
        ],
        "any": [],
        "none": [
          "campaign:B6"
        ]
      },
      "effects": {
        "add": [
          "campaign:B6",
          "finale:departed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "coffin",
      "beatId": "beat:lower-landing",
      "speakerId": null,
      "label": "Inspect the coffin",
      "intention": "ask",
      "text": "Lift the lid.",
      "reply": "A shallow dent marks the lining where a shoulder lay. The coffin was occupied. A broken cart seal is caught under the hinge.",
      "journal": "The coffin carried a body. The lost-cargo form conceals its removal.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "campaign:B0"
        ],
        "remove": []
      },
      "arcActionId": "slice.M0-inspect-coffin",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "nessa-account",
      "beatId": "beat:lower-landing",
      "speakerId": "nessa",
      "label": "Ask what she saw",
      "intention": "ask",
      "text": "Who took the body?",
      "reply": "A concession cart, with a proper seal. Leth An was inside this morning. Find his wage tally in the lift yard. They want to blame Melian because she buys the same salt. That leaves the contractor’s repair money untouched.",
      "journal": "Nessa names Leth An and his wage tally. The proposed accusation against Melian rests on shared salt; it would protect the contractor’s repair income.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:nessa-heard",
          "campaign:B0"
        ],
        "remove": []
      },
      "arcActionId": "slice.M0-hear-porter",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "meal",
      "beatId": "beat:lower-landing",
      "speakerId": "nessa",
      "label": "Buy bread for the waiting porters — 4 cuts",
      "intention": "offer",
      "text": "Eat first. I will pay for the bread.",
      "reply": "Then I can ask them to stay. Take my tally up the workers’ stair; the guard knows it. I am still owed wages, mind. Bread is not a receipt.",
      "journal": "Four cuts fed the porters. They stay at the barge; Nessa lends her toll tally.",
      "prerequisites": {
        "all": [
          "story:nessa-heard"
        ],
        "any": [],
        "none": [
          "story:opening-choice"
        ]
      },
      "effects": {
        "add": [
          "story:opening-choice",
          "story:porters-fed",
          "story:toll-pass"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 4,
      "rewardCuts": 0,
      "operation": "meal",
      "afterResolution": false
    },
    {
      "id": "false-report",
      "beatId": "beat:lower-landing",
      "speakerId": "nessa",
      "label": "Sign “lost cargo” for a 4-cut fee",
      "intention": "offer",
      "text": "I will sign the cargo report. Pay the witnessing fee.",
      "reply": "Here. Four cuts for making a person into a misplaced crate. They will pin it on Melian now. She buys the same salt. That is the whole of their case.",
      "journal": "You took four cuts for a false report. Nessa withdraws her trust; Melian’s shutter closes under accusation.",
      "prerequisites": {
        "all": [
          "story:nessa-heard"
        ],
        "any": [],
        "none": [
          "story:opening-choice"
        ]
      },
      "effects": {
        "add": [
          "story:opening-choice",
          "story:false-report"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 4,
      "operation": "accuse",
      "afterResolution": false
    },
    {
      "id": "claim-pay",
      "beatId": "beat:lower-landing",
      "speakerId": "nessa",
      "label": "Pay the widow’s claim fee — 3 cuts",
      "intention": "offer",
      "text": "{Cuts}. Put his name on the claim before the cart comes.",
      "reply": "She will not thank you. She will be at the kiln gate before dark with the receipt in her fist, and that is better than thanks.",
      "journal": "Paid {cuts} so a porter who fell on the stair is claimed and buried, not sold to the gallery as unclaimed.",
      "prerequisites": {
        "all": [
          "z04:contract-gallery"
        ],
        "any": [],
        "none": [
          "z04:claim-paid",
          "z04:claim-left"
        ]
      },
      "effects": {
        "add": [
          "z04:claim-paid"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 3,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "claim-leave",
      "beatId": "beat:lower-landing",
      "speakerId": "nessa",
      "label": "Keep your cuts: the court can pay its own claims",
      "intention": "ask",
      "text": "I cannot pay every fee on this landing.",
      "reply": "No. Nobody can. That is what the contract counts on.",
      "journal": "Left a porter’s claim fee unpaid. Tonight the cart takes him up to the gallery as unclaimed.",
      "prerequisites": {
        "all": [
          "z04:contract-gallery"
        ],
        "any": [],
        "none": [
          "z04:claim-paid",
          "z04:claim-left"
        ]
      },
      "effects": {
        "add": [
          "z04:claim-left"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "urn-promise",
      "beatId": "beat:lower-landing",
      "speakerId": "nessa",
      "label": "Promise to find her mother’s urn before the shelf is cleared",
      "intention": "offer",
      "text": "I will find it before they clear it. You have my word.",
      "reply": "Your word. The last outsider gave me four cuts and a look. I will take the word, and I will remember it.",
      "journal": "Promised Nessa to find her mother’s urn in the columbarium before the Compact clears its shelf.",
      "prerequisites": {
        "all": [
          "z04:contract-vault"
        ],
        "any": [],
        "none": [
          "z04:urn-promised",
          "z04:urn-reassured"
        ]
      },
      "effects": {
        "add": [
          "z04:urn-promised"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "urn-reassure",
      "beatId": "beat:lower-landing",
      "speakerId": "nessa",
      "label": "Tell her no vault clears a niche while its family lives",
      "intention": "ask",
      "text": "They cannot clear a niche while you are alive to claim it.",
      "reply": "Is that so? Then I can stop counting shelves in my head. Ask me about Leth.",
      "journal": "Told Nessa her mother’s niche was safe while she lived. The Compact’s clearance list says otherwise.",
      "prerequisites": {
        "all": [
          "z04:contract-vault"
        ],
        "any": [],
        "none": [
          "z04:urn-promised",
          "z04:urn-reassured"
        ]
      },
      "effects": {
        "add": [
          "z04:urn-reassured"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "lime-tell",
      "beatId": "beat:lower-landing",
      "speakerId": "nessa",
      "label": "Tell the porters what the tunnels burn",
      "intention": "ask",
      "text": "Tell them. They should know what they are feeding.",
      "reply": "Then they will stand on the landing with empty hands and their pride. I will tell them it was you who said it.",
      "journal": "Told the porters what the firing tunnels burn. They turned down the Standard’s double pay for the lime.",
      "prerequisites": {
        "all": [
          "z04:contract-firing"
        ],
        "any": [],
        "none": [
          "z04:lime-refused",
          "z04:lime-carried"
        ]
      },
      "effects": {
        "add": [
          "z04:lime-refused"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "lime-quiet",
      "beatId": "beat:lower-landing",
      "speakerId": "nessa",
      "label": "Let them take the double pay: carrying lime is honest work",
      "intention": "ask",
      "text": "Carrying lime is honest work. Let them be paid for it.",
      "reply": "Honest. They will carry it past the dead and be paid twice for it. I will not be the one to tell them.",
      "journal": "Let the porters take the Standard’s double pay to carry lime up to the firing tunnels, not knowing what the tunnels burn.",
      "prerequisites": {
        "all": [
          "z04:contract-firing"
        ],
        "any": [],
        "none": [
          "z04:lime-refused",
          "z04:lime-carried"
        ]
      },
      "effects": {
        "add": [
          "z04:lime-carried"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "toll-pay",
      "beatId": "beat:toll-stair",
      "speakerId": "guard",
      "label": "Pay the posted toll — 2 cuts",
      "intention": "offer",
      "text": "Two cuts. Let me through.",
      "reply": "Counted. Keep the slip. The next man is very keen to charge for the same stairs.",
      "journal": "Paid two cuts for access to the market.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "story:toll-pass"
        ]
      },
      "effects": {
        "add": [
          "story:toll-pass"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 2,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "toll-service",
      "beatId": "beat:toll-stair",
      "speakerId": "guard",
      "label": "Carry the empty grain measures upstairs",
      "intention": "offer",
      "text": "I can carry those measures if that covers passage.",
      "reply": "Both of them. Leave them at the bath stall. You have just discovered the only duty here paid in stairs.",
      "journal": "Earned passage by carrying the grain measures.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "story:toll-pass"
        ]
      },
      "effects": {
        "add": [
          "story:toll-pass"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "tally",
      "beatId": "beat:lift-yard",
      "speakerId": null,
      "label": "Read Leth’s wage tally",
      "intention": "ask",
      "text": "Compare the dates beside Leth An’s name.",
      "reply": "Wages were charged for six days after his burial. The last payment bought a lift pin. Someone is selling the dead man’s labour and keeping the living workers’ pay. A note proposes blaming Melian for the stolen bodies because of a salt purchase. Nothing here links her to their preparation.",
      "journal": "Leth was billed as a worker after his burial. His wages paid for the pin, not the missing bearing. The proposed charge against Melian contains no evidence of corpse-work.",
      "prerequisites": {
        "all": [
          "fact:investigation-opened",
          "story:nessa-heard"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M1-match-wage-tally",
      "evidenceIds": [
        "story:wage-tally"
      ],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "bearing",
      "beatId": "beat:lift-yard",
      "speakerId": null,
      "label": "Inspect the pin and broken bearing",
      "intention": "ask",
      "text": "Turn the unloaded drum by hand.",
      "reply": "The pin is new. The drum catches against a crack in its bearing. More lime sales will not make that crack disappear. A fitted bearing or a paid porter crew would move the grain.",
      "journal": "The pin cannot repair the lift. A bearing, living porters, a faction obligation or rationed lifting can.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:bearing-known"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "melian-need",
      "beatId": "beat:middle-market-cold-bath",
      "speakerId": "melian",
      "label": "Ask why the crowd blames her",
      "intention": "ask",
      "text": "Why are they saying your name?",
      "reply": "I buy salt from the same warehouse. So do fishmongers. Blame me, and the concession keeps its contract; the repair account stays untouched. It is a convenient answer, except that I have never worked on a dead body.",
      "journal": "Shared salt is the accusation against Melian. Blaming her protects the concession’s repair income, not the truth.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:scapegoat-known"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "melian-demo",
      "beatId": "beat:middle-market-cold-bath",
      "speakerId": "melian",
      "label": "Watch her treat a living patient",
      "intention": "ask",
      "text": "Show me the difference.",
      "reply": "This thread was worn by this woman. The salt holds warmth against her injured hand. No anchor, no imposed motion. Write what you saw. I would rather be acquitted of my actual work.",
      "journal": "Observed Melian’s lawful treatment. Shared ingredients do not make it corpse-work.",
      "prerequisites": {
        "all": [
          "story:scapegoat-known"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:lawful-demo"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [
        "story:lawful-demonstration"
      ],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "drain",
      "beatId": "beat:middle-market-cold-bath",
      "speakerId": null,
      "label": "Inspect the bath drain",
      "intention": "ask",
      "text": "Follow the dry channel behind the treatment alcove.",
      "reply": "Fresh porter marks run beneath the bath to the lock foot. A reed mat hides a dry side ledge. Small shoes stand on it in pairs. This is somebody’s way home.",
      "journal": "Found a dry maintenance shortcut from the bath to the lock foot. Keeping its users out of the public record preserves access.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:drain-known"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "official-offer",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Ask for an inspection warrant",
      "intention": "ask",
      "text": "The dead are still drawing wages. I want to visit the kilns.",
      "reply": "Take the warrant. It grants entry, not a verdict. Match a record to a body or protect someone who saw it. Two copies of a lie are still one lie.",
      "journal": "The official grants kiln entry. A public case needs independent kinds of evidence.",
      "prerequisites": {
        "all": [
          "fact:name-attached"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:warrant"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "lodging-work",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Copy the lodging rolls — earn 8 cuts once",
      "intention": "offer",
      "text": "I can copy the lodging rolls. What does the office pay?",
      "reply": "Eight cuts for the completed copy. Every room and witness gets a line. That is the last copying work the office has to offer.",
      "journal": "Copied the court lodging rolls for eight cuts. The job is finished; its wages can fund protection.",
      "prerequisites": {
        "all": [
          "story:warrant"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:lodging-work-paid"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 8,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "road-pawl",
      "beatId": "beat:eastern-road-lock-foot",
      "speakerId": null,
      "label": "Inspect the marked safety pawl",
      "intention": "ask",
      "text": "Check the painted water line.",
      "reply": "The pawl permits a slow hoist cycle. Below the red line, the bearing carries less weight. Grain will move, but most of it will still be waiting tomorrow.",
      "journal": "Rationed lifting is possible without debt. It leaves a severe grain backlog.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:pawl-known"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "variants": [
        {
          "when": {
            "all": [
              "story:grain-settled"
            ],
            "any": [],
            "none": []
          },
          "reply": "The pawl permits a slow hoist cycle below the red line. The grain is already settled, so the lift has no need of it now. The painted line still marks where the water is safe to stand.",
          "journal": "The safety pawl marks the lock’s safe water line. The grain is already settled, so its slow hoist cycle is no longer needed."
        }
      ]
    },
    {
      "id": "separate",
      "beatId": "beat:middle-market-cold-bath",
      "speakerId": "melian",
      "label": "Compare her demonstration with the station records",
      "intention": "ask",
      "text": "The stations use anchors and imposed motion. Your treatment uses neither.",
      "reply": "Put both descriptions in the hearing. Do not merely call me harmless. A man can say that while fastening the door.",
      "journal": "Recorded the material difference between Melian’s lawful practice and corpse-work.",
      "prerequisites": {
        "all": [
          "story:lawful-demo",
          "fact:records-secured"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-separate-melian",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "protect",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Fund safe lodging and public custody — 6 cuts",
      "intention": "offer",
      "text": "Six cuts for witness lodging. Put their protection in the register.",
      "reply": "The money goes to the bath keeper, and my seal goes beside each name. Creditors who want these witnesses must now argue with the office.",
      "journal": "Paid six cuts for witness lodging and secured public custody for Nessa and Odel.",
      "prerequisites": {
        "all": [
          "fact:name-attached"
        ],
        "any": [],
        "none": [
          "fact:terminal-accounting-complete"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-secure-witnesses",
      "evidenceIds": [],
      "costCuts": 6,
      "rewardCuts": 0,
      "operation": "protect",
      "afterResolution": true
    },
    {
      "id": "public",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Present the protected case and close the concession",
      "intention": "offer",
      "text": "Close it publicly. Name the dead and clear Melian.",
      "reply": "The seal goes on the closure. The records stay here; the families get copies. Now tell me how you intend to move their grain.",
      "journal": "The concession is publicly closed. Witness protection and a separate grain settlement are the price.",
      "prerequisites": {
        "all": [
          "fact:records-secured",
          "fact:witnesses-protected",
          "fact:tethers-inspected",
          "fact:melian-separated"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "campaign:B1"
        ],
        "remove": []
      },
      "arcActionId": "slice.M3-public-dismantling",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "settle-operation",
      "afterResolution": false
    },
    {
      "id": "depart",
      "beatId": "beat:eastern-road-lock-foot",
      "speakerId": null,
      "label": "Leave the burial dispute unresolved",
      "intention": "leave",
      "text": "Take the road out with what you have learned.",
      "reply": "Behind you, a cart bell rings. The same workers answer it. The grain and the missing dead remain someone else’s unfinished morning.",
      "journal": "Left the concession active. The record names the grain shortage and workers you left exposed.",
      "prerequisites": {
        "all": [
          "fact:investigation-opened"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "campaign:B1"
        ],
        "remove": []
      },
      "arcActionId": "slice.M3-departure-failure",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "depart",
      "afterResolution": false
    },
    {
      "id": "buy-bearing",
      "beatId": "beat:lift-yard",
      "speakerId": null,
      "label": "Buy and fit the bearing — posted price",
      "intention": "ask",
      "text": "Buy and fit the bearing — posted price",
      "reply": "The fitter seats the new bearing. The first grain platform rises without its grinding catch.",
      "journal": "Paid the posted bearing price. The lift works without a faction debt.",
      "prerequisites": {
        "all": [
          "story:bearing-known"
        ],
        "any": [],
        "none": [
          "story:grain-settled"
        ]
      },
      "effects": {
        "add": [
          "story:grain-settled"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "buy-bearing",
      "afterResolution": true,
      "touches": [
        "noll"
      ]
    },
    {
      "id": "porters",
      "beatId": "beat:lift-yard",
      "speakerId": null,
      "label": "Hire a grain crew — 16 cuts",
      "intention": "ask",
      "text": "Hire a grain crew — {cuts}.",
      "reply": "Four porters count the funded wage chits, then shoulder the sacks. The broken lift stays silent.",
      "journal": "Paid {cuts} to living porters. Grain moves by hand; the bearing remains broken.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "story:grain-settled"
        ]
      },
      "effects": {
        "add": [
          "story:grain-settled"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 16,
      "rewardCuts": 0,
      "operation": "manual-transshipment",
      "afterResolution": true
    },
    {
      "id": "faction-repair",
      "beatId": "beat:lift-yard",
      "speakerId": null,
      "label": "Accept the posted faction repair obligation",
      "intention": "ask",
      "text": "Accept the posted faction repair obligation",
      "reply": "The requisition is signed. Engineers begin work; beside them a clerk writes the district’s new obligation.",
      "journal": "Accepted the displayed faction obligation in exchange for a repaired lift.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "story:grain-settled"
        ]
      },
      "effects": {
        "add": [
          "story:grain-settled"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "conditional-faction-repair",
      "afterResolution": true,
      "touches": [
        "noll"
      ]
    },
    {
      "id": "ration",
      "beatId": "beat:lift-yard",
      "speakerId": null,
      "label": "Set the safe low-load cycle",
      "intention": "ask",
      "text": "Set the safe low-load cycle",
      "reply": "The pawl catches below the red line. A single light sack rises while the queue grows.",
      "journal": "Accepted thirty-percent grain movement. No debt was incurred; the shortage remains.",
      "prerequisites": {
        "all": [
          "story:pawl-known"
        ],
        "any": [],
        "none": [
          "story:grain-settled"
        ]
      },
      "effects": {
        "add": [
          "story:grain-settled"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "reduced-throughput",
      "afterResolution": true
    },
    {
      "id": "account",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Register the settlement and the nine dead",
      "intention": "offer",
      "text": "Record what happened to the grain, the workers and each body.",
      "reply": "Every body gets a line. Even “not returned” gets a line. Copies go to the market and the kiln gate. Go and see whether the people there recognise this account.",
      "journal": "The settlement is registered. Visit the market and the kiln gate to see what changed.",
      "prerequisites": {
        "all": [
          "fact:resolution-chosen",
          "story:grain-settled"
        ],
        "any": [],
        "none": [
          "fact:terminal-accounting-complete"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "account",
      "afterResolution": true
    },
    {
      "id": "nessa-after",
      "beatId": "beat:lower-landing",
      "speakerId": "nessa",
      "label": "Ask what she needs now",
      "intention": "ask",
      "text": "What happens tomorrow?",
      "reply": "Tomorrow I collect the urn. If the office asks you whether that happened, come and ask me. We have had enough completed forms.",
      "journal": "Promised to check the burial return with Nessa herself, not only the office.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:nessa-after"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "melian-after",
      "beatId": "beat:middle-market-cold-bath",
      "speakerId": "melian",
      "label": "Ask whether she can reopen",
      "intention": "ask",
      "text": "Will they let you work?",
      "reply": "Watch the shutter. That will tell you more than the notice. Leave my name attached to what you actually saw.",
      "journal": "Melian asks you to stand by the observed facts; her shutter reflects the recorded verdict.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:melian-after"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mentor-assay",
      "beatId": "beat:middle-market-cold-bath",
      "speakerId": "melian",
      "label": "Compare Corren’s seized formula with the lawful preparation",
      "intention": "ask",
      "text": "This is Corren’s original formula. Will you witness a comparison?",
      "reply": "Yes. This wash has no binding wax or quicksilver. We can repeat the comparison before the clerk. Your mentor’s name belongs beside his own work, not beside mine.",
      "journal": "Melian witnessed the comparison of Corren’s original formula. The court will record an honest finding on his work, unless the kiln case is settled in private or the court is paid to look away.",
      "prerequisites": {
        "all": [
          "story:personal-recovered"
        ],
        "any": [],
        "none": [
          "fact:terminal-accounting-complete"
        ]
      },
      "effects": {
        "add": [
          "story:claim-closed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "hedge-binder"
    },
    {
      "id": "addendum-finding",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Enter the muster addendum for a public finding",
      "intention": "offer",
      "text": "This is the order my unit was blamed for obeying. Enter it where anyone can read it.",
      "reply": "The quartermaster’s mark is genuine; the seal on the loan pledge is not. Noll’s creditors lose their collateral the moment I write this down. I will enter it with the case. But a public finding needs a public case. If the kilns end in a private arrangement, your order is sealed with the rest.",
      "journal": "Entered the muster addendum at Reeve’s Court. It becomes a public finding unless the kiln case ends in a private arrangement.",
      "prerequisites": {
        "all": [
          "story:personal-recovered"
        ],
        "any": [],
        "none": [
          "fact:terminal-accounting-complete"
        ]
      },
      "effects": {
        "add": [
          "story:claim-closed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "disgraced-legionary"
    },
    {
      "id": "fee-division",
      "beatId": "beat:lower-landing",
      "speakerId": "nessa",
      "label": "Offer the porters first claim on the estate",
      "intention": "offer",
      "text": "My dead employer owes me eighteen ves and owes your porters their wages. Put your names above mine on the tally.",
      "reply": "Nessa reads the tally twice. “Wages first, then the burials, then you. That leaves you about nine.” She does not mark it. “Porters sign once their own money is in their hands. The pouch under the tally shelter in the lift yard has their names on it. If it reaches them, you have our marks. If it goes missing, nobody here puts a mark beside yours.”",
      "journal": "Offered the porters first claim on your fee: wages first, about nine ves to you. Nessa will countersign once the porters’ own pouch from the lift yard reaches them.",
      "prerequisites": {
        "all": [
          "story:personal-recovered"
        ],
        "any": [],
        "none": [
          "fact:terminal-accounting-complete"
        ]
      },
      "effects": {
        "add": [
          "story:claim-closed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "unpaid-sellsword"
    },
    {
      "id": "deed-ruling",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Register the deed with its confiscation schedule — 4 cuts",
      "intention": "offer",
      "text": "Register Cessa’s deed. Attach the confiscation schedule, and put the dyer’s heirs on the roll.",
      "reply": "Most families bring me the deed and lose the schedule. Four cuts: the tenure fee, and the first quit-rent owed to the dyer’s heirs. Once I stamp this, your sister cannot be evicted, and anyone can read how your family came by the house. The ruling holds as long as this court’s seal is not for sale.",
      "journal": "Paid four cuts to register Cessa’s deed with the confiscation schedule attached. She is protected from eviction; the dyer’s heirs are on the roll for a quit-rent.",
      "prerequisites": {
        "all": [
          "story:personal-recovered"
        ],
        "any": [],
        "none": [
          "fact:terminal-accounting-complete"
        ]
      },
      "effects": {
        "add": [
          "story:claim-closed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 4,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "fallen-household"
    },
    {
      "id": "deposition-custody",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Lodge the original deposition, your patron’s name and all",
      "intention": "offer",
      "text": "Here is the original, and the buyer’s copy with a line missing. Lodge the original where it cannot be bought.",
      "reply": "The buyer’s copy is short one line, and it is the line with your patron’s name. Your patron will know who brought me this. I will lodge the original under a court number. But custody holds only what someone has paid it to hold. If lodging and public custody are funded before the settlement is registered, no seal can lift this out. If not, it sits in a drawer.",
      "journal": "Lodged the unaltered deposition at Reeve’s Court, naming your former patron. It is safe from the buyer only if public custody is funded before the settlement is registered.",
      "prerequisites": {
        "all": [
          "story:personal-recovered"
        ],
        "any": [],
        "none": [
          "fact:terminal-accounting-complete"
        ]
      },
      "effects": {
        "add": [
          "story:claim-closed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "intelligence-runner"
    },
    {
      "id": "lock-guarantee",
      "beatId": "beat:eastern-road-lock-foot",
      "speakerId": null,
      "label": "Answer the vouchers’ margin with the true water line",
      "intention": "ask",
      "text": "They asked for irrigation information. Give them this lock’s, not Sekhet Anar’s.",
      "reply": "The margin asks for irrigation information and does not say whose. You copy the real safe line from under the painted one on the pawl, with the depth it actually holds. It is true, the lock needs it, and it says nothing about how Sekhet Anar waters its fields. The lock-house stamps passage for three. Hazren and the children will cross by the low walkway, and only a shored walkway will hold them.",
      "journal": "Answered the transit guarantee with Lock Foot’s true water line instead of Serekh charts. Passage for Hazren and the children is stamped; they cross by the low walkway, which must be shored to hold them.",
      "prerequisites": {
        "all": [
          "story:personal-recovered"
        ],
        "any": [],
        "none": [
          "fact:terminal-accounting-complete"
        ]
      },
      "effects": {
        "add": [
          "story:claim-closed",
          "story:pawl-known"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "serekh-exile"
    },
    {
      "id": "seal-rubbing",
      "beatId": "beat:lower-landing",
      "speakerId": null,
      "label": "Rub the broken seal under the hinge",
      "intention": "ask",
      "text": "Press a scrap of paper against the broken cart seal.",
      "reply": "The seal has two cuts across its rim. Nessa turns it in the light. “A return mark. They charged us for bringing back the empty box.”",
      "journal": "Copied the double-cut return mark. It can challenge the toll and identify Nessa’s urn wrapping.",
      "prerequisites": {
        "all": [
          "fact:investigation-opened"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "side:seal-copied"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "seal-toll",
      "beatId": "beat:toll-stair",
      "speakerId": "guard",
      "label": "Challenge the second toll with the cart seal",
      "intention": "ask",
      "text": "This cart has already paid for its return.",
      "reply": "The guard checks the rim, then pushes the collection bowl behind him. “Someone has been very thorough. Not me, unfortunately.” He writes a passage slip for you and the waiting porters.",
      "journal": "The cart seal secured free passage and ended the duplicate porter toll.",
      "prerequisites": {
        "all": [
          "side:seal-copied"
        ],
        "any": [],
        "none": [
          "side:toll-profit"
        ]
      },
      "effects": {
        "add": [
          "story:toll-pass",
          "side:porter-toll-ended"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "toll-kickback",
      "beatId": "beat:toll-stair",
      "speakerId": "guard",
      "label": "Keep quiet about the duplicate toll — take 4 cuts",
      "intention": "ask",
      "text": "Give me my share and I will leave the bowl where it is.",
      "reply": "“Your share,” the guard repeats. He counts four cuts from the porters’ bowl. Below the stair, another cart is stopped.",
      "journal": "Took four cuts from the duplicate toll. The porters still pay it.",
      "prerequisites": {
        "all": [
          "side:seal-copied"
        ],
        "any": [],
        "none": [
          "side:porter-toll-ended"
        ]
      },
      "effects": {
        "add": [
          "side:toll-profit"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 4,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "drain-discretion",
      "beatId": "beat:middle-market-cold-bath",
      "speakerId": null,
      "label": "Leave the families’ route out of your report",
      "intention": "ask",
      "text": "Turn the paper over before copying the drain marks.",
      "reply": "A woman on the ledge moves her shoes aside. “Mind the last step. The city has not admitted to it yet.”",
      "journal": "Kept the escape path private. The families will continue to admit you.",
      "prerequisites": {
        "all": [
          "story:drain-known"
        ],
        "any": [],
        "none": [
          "side:route-sold"
        ]
      },
      "effects": {
        "add": [
          "side:route-kept"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "drain-sale",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Sell the hidden route to the toll office — 6 cuts",
      "intention": "ask",
      "text": "I can show your collectors how people are avoiding the stair.",
      "reply": "The official pays for the drawing and pins it beside the tariff. A guard takes a clean copy. The route will be watched before you get back.",
      "journal": "Sold the escape route for six cuts. Its users withdraw access; a hired scout will end their contract.",
      "prerequisites": {
        "all": [
          "story:drain-known"
        ],
        "any": [],
        "none": [
          "side:route-kept"
        ]
      },
      "effects": {
        "add": [
          "side:route-sold"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 6,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "bath-screen",
      "beatId": "beat:middle-market-cold-bath",
      "speakerId": null,
      "label": "Replace the torn patient screen — 3 cuts",
      "intention": "offer",
      "text": "Buy cloth and fix it across the treatment doorway.",
      "reply": "Melian tests the gap with her shoulder. “That will keep the patients out of the argument. A surprisingly rare medical supply.”",
      "journal": "Paid three cuts for a sheltered treatment entrance. Even an accusation cannot close this side service.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "side:bath-screen"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 3,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "tally-shelter",
      "beatId": "beat:lift-yard",
      "speakerId": null,
      "label": "Look beneath the tally shelter’s dry shelf",
      "intention": "ask",
      "text": "Lift the only board without rain marks.",
      "reply": "A pay pouch is wedged above the crossbeam: eight cuts, with four porter names. Beside it is a receipt marked paid. The shelter has kept one account drier than the other.",
      "journal": "Found eight withheld cuts. Return them to the named porters or take them; the pouch cannot pay both.",
      "prerequisites": {
        "all": [
          "fact:name-attached"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "side:arrears-found"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "arrears-return",
      "beatId": "beat:lift-yard",
      "speakerId": null,
      "label": "Return the eight cuts to the named porters",
      "intention": "ask",
      "text": "Lay the pouch beside the four names.",
      "reply": "Each porter takes two cuts. The eldest finds an unbroken handcart behind the shelter. “Now we can discuss tomorrow’s work without yesterday standing in the doorway.”",
      "journal": "Returned withheld wages. The porters lend a handcart for local bread deliveries.",
      "prerequisites": {
        "all": [
          "side:arrears-found"
        ],
        "any": [],
        "none": [
          "side:arrears-taken"
        ]
      },
      "effects": {
        "add": [
          "side:arrears-returned"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "return-arrears",
      "afterResolution": true
    },
    {
      "id": "arrears-pocket",
      "beatId": "beat:lift-yard",
      "speakerId": null,
      "label": "Keep the unclaimed pouch — 8 cuts",
      "intention": "ask",
      "text": "Put the pay pouch in your own purse.",
      "reply": "One of the porters watches you lower the empty board. He does not ask what you found.",
      "journal": "Kept eight cuts owed to the porters. They will not lend their handcart.",
      "prerequisites": {
        "all": [
          "side:arrears-found"
        ],
        "any": [],
        "none": [
          "side:arrears-returned"
        ]
      },
      "effects": {
        "add": [
          "side:arrears-taken"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 8,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "court-copy",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Have the duplicate toll struck from the public schedule",
      "intention": "ask",
      "text": "Put the seal rubbing beside the older toll schedule.",
      "reply": "The official scrapes the second charge away. “A correction, not a gift.” The porters take a copy anyway.",
      "journal": "Registered a civilian fee exemption. Families can reclaim burial tokens without a second charge.",
      "prerequisites": {
        "all": [
          "side:porter-toll-ended"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "side:fee-exemption",
          "side:toll-struck"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "kitchen-surety",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Guarantee six cuts for the bath kitchen after the hearing",
      "intention": "ask",
      "text": "Write my name against the kitchen’s next six cuts.",
      "reply": "“Your name, not the district’s?” The official waits for your mark. “Good. It is unusual to know where to send the bill.”",
      "journal": "Personally guaranteed six cuts for the bath kitchen. The promise stays with you if you survive.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "side:kitchen-paid",
          "side:kitchen-promised"
        ]
      },
      "effects": {
        "add": [
          "side:kitchen-promised"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "kitchen-promise",
      "afterResolution": false
    },
    {
      "id": "lock-shore",
      "beatId": "beat:eastern-road-lock-foot",
      "speakerId": null,
      "label": "Shore the low walkway — 2 cuts",
      "intention": "offer",
      "text": "Buy a length of timber and wedge it below the water mark.",
      "reply": "The plank settles against stone. The next barrow crosses without lifting its wheels out of the water. Someone retrieves a shoe from the channel.",
      "journal": "Paid two cuts to preserve the low walkway. A porter handcart can now carry bread around the lift queue.",
      "prerequisites": {
        "all": [
          "story:pawl-known"
        ],
        "any": [],
        "none": [
          "side:sluice-flushed"
        ]
      },
      "effects": {
        "add": [
          "side:walkway-shored"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 2,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "lock-flush",
      "beatId": "beat:eastern-road-lock-foot",
      "speakerId": null,
      "label": "Flush out the dropped toll box — damage the walkway, take 6 cuts",
      "intention": "ask",
      "text": "Lift the pawl above the red mark.",
      "reply": "The rush tears the plank from its seating. A tin toll box rolls into reach. Beyond it, bedding floats out from beneath the bath.",
      "journal": "Took six cuts from the recovered box. Flooded the families’ path and patient entrance; a hired mason will leave.",
      "prerequisites": {
        "all": [
          "story:pawl-known"
        ],
        "any": [],
        "none": [
          "side:walkway-shored"
        ]
      },
      "effects": {
        "add": [
          "side:sluice-flushed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 6,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "urn-return",
      "beatId": "beat:lower-landing",
      "speakerId": "nessa",
      "label": "Give Nessa the collection cord and identification",
      "intention": "ask",
      "text": "The urn is there. Here is the mark and the cord that admits you.",
      "reply": "Nessa reads the name twice. “You have brought me something I can use. I was beginning to think the town had stopped making those.”",
      "journal": "Nessa can collect the identified urn. She volunteers to witness family handovers at the gate.",
      "prerequisites": {
        "all": [
          "side:urn-identified"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "side:urn-returned"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "salt-deliver",
      "beatId": "beat:middle-market-cold-bath",
      "speakerId": "melian",
      "label": "Return the prepaid salt to Melian",
      "intention": "ask",
      "text": "Put the unopened jars beside the treatment bowl.",
      "reply": "“Mine,” Melian says, checking the marks. “An excellent new supplier.” She crosses the concession surcharge off her slate.",
      "journal": "Returned Melian’s prepaid salt. Her posted salt price falls by one cut.",
      "prerequisites": {
        "all": [
          "side:salt-recovered"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "side:salt-delivered"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "deposit-comparison",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Deposit the staple comparison for another reader",
      "intention": "ask",
      "text": "File the measurements with the rubbing, not a theory.",
      "reply": "The official leaves the cause column empty. “For once, the form has enough room.” A public copy goes to the landing.",
      "journal": "Deposited the measured staple comparison. A later outsider can read it to obtain an inspection warrant, without inheriting your proof.",
      "prerequisites": {
        "all": [
          "side:staple-compared"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "side:comparison-deposited"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "deposit-record",
      "afterResolution": true
    },
    {
      "id": "kitchen-pay",
      "beatId": "beat:middle-market-cold-bath",
      "speakerId": null,
      "label": "Honour the kitchen guarantee — 6 cuts",
      "intention": "offer",
      "text": "Pay the kitchen’s six cuts against the named promise.",
      "reply": "The keeper scores the debt through. Six portions go into covered bowls. The empty place at the table stays empty.",
      "journal": "Paid the six-cut kitchen promise. Its burden ends; its recipients can eat.",
      "prerequisites": {
        "all": [
          "side:kitchen-promised"
        ],
        "any": [],
        "none": [
          "side:kitchen-paid"
        ]
      },
      "effects": {
        "add": [
          "side:kitchen-paid"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 6,
      "rewardCuts": 0,
      "operation": "kitchen-pay",
      "afterResolution": true
    },
    {
      "id": "legacy-record",
      "beatId": "beat:lower-landing",
      "speakerId": null,
      "label": "Read the earlier traveller’s deposited comparison",
      "intention": "ask",
      "text": "Open the public copy left at the landing.",
      "reply": "The drawing names a tool flaw and an uncut mortar layer. No explanation is offered. A clerk has left space for another reader’s own measurements.",
      "journal": "Read a genuinely deposited comparison. It grants a warrant lead, not inherited skills or a fresh verification.",
      "prerequisites": {
        "all": [
          "legacy:record-available"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "legacy:record-read"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "read-record",
      "afterResolution": false
    },
    {
      "id": "legacy-warrant",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Request access on the deposited comparison",
      "intention": "ask",
      "text": "Someone left a measurement worth checking. Let me inspect it.",
      "reply": "“Bring back your own result.” The official seals the warrant. “Agreement is optional. Looking is the part I can authorise.”",
      "journal": "The prior deposit secured inspection access before the wage-tally investigation.",
      "prerequisites": {
        "all": [
          "legacy:record-read"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:warrant",
          "fact:kiln-access"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "landing-return",
      "beatId": "beat:lower-landing",
      "speakerId": null,
      "label": "Stand a moment where the last life began",
      "intention": "ask",
      "text": "You know this landing.",
      "reply": "The same barge, the same wind off the water. The porters work it like no interval passed. Your earlier life walks the Quiet Kilns now, with their own possessions and promises. The landing board holds travellers' deposits for whoever stops to read them.",
      "journal": "Began another life where the last one began. The earlier traveller survives at the Quiet Kilns; the landing keeps their deposits.",
      "prerequisites": {
        "all": [
          "legacy:survivor-present"
        ],
        "any": [],
        "none": [
          "story:landing-remembered",
          "legacy:last-died"
        ]
      },
      "effects": {
        "add": [
          "story:landing-remembered"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "landing-grave",
      "beatId": "beat:lower-landing",
      "speakerId": null,
      "label": "Read the newest name on the list of the dead",
      "intention": "ask",
      "text": "Look over the landing’s list of the dead.",
      "reply": "Nessa runs a finger down the landing’s list of the dead and reads you the outsiders on it. {dead} Beside each name, where a burial should be entered, the space is blank.",
      "journal": "The outsiders on the landing’s list of the dead, as Nessa read them: {dead} Nothing brings them back.",
      "prerequisites": {
        "all": [
          "legacy:last-died"
        ],
        "any": [],
        "none": [
          "story:landing-remembered"
        ]
      },
      "effects": {
        "add": [
          "story:landing-remembered"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "toll-memory",
      "beatId": "beat:toll-stair",
      "speakerId": null,
      "label": "Count the stairs you have already climbed",
      "intention": "ask",
      "text": "These stairs again.",
      "reply": "The guard stamps the slip without looking up, then looks up. You walk like someone who has paid this before. The stairs have not changed. The person climbing them has.",
      "journal": "Crossed the toll stair again in a new life. The last crossing is remembered here, even if the fee is owed again.",
      "prerequisites": {
        "all": [
          "legacy:survivor-present"
        ],
        "any": [],
        "none": [
          "story:toll-remembered",
          "legacy:last-died"
        ]
      },
      "effects": {
        "add": [
          "story:toll-remembered"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "toll-grave",
      "beatId": "beat:toll-stair",
      "speakerId": null,
      "label": "Ask the guard who went up before you",
      "intention": "ask",
      "text": "Who came up these stairs before me?",
      "reply": "“One like you. New off the barge, asked about the kilns, went up quick.” He stamps your slip. “Came down slower, on a board. Nobody claimed the board.” He looks at you a moment longer than he needs to. “Go up slower.”",
      "journal": "The toll guard remembers the last outsider going up to the kilns and being carried down. Nobody claimed them.",
      "prerequisites": {
        "all": [
          "legacy:last-died"
        ],
        "any": [],
        "none": [
          "story:toll-remembered"
        ]
      },
      "effects": {
        "add": [
          "story:toll-remembered"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "gate-post",
      "beatId": "z04-gate-of-accounts",
      "speakerId": null,
      "label": "Read the burial prices and returned-token board",
      "intention": "ask",
      "text": "Compare the posted fees with the tokens.",
      "reply": "The board records Leth An as returned. A woman in the cooling court is still holding the matching token.",
      "journal": "Leth’s token was marked returned. His family is still waiting in the cooling court.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:gate-read"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "token",
      "beatId": "z04-cooling-court",
      "speakerId": null,
      "label": "Match the family’s token to Leth’s entry",
      "intention": "ask",
      "text": "May I compare the token with the register?",
      "reply": "The family puts it on your open palm. The notch and number match. “They say we collected him. You can see how well that went.”",
      "journal": "The family’s token contradicts the burial register. This is physical evidence independent of the wage tally.",
      "prerequisites": {
        "all": [
          "fact:investigation-opened"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M1-match-token",
      "evidenceIds": [
        "evidence:z04-leth-grave-token",
        "evidence:z04-burial-register-leth"
      ],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "gallery",
      "beatId": "z04-lower-work-gallery",
      "speakerId": null,
      "label": "Watch {working}’s repeated tally gesture",
      "intention": "ask",
      "text": "Watch without touching the anchor.",
      "reply": "Two fingers rise. Nothing is being counted. The body has no breath and does not answer its name. From the ramp comes a shout: load the records cart.",
      "journal": "{working} is dead. The body’s motion is imposed, not testimony. The concession has begun loading a records cart.",
      "prerequisites": {
        "all": [
          "fact:name-attached"
        ],
        "any": [],
        "none": [
          "fact:necromancy-observed"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-observe-working-dead",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "observe-working-station",
      "afterResolution": false,
      "stationId": "station-lower-gallery"
    },
    {
      "id": "vault-working",
      "beatId": "z04-cooling-court",
      "speakerId": null,
      "label": "Watch {working} clear the old niches",
      "intention": "ask",
      "text": "Watch without touching the anchor.",
      "reply": "The body lifts an urn from a high niche, carries it to the clearance table, and goes back for the next. It reads no name on any of them. From the ramp comes a shout: load the records cart.",
      "journal": "{working} is dead. The body clears niches for the Compact’s resale; the motion is imposed, not testimony. The concession has begun loading a records cart.",
      "prerequisites": {
        "all": [
          "fact:name-attached",
          "z04:contract-vault"
        ],
        "any": [],
        "none": [
          "fact:necromancy-observed"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-observe-working-dead",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "observe-working-station",
      "afterResolution": false,
      "stationId": "station-columbarium-vault"
    },
    {
      "id": "firing-working",
      "beatId": "z04-cart-ramp-office",
      "speakerId": null,
      "label": "Watch {working} feed the firing tunnel",
      "intention": "ask",
      "text": "Watch without touching the anchor.",
      "reply": "The body shovels broken limestone into the tunnel mouth, steps back from heat it cannot feel, and shovels again. Its sleeves have burned away to the elbow. Behind you someone shouts: load the records cart.",
      "journal": "{working} is dead. The body stokes the firing tunnels for the Standard’s lime; the motion is imposed, not testimony. The concession has begun loading a records cart.",
      "prerequisites": {
        "all": [
          "fact:name-attached",
          "z04:contract-firing"
        ],
        "any": [],
        "none": [
          "fact:necromancy-observed"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-observe-working-dead",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "observe-working-station",
      "afterResolution": false,
      "stationId": "station-firing-tunnels"
    },
    {
      "id": "gallery-stopped",
      "beatId": "z04-lower-work-gallery",
      "speakerId": null,
      "label": "Examine the stopped gallery and its records",
      "intention": "ask",
      "text": "Check the motionless remains against the station register.",
      "reply": "No tally gesture repeats here. The register lists Leth among the stolen dead assigned to this station. Numbered fittings and binding wax remain beside the still bodies. Outside, the concession is loading a records cart.",
      "journal": "Recorded the stopped gallery’s corpse-work fittings and burial register. No body is moving here. The concession is loading a records cart.",
      "prerequisites": {
        "all": [
          "fact:name-attached"
        ],
        "any": [],
        "none": [
          "fact:necromancy-observed"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-observe-working-dead",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "inspect-stopped-work",
      "afterResolution": false,
      "stationId": "station-lower-gallery"
    },
    {
      "id": "tethers",
      "beatId": "z04-selas-rooms",
      "speakerId": null,
      "label": "Compare the station diagrams with your site notes",
      "intention": "ask",
      "text": "Compare the numbered diagrams with the stations you examined.",
      "reply": "Your notes account for all three stations: the fittings still in use and any that have already stopped. Each diagram describes a local task. Ending a connection cannot call anyone back.",
      "journal": "Compared all three stations with their tether diagrams. Recorded which connections remain; safe release cannot revive anyone.",
      "prerequisites": {
        "all": [
          "fact:necromancy-observed",
          "story:tether-gallery",
          "story:tether-vault",
          "story:tether-firing"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-inspect-tethers",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "records",
      "beatId": "z04-selas-rooms",
      "speakerId": null,
      "label": "Secure the station ledgers",
      "intention": "ask",
      "text": "Copy the body names and reagent draws; wrap the original ledgers.",
      "reply": "Nine names. The ledgers list seven bodies assigned to stations and two unfinished. The salt purchase is ordinary; the wax arrangements and imposed tasks are not.",
      "journal": "Secured the station records and the names of all nine stolen dead.",
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": [
          "fact:terminal-accounting-complete"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-take-records",
      "evidenceIds": [
        "evidence:z04-station-ledgers"
      ],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "odel-cooperate",
      "beatId": "z04-cooling-court",
      "speakerId": "odel",
      "label": "Ask what would let him help",
      "intention": "ask",
      "text": "What would it take for you to help shut the work down?",
      "reply": "{Cuts:worker-guarantee}: my sister’s bond release and what the crew is owed. Pay that and we stop the stations ourselves. Do not make speeches about our courage while we do it.",
      "journal": "Odel will help for {cuts:worker-guarantee}: his sister’s bond release and the crew’s arrears.",
      "prerequisites": {
        "all": [
          "fact:name-attached"
        ],
        "any": [],
        "none": [
          "fact:terminal-accounting-complete"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-win-odel-cooperation",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "worker-guarantee",
      "beatId": "z04-cooling-court",
      "speakerId": "odel",
      "label": "Pay the crew’s arrears and his sister’s bond release — 12 cuts",
      "intention": "offer",
      "text": "{Cuts}. Pay the crew, and take the release fee to the court in her name.",
      "reply": "He counts it twice, the way wages are counted here. “Eight for the crew tonight. Four to the court, and her bond copy comes out of the office drawer.” He puts the coins away. “Trace the three anchors and bring the ledgers. Then we stop this.”",
      "journal": "Paid Odel {cuts}: the crew’s arrears and his sister’s bond release. The workers are protected from creditor seizure and will stop the stations once the anchors are traced and the ledgers secured.",
      "prerequisites": {
        "all": [
          "fact:odel-cooperation"
        ],
        "any": [],
        "none": [
          "fact:terminal-accounting-complete"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-guarantee-worker-protection",
      "evidenceIds": [],
      "costCuts": 12,
      "rewardCuts": 0,
      "operation": "worker-protection",
      "afterResolution": true
    },
    {
      "id": "intercept",
      "beatId": "z04-cart-ramp-office",
      "speakerId": null,
      "label": "Chock the records cart",
      "intention": "ask",
      "text": "Put the wheel chock through the cart’s spokes.",
      "reply": "The driver lifts both hands. “It is paid by the journey. This is becoming an excellent journey.” The records stay under the loading beam.",
      "journal": "Stopped the named equipment transfer. Reading and resting did not move it.",
      "prerequisites": {
        "all": [
          "fact:removal-attempted"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-intercept-removal",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "noll-account",
      "beatId": "z04-cart-ramp-office",
      "speakerId": "noll",
      "label": "Ask whose labour bought the bearing",
      "intention": "ask",
      "text": "How much of the repair was paid from wages never handed over?",
      "reply": "All of it, if you want the short answer. Return the dead and pay the living, then see what remains for the lift. I have made a profitable arrangement. I did not say it was an innocent one.",
      "journal": "Noll admits that stolen bodies and withheld wages paid for the repair stock.",
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:noll-admission"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [
        "evidence:z04-noll-payments"
      ],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "noll-out",
      "beatId": "z04-cart-ramp-office",
      "speakerId": "noll",
      "label": "Use the records to force him out",
      "intention": "warn",
      "text": "The records leave with me. Surrender the office or face a public hearing.",
      "reply": "Leave my creditors their receipts and I will give you the keys. They are not sentimental about whose name is on the door.",
      "journal": "Noll relinquishes control. His creditors still require a settlement.",
      "prerequisites": {
        "all": [
          "fact:records-secured",
          "fact:removal-intercepted"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-force-noll-out",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "sela-terms",
      "beatId": "z04-selas-rooms",
      "speakerId": "sela",
      "label": "Offer supervision instead of a cell",
      "intention": "offer",
      "text": "Stop the work. Accept supervision and preserve the evidence.",
      "reply": "An outside inspector costs {cuts:guarantor} at the court. Pay it and someone independent holds the keys. Noll called himself my protector too. And write this down: I knew what I was making by the end.",
      "journal": "Sela accepts supervision if an outside inspector holds the keys, for {cuts:guarantor}. She admits her responsibility.",
      "prerequisites": {
        "all": [
          "fact:noll-removed"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-bargain-sela",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "guarantor",
      "beatId": "z04-selas-rooms",
      "speakerId": "sela",
      "label": "Pay for an outside inspector to hold the keys — 8 cuts",
      "intention": "offer",
      "text": "{Cuts} to the court for an outside inspector. They hold the keys. Noll’s patron gets none.",
      "reply": "“Someone I cannot bargain with. Good.” She writes the inspector’s office into her own ledger. “This stops the work. It does not give the families a public answer. They will ask you for one, not me.”",
      "journal": "Paid {cuts} for an outside inspector to hold the kiln keys. The work can stop under supervision; the families get no public answer.",
      "prerequisites": {
        "all": [
          "fact:sela-contained"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-secure-independent-guarantor",
      "evidenceIds": [],
      "costCuts": 8,
      "rewardCuts": 0,
      "operation": "guarantor",
      "afterResolution": false
    },
    {
      "id": "support",
      "beatId": "z04-selas-rooms",
      "speakerId": "sela",
      "label": "Supply the missing wax — 5 cuts",
      "intention": "offer",
      "text": "Keep the stations working. I will buy the wax.",
      "reply": "Then two more bodies can be put to work. Say bodies when you tell the others. I have had enough of improvements that cannot be named.",
      "journal": "Paid five cuts to support corpse-work. The two unfinished bodies are bound: nine now work.",
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": [
          "side:gallery-released"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-support-operation",
      "evidenceIds": [],
      "costCuts": 5,
      "rewardCuts": 0,
      "operation": "support",
      "afterResolution": false
    },
    {
      "id": "silence",
      "beatId": "z04-cooling-court",
      "speakerId": "odel",
      "label": "Threaten Odel into silence",
      "intention": "threaten",
      "text": "Keep quiet, or your sister’s bond will be called in.",
      "reply": "I understand. I was hoping you did not. You will have a very quiet witness.",
      "journal": "Threatened Odel with his sister’s debt. Witnesses disappear from the gate.",
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": [
          "fact:witnesses-protected",
          "fact:workers-protected"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": "slice.M2-intimidate-witnesses",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "silence",
      "afterResolution": false
    },
    {
      "id": "prepare",
      "beatId": "z04-cart-ramp-office",
      "speakerId": null,
      "label": "Move the ledgers and workers out of the line of fire",
      "intention": "ask",
      "text": "Open the workers’ side door and put the records behind stone.",
      "reply": "Odel takes the hint without waiting for an order. The side door stands open; the ledgers are beyond the lamps.",
      "journal": "Opened an exit for the workers and protected the records before approaching the stations.",
      "prerequisites": {
        "all": [
          "fact:records-secured"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:careful"
        ],
        "remove": []
      },
      "arcActionId": "slice.M2-prepare-combat",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "fight",
      "beatId": "z04-cart-ramp-office",
      "speakerId": "noll",
      "label": "Draw on the concession guard",
      "intention": "warn",
      "text": "I am ending the work. Stand aside.",
      "reply": "Noll retreats behind the desk. “I paid for that doorway.” The guard draws his blade.",
      "journal": "A fight has begun. Defeat the guard before approaching the working stations.",
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": [
          "story:combat-won"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "fight",
      "afterResolution": false
    },
    {
      "id": "fight-successor",
      "beatId": "z04-cart-ramp-office",
      "speakerId": "noll",
      "label": "Draw on the new guard",
      "intention": "warn",
      "text": "Your last guard died in that doorway. Stand aside.",
      "reply": "Noll does not get up. “He died before you came here. The concession sent me another, paid double, and told him how the last one went.” The new guard is already on his feet.",
      "journal": "The guard killed in an earlier life stays dead. The concession put a successor in his doorway, and a fight has begun.",
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": [
          "story:combat-won"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "fight",
      "afterResolution": false
    },
    {
      "id": "careful-end",
      "beatId": "z04-cart-ramp-office",
      "speakerId": null,
      "label": "Break the anchor fittings; preserve the dead",
      "intention": "ask",
      "text": "Break the fittings, keeping fire away from the ledgers and bodies.",
      "reply": "The remaining imposed motions stop one by one. No one wakes. There are nine stolen names to carry home, and a guard who will never go home.",
      "journal": "Destroyed the stations by controlled force. Preserved identifiable remains and repair stock.",
      "prerequisites": {
        "all": [
          "story:combat-won",
          "story:careful"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "campaign:B1"
        ],
        "remove": []
      },
      "arcActionId": "slice.M3-violent-destruction",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "careful",
      "afterResolution": false
    },
    {
      "id": "secure-stopped-stations",
      "beatId": "z04-cart-ramp-office",
      "speakerId": null,
      "label": "Secure the already-stopped stations",
      "intention": "ask",
      "text": "Leave the broken fittings alone. Secure the remains and records for the families.",
      "reply": "The anchors were stopped before you arrived. You secure what remains without striking another fitting or burning a body. The guard stays dead; the stolen names can still go home.",
      "journal": "Secured stations stopped in an earlier life. Preserved their remains and records without destroying them again.",
      "prerequisites": {
        "all": [
          "story:combat-won"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "campaign:B1"
        ],
        "remove": []
      },
      "arcActionId": "slice.M3-violent-destruction",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "secure-stopped-stations",
      "afterResolution": false
    },
    {
      "id": "reckless-end",
      "beatId": "z04-cart-ramp-office",
      "speakerId": null,
      "label": "Burn the stations and repair stock",
      "intention": "ask",
      "text": "Use the lamps to burn out the stations.",
      "reply": "Flame runs through wax and cloth. The bodies still bound to the stations stop. Their names survive on paper; their remains can no longer be identified. Bodies already released and the two unfinished bodies lie beyond the fire. The bearing stock is ruined.",
      "journal": "Burned the still-bound working remains, their physical evidence and the repair stock. Earlier releases and the two unfinished bodies survive.",
      "prerequisites": {
        "all": [
          "story:combat-won"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:stations-burned",
          "campaign:B1"
        ],
        "remove": []
      },
      "arcActionId": "slice.M3-violent-destruction",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "reckless",
      "afterResolution": false
    },
    {
      "id": "workers",
      "beatId": "z04-cooling-court",
      "speakerId": "odel",
      "label": "Back the workers’ shutdown",
      "intention": "offer",
      "text": "The debts are struck. The records belong with you.",
      "reply": "Then leave us the keys and keep the creditors outside. We know the sequence. We have had a great deal of practice wishing it would stop.",
      "journal": "Workers stop the stations and take custody of the records. Your paid guarantees remain binding.",
      "prerequisites": {
        "all": [
          "fact:workers-protected",
          "fact:tethers-inspected",
          "fact:records-secured"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "campaign:B1"
        ],
        "remove": []
      },
      "arcActionId": "slice.M3-workers-shutdown",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "settle-operation",
      "afterResolution": false
    },
    {
      "id": "private",
      "beatId": "z04-selas-rooms",
      "speakerId": "sela",
      "label": "Accept the supervised closure",
      "intention": "offer",
      "text": "The independent guarantee is signed. Stop the work.",
      "reply": "I will. Keep the diagrams with the bodies; families should know what was done. Whether they ever hear it in court is now your part of the bargain.",
      "journal": "Animation ends under private supervision. Families receive no public admission.",
      "prerequisites": {
        "all": [
          "fact:sela-contained",
          "fact:independent-guarantor",
          "fact:tethers-inspected"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "campaign:B1"
        ],
        "remove": []
      },
      "arcActionId": "slice.M3-private-containment",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "settle-operation",
      "afterResolution": false
    },
    {
      "id": "licensed",
      "beatId": "z04-cart-ramp-office",
      "speakerId": "noll",
      "label": "Protect the operation in exchange for repair funds",
      "intention": "offer",
      "text": "Keep producing. Pay for the bearing and put my name on the concession pass.",
      "reply": "A workable arrangement. Twenty-four cuts for the repair. Melian’s accusation will stand, of course. Someone must explain the missing bodies.",
      "journal": "Accepted twenty-four cuts and institutional access. The dead work on; living wages remain unpaid; Melian takes the blame.",
      "prerequisites": {
        "all": [
          "fact:operation-supported",
          "fact:witnesses-intimidated"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "campaign:B1"
        ],
        "remove": []
      },
      "arcActionId": "slice.M3-licensed-atrocity",
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 24,
      "operation": "settle-operation",
      "afterResolution": false
    },
    {
      "id": "personal-record",
      "beatId": "z04-cart-ramp-office",
      "speakerId": null,
      "label": "Recover the papers for your own claim",
      "intention": "ask",
      "text": "Search the pledged claims drawer for your original papers.",
      "reply": "Your packet lies beneath the repair advance. Its edges have been trimmed to fit someone else’s account. You take it whole.",
      "journal": "Recovered the source papers for your personal claim. The final finding still depends on how you settle the case.",
      "prerequisites": {
        "all": [
          "fact:kiln-access"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:personal-recovered"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "dry-cut",
      "beatId": "z04-dry-cut",
      "speakerId": null,
      "label": "Examine the staple in sealed mortar",
      "intention": "ask",
      "text": "Check the mortar around the modern staple.",
      "reply": "The mortar has not been cut. You make a rubbing and leave the staple where it is. None of the station diagrams contains this place.",
      "journal": "A modern repair staple lies inside undisturbed old mortar. This is unrelated to the corpse-work and remains unexplained.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:cycle-clue"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "odel-after",
      "beatId": "z04-cooling-court",
      "speakerId": "odel",
      "label": "Ask who keeps the records now",
      "intention": "ask",
      "text": "Who will keep the names?",
      "reply": "Whoever has the ledger needs someone looking over their shoulder. You may put that in your own book.",
      "journal": "Odel asks for scrutiny of whoever now controls the burial records.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "story:odel-after"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "tether-gallery",
      "beatId": "z04-lower-work-gallery",
      "speakerId": null,
      "label": "Inspect the lower gallery anchor",
      "intention": "ask",
      "text": "Examine the numbered wax arrangement without disturbing it.",
      "reply": "Two shallow grooves hold the wax, with a third worn half away where thumbs have pressed it. You copy their order and the station number. {working}’s counting goes on while you work.",
      "journal": "Copied the actual tether arrangement at the lower gallery.",
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": [
          "story:tether-gallery"
        ]
      },
      "effects": {
        "add": [
          "story:tether-gallery"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "inspect-anchor",
      "afterResolution": false,
      "stationId": "station-lower-gallery"
    },
    {
      "id": "tether-gallery-remains",
      "beatId": "z04-lower-work-gallery",
      "speakerId": null,
      "label": "Examine the stopped lower gallery station",
      "intention": "ask",
      "text": "Check the plinth and the remains where the gallery anchor worked.",
      "reply": "The gallery anchor no longer binds anything. You sketch the empty fitting in your notes; the plinth keeps its tally silence. The station diagrams are the only comparison left.",
      "journal": "Examined the stopped lower gallery station. Nothing there still binds; there is no anchor left to copy or release.",
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": [
          "story:tether-gallery"
        ]
      },
      "effects": {
        "add": [
          "story:tether-gallery"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "inspect-stilled-station",
      "afterResolution": false,
      "stationId": "station-lower-gallery"
    },
    {
      "id": "tether-vault",
      "beatId": "z04-cooling-court",
      "speakerId": null,
      "label": "Inspect the columbarium vault anchor",
      "intention": "ask",
      "text": "Examine the numbered wax arrangement without disturbing it.",
      "reply": "The wax sits in three pigeonhole grooves, each initialled in chalk that has been wetted and rewritten. You copy their order and the station number. Cold air moves through the niches while you work.",
      "journal": "Copied the actual tether arrangement at the columbarium vault.",
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": [
          "story:tether-vault"
        ]
      },
      "effects": {
        "add": [
          "story:tether-vault"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "inspect-anchor",
      "afterResolution": false,
      "stationId": "station-columbarium-vault"
    },
    {
      "id": "tether-vault-remains",
      "beatId": "z04-cooling-court",
      "speakerId": null,
      "label": "Examine the stopped columbarium vault station",
      "intention": "ask",
      "text": "Check the plinth and the remains where the vault anchor worked.",
      "reply": "The vault anchor is cold and unbound. You mark the empty fitting, and the niches give back nothing to count. The station diagrams are the only record left.",
      "journal": "Examined the stopped columbarium vault station. The anchor is spent; no working arrangement remains to copy or release.",
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": [
          "story:tether-vault"
        ]
      },
      "effects": {
        "add": [
          "story:tether-vault"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "inspect-stilled-station",
      "afterResolution": false,
      "stationId": "station-columbarium-vault"
    },
    {
      "id": "tether-firing",
      "beatId": "z04-cart-ramp-office",
      "speakerId": null,
      "label": "Inspect the firing tunnel anchor",
      "intention": "ask",
      "text": "Examine the numbered wax arrangement without disturbing it.",
      "reply": "Three grooves hold the wax, the middle one blistered soft by kiln heat and re-cut with a hot wire. You copy their order and the station number. The tunnel draught pulls at the wax while you work.",
      "journal": "Copied the actual tether arrangement at the firing tunnel.",
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": [
          "story:tether-firing"
        ]
      },
      "effects": {
        "add": [
          "story:tether-firing"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "inspect-anchor",
      "afterResolution": false,
      "stationId": "station-firing-tunnels"
    },
    {
      "id": "tether-firing-remains",
      "beatId": "z04-cart-ramp-office",
      "speakerId": null,
      "label": "Examine the stopped firing tunnel station",
      "intention": "ask",
      "text": "Check the plinth and the remains where the tunnel anchor worked.",
      "reply": "The firing-tunnel anchor has gone slack with the heat. You mark the empty fitting in your notes; soot has filled the grooves past reading. The station diagrams are the only witness left.",
      "journal": "Examined the stopped firing tunnel station. Heat has taken the binding; no readable anchor remains to copy or release.",
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": [
          "story:tether-firing"
        ]
      },
      "effects": {
        "add": [
          "story:tether-firing"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "inspect-stilled-station",
      "afterResolution": false,
      "stationId": "station-firing-tunnels"
    },
    {
      "id": "theron-niche",
      "beatId": "z04-cooling-court",
      "speakerId": null,
      "label": "Read Theron’s reassigned niche against the vault roster",
      "intention": "ask",
      "text": "Match the niche number on the transfer entry to the columbarium shelves.",
      "reply": "The niche on your receipt holds another family’s urn. Its number appears again on the vault station’s roster. The body listed beside it favours its left hand, as Theron did. It is his body, not him. How this station ends decides whether you can bury it.",
      "journal": "Found Theron’s body on the vault station roster. If the station ends without fire, his remains can be named and buried.",
      "prerequisites": {
        "all": [
          "story:personal-recovered"
        ],
        "any": [],
        "none": [
          "fact:terminal-accounting-complete"
        ]
      },
      "effects": {
        "add": [
          "story:claim-closed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "grave-witness"
    },
    {
      "id": "broker-chain",
      "beatId": "z04-cooling-court",
      "speakerId": "odel",
      "label": "Show Odel the broker chain on your sale",
      "intention": "ask",
      "text": "Three offices certify the same debt on me. Do you know this hand?",
      "reply": "Odel reads the chain the way he read his sister’s bond. “Same clerk. He adds the interest before he copies, so every office thinks it holds the first debt.” He taps the kiln copy. “Hers went through the same drawer. When the court strikes her bond for this, it can strike all three of yours on the same page. If hers stays in the drawer, so do yours.”",
      "journal": "Odel named the broker’s trick on all three copies of your sale. They are struck with his sister’s bond, or not at all: her release has to be paid before the settlement is registered.",
      "prerequisites": {
        "all": [
          "story:personal-recovered"
        ],
        "any": [],
        "none": [
          "fact:terminal-accounting-complete"
        ]
      },
      "effects": {
        "add": [
          "story:claim-closed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "escaped-worker"
    },
    {
      "id": "family-fee",
      "beatId": "z04-gate-of-accounts",
      "speakerId": null,
      "label": "Pay the waiting family’s second burial fee — 3 cuts",
      "intention": "offer",
      "text": "Put {cuts} beside their first receipt.",
      "reply": "The clerk gives them a collection cord. “Keep both receipts,” the mother says. “We appear to be collecting those as well.”",
      "journal": "Paid the family’s duplicate fee: {cuts}. They can enter the identification room.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "side:family-admitted"
        ]
      },
      "effects": {
        "add": [
          "side:family-admitted"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 3,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false,
      "touches": [
        "z04-cooling-court"
      ]
    },
    {
      "id": "family-exemption",
      "beatId": "z04-gate-of-accounts",
      "speakerId": null,
      "label": "Use the corrected schedule to admit the family",
      "intention": "ask",
      "text": "Put the exemption over the second payment line.",
      "reply": "The clerk looks for a place to argue, then hands over the collection cord. The mother keeps both papers.",
      "journal": "Used the civilian exemption. The family enters without paying again.",
      "prerequisites": {
        "all": [
          "side:fee-exemption"
        ],
        "any": [],
        "none": [
          "side:family-admitted"
        ]
      },
      "effects": {
        "add": [
          "side:family-admitted"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false,
      "touches": [
        "z04-cooling-court"
      ]
    },
    {
      "id": "urn-identify",
      "beatId": "z04-cooling-court",
      "speakerId": null,
      "label": "Match the two-cut wrapping to Nessa’s urn",
      "intention": "ask",
      "text": "Check the wrapping and the family marks; leave the other urns closed.",
      "reply": "The return mark matches the coffin seal. Under it, Nessa’s mother’s name is written in a different hand. Odel brings a basket. “This one can travel without becoming cargo.”",
      "journal": "Identified Nessa’s mother’s urn without disturbing other burials. Nessa can collect it from the landing.",
      "prerequisites": {
        "all": [
          "side:seal-copied",
          "side:family-admitted"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "side:urn-identified"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "gallery-release",
      "beatId": "z04-lower-work-gallery",
      "speakerId": null,
      "label": "Unfasten this station’s anchor — 2 cuts for holding cloth",
      "intention": "offer",
      "text": "Follow the copied grooves. Keep the bodies supported as the motion stops.",
      "reply": "{working}’s fingers lower, and the neighbouring body settles against the cloth. No breath follows. The sorting lane is quiet enough for the family to enter.",
      "journal": "Released the lower station and preserved its remains. This station cannot supply Noll’s licensed bargain.",
      "prerequisites": {
        "all": [
          "story:tether-gallery"
        ],
        "any": [],
        "none": [
          "fact:operation-supported"
        ]
      },
      "effects": {
        "add": [
          "side:gallery-released"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 2,
      "rewardCuts": 0,
      "operation": "release-gallery",
      "afterResolution": false,
      "stationId": "station-lower-gallery"
    },
    {
      "id": "sela-salt",
      "beatId": "z04-selas-rooms",
      "speakerId": "sela",
      "label": "Separate unused treatment salt from the binding stock",
      "intention": "ask",
      "text": "These sealed jars have no wax in them. May the bath have them?",
      "reply": "Sela puts the plain jars by the door. “Yes. Do not credit me with charity. I charged the bath for them last month.”",
      "journal": "Recovered the bath’s prepaid ordinary salt. Deliver it to restore affordable treatment stock.",
      "prerequisites": {
        "all": [
          "story:lawful-demo",
          "fact:records-secured"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "side:salt-recovered"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "driver-pay",
      "beatId": "z04-cart-ramp-office",
      "speakerId": null,
      "label": "Pay the cart driver to carry family copies — 3 cuts",
      "intention": "offer",
      "text": "You are paid by the journey. Take these copies to the families.",
      "reply": "“At last, a destination.” He checks that no names are missing before folding the sheet. “I am not doing nine separate trips.”",
      "journal": "Paid three cuts for burial copies to reach the families. They can maintain a handover watch if the concession closes.",
      "prerequisites": {
        "all": [
          "fact:records-secured",
          "fact:removal-intercepted"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "side:family-copies"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 3,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": false
    },
    {
      "id": "dry-cut-measure",
      "beatId": "z04-dry-cut",
      "speakerId": null,
      "label": "Compare the staple with the lift fitter’s marks",
      "intention": "ask",
      "text": "Lay the rubbing beside your notes from the bearing.",
      "reply": "The staple has the fitter’s fresh die flaw. The mortar over its arms has no break. You draw both, including the part that will not fit an explanation.",
      "journal": "Recorded a checkable comparison: a current die flaw beneath undisturbed old mortar. No cause is established.",
      "prerequisites": {
        "all": [
          "story:cycle-clue",
          "story:bearing-known"
        ],
        "any": [],
        "none": [
          "legacy:record-read"
        ]
      },
      "effects": {
        "add": [
          "side:staple-compared"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "still-place",
      "beatId": "z04-dry-cut",
      "speakerId": null,
      "label": "Enter the stone refuge and close this life",
      "intention": "ask",
      "text": "Settle into the dry recess beyond the old channel.",
      "reply": "The waiting is long. Nothing in the kiln equipment changes it. When the road opens again, the people who left with the interval do not recognise you.",
      "journal": "Closed this compact life at the still place. The dead remain dead; your possessions and unpaid promises remain yours.",
      "prerequisites": {
        "all": [
          "fact:local-aftermath-observed"
        ],
        "any": [],
        "none": [
          "campaign:B2"
        ]
      },
      "effects": {
        "add": [
          "story:life-closed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "close-life",
      "afterResolution": true
    },
    {
      "id": "staple-recheck",
      "beatId": "z04-dry-cut",
      "speakerId": null,
      "label": "Lay the deposited drawing over the staple",
      "intention": "ask",
      "text": "Match the landing copy to the staple, line by line.",
      "reply": "Every line holds: the same staple, the same fresh die flaw, the same unbroken mortar over its arms. Only the court’s receiving stamp is wrong. It is dated to a day that has not come yet. You add your own rubbing beneath the first and leave the cause column empty, as they did.",
      "journal": "The deposited drawing matches the staple exactly, but the court stamped it on a day still to come. Your own rubbing now sits beneath it. No cause is established.",
      "prerequisites": {
        "all": [
          "story:cycle-clue",
          "legacy:record-read"
        ],
        "any": [],
        "none": [
          "side:staple-rechecked"
        ]
      },
      "effects": {
        "add": [
          "side:staple-rechecked",
          "side:staple-compared"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-docket",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Carry the court’s grain docket upriver to Caldris — your rest at the Dry Cut waits until you are back",
      "intention": "offer",
      "text": "You said the grain goes upriver. Who signs for it at the other end?",
      "reply": "Caldris does, or nobody pays us. Their grain court counts every barge from the Silt Stair against the city’s bread register. This docket says what we sent. Bring it back with their seal and the court pays you ten cuts. The towpath barge leaves from the Lock Foot; show it the docket.",
      "journal": "Took the court’s grain docket for Caldris, 43 km up the towpath from the Lock Foot. The grain court must seal it; the court pays ten cuts on return. The still place can wait.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete"
        ],
        "any": [],
        "none": [
          "campaign:B2"
        ]
      },
      "effects": {
        "add": [
          "campaign:B2",
          "z01:docket",
          "errand:z01:underway"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-docket-second",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Carry the court’s grain docket up to Caldris as well — your rest at the Dry Cut waits until it is sealed",
      "intention": "offer",
      "text": "The grain still goes upriver. Has Caldris had its docket?",
      "reply": "Not yet. Their grain court counts every barge from the Silt Stair against the city’s bread register, and this docket says what we sent. Bring it back with their seal and the court pays you ten cuts. The towpath barge leaves from the Lock Foot; show it the docket.",
      "journal": "Took the court’s grain docket for Caldris as well, 43 km up the towpath from the Lock Foot. The grain court must seal it; the court pays ten cuts on return.",
      "prerequisites": {
        "all": [
          "campaign:B2"
        ],
        "any": [],
        "none": [
          "z01:docket",
          "errand:second",
          "campaign:B4",
          "campaign:B6"
        ]
      },
      "effects": {
        "add": [
          "z01:docket",
          "errand:z01:underway",
          "errand:second"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-docket-return",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Hand back the sealed docket — the court pays 10 cuts",
      "intention": "ask",
      "text": "Sealed by the grain court in Caldris.",
      "reply": "So it is. Ten cuts, as promised. What they did with our grain is written on the back, and I will read it tonight.",
      "journal": "Returned the sealed Caldris docket to the court and was paid ten cuts. The errand is done.",
      "prerequisites": {
        "all": [
          "z01:docket-sealed"
        ],
        "any": [],
        "none": [
          "z01:docket-returned"
        ]
      },
      "effects": {
        "add": [
          "z01:docket-returned",
          "errand:z01:done"
        ],
        "remove": [
          "errand:z01:underway"
        ]
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 10,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-watch-count",
      "beatId": "beat:z01-river-bridge",
      "speakerId": "z01-captain",
      "label": "Ask why the watch counts every sack twice",
      "intention": "ask",
      "text": "Why count every sack twice?",
      "reply": "Because nobody has paid the watch in coin for months, and a short count comes out of whatever we do get. The register table sells exemptions to feed the watch. Ask the registrar where that money goes. I have stopped asking.",
      "journal": "The forum watch is unpaid. The register table sells exemptions, and the money is meant for the watch.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "z01:watch-unpaid",
          "z01:watch-posted",
          "z01:runner-beaten"
        ]
      },
      "effects": {
        "add": [
          "z01:watch-unpaid"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-watch-post",
      "beatId": "beat:z01-river-bridge",
      "speakerId": "z01-captain",
      "label": "Pay two watchmen to stand at the archive grille — 8 cuts",
      "intention": "offer",
      "text": "The advocate’s man is carrying the bond chests out of the archive. Two of yours at the grille would stop him.",
      "reply": "Eight cuts is two men fed for a day and a night. For that they will stand at the grille and look official. He will not argue with bronze.",
      "journal": "Paid {cuts} to post two of the forum watch at the archive grille.",
      "prerequisites": {
        "all": [
          "z01:runner-seen"
        ],
        "any": [],
        "none": [
          "z01:watch-posted",
          "z01:chests-open",
          "z01:runner-beaten"
        ]
      },
      "effects": {
        "add": [
          "z01:watch-posted"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 8,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-docket-read",
      "beatId": "beat:z01-grain-court",
      "speakerId": "z01-registrar",
      "label": "Hand over the Silt Stair docket",
      "intention": "ask",
      "text": "The Silt Stair’s grain docket, from the court.",
      "reply": "Let me see what your barges carried. Every sack buys a place on the register, and there are more names than places. The man in grey at the end of my table is Advocate Vasko’s clerk. He writes down whoever seals over a bond they know to be bad.",
      "journal": "The registrar read the docket against the bread register. The Silt Stair’s grain buys places, and more households are struck than it can feed.",
      "prerequisites": {
        "all": [
          "z01:docket"
        ],
        "any": [],
        "none": [
          "z01:docket-read"
        ]
      },
      "effects": {
        "add": [
          "z01:docket-read"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-registrar-bonds",
      "beatId": "beat:z01-grain-court",
      "speakerId": "z01-registrar",
      "label": "Ask why bonded households are struck",
      "intention": "ask",
      "text": "Why are the struck households struck?",
      "reply": "In 640 the Senate sold ninety-six disputed debts to pay for the bread fund. Buyers paid the fund; the fund bought bread. The rule says a bonded household is fed by its creditor, so the register strikes it. The bonds that paid for the bread keep their households off the bread.",
      "journal": "The bread fund was paid for by selling ninety-six debt bonds. The register strikes every bonded household.",
      "prerequisites": {
        "all": [
          "z01:docket-read"
        ],
        "any": [],
        "none": [
          "z01:bonds-explained",
          "z01:docket-sealed",
          "z01:bonds-void"
        ]
      },
      "effects": {
        "add": [
          "z01:bonds-explained"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-register-call",
      "beatId": "beat:z01-grain-court",
      "speakerId": "z01-registrar",
      "label": "Call names at the register table for a morning — earn 6 cuts once",
      "intention": "offer",
      "text": "Your voice is going. I can read names.",
      "reply": "Then read. Loud, and in order, and do not look up when a name has a line through it. Six cuts from the exemption box; the watch will forgive me.",
      "journal": "Called names at the bread register for a morning and was paid six cuts. Some names had a line through them; you read those too.",
      "prerequisites": {
        "all": [
          "z01:docket-read"
        ],
        "any": [],
        "none": [
          "z01:called-names",
          "z01:docket-sealed",
          "z01:bonds-void"
        ]
      },
      "effects": {
        "add": [
          "z01:called-names"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 6,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-seal-standing",
      "beatId": "beat:z01-grain-court",
      "speakerId": "z01-registrar",
      "label": "Have the docket sealed against the register as it stands — the struck households stay struck; you know nothing against their bonds, so the advocate’s clerk has nothing to write",
      "intention": "ask",
      "text": "Seal it as the register stands.",
      "reply": "Done. The same names eat and the same names wait. It is the lawful answer, and the quick one. At the end of the table the clerk in advocate’s grey looks up, finds nothing in it to write down, and goes back to his tablet.",
      "journal": "The grain court sealed the docket against the register as it stands. The struck households stay struck.",
      "prerequisites": {
        "all": [
          "z01:docket-read"
        ],
        "any": [],
        "none": [
          "z01:docket-sealed",
          "z01:witness-dated"
        ]
      },
      "effects": {
        "add": [
          "z01:docket-sealed",
          "z01:register-standing",
          "errand:z01:standing"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-seal-knowing",
      "beatId": "beat:z01-grain-court",
      "speakerId": "z01-registrar",
      "label": "Have the docket sealed against the register as it stands — the households struck on drowned men’s oaths stay struck, and the advocate’s clerk writes down that you knew",
      "intention": "ask",
      "text": "Seal it as the register stands. I know about Aulo.",
      "reply": "The registrar looks at you over the docket. “So do I. It is still the lawful answer, and the quick one.” The seal goes down. The same names eat and the same names wait. At the end of the table a clerk in advocate’s grey writes down the date, and then your name.",
      "journal": "Had the docket sealed against the register as it stands, knowing that households were struck on the oaths of drowned men. An advocate’s clerk wrote down your name.",
      "prerequisites": {
        "all": [
          "z01:docket-read",
          "z01:witness-dated"
        ],
        "any": [],
        "none": [
          "z01:docket-sealed"
        ]
      },
      "effects": {
        "add": [
          "z01:docket-sealed",
          "z01:register-standing",
          "errand:z01:standing",
          "pressure:z01:sealed-over-drowned"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-seal-restored",
      "beatId": "beat:z01-grain-court",
      "speakerId": "z01-registrar",
      "label": "Have the voided households read first, then seal the docket",
      "intention": "ask",
      "text": "The court voided eleven bonds. Read those households first.",
      "reply": "Then eleven households eat that did not, and eleven honest debtors wait a season longer. I will read the names aloud. You may want to stand somewhere else.",
      "journal": "The registrar read the eleven voided households back onto the register first and sealed the docket. Eleven other households wait a season longer.",
      "prerequisites": {
        "all": [
          "z01:docket-read",
          "z01:bonds-void"
        ],
        "any": [],
        "none": [
          "z01:docket-sealed"
        ]
      },
      "effects": {
        "add": [
          "z01:docket-sealed",
          "z01:households-restored",
          "errand:z01:restored"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z01-irra"
      ]
    },
    {
      "id": "z01-exemption",
      "beatId": "beat:z01-grain-court",
      "speakerId": "z01-registrar",
      "label": "Buy the Senth household an exemption — 6 cuts",
      "intention": "offer",
      "text": "What does an exemption cost for the Senth household?",
      "reply": "Six cuts, and the watch is fed for a day. Her name goes back on the list. Everyone in the queue is watching you pay it.",
      "journal": "Paid {cuts} for an exemption. The Senth household is back on the register this season; the money feeds the watch.",
      "prerequisites": {
        "all": [
          "z01:bond-lead",
          "z01:docket-read"
        ],
        "any": [],
        "none": [
          "z01:irra-exempted",
          "z01:bond-bought",
          "z01:households-restored"
        ]
      },
      "effects": {
        "add": [
          "z01:irra-exempted"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 6,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z01-irra"
      ]
    },
    {
      "id": "z01-irra-bond",
      "beatId": "beat:z01-grain-court",
      "speakerId": "z01-irra",
      "label": "Ask who holds her husband’s bond",
      "intention": "ask",
      "text": "Who holds your husband’s bond now?",
      "reply": "An advocate, Vasko, bought a bundle of them. He says they are sound because a witness swore to each one. My husband’s witness was Aulo the carter. Aulo drowned in the flood two winters before he swore. The archive under the basilica keeps the flood register.",
      "journal": "Irra Senth’s household was struck because her husband’s debt is one of the ninety-six. Its witness, Aulo the carter, drowned two winters before he swore. The flood register is in the archive under the basilica.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "z01:bond-lead"
        ]
      },
      "effects": {
        "add": [
          "z01:bond-lead"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-irra-bread",
      "beatId": "beat:z01-grain-court",
      "speakerId": "z01-irra",
      "label": "Buy the Senth household today’s bread — 2 cuts",
      "intention": "offer",
      "text": "Take this for today’s bread.",
      "reply": "Two cuts is bread for the four of us. I will take it. I would rather have the name back on the list.",
      "journal": "Paid {cuts} for a day’s bread for the Senth household.",
      "prerequisites": {
        "all": [
          "z01:bond-lead"
        ],
        "any": [],
        "none": [
          "z01:irra-fed",
          "z01:irra-exempted",
          "z01:bond-bought",
          "z01:households-restored"
        ]
      },
      "effects": {
        "add": [
          "z01:irra-fed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 2,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-irra-witness",
      "beatId": "beat:z01-grain-court",
      "speakerId": "z01-irra",
      "label": "Show her Aulo in the flood register and ask her to tell the court",
      "intention": "ask",
      "text": "Aulo is in the flood register. Will you tell the court what you know?",
      "reply": "Two winters before he swore. I knew it, and now it is written somewhere the court keeps. Yes. I will stand up in that basilica and say it.",
      "journal": "Irra Senth will testify before the Senate court that the witness to her husband’s bond was already dead.",
      "prerequisites": {
        "all": [
          "z01:witness-dated"
        ],
        "any": [],
        "none": [
          "z01:irra-witness",
          "z01:bond-bought",
          "z01:claimant-declared"
        ]
      },
      "effects": {
        "add": [
          "z01:irra-witness"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-claimant-ask",
      "beatId": "beat:z01-basilica",
      "speakerId": "z01-claimant",
      "label": "Ask why she sits on a second dais",
      "intention": "ask",
      "text": "Why two daises?",
      "reply": "The Senate holds that the empire’s seat is empty until a court fills it. I hold that it is not empty; I am sitting in it. Meanwhile I feed three hundred households from my own granary, which is more than their register does this week.",
      "journal": "Liria Castel claims the imperial succession from a second dais in the basilica, and feeds households from her own granary.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "z01:claimant-met",
          "z01:claimant-declared"
        ]
      },
      "effects": {
        "add": [
          "z01:claimant-met"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-claimant-feed",
      "beatId": "beat:z01-basilica",
      "speakerId": "z01-claimant",
      "label": "Ask her to feed the struck households — you stand at her dais, and the Senate court will not hear you after",
      "intention": "offer",
      "text": "Will you feed the households the register struck?",
      "reply": "Gladly, and publicly. Stand here beside me while the court sits, so their clerks can write your name down with mine. Then my carts go to the end of the queue tonight.",
      "journal": "Stood at the claimant’s dais in front of the Senate court. Her granary feeds the struck households; the Senate court will not hear your petition now.",
      "prerequisites": {
        "all": [
          "z01:docket-read"
        ],
        "any": [],
        "none": [
          "z01:claimant-declared",
          "z01:bonds-void"
        ]
      },
      "effects": {
        "add": [
          "z01:claimant-declared"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z01-irra",
        "z01-registrar"
      ]
    },
    {
      "id": "z01-advocate-ask",
      "beatId": "beat:z01-basilica",
      "speakerId": "z01-advocate",
      "label": "Ask how he came by the bonds",
      "intention": "ask",
      "text": "How did you come by the ninety-six bonds?",
      "reply": "I bought them from their first buyers at a discount, when the fund’s credit wobbled. Every bond was sworn before this court. I do not make debts. I only see that the court’s word is kept.",
      "journal": "Advocate Idrin Vasko bought many of the ninety-six bonds cheaply and holds that every one was properly sworn.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "z01:advocate-met",
          "z01:bond-bought",
          "z01:advocate-confronted",
          "z01:bonds-void"
        ]
      },
      "effects": {
        "add": [
          "z01:advocate-met"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-advocate-sell",
      "beatId": "beat:z01-basilica",
      "speakerId": "z01-advocate",
      "label": "Buy the Senth bond from him and tear it up — 12 cuts; Irra will not stand before the court after",
      "intention": "offer",
      "text": "What do you want for the Senth bond?",
      "reply": "Twelve cuts, which is less than it is worth. Here. Tear it if it pleases you. There are ninety-five more. Your cuts will pay for the reading on the next one.",
      "journal": "Paid {cuts} to buy the Senth bond from Advocate Vasko and tore it up. The Senth household can eat; Irra will not risk the court now.",
      "prerequisites": {
        "all": [
          "z01:bond-lead"
        ],
        "any": [],
        "none": [
          "z01:bond-bought",
          "z01:advocate-confronted",
          "z01:bonds-void",
          "z01:irra-witness",
          "z01:irra-exempted",
          "z01:households-restored"
        ]
      },
      "effects": {
        "add": [
          "z01:bond-bought",
          "pressure:z01:advocate-paid"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 12,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z01-irra",
        "z01-registrar"
      ]
    },
    {
      "id": "z01-advocate-confront",
      "beatId": "beat:z01-basilica",
      "speakerId": "z01-advocate",
      "label": "Tell him Aulo drowned two winters before he swore",
      "intention": "ask",
      "text": "Aulo the carter drowned two winters before he swore to the Senth debt.",
      "reply": "And yet he swore, and the court accepted it. There are people who can ask the dead a question and write down what the body does. It is expensive, and the court has always found it persuasive.",
      "journal": "Vasko does not deny that Aulo was dead when he swore. He says the court accepts testimony taken from the dead.",
      "prerequisites": {
        "all": [
          "z01:witness-dated"
        ],
        "any": [],
        "none": [
          "z01:advocate-confronted",
          "z01:bonds-void"
        ]
      },
      "effects": {
        "add": [
          "z01:advocate-confronted"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-petition",
      "beatId": "beat:z01-basilica",
      "speakerId": null,
      "label": "Put the bond file, the flood register and Irra before the Senate court",
      "intention": "ask",
      "text": "Eleven of the ninety-six bonds were sworn by witnesses the flood register already lists as drowned. Irra Senth will say so.",
      "reply": "The reading clerk takes the two books and hears Irra out. The court voids eleven bonds sworn by dead witnesses. It says nothing about the other eighty-five. A general inquiry, the clerk says, would ask where the bread fund’s money went, and neither dais wants that read aloud.",
      "journal": "The Senate court voided the eleven bonds sworn by dead witnesses, and refused a general inquiry into the other eighty-five.",
      "prerequisites": {
        "all": [
          "z01:bond-list",
          "z01:witness-dated",
          "z01:irra-witness",
          "z01:holder-sen"
        ],
        "any": [],
        "none": [
          "z01:bonds-void",
          "z01:claimant-declared",
          "z01:docket-sealed"
        ]
      },
      "effects": {
        "add": [
          "z01:bonds-void"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z01-irra",
        "z01-registrar",
        "z01-advocate"
      ]
    },
    {
      "id": "z01-petition-standard",
      "beatId": "beat:z01-basilica",
      "speakerId": null,
      "label": "Put the bond file, the flood register and Irra before the Senate court — the Standard countersigns for a quarter of the grain",
      "intention": "ask",
      "text": "Eleven of the ninety-six bonds were sworn by witnesses the flood register already lists as drowned. Irra Senth will say so.",
      "reply": "The reading clerk hears Irra out and voids eleven bonds sworn by dead witnesses. The depot officer countersigns, for a quarter of this season’s Silt Stair grain to the army depots. The court refuses any inquiry into the other eighty-five.",
      "journal": "The Senate court voided the eleven bonds sworn by dead witnesses. The Standard countersigned the finding for a quarter of the Silt Stair grain.",
      "prerequisites": {
        "all": [
          "z01:bond-list",
          "z01:witness-dated",
          "z01:irra-witness",
          "z01:holder-brz"
        ],
        "any": [],
        "none": [
          "z01:bonds-void",
          "z01:claimant-declared",
          "z01:docket-sealed"
        ]
      },
      "effects": {
        "add": [
          "z01:bonds-void",
          "z01:depot-countersign"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z01-irra",
        "z01-registrar",
        "z01-advocate"
      ]
    },
    {
      "id": "z01-runner-ask",
      "beatId": "beat:z01-archive-stair",
      "speakerId": null,
      "label": "Ask the man at the grille whose chests these are",
      "intention": "ask",
      "text": "Whose chests are those?",
      "reply": "“Advocate Vasko’s business. The bond chests go to his chambers for safekeeping; the archive cannot keep the river out, and he can. Stand aside.” He has a cudgel on his belt and the patience of a man paid by the load.",
      "journal": "The advocate’s runner is carrying the ninety-six bond files out of the archive.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "z01:runner-seen"
        ]
      },
      "effects": {
        "add": [
          "z01:runner-seen"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-runner-pay",
      "beatId": "beat:z01-archive-stair",
      "speakerId": null,
      "label": "Pay the runner to let you read the bond file first — 5 cuts",
      "intention": "offer",
      "text": "Five cuts to read before you carry.",
      "reply": "“Five cuts to study the ceiling.” He sits on the handcart. “Be quick. What you read is yours. What I carry is his.”",
      "journal": "Paid the advocate’s runner {cuts} to read the bond file before he carries it off.",
      "prerequisites": {
        "all": [
          "z01:runner-seen"
        ],
        "any": [],
        "none": [
          "z01:chests-open",
          "z01:runner-beaten"
        ]
      },
      "effects": {
        "add": [
          "z01:runner-paid",
          "z01:chests-open"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 5,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-runner-watch",
      "beatId": "beat:z01-archive-stair",
      "speakerId": null,
      "label": "Point the runner to the watchmen at the grille",
      "intention": "ask",
      "text": "The forum watch is keeping these chests here.",
      "reply": "He looks at the two bronze helmets, then at his handcart. “Nobody pays me to argue with the watch.” He goes up the stair without the chests.",
      "journal": "The forum watch stood at the grille, and the advocate’s runner left the bond chests behind.",
      "prerequisites": {
        "all": [
          "z01:watch-posted"
        ],
        "any": [],
        "none": [
          "z01:chests-open",
          "z01:runner-beaten"
        ]
      },
      "effects": {
        "add": [
          "z01:chests-open"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-runner-fight",
      "beatId": "beat:z01-archive-stair",
      "speakerId": null,
      "label": "Take the bond chests from the runner by force",
      "intention": "ask",
      "text": "Leave the chests.",
      "reply": "He puts the chest down and takes the cudgel off his belt. “Then take them.”",
      "journal": "Chose to take the bond chests from the advocate’s runner by force.",
      "prerequisites": {
        "all": [
          "z01:runner-seen"
        ],
        "any": [],
        "none": [
          "z01:chests-open",
          "z01:runner-beaten"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "fight",
      "afterResolution": true,
      "encounter": "z01-runner"
    },
    {
      "id": "z01-archive-bonds",
      "beatId": "beat:z01-archive-stair",
      "speakerId": null,
      "label": "Read the bond file of the ninety-six",
      "intention": "ask",
      "text": "Open the bond file.",
      "reply": "Ninety-six bonds, sold in 640 for the bread fund. Eighty-five rest on signed debts. Eleven rest on sworn statements instead, and the same four witnesses swore to all eleven, each on a dated line. You copy the four names and their dates.",
      "journal": "The bond file: eleven of the ninety-six bonds rest on sworn statements by the same four witnesses. You have copied their names and dates.",
      "prerequisites": {
        "all": [],
        "any": [
          "z01:chests-open",
          "z01:runner-beaten"
        ],
        "none": [
          "z01:bond-list"
        ]
      },
      "effects": {
        "add": [
          "z01:bond-list"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z01-archive-flood",
      "beatId": "beat:z01-archive-stair",
      "speakerId": null,
      "label": "Find Aulo the carter in the flood register",
      "intention": "ask",
      "text": "Look for Aulo the carter.",
      "reply": "The flood register lists the dead of the winter the river came up this stair. Aulo the carter is there, drowned two winters before the date on the Senth bond. The other three names that swore to the eleven sworn bonds are on the same page.",
      "journal": "The flood register lists Aulo the carter and three other bond witnesses as drowned before the dates they swore.",
      "prerequisites": {
        "all": [
          "z01:bond-lead"
        ],
        "any": [],
        "none": [
          "z01:witness-dated"
        ]
      },
      "effects": {
        "add": [
          "z01:witness-dated"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-notes",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Carry the court’s quay notes down the canal to Nacre Quay — your rest at the Dry Cut waits until you are back",
      "intention": "offer",
      "text": "You said the court sold grain down the canal. What came back?",
      "reply": "Paper. Three Salt Compact quay notes, each good for forty measures of grain from the relief fleet at Nacre Quay, due before winter. The fleet is in, and nothing has come up the canal. Take the notes to the sale court at Nacre and have them redeemed. Sign what you must in the court’s name, but bring us grain. The court pays you ten cuts when the notes are settled. The canal boat leaves from the Lower Landing; the fare is yours to find.",
      "journal": "Took the court’s three quay notes for Nacre Quay, 76 km down the lower canal from the Lower Landing. The sale court there must redeem them in grain from the relief fleet; the court pays ten cuts on return. The still place can wait.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete"
        ],
        "any": [],
        "none": [
          "campaign:B2"
        ]
      },
      "effects": {
        "add": [
          "campaign:B2",
          "z02:notes",
          "errand:z02:underway"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-notes-second",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Carry the court’s quay notes down the canal to Nacre Quay as well — your rest at the Dry Cut waits until they are settled",
      "intention": "offer",
      "text": "The grain the court sold down the canal: did anything come back?",
      "reply": "Paper. Three Salt Compact quay notes, each good for forty measures of grain from the relief fleet at Nacre Quay, due before winter. The fleet is in, and nothing has come up the canal. Take the notes to the sale court at Nacre and have them redeemed. Sign what you must in the court’s name, but bring us grain. The court pays you ten cuts when the notes are settled. The canal boat leaves from the Lower Landing; the fare is yours to find.",
      "journal": "Took the court’s three quay notes for Nacre Quay as well, 76 km down the lower canal from the Lower Landing. The sale court there must redeem them in grain from the relief fleet; the court pays ten cuts on return.",
      "prerequisites": {
        "all": [
          "campaign:B2"
        ],
        "any": [],
        "none": [
          "z02:notes",
          "errand:second",
          "campaign:B4",
          "campaign:B6"
        ]
      },
      "effects": {
        "add": [
          "z02:notes",
          "errand:z02:underway",
          "errand:second"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-fare",
      "beatId": "beat:lower-landing",
      "speakerId": null,
      "label": "Buy passage on the canal boat to Nacre Quay — 4 cuts",
      "intention": "offer",
      "text": "Passage to Nacre Quay.",
      "reply": "The ferry clerk takes your {cuts} and chalks a mark on your sleeve. “Seventy-six kilometres of canal and coast road. She goes when she is full, and she is always full.”",
      "journal": "Paid {cuts} for passage on the canal boat to Nacre Quay.",
      "prerequisites": {
        "all": [
          "z02:notes"
        ],
        "any": [],
        "none": [
          "travel:z02-fare"
        ]
      },
      "effects": {
        "add": [
          "travel:z02-fare"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 4,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-fare-work",
      "beatId": "beat:lower-landing",
      "speakerId": null,
      "label": "Work your passage at the sweeps instead of paying",
      "intention": "ask",
      "text": "I cannot pay the fare. I can row.",
      "reply": "“Everyone can row,” the ferry clerk says, and chalks a different mark on your sleeve. “Two shifts at the sweeps a day. You will know every lock on the canal by the coast.”",
      "journal": "Worked passage on the canal boat to Nacre Quay at the sweeps.",
      "prerequisites": {
        "all": [
          "z02:notes"
        ],
        "any": [],
        "none": [
          "travel:z02-fare"
        ]
      },
      "effects": {
        "add": [
          "travel:z02-fare",
          "z02:rowed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-notes-return",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Report the Nacre Quay notes settled — the court pays 10 cuts",
      "intention": "ask",
      "text": "The notes from Nacre Quay are settled.",
      "reply": "Then there is grain on the canal. Ten cuts, as promised. Whatever you signed at the coast, the court signed it too. The salt barges will tell me the rest before you do.",
      "journal": "Reported the Nacre Quay notes settled at Reeve’s Court and was paid ten cuts. The errand is done.",
      "prerequisites": {
        "all": [
          "z02:redeemed"
        ],
        "any": [],
        "none": [
          "errand:z02:done"
        ]
      },
      "effects": {
        "add": [
          "errand:z02:done"
        ],
        "remove": [
          "errand:z02:underway"
        ]
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 10,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-sereth-fleet",
      "beatId": "beat:z02-mole-berths",
      "speakerId": "z02-sereth",
      "label": "Ask why the fleet will not unload",
      "intention": "ask",
      "text": "Why will the fleet not unload?",
      "reply": "Because the Namar masters will not break a hatch until they know they will be paid, and at Nacre that means a Compact guarantee sworn at the shrine on the rope walk. The Convener swore one for this fleet. Now his clerks say it was sworn on conditions, and the pilot who could say otherwise drowned on the bar. Guarantees here have two witnesses. Heddo was one. Find out who the other was.",
      "journal": "The relief fleet will not unload without the Compact’s guarantee. It was sworn at the shrine on the rope walk before two witnesses; one of them, the pilot Heddo Rask, drowned on the bar.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "z02:fleet-asked",
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:fleet-asked"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-sereth-crew",
      "beatId": "beat:z02-mole-berths",
      "speakerId": "z02-sereth",
      "label": "Pay the crew’s withheld wages so they unload the pier hull for the Silt Stair — 8 cuts; the rest of the fleet will sail home full",
      "intention": "offer",
      "text": "What would it take for your crews to open that hull for the Silt Stair?",
      "reply": "{Cuts}. That is what the broker owes the crew who emptied his first lighter. Pay it, and we open the hull at the pier onto your canal barges, guarantee or none. The broker will call it theft, and the Namar masters will take the rest of the fleet home rather than anchor where a hold was emptied. His hook-hand sits on the hull’s gangway, and you will have to move her. Do not stand still in front of that hook; it comes quick, and it keeps coming.",
      "journal": "Paid {cuts} of the crews’ withheld wages. Sereth Vann’s crews will empty the pier hull onto the Silt Stair’s barges once the broker’s hook-hand is off the gangway. The rest of the fleet will sail home full.",
      "prerequisites": {
        "all": [
          "z02:guarantee-disputed"
        ],
        "any": [],
        "none": [
          "z02:crew-paid",
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:crew-paid"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 8,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-hull-fight",
      "beatId": "beat:z02-mole-berths",
      "speakerId": null,
      "label": "Move the broker’s hook-hand off the gangway by force",
      "intention": "ask",
      "text": "Off the gangway.",
      "reply": "She stands, lets the cargo hook swing on its rope, and takes the haft in both hands. “Broker’s cargo,” he says. “Come and unload it.”",
      "journal": "Chose to move the broker’s hook-hand off the hull’s gangway by force.",
      "prerequisites": {
        "all": [
          "z02:crew-paid"
        ],
        "any": [],
        "none": [
          "z02:gangway-cleared",
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "fight",
      "afterResolution": true,
      "encounter": "z02-hook-hand"
    },
    {
      "id": "z02-hull-load",
      "beatId": "beat:z02-mole-berths",
      "speakerId": "z02-sereth",
      "label": "Have the crews empty the hull onto the Silt Stair’s barges",
      "intention": "ask",
      "text": "Open her hatches.",
      "reply": "The crews go up the gangway past the blood. By dark the hull is empty and three canal barges ride low for the Silt Stair. Out beyond the bar, the Namar masters are already shortening their anchor cables.",
      "journal": "Sereth Vann’s crews emptied the relief fleet’s smallest hull onto the Silt Stair’s barges without a guarantee. The other three hulls are sailing home to Namar full.",
      "prerequisites": {
        "all": [
          "z02:gangway-cleared"
        ],
        "any": [],
        "none": [
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:redeemed",
          "errand:z02:grain-hull"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z02-maurel",
        "z02-inspector",
        "z02-tamsa"
      ]
    },
    {
      "id": "z02-tamsa-protect",
      "beatId": "beat:z02-mole-berths",
      "speakerId": "z02-sereth",
      "label": "Pay into the crews’ fund to carry Tamsa Brin’s bond — 6 cuts",
      "intention": "offer",
      "text": "Tamsa Brin will say what was sworn if the Convener cannot sell her bond. Can the crews carry it?",
      "reply": "For {cuts} into the fund, yes. A bond on the crews’ roll cannot be sold without a vote of the hull delegates, and the Convener will not win that vote this winter. Tell her the crews have her.",
      "journal": "Paid {cuts} into the crews’ fund. Tamsa Brin’s bond is on the crews’ roll, out of the Convener’s reach.",
      "prerequisites": {
        "all": [
          "z02:oath-heard"
        ],
        "any": [],
        "none": [
          "z02:tamsa-protected",
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:tamsa-protected"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 6,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z02-tamsa"
      ]
    },
    {
      "id": "z02-tide",
      "beatId": "beat:z02-mole-berths",
      "speakerId": null,
      "label": "Read the tide slate at the light",
      "intention": "ask",
      "text": "Read the tide slate.",
      "reply": "The keeper of the light chalks each day’s tides on a slate by her door, copied from an almanac the Namar ships bring. This one runs out at the end of the month after next. She says they all do: whichever port prints the almanac, its last page falls on the same day, and next year’s comes with the first ship after. Nobody at the light thinks that strange. You copy the last line.",
      "journal": "Copied the last line of the Namar tide almanac at the light on the mole. Every almanac ends on the same day, whichever port prints it. One harbour’s habit proves nothing yet.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "z02:tide-record"
        ]
      },
      "effects": {
        "add": [
          "z02:tide-record"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-notes-present",
      "beatId": "beat:z02-sale-court",
      "speakerId": "z02-inspector",
      "label": "Present the Silt Stair’s quay notes for redemption",
      "intention": "ask",
      "text": "Three quay notes from the Silt Stair court, against the relief fleet.",
      "reply": "Forty measures each, against the relief fleet, under the Convener’s guarantee. Good paper. But his clerks have lodged a dispute: they say the guarantee was sworn on conditions, and the pilot who swore to them drowned on the bar. Until the guarantee is settled the fleet does not unload, and your notes are paper. Guarantees are sworn at the shrine on the rope walk, before two witnesses. The Convener is on the platform, if you would rather hear his terms.",
      "journal": "The sale court will not redeem the notes: the Convener’s clerks dispute the relief fleet’s guarantee, and the fleet will not unload until it is settled. Guarantees are sworn at the shrine on the rope walk before two witnesses.",
      "prerequisites": {
        "all": [
          "z02:notes"
        ],
        "any": [],
        "none": [
          "z02:guarantee-disputed"
        ]
      },
      "effects": {
        "add": [
          "z02:guarantee-disputed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-maurel-terms",
      "beatId": "beat:z02-sale-court",
      "speakerId": "z02-maurel",
      "label": "Ask the Convener his terms for the guarantee",
      "intention": "ask",
      "text": "What will it take for the Compact to stand behind its guarantee?",
      "reply": "Plainly, then. My clerk swore a guarantee for four hulls brought over the bar by a named pilot. The pilot drowned, and so did the promise. I will stand behind your notes anyway, in the Compact’s own name. In return your court leases the Lower Landing’s berths to the Compact for twenty years. The Silt Stair gets its grain this week, and I get a landing that will still be useful when nobody remembers this winter.",
      "journal": "Maurel Neth will guarantee the relief fleet in the Compact’s own name if the Silt Stair court leases its Lower Landing berths to the Compact for twenty years.",
      "prerequisites": {
        "all": [
          "z02:guarantee-disputed"
        ],
        "any": [],
        "none": [
          "z02:terms-heard",
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:terms-heard"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-concession",
      "beatId": "beat:z02-sale-court",
      "speakerId": "z02-maurel",
      "label": "Sign the Lower Landing’s berths to the Compact for twenty years in the court’s name, for his guarantee",
      "intention": "offer",
      "text": "Draw the lease.",
      "reply": "He has it drawn already; it only wanted a name. You sign for the court. By evening the fleet’s hatches are open and your notes are redeemed at the balance, forty measures each. A Compact clerk takes a seat on the next canal boat up, with a measuring rod across his knees.",
      "journal": "Signed the Silt Stair’s Lower Landing berths to the Salt Compact for twenty years in the court’s name. Maurel Neth guaranteed the fleet, and the notes are redeemed.",
      "prerequisites": {
        "all": [
          "z02:terms-heard"
        ],
        "any": [],
        "none": [
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:redeemed",
          "errand:z02:concession"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z02-inspector",
        "z02-sereth",
        "z02-tamsa"
      ]
    },
    {
      "id": "z02-redeem-witness",
      "beatId": "beat:z02-sale-court",
      "speakerId": "z02-inspector",
      "label": "Bring Tamsa Brin before the sale court to say what was sworn at the shrine",
      "intention": "ask",
      "text": "Tamsa Brin stood witness to the fleet’s guarantee. Hear her.",
      "reply": "Tamsa climbs to the platform and repeats the oath the Convener’s clerk swore at the shrine: for the fleet as it arrives, no count and no conditions. The inspector writes it down and looks at the Convener for a long moment. The Convener says the Compact honours what it swears. The guarantee stands, the hatches open, and your notes are redeemed.",
      "journal": "Tamsa Brin told the sale court that the guarantee was sworn for the fleet as it arrives. The Convener honoured it. The fleet unloads, and the Silt Stair’s notes are redeemed.",
      "prerequisites": {
        "all": [
          "z02:tamsa-witness",
          "z02:guarantee-disputed"
        ],
        "any": [],
        "none": [
          "z02:redeemed",
          "z02:holder-sen"
        ]
      },
      "effects": {
        "add": [
          "z02:redeemed",
          "errand:z02:guarantee-witness"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z02-maurel",
        "z02-sereth",
        "z02-tamsa"
      ]
    },
    {
      "id": "z02-redeem-witness-senate",
      "beatId": "beat:z02-sale-court",
      "speakerId": "z02-inspector",
      "label": "Bring Tamsa Brin before the sale court to say what was sworn at the shrine — the Senate’s harbour office takes a fifth of the grain as its due",
      "intention": "ask",
      "text": "Tamsa Brin stood witness to the fleet’s guarantee. Hear her.",
      "reply": "Tamsa climbs to the platform and repeats the oath the Convener’s clerk swore at the shrine: for the fleet as it arrives, no count and no conditions. The inspector writes it down, and the Senate’s harbour magistrate seals the finding, for a fifth of the Silt Stair’s grain to the Senate’s bread store. The Convener says the Compact honours what it swears. The hatches open, and your notes are redeemed.",
      "journal": "Tamsa Brin told the sale court that the guarantee was sworn for the fleet as it arrives. The Convener honoured it, and the Senate’s harbour office took a fifth of the Silt Stair’s grain as its due.",
      "prerequisites": {
        "all": [
          "z02:tamsa-witness",
          "z02:guarantee-disputed",
          "z02:holder-sen"
        ],
        "any": [],
        "none": [
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:redeemed",
          "errand:z02:guarantee-witness",
          "z02:harbour-due"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z02-maurel",
        "z02-sereth",
        "z02-tamsa"
      ]
    },
    {
      "id": "z02-redeem-testimony",
      "beatId": "beat:z02-sale-court",
      "speakerId": "z02-inspector",
      "label": "Put the drowned pilot’s oath before the sale court, as Ildren Vos reads it — the court will take a dead man’s word as evidence",
      "intention": "ask",
      "text": "The pilot Heddo Rask can tell the court what was sworn.",
      "reply": "Ildren Vos sets the jar on the platform and lifts the pilot’s hand onto its rim. The hand pays out its line; the mouth works. Vos reads the words aloud: for the fleet as it arrives. The inspector writes them down as the pilot’s. The Convener does not argue with a dead man in front of the whole court. The fleet unloads, and your notes are redeemed. On the back bench a clerk with a Caldris seal-ring copies the finding into his own book before the ink is dry.",
      "journal": "The sale court accepted the drowned pilot’s oath, as Ildren Vos read it, that the guarantee was sworn for the fleet as it arrives. The notes are redeemed. Nacre’s sale court has now taken a dead man’s word as evidence.",
      "prerequisites": {
        "all": [
          "z02:vos-hired",
          "z02:guarantee-disputed"
        ],
        "any": [],
        "none": [
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:redeemed",
          "errand:z02:dead-testimony",
          "pressure:z02:dead-testimony"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z02-maurel",
        "z02-vos",
        "z02-tamsa"
      ]
    },
    {
      "id": "z02-maurel-bonds",
      "beatId": "beat:z02-sale-court",
      "speakerId": "z02-maurel",
      "label": "Ask the Convener what binds the ropemakers on his walk",
      "intention": "ask",
      "text": "The ropemakers on your walk. What holds them there?",
      "reply": "Recovery bonds, from the Vannic famine. A hundred and forty-three people who would have drowned or starved got passage on them. The fees are uncapped because the losses were: somebody insured a hull against that labour, and the hull went down, and I am still paying for it too. Find me a better arrangement that a Namar house will lend against, and I will sign it tomorrow.",
      "journal": "Maurel Neth defends the Vannic recovery bonds: famine passage for a hundred and forty-three people, on uncapped fees that insured a hull since lost.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "z02:bonds-asked",
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:bonds-asked"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-vos-ask",
      "beatId": "beat:z02-bonded-warehouse",
      "speakerId": "z02-vos",
      "label": "Ask what she does at these tables",
      "intention": "ask",
      "text": "What is done at these tables?",
      "reply": "I read what the body keeps. A drowned pilot keeps his work: the hand pays out a lead line, the mouth counts the fathoms. What the words meant is for a court to decide, and courts like to be told. The Compact keeps its drowned here as salvage until someone claims them. Your pilot is Heddo Rask. The Convener’s clerk has already asked what Heddo would say for him. I told him my price.",
      "journal": "Ildren Vos reads testimony from the dead at three trestle tables in the bonded warehouse. The drowned pilot, Heddo Rask, lies in her salt. The Convener’s clerk has already asked her price.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "z02:tables-seen"
        ]
      },
      "effects": {
        "add": [
          "z02:tables-seen"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-vos-hire",
      "beatId": "beat:z02-bonded-warehouse",
      "speakerId": "z02-vos",
      "label": "Pay Ildren Vos to read the pilot’s oath before the sale court — 8 cuts; the court will take a dead man’s word",
      "intention": "offer",
      "text": "Read Heddo’s oath for the sale court.",
      "reply": "{Cuts}. The body will say what it says; I will say what it means, and I will say it well. Bring me to the platform when you are ready.",
      "journal": "Paid {cuts} to Ildren Vos to read the drowned pilot’s oath before the sale court.",
      "prerequisites": {
        "all": [
          "z02:tables-seen",
          "z02:guarantee-disputed"
        ],
        "any": [],
        "none": [
          "z02:vos-hired",
          "z02:heddo-buried",
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:vos-hired"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 8,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-vos-buyers",
      "beatId": "beat:z02-bonded-warehouse",
      "speakerId": "z02-vos",
      "label": "Ask who buys her readings",
      "intention": "ask",
      "text": "Who pays for what the dead say?",
      "reply": "Inheritance advocates, mostly. A drowned man’s hand signs nothing, but a court will let me say what it would have signed. An advocate in Caldris, Vasko, buys more than anyone; the Senate court there has taken the dead at their word for years. If a court ever gives away a granary on a dead man’s word, it will be one of mine who speaks for him.",
      "journal": "Ildren Vos sells dead testimony to inheritance advocates, above all to Advocate Vasko in Caldris, whose Senate court has long accepted it.",
      "prerequisites": {
        "all": [
          "z02:tables-seen"
        ],
        "any": [],
        "none": [
          "z02:vos-buyers"
        ]
      },
      "effects": {
        "add": [
          "z02:vos-buyers"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-heddo-bury",
      "beatId": "beat:z02-bonded-warehouse",
      "speakerId": "z02-vos",
      "label": "Claim the drowned pilot from the Compact’s salvage and have him buried — 4 cuts; Vos will have nobody to read",
      "intention": "offer",
      "text": "I will claim Heddo Rask’s body.",
      "reply": "Vos watches you count out {cuts}. “The salvage clerk will take them. The Compact sells its drowned to anyone who asks.” By evening Heddo is sewn into sailcloth and carried up the rope walk, and the crews bury him behind the shrine. His hand is still at last.",
      "journal": "Paid {cuts} to claim the pilot Heddo Rask from the Compact’s salvage. The crews buried him behind the harbour shrine. Nobody will read him now.",
      "prerequisites": {
        "all": [
          "z02:tables-seen"
        ],
        "any": [],
        "none": [
          "z02:heddo-buried",
          "z02:vos-hired"
        ]
      },
      "effects": {
        "add": [
          "z02:heddo-buried"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 4,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z02-tamsa"
      ]
    },
    {
      "id": "z02-rope-work",
      "beatId": "beat:z02-rope-walk",
      "speakerId": "z02-tamsa",
      "label": "Walk rope with the bonded gang for a morning — earn 6 cuts once",
      "intention": "offer",
      "text": "Your gang is a hand short. I can walk rope.",
      "reply": "“Walk backwards, keep the hemp even, and do not look at the shrine while the foreman is watching.” By noon your hands are raw. The foreman pays six cuts, and Tamsa has decided you can be talked to.",
      "journal": "Walked rope with the bonded gang for a morning and was paid six cuts.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "z02:rope-walked",
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:rope-walked"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 6,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-shrine-cord",
      "beatId": "beat:z02-rope-walk",
      "speakerId": null,
      "label": "Read the oath cord at the harbour shrine",
      "intention": "ask",
      "text": "Find the fleet’s knot.",
      "reply": "One knot for each guarantee sworn this season, and on each a clay tag: the house that swore, the day, and the two witnesses. The fleet’s tag reads: the Compact, by the Convener’s clerk; witnesses Heddo Rask, pilot, and Tamsa Brin, rope walk. The cord keeps who swore and who heard. The words it leaves to the witnesses.",
      "journal": "The oath cord at the harbour shrine names the fleet’s two witnesses: Heddo Rask, the drowned pilot, and Tamsa Brin of the rope walk. The cord does not keep the words.",
      "prerequisites": {
        "all": [
          "z02:guarantee-disputed"
        ],
        "any": [],
        "none": [
          "z02:oath-read",
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:oath-read"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-tamsa-oath",
      "beatId": "beat:z02-rope-walk",
      "speakerId": "z02-tamsa",
      "label": "Ask Tamsa what was sworn at the shrine for the fleet",
      "intention": "ask",
      "text": "Your name is on the fleet’s knot. What did the Convener’s clerk swear?",
      "reply": "She looks at the foreman before she answers. “I tied that knot. The clerk swore, Heddo and I stood witness, and Heddo made him say it plain: for the fleet as it arrives, no count, no conditions. Heddo had been cheated by a condition once.” She goes back to the hemp. “I am on a recovery bond to the Compact. Ask me to say that on the platform, and the Convener sells my bond to the saltpans on the next tide.”",
      "journal": "Tamsa Brin witnessed the fleet’s guarantee: sworn for the fleet as it arrives, with no count and no conditions. She is on a recovery bond to the Compact and will not testify while the Convener can sell it. The hull delegates can carry a bond.",
      "prerequisites": {
        "all": [
          "z02:oath-read"
        ],
        "any": [],
        "none": [
          "z02:oath-heard",
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:oath-heard"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z02-tamsa-witness",
      "beatId": "beat:z02-rope-walk",
      "speakerId": "z02-tamsa",
      "label": "Tell Tamsa the crews carry her bond, and ask her to speak at the sale court",
      "intention": "ask",
      "text": "The crews carry your bond. Will you say it on the platform?",
      "reply": "“On the crews’ roll.” She reads your face for the lie and does not find one. “Then I will say it on the platform, in the Convener’s hearing, the way Heddo made him say it.”",
      "journal": "Tamsa Brin will tell the sale court what was sworn at the shrine. Her bond is on the crews’ roll, out of the Convener’s reach.",
      "prerequisites": {
        "all": [
          "z02:tamsa-protected"
        ],
        "any": [],
        "none": [
          "z02:tamsa-witness",
          "z02:redeemed"
        ]
      },
      "effects": {
        "add": [
          "z02:tamsa-witness"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z06-lime-order-first",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Take the court’s letter for its lime beyond the Broken Causeway, 44 km west of Caldris — the causeway lease comes before anything upriver, and your rest at the Dry Cut waits until you are back",
      "intention": "offer",
      "text": "What does the court need first?",
      "reply": "The official lays a Compact tablet beside the letter. “An outsider before you signed this court into the Broken Causeway’s lease. We are a party to it now, and the Compact reminds us every week. Our lime has stood at the causeway since spring, and the stair walls want mortar before the rains. The kilns burned our lime once, and we know now what fed them. The court has paid a works contractor there, forty-four kilometres west of Caldris on the imperial road, for six carts of Dovren lime. This letter lets you agree the carriage, and this purse is for any toll: twelve cuts. Whatever you do not spend is yours. Get the carts over and tell me they are on the road. Caldris and the quay can wait for your return.”",
      "journal": "Took the court’s letter and a twelve-cut purse for six carts of lime held at the Broken Causeway, 44 km west of Caldris by the imperial road. The Silt Stair is a party to the causeway lease an earlier outsider signed, so this errand comes first. What the purse does not spend is yours.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "past:z06:lease-signed"
        ],
        "any": [],
        "none": [
          "campaign:B2",
          "fact:outcome-licensed-atrocity",
          "fact:outcome-departure-failure"
        ]
      },
      "effects": {
        "add": [
          "campaign:B2",
          "z06:errand",
          "errand:z06:underway"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 12,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z06-lime-order",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Take the court’s letter for its lime beyond the Broken Causeway, 44 km west of Caldris — your rest at the Dry Cut waits until you are back",
      "intention": "offer",
      "text": "Is there anything else the court needs from upriver?",
      "reply": "The official seals a letter and holds it out. “The lift pit’s footing is cracked, and the stair walls want mortar before the rains. The kilns burned our lime once, and we know now what fed them. The court has paid a works contractor at the Broken Causeway, forty-four kilometres west of Caldris on the imperial road, for six carts of Dovren lime, and they have not moved. The Salt Compact holds the causeway under a toll-and-repair lease, and its factor keeps his chain up until the court pays his toll or signs his lease. This letter lets you agree the carriage, and this purse is for his toll: twelve cuts. Whatever you do not spend on him is yours. Get the carts over and tell me they are on the road.”",
      "journal": "Took the court’s letter and a twelve-cut toll purse for six carts of lime held at the Broken Causeway, 44 km west of Caldris by the imperial road. The Salt Compact’s factor keeps his chain up until the court pays his toll or signs his lease. What the toll does not take is yours.",
      "prerequisites": {
        "all": [
          "campaign:B2"
        ],
        "any": [],
        "none": [
          "z06:errand",
          "fact:outcome-licensed-atrocity",
          "fact:outcome-departure-failure",
          "errand:second",
          "campaign:B4",
          "campaign:B6"
        ]
      },
      "effects": {
        "add": [
          "z06:errand",
          "errand:z06:underway",
          "errand:second"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 12,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z06-lime-order-kilns",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Take the court’s letter for its lime beyond the Broken Causeway, 44 km west of Caldris — your rest at the Dry Cut waits until you are back",
      "intention": "offer",
      "text": "Is there anything else the court needs from upriver?",
      "reply": "The official seals a letter and holds it out. “The lift pit’s footing is cracked, and the stair walls want mortar before the rains. The concession at the kilns offers us its own lime, cheap. Whatever the court signed, it will not mortar the Silt Stair’s walls with what those kilns burn. The court has paid a works contractor at the Broken Causeway, forty-four kilometres west of Caldris on the imperial road, for six carts of Dovren lime, and they have not moved. The Salt Compact holds the causeway under a toll-and-repair lease, and its factor keeps his chain up until the court pays his toll or signs his lease. This letter lets you agree the carriage, and this purse is for his toll: twelve cuts. Whatever you do not spend on him is yours. Get the carts over and tell me they are on the road.”",
      "journal": "Took the court’s letter and a twelve-cut toll purse for six carts of lime held at the Broken Causeway, 44 km west of Caldris by the imperial road. The Salt Compact’s factor keeps his chain up until the court pays his toll or signs his lease. What the toll does not take is yours.",
      "prerequisites": {
        "all": [
          "campaign:B2"
        ],
        "any": [
          "fact:outcome-licensed-atrocity",
          "fact:outcome-departure-failure"
        ],
        "none": [
          "z06:errand",
          "errand:second",
          "campaign:B4",
          "campaign:B6"
        ]
      },
      "effects": {
        "add": [
          "z06:errand",
          "errand:z06:underway",
          "errand:second"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 12,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z06-factor-rates",
      "beatId": "beat:z06-toll-shelter",
      "speakerId": "z06-factor",
      "label": "Ask why the rate for repair is written larger than the rate for passage",
      "intention": "ask",
      "text": "Your tablet charges more for repair than for passage. Why?",
      "reply": "“Because passage is free. Walkers cross the planks for nothing. Wheels pay the repair rate until the causeway is sound; that is the lease. The Compact built the plank bridge at its own cost, and it pays the gang rebuilding the arches. A court whose carts use this road may become a party to the lease instead, and its carts cross free. Parties share the renewal levy each season the works are unfinished. They generally are.”",
      "journal": "The Salt Compact’s lease: wheels pay the repair toll until the causeway is sound, or their owner signs as a party to the lease, crosses free, and shares the renewal levy every season the works stay unfinished.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "z06:lease-read",
          "z06:carts-across"
        ]
      },
      "effects": {
        "add": [
          "z06:lease-read"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z06-toll-pay",
      "beatId": "beat:z06-toll-shelter",
      "speakerId": "z06-factor",
      "label": "Pay the toll for the court’s six carts — 12 cuts",
      "intention": "offer",
      "text": "Six carts of the court’s lime. Here is their toll.",
      "reply": "“Entered.” He sends a boy running to the camp. Within the hour the court’s six carts come over the planks, white to the axles, and the chain comes down for them.",
      "journal": "Paid {cuts} toll at the Broken Causeway. The court’s six lime carts came over the planks and through the chain.",
      "prerequisites": {
        "all": [
          "z06:errand",
          "z06:lime-seen"
        ],
        "any": [],
        "none": [
          "z06:carts-across"
        ]
      },
      "effects": {
        "add": [
          "z06:toll-paid",
          "z06:carts-across",
          "errand:z06:toll"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 12,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "beat:z06-toll-shelter"
      ]
    },
    {
      "id": "z06-lease-sign",
      "beatId": "beat:z06-toll-shelter",
      "speakerId": "z06-factor",
      "label": "Sign the court into the Compact’s lease — its carts cross free, and the Silt Stair shares the levy every season the arch stands open",
      "intention": "offer",
      "text": "The court’s letter lets me agree the carriage. Put the Silt Stair down as a party to the lease.",
      "reply": "“Gladly. Here, and here.” He turns the tablet for your mark. “The Silt Stair is a party to the causeway lease. Its carts cross free, and it shares the renewal levy each season the works are unfinished.” He sends to the camp, and the chain comes down.",
      "journal": "Signed the Silt Stair court into the Salt Compact’s causeway lease. The court’s carts crossed free; the court now shares the renewal levy every season the last arch stands open.",
      "prerequisites": {
        "all": [
          "z06:errand",
          "z06:lime-seen",
          "z06:lease-read"
        ],
        "any": [],
        "none": [
          "z06:carts-across"
        ]
      },
      "effects": {
        "add": [
          "z06:lease-signed",
          "z06:carts-across",
          "errand:z06:lease"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "beat:z06-toll-shelter"
      ]
    },
    {
      "id": "z06-roll-countersign",
      "beatId": "beat:z06-toll-shelter",
      "speakerId": "z06-factor",
      "label": "Seal the gang’s bond roll in the court’s name over a drowned notary’s oaths — the court’s carts cross free",
      "intention": "offer",
      "text": "The court’s letter carries a seal. What would it buy here?",
      "reply": "“A countersign.” He brings out the gang’s bond roll. “Every bond on it was sworn before the Compact’s notary here, and the wall took him when it burst. A roll sworn before a dead man is a roll any Caldris advocate can argue. Put your court’s seal under his and it stands, whatever he can no longer say. Your carts cross free for it.” You seal it. Temmo Sard’s name is the fourth line down. The factor sends to the camp, and the chain comes down. Up on the hoist, Temmo watches the seal go down and does not pull the rope.",
      "journal": "Sealed the Salt Compact’s gang bond roll in the Silt Stair court’s name, over the oaths of a notary the burst wall killed. The court’s carts crossed free. Temmo Sard’s bond stands on the court’s word now.",
      "prerequisites": {
        "all": [
          "z06:errand",
          "z06:lime-seen"
        ],
        "any": [],
        "none": [
          "z06:carts-across",
          "z06:coffin-cart"
        ]
      },
      "effects": {
        "add": [
          "z06:roll-countersigned",
          "z06:carts-across",
          "errand:z06:countersign",
          "pressure:z06:roll-countersigned"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "beat:z06-toll-shelter"
      ]
    },
    {
      "id": "z06-carter-ask",
      "beatId": "beat:z06-toll-shelter",
      "speakerId": null,
      "label": "Hear out the carter by the covered wagon",
      "intention": "ask",
      "text": "You have been watching me since I came up the road.",
      "reply": "“You carry a court’s letter; I saw the factor read it. My wagon goes west, to Telvas, sealed in Caldris. Let it cross as your court’s carriage and the factor opens nothing, and I pay your carts’ toll. Everyone’s business stays their own.”",
      "journal": "A carter with a covered wagon bound west will pay the court’s toll if his wagon crosses as court carriage, unopened.",
      "prerequisites": {
        "all": [
          "z06:coffin-cart",
          "z06:errand"
        ],
        "any": [],
        "none": [
          "z06:carter-heard",
          "z06:carts-across"
        ]
      },
      "effects": {
        "add": [
          "z06:carter-heard"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z06-coffins-look",
      "beatId": "beat:z06-toll-shelter",
      "speakerId": null,
      "label": "Lift a corner of the carter’s canvas",
      "intention": "ask",
      "text": "Lift a corner of the canvas.",
      "reply": "Six plain coffins, packed in lime and salt so that they keep. The lids are not nailed. Inside are six people: a young man with a carter’s hands, a washerwoman, four you cannot guess at. Each wears a wax tag with a Caldris court number, a date, and the word testimony. The carter watches you read them and says nothing at all.",
      "journal": "The carter’s wagon holds six bodies packed in lime and salt, tagged with Caldris court numbers and the word testimony. They are going west, not to a grave.",
      "prerequisites": {
        "all": [
          "z06:carter-heard"
        ],
        "any": [],
        "none": [
          "z06:coffins-seen",
          "z06:coffins-passed",
          "z06:coffins-held"
        ]
      },
      "effects": {
        "add": [
          "z06:coffins-seen"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z06-coffins-cover",
      "beatId": "beat:z06-toll-shelter",
      "speakerId": null,
      "label": "Let the carter’s wagon cross as the court’s carriage — he pays your carts’ toll, and nobody opens his coffins",
      "intention": "offer",
      "text": "Your wagon crosses under the court’s letter.",
      "reply": "“Good.” He pays the factor for six carts and one wagon, and the factor writes court carriage on his tablet without looking up. The chain comes down. The court’s lime rolls east; the covered wagon rolls west over the planks. The factor’s boy watches it go. “That’s the Silt Stair’s name on that wagon now,” he says, to nobody.",
      "journal": "Let a carter’s covered wagon cross the Broken Causeway as the Silt Stair court’s carriage, unopened. He paid the court’s toll. Six bodies tagged for testimony went west with it.",
      "prerequisites": {
        "all": [
          "z06:carter-heard",
          "z06:lime-seen"
        ],
        "any": [],
        "none": [
          "z06:carts-across",
          "z06:coffins-held"
        ]
      },
      "effects": {
        "add": [
          "z06:coffins-passed",
          "z06:carts-across",
          "errand:z06:coffins",
          "pressure:z06:coffins-uninspected"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z06-factor"
      ]
    },
    {
      "id": "z06-coffins-report",
      "beatId": "beat:z06-toll-shelter",
      "speakerId": "z06-factor",
      "label": "Tell the factor what is under the carter’s canvas",
      "intention": "ask",
      "text": "Open the carter’s wagon. It is not trade.",
      "reply": "The factor lifts the canvas himself and reads each tag twice. “Six bodies under court seals, sold west as testimony. The Compact does not carry what a court will not bury.” He sends to the stalls for spades, and to the camp for your carts. “The Compact’s thanks. Your carts cross on it.”",
      "journal": "Showed the factor the six bodies in the carter’s wagon. He held them for burial by the boundary stone and let the court’s carts cross on the Compact’s thanks.",
      "prerequisites": {
        "all": [
          "z06:coffins-seen",
          "z06:lime-seen"
        ],
        "any": [],
        "none": [
          "z06:carts-across",
          "z06:coffins-passed"
        ]
      },
      "effects": {
        "add": [
          "z06:coffins-held",
          "z06:carts-across",
          "errand:z06:report"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "beat:z06-toll-shelter"
      ]
    },
    {
      "id": "z06-chain-force",
      "beatId": "beat:z06-toll-shelter",
      "speakerId": null,
      "label": "Drop the toll chain and bring the court’s carts through by force",
      "intention": "ask",
      "text": "Drop the chain.",
      "reply": "The lease guard sets his shield and draws a heavy, bronze-capped club from his belt. “Then come and drop it.” The factor’s chainman comes round the shelter with a boathook, keeping wide of him.",
      "journal": "Chose to drop the Compact’s toll chain by force.",
      "prerequisites": {
        "all": [
          "z06:errand",
          "z06:lime-seen"
        ],
        "any": [],
        "none": [
          "z06:carts-across",
          "z06:guard-beaten"
        ]
      },
      "effects": {
        "add": [],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": "fight",
      "afterResolution": true,
      "encounter": "z06-lease-guard"
    },
    {
      "id": "z06-carts-through",
      "beatId": "beat:z06-toll-shelter",
      "speakerId": null,
      "label": "Wave the court’s carts through the dropped chain",
      "intention": "ask",
      "text": "Bring them through.",
      "reply": "The carters come over the planks at a run and do not look at the man by the chain. The factor writes, and keeps writing.",
      "journal": "Brought the court’s six lime carts through the Compact’s chain by force. The lease guard died at the chain.",
      "prerequisites": {
        "all": [
          "z06:guard-beaten"
        ],
        "any": [],
        "none": [
          "z06:carts-across"
        ]
      },
      "effects": {
        "add": [
          "z06:carts-across",
          "errand:z06:force"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z06-factor"
      ]
    },
    {
      "id": "z06-mason-arch",
      "beatId": "beat:z06-broken-span",
      "speakerId": "z06-mason",
      "label": "Ask why the last arch has no keystone",
      "intention": "ask",
      "text": "Three arches closed, and the fourth waits on one stone. Why?",
      "reply": "“Because the lease runs until the causeway is sound, and not a day past it. The keystone was cut in spring; it’s in the yard under canvas. The day it goes in, the chain comes down, the Compact stops paying the contractor, and the gang goes up the quarry road to the next job. So it doesn’t go in.”",
      "journal": "The last arch’s keystone was cut in spring and waits in the contractor’s yard. The Compact’s lease, and the contractor’s pay, end the day it is set.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "z06:clause-known",
          "z06:arch-closed"
        ]
      },
      "effects": {
        "add": [
          "z06:clause-known"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z06-mason-bond",
      "beatId": "beat:z06-broken-span",
      "speakerId": "z06-mason",
      "label": "Ask about the bronze tag at his neck",
      "intention": "ask",
      "text": "What does the tag at your neck say?",
      "reply": "“My bond. A Vannic recovery bond: the Compact paid my passage over the sea in the famine, and I work it off. The fare has a fee, and the fee has a fee. I have paid it down for eleven years. It is bigger now than when I came.”",
      "journal": "Temmo Sard works the causeway on a Vannic recovery bond. Its fees grow faster than his wage pays it down.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "z06:bond-heard",
          "z06:arch-closed"
        ]
      },
      "effects": {
        "add": [
          "z06:bond-heard"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z06-contractor-lime",
      "beatId": "beat:z06-repair-camp",
      "speakerId": "z06-contractor",
      "label": "Ask after the court’s six carts of lime",
      "intention": "ask",
      "text": "The Silt Stair court paid you for six carts of lime.",
      "reply": "“And there they stand, burnt and bagged, shafts down. They roll when the factor’s chain comes down, and it comes down for coin or for a signature on his lease. Or Wenna Coll takes carts through the old ford below, when the water is low and the factor isn’t looking.”",
      "journal": "Livra Cantor’s six carts of the court’s lime wait loaded at the repair camp. The factor’s chain comes down for his toll or a signature on his lease; Wenna Coll takes carts through the old ford when the water is low.",
      "prerequisites": {
        "all": [
          "z06:errand"
        ],
        "any": [],
        "none": [
          "z06:lime-seen"
        ]
      },
      "effects": {
        "add": [
          "z06:lime-seen"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z06-contractor-work",
      "beatId": "beat:z06-repair-camp",
      "speakerId": "z06-contractor",
      "label": "Work a day on the hoist gang — earn 5 cuts once",
      "intention": "offer",
      "text": "You look short a pair of hands.",
      "reply": "“Short twelve. Take the rope on the far side and pull when Temmo says pull. Five cuts at sundown, out of the Compact’s box. The factor won’t miss it.”",
      "journal": "Worked a day on the causeway hoist gang for five cuts.",
      "prerequisites": {
        "all": [
          "z06:errand"
        ],
        "any": [],
        "none": [
          "z06:worked",
          "z06:arch-closed"
        ]
      },
      "effects": {
        "add": [
          "z06:worked"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 5,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "z06-keystone",
      "beatId": "beat:z06-repair-camp",
      "speakerId": "z06-contractor",
      "label": "Pay the gang’s day to set the keystone — 10 cuts; the lease ends, the chain comes down for everyone, and the bonded gang is sent up the quarry road",
      "intention": "offer",
      "text": "The keystone is cut. Set it, and I will pay the gang’s day.",
      "reply": "“About time somebody did.” She sends for the gang. By evening the stone is in, the centring comes out, and the arch holds. The factor walks up from his shelter, looks at it for a long time, and goes back to coil his chain. The court’s carts go over on stone.",
      "journal": "Paid {cuts} for the gang’s day and had the keystone set. The causeway is sound, the Compact’s lease has ended, and the chain is down for everyone. The bonded gang goes to the Dovren quarries.",
      "prerequisites": {
        "all": [
          "z06:errand",
          "z06:clause-known",
          "z06:lime-seen"
        ],
        "any": [],
        "none": [
          "z06:carts-across"
        ]
      },
      "effects": {
        "add": [
          "z06:arch-closed",
          "z06:carts-across",
          "errand:z06:repair"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 10,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z06-factor",
        "z06-mason",
        "beat:z06-toll-shelter",
        "beat:z06-broken-span"
      ]
    },
    {
      "id": "z06-guide-ford",
      "beatId": "beat:z06-old-ford",
      "speakerId": "z06-guide",
      "label": "Have Wenna take the court’s carts through the ford — 6 cuts; the travellers’ camp will follow them across",
      "intention": "offer",
      "text": "Six carts of lime, and the water is low.",
      "reply": "“Then we go now, before it thinks better of it.” She walks the first cart in herself, pole first. By the third, the travellers are packing; by the sixth, thirty-one people are wading behind the wheels. On the Caldris bank she counts heads and grins. “The factor will fine me. Worth it.”",
      "journal": "Paid Wenna Coll {cuts} to take the court’s six carts through the old ford. The travellers’ camp waded over behind them without paying. The Compact will fine her.",
      "prerequisites": {
        "all": [
          "z06:errand",
          "z06:lime-seen"
        ],
        "any": [],
        "none": [
          "z06:carts-across",
          "z06:ford-high"
        ]
      },
      "effects": {
        "add": [
          "z06:travellers-across",
          "z06:carts-across",
          "errand:z06:ford"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 6,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "touches": [
        "z06-factor",
        "beat:z06-old-ford"
      ]
    },
    {
      "id": "z06-lime-return",
      "beatId": "beat:reeves-court",
      "speakerId": "official",
      "label": "Report the court’s lime on the road home — the court pays 6 cuts",
      "intention": "ask",
      "text": "Six carts of lime, over the Broken Causeway and on the road home.",
      "reply": "Six carts, by the carters’ own tally. Then the footing gets its mortar before the rains. Six cuts for your trouble. How they came over is written here, and I will read it again tonight.",
      "journal": "Reported the court’s six carts of lime over the Broken Causeway and on the road home. Paid six cuts. The errand is done.",
      "prerequisites": {
        "all": [
          "z06:carts-across"
        ],
        "any": [],
        "none": [
          "errand:z06:done"
        ]
      },
      "effects": {
        "add": [
          "errand:z06:done"
        ],
        "remove": [
          "errand:z06:underway"
        ]
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 6,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mystery-book",
      "beatId": "beat:lower-landing",
      "speakerId": null,
      "label": "Open the public Comparison Book",
      "intention": "ask",
      "text": "Read the comparisons left for the next traveller.",
      "reply": "The book leaves room beside every account for someone else to check it. {comparison} A note names the comparison court at Arel Vennat: take the road from the reeve’s court. Nobody asks you to believe a theory.",
      "journal": "Read the public Comparison Book. Its records belong to earlier witnesses; checking them in this life is separate work. The comparison court at Arel Vennat can be reached from the reeve’s court.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "mystery:book-read"
        ]
      },
      "effects": {
        "add": [
          "mystery:book-read"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mystery-book-court",
      "beatId": "beat:z11-comparison-court",
      "speakerId": null,
      "label": "Read the public Comparison Book",
      "intention": "ask",
      "text": "Lay the public accounts beside the objects they describe.",
      "reply": "The book leaves room beside every account for someone else to check it. {comparison} The objects and measured lines named in the margins are here in the court. Nobody asks you to believe a theory.",
      "journal": "Read the public Comparison Book at the Measure House. Its records belong to earlier witnesses; checking them in this life is separate work.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "mystery:book-read"
        ]
      },
      "effects": {
        "add": [
          "mystery:book-read"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mystery-staple",
      "beatId": "z04-dry-cut",
      "speakerId": null,
      "label": "Check the sealed mortar against the fitter’s die",
      "intention": "ask",
      "text": "Check the undisturbed mortar, the staple and the fresh die flaw together.",
      "reply": "The die flaw is the one on the lift’s new fitting. Old mortar runs over both arms without a cut. You leave the metal in the wall and sign a fresh drawing. The contradiction is in the objects, not just in somebody’s story.",
      "journal": "Checked a modern stamped staple inside an unbroken old mortar layer. The metal stays in the wall. A fresh drawing records this life’s inspection.",
      "prerequisites": {
        "all": [
          "story:cycle-clue",
          "story:bearing-known"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "mystery:verified:P-M2"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mystery-shells",
      "beatId": "beat:z11-comparison-court",
      "speakerId": null,
      "label": "Turn the quarry sample under the lamp",
      "intention": "ask",
      "text": "Follow the healed injuries through both bands of shell.",
      "reply": "The quarry seal is intact. In one band a shell healed around an injury; in the other the same growth continues through stone which was already there. You turn the sample over and follow both seams. Neither was recut. The rock was old before anyone built this court.",
      "journal": "Examined the certified quarry sample. Two incompatible growth sequences contain the same healed injury, in stone older than the empire.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "mystery:verified:P-M1"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mystery-baselines",
      "beatId": "beat:z11-comparison-court",
      "speakerId": null,
      "label": "Measure the court’s three sighting lines",
      "intention": "ask",
      "text": "Set the plumb line, turn the board and measure again.",
      "reply": "Each pair of marks gives the same distance from either end. Your board is square. Joined on one sheet, the three lines refuse to close. The old surveyors wrote “instrument error”; replacing the cord changes nothing. The western White Joint holds the matching fixed points.",
      "journal": "Measured three locally consistent sighting lines at Arel Vennat. They cannot close on one sheet. Compare them with the fixed points at the White Joint.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "mystery:baselines"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mystery-tides",
      "beatId": "beat:z11-comparison-court",
      "speakerId": null,
      "label": "Compare the road, tide and water records",
      "intention": "ask",
      "text": "Lay the independently sealed records beside one another.",
      "reply": "The Talruni road tally, Nacre tide sheet and Serekh water record arrived by different hands. You match each to its departure receipt and count the intervals yourself. All end at the same missing continuation. Their clocks disagree by minutes, but none has a following day. The break reaches far beyond this basin.",
      "journal": "Cross-checked independently carried road, tide and water records against their receipts. All share the missing continuation; no local ruler or kiln can account for their reach.",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "mystery:verified:P-T2"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mystery-dead",
      "beatId": "beat:lower-landing",
      "speakerId": null,
      "label": "Compare the old burial entry with today’s roll",
      "intention": "ask",
      "text": "Check the name, burial entry and the obligation still owing.",
      "reply": "The old account names Leth An as dead. The new roll changes who claims the granary and who owes his wages. It does not change Leth. His burial entry and the porter’s claim identify the same man. A body made to work would still not be him.",
      "journal": "Compared Leth An’s recorded death with the new roll and the surviving wage claim. The offices changed; the closed identity did not.",
      "prerequisites": {
        "all": [
          "mystery:earlier-account"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "mystery:verified:P-I2"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mystery-compare-points",
      "beatId": "beat:z12-white-joint",
      "speakerId": null,
      "label": "Check the western points against your court measurements",
      "intention": "ask",
      "text": "Stretch the line from the first fixed point to the second, then sight the third.",
      "reply": "The western lines are exact too. Put beside the court’s figures, they describe two sound approaches with no common way onward. The stones do not move when you lower the instrument. Breaking the instrument would only leave you unable to measure it.",
      "journal": "Checked the White Joint against the Arel Vennat baselines. Two locally valid surveys have no shared continuation. The instruments measure the fault; they do not cause it.",
      "prerequisites": {
        "all": [
          "mystery:baselines"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "mystery:verified:P-T1"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mystery-account",
      "beatId": "beat:z11-comparison-court",
      "speakerId": null,
      "label": "Include every living survivor in the crossing account",
      "intention": "ask",
      "text": "Leave nobody out, whether they would welcome you or not.",
      "reply": "The comparisons now give a fourth bearing: an outward path, measured across different arrangements. {survivor-account} Nobody’s old flag is struck from the account. The dead are entered separately. Their names will cross on paper, never as living people.",
      "journal": "Established the complete survivor account. The route must admit every living continuant, including opponents. It cannot restore the dead.",
      "prerequisites": {
        "all": [
          "mystery:fourth-bearing",
          "mystery:book-read",
          "campaign:B5"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "mystery:account"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mystery-approach",
      "beatId": "beat:z12-white-joint",
      "speakerId": null,
      "label": "Divert the pack road and lift the covering boards",
      "intention": "ask",
      "text": "Mark the bypass, carry the boards clear and expose the survey points.",
      "reply": "The pack drivers use the marked bypass. You lift the later boards with the road crew’s tools and lay a low crossing over the cut. The road covered the fault; it never made it. Before you go, the crew posts the rebuilding account: forty-eight beams and six hundred worker-days, with food and wages still to find.",
      "journal": "Prepared the White Joint approach and a safe public bypass. The basin inherits the rebuilding work; the crossing does not pay its bill.",
      "prerequisites": {
        "all": [
          "mystery:account"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "mystery:approach"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mystery-first-point",
      "beatId": "beat:z12-white-joint",
      "speakerId": null,
      "label": "Set the plumb line at the first point",
      "intention": "ask",
      "text": "Walk to the first point and let the weight settle.",
      "reply": "The line hangs still. On the board, you mark the approach you measured yourself. A strip of pale stone meets it without a step. There is room to turn back.",
      "journal": "Set the first point of the Fourth Bearing. The way back remains open.",
      "prerequisites": {
        "all": [
          "mystery:approach"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "mystery:first-point"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mystery-second-point",
      "beatId": "beat:z12-white-joint",
      "speakerId": null,
      "label": "Carry the line to the second point",
      "intention": "ask",
      "text": "Keep the first mark in sight as you carry the line across.",
      "reply": "The second point looks too close, but the line reaches the length in the comparisons. You chalk the stone. From here the third mark lies beyond both old approaches. This is the continuation they could not draw in one life.",
      "journal": "Reached the second point without losing the first. The final mark lies beyond the old return. Crossing it will end the repeated interval.",
      "prerequisites": {
        "all": [
          "mystery:first-point"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "mystery:second-point"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "mystery-crossing",
      "beatId": "beat:z12-white-joint",
      "speakerId": null,
      "label": "Cross the final mark — there will be no Return",
      "intention": "ask",
      "text": "Keep the whole account. Take the measured way onward.",
      "reply": "You step over the last chalk mark. Light reaches the cut from a new angle. Behind you, still places open into the same morning. Someone asks the date. The road clerk checks twice: “First Ember. Six hundred and forty-one.” The dead have not returned. The living have work to do. {survivor-account}",
      "journal": "Made the Fourth Bearing with the complete survivor account. The repeated interval ended. The first new date is 1 Ember 641 AC.",
      "prerequisites": {
        "all": [
          "mystery:second-point",
          "mystery:account",
          "campaign:B5"
        ],
        "any": [],
        "none": []
      },
      "effects": {
        "add": [
          "mystery:crossed"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true
    },
    {
      "id": "continuation-disgraced-legionary-held",
      "beatId": "beat:z01-river-bridge",
      "speakerId": "z01-captain",
      "label": "Show the captain the Silt Stair finding on the Fourth Cohort",
      "intention": "offer",
      "text": "The Fourth Cohort was ordered off the river redoubt. Reeve’s Court has it as a public finding. Some of them stand your watch under other names.",
      "reply": "Hadra reads the finding twice, the second time with a finger under the seal. “Deserters go last on the arrears list, if arrears ever come. Veterans go first.” The night roll comes down off its nail; three work-names are struck through and true names written beside them. “Kaeso Dareth. I always wondered what he was hiding. It was his own name.”",
      "journal": "Showed Captain Hadra Dost the public finding on the Fourth Cohort. Three of its men stand the Caldris watch under their own names now, first on the arrears list.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z01:docket"
        ],
        "any": [],
        "none": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ]
      },
      "effects": {
        "add": [
          "continuation:disgraced-legionary:held"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "disgraced-legionary"
    },
    {
      "id": "continuation-disgraced-legionary-open",
      "beatId": "beat:z01-river-bridge",
      "speakerId": "z01-captain",
      "label": "Ask the captain what the watch does with a man the army calls a deserter",
      "intention": "ask",
      "text": "My old unit is still on the army’s books as deserters. Does the watch take men like that?",
      "reply": "“It takes anyone who will stand a bridge for no pay.” Hadra does not look up from the count. “They answer to the name I write. One of mine is from the Fourth. Calls himself Kaeso of the bridge. I have never asked what the army calls him, and I will not start because you did.”",
      "journal": "The Fourth Cohort is still on the army’s books as deserters. At Caldris one of its men, Kaeso, stands the bridge watch under a work-name, and Captain Hadra Dost will not ask for another.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z01:docket"
        ],
        "any": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ],
        "none": []
      },
      "effects": {
        "add": [
          "continuation:disgraced-legionary:open"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "disgraced-legionary"
    },
    {
      "id": "continuation-fallen-household-held",
      "beatId": "beat:z01-grain-court",
      "speakerId": "z01-registrar",
      "label": "Ask the registrar to enter the dyer’s heirs’ quit-rent on the bread register",
      "intention": "offer",
      "text": "The dyer’s heirs draw a quit-rent from my family’s house at the Silt Stair, by a ruling of Reeve’s Court. Two of them are on your register. Enter it against their bread.",
      "reply": "Corvan finds the heirs on the third tablet. “Struck in spring, like the rest.” The Silt Stair ruling is read, then the confiscation schedule pinned behind it. “A rent paid by the family that got the house. I have not seen that written down before.” The stylus moves. “They eat from next quarter, on your family’s account. Everyone at this table will know why.”",
      "journal": "Had Registrar Corvan Esk enter the dyer’s heirs’ quit-rent on the Caldris bread register. They eat from next quarter on your family’s account, with the confiscation read out beside it.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z01:docket"
        ],
        "any": [],
        "none": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ]
      },
      "effects": {
        "add": [
          "continuation:fallen-household:held"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "fallen-household"
    },
    {
      "id": "continuation-fallen-household-open",
      "beatId": "beat:z01-grain-court",
      "speakerId": "z01-registrar",
      "label": "Have the registrar write beside the dyer’s heirs how your family came by their house",
      "intention": "ask",
      "text": "The dyer’s heirs are on your struck list. My family has their house at the Silt Stair. I want that written beside their names.",
      "reply": "Corvan looks at you for a long moment. “Nobody asks me to write down what they owe.” It goes in the margin of the tablet: the house, the confiscation, your family’s name. “It feeds nobody. But the next clerk who strikes them will have to read it.”",
      "journal": "Had your family’s confiscation of the dyer’s house written beside the dyer’s heirs on the Caldris register. It feeds nobody, but it stands on the record where they are struck.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z01:docket"
        ],
        "any": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ],
        "none": []
      },
      "effects": {
        "add": [
          "continuation:fallen-household:open"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "fallen-household"
    },
    {
      "id": "continuation-unpaid-sellsword-held",
      "beatId": "beat:z02-sale-court",
      "speakerId": "z02-inspector",
      "label": "Present the porters’ countersigned tally for redemption — the Compact pays 8 cuts now",
      "intention": "offer",
      "text": "My dead employer’s estate owes me nine ves. The porters were paid first, and they countersigned it. Will the Compact redeem a claim like that?",
      "reply": "Garo turns the tally to the light. “Wages first, burials second, you last, and the workers’ marks on it. Nobody here will argue with that.” A quay note is written against the estate’s last hull. “Nine ves when the hull sells, less my discount. Eight cuts now, as earnest.”",
      "journal": "Redeemed the countersigned fee tally at the Nacre sale court. Garo Tessin paid 8 cuts as earnest; the rest comes when your dead employer’s last hull sells.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z02:notes"
        ],
        "any": [],
        "none": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ]
      },
      "effects": {
        "add": [
          "continuation:unpaid-sellsword:held"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 8,
      "operation": null,
      "afterResolution": true,
      "origin": "unpaid-sellsword"
    },
    {
      "id": "continuation-unpaid-sellsword-open",
      "beatId": "beat:z02-sale-court",
      "speakerId": "z02-inspector",
      "label": "Sign your claim on the estate over to the crews’ wage fund",
      "intention": "offer",
      "text": "Nobody countersigned my tally. The crews hold marks on the same estate. Put my nine ves behind their wages.",
      "reply": "Garo raises an eyebrow and writes it. “A claimant who gives way to the crews. The Convener will think you mad and the crews will think you honest. I will enter both opinions.” The tally is filed under the crews’ fund.",
      "journal": "Signed your unmarked claim on your dead employer’s estate over to the Nacre crews’ wage fund. You will not see the nine ves; the crews are paid before anyone else now.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z02:notes",
          "story:personal-recovered"
        ],
        "any": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ],
        "none": []
      },
      "effects": {
        "add": [
          "continuation:unpaid-sellsword:open"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "unpaid-sellsword"
    },
    {
      "id": "continuation-escaped-worker-held",
      "beatId": "beat:z02-rope-walk",
      "speakerId": "z02-tamsa",
      "label": "Show Tamsa how three copies of one sale were struck together",
      "intention": "offer",
      "text": "My sale was copied at three offices. The Silt Stair court struck all three at once, with Odel’s crew swearing to the broker’s interest. Your bond will have copies too.",
      "reply": "Tamsa stops the wheel. “Three.” She counts along the rope. “The Compact’s office. The recovery house at Vannic. Whoever bought it after.” She takes your chain of brokers, written out, and folds it into her sleeve. “Nobody here knew you had to find all of them. They burn one and wonder why the bond comes back.”",
      "journal": "Gave Tamsa Brin the broker chain from your own sale: find every copy, strike them together. The bonded gang at Nacre knows now how a bond comes back.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z02:notes"
        ],
        "any": [],
        "none": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ]
      },
      "effects": {
        "add": [
          "continuation:escaped-worker:held"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "escaped-worker"
    },
    {
      "id": "continuation-escaped-worker-open",
      "beatId": "beat:z02-rope-walk",
      "speakerId": "z02-tamsa",
      "label": "Warn Tamsa that copies of your sale still stand",
      "intention": "warn",
      "text": "Copies of my sale still stand at more than one office. Compact factors buy paper like that. If one comes through Nacre, it has my name on it.",
      "reply": "“Then keep off the rope walk when the factors come by.” She says it without unkindness. “I will know the name if I see it in a ledger. I cannot do anything about it. But I will know.”",
      "journal": "Told Tamsa Brin that copies of your sale still stand. The bonded gang at Nacre will know your name if a factor brings one through.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z02:notes"
        ],
        "any": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ],
        "none": []
      },
      "effects": {
        "add": [
          "continuation:escaped-worker:open"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "escaped-worker"
    },
    {
      "id": "continuation-hedge-binder-held",
      "beatId": "beat:z02-bonded-warehouse",
      "speakerId": "z02-vos",
      "label": "Tell Vos the Silt Stair court found Corren’s washes lawful",
      "intention": "offer",
      "text": "My teacher, Corren, was accused of supplying corpse-work. The court at the Silt Stair compared his washes with a lawful one and found no binding in them.",
      "reply": "Vos sets down the thread she was winding. “Corren of the Orsen? Half the binders on this coast learned from his notebook and hid it when he was charged.” She looks along her tables, the salt jars, the tags. “People came to me because the binders would not touch their dead after that. Some of them will go back now.” She does not sound sorry, or glad.",
      "journal": "Told Ildren Vos that Corren’s washes were found lawful. Binders on the coast can use his formula openly again, and some of her custom will go back to them.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z02:notes"
        ],
        "any": [],
        "none": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ]
      },
      "effects": {
        "add": [
          "continuation:hedge-binder:held"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "hedge-binder"
    },
    {
      "id": "continuation-hedge-binder-open",
      "beatId": "beat:z02-bonded-warehouse",
      "speakerId": "z02-vos",
      "label": "Tell the people waiting at Vos’s tables what Corren’s washes really are",
      "intention": "offer",
      "text": "Corren’s washes are salt, vinegar and heat. No wax, no quicksilver. They keep the living warm; they do nothing to the dead.",
      "reply": "A few in the queue listen. One woman asks you to write it down, and you do, on the back of a salvage tag. Vos watches and says nothing until you finish. “No court said that,” she says. “But they will remember that you did.”",
      "journal": "Told the people queuing at Ildren Vos’s tables what Corren’s washes are. No court has cleared him; they have your word and a salvage tag.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z02:notes"
        ],
        "any": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ],
        "none": []
      },
      "effects": {
        "add": [
          "continuation:hedge-binder:open"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "hedge-binder"
    },
    {
      "id": "continuation-grave-witness-held",
      "beatId": "beat:z02-rope-walk",
      "speakerId": null,
      "label": "Tie a burial cord for Theron at the harbour shrine",
      "intention": "offer",
      "text": "Theron. Buried at the Silt Stair, in a niche with his own name on it.",
      "reply": "The shrine keeps a cord for every name the sea gave back. Theron was never at sea, but the ropemakers let you knot his anyway, a burial knot, with a copper cut threaded through the strand. “The ones with graves get the copper,” a woman on the walk tells you. “So the others know it can be done.”",
      "journal": "Tied a burial cord for Theron at the Nacre harbour shrine. His is one of the few there with a grave behind it.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z02:notes"
        ],
        "any": [],
        "none": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ]
      },
      "effects": {
        "add": [
          "continuation:grave-witness:held"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "grave-witness"
    },
    {
      "id": "continuation-grave-witness-open",
      "beatId": "beat:z02-rope-walk",
      "speakerId": null,
      "label": "Tie a plain cord for Theron at the harbour shrine",
      "intention": "offer",
      "text": "Theron. His burial was paid for, and his niche is empty.",
      "reply": "The ropemakers knot it plain, like the cords for the drowned whose bodies never came back. “Most of them are plain,” one of them says. “It does not mean nobody looked.” The cord hangs among a hundred others.",
      "journal": "Tied a plain cord for Theron at the Nacre harbour shrine, among the drowned whose bodies never came back. His niche at the Silt Stair is still empty.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z02:notes"
        ],
        "any": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ],
        "none": []
      },
      "effects": {
        "add": [
          "continuation:grave-witness:open"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "grave-witness"
    },
    {
      "id": "continuation-serekh-exile-held",
      "beatId": "beat:z06-old-ford",
      "speakerId": "z06-guide",
      "label": "Ask Wenna to watch for Hazren and the two children on the west road",
      "intention": "ask",
      "text": "My aunt and two children crossed at Lock Foot on stamped vouchers. They mean to come west. Their papers are good, but they have no money for chains.",
      "reply": "“Papers are no use to a chain, and money is no use to the water.” Wenna ties a strip of blue cloth to her ford pole. “Tell them to look for that. I will take them over when the water is low, and ask them nothing.”",
      "journal": "Asked Wenna Coll to see Hazren and the children over the old ford when they come west. She tied a blue strip to her ford pole for them to look for.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z06:errand"
        ],
        "any": [],
        "none": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ]
      },
      "effects": {
        "add": [
          "continuation:serekh-exile:held"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "serekh-exile"
    },
    {
      "id": "continuation-serekh-exile-open",
      "beatId": "beat:z06-old-ford",
      "speakerId": "z06-guide",
      "label": "Ask Wenna whether the ford takes people with no stamped passage",
      "intention": "ask",
      "text": "My aunt and two children are still at Lock Foot. Nobody made their passage safe. Is there a way west that asks for no papers?",
      "reply": "“This one.” Wenna looks down into the ravine, then at you. “Shin-deep in a dry month and a grave in a wet one. No stamp, no guarantee, and nobody to complain to if it goes wrong. If they get this far, I will take them. I will not tell you it is safe.”",
      "journal": "Wenna Coll will take Hazren and the children over the old ford without papers if they reach it. It is no lawful passage and no safe one, and she said so.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z06:errand"
        ],
        "any": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ],
        "none": []
      },
      "effects": {
        "add": [
          "continuation:serekh-exile:open"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "serekh-exile"
    },
    {
      "id": "continuation-intelligence-runner-held",
      "beatId": "beat:z06-toll-shelter",
      "speakerId": "z06-factor",
      "label": "Ask the factor whether anything has come west under your name",
      "intention": "ask",
      "text": "Your chain stops couriers as well as carts. Has anything come through with my name on it?",
      "reply": "Aurin checks his packet book without being asked twice. “One, from Caldris, under a patron’s seal. It offers you forty cuts to recant a deposition. It is eight days late.” He hands it over unopened. “Your old patron pays the toll on letters that no longer matter. I admire the thrift.”",
      "journal": "The Compact factor at the Broken Causeway handed over a letter from your former patron: forty cuts to recant a deposition already in public custody. It came too late to matter.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z06:errand"
        ],
        "any": [],
        "none": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ]
      },
      "effects": {
        "add": [
          "continuation:intelligence-runner:held"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 0,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "intelligence-runner"
    },
    {
      "id": "continuation-intelligence-runner-open",
      "beatId": "beat:z06-toll-shelter",
      "speakerId": "z06-factor",
      "label": "Pay the factor to carry your sworn account of the missing line to the Caldris archive — 4 cuts",
      "intention": "offer",
      "text": "The copy people are reading leaves out one line. I carried the original; I will swear to what it said. Send my account to the public archive at Caldris.",
      "reply": "Aurin reads it and seals it with the Compact’s lead. “Sworn by the runner who carried it. The archive will file it beside the copy, not instead of it.” He writes the fee in his book. “Your patron will know by the next packet. I would not travel east for a while.”",
      "journal": "Paid the Compact factor {cuts} to carry your sworn account of the deposition’s missing line to the Caldris archive. It will sit beside the buyer’s copy, not replace it, and your former patron will hear of it.",
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete",
          "z06:errand"
        ],
        "any": [
          "story:personal-compromised",
          "story:personal-failed",
          "story:personal-abandoned"
        ],
        "none": []
      },
      "effects": {
        "add": [
          "continuation:intelligence-runner:open"
        ],
        "remove": []
      },
      "arcActionId": null,
      "evidenceIds": [],
      "costCuts": 4,
      "rewardCuts": 0,
      "operation": null,
      "afterResolution": true,
      "origin": "intelligence-runner"
    }
  ],
  "objectives": [
    {
      "prerequisites": {
        "all": [
          "campaign:B5",
          "fact:local-aftermath-observed"
        ],
        "any": [],
        "none": [
          "campaign:B6"
        ]
      },
      "text": "What was yours to settle here is settled. Walk out of the basin through the Dry Cut.",
      "next": [
        {
          "beatId": "z04-dry-cut",
          "targetId": "finale-depart",
          "label": "Walk out through the Dry Cut"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B5"
        ],
        "any": [],
        "none": [
          "campaign:B6",
          "fact:local-aftermath-observed"
        ]
      },
      "text": "Before you leave the basin, see what changed at the market and the kiln gate.",
      "next": [
        {
          "beatId": "beat:middle-market-cold-bath",
          "targetId": "visit",
          "label": "Return to the market"
        },
        {
          "beatId": "z04-gate-of-accounts",
          "targetId": "visit",
          "label": "Return to the kiln gate"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B4",
          "finale:containment"
        ],
        "any": [],
        "none": [
          "campaign:B5",
          "finale:kind"
        ]
      },
      "text": "Advocate Vasko is waiting for the Silt Stair to give him a claim. Tell the court where this season’s grain goes: kept, the court owes Caldris a debt he can buy; sent, the pledge is paid.",
      "next": [
        {
          "beatId": "beat:reeves-court",
          "targetId": "containment-keep",
          "label": "Keep the grain at the Silt Stair"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "containment-send",
          "label": "Send the grain up the towpath to Caldris"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B4",
          "finale:containment"
        ],
        "any": [],
        "none": [
          "campaign:B5"
        ]
      },
      "text": "Nothing came down the river that needs a court. Tell the court where this season’s grain goes.",
      "next": [
        {
          "beatId": "beat:reeves-court",
          "targetId": "containment-keep",
          "label": "Keep the grain at the Silt Stair"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "containment-send",
          "label": "Send the grain up the towpath to Caldris"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B4",
          "finale:hearing",
          "finale:nessa-witness"
        ],
        "any": [
          "finale:reading-watched",
          "finale:ledger-seized"
        ],
        "none": [
          "campaign:B5"
        ]
      },
      "text": "Nessa Tal will speak for Leth An, and you know what Vos’s reading is. Stand before the Senate court in the basilica.",
      "next": [
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-court-sits",
          "label": "Take a place on the benches as the Senate court sits"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-hearing",
          "label": "Stand before the Senate court with Nessa Tal"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B4",
          "finale:hearing",
          "finale:ledger-seized"
        ],
        "any": [],
        "none": [
          "campaign:B5",
          "finale:nessa-witness"
        ]
      },
      "text": "You have Vos’s reading book: the clerk’s questions and answers in one hand. The court will still want someone living to say what Leth An’s count meant.",
      "next": [
        {
          "beatId": "beat:lower-landing",
          "targetId": "n03-nessa",
          "label": "Ask Nessa Tal to speak for Leth An"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-court-sits",
          "label": "Take a place on the benches as the Senate court sits"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-hearing-alone",
          "label": "Or put the book before the court alone"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-withdraw",
          "label": "Or pay Vasko to withdraw"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B4",
          "finale:hearing",
          "finale:court-sat"
        ],
        "any": [],
        "none": [
          "campaign:B5"
        ]
      },
      "text": "The Senate court has heard Ildren Vos read Leth An’s hand as the granary’s pledge, and waits one sitting for the Silt Stair’s answer: someone living who knew him, and proof of what her reading can and cannot show. Or pay Vasko off, or let the claim stand.",
      "next": [
        {
          "beatId": "beat:lower-landing",
          "targetId": "n03-nessa",
          "label": "Ask Nessa Tal to speak for Leth An"
        },
        {
          "beatId": "beat:z01-archive-stair",
          "targetId": "n03-annex-watch",
          "label": "Watch Vos rehearse in the burial annex"
        },
        {
          "beatId": "beat:z01-archive-stair",
          "targetId": "n03-annex-seize",
          "label": "Or take her reading book by force"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-hearing",
          "label": "Answer the court with Nessa Tal"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-hearing-alone",
          "label": "Or put the book before the court alone"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-withdraw",
          "label": "Or pay Vasko to withdraw"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-concede",
          "label": "Or let the claim stand"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B4",
          "finale:hearing",
          "finale:claim-heard"
        ],
        "any": [],
        "none": [
          "campaign:B5"
        ]
      },
      "text": "The Senate court will hear Ildren Vos read Leth An’s hand as the granary’s pledge. Answer it with someone living who knew him, and proof of what her reading can and cannot show. Or pay Vasko off, or let the claim stand.",
      "next": [
        {
          "beatId": "beat:lower-landing",
          "targetId": "n03-nessa",
          "label": "Ask Nessa Tal to speak for Leth An"
        },
        {
          "beatId": "beat:z01-archive-stair",
          "targetId": "n03-annex-watch",
          "label": "Watch Vos rehearse in the burial annex"
        },
        {
          "beatId": "beat:z01-archive-stair",
          "targetId": "n03-annex-seize",
          "label": "Or take her reading book by force"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-court-sits",
          "label": "Take a place on the benches as the Senate court sits"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-hearing",
          "label": "Stand before the Senate court with Nessa Tal"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-withdraw",
          "label": "Or pay Vasko to withdraw"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-concede",
          "label": "Or let the claim stand"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B4",
          "finale:hearing"
        ],
        "any": [],
        "none": [
          "campaign:B5",
          "finale:claim-heard"
        ]
      },
      "text": "Advocate Vasko claims the Silt Stair’s granary before the Senate court in Caldris, on Leth An’s dead hand as Ildren Vos reads it. Hear his claim in the basilica.",
      "next": [
        {
          "beatId": "beat:z01-basilica",
          "targetId": "n03-vasko",
          "label": "Ask Vasko what he claims"
        },
        {
          "beatId": "beat:lower-landing",
          "targetId": "n03-nessa",
          "label": "Ask Nessa Tal what Leth’s count meant"
        },
        {
          "beatId": "beat:z01-archive-stair",
          "targetId": "n03-annex-watch",
          "label": "Watch Vos rehearse in the burial annex"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "errand:second"
        ],
        "any": [
          "errand:z01:done",
          "errand:z02:done",
          "errand:z06:done"
        ],
        "none": [
          "errand:z01:underway",
          "errand:z02:underway",
          "errand:z06:underway",
          "campaign:B4",
          "campaign:B6"
        ]
      },
      "text": "Both errands you took for the court are done. Tell the court you have carried your last.",
      "next": [
        {
          "beatId": "beat:reeves-court",
          "targetId": "finale-summons",
          "label": "Tell the court you have carried the last of its errands"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "finale-quiet",
          "label": "Tell the court you have carried the last of its errands"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "finale-contain",
          "label": "Tell the court you have carried the last of its errands"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2"
        ],
        "any": [
          "errand:z01:done",
          "errand:z02:done",
          "errand:z06:done"
        ],
        "none": [
          "errand:z01:underway",
          "errand:z02:underway",
          "errand:z06:underway",
          "errand:second",
          "campaign:B4",
          "campaign:B6"
        ]
      },
      "text": "The court’s errand is done. It has another road for you if you want one, or tell it you have carried your last.",
      "next": [
        {
          "beatId": "beat:reeves-court",
          "targetId": "z01-docket-second",
          "label": "Take the court’s grain docket up to Caldris as well"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "z02-notes-second",
          "label": "Take the court’s quay notes down to Nacre Quay as well"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "z06-lime-order",
          "label": "Take the court’s letter for its lime at the Broken Causeway"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "z06-lime-order-kilns",
          "label": "Take the court’s letter for its lime at the Broken Causeway"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "finale-summons",
          "label": "Tell the court you have carried the last of its errands"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "finale-quiet",
          "label": "Tell the court you have carried the last of its errands"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "finale-contain",
          "label": "Tell the court you have carried the last of its errands"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "fact:local-aftermath-observed"
        ],
        "any": [],
        "none": []
      },
      "text": "The settlement is visible. Decide what you carry away.",
      "next": [
        {
          "beatId": "beat:reeves-court",
          "targetId": "z06-lime-order-first",
          "label": "Ask the court about its share of the causeway lease"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "z01-docket",
          "label": "Ask the court about the grain docket for Caldris"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "z02-notes",
          "label": "Or ask the court about its quay notes for Nacre Quay"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "fact:terminal-accounting-complete"
        ],
        "any": [],
        "none": []
      },
      "text": "See the result at the market and the kiln gate.",
      "next": [
        {
          "beatId": "beat:middle-market-cold-bath",
          "targetId": "visit",
          "label": "Return to the market"
        },
        {
          "beatId": "z04-gate-of-accounts",
          "targetId": "visit",
          "label": "Return to the kiln gate"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "z01-docket",
          "label": "Ask the court about the grain docket for Caldris"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "z02-notes",
          "label": "Or ask the court about its quay notes for Nacre Quay"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "fact:resolution-chosen",
          "story:grain-settled"
        ],
        "any": [],
        "none": []
      },
      "text": "Register grain, burial and your own claim at the court.",
      "next": [
        {
          "beatId": "beat:reeves-court",
          "targetId": "account",
          "label": "Register the settlement"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "fact:resolution-chosen"
        ],
        "any": [],
        "none": []
      },
      "text": "Choose who pays to move the grain.",
      "next": [
        {
          "beatId": "beat:lift-yard",
          "targetId": "bearing",
          "label": "Inspect the lift"
        },
        {
          "beatId": "beat:lift-yard",
          "targetId": "porters",
          "label": "Fund a living crew"
        },
        {
          "beatId": "beat:eastern-road-lock-foot",
          "targetId": "road-pawl",
          "label": "Inspect the safe hoist cycle"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "story:combat-won",
          "world:work-stopped"
        ],
        "any": [],
        "none": []
      },
      "text": "The anchors were stopped before you came, and nothing here is left to break or burn. Secure the remains and records for the families.",
      "next": [
        {
          "beatId": "z04-cart-ramp-office",
          "targetId": "secure-stopped-stations",
          "label": "Secure the already-stopped stations"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "story:combat-won"
        ],
        "any": [],
        "none": []
      },
      "text": "Controlled force or fire? Force needs the ledgers and workers moved clear first, and leaves the dead to be named. Fire needs only the lamps, and takes every bound body and the bearing stock with it.",
      "next": [
        {
          "beatId": "z04-cart-ramp-office",
          "targetId": "careful-end",
          "label": "Break the anchor fittings"
        },
        {
          "beatId": "z04-cart-ramp-office",
          "targetId": "reckless-end",
          "label": "Burn the stations"
        },
        {
          "beatId": "z04-cart-ramp-office",
          "targetId": "secure-stopped-stations",
          "label": "Secure the already-stopped stations"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": [
          "fact:tethers-inspected"
        ]
      },
      "text": "What connects the working dead to the three work stations?",
      "next": [
        {
          "beatId": "z04-lower-work-gallery",
          "targetId": "tether-gallery",
          "label": "Trace the gallery anchor"
        },
        {
          "beatId": "z04-lower-work-gallery",
          "targetId": "tether-gallery-remains",
          "label": "Examine the stopped lower gallery station"
        },
        {
          "beatId": "z04-cooling-court",
          "targetId": "tether-vault",
          "label": "Trace the cooling-vault anchor"
        },
        {
          "beatId": "z04-cooling-court",
          "targetId": "tether-vault-remains",
          "label": "Examine the stopped columbarium vault station"
        },
        {
          "beatId": "z04-cart-ramp-office",
          "targetId": "tether-firing",
          "label": "Trace the firing-floor anchor"
        },
        {
          "beatId": "z04-cart-ramp-office",
          "targetId": "tether-firing-remains",
          "label": "Examine the stopped firing tunnel station"
        },
        {
          "beatId": "z04-selas-rooms",
          "targetId": "tethers",
          "label": "Compare the three anchors with Sela’s pattern"
        },
        {
          "beatId": "z04-dry-cut",
          "targetId": "dry-cut",
          "label": "Look at the cold stone in the Dry Cut, past the gallery"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "fact:tethers-inspected",
          "fact:records-secured"
        ],
        "any": [],
        "none": [
          "fact:melian-separated"
        ]
      },
      "text": "Does the shared salt really connect Melian to the dead?",
      "next": [
        {
          "beatId": "beat:middle-market-cold-bath",
          "targetId": "melian-demo",
          "label": "Observe Melian’s living practice"
        },
        {
          "beatId": "beat:middle-market-cold-bath",
          "targetId": "separate",
          "label": "Compare the kiln records with Melian’s practice"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "fact:necromancy-observed"
        ],
        "any": [],
        "none": []
      },
      "text": "Secure the records and prepare terms for stopping the work.",
      "next": [
        {
          "beatId": "z04-selas-rooms",
          "targetId": "records",
          "label": "Secure the station ledgers"
        },
        {
          "beatId": "z04-cart-ramp-office",
          "targetId": "intercept",
          "label": "Hold the records cart"
        },
        {
          "beatId": "z04-cooling-court",
          "targetId": "odel-cooperate",
          "label": "Ask what will protect Odel’s sister"
        },
        {
          "beatId": "z04-cart-ramp-office",
          "targetId": "noll-out",
          "label": "Force Noll out; Sela will not bargain while he holds the office"
        },
        {
          "beatId": "z04-selas-rooms",
          "targetId": "sela-terms",
          "label": "Ask Sela for terms"
        },
        {
          "beatId": "beat:reeves-court",
          "targetId": "protect",
          "label": "Arrange protected testimony — 6 cuts"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "fact:name-attached"
        ],
        "any": [],
        "none": []
      },
      "text": "Follow Leth’s wages to the Quiet Kilns and compare the burial record.",
      "next": [
        {
          "beatId": "z04-cooling-court",
          "targetId": "token",
          "label": "Match the family token"
        },
        {
          "beatId": "z04-lower-work-gallery",
          "targetId": "gallery",
          "label": "Watch the lower gallery"
        },
        {
          "beatId": "z04-lower-work-gallery",
          "targetId": "gallery-stopped",
          "label": "Examine the stopped gallery"
        },
        {
          "beatId": "z04-cooling-court",
          "targetId": "vault-working",
          "label": "Watch the columbarium vault"
        },
        {
          "beatId": "z04-cart-ramp-office",
          "targetId": "firing-working",
          "label": "Watch the firing tunnel"
        },
        {
          "beatId": "z04-dry-cut",
          "targetId": "dry-cut",
          "label": "Look at the cold stone in the Dry Cut, past the gallery"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "fact:investigation-opened",
          "story:nessa-heard"
        ],
        "any": [],
        "none": []
      },
      "text": "Find the missing worker’s name in the lift-yard wage tally.",
      "next": [
        {
          "beatId": "beat:lower-landing",
          "targetId": "nessa-account",
          "label": "Ask Nessa what she saw"
        },
        {
          "beatId": "beat:middle-market-cold-bath",
          "targetId": "melian-need",
          "label": "Ask Melian about the accusation"
        },
        {
          "beatId": "beat:lift-yard",
          "targetId": "tally",
          "label": "Read the wage tally"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [],
        "any": [],
        "none": [
          "fact:coffin-inspected"
        ]
      },
      "text": "A closed coffin waits beside the grain. See what it is holding.",
      "next": [
        {
          "beatId": "beat:lower-landing",
          "targetId": "coffin",
          "label": "Inspect the coffin"
        },
        {
          "beatId": "beat:lower-landing",
          "targetId": "nessa-account",
          "label": "Speak to Nessa"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "fact:coffin-inspected"
        ],
        "any": [],
        "none": []
      },
      "text": "Find out why the coffin is empty.",
      "next": [
        {
          "beatId": "beat:lower-landing",
          "targetId": "coffin",
          "label": "Inspect the coffin"
        },
        {
          "beatId": "beat:lower-landing",
          "targetId": "nessa-account",
          "label": "Speak to Nessa"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "campaign:B6",
          "fact:local-aftermath-observed"
        ],
        "any": [],
        "none": []
      },
      "text": "The court’s errand is done. Take shelter at the Dry Cut when you are ready.",
      "next": []
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "campaign:B6"
        ],
        "any": [],
        "none": []
      },
      "text": "The court’s errand is done. See what changed at the market and the kiln gate, then take shelter at the Dry Cut.",
      "next": [
        {
          "beatId": "beat:middle-market-cold-bath",
          "targetId": "visit",
          "label": "Return to the market"
        },
        {
          "beatId": "z04-gate-of-accounts",
          "targetId": "visit",
          "label": "Return to the kiln gate"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z01:docket-sealed"
        ],
        "any": [],
        "none": [
          "z01:docket-returned"
        ]
      },
      "text": "Carry the sealed docket back to Reeve’s Court.",
      "next": [
        {
          "beatId": "beat:reeves-court",
          "targetId": "z01-docket-return",
          "label": "Return the sealed docket"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z01:bonds-void"
        ],
        "any": [],
        "none": [
          "z01:docket-sealed"
        ]
      },
      "text": "The court voided eleven bonds. Take the finding to the register table and have the docket sealed.",
      "next": [
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-seal-restored",
          "label": "Have the voided households read first"
        },
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-seal-standing",
          "label": "Seal the docket as the register stands"
        },
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-seal-knowing",
          "label": "Seal the docket as the register stands"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z01:claimant-declared"
        ],
        "any": [],
        "none": [
          "z01:docket-sealed"
        ]
      },
      "text": "You stood at the claimant’s dais, so the Senate court will not hear you now. The struck households eat from her carts. Have the docket sealed as the register stands.",
      "next": [
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-seal-standing",
          "label": "Seal the docket as the register stands"
        },
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-seal-knowing",
          "label": "Seal the docket as the register stands"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z01:bond-list",
          "z01:witness-dated",
          "z01:irra-witness"
        ],
        "any": [],
        "none": [
          "z01:bonds-void",
          "z01:docket-sealed"
        ]
      },
      "text": "You have the bond file, the flood register and a living witness. Put them before the Senate court.",
      "next": [
        {
          "beatId": "beat:z01-basilica",
          "targetId": "z01-petition",
          "label": "Petition the Senate court"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "z01-petition-standard",
          "label": "Petition the Senate court"
        },
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-seal-standing",
          "label": "Seal the docket as the register stands"
        },
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-seal-knowing",
          "label": "Seal the docket as the register stands"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z01:bond-lead"
        ],
        "any": [],
        "none": [
          "z01:docket-sealed",
          "z01:bonds-void"
        ]
      },
      "text": "Aulo the carter swore to a debt two winters after he drowned. The archive under the basilica holds both dates; the court will want a living witness too.",
      "next": [
        {
          "beatId": "beat:z01-archive-stair",
          "targetId": "z01-archive-flood",
          "label": "Find Aulo in the flood register"
        },
        {
          "beatId": "beat:z01-archive-stair",
          "targetId": "z01-runner-ask",
          "label": "Ask who is carrying the bond chests out"
        },
        {
          "beatId": "beat:z01-archive-stair",
          "targetId": "z01-runner-watch",
          "label": "Send the runner off with the watch"
        },
        {
          "beatId": "beat:z01-archive-stair",
          "targetId": "z01-archive-bonds",
          "label": "Read the bond file"
        },
        {
          "beatId": "beat:z01-river-bridge",
          "targetId": "z01-watch-post",
          "label": "Post the watch at the archive grille"
        },
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-register-call",
          "label": "Earn six cuts calling names at the register"
        },
        {
          "beatId": "beat:z01-archive-stair",
          "targetId": "z01-runner-pay",
          "label": "Pay the runner to let you read first"
        },
        {
          "beatId": "beat:z01-archive-stair",
          "targetId": "z01-runner-fight",
          "label": "Take the chests from the runner"
        },
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-irra-witness",
          "label": "Ask Irra to tell the court"
        },
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-seal-standing",
          "label": "Or seal the docket as the register stands"
        },
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-seal-knowing",
          "label": "Or seal the docket as the register stands"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "z01-claimant-feed",
          "label": "Or ask the claimant on the second dais to feed the struck households"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z01:docket-read"
        ],
        "any": [],
        "none": [
          "z01:docket-sealed",
          "z01:bond-lead"
        ]
      },
      "text": "The Silt Stair’s grain buys places on the bread register, and more households are struck than it can feed. Seal the docket, or find out why they were struck.",
      "next": [
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-registrar-bonds",
          "label": "Ask why bonded households are struck"
        },
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-irra-bond",
          "label": "Ask Irra Senth who holds her husband’s bond"
        },
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-seal-standing",
          "label": "Seal the docket as the register stands"
        },
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-seal-knowing",
          "label": "Seal the docket as the register stands"
        },
        {
          "beatId": "beat:z01-basilica",
          "targetId": "z01-claimant-feed",
          "label": "Or ask the claimant on the second dais to feed the struck households"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z01:docket"
        ],
        "any": [],
        "none": [
          "z01:docket-read"
        ]
      },
      "text": "Take the Silt Stair’s grain docket up the towpath to the grain court in Caldris.",
      "next": [
        {
          "beatId": "beat:z01-grain-court",
          "targetId": "z01-docket-read",
          "label": "Hand the docket to the registrar"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z02:redeemed"
        ],
        "any": [],
        "none": [
          "errand:z02:done"
        ]
      },
      "text": "The notes are settled. Take the canal boat home and report to Reeve’s Court.",
      "next": [
        {
          "beatId": "beat:reeves-court",
          "targetId": "z02-notes-return",
          "label": "Report the notes settled at Reeve’s Court"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z02:gangway-cleared"
        ],
        "any": [],
        "none": [
          "z02:redeemed"
        ]
      },
      "text": "The gangway is clear. Have Sereth Vann’s crews empty the hull onto the Silt Stair’s barges.",
      "next": [
        {
          "beatId": "beat:z02-mole-berths",
          "targetId": "z02-hull-load",
          "label": "Have the crews empty the hull"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z02:tamsa-witness"
        ],
        "any": [],
        "none": [
          "z02:redeemed"
        ]
      },
      "text": "Tamsa Brin will say what was sworn. Bring her before the sale court.",
      "next": [
        {
          "beatId": "beat:z02-sale-court",
          "targetId": "z02-redeem-witness",
          "label": "Bring Tamsa before the sale court"
        },
        {
          "beatId": "beat:z02-sale-court",
          "targetId": "z02-redeem-witness-senate",
          "label": "Bring Tamsa before the sale court"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z02:vos-hired"
        ],
        "any": [],
        "none": [
          "z02:redeemed"
        ]
      },
      "text": "Ildren Vos will read the drowned pilot’s oath before the sale court.",
      "next": [
        {
          "beatId": "beat:z02-sale-court",
          "targetId": "z02-redeem-testimony",
          "label": "Put the pilot’s oath before the sale court"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z02:crew-paid"
        ],
        "any": [],
        "none": [
          "z02:redeemed"
        ]
      },
      "text": "Sereth Vann’s crews are paid and waiting, but the broker’s hook-hand still sits on the hull’s gangway.",
      "next": [
        {
          "beatId": "beat:z02-mole-berths",
          "targetId": "z02-hull-fight",
          "label": "Move the hook-hand off the gangway"
        },
        {
          "beatId": "beat:z02-rope-walk",
          "targetId": "z02-shrine-cord",
          "label": "Or read the oath cord at the shrine"
        },
        {
          "beatId": "beat:z02-sale-court",
          "targetId": "z02-maurel-terms",
          "label": "Or hear the Convener’s terms"
        },
        {
          "beatId": "beat:z02-sale-court",
          "targetId": "z02-concession",
          "label": "Or sign the Convener’s lease"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z02:oath-heard"
        ],
        "any": [],
        "none": [
          "z02:redeemed"
        ]
      },
      "text": "Tamsa Brin heard the guarantee sworn plain, but will not say so while the Convener can sell her bond. The hull delegates can carry a bond.",
      "next": [
        {
          "beatId": "beat:z02-rope-walk",
          "targetId": "z02-rope-work",
          "label": "Earn six cuts walking rope"
        },
        {
          "beatId": "beat:z02-mole-berths",
          "targetId": "z02-tamsa-protect",
          "label": "Ask Sereth Vann to put Tamsa’s bond on the crews’ roll"
        },
        {
          "beatId": "beat:z02-rope-walk",
          "targetId": "z02-tamsa-witness",
          "label": "Ask Tamsa to speak at the sale court"
        },
        {
          "beatId": "beat:z02-sale-court",
          "targetId": "z02-maurel-terms",
          "label": "Or hear the Convener’s terms"
        },
        {
          "beatId": "beat:z02-sale-court",
          "targetId": "z02-concession",
          "label": "Or sign the Convener’s lease"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z02:guarantee-disputed"
        ],
        "any": [],
        "none": [
          "z02:redeemed"
        ]
      },
      "text": "The Convener’s clerks dispute the fleet’s guarantee, and the notes are paper until it is settled. Guarantees here are sworn at the harbour shrine on the rope walk, before two witnesses.",
      "next": [
        {
          "beatId": "beat:z02-rope-walk",
          "targetId": "z02-shrine-cord",
          "label": "Read the oath cord at the shrine"
        },
        {
          "beatId": "beat:z02-rope-walk",
          "targetId": "z02-tamsa-oath",
          "label": "Ask Tamsa Brin what was sworn"
        },
        {
          "beatId": "beat:z02-sale-court",
          "targetId": "z02-maurel-terms",
          "label": "Or hear the Convener’s terms"
        },
        {
          "beatId": "beat:z02-sale-court",
          "targetId": "z02-concession",
          "label": "Or sign the Convener’s lease"
        },
        {
          "beatId": "beat:z02-bonded-warehouse",
          "targetId": "z02-vos-ask",
          "label": "Or ask what is done at the tables in the bonded warehouse"
        },
        {
          "beatId": "beat:z02-bonded-warehouse",
          "targetId": "z02-vos-hire",
          "label": "Or pay Ildren Vos to read the drowned pilot’s oath"
        },
        {
          "beatId": "beat:z02-mole-berths",
          "targetId": "z02-sereth-crew",
          "label": "Or pay Sereth Vann’s crews to empty the pier hull"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z02:notes"
        ],
        "any": [],
        "none": [
          "z02:guarantee-disputed"
        ]
      },
      "text": "Take the court’s quay notes down the canal to the sale court at Nacre Quay.",
      "next": [
        {
          "beatId": "beat:lower-landing",
          "targetId": "z02-fare",
          "label": "Buy passage on the canal boat to Nacre Quay — 4 cuts"
        },
        {
          "beatId": "beat:lower-landing",
          "targetId": "z02-fare-work",
          "label": "Or work your passage at the sweeps"
        },
        {
          "beatId": "beat:z02-sale-court",
          "targetId": "z02-notes-present",
          "label": "Present the quay notes at the sale court"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z06:carts-across"
        ],
        "any": [],
        "none": [
          "errand:z06:done"
        ]
      },
      "text": "The court’s lime is over the Broken Causeway and on the road. Tell the court at Reeve’s table.",
      "next": [
        {
          "beatId": "beat:reeves-court",
          "targetId": "z06-lime-return",
          "label": "Report the court’s lime on the road home"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z06:lime-seen"
        ],
        "any": [],
        "none": [
          "z06:carts-across"
        ]
      },
      "text": "Livra Cantor’s six carts are loaded. Get them over the break: pay the factor’s toll, sign the court into his lease, have the last keystone set, or take them through the old ford while the water is low.",
      "next": [
        {
          "beatId": "beat:z06-toll-shelter",
          "targetId": "z06-carts-through",
          "label": "Wave the carts through the dropped chain"
        },
        {
          "beatId": "beat:z06-toll-shelter",
          "targetId": "z06-factor-rates",
          "label": "Ask the factor about his rates"
        },
        {
          "beatId": "beat:z06-broken-span",
          "targetId": "z06-mason-arch",
          "label": "Ask the mason why the last arch has no keystone"
        },
        {
          "beatId": "beat:z06-toll-shelter",
          "targetId": "z06-toll-pay",
          "label": "Pay the toll for the court’s six carts — 12 cuts"
        },
        {
          "beatId": "beat:z06-toll-shelter",
          "targetId": "z06-lease-sign",
          "label": "Or sign the court into the Compact’s lease"
        },
        {
          "beatId": "beat:z06-toll-shelter",
          "targetId": "z06-roll-countersign",
          "label": "Seal the gang’s bond roll for free passage"
        },
        {
          "beatId": "beat:z06-repair-camp",
          "targetId": "z06-keystone",
          "label": "Or pay the gang’s day to set the keystone"
        },
        {
          "beatId": "beat:z06-repair-camp",
          "targetId": "z06-contractor-work",
          "label": "Earn five cuts on the hoist gang"
        },
        {
          "beatId": "beat:z06-old-ford",
          "targetId": "z06-guide-ford",
          "label": "Or have Wenna take the carts through the ford"
        },
        {
          "beatId": "beat:z06-toll-shelter",
          "targetId": "z06-carter-ask",
          "label": "Hear out the carter by the covered wagon"
        },
        {
          "beatId": "beat:z06-toll-shelter",
          "targetId": "z06-coffins-look",
          "label": "Lift a corner of the carter’s canvas"
        },
        {
          "beatId": "beat:z06-toll-shelter",
          "targetId": "z06-coffins-report",
          "label": "Tell the factor what is under the canvas"
        },
        {
          "beatId": "beat:z06-toll-shelter",
          "targetId": "z06-coffins-cover",
          "label": "Or let the carter’s wagon cross as court carriage"
        },
        {
          "beatId": "beat:z06-toll-shelter",
          "targetId": "z06-chain-force",
          "label": "Or drop the chain by force"
        }
      ]
    },
    {
      "prerequisites": {
        "all": [
          "campaign:B2",
          "z06:errand"
        ],
        "any": [],
        "none": [
          "z06:lime-seen"
        ]
      },
      "text": "Six carts of the court’s lime wait at a repair camp beyond the Broken Causeway, 44 km west of Caldris. Find the contractor, Livra Cantor, across the plank bridge.",
      "next": [
        {
          "beatId": "beat:z06-repair-camp",
          "targetId": "z06-contractor-lime",
          "label": "Ask Livra Cantor after the court’s lime"
        },
        {
          "beatId": "beat:z06-toll-shelter",
          "targetId": "z06-factor-rates",
          "label": "Ask the factor about his rates"
        }
      ]
    }
  ],
  "reckonings": {
    "finale-summons": [
      {
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "text": "What was done in the basin this season told the Senate court that the basin would let the dead speak:"
      },
      {
        "prerequisites": {
          "all": [
            "fact:operation-supported"
          ],
          "any": [],
          "none": []
        },
        "text": "At the Quiet Kilns you paid for the wax that bound two more bodies to their work."
      },
      {
        "prerequisites": {
          "all": [
            "fact:witnesses-intimidated"
          ],
          "any": [],
          "none": []
        },
        "text": "At the kilns you frightened Odel Thann into silence. A court that cannot hear the living listens harder to the dead."
      },
      {
        "prerequisites": {
          "all": [
            "pressure:z01:advocate-paid"
          ],
          "any": [],
          "none": []
        },
        "text": "In Caldris you paid Advocate Vasko {cuts:z01-advocate-sell} for one widow’s bond. He spends his cuts at Ildren Vos’s tables."
      },
      {
        "prerequisites": {
          "all": [
            "pressure:z02:dead-testimony"
          ],
          "any": [],
          "none": []
        },
        "text": "At Nacre Quay you put a drowned pilot’s oath before the sale court, and it was written down as his."
      },
      {
        "prerequisites": {
          "all": [
            "pressure:z06:coffins-uninspected"
          ],
          "any": [],
          "none": []
        },
        "text": "At the Broken Causeway you let a covered wagon cross under the court’s letter, unopened. Its six coffins were tagged for a Caldris court, as testimony."
      },
      {
        "prerequisites": {
          "all": [
            "pressure:z01:sealed-over-drowned"
          ],
          "any": [],
          "none": []
        },
        "text": "In Caldris you had the grain docket sealed over households struck on drowned men’s oaths, and you knew it."
      },
      {
        "prerequisites": {
          "all": [
            "pressure:z06:roll-countersigned"
          ],
          "any": [],
          "none": []
        },
        "text": "At the Broken Causeway you sealed a gang’s bond roll in the court’s name, over a drowned notary’s oaths."
      }
    ],
    "finale-depart": [
      {
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "text": "{claim}"
      },
      {
        "prerequisites": {
          "all": [
            "finale:n03:struck"
          ],
          "any": [],
          "none": []
        },
        "text": "In Caldris, the Senate court struck a dead man’s reading because a living woman said what his hands meant. Vasko keeps his other bonds. Ildren Vos packs her trestles for the coast."
      },
      {
        "prerequisites": {
          "all": [
            "finale:n03:bought"
          ],
          "any": [],
          "none": []
        },
        "text": "In Caldris, Vasko withdrew for your cuts. Leth An’s reading is still on the Senate court’s roll as good evidence, and Vasko knows what it is worth."
      },
      {
        "prerequisites": {
          "all": [
            "finale:n03:lost"
          ],
          "any": [],
          "none": []
        },
        "text": "In Caldris, the Senate court took Leth An’s counting hand as a pledge and gave the Silt Stair’s granary to the bondholders. Ildren Vos had three new buyers by evening."
      },
      {
        "prerequisites": {
          "all": [
            "finale:containment"
          ],
          "any": [],
          "none": [
            "finale:kind"
          ]
        },
        "text": "No court took a granary on a dead man’s word this season. What the dead were made to say stayed small: a price at a table, a line in a roll, nobody’s grain."
      },
      {
        "prerequisites": {
          "all": [
            "finale:kind"
          ],
          "any": [],
          "none": []
        },
        "text": "Nobody at the Silt Stair paid for a dead man’s word this season. When Advocate Vasko’s clerk came asking, there was nothing to find."
      },
      {
        "prerequisites": {
          "all": [
            "errand:z02:concession"
          ],
          "any": [],
          "none": []
        },
        "text": "The Salt Compact holds the Lower Landing’s berths for twenty years, on your signature in the court’s name."
      },
      {
        "prerequisites": {
          "all": [
            "z06:lease-signed"
          ],
          "any": [],
          "none": []
        },
        "text": "The Silt Stair court pays into the Salt Compact’s causeway lease every season the last arch stands open."
      },
      {
        "prerequisites": {
          "all": [
            "z06:roll-countersigned"
          ],
          "any": [],
          "none": []
        },
        "text": "Temmo Sard’s gang works the Broken Causeway on a bond roll the Silt Stair court sealed over a drowned notary’s oaths."
      },
      {
        "prerequisites": {
          "all": [
            "z01:depot-countersign"
          ],
          "any": [],
          "none": []
        },
        "text": "The Bronze Standard takes a quarter of the grain Caldris counts from the Silt Stair, for its countersign."
      },
      {
        "prerequisites": {
          "all": [
            "z02:harbour-due"
          ],
          "any": [],
          "none": []
        },
        "text": "The Senate’s harbour office at Nacre takes a fifth of the relief grain as its due."
      },
      {
        "prerequisites": {
          "all": [
            "z01:claimant-declared"
          ],
          "any": [],
          "none": []
        },
        "text": "The Senate’s clerks have your name written beside Liria Castel’s, the claimant on the second dais."
      },
      {
        "prerequisites": {
          "all": [
            "fact:outcome-licensed-atrocity"
          ],
          "any": [],
          "none": []
        },
        "text": "The kiln concession works its dead under licence, and the court’s seal is on the licence."
      },
      {
        "prerequisites": {
          "all": [
            "fact:outcome-private-containment"
          ],
          "any": [],
          "none": []
        },
        "text": "The kilns answer to a supervisor you paid for in private, not to the court."
      },
      {
        "prerequisites": {
          "all": [],
          "any": [],
          "none": [
            "errand:z02:concession",
            "z06:lease-signed",
            "z06:roll-countersigned",
            "z01:depot-countersign",
            "z02:harbour-due",
            "z01:claimant-declared",
            "fact:outcome-licensed-atrocity",
            "fact:outcome-private-containment"
          ]
        },
        "text": "You signed nothing away in the court’s name that will outlast you."
      },
      {
        "prerequisites": {
          "all": [
            "finale:containment:kept"
          ],
          "any": [],
          "none": []
        },
        "text": "The Silt Stair eats this winter from its own granary. Caldris counts its barges short and has written to say so."
      },
      {
        "prerequisites": {
          "all": [
            "finale:containment:sent"
          ],
          "any": [],
          "none": []
        },
        "text": "The Silt Stair’s barges went up the towpath full, and the landing’s queue stays long."
      },
      {
        "prerequisites": {
          "all": [
            "finale:containment:kept"
          ],
          "any": [],
          "none": [
            "finale:kind"
          ]
        },
        "text": "Advocate Vasko has bought the Silt Stair’s debt to Caldris at a discount. His clerk sits on the court steps, waiting for a default."
      },
      {
        "prerequisites": {
          "all": [
            "finale:containment:sent"
          ],
          "any": [],
          "none": [
            "finale:kind"
          ]
        },
        "text": "Advocate Vasko’s clerk went home with a copy of the grain count and nothing to claim."
      },
      {
        "prerequisites": {
          "all": [],
          "any": [
            "finale:n03:struck",
            "finale:n03:bought"
          ],
          "none": []
        },
        "text": "The Silt Stair keeps its granary and its grain this winter."
      },
      {
        "prerequisites": {
          "all": [
            "finale:n03:lost"
          ],
          "any": [],
          "none": []
        },
        "text": "The bondholders’ factors are at the lift yard, counting the Silt Stair’s grain onto their own barges. The landing rations what they leave."
      },
      {
        "prerequisites": {
          "all": [
            "world:companions-with-you"
          ],
          "any": [],
          "none": []
        },
        "text": "Through the cut with you, each on their own contract: {companions}."
      },
      {
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "text": "{fallen} did not leave the basin. Nothing brings them back."
      },
      {
        "prerequisites": {
          "all": [],
          "any": [],
          "none": [
            "world:companions-with-you",
            "world:companions-fallen"
          ]
        },
        "text": "Nobody you hired walks out with you."
      },
      {
        "prerequisites": {
          "all": [
            "finale:nessa-witness",
            "finale:n03:struck"
          ],
          "any": [],
          "none": []
        },
        "text": "Nessa Tal said her piece in the basilica and took the next barge home."
      },
      {
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "text": "The concession guard you killed is buried outside the kiln gate."
      },
      {
        "prerequisites": {
          "all": [
            "z01:runner-beaten"
          ],
          "any": [],
          "none": []
        },
        "text": "The advocate’s runner who died on the archive stair is buried in Caldris."
      },
      {
        "prerequisites": {
          "all": [
            "finale:ledger-seized"
          ],
          "any": [],
          "none": []
        },
        "text": "The advocate’s doorman who died in the burial annex is buried in Caldris, over a book."
      },
      {
        "prerequisites": {
          "all": [
            "z06:guard-beaten"
          ],
          "any": [],
          "none": []
        },
        "text": "The Salt Compact’s lease guard is buried by the chain he kept."
      },
      {
        "prerequisites": {
          "all": [
            "z02:gangway-cleared"
          ],
          "any": [],
          "none": []
        },
        "text": "The broker’s hook-hand is buried at Nacre Quay."
      },
      {
        "prerequisites": {
          "all": [
            "finale:n03:struck"
          ],
          "any": [],
          "none": []
        },
        "text": "The next outsider up the Silt Stair will find a Caldris court that once heard the living over the dead."
      },
      {
        "prerequisites": {
          "all": [
            "finale:n03:bought"
          ],
          "any": [],
          "none": []
        },
        "text": "The next outsider will find Leth An’s reading still on a Caldris roll, and an advocate who knows what the Silt Stair will pay."
      },
      {
        "prerequisites": {
          "all": [
            "finale:n03:lost"
          ],
          "any": [],
          "none": []
        },
        "text": "The next outsider will find the Silt Stair’s granary in other hands."
      },
      {
        "prerequisites": {
          "all": [
            "finale:containment:kept"
          ],
          "any": [],
          "none": []
        },
        "text": "The next outsider will find the landing fed and the court in Caldris’s debt."
      },
      {
        "prerequisites": {
          "all": [
            "finale:containment:sent"
          ],
          "any": [],
          "none": []
        },
        "text": "The next outsider will find Caldris counting the Silt Stair’s barges as honest."
      }
    ],
    "finale-contain": [
      {
        "prerequisites": {
          "all": [],
          "any": [
            "fact:operation-supported",
            "fact:witnesses-intimidated",
            "pressure:z01:advocate-paid",
            "pressure:z02:dead-testimony",
            "pressure:z06:coffins-uninspected"
          ],
          "none": []
        },
        "text": "None of it came to a hearing, but it was done:"
      },
      {
        "prerequisites": {
          "all": [
            "fact:operation-supported"
          ],
          "any": [],
          "none": []
        },
        "text": "At the Quiet Kilns you paid for the wax that bound two more bodies to their work."
      },
      {
        "prerequisites": {
          "all": [
            "fact:witnesses-intimidated"
          ],
          "any": [],
          "none": []
        },
        "text": "At the kilns you frightened Odel Thann into silence. A court that cannot hear the living listens harder to the dead."
      },
      {
        "prerequisites": {
          "all": [
            "pressure:z01:advocate-paid"
          ],
          "any": [],
          "none": []
        },
        "text": "In Caldris you paid Advocate Vasko {cuts:z01-advocate-sell} for one widow’s bond. He spends his cuts at Ildren Vos’s tables."
      },
      {
        "prerequisites": {
          "all": [
            "pressure:z02:dead-testimony"
          ],
          "any": [],
          "none": []
        },
        "text": "At Nacre Quay you put a drowned pilot’s oath before the sale court, and it was written down as his."
      },
      {
        "prerequisites": {
          "all": [
            "pressure:z06:coffins-uninspected"
          ],
          "any": [],
          "none": []
        },
        "text": "At the Broken Causeway you let a covered wagon cross under the court’s letter, unopened. Its six coffins were tagged for a Caldris court, as testimony."
      },
      {
        "prerequisites": {
          "all": [
            "pressure:z01:sealed-over-drowned"
          ],
          "any": [],
          "none": []
        },
        "text": "In Caldris you had the grain docket sealed over households struck on drowned men’s oaths, and you knew it."
      },
      {
        "prerequisites": {
          "all": [
            "pressure:z06:roll-countersigned"
          ],
          "any": [],
          "none": []
        },
        "text": "At the Broken Causeway you sealed a gang’s bond roll in the court’s name, over a drowned notary’s oaths."
      }
    ],
    "z01-advocate-sell": [
      {
        "prerequisites": {
          "all": [],
          "any": [],
          "none": [
            "convergence:n03"
          ]
        },
        "text": "Someone saw it done, and word of it will reach Caldris before you do. Advocate Vasko keeps a book of every time this basin lets the dead speak for the living."
      },
      {
        "prerequisites": {
          "all": [
            "convergence:n03"
          ],
          "any": [],
          "none": []
        },
        "text": "Word of it will reach Caldris before you do, and it is the word Advocate Vasko has been waiting for. His clerk will be at Reeve’s Court when you get back."
      }
    ],
    "z06-roll-countersign": [
      {
        "prerequisites": {
          "all": [],
          "any": [],
          "none": [
            "convergence:n03"
          ]
        },
        "text": "Someone saw it done, and word of it will reach Caldris before you do. Advocate Vasko keeps a book of every time this basin lets the dead speak for the living."
      },
      {
        "prerequisites": {
          "all": [
            "convergence:n03"
          ],
          "any": [],
          "none": []
        },
        "text": "Word of it will reach Caldris before you do, and it is the word Advocate Vasko has been waiting for. His clerk will be at Reeve’s Court when you get back."
      }
    ],
    "z06-coffins-cover": [
      {
        "prerequisites": {
          "all": [],
          "any": [],
          "none": [
            "convergence:n03"
          ]
        },
        "text": "Someone saw it done, and word of it will reach Caldris before you do. Advocate Vasko keeps a book of every time this basin lets the dead speak for the living."
      },
      {
        "prerequisites": {
          "all": [
            "convergence:n03"
          ],
          "any": [],
          "none": []
        },
        "text": "Word of it will reach Caldris before you do, and it is the word Advocate Vasko has been waiting for. His clerk will be at Reeve’s Court when you get back."
      }
    ],
    "z01-seal-knowing": [
      {
        "prerequisites": {
          "all": [],
          "any": [],
          "none": [
            "convergence:n03"
          ]
        },
        "text": "Someone saw it done, and word of it will reach Caldris before you do. Advocate Vasko keeps a book of every time this basin lets the dead speak for the living."
      },
      {
        "prerequisites": {
          "all": [
            "convergence:n03"
          ],
          "any": [],
          "none": []
        },
        "text": "Word of it will reach Caldris before you do, and it is the word Advocate Vasko has been waiting for. His clerk will be at Reeve’s Court when you get back."
      }
    ],
    "z02-redeem-testimony": [
      {
        "prerequisites": {
          "all": [],
          "any": [],
          "none": [
            "convergence:n03"
          ]
        },
        "text": "Someone saw it done, and word of it will reach Caldris before you do. Advocate Vasko keeps a book of every time this basin lets the dead speak for the living."
      },
      {
        "prerequisites": {
          "all": [
            "convergence:n03"
          ],
          "any": [],
          "none": []
        },
        "text": "Word of it will reach Caldris before you do, and it is the word Advocate Vasko has been waiting for. His clerk will be at Reeve’s Court when you get back."
      }
    ],
    "z06-toll-pay": [
      {
        "prerequisites": {
          "all": [
            "z06:coffin-cart"
          ],
          "any": [],
          "none": [
            "z06:coffins-held",
            "z06:coffins-passed"
          ]
        },
        "text": "The carter’s covered wagon crossed west in the same hour as the court’s carts, canvas roped down. Whatever it carried, nobody opened it."
      }
    ],
    "z06-lease-sign": [
      {
        "prerequisites": {
          "all": [
            "z06:coffin-cart"
          ],
          "any": [],
          "none": [
            "z06:coffins-held",
            "z06:coffins-passed"
          ]
        },
        "text": "The carter’s covered wagon crossed west in the same hour as the court’s carts, canvas roped down. Whatever it carried, nobody opened it."
      }
    ],
    "z06-carts-through": [
      {
        "prerequisites": {
          "all": [
            "z06:coffin-cart"
          ],
          "any": [],
          "none": [
            "z06:coffins-held",
            "z06:coffins-passed"
          ]
        },
        "text": "The carter’s covered wagon crossed west in the same hour as the court’s carts, canvas roped down. Whatever it carried, nobody opened it."
      }
    ],
    "z06-keystone": [
      {
        "prerequisites": {
          "all": [
            "z06:coffin-cart"
          ],
          "any": [],
          "none": [
            "z06:coffins-held",
            "z06:coffins-passed"
          ]
        },
        "text": "The carter’s covered wagon crossed west in the same hour as the court’s carts, canvas roped down. Whatever it carried, nobody opened it."
      }
    ],
    "z06-guide-ford": [
      {
        "prerequisites": {
          "all": [
            "z06:coffin-cart"
          ],
          "any": [],
          "none": [
            "z06:coffins-held",
            "z06:coffins-passed"
          ]
        },
        "text": "The carter’s covered wagon crossed west in the same hour as the court’s carts, canvas roped down. Whatever it carried, nobody opened it."
      }
    ]
  },
  "sideAftermath": [
    {
      "prerequisites": {
        "all": [
          "pressure:z02:dead-testimony"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:reeves-court": "A boatman off the Nacre canal says the sale court there wrote a drowned pilot’s oath into its record, on the Silt Stair’s notes. The court’s clerks have heard it twice already."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "pressure:z06:coffins-uninspected"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:reeves-court": "A carter off the west road says six coffins crossed the Broken Causeway under the Silt Stair’s letter, tagged for a Caldris court as testimony. The clerks have taken out the letter’s copy and are reading it again."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "pressure:z01:advocate-paid"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:reeves-court": "A Caldris bargeman says Advocate Vasko paid Ildren Vos’s table this week in Silt Stair cuts."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "pressure:z01:sealed-over-drowned"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:reeves-court": "A Caldris bargeman says the Silt Stair’s docket was sealed over the drowned men’s bonds by someone who had read the flood register first. The clerks say the name he gives is yours."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "pressure:z06:roll-countersigned"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:reeves-court": "A lime carter says the Silt Stair’s seal is on the Compact’s gang roll at the Broken Causeway now, under a drowned notary’s. The clerks have written to ask what it was they sealed."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "convergence:n03"
        ],
        "any": [],
        "none": [
          "campaign:B4"
        ]
      },
      "at": {
        "beat:reeves-court": "A clerk in advocate’s grey has sat on the court steps since morning, asking what the Silt Stair’s granary is pledged against."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "finale:containment:kept"
        ],
        "any": [],
        "none": [
          "finale:kind"
        ]
      },
      "at": {
        "beat:reeves-court": "A clerk in advocate’s grey sits on the court steps, copying the grain count into Advocate Vasko’s book. He has asked twice what the court owes Caldris."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "finale:containment:sent"
        ],
        "any": [],
        "none": [
          "finale:kind"
        ]
      },
      "at": {
        "beat:reeves-court": "The clerk in advocate’s grey read the barge manifest over the court’s shoulder, found the pledge paid, and took the next boat home."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "finale:n03:struck"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down the towpath: the Senate court at Caldris struck a dead porter’s reading and dismissed the claim on the Silt Stair’s granary. Nessa Tal is home, and says she spoke slowly."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "finale:n03:bought"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down the towpath: Advocate Vasko has withdrawn his claim on the Silt Stair’s granary. The court paid nothing for it; an outsider did."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "finale:n03:lost"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down the towpath: the Senate court at Caldris gave the Silt Stair’s granary to the bondholders on a dead porter’s count. Their factors are already at the lift yard."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "finale:containment:kept"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "The grain count is chalked on the court door every morning. The landing eats, and Caldris writes."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "finale:containment:sent"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "The barges went up the towpath full. The lift queue is as long as ever."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "past:finale:n03:struck"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:reeves-court": "A copy of a Caldris ruling is pinned by the court’s door: a dead man’s reading struck, because a living witness was heard. The pin has rusted. Nobody has taken it down."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "past:finale:n03:bought"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:reeves-court": "The court’s ledger carries a line an earlier outsider paid for: an advocate’s claim withdrawn, and a reading left on a Caldris roll."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "past:finale:n03:lost"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Barges with a Caldris bondholder’s mark load at the lift yard. An earlier outsider let the granary go."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "past:finale:containment:kept"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:reeves-court": "The court still owes Caldris a season of grain, from the winter an earlier outsider kept the barges home."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "past:finale:containment:sent"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Old porters still call the winter the barges went full to Caldris the long-queue winter."
      },
      "source": "finale"
    },
    {
      "prerequisites": {
        "all": [
          "side:arrears-returned",
          "side:walkway-shored"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "The paid porters run their handcart across the shored walkway. Bread reaches the bath for one cut even while the lift queue waits.",
        "beat:reeves-court": "The porter receipts name the workers who were actually paid."
      }
    },
    {
      "prerequisites": {
        "all": [
          "side:arrears-taken"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "The porters keep their handcart chained. They have recognised the missing pay pouch.",
        "beat:reeves-court": "Four wages are still marked unpaid beneath your settlement."
      }
    },
    {
      "prerequisites": {
        "all": [
          "side:bath-screen"
        ],
        "any": [],
        "none": [
          "side:sluice-flushed"
        ]
      },
      "at": {
        "beat:middle-market-cold-bath": "The cloth screen shelters a working treatment entrance. Patients can come without crossing the crowd.",
        "beat:reeves-court": "The treatment entrance remains a civilian service, whatever the accusation says."
      }
    },
    {
      "prerequisites": {
        "all": [
          "side:route-sold"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "A toll collector waits at the bath drain. The small shoes have gone.",
        "z04-gate-of-accounts": "A collector checks travellers against the route drawing you sold.",
        "beat:reeves-court": "Your paid route drawing hangs beside the collection schedule."
      }
    },
    {
      "prerequisites": {
        "all": [
          "side:sluice-flushed"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Wet bedding hangs across the bath doorway. The patients and the families wait outside together.",
        "beat:reeves-court": "A damaged walkway has been added to the district’s repair list."
      }
    },
    {
      "prerequisites": {
        "all": [
          "side:urn-returned"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Nessa has a collection cord tied to her wrist. This time she can put a name to what she is going to collect.",
        "beat:reeves-court": "Nessa’s mother is listed as identified for collection, with Nessa as the witness."
      }
    },
    {
      "prerequisites": {
        "all": [
          "side:family-copies"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Families bring their own burial copies to the stalls. There are too many to lose in one office.",
        "beat:reeves-court": "The official must answer to the copies already delivered outside the court."
      }
    },
    {
      "prerequisites": {
        "all": [
          "side:kitchen-promised"
        ],
        "any": [],
        "none": [
          "side:kitchen-paid"
        ]
      },
      "at": {
        "beat:middle-market-cold-bath": "Six kitchen portions are promised against your name. The keeper has kept the receipt.",
        "beat:reeves-court": "Your six-cut kitchen guarantee remains in the unpaid column."
      }
    },
    {
      "prerequisites": {
        "all": [
          "side:kitchen-paid"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Covered bowls leave the kitchen. Your guarantee is crossed through.",
        "beat:reeves-court": "The kitchen receipt is marked paid; the empty place at the table proves nothing either way."
      }
    },
    {
      "prerequisites": {
        "all": [
          "side:urn-returned"
        ],
        "any": [],
        "none": []
      },
      "outcomes": [
        "public-dismantling",
        "workers-shutdown",
        "private-containment",
        "violent-destruction"
      ],
      "at": {
        "z04-gate-of-accounts": "Nessa compares each handover with the family’s own cord."
      }
    },
    {
      "prerequisites": {
        "all": [
          "side:urn-returned"
        ],
        "any": [],
        "none": []
      },
      "outcomes": [
        "licensed-atrocity",
        "departure-failure"
      ],
      "at": {
        "z04-gate-of-accounts": "Nessa waits outside with her collection cord. Having the right name has not made the concession answer."
      }
    },
    {
      "prerequisites": {
        "all": [
          "side:family-copies"
        ],
        "any": [],
        "none": []
      },
      "outcomes": [
        "public-dismantling",
        "workers-shutdown",
        "private-containment",
        "violent-destruction"
      ],
      "at": {
        "z04-gate-of-accounts": "The families hold their own copies beside the receiving desk."
      }
    },
    {
      "prerequisites": {
        "all": [
          "side:family-copies"
        ],
        "any": [],
        "none": []
      },
      "outcomes": [
        "licensed-atrocity",
        "departure-failure"
      ],
      "at": {
        "z04-gate-of-accounts": "The families keep their delivered copies out of the concession guard’s reach."
      }
    },
    {
      "prerequisites": {
        "all": [
          "side:salt-delivered"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "The bath’s prepaid salt is back on its shelf. Melian has removed one cut from the posted price."
      }
    },
    {
      "prerequisites": {
        "all": [
          "fact:outcome-departure-failure"
        ],
        "any": [],
        "none": [
          "fact:kiln-access"
        ]
      },
      "at": {
        "z04-gate-of-accounts": "The guards turn you away from the work floors. A path outside the wall leads to shelter at the Dry Cut; you need no concession pass to walk it."
      }
    },
    {
      "prerequisites": {
        "all": [
          "z01:docket-returned",
          "z01:households-restored"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down the towpath with the barges: in Caldris, eleven struck households are back on the bread register because of the flood register you read. Eleven honest debtors there wait a season longer."
      },
      "source": "Z01"
    },
    {
      "prerequisites": {
        "all": [
          "z01:docket-returned",
          "z01:bonds-void",
          "z01:register-standing"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down the towpath with the barges: the Senate court in Caldris voided eleven bonds on your evidence, and your docket was still sealed as the register stood. The court was right, and the same names wait for bread."
      },
      "source": "Z01"
    },
    {
      "prerequisites": {
        "all": [
          "z01:docket-returned",
          "z01:claimant-declared"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down the towpath with the barges: the struck households of Caldris eat from Liria Castel’s granary, and the Senate’s clerks have written your name beside hers."
      },
      "source": "Z01"
    },
    {
      "prerequisites": {
        "all": [
          "z01:docket-returned",
          "z01:bond-bought"
        ],
        "any": [],
        "none": [
          "z01:claimant-declared"
        ]
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down the towpath with the barges: the Senth household in Caldris eats, because you bought its bond and tore it up. The advocate holds ninety-five more."
      },
      "source": "Z01"
    },
    {
      "prerequisites": {
        "all": [
          "z01:docket-returned",
          "z01:register-standing"
        ],
        "any": [],
        "none": [
          "z01:bonds-void",
          "z01:claimant-declared",
          "z01:bond-bought"
        ]
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down the towpath with the barges: your docket was sealed in Caldris as the register stood. Sixty-one households there stay struck."
      },
      "source": "Z01"
    },
    {
      "prerequisites": {
        "all": [
          "z01:docket-returned",
          "z01:runner-beaten"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "In Caldris they say an outsider killed the advocate’s runner on the archive stair. The advocate has filed a complaint against a person unknown."
      },
      "source": "Z01"
    },
    {
      "prerequisites": {
        "all": [
          "errand:z02:done",
          "errand:z02:concession"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes up the canal with the salt barges: the relief grain from Nacre Quay is on its way, and the Salt Compact holds the Lower Landing’s berths for twenty years on your signature. A Compact clerk is already measuring them.",
        "beat:reeves-court": "The Compact’s lease on the Lower Landing’s berths is pinned beside the court’s own schedule, signed in the court’s name for twenty years."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "errand:z02:done",
          "errand:z02:guarantee-witness"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes up the canal with the salt barges: the sale court at Nacre Quay redeemed the court’s notes on a bonded ropemaker’s word, and the Convener honoured the fleet’s guarantee in front of the whole harbour."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "errand:z02:done",
          "errand:z02:dead-testimony"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes up the canal with the salt barges: Nacre’s sale court redeemed the court’s notes on a drowned pilot’s oath, read aloud by Ildren Vos. The court there takes the word of the dead now."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "errand:z02:done",
          "errand:z02:grain-hull"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes up the canal with the salt barges: a whole hull of relief grain for the Silt Stair, emptied without a guarantee, and three more hulls sailed home to Namar full. They say Nacre will be hungry this winter."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "errand:z02:done",
          "z02:gangway-cleared"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "At Nacre Quay they say an outsider killed the broker’s hook-hand on the timber pier."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "past:errand:z02:concession"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:reeves-court": "The Compact’s lease on the Lower Landing’s berths is still pinned beside the court’s schedule, signed in the court’s name by an earlier traveller: twenty years."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "past:errand:z02:grain-hull"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "The salt barges from Nacre come up light this season. The coast remembers a relief fleet that went home full."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "errand:z06:done",
          "errand:z06:toll"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down with the lime carts: the court’s lime crossed the Broken Causeway at the Salt Compact’s toll, like anyone’s. The last arch there still has no keystone."
      },
      "source": "Z06"
    },
    {
      "prerequisites": {
        "all": [
          "errand:z06:done",
          "errand:z06:countersign"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down with the lime carts: the court’s lime crossed the Broken Causeway free, on the Silt Stair’s seal under a drowned notary’s oaths. The gang’s bonds stand on the court’s word now."
      },
      "source": "Z06"
    },
    {
      "prerequisites": {
        "all": [
          "errand:z06:done",
          "errand:z06:lease"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down with the lime carts: the Silt Stair court is a party to the Salt Compact’s causeway lease now. Its carts cross free, and it owes a share of the levy every season the last arch stands open. The arch stands open."
      },
      "source": "Z06"
    },
    {
      "prerequisites": {
        "all": [
          "errand:z06:done",
          "errand:z06:repair"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down with the lime carts: the Broken Causeway is whole. The Compact’s lease ended with the keystone you paid for, and the chain is down for everyone. The bonded gang that built the arch has gone up the quarry road to Dovren."
      },
      "source": "Z06"
    },
    {
      "prerequisites": {
        "all": [
          "errand:z06:done",
          "errand:z06:ford"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down with the lime carts: they came through the old ford below the Broken Causeway, and thirty-one people from the travellers’ camp waded over behind them without paying. The Compact has fined the ford guide."
      },
      "source": "Z06"
    },
    {
      "prerequisites": {
        "all": [
          "errand:z06:done",
          "errand:z06:force"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down with the lime carts: an outsider killed a Salt Compact lease guard at the Broken Causeway’s chain and drove the court’s carts through. The Compact has asked the court for the guard’s blood-price. The court says it sent a letter, not a blade."
      },
      "source": "Z06"
    },
    {
      "prerequisites": {
        "all": [
          "errand:z06:done",
          "errand:z06:coffins"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "The lime carters talk at the landing: at the Broken Causeway a covered wagon crossed west under the court’s letter, and the factor never lifted its canvas. One carter swears he saw a wax tag on a coffin rope, marked testimony."
      },
      "source": "Z06"
    },
    {
      "prerequisites": {
        "all": [
          "errand:z06:done",
          "errand:z06:report"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Word comes down with the lime carts: at the Broken Causeway, six bodies going west as testimony were taken off a carter’s wagon and buried by the boundary stone. The court’s carts crossed on the Salt Compact’s thanks."
      },
      "source": "Z06"
    },
    {
      "prerequisites": {
        "all": [
          "legacy:refused:kitchen"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "The bath kitchen still pins an earlier traveller’s receipt by the pot: six cuts, unpaid."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:took:odel"
        ],
        "any": [],
        "none": [
          "fact:workers-protected"
        ]
      },
      "at": {
        "z04-gate-of-accounts": "Odel stands by the creditor list with his sister’s name still on it. He tells anyone who will listen that two outsiders owe his crew now.",
        "beat:reeves-court": "Odel tells the clerk that two outsiders owe his crew now."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:took:odel",
          "fact:workers-protected"
        ],
        "any": [],
        "none": [
          "legacy:survivor-killed"
        ]
      },
      "at": {
        "z04-gate-of-accounts": "Odel’s sister stands in the receiving yard. The earlier traveller stands a little behind her and does not come closer."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:refused:odel"
        ],
        "any": [],
        "none": [
          "fact:workers-protected"
        ]
      },
      "at": {
        "z04-gate-of-accounts": "Odel’s sister’s name is still on the creditor list by the gate."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:took:pouch"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "The porters’ handcart is unchained. Someone paid back part of a pouch an outsider took."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:refused:pouch"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "The porters keep their handcart chained against outsiders. They have not forgotten the pouch."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:took:false-report"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Nessa’s porters eat on the landing. She tells anyone who asks that two outsiders paid for it."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:refused:false-report"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "Nessa has pinned the false cargo entry beside the coffin rack, where every outsider will see it."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:took:fire"
        ],
        "any": [],
        "none": [
          "legacy:survivor-killed"
        ]
      },
      "at": {
        "z04-gate-of-accounts": "The earlier traveller stands at the gate and reads the station names aloud. None of them is ash."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:refused:fire"
        ],
        "any": [],
        "none": [
          "legacy:survivor-killed"
        ]
      },
      "at": {
        "z04-gate-of-accounts": "The earlier traveller will not come near the gate. They say it still smells of the last fire."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:took:toll"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:reeves-court": "The porters’ toll refund is entered in the court book, paid by an outsider for an outsider."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:refused:toll"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:reeves-court": "The second toll is struck from the schedule. Nobody pays back what it took."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:took:lamp"
        ],
        "any": [],
        "none": [
          "legacy:survivor-killed",
          "world:survivor-with-you"
        ]
      },
      "at": {
        "z04-gate-of-accounts": "A lamp burns under the nine names. The earlier traveller keeps it trimmed."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:took:lamp",
          "world:survivor-with-you"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "z04-gate-of-accounts": "A lamp burns under the nine names. The earlier traveller who helped pay for its oil walks on with you."
      }
    },
    {
      "prerequisites": {
        "all": [
          "legacy:refused:lamp"
        ],
        "any": [],
        "none": [
          "legacy:survivor-killed",
          "world:survivor-with-you"
        ]
      },
      "at": {
        "z04-gate-of-accounts": "The nine names hang in the dark. The earlier traveller stands under them anyway."
      }
    },
    {
      "prerequisites": {
        "all": [
          "continuation:disgraced-legionary:held"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From Caldris: three men of the Fourth Cohort stand the forum watch under their own names now, first in line for the arrears."
      },
      "source": "Z01"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:disgraced-legionary:open"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From Caldris: a Fourth Cohort man stands the bridge watch as Kaeso of the bridge. The army’s books still call his unit deserters."
      },
      "source": "Z01"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:fallen-household:held"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From Caldris: the dyer’s heirs draw bread again from a quit-rent your family pays, and the register says why."
      },
      "source": "Z01"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:fallen-household:open"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From Caldris: beside the dyer’s heirs on the struck list, a clerk has written how your family came by their house."
      },
      "source": "Z01"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:unpaid-sellsword:held"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From Nacre Quay: a dead contractor’s last hull was sold, and your countersigned tally was paid from it after the porters’ wages."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:unpaid-sellsword:open"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From Nacre Quay: the crews’ wage fund holds a claim on a dead contractor’s estate that an outsider signed over to them."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:escaped-worker:held"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From Nacre Quay: the bonded ropemakers are tracing their bonds through every office at once, the way an outsider showed them."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:escaped-worker:open"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From Nacre Quay: the ropemakers watch the factors’ ledgers for an outsider’s name, on sale copies nobody struck."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:hedge-binder:held"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From Nacre Quay: binders on the coast work from Corren’s notebook openly again, and fewer families bring their dead to the reading tables."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:hedge-binder:open"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From Nacre Quay: a salvage tag passes from hand to hand at the bonded warehouse, with Corren’s washes written on the back."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:grave-witness:held"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From Nacre Quay: among the harbour shrine’s cords hangs one for Theron, with a copper cut through it for a grave."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:grave-witness:open"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From Nacre Quay: a plain cord for Theron hangs at the harbour shrine among the sea’s unburied."
      },
      "source": "Z02"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:serekh-exile:held"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From the Broken Causeway: a blue strip hangs on the ford pole, for a Serekh woman and two children with good papers and no toll money."
      },
      "source": "Z06"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:serekh-exile:open"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From the Broken Causeway: the ford guide will take a Serekh family across without papers, if they ever get that far."
      },
      "source": "Z06"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:intelligence-runner:held"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From the Broken Causeway: your former patron’s last offer reached you eight days too late, and went unanswered."
      },
      "source": "Z06"
    },
    {
      "prerequisites": {
        "all": [
          "continuation:intelligence-runner:open"
        ],
        "any": [],
        "none": []
      },
      "at": {
        "beat:middle-market-cold-bath": "From Caldris: the public archive files an outsider’s sworn account beside the deposition copy that everyone reads."
      },
      "source": "Z06"
    }
  ],
  "remembered": [
    {
      "fact": "finale:n03:lost",
      "last": true,
      "survivor": "I carried a case up to Caldris once and let a woman with two fingers raised tell the court they meant granary. Nobody answered her. I was standing right there."
    },
    {
      "fact": "finale:n03:bought",
      "last": true,
      "survivor": "I paid an advocate in Caldris to withdraw a claim once, a claim built on a dead porter’s hand. The granary stayed. So did the reading. I bought one season."
    },
    {
      "fact": "finale:n03:struck",
      "last": true,
      "survivor": "I stood in the basilica at Caldris once while a porter’s friend told the court what a dead man’s fingers meant. They struck the reading. I have never heard a court go so quiet."
    },
    {
      "fact": "finale:kind",
      "last": true,
      "survivor": "I left the Silt Stair once without anyone buying a dead man’s word on my account. An advocate’s clerk came down the towpath asking. There was nothing to find."
    },
    {
      "fact": "finale:containment:kept",
      "last": true,
      "survivor": "I told the Silt Stair’s court to keep its grain once, and the landing ate that winter. Caldris wrote to say we owed it. We did."
    },
    {
      "fact": "finale:containment:sent",
      "last": true,
      "survivor": "I told the Silt Stair’s court to send its grain upriver once, as promised. Caldris ate. The landing queued. I would do it again, and I would not enjoy it."
    },
    {
      "fact": "side:toll-struck"
    },
    {
      "fact": "z01:runner-beaten",
      "survivor": "I went up the towpath to Caldris once and took a chest of bonds off a man on the archive stair. He was carried up on a door. Nobody there asked me who he was."
    },
    {
      "fact": "z01:claimant-declared",
      "survivor": "I went up the towpath to Caldris once and stood at the claimant’s dais so she would feed the struck households. They ate that night. I still do not know what I sold her."
    },
    {
      "fact": "z01:households-restored",
      "survivor": "I went up the towpath to Caldris once. Eleven households went back on the bread register because I read a flood register, and eleven others waited a season because of it."
    },
    {
      "fact": "z01:bonds-void",
      "survivor": "I went up the towpath to Caldris once and had eleven bonds voided in the Senate court. Then I let the docket be sealed as the register stood. The court was right, and nobody ate."
    },
    {
      "fact": "z01:bond-bought",
      "survivor": "I went up the towpath to Caldris once and bought one widow’s bond so I could tear it up. The advocate thanked me. He had ninety-five more."
    },
    {
      "fact": "pressure:z01:sealed-over-drowned",
      "survivor": "I had a grain docket sealed in Caldris once over households struck on drowned men’s oaths. I had read the flood register. I sealed it anyway."
    },
    {
      "fact": "z01:register-standing",
      "survivor": "I carried a grain docket to Caldris once and had it sealed as the register stood. It was lawful and quick. The queue was still there when I left."
    },
    {
      "fact": "errand:z02:dead-testimony",
      "survivor": "I went down the canal to Nacre Quay once and paid a woman to make a drowned pilot swear to a guarantee. The sale court wrote it down as his word. I still hear her reading it."
    },
    {
      "fact": "z02:gangway-cleared",
      "survivor": "I went down the canal to Nacre Quay once and killed a broker’s hook-hand on a gangway, over a hold full of grain that was not mine."
    },
    {
      "fact": "errand:z02:grain-hull",
      "survivor": "I went down the canal to Nacre Quay once and had a relief hull emptied onto the Silt Stair’s barges. Three more hulls sailed home full. Nacre went short that winter, and I let it."
    },
    {
      "fact": "errand:z02:concession",
      "survivor": "I carried the court’s notes to Nacre Quay once and signed our landing to the Salt Compact for twenty years to have them paid. It was quick. The Convener had the lease drawn before I arrived."
    },
    {
      "fact": "errand:z02:guarantee-witness",
      "survivor": "I went down the canal to Nacre Quay once and put a bonded ropemaker on the sale court’s platform to say what was sworn. The Convener honoured it in front of everyone. He did not forget my face."
    },
    {
      "fact": "z02:heddo-buried",
      "survivor": "I paid to bury a drowned pilot at Nacre Quay once, so nobody could make him swear to anything. It was the cheapest thing I did there."
    },
    {
      "fact": "z02:tide-record",
      "survivor": "I copied a tide almanac at the light on Nacre’s mole once. Every almanac ends on the same day, the keeper said, whichever port prints it. I have not found out why."
    },
    {
      "fact": "z06:guard-beaten",
      "survivor": "I went west over the Broken Causeway once and dropped the Salt Compact’s chain with a lease guard under it. The court’s lime came home. The guard did not."
    },
    {
      "fact": "z06:coffins-passed",
      "survivor": "I let a covered wagon cross the Broken Causeway under a court’s letter once, so its carter would pay my toll. I never asked who was waiting for it in the west."
    },
    {
      "fact": "z06:roll-countersigned",
      "survivor": "I put a court’s seal under a drowned notary’s oaths at the Broken Causeway once, so the lime could cross free. A mason’s bond stands on it still."
    },
    {
      "fact": "z06:lease-signed",
      "survivor": "I signed the Silt Stair court into the Salt Compact’s lease at the Broken Causeway once. It saved the court a toll that day. It has cost it every season since."
    },
    {
      "fact": "z06:travellers-across",
      "survivor": "I took the court’s carts through the old ford under the Broken Causeway once, and the whole travellers’ camp waded over behind me. The guide paid the fine. I never went back."
    },
    {
      "fact": "z06:arch-closed",
      "survivor": "I paid a gang to set the last keystone on the Broken Causeway once. The toll ended that day. The gang went up the quarry road the next."
    },
    {
      "fact": "z06:coffins-held",
      "survivor": "I lifted a carter’s canvas at the Broken Causeway once. Six people went into the ground there instead of going west to be asked questions."
    },
    {
      "fact": "z06:toll-paid",
      "survivor": "I carried the court’s letter to the Broken Causeway once and paid the Salt Compact’s toll, like anyone. It was the easiest thing I did in that life."
    }
  ],
  "encounters": {
    "n03-annex-doorman": {
      "foe": {
        "personId": "person:n03-annex-doorman",
        "name": "The advocate’s doorman",
        "maxHp": 8,
        "attackDamage": 2,
        "attackWindupTicks": 3,
        "movePerTick": 1000
      },
      "pc": {
        "attackDamage": 4
      },
      "won": "finale:ledger-seized",
      "ambush": true,
      "ground": "the burial annex under the basilica",
      "blocks": "The doorman blocks the annex grille.",
      "objective": "Survive the advocate’s doorman. He is light and quick, and he has never yet had to take a beating.",
      "preview": {
        "tell": "The doorman closes his fist around the grille. He is lightly armed and quick. Taking the book by force means fighting him in the narrow annex.",
        "alternative": "Leave the book for now and pursue the hearing with the evidence you already hold."
      }
    },
    "lock": {
      "foe": {
        "personId": "person:lock-thief",
        "name": "Lock thief",
        "movePerTick": 1200
      },
      "pc": {
        "attackDamage": 4
      },
      "won": "story:lock-defended",
      "ambush": true,
      "ground": "the lock walkway",
      "blocks": "The thief blocks the exit.",
      "objective": "Survive the lock thief. A thief wants the box, not a fight, and works round to whichever side you are not facing.",
      "preview": {
        "tell": "You are alone. A figure under the walkway watches the toll box, then checks the empty path behind you. Raising the water will bring the box within reach — and leave you trapped beside it.",
        "alternative": "Leave the box submerged, or return with company. Shoring the walkway gives up the box."
      }
    },
    "guard": {
      "foe": {
        "personId": "person:kiln-office-guard",
        "name": "Concession guard",
        "maxHp": 16,
        "attackDamage": 5,
        "attackWindupTicks": 4
      },
      "pc": {
        "attackDamage": 4
      },
      "won": "story:combat-won",
      "ground": "the kiln office",
      "blocks": "The guard blocks the exit.",
      "objective": "Survive the guard. He is trained: he mixes full swings with short cuts, and the full ones hurt.",
      "preview": {
        "tell": "The guard keeps a hand on his blade. There is room to fight in the doorway, but no room to pass him once you draw. His long swings carry weight; a shield or a well-timed spear can answer them.",
        "alternative": "Put the blade away. Evidence, witnesses and the people working here may settle the concession without a fight."
      }
    },
    "tunnel": {
      "foe": {
        "station": "station-firing-tunnels",
        "maxHp": 14,
        "movePerTick": 500,
        "attackDamage": 4,
        "attackWindupTicks": 4
      },
      "pc": {
        "attackDamage": 4
      },
      "won": "story:tunnel-defended",
      "ground": "the firing tunnels",
      "blocks": "The working body blocks the exit.",
      "objective": "Survive the working body. It winds up slowly, the way the dead do everything, and it does not tire.",
      "preview": {
        "tell": "The stoker turns each time you move towards its anchor. Getting close enough to trace the fitting will put you within its reach. Its movements are slow and heavy. It will not tire.",
        "alternative": "Leave the anchor for now. You can step back, change your equipment, or seek another way to stop the stations."
      }
    },
    "z01-runner": {
      "foe": {
        "personId": "person:z01-bond-runner",
        "name": "The advocate’s runner",
        "maxHp": 10,
        "attackDamage": 4,
        "attackWindupTicks": 7,
        "movePerTick": 1600
      },
      "pc": {
        "attackDamage": 4
      },
      "won": "z01:runner-beaten",
      "ambush": true,
      "ground": "the archive stair",
      "blocks": "The runner blocks the stair.",
      "objective": "Survive the advocate’s runner. He is quick on his feet, quicker than you, and he swings the cudgel all the way from the shoulder.",
      "preview": {
        "tell": "The runner plants his cudgel across the archive stair. He is quicker on his feet than you. His swing comes all the way from the shoulder; racing past him will leave your back open.",
        "alternative": "Leave the chests with him while you pursue the records and the court."
      }
    },
    "z02-hook-hand": {
      "foe": {
        "personId": "person:z02-hook-hand",
        "name": "The broker’s hook-hand",
        "maxHp": 16,
        "attackDamage": 3,
        "attackWindupTicks": 3,
        "movePerTick": 1000
      },
      "pc": {
        "attackDamage": 4
      },
      "won": "z02:gangway-cleared",
      "ambush": true,
      "ground": "the timber pier at Nacre Quay",
      "blocks": "The hook-hand blocks the gangway.",
      "objective": "Survive the broker’s hook-hand. Her swings are short and quick and never stop coming. Each is light, but they add up, and the hook reaches no further than her arm.",
      "preview": {
        "tell": "The broker’s hook-hand bars the gangway. She grips the hook close and makes short, quick jabs. Beyond her, the pier gives you little room to retreat.",
        "alternative": "Leave the gangway. The quay’s cargo and berth records offer other ways to press the claim."
      }
    },
    "z06-lease-guard": {
      "foe": {
        "personId": "person:z06-lease-guard",
        "name": "The lease guard",
        "maxHp": 14,
        "attackDamage": 5,
        "attackWindupTicks": 4,
        "movePerTick": 500
      },
      "second": {
        "personId": "person:z06-chainman",
        "name": "The factor’s chainman",
        "maxHp": 8,
        "attackDamage": 3,
        "attackWindupTicks": 3,
        "movePerTick": 1200
      },
      "pc": {
        "attackDamage": 4
      },
      "won": "z06:guard-beaten",
      "ambush": true,
      "ground": "the toll chain at the Broken Causeway",
      "blocks": "The lease guard stands over the chain.",
      "objective": "Survive the lease guard and the factor’s chainman. The guard’s club lands hard, but he is slow on his feet. The chainman is quick and light-handed, keeps to your side, and is paid too little to die for the chain.",
      "preview": {
        "tell": "Two people hold the chain. The guard carries a heavy club; the chainman keeps moving towards your flank. Drawing here means facing both of them.",
        "alternative": "Leave the chain up while you pursue the lease and the court’s authority."
      }
    },
    "survivor": {
      "foe": {
        "survivor": true,
        "attackDamage": 5,
        "attackWindupTicks": 3
      },
      "pc": {
        "attackDamage": 4
      },
      "won": "legacy:survivor-killed",
      "ambush": true,
      "ground": "the Dry Cut",
      "blocks": "The earlier traveller stands between you and the way out.",
      "objective": "Survive the earlier traveller. They crossed the whole basin with what they carry, and they know what it is for.",
      "preview": {
        "tell": "The earlier traveller watches your hand move towards your weapon. They survived these roads once. Drawing on them turns a living person from your past into an enemy; their death will be permanent.",
        "alternative": "Keep talking, refuse their terms, or leave. You owe them no fight."
      }
    }
  },
  "pressure": {
    "threshold": 4,
    "fact": "convergence:n03",
    "weights": {
      "pressure:z01:advocate-paid": 2,
      "pressure:z02:dead-testimony": 2,
      "pressure:z06:coffins-uninspected": 2,
      "pressure:z01:sealed-over-drowned": 2,
      "pressure:z06:roll-countersigned": 2
    }
  },
  "endings": [
    {
      "fact": "finale:n03:struck",
      "name": "A Living Witness"
    },
    {
      "fact": "finale:n03:bought",
      "name": "A Season Bought"
    },
    {
      "fact": "finale:n03:lost",
      "name": "The Dead Man’s Word"
    },
    {
      "fact": "finale:kind",
      "name": "Nothing for the Dead to Say"
    },
    {
      "fact": "finale:containment",
      "name": "Kept Out of Court"
    }
  ],
  "version": 1,
  "start": "beat:lower-landing",
  "beats": [
    {
      "id": "beat:lower-landing",
      "name": "Lower Landing",
      "zone": "Z03",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "story:grain-settled"
            ],
            "any": [],
            "none": []
          },
          "text": "Sacks leave the grain barge now. The coffin stays where it was. Nessa holds a form against the wind.",
          "survives": [
            "coffin",
            "seal-rubbing",
            "legacy-record",
            "landing-return",
            "z02-fare",
            "z02-fare-work",
            "mystery-book",
            "mystery-dead"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "story:grain-settled"
            ]
          },
          "text": "A closed coffin waits beside the grain nobody will unload. Nessa holds a form against the wind.",
          "survives": [
            "coffin",
            "seal-rubbing",
            "legacy-record",
            "landing-return",
            "z02-fare",
            "z02-fare-work",
            "mystery-book",
            "mystery-dead"
          ]
        }
      ],
      "exits": [
        "beat:toll-stair"
      ]
    },
    {
      "id": "beat:toll-stair",
      "name": "Toll Stair",
      "zone": "Z03",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "side:porter-toll-ended"
            ],
            "any": [],
            "none": []
          },
          "text": "The porters climb past the toll post without stopping. The guard still weighs everyone else’s bread before he takes their coin. A workers’ stair runs behind the post.",
          "survives": [
            "toll-memory"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:side:toll-struck"
            ],
            "any": [],
            "none": [
              "side:porter-toll-ended"
            ]
          },
          "text": "A fresh copy of the toll schedule is nailed to the post, the second charge written back in. The toll guard weighs the bread in a porter’s hand before accepting his coin. A workers’ stair runs behind the post.",
          "survives": [
            "toll-memory"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "side:porter-toll-ended"
            ]
          },
          "text": "The toll guard weighs the bread in a porter’s hand before accepting his coin. A workers’ stair runs behind the post.",
          "survives": [
            "toll-memory"
          ]
        }
      ],
      "exits": [
        "beat:lower-landing",
        "beat:middle-market-cold-bath"
      ]
    },
    {
      "id": "beat:middle-market-cold-bath",
      "name": "Market and Cold Bath",
      "zone": "Z03",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "side:sluice-flushed"
            ],
            "any": [],
            "none": []
          },
          "text": "Wet bedding hangs across the bath doorway. Melian treats a cracked hand outside it, beside stalls with more prices than goods."
        },
        {
          "prerequisites": {
            "all": [
              "side:bath-screen"
            ],
            "any": [],
            "none": [
              "side:sluice-flushed"
            ]
          },
          "text": "A cloth screen shelters the bath’s side entrance. Melian treats a cracked hand behind it, beside stalls with more prices than goods.",
          "survives": [
            "drain",
            "drain-discretion",
            "kitchen-pay"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "melian:accused"
            ],
            "any": [],
            "none": [
              "side:sluice-flushed",
              "side:bath-screen"
            ]
          },
          "text": "The bath shutter is closed. Melian treats a cracked hand in the doorway, beside stalls with more prices than goods.",
          "survives": [
            "drain",
            "drain-discretion",
            "kitchen-pay"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "side:sluice-flushed",
              "side:bath-screen",
              "melian:accused"
            ]
          },
          "text": "The bath is cold. Melian treats a cracked hand beside stalls with more prices than goods.",
          "survives": [
            "drain",
            "drain-discretion",
            "kitchen-pay"
          ]
        }
      ],
      "exits": [
        "beat:toll-stair",
        "beat:lift-yard"
      ]
    },
    {
      "id": "beat:lift-yard",
      "name": "Lift Yard",
      "zone": "Z03",
      "lines": [
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "story:grain-settled"
            ]
          },
          "text": "A bright pin sits in a cracked bearing. A boy sweeps spilled grain into a sack already marked as paid.",
          "survives": [
            "tally",
            "bearing",
            "tally-shelter",
            "arrears-return"
          ]
        }
      ],
      "exits": [
        "beat:middle-market-cold-bath",
        "beat:reeves-court",
        "beat:eastern-road-lock-foot"
      ]
    },
    {
      "id": "beat:reeves-court",
      "name": "Reeve’s Court",
      "zone": "Z03",
      "lines": [
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "The official has cleared a space for your evidence. The repair requisition occupies the rest of the desk."
        }
      ],
      "exits": [
        "beat:lift-yard",
        "beat:eastern-road-lock-foot"
      ]
    },
    {
      "id": "beat:eastern-road-lock-foot",
      "name": "Eastern Road and Lock Foot",
      "zone": "Z03",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "side:sluice-flushed"
            ],
            "any": [],
            "none": []
          },
          "text": "Nine kilometres of funeral road lead to the kilns. Below it, the sluice pawl sits above its red mark, and the walkway plank hangs torn from its seating.",
          "survives": [
            "road-pawl",
            "depart"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Nine kilometres of funeral road lead to the kilns. Below it, the sluice pawl stands dry over its marked water line.",
          "survives": [
            "road-pawl",
            "lock-shore",
            "depart"
          ]
        }
      ],
      "exits": [
        "beat:reeves-court",
        "beat:lift-yard",
        "z04-gate-of-accounts"
      ]
    },
    {
      "id": "z04-gate-of-accounts",
      "name": "Gate of Accounts",
      "zone": "Z04",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "world:guard-dead"
            ],
            "any": [],
            "none": []
          },
          "text": "The gate lists burial prices and returned tokens. The guard’s stool stands empty; nobody has been sent to fill it.",
          "survives": [
            "family-fee"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z04:contract-gallery"
            ],
            "any": [],
            "none": [
              "world:guard-dead"
            ]
          },
          "text": "The gate lists burial prices and returned tokens. A new notice is nailed over the old one: the concession has reopened the lower gallery under a Senate contract, and buys the unclaimed dead by the body. The guard wears the Senate’s stapled bronze ring.",
          "survives": [
            "family-fee"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z04:contract-vault"
            ],
            "any": [],
            "none": [
              "world:guard-dead"
            ]
          },
          "text": "The gate lists burial prices and returned tokens. A new notice is nailed over the old one: the columbarium vault works again under a Compact contract, and old niches are to be cleared for resale. The guard wears the Compact’s sail and weight.",
          "survives": [
            "family-fee"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z04:contract-firing"
            ],
            "any": [],
            "none": [
              "world:guard-dead"
            ]
          },
          "text": "The gate lists burial prices and returned tokens. A new notice is nailed over the old one: the firing tunnels are lit again under a contract with the Standard, which wants lime for its walls. The guard wears the Standard’s dented sun-disc.",
          "survives": [
            "family-fee"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "world:guard-dead"
            ]
          },
          "text": "The gate lists burial prices and returned tokens. The guard wears the concession’s patron’s mark.",
          "survives": [
            "family-fee"
          ]
        }
      ],
      "exits": [
        "beat:eastern-road-lock-foot",
        "z04-cooling-court",
        "z04-cart-ramp-office"
      ]
    },
    {
      "id": "z04-cooling-court",
      "name": "Cooling Court",
      "zone": "Z04",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "fact:resolution-chosen"
            ],
            "any": [],
            "none": [
              "fact:outcome-licensed-atrocity",
              "fact:outcome-departure-failure"
            ]
          },
          "text": "The family still waits beneath the urn shelves. ‘Already gone home’ is struck from their receipt. Leth An’s name is written under it in a clerk’s hand."
        },
        {
          "prerequisites": {
            "all": [
              "fact:resolution-chosen"
            ],
            "any": [
              "fact:outcome-licensed-atrocity",
              "fact:outcome-departure-failure"
            ],
            "none": []
          },
          "text": "The family still waits beneath the empty urn shelves. Nobody has corrected their receipt."
        },
        {
          "prerequisites": {
            "all": [
              "side:urn-identified"
            ],
            "any": [],
            "none": [
              "fact:resolution-chosen"
            ]
          },
          "text": "The family waits beneath the urn shelves with a collection cord. Beside them, Nessa’s mother’s urn has been lifted down and wrapped for travel.",
          "survives": [
            "vault-working"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "side:family-admitted"
            ],
            "any": [],
            "none": [
              "fact:resolution-chosen",
              "side:urn-identified"
            ]
          },
          "text": "The family waits beneath the urn shelves with a collection cord. The mother keeps the first receipt folded behind the new one.",
          "survives": [
            "token",
            "vault-working"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "done:token"
            ],
            "any": [],
            "none": [
              "fact:resolution-chosen",
              "side:family-admitted"
            ]
          },
          "text": "The family waits beneath empty urn shelves. Their token matches Leth An’s entry. Their receipt still says they have already gone home.",
          "survives": [
            "vault-working"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "fact:resolution-chosen",
              "done:token",
              "side:family-admitted"
            ]
          },
          "text": "A family waits beneath empty urn shelves. Their receipt says they have already gone home.",
          "survives": [
            "vault-working"
          ]
        }
      ],
      "exits": [
        "z04-gate-of-accounts",
        "z04-lower-work-gallery"
      ]
    },
    {
      "id": "z04-lower-work-gallery",
      "name": "Lower Work Gallery",
      "zone": "Z04",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z04:contract-gallery",
              "z04:claim-paid"
            ],
            "any": [],
            "none": []
          },
          "text": "A fresh notice is nailed to the tally stand: the gallery works again under a Senate contract, on dead bought from the unclaimed shelves. One body lifts two fingers, counts nothing, and lowers them. A claim tag hangs on the door where tonight’s cart from the landing would have unloaded.",
          "survives": [
            "gallery",
            "tether-gallery"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z04:contract-gallery",
              "z04:claim-left"
            ],
            "any": [],
            "none": []
          },
          "text": "A fresh notice is nailed to the tally stand: the gallery works again under a Senate contract, on dead bought from the unclaimed shelves. One body lifts two fingers, counts nothing, and lowers them. By the door a long bundle waits for tonight’s shift, a porter’s stair-strap still buckled round it.",
          "survives": [
            "gallery",
            "tether-gallery"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "legacy:work-reopened"
            ],
            "any": [],
            "none": []
          },
          "text": "A fresh notice is nailed to the tally stand: the concession has reopened the gallery under a new contract and bought its dead from the unclaimed shelves. One body lifts two fingers, counts nothing, and lowers them.",
          "survives": [
            "gallery",
            "tether-gallery"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "legacy:work-reopened"
            ]
          },
          "text": "Leth An’s body lifts two fingers, counts nothing, and lowers them. The tally slab is gone from its stand; the counting goes on over bare stone.",
          "survives": [
            "gallery",
            "tether-gallery"
          ]
        }
      ],
      "exits": [
        "z04-cooling-court",
        "z04-selas-rooms",
        "z04-dry-cut"
      ]
    },
    {
      "id": "z04-selas-rooms",
      "name": "Sela’s Preparation Rooms",
      "zone": "Z04",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "fact:records-secured"
            ],
            "any": [],
            "none": []
          },
          "text": "Two bodies lie unfinished. The table where the station ledgers lay is bare."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "fact:records-secured"
            ]
          },
          "text": "Two bodies lie unfinished. On another table, three ledgers count the others by output."
        }
      ],
      "exits": [
        "z04-lower-work-gallery",
        "z04-cart-ramp-office",
        "z04-dry-cut"
      ]
    },
    {
      "id": "z04-cart-ramp-office",
      "name": "Cart Ramp and Office",
      "zone": "Z04",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z04:contract-firing",
              "z04:lime-carried"
            ],
            "any": [],
            "none": []
          },
          "text": "A cart stands under a loading beam, piled with the Standard’s lime. Two porters from the landing stack the sacks at the tunnel mouth and do not look inside. Noll’s desk is positioned so that visitors must face the door.",
          "survives": [
            "intercept",
            "prepare",
            "tether-firing",
            "driver-pay",
            "careful-end",
            "reckless-end",
            "personal-record",
            "firing-working"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z04:contract-firing",
              "z04:lime-refused"
            ],
            "any": [],
            "none": []
          },
          "text": "A cart stands under a loading beam. The Standard’s lime lies in a split heap where the barge crew tipped it; no porter came up to carry it. Noll’s desk is positioned so that visitors must face the door.",
          "survives": [
            "intercept",
            "prepare",
            "tether-firing",
            "driver-pay",
            "careful-end",
            "reckless-end",
            "personal-record",
            "firing-working"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "A cart stands under a loading beam. Noll’s desk is positioned so that visitors must face the door.",
          "survives": [
            "intercept",
            "prepare",
            "tether-firing",
            "driver-pay",
            "careful-end",
            "reckless-end",
            "personal-record",
            "firing-working"
          ]
        }
      ],
      "exits": [
        "z04-selas-rooms",
        "z04-gate-of-accounts"
      ]
    },
    {
      "id": "z04-dry-cut",
      "name": "The Dry Cut",
      "zone": "Z04",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "finale:departed"
            ],
            "any": [],
            "none": []
          },
          "text": "Your footprints go on past the staple, into the dust of the cut, and do not come back.",
          "survives": [
            "mystery-staple"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "campaign:B5"
            ],
            "any": [],
            "none": []
          },
          "text": "The cut runs on past the staple, narrow and dry, climbing west out of the basin. For the first time it looks like a road.",
          "survives": [
            "mystery-staple"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "fact:outcome-departure-failure"
            ],
            "any": [],
            "none": [
              "fact:kiln-access"
            ]
          },
          "text": "The path from the gate follows the outside of the kiln wall to this sheltered cut. A repair staple sits inside old, unbroken mortar. The pale stone beneath it is cold. No tether reaches this far.",
          "survives": [
            "mystery-staple"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "A repair staple sits inside old, unbroken mortar. The pale stone beneath it is cold. No tether reaches this far.",
          "survives": [
            "mystery-staple"
          ]
        }
      ],
      "exits": [
        "z04-lower-work-gallery",
        "z04-selas-rooms"
      ]
    },
    {
      "id": "beat:z01-river-bridge",
      "name": "River Bridge",
      "zone": "Z01",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z01:docket-sealed"
            ],
            "any": [],
            "none": []
          },
          "text": "Barges for the Silt Stair are loading at the landing. The chain is down between the stone lions, and your sealed docket is the one paper on this bridge nobody is arguing over."
        },
        {
          "prerequisites": {
            "all": [
              "z01:holder-brz"
            ],
            "any": [],
            "none": []
          },
          "text": "The bridge carries the grain road over the Orsen into Caldris. At the landing below, the Standard’s pickets count every sack off the barges and chalk each count on a board. A chain hangs between the stone lions, down for now."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "The bridge carries the grain road over the Orsen into Caldris. At the landing below, the forum watch counts every sack off the barges, then counts it again. A chain hangs between the stone lions, down for now."
        }
      ],
      "exits": [
        "beat:z01-grain-court"
      ]
    },
    {
      "id": "beat:z01-grain-court",
      "name": "Grain Court",
      "zone": "Z01",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z01:households-restored"
            ],
            "any": [],
            "none": []
          },
          "text": "The clerk reads the restored names aloud at the register tables. Part of the queue cheers. The rest of it goes very quiet."
        },
        {
          "prerequisites": {
            "all": [
              "z01:claimant-declared"
            ],
            "any": [],
            "none": []
          },
          "text": "A cart from the claimant’s granary stands at the far end of the queue under ochre cloth. The struck households are fed there, where every clerk at the register tables can see."
        },
        {
          "prerequisites": {
            "all": [
              "past:z01:claimant-declared"
            ],
            "any": [],
            "none": []
          },
          "text": "Clerks call names from wax tablets at the register tables, and the measures are smaller than the sacks. At the far end of the queue, a cart under ochre cloth hands out the claimant’s bread, as it has since an earlier traveller stood at her dais."
        },
        {
          "prerequisites": {
            "all": [
              "past:z01:households-restored"
            ],
            "any": [],
            "none": []
          },
          "text": "Clerks call names from wax tablets at the register tables. Near the top of the list, eleven names are written in fresh ink; an earlier traveller had them read first. The queue behind them has been standing since dawn."
        },
        {
          "prerequisites": {
            "all": [
              "z01:holder-brz"
            ],
            "any": [],
            "none": []
          },
          "text": "Soldiers of the Standard hold the rope at the register tables. Clerks still call names from wax tablets; a depot officer checks each name against a ration chit. The measures on the table are smaller than the sacks."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Clerks call names from wax tablets at the register tables. The measures on the table are smaller than the sacks. A rope keeps the queue from the grain, and the queue has been standing since dawn."
        }
      ],
      "exits": [
        "beat:z01-river-bridge",
        "beat:z01-basilica"
      ]
    },
    {
      "id": "beat:z01-basilica",
      "name": "Senate Basilica",
      "zone": "Z01",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "finale:n03:struck"
            ],
            "any": [],
            "none": []
          },
          "text": "The court has risen. On the old stone dais the reading clerk has drawn a line through Leth An’s reading. Ildren Vos’s trestle is gone from the floor."
        },
        {
          "prerequisites": {
            "all": [
              "finale:n03:bought"
            ],
            "any": [],
            "none": []
          },
          "text": "The court has risen early. Vasko’s claim is struck from the day’s list in his own hand. Leth An’s reading is still on the roll beside it."
        },
        {
          "prerequisites": {
            "all": [
              "finale:n03:lost"
            ],
            "any": [],
            "none": []
          },
          "text": "The court has risen. The reading clerk is copying the finding on the Silt Stair’s granary into the public roll, and Vasko stands close enough to read it."
        },
        {
          "prerequisites": {
            "all": [
              "finale:court-sat"
            ],
            "any": [],
            "none": [
              "campaign:B5"
            ]
          },
          "text": "The Senate court is sitting for Vasko’s claim. On Ildren Vos’s trestle lies Leth An’s count, drawn in wax. The reading clerk waits, stylus up, for the Silt Stair’s answer."
        },
        {
          "prerequisites": {
            "all": [
              "finale:hearing"
            ],
            "any": [],
            "none": [
              "campaign:B5"
            ]
          },
          "text": "The benches are full for Vasko’s claim. Before the old stone dais Ildren Vos has set a single trestle, with nothing on it yet. On the timber dais, the claimant’s clerk sharpens a stylus."
        },
        {
          "prerequisites": {
            "all": [
              "z01:bonds-void"
            ],
            "any": [],
            "none": []
          },
          "text": "The court has risen. On the old stone dais a clerk copies eleven voided bonds into the public roll. On the new timber dais, the claimant’s clerk copies them too."
        },
        {
          "prerequisites": {
            "all": [
              "z01:holder-brz"
            ],
            "any": [],
            "none": []
          },
          "text": "The Senate’s court sits on the old stone dais, benches ranked by office. The Standard’s sun-disc hangs over the second dais, and every finding from the old one waits for the depot officer’s countersign."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "The Senate’s court sits on the old stone dais, benches ranked by office. Across the floor stands a second dais of new timber and ochre cloth. The claimant sits there, and her clerk writes down everything the court says."
        }
      ],
      "exits": [
        "beat:z01-grain-court",
        "beat:z01-archive-stair"
      ]
    },
    {
      "id": "beat:z01-archive-stair",
      "name": "Archive Stair",
      "zone": "Z01",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "finale:ledger-seized"
            ],
            "any": [],
            "none": []
          },
          "text": "The annex door hangs open behind the grille. Vos’s trestles are overturned, and the advocate’s doorman lies where he fell."
        },
        {
          "prerequisites": {
            "all": [
              "finale:reading-watched"
            ],
            "any": [],
            "none": [
              "campaign:B5"
            ]
          },
          "text": "Behind the grille, in the burial annex, Vasko’s clerk and Ildren Vos go through the reading again: the question, two fingers, the answer."
        },
        {
          "prerequisites": {
            "all": [
              "finale:hearing"
            ],
            "any": [],
            "none": [
              "campaign:B5"
            ]
          },
          "text": "Lamplight shows behind the grille, in the burial annex. The advocate’s doorman stands in front of it, and inside someone is counting aloud.",
          "survives": [
            "n03-annex-seize"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:bond-list",
              "z01:witness-dated"
            ],
            "any": [],
            "none": []
          },
          "text": "The bond file lies open beside the flood register: two dates on two shelves, and a drowned man between them."
        },
        {
          "prerequisites": {
            "all": [
              "z01:bond-list"
            ],
            "any": [],
            "none": []
          },
          "text": "The bond file of the ninety-six lies open on the reading desk. Eleven of the bonds rest on sworn statements instead of signed debts, and the same four witnesses swore to all of them."
        },
        {
          "prerequisites": {
            "all": [
              "z01:witness-dated",
              "z01:runner-beaten"
            ],
            "any": [],
            "none": []
          },
          "text": "Blood on the lower steps where the runner fell. The flood register lies open at the winter the river came up the stair, and Aulo the carter is on it."
        },
        {
          "prerequisites": {
            "all": [
              "z01:witness-dated",
              "z01:chests-open"
            ],
            "any": [],
            "none": []
          },
          "text": "The flood register lies open at the winter the river came up the stair, and Aulo the carter is on it. The bond chests wait by the grille."
        },
        {
          "prerequisites": {
            "all": [
              "z01:witness-dated"
            ],
            "any": [],
            "none": []
          },
          "text": "The flood register lies open at the winter the river came up the stair, and Aulo the carter is on it. At the grille, the advocate’s runner is still loading bond chests.",
          "survives": [
            "z01-runner-fight",
            "z01-runner-ask"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:runner-beaten"
            ],
            "any": [],
            "none": []
          },
          "text": "Blood on the lower steps where the runner fell. The bond chests stand where he dropped them."
        },
        {
          "prerequisites": {
            "all": [
              "z01:runner-paid"
            ],
            "any": [],
            "none": []
          },
          "text": "The runner leans on his handcart, paid to study the ceiling while you read."
        },
        {
          "prerequisites": {
            "all": [
              "z01:chests-open"
            ],
            "any": [],
            "none": []
          },
          "text": "The runner has gone up the stair without his chests. Two watchmen stand at the grille, eating."
        },
        {
          "prerequisites": {
            "all": [
              "z01:runner-seen"
            ],
            "any": [],
            "none": []
          },
          "text": "At the grille, the advocate’s runner is loading bond chests onto a handcart. He means to have them up the stair before anyone reads them.",
          "survives": [
            "z01-runner-fight"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:z01:runner-beaten"
            ],
            "any": [],
            "none": []
          },
          "text": "Shelves climb the brick vaults above a pale flood line; nothing is kept below it. At the iron grille, a new runner loads chests onto a handcart with his cudgel already in his hand. The last one died on these steps."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Shelves climb the brick vaults above a pale flood line; nothing is kept below it. At the iron grille, a man is loading chests onto a handcart."
        }
      ],
      "exits": [
        "beat:z01-basilica"
      ]
    },
    {
      "id": "beat:z02-mole-berths",
      "name": "The Mole and Berths",
      "zone": "Z02",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "errand:z02:grain-hull"
            ],
            "any": [],
            "none": []
          },
          "text": "The timber pier is bare. The hull’s grain went up the canal on the Silt Stair’s barges, and the three Namar hulls weighed anchor at dawn with their holds still full. The crane stands empty over the water."
        },
        {
          "prerequisites": {
            "all": [
              "z02:redeemed"
            ],
            "any": [],
            "none": []
          },
          "text": "Lighters work between the bar and the pier at last, and the crane swings full nets off the Namar hulls. The Silt Stair’s canal barges load first. The harbour queue watches them go."
        },
        {
          "prerequisites": {
            "all": [
              "z02:gangway-cleared"
            ],
            "any": [],
            "none": []
          },
          "text": "The broker’s hook-hand lies on the gangway where she fell. Sereth Vann’s crews wait by the hatches of the hull at the timber pier."
        },
        {
          "prerequisites": {
            "all": [
              "past:z02:gangway-cleared"
            ],
            "any": [],
            "none": []
          },
          "text": "Stone moles hold back the silt, not very well. Beyond the bar, three Namar hulls ride at anchor, low with grain. At the timber pier the fleet’s smallest hull is tied up with a full net hanging over her deck, and a new hook-hand sits on her gangway. The last one went into the harbour; this one keeps her back to the wall.",
          "survives": [
            "z02-tide",
            "z02-hull-fight"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:errand:z02:grain-hull"
            ],
            "any": [],
            "none": []
          },
          "text": "Stone moles hold back the silt, not very well. Beyond the bar, three Namar hulls ride at anchor, low with grain, and they anchor further out than they used to. At the timber pier the smallest hull has a chain across her gangway: nobody empties a Namar hold here twice.",
          "survives": [
            "z02-tide",
            "z02-hull-fight"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:holder-sen"
            ],
            "any": [],
            "none": []
          },
          "text": "Stone moles hold back the silt, not very well. The Senate’s harbour flag flies from the light, and a Compact sail flies under it, on the lease. Beyond the bar, three Namar hulls ride at anchor, low with grain. The fleet’s smallest hull is tied up at the timber pier, and the crane over her holds a full net that has not moved since noon.",
          "survives": [
            "z02-tide",
            "z02-hull-fight"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Stone moles hold back the silt, not very well; broken pilings stand in the shallows where berths used to be. Beyond the bar, the relief fleet rides at anchor: three Namar hulls, low in the water with grain. The fleet’s smallest hull is tied up at the timber pier, and the crane over her holds a full net that has not moved since noon.",
          "survives": [
            "z02-tide",
            "z02-hull-fight"
          ]
        }
      ],
      "exits": [
        "beat:z02-sale-court",
        "beat:z02-bonded-warehouse",
        "beat:z02-rope-walk"
      ]
    },
    {
      "id": "beat:z02-bonded-warehouse",
      "name": "The Bonded Warehouse",
      "zone": "Z02",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "pressure:z02:dead-testimony"
            ],
            "any": [],
            "none": []
          },
          "text": "Ildren Vos is packing her tables. The pilot’s jar went to the sale court with a seal on its lid, and the salt on the floor has been swept into a neat pile."
        },
        {
          "prerequisites": {
            "all": [
              "z02:heddo-buried"
            ],
            "any": [],
            "none": []
          },
          "text": "The nearest trestle is scrubbed and bare; the crews carried the pilot up to the shrine. Ildren Vos works at her trestle tables on somebody else’s drowned."
        },
        {
          "prerequisites": {
            "all": [
              "z02:tables-seen"
            ],
            "any": [],
            "none": []
          },
          "text": "Behind the salt jars, under blue cloth, Ildren Vos works at three trestle tables. On the nearest lies a drowned man packed in salt. His hand keeps paying out a line that is not there."
        },
        {
          "prerequisites": {
            "all": [
              "past:errand:z02:dead-testimony"
            ],
            "any": [],
            "none": []
          },
          "text": "Salt jars stand in rows under the Compact’s bond marks, their mouths crusted white. Against the back wall, three trestle tables wait under blue cloth. The sale court has sent two drowned men here since an earlier traveller bought a pilot’s word."
        },
        {
          "prerequisites": {
            "all": [
              "z02:holder-sen"
            ],
            "any": [],
            "none": []
          },
          "text": "Salt jars stand in rows under the Senate’s seals and the Compact’s bond marks, their mouths crusted white. Against the back wall, three trestle tables are covered in blue cloth, and nobody moves cargo near them."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Salt jars stand in rows under the Compact’s bond marks, their mouths crusted white. Against the back wall, three trestle tables are covered in blue cloth, and nobody moves cargo near them."
        }
      ],
      "exits": [
        "beat:z02-mole-berths",
        "beat:z02-sale-court"
      ]
    },
    {
      "id": "beat:z02-rope-walk",
      "name": "The Rope Walk",
      "zone": "Z02",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "errand:z02:guarantee-witness"
            ],
            "any": [],
            "none": []
          },
          "text": "The gang walks rope without Tamsa today. The hull delegates’ mark is chalked on her empty frame, and at the shrine somebody has left bread under the fleet’s knot.",
          "survives": [
            "continuation-grave-witness-held",
            "continuation-grave-witness-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:oath-read"
            ],
            "any": [],
            "none": []
          },
          "text": "The oath cord hangs from the shrine’s lintel, one knot for every guarantee sworn this season. The newest knot is the fleet’s. Its clay tag names two witnesses, and one of them is drowned.",
          "survives": [
            "continuation-grave-witness-held",
            "continuation-grave-witness-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:errand:z02:guarantee-witness"
            ],
            "any": [],
            "none": []
          },
          "text": "The ropemakers walk backwards down the long frames, paying out hemp as the wheel turns. At the harbour shrine the oath cord carries a second tag on every knot now: the name of a living witness, written large.",
          "survives": [
            "continuation-grave-witness-held",
            "continuation-grave-witness-open"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "The ropemakers walk backwards down the long frames, paying out hemp as the wheel turns. At the end of the walk stands the harbour shrine, shared by every crew. The Compact swears its guarantees there, and an oath cord hangs from the lintel, knotted along its length.",
          "survives": [
            "continuation-grave-witness-held",
            "continuation-grave-witness-open"
          ]
        }
      ],
      "exits": [
        "beat:z02-mole-berths",
        "beat:z02-sale-court"
      ]
    },
    {
      "id": "beat:z02-sale-court",
      "name": "The Sale Court",
      "zone": "Z02",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "errand:z02:grain-hull"
            ],
            "any": [],
            "none": []
          },
          "text": "The sale court is loud. The Namar hulls sailed at dawn, and the harbour queue has learned why. The great balance on the platform stands empty; nobody weighs relief grain today."
        },
        {
          "prerequisites": {
            "all": [
              "z02:redeemed"
            ],
            "any": [],
            "none": []
          },
          "text": "Relief grain crosses the great balance sack by sack, and the clerks call each weight. The Silt Stair’s share is chalked on the notice board, with your notes pinned beside it."
        },
        {
          "prerequisites": {
            "all": [
              "z02:holder-sen"
            ],
            "any": [],
            "none": []
          },
          "text": "Merchants and clerks crowd the paving under the Senate’s green seals; the Compact’s blue banners still hang by the platform, on the lease. The great balance stands idle. The notice board lists the relief fleet as held pending guarantee, and the bread price beside it has been rubbed out and raised twice."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Merchants and clerks crowd the paving under the Compact’s blue banners. On the platform the great balance stands idle, its pans empty. The notice board lists the relief fleet as held pending guarantee, and the bread price beside it has been rubbed out and raised twice."
        }
      ],
      "exits": [
        "beat:z02-rope-walk",
        "beat:z02-bonded-warehouse",
        "beat:z02-mole-berths"
      ]
    },
    {
      "id": "beat:z06-toll-shelter",
      "name": "Toll Shelter",
      "zone": "Z06",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z06:arch-closed",
              "z06:coffin-cart"
            ],
            "any": [],
            "none": [
              "z06:coffins-held",
              "z06:coffins-passed"
            ]
          },
          "text": "The chain lies coiled on the factor’s table, and he is counting what he took before noon. Carts roll past his shelter on stone without stopping. Nobody here quite trusts it yet. The carter’s covered wagon went west over the causeway in the same hour, its canvas still roped down. Nobody opened it."
        },
        {
          "prerequisites": {
            "all": [
              "z06:arch-closed"
            ],
            "any": [],
            "none": []
          },
          "text": "The chain lies coiled on the factor’s table, and he is counting what he took before noon. Carts roll past his shelter on stone without stopping. Nobody here quite trusts it yet."
        },
        {
          "prerequisites": {
            "all": [
              "z06:guard-beaten",
              "z06:carts-across",
              "z06:coffin-cart"
            ],
            "any": [],
            "none": [
              "z06:coffins-held",
              "z06:coffins-passed"
            ]
          },
          "text": "The chain lies in the road where it fell. The lease guard’s shield leans on the shelter wall, the court’s carts have gone through, and the factor is chalking a description of you on his table. The carter’s covered wagon went west over the causeway in the same hour, its canvas still roped down. Nobody opened it."
        },
        {
          "prerequisites": {
            "all": [
              "z06:guard-beaten",
              "z06:carts-across"
            ],
            "any": [],
            "none": []
          },
          "text": "The chain lies in the road where it fell. The lease guard’s shield leans on the shelter wall, the court’s carts have gone through, and the factor is chalking a description of you on his table."
        },
        {
          "prerequisites": {
            "all": [
              "z06:guard-beaten"
            ],
            "any": [],
            "none": []
          },
          "text": "The chain is down and the lease guard with it. The court’s carters wait at the planks, watching you, not moving until someone waves them on."
        },
        {
          "prerequisites": {
            "all": [
              "z06:coffins-held"
            ],
            "any": [],
            "none": []
          },
          "text": "The carter’s six coffins stand in a row under the awning, lids nailed down again. The factor has sent to the stalls for spades. The court’s lime carts stand on the Caldris side of the chain."
        },
        {
          "prerequisites": {
            "all": [
              "z06:coffins-passed"
            ],
            "any": [],
            "none": []
          },
          "text": "The covered wagon has gone west over the planks. The factor wrote court carriage on his tablet and did not look up. The court’s lime carts stand on the Caldris side of the chain."
        },
        {
          "prerequisites": {
            "all": [
              "z06:carts-across",
              "z06:coffin-cart"
            ],
            "any": [],
            "none": [
              "z06:coffins-held",
              "z06:coffins-passed"
            ]
          },
          "text": "The court’s six lime carts stand on the Caldris side of the chain, white to the axles, waiting for their road home. The carter’s covered wagon went west over the causeway in the same hour, its canvas still roped down. Nobody opened it."
        },
        {
          "prerequisites": {
            "all": [
              "z06:carts-across"
            ],
            "any": [],
            "none": []
          },
          "text": "The court’s six lime carts stand on the Caldris side of the chain, white to the axles, waiting for their road home."
        },
        {
          "prerequisites": {
            "all": [
              "z06:coffins-seen",
              "z01:advocate-confronted"
            ],
            "any": [],
            "none": []
          },
          "text": "Under the carter’s canvas: six bodies packed in lime and salt, each tagged with a Caldris court number and the word testimony. In Caldris an advocate told you the court finds the dead persuasive. Here are six of them, travelling west.",
          "survives": [
            "z06-chain-force"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:coffins-seen"
            ],
            "any": [],
            "none": []
          },
          "text": "Under the carter’s canvas: six bodies packed in lime and salt so they keep, each tagged with a Caldris court number and the word testimony. None of them is going to a grave.",
          "survives": [
            "z06-chain-force"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:carter-heard"
            ],
            "any": [],
            "none": []
          },
          "text": "The carter leans on his wheel with his arms folded, waiting for your answer. Under the roped canvas the load lies long and even, like planks, or like boxes the length of a man.",
          "survives": [
            "z06-chain-force"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:coffin-cart"
            ],
            "any": [],
            "none": []
          },
          "text": "A carter’s covered wagon waits behind the chain, bound west. The canvas is roped down tight, and the carter stands where he can see the factor’s hands.",
          "survives": [
            "z06-chain-force"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:z06:guard-beaten"
            ],
            "any": [],
            "none": []
          },
          "text": "Three lease guards stand at the chain where there used to be one. Chalked on the factor’s table is a description of an armed outsider who came over it by force. An earlier traveller.",
          "survives": [
            "z06-chain-force"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:z06:coffins-passed"
            ],
            "any": [],
            "none": []
          },
          "text": "The factor lifts the canvas of every wagon that comes up the road now, even under a court’s letter. An earlier traveller taught him to.",
          "survives": [
            "z06-chain-force"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:holder-brz"
            ],
            "any": [],
            "none": []
          },
          "text": "The west imperial road reaches the Broken Causeway here. A chain crosses it between two posts. Under the Compact’s blue awning a factor weighs every cart, and a depot officer of the Standard takes a quarter of the toll before the chain comes down. Walkers go round the chain for nothing; wheels wait.",
          "survives": [
            "z06-chain-force"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "The west imperial road reaches the Broken Causeway here. A chain crosses it between two posts, and under the Compact’s blue awning a factor weighs every cart before it comes down. Walkers go round the chain for nothing. Wheels wait.",
          "survives": [
            "z06-chain-force"
          ]
        }
      ],
      "exits": [
        "beat:z06-broken-span",
        "beat:z06-old-ford"
      ]
    },
    {
      "id": "beat:z06-broken-span",
      "name": "Broken Span",
      "zone": "Z06",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z06:arch-closed"
            ],
            "any": [],
            "none": []
          },
          "text": "The keystone is in. The gang knocks the timber centring out from under the new arch, and it holds. By nightfall carts cross on stone, and the plank bridge is being broken up for firewood."
        },
        {
          "prerequisites": {
            "all": [
              "z06:clause-known"
            ],
            "any": [],
            "none": []
          },
          "text": "Three new arches are closed. The fourth stands on its timber centring, finished but for one stone, and the hoist beside it holds nothing. The keystone lies in the contractor’s yard under canvas."
        },
        {
          "prerequisites": {
            "all": [
              "past:z06:arch-closed"
            ],
            "any": [],
            "none": []
          },
          "text": "The arch an earlier traveller paid to close still stands. The one beside it slumped in the spring rains, so the plank bridge is back, and so is the lease."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "The road runs out onto the causeway and stops where the retaining wall burst. A plank bridge on tar-black trestles carries one cart at a time over the gap. Beside it, new arches stand on timber centring, and a hoist holds a block in its sling that nobody is lifting."
        }
      ],
      "exits": [
        "beat:z06-toll-shelter",
        "beat:z06-repair-camp",
        "beat:z06-old-ford"
      ]
    },
    {
      "id": "beat:z06-repair-camp",
      "name": "Repair Camp",
      "zone": "Z06",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z06:arch-closed"
            ],
            "any": [],
            "none": []
          },
          "text": "The gang is packing its tools. The pay table is folded, and a Compact clerk reads out the names that go up the quarry road tomorrow."
        },
        {
          "prerequisites": {
            "all": [
              "z06:carts-across"
            ],
            "any": [],
            "none": []
          },
          "text": "The lime carts have gone. The kiln burns on for an arch nobody is building."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "The contractor’s camp sits on a terrace beyond the break: tents, a stone yard, a lime kiln that has not been let cool in a month. Six carts stand loaded with sacked lime beside the pay table, shafts down. The carters are eating."
        }
      ],
      "exits": [
        "beat:z06-broken-span"
      ]
    },
    {
      "id": "beat:z06-old-ford",
      "name": "Old Ford",
      "zone": "Z06",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z06:travellers-across"
            ],
            "any": [],
            "none": []
          },
          "text": "The travellers’ camp is empty. Cart ruts and bare footprints run into the stream and climb out on the far side."
        },
        {
          "prerequisites": {
            "all": [
              "z06:ford-high"
            ],
            "any": [],
            "none": []
          },
          "text": "The stream came up in the night. It runs brown and fast over the stepping stones, and the cart ruts vanish into it. The travellers on the gravel terrace wait for it to fall."
        },
        {
          "prerequisites": {
            "all": [
              "past:z06:travellers-across"
            ],
            "any": [],
            "none": []
          },
          "text": "A Compact guard sits on the boundary stone and watches the stepping stones. The ford was fined after an earlier traveller brought the travellers’ camp over it behind their carts."
        },
        {
          "prerequisites": {
            "all": [
              "past:z06:coffins-held"
            ],
            "any": [],
            "none": []
          },
          "text": "Six graves lie in a row by the boundary stone, dug for the people an earlier traveller found under a carter’s canvas."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Below the causeway the old road goes down into the ravine and crosses the stream on stepping stones. It is shin-deep today. Travellers who could not pay the toll have camped on the gravel terrace, waiting for the water to stay low one more day."
        }
      ],
      "exits": [
        "beat:z06-toll-shelter",
        "beat:z06-broken-span"
      ]
    },
    {
      "id": "beat:z11-comparison-court",
      "name": "The Comparison Court",
      "zone": "Z11",
      "lines": [
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "A plumb line hangs beside a table of sealed specimens. Old sighting marks cross the worn court. Everything here was built to measure something; none of it could make a day.",
          "survives": [
            "mystery-shells",
            "mystery-baselines",
            "mystery-tides",
            "mystery-account",
            "mystery-book-court"
          ]
        }
      ],
      "exits": [
        "beat:z12-white-joint"
      ]
    },
    {
      "id": "beat:z12-white-joint",
      "name": "The White Joint",
      "zone": "Z12",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "mystery:second-point"
            ],
            "any": [],
            "none": []
          },
          "text": "Two chalk marks lie behind you. The final mark lies on stone neither old approach could reach. You can still turn back.",
          "survives": [
            "mystery-compare-points",
            "mystery-first-point"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "mystery:approach"
            ],
            "any": [],
            "none": []
          },
          "text": "The public bypass is open. The covering boards lie stacked beside it. Three fixed points wait on the pale stone.",
          "survives": [
            "mystery-compare-points",
            "mystery-first-point"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Pack animals pass on a makeshift span. Beneath it, an older road ends where two good surveys fail to meet. Pale stone shows through the cut.",
          "survives": [
            "mystery-compare-points",
            "mystery-first-point"
          ]
        }
      ],
      "exits": [
        "beat:z11-comparison-court"
      ]
    }
  ],
  "scenes": [
    {
      "id": "nessa",
      "personId": "person:nessa-tal",
      "name": "Nessa Tal",
      "beatId": "beat:lower-landing",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "finale:n03:struck"
            ],
            "any": [],
            "none": []
          },
          "text": "They struck it. I said it slowly. Leth would have counted the benches twice."
        },
        {
          "prerequisites": {
            "all": [
              "finale:nessa-witness"
            ],
            "any": [],
            "none": []
          },
          "text": "I will say it slowly, and I will say it in front of him. Leth counted twice. That is all his hands ever said."
        },
        {
          "prerequisites": {
            "all": [
              "finale:hearing"
            ],
            "any": [],
            "none": [
              "campaign:B5"
            ]
          },
          "text": "They want to read Leth in a court? He counted sacks. Ask me what the count meant."
        },
        {
          "prerequisites": {
            "all": [
              "fact:terminal-accounting-complete",
              "z04:urn-promised"
            ],
            "any": [],
            "none": [
              "side:urn-returned"
            ]
          },
          "text": "You gave me your word about my mother’s urn. The shelf was cleared while you were at the court. I will not ask you for another word."
        },
        {
          "prerequisites": {
            "all": [
              "fact:terminal-accounting-complete",
              "z04:urn-reassured"
            ],
            "any": [],
            "none": [
              "side:urn-returned"
            ]
          },
          "text": "You told me they could not clear a niche while I lived. They cleared hers this morning. I was here, alive, waiting on your case."
        },
        {
          "prerequisites": {
            "all": [
              "fact:terminal-accounting-complete"
            ],
            "any": [],
            "none": []
          },
          "text": "My mother’s urn is on tomorrow’s list. I am going myself. A second receipt will not fit on the shelf.",
          "survives": [
            "nessa-after"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "story:false-report"
            ],
            "any": [],
            "none": []
          },
          "text": "You have your witnessing fee. I still have an empty coffin. Are we both calling that a completed job?",
          "survives": [
            "claim-pay",
            "claim-leave",
            "urn-promise",
            "urn-reassure",
            "lime-tell",
            "lime-quiet"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "story:porters-fed"
            ],
            "any": [],
            "none": []
          },
          "text": "The porters stayed. There is your first four cuts accounted for. Now we can discuss the money the concession owes us.",
          "survives": [
            "claim-pay",
            "claim-leave",
            "urn-promise",
            "urn-reassure",
            "lime-tell",
            "lime-quiet"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "side:urn-returned"
            ],
            "any": [],
            "none": [
              "story:opening-choice"
            ]
          },
          "text": "You brought me my mother’s name. The porters are still owed four cuts, and the concession still calls her cargo.",
          "survives": [
            "claim-pay",
            "claim-leave",
            "urn-promise",
            "urn-reassure",
            "lime-tell",
            "lime-quiet"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z04:contract-gallery"
            ],
            "any": [],
            "none": [
              "story:opening-choice",
              "side:urn-returned",
              "z04:claim-paid",
              "z04:claim-left"
            ]
          },
          "text": "The kilns have a Senate contract now, and it pays for unclaimed dead. A porter fell on the stair last week. His widow cannot pay the claim fee, so tonight the cart takes him up as unclaimed. Leth’s coffin can wait an hour. Can he?",
          "survives": [
            "nessa-account"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z04:contract-vault"
            ],
            "any": [],
            "none": [
              "story:opening-choice",
              "side:urn-returned",
              "z04:urn-promised",
              "z04:urn-reassured"
            ]
          },
          "text": "The vault has a Compact contract now. They are clearing old niches to sell again, and my mother’s is on today’s list. Leth’s coffin can wait an hour. Can her urn?",
          "survives": [
            "nessa-account"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z04:contract-firing"
            ],
            "any": [],
            "none": [
              "story:opening-choice",
              "side:urn-returned",
              "z04:lime-refused",
              "z04:lime-carried"
            ]
          },
          "text": "The firing tunnels are lit again. The Standard wants lime for its walls, and the concession pays double to carry it up. Half my porters are already lacing their straps. Do they know what those tunnels burn? Do I tell them?",
          "survives": [
            "nessa-account"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "world:later-life"
            ],
            "any": [],
            "none": [
              "story:opening-choice",
              "side:urn-returned"
            ]
          },
          "text": "You have the same look as the last one they sent down the stair — coffin first, questions later. The porters are still owed and the forms are still wrong. Where do you want to start?",
          "survives": [
            "nessa-account"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "story:opening-choice",
              "side:urn-returned"
            ]
          },
          "text": "I need four cuts owed to the porters and my mother’s urn. The form says lost cargo. Cargo does not have a mother.",
          "survives": [
            "nessa-account"
          ]
        }
      ]
    },
    {
      "id": "guard",
      "personId": "person:toll-guard",
      "name": "Toll guard",
      "beatId": "beat:toll-stair",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "side:porter-toll-ended"
            ],
            "any": [],
            "none": []
          },
          "text": "The porters go up free now, on the court’s own copy. Everyone else still pays me two cuts. I still do not get to eat it."
        },
        {
          "prerequisites": {
            "all": [
              "side:toll-profit",
              "story:toll-pass"
            ],
            "any": [],
            "none": [
              "side:porter-toll-ended"
            ]
          },
          "text": "Your share is paid. Mine is not your business. Go on up before the porters count their bowl."
        },
        {
          "prerequisites": {
            "all": [
              "side:toll-profit"
            ],
            "any": [],
            "none": [
              "side:porter-toll-ended",
              "story:toll-pass"
            ]
          },
          "text": "Your share is paid. The stair is not: two cuts, or a porter’s tally, same as anyone. Mine is not your business."
        },
        {
          "prerequisites": {
            "all": [
              "story:toll-pass"
            ],
            "any": [],
            "none": [
              "side:porter-toll-ended"
            ]
          },
          "text": "Your pass is good; go on up. I collect the toll. I do not get to eat it."
        },
        {
          "prerequisites": {
            "all": [
              "past:side:toll-struck"
            ],
            "any": [],
            "none": [
              "story:toll-pass",
              "side:porter-toll-ended",
              "side:toll-profit"
            ]
          },
          "text": "Two cuts, or show me a porter’s tally. And yes, the second charge is back. The concession had its schedule copied fresh from its own roll, and the court’s correction did not make the copy. I collect the toll. I do not get to eat it."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "story:toll-pass"
            ]
          },
          "text": "Two cuts, or show me a porter’s tally. I collect the toll. I do not get to eat it."
        }
      ]
    },
    {
      "id": "melian",
      "personId": "person:melian-sar",
      "name": "Melian Sar",
      "beatId": "beat:middle-market-cold-bath",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "side:sluice-flushed"
            ],
            "any": [],
            "none": []
          },
          "text": "The water has left its mark on every clean cloth. Bring a plank before another apology."
        },
        {
          "prerequisites": {
            "all": [
              "fact:terminal-accounting-complete",
              "melian:cleared"
            ],
            "any": [],
            "none": []
          },
          "text": "The shutter is open. I had forgotten how much light it keeps out. If you need treatment, come through the front this time."
        },
        {
          "prerequisites": {
            "all": [
              "side:bath-screen"
            ],
            "any": [],
            "none": [
              "melian:cleared"
            ]
          },
          "text": "Use the screened entrance. The accusation has not changed; at least the patients no longer have to stand inside it.",
          "survives": [
            "melian-need",
            "melian-demo",
            "melian-after"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "fact:terminal-accounting-complete",
              "melian:accused"
            ],
            "any": [],
            "none": []
          },
          "text": "The notice calls me a corpse-worker. The shutter stays closed. Please stop standing where the patients can be seen."
        },
        {
          "prerequisites": {
            "all": [
              "fact:terminal-accounting-complete",
              "melian:under-suspicion"
            ],
            "any": [],
            "none": []
          },
          "text": "I can treat a hand. I cannot treat a rumour. Until the finding names the difference, I keep the door half shut.",
          "survives": [
            "melian-after"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "fact:melian-separated"
            ],
            "any": [],
            "none": [
              "fact:terminal-accounting-complete"
            ]
          },
          "text": "You set my treatment beside the station records. That is the first honest comparison anyone has made. The crowd has not read it yet."
        },
        {
          "prerequisites": {
            "all": [
              "story:false-report"
            ],
            "any": [],
            "none": [
              "fact:terminal-accounting-complete"
            ]
          },
          "text": "The porters say you signed the lost-cargo form. Now the kiln gate says I took what was lost. Hold that cloth anyway, please. The hand still needs it.",
          "survives": [
            "melian-need",
            "melian-demo"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "done:mentor-assay"
            ],
            "any": [],
            "none": [
              "fact:terminal-accounting-complete",
              "story:false-report",
              "fact:melian-separated"
            ]
          },
          "text": "Corren’s wash held up to the comparison. I can witness that. The accusation against my work still needs its own answer."
        },
        {
          "prerequisites": {
            "all": [
              "story:lawful-demo"
            ],
            "any": [],
            "none": [
              "fact:terminal-accounting-complete",
              "story:false-report",
              "fact:melian-separated"
            ]
          },
          "text": "Hold that cloth, please. You have seen what I do. Write it down before the kiln gate writes it for me."
        },
        {
          "prerequisites": {
            "all": [
              "story:scapegoat-known"
            ],
            "any": [],
            "none": [
              "fact:terminal-accounting-complete",
              "story:false-report",
              "story:lawful-demo"
            ]
          },
          "text": "Hold that cloth, please. You asked what I actually do. The kiln gate still has not."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "fact:terminal-accounting-complete",
              "story:false-report",
              "story:scapegoat-known"
            ]
          },
          "text": "Hold that cloth, please. People have been shouting my name at the kiln gate. None has asked what I actually do."
        }
      ]
    },
    {
      "id": "official",
      "personId": "official",
      "name": "The local official",
      "beatId": "beat:reeves-court",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "world:holder:SEN"
            ],
            "any": [],
            "none": [
              "story:official-addressed"
            ]
          },
          "text": "Clerk Talla Vel stamps the docket. “The Senate holds this landing's registry. I can open the records; an entry is not a verdict.”"
        },
        {
          "prerequisites": {
            "all": [
              "world:holder:BRZ"
            ],
            "any": [],
            "none": [
              "story:official-addressed"
            ]
          },
          "text": "Depot Officer Sereth Kall lays out the requisition ledger. “The garrison keeps this landing's gate. My escort is not a finding; bring me a record.”"
        },
        {
          "prerequisites": {
            "all": [
              "world:holder:REE"
            ],
            "any": [],
            "none": [
              "story:official-addressed"
            ]
          },
          "text": "Measurer Bera Nall marks the canal ledger. “The Reed Covenant keeps this water moving. A toll buys passage; it does not settle a burial.”"
        },
        {
          "prerequisites": {
            "all": [
              "world:holder:SAL"
            ],
            "any": [],
            "none": [
              "story:official-addressed"
            ]
          },
          "text": "Factor Deren Pell opens the quay ledger. “The Salt Compact holds this landing's books. A fee admits you; it does not make the figures true.”"
        },
        {
          "prerequisites": {
            "all": [
              "world:holder:LOC"
            ],
            "any": [],
            "none": [
              "story:official-addressed"
            ]
          },
          "text": "Speaker Maran gestures to the neighbours at the rail. “The Lock Foot council holds this landing by consent. I can authorize a visit; the people will judge what you find.”"
        },
        {
          "prerequisites": {
            "all": [
              "finale:containment:kept"
            ],
            "any": [],
            "none": []
          },
          "text": "The grain count is on the door every morning. Caldris writes weekly, and we answer weekly."
        },
        {
          "prerequisites": {
            "all": [
              "finale:containment:sent"
            ],
            "any": [],
            "none": []
          },
          "text": "The barges went full. The Caldris receipt is pinned where the queue can read it. Some of them do."
        },
        {
          "prerequisites": {
            "all": [
              "finale:n03:struck"
            ],
            "any": [],
            "none": []
          },
          "text": "Struck, on a porter’s habit and a woman who knew him. I have had the ruling copied for the door."
        },
        {
          "prerequisites": {
            "all": [
              "finale:n03:bought"
            ],
            "any": [],
            "none": []
          },
          "text": "Withdrawn. I will not ask what it cost you. I will ask what it costs us, the next time he buys a reading."
        },
        {
          "prerequisites": {
            "all": [
              "finale:n03:lost"
            ],
            "any": [],
            "none": []
          },
          "text": "Their factors came up with the barge. I signed where the ruling told me to sign."
        },
        {
          "prerequisites": {
            "all": [
              "finale:hearing"
            ],
            "any": [],
            "none": []
          },
          "text": "Caldris sits on Vasko’s claim, and our granary waits on Caldris. Nessa at the landing knew Leth An better than anyone living."
        },
        {
          "prerequisites": {
            "all": [
              "finale:containment"
            ],
            "any": [],
            "none": []
          },
          "text": "Keep the grain or send it. I have both letters written; I only need to know which one to seal."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z01:underway",
              "z01:docket-sealed"
            ],
            "any": [],
            "none": []
          },
          "text": "That is the Caldris seal on our docket. Hand it here, and the court pays what it promised."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:underway",
              "z02:redeemed"
            ],
            "any": [],
            "none": []
          },
          "text": "The Nacre notes are settled, then. Tell me how, and the court pays what it promised."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z06:underway",
              "z06:carts-across"
            ],
            "any": [],
            "none": []
          },
          "text": "The lime is over the causeway, then. Tell me how it crossed, and the court pays what it promised."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z01:underway",
              "errand:z02:underway"
            ],
            "any": [],
            "none": []
          },
          "text": "Our docket for Caldris and our notes for Nacre Quay, both in one pair of hands. Which comes first is your road to choose. Bring back a seal and a settlement."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z01:underway",
              "errand:z06:underway"
            ],
            "any": [],
            "none": []
          },
          "text": "Our docket for Caldris and our letter for the lime at the Broken Causeway, both in one pair of hands. The west road leaves from the bridge at Caldris, so the docket is on your way. Bring back a seal and the carts."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:underway",
              "errand:z06:underway"
            ],
            "any": [],
            "none": []
          },
          "text": "Our notes for Nacre Quay and our letter for the lime at the Broken Causeway, both in one pair of hands. The canal boat leaves from the Lower Landing; the west road from the bridge at Caldris. Which comes first is your road to choose."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z01:underway"
            ],
            "any": [],
            "none": []
          },
          "text": "You carry our docket for Caldris. Their grain court counts our grain against its bread register, and without their seal it is only a boat that left."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:underway"
            ],
            "any": [],
            "none": []
          },
          "text": "You carry our notes for Nacre Quay. The sale court there redeems them from the relief fleet, or nobody does. The canal boat leaves from the Lower Landing."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z06:underway"
            ],
            "any": [],
            "none": []
          },
          "text": "You carry our letter for the lime at the Broken Causeway. The west road leaves from the bridge at Caldris."
        },
        {
          "prerequisites": {
            "all": [
              "convergence:n03"
            ],
            "any": [],
            "none": [
              "campaign:B4",
              "errand:z01:underway",
              "errand:z02:underway",
              "errand:z06:underway"
            ]
          },
          "text": "Advocate Vasko’s clerk has sat on our steps since morning. He has what he came for: enough times this season that the basin let the dead speak for the living. Tell me you have carried your last errand, and I will tell you what he means to do with it."
        },
        {
          "prerequisites": {
            "all": [
              "errand:second"
            ],
            "any": [
              "pressure:z01:sealed-over-drowned",
              "pressure:z01:advocate-paid",
              "pressure:z02:dead-testimony",
              "pressure:z06:coffins-uninspected",
              "pressure:z06:roll-countersigned"
            ],
            "none": [
              "convergence:n03",
              "campaign:B4",
              "errand:z01:underway",
              "errand:z02:underway",
              "errand:z06:underway"
            ]
          },
          "text": "Word of what you did on our road came home before you did. Advocate Vasko’s clerk has it in his book, under the Silt Stair’s name. He keeps a page for every place that lets the dead speak for the living, and ours has a line on it now."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [
              "pressure:z01:sealed-over-drowned",
              "pressure:z01:advocate-paid",
              "pressure:z02:dead-testimony",
              "pressure:z06:coffins-uninspected",
              "pressure:z06:roll-countersigned"
            ],
            "none": [
              "errand:second",
              "convergence:n03",
              "campaign:B4",
              "errand:z01:underway",
              "errand:z02:underway",
              "errand:z06:underway"
            ]
          },
          "text": "Word of what you did on our errand came home before you did. Advocate Vasko’s clerk has copied it into his book. He keeps a page for every place that lets the dead speak for the living. One line is gossip to him. One more like it on our next errand, and he has enough to take the Silt Stair before the Senate court."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:done",
              "errand:z02:concession"
            ],
            "any": [],
            "none": []
          },
          "text": "Grain, and a lease on our own landing with the court’s name on it. The Compact’s clerk came up on the same boat to measure the berths. The court will live with it for twenty years."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:done",
              "errand:z02:grain-hull"
            ],
            "any": [],
            "none": []
          },
          "text": "A whole hull of grain at our landing, and a letter from the Compact asking who emptied it. I have not answered. Everyone at the coast already knows."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:done",
              "errand:z02:dead-testimony"
            ],
            "any": [],
            "none": []
          },
          "text": "Redeemed, on a drowned man’s word. The sale court wrote it down as his. I will not ask how a drowned man gives his word."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:done"
            ],
            "any": [],
            "none": []
          },
          "text": "Redeemed in full, on a living witness. The Convener sent a letter saying the Compact honours what it swears. He did not say he was glad to."
        },
        {
          "prerequisites": {
            "all": [
              "z01:docket-returned",
              "z01:households-restored"
            ],
            "any": [],
            "none": []
          },
          "text": "Sealed, and eleven struck names read back onto their register because of what you carried. Caldris will say its own court did that. Let it."
        },
        {
          "prerequisites": {
            "all": [
              "z01:docket-returned",
              "z01:claimant-declared"
            ],
            "any": [],
            "none": []
          },
          "text": "Sealed, and I hear you stood at the claimant’s dais to feed the struck households. Caldris will count our next barge with that in mind."
        },
        {
          "prerequisites": {
            "all": [
              "z01:docket-returned"
            ],
            "any": [],
            "none": []
          },
          "text": "Sealed and home. Caldris counted our grain against its register as the register stands. It will count the next barge the same way."
        },
        {
          "prerequisites": {
            "all": [
              "z02:notes"
            ],
            "any": [],
            "none": []
          },
          "text": "You carry the court’s notes. The sale court at Nacre Quay redeems them from the relief fleet, or nobody does. The canal boat leaves from the Lower Landing."
        },
        {
          "prerequisites": {
            "all": [
              "campaign:B2"
            ],
            "any": [],
            "none": []
          },
          "text": "You carry the court’s docket. Caldris counts our grain against its bread register, and without their seal it is only a boat that left."
        },
        {
          "prerequisites": {
            "all": [
              "fact:terminal-accounting-complete"
            ],
            "any": [],
            "none": []
          },
          "text": "The account is registered. Now the district will discover whether we wrote down enough of the cost."
        },
        {
          "prerequisites": {
            "all": [
              "carts:moving"
            ],
            "any": [],
            "none": []
          },
          "text": "The lift moves. My requisition is satisfied; my ledger is not. Settle the account before the contractors write their own figures.",
          "survives": [
            "official-offer",
            "lodging-work",
            "drain-sale",
            "kitchen-surety",
            "legacy-warrant",
            "protect"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "story:grain-settled",
              "carts:porters",
              "side:route-sold",
              "side:kitchen-promised"
            ],
            "any": [],
            "none": []
          },
          "text": "Porters still carry the grain up by hand. Your route drawing is posted beside the tariff; the collectors have a copy. Your name stands against the kitchen’s six cuts. My grain requisition is still open. Settle that account before the contractors write their own figures.",
          "survives": [
            "protect"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "story:grain-settled",
              "carts:porters",
              "side:route-sold"
            ],
            "any": [],
            "none": [
              "side:kitchen-promised"
            ]
          },
          "text": "Porters still carry the grain up by hand. Your route drawing is posted beside the tariff; the collectors have a copy. My grain requisition is still open. Settle that account before the contractors write their own figures.",
          "survives": [
            "protect"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "story:grain-settled",
              "carts:porters",
              "side:kitchen-promised"
            ],
            "any": [],
            "none": [
              "side:route-sold"
            ]
          },
          "text": "Porters still carry the grain up by hand. Your name stands against the kitchen’s six cuts. My grain requisition is still open. Settle that account before the contractors write their own figures.",
          "survives": [
            "protect"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "story:grain-settled",
              "carts:porters"
            ],
            "any": [],
            "none": []
          },
          "text": "Porters carry the grain up by hand while the lift stands broken. My requisition is still open. Settle the account before the contractors write their own figures.",
          "survives": [
            "protect"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "carts:rationed",
              "story:lodging-work-paid",
              "side:kitchen-promised"
            ],
            "any": [],
            "none": []
          },
          "text": "The lift turns at a third of a load; the temporary arrangement imposes no repair debt. Your lodging copies are filed and your copying wages paid. The kitchen’s six cuts stand against your name. The grain account still needs your seal.",
          "survives": [
            "protect"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "carts:rationed",
              "story:lodging-work-paid"
            ],
            "any": [],
            "none": [
              "side:kitchen-promised"
            ]
          },
          "text": "The lift turns at a third of a load; the temporary arrangement imposes no repair debt. Your lodging copies are filed and your copying wages paid. The grain account still needs your seal.",
          "survives": [
            "protect"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "carts:rationed",
              "side:kitchen-promised"
            ],
            "any": [],
            "none": [
              "story:lodging-work-paid"
            ]
          },
          "text": "The lift turns at a third of a load; the temporary arrangement imposes no repair debt. The kitchen’s six cuts stand against your name. The grain account still needs your seal.",
          "survives": [
            "protect"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "carts:rationed"
            ],
            "any": [],
            "none": []
          },
          "text": "The lift turns at a third of a load and the queue grows behind it. No one owes a debt for it yet. Settle the account before the contractors write their own figures.",
          "survives": [
            "protect"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "story:grain-settled"
            ]
          },
          "text": "The grain is spoiling. Bring me something I can put beside the contractor’s signature, and we can discuss whose money repairs the lift.",
          "survives": [
            "official-offer",
            "lodging-work",
            "drain-sale",
            "kitchen-surety",
            "legacy-warrant",
            "court-copy",
            "protect"
          ]
        }
      ]
    },
    {
      "id": "odel",
      "personId": "person:odel-thann",
      "name": "Odel Thann",
      "beatId": "z04-cooling-court",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "fact:terminal-accounting-complete"
            ],
            "any": [],
            "none": []
          },
          "text": "The records have changed hands. Keep watching the hands."
        },
        {
          "prerequisites": {
            "all": [
              "fact:workers-protected"
            ],
            "any": [],
            "none": []
          },
          "text": "My sister came up to see the struck copy for herself. First time she has stood in this court without a debt in it. The crew is ready when you are."
        },
        {
          "prerequisites": {
            "all": [
              "fact:witnesses-protected"
            ],
            "any": [],
            "none": []
          },
          "text": "There is an office seal beside my name now. The creditors’ man passed me this morning and kept walking."
        },
        {
          "prerequisites": {
            "all": [
              "fact:odel-cooperation"
            ],
            "any": [],
            "none": [
              "fact:workers-protected"
            ]
          },
          "text": "I have told you the price: {cuts:worker-guarantee}, for my sister’s bond and the crew’s arrears. Until it is paid, the debt follows her."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "fact:odel-cooperation"
            ]
          },
          "text": "My sister’s bond is in the office. If I tell you what happened here, the debt follows her. That is how they keep me useful."
        }
      ]
    },
    {
      "id": "sela",
      "personId": "person:sela-venn",
      "name": "Sela Venn",
      "beatId": "z04-selas-rooms",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "fact:terminal-accounting-complete"
            ],
            "any": [],
            "none": []
          },
          "text": "The work has stopped. What I did while it was running has not disappeared with it."
        },
        {
          "prerequisites": {
            "all": [
              "fact:independent-guarantor"
            ],
            "any": [],
            "none": []
          },
          "text": "The inspector sits by the door and notes each time I stand up. I asked for that. Finish it."
        },
        {
          "prerequisites": {
            "all": [
              "world:work-stopped"
            ],
            "any": [],
            "none": []
          },
          "text": "The wax is holding nothing now. I can stop guarding it. Say what you came to say."
        },
        {
          "prerequisites": {
            "all": [
              "fact:operation-supported"
            ],
            "any": [],
            "none": [
              "world:work-stopped"
            ]
          },
          "text": "The new wax is setting. Two more bodies will be working by the next shift. You paid for that; remember it when you tell the others.",
          "survives": [
            "sela-salt"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "world:work-stopped"
            ]
          },
          "text": "Do not move the wax. It is holding a motion in place. There are safer ways to stop it than breaking everything in reach.",
          "survives": [
            "sela-salt"
          ]
        }
      ]
    },
    {
      "id": "noll",
      "personId": "person:tavren-noll",
      "name": "Tavren Noll",
      "beatId": "z04-cart-ramp-office",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "fact:terminal-accounting-complete"
            ],
            "any": [],
            "none": []
          },
          "text": "You can read the new notice at the gate. My creditors certainly have.",
          "survives": [
            "buy-bearing"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "story:combat-won",
              "world:guard-dead"
            ],
            "any": [],
            "none": []
          },
          "text": "The guard is dead on my office floor. Say what you came to take before the concession decides I ordered it."
        },
        {
          "prerequisites": {
            "all": [
              "story:combat-won"
            ],
            "any": [],
            "none": [
              "world:guard-dead"
            ]
          },
          "text": "The guard ran rather than die in my doorway. Say what you came to take before the concession decides I sent him."
        },
        {
          "prerequisites": {
            "all": [
              "carts:moving"
            ],
            "any": [],
            "none": [
              "story:combat-won"
            ]
          },
          "text": "The lift turns again, and this time someone else paid for the bearing. I paid for the last one with dead men’s wages. Before you decide what sort of man I am, ask who pays for the next.",
          "survives": [
            "fight",
            "noll-out"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "story:combat-won",
              "carts:moving"
            ]
          },
          "text": "The lift needs a bearing. I bought one. Before you decide what sort of man I am, tell me who will buy the next.",
          "survives": [
            "fight",
            "noll-out"
          ]
        }
      ]
    },
    {
      "id": "z01-captain",
      "personId": "person:z01-watch-captain",
      "name": "Captain Hadra Dost",
      "beatId": "beat:z01-river-bridge",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z01:runner-beaten"
            ],
            "any": [],
            "none": []
          },
          "text": "A man was carried off the archive stair on a door. The advocate filed his complaint before the blood dried. The watch saw nothing; nobody paid it to look.",
          "survives": [
            "z01-watch-count",
            "continuation-disgraced-legionary-held",
            "continuation-disgraced-legionary-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:watch-posted"
            ],
            "any": [],
            "none": []
          },
          "text": "Two of mine are on the archive stair, fed for the day. They will stand there until the advocate’s man remembers somewhere else to be.",
          "survives": [
            "continuation-disgraced-legionary-held",
            "continuation-disgraced-legionary-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:watch-unpaid",
              "z01:holder-brz"
            ],
            "any": [],
            "none": []
          },
          "text": "Four months unpaid under the Senate, two more under the Standard. The Standard pays in bread, at least. We count twice because a short count comes out of our ration.",
          "survives": [
            "continuation-disgraced-legionary-held",
            "continuation-disgraced-legionary-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:watch-unpaid"
            ],
            "any": [],
            "none": []
          },
          "text": "Four months unpaid. The register table sells exemptions, and the money is meant for us. We count every sack twice because a short count comes out of our pay.",
          "survives": [
            "continuation-disgraced-legionary-held",
            "continuation-disgraced-legionary-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:errand"
            ],
            "any": [],
            "none": [
              "z01:docket"
            ]
          },
          "text": "No docket? Then you are for the west road. It leaves from this bridge: forty-four kilometres to the Broken Causeway, and the Compact weighs everything at its chain.",
          "survives": [
            "continuation-disgraced-legionary-held",
            "continuation-disgraced-legionary-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:z01:runner-beaten"
            ],
            "any": [],
            "none": []
          },
          "text": "Docket from the Silt Stair? Up the stairs to the grain court. And keep off the archive stair. An earlier traveller killed the advocate’s runner there, and the new one carries his cudgel in his hand.",
          "survives": [
            "continuation-disgraced-legionary-held",
            "continuation-disgraced-legionary-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:holder-brz"
            ],
            "any": [],
            "none": []
          },
          "text": "The Standard holds the bridge now. The watch still wears Senate bronze, because nobody issued anything else. Docket? Up the stairs to the grain court.",
          "survives": [
            "continuation-disgraced-legionary-held",
            "continuation-disgraced-legionary-open"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Docket from the Silt Stair? Up the stairs to the grain court. Mind the queue; it has stood there since dawn and it knows its own order.",
          "survives": [
            "continuation-disgraced-legionary-held",
            "continuation-disgraced-legionary-open"
          ]
        }
      ]
    },
    {
      "id": "z01-registrar",
      "personId": "person:z01-senate-clerk",
      "name": "Registrar Corvan Esk",
      "beatId": "beat:z01-grain-court",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z01:households-restored"
            ],
            "any": [],
            "none": []
          },
          "text": "Eleven households back on the register, and eleven honest debtors waiting a season longer for it. Your docket is sealed. Take it home before anyone asks me to read the list again.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:register-standing",
              "z01:claimant-declared"
            ],
            "any": [],
            "none": []
          },
          "text": "Sealed as the register stands. The struck households are eating the claimant’s bread at the end of my queue, and the Senate will remember whose name stood at her dais.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "pressure:z01:sealed-over-drowned"
            ],
            "any": [],
            "none": []
          },
          "text": "Sealed as the register stands, and you knew whose oaths struck them. So does the clerk in grey who copied your name. Take it home.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:register-standing"
            ],
            "any": [],
            "none": []
          },
          "text": "Sealed as the register stands. The same names eat; the same names wait. Take it home.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:bonds-void"
            ],
            "any": [],
            "none": [
              "z01:docket-sealed"
            ]
          },
          "text": "The court has voided eleven bonds. I can read those households first and seal your docket that way. Eleven others, whose debts were honest, will wait a season for it.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:claimant-declared"
            ],
            "any": [],
            "none": [
              "z01:docket-sealed"
            ]
          },
          "text": "The claimant’s carts feed my struck households at the end of my own queue, and her clerk counts every mouth. The Senate will ask me why I let her. I can still seal your docket as the register stands; that is all I can do now.",
          "survives": [
            "z01-exemption",
            "z01-register-call",
            "z01-registrar-bonds",
            "z01-advocate-sell",
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:bond-bought"
            ],
            "any": [],
            "none": []
          },
          "text": "The Senth bond is torn, so the household is back on my list. Vasko was paid; nobody in this court will ask how he came by it.",
          "survives": [
            "z01-docket-read",
            "z01-registrar-bonds",
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:irra-exempted"
            ],
            "any": [],
            "none": []
          },
          "text": "The Senth household is back on the list, bought and paid. Everyone in the queue saw what an exemption costs. Seal the docket when you are ready.",
          "survives": [
            "z01-registrar-bonds",
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:called-names"
            ],
            "any": [],
            "none": []
          },
          "text": "You read a fair list and did not stumble on the struck names. Nobody in that queue will forget your voice. Seal the docket when you are ready.",
          "survives": [
            "z01-registrar-bonds",
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:docket-read",
              "z01:bonds-explained"
            ],
            "any": [],
            "none": []
          },
          "text": "Ninety-six debts were sold to pay for this bread. The rule says a bonded household is fed by its creditor, so the register strikes it. The people who bought the bonds wrote the rule. At the end of my table sits Advocate Vasko’s clerk, in grey. He writes down whoever seals over a bond they know to be bad.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:docket-read",
              "carts:moving"
            ],
            "any": [],
            "none": []
          },
          "text": "Full barges from the Silt Stair: forty places on the register. I have sixty-one households struck this season. Seal the docket as the register stands, or give me a lawful reason to read other names first. At the end of my table sits Advocate Vasko’s clerk, in grey. He writes down whoever seals over a bond they know to be bad.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:docket-read",
              "carts:porters"
            ],
            "any": [],
            "none": []
          },
          "text": "Hand-carried grain, a crew’s worth: thirty places on the register. I have sixty-one households struck this season. Seal the docket as the register stands, or give me a lawful reason to read other names first. At the end of my table sits Advocate Vasko’s clerk, in grey. He writes down whoever seals over a bond they know to be bad.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:docket-read",
              "carts:rationed"
            ],
            "any": [],
            "none": []
          },
          "text": "The lift turns light, so the barges come light: twenty places on the register. I have sixty-one households struck this season. Seal the docket as the register stands, or give me a lawful reason to read other names first. At the end of my table sits Advocate Vasko’s clerk, in grey. He writes down whoever seals over a bond they know to be bad.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:docket-read"
            ],
            "any": [],
            "none": []
          },
          "text": "Your docket says the grain still waits at the Silt Stair. It buys no places until it moves, but I can seal it, and Caldris will owe for it when it comes. Sixty-one households are struck this season either way. At the end of my table sits Advocate Vasko’s clerk, in grey. He writes down whoever seals over a bond they know to be bad.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:errand"
            ],
            "any": [],
            "none": [
              "z01:docket"
            ]
          },
          "text": "You have no docket for me. Grain for Caldris is counted here, and the west road leaves from the bridge.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:notes",
              "z01:docket"
            ],
            "any": [],
            "none": [
              "z01:docket-read"
            ]
          },
          "text": "The Silt Stair sends paper down to Nacre as well? If the relief fleet unloads for you, your barges come up to me fuller. I will believe it when I count it.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:holder-brz"
            ],
            "any": [],
            "none": []
          },
          "text": "The Standard kept the clerks; its soldiers cannot read the old register. Every barge buys places on it. Hand me your docket and I will tell you how many households it feeds.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Docket? Good. Every barge buys places on the bread register. Hand it here and I will tell you how many households it feeds.",
          "survives": [
            "continuation-fallen-household-held",
            "continuation-fallen-household-open"
          ]
        }
      ]
    },
    {
      "id": "z01-irra",
      "personId": "person:z01-register-widow",
      "name": "Irra Senth",
      "beatId": "beat:z01-grain-court",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z01:households-restored"
            ],
            "any": [],
            "none": []
          },
          "text": "They read our name first. First! The man behind me has waited since spring, and he did not look at me. I do not blame him."
        },
        {
          "prerequisites": {
            "all": [
              "z01:bonds-void"
            ],
            "any": [],
            "none": []
          },
          "text": "The court says Aulo could not have sworn. I knew that. Now the court knows it. The clerk still has to read us back onto his list."
        },
        {
          "prerequisites": {
            "all": [
              "z01:bond-bought"
            ],
            "any": [],
            "none": []
          },
          "text": "You bought Aulo’s lie from Vasko and tore it up in front of him. We eat. I will not stand before any court now; I have too much to lose again.",
          "survives": [
            "z01-claimant-feed"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:claimant-declared"
            ],
            "any": [],
            "none": []
          },
          "text": "We ate from the claimant’s cart tonight, at the end of the queue where every clerk could watch. Her clerk wrote our name in her own book. The Senate’s book still has a line through it.",
          "survives": [
            "z01-exemption",
            "z01-irra-bread",
            "z01-irra-bond"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:irra-witness"
            ],
            "any": [],
            "none": []
          },
          "text": "I will tell the court what I told you. Aulo pulled carts, then he drowned, then he swore. Only two of those are possible.",
          "survives": [
            "z01-exemption",
            "z01-irra-bread"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:irra-exempted"
            ],
            "any": [],
            "none": []
          },
          "text": "An exemption. Six cuts from a stranger’s purse, and we eat this season. Next season the list is read again."
        },
        {
          "prerequisites": {
            "all": [
              "z01:irra-fed"
            ],
            "any": [],
            "none": []
          },
          "text": "Bread for today. Thank you. The list is read again tomorrow."
        },
        {
          "prerequisites": {
            "all": [
              "z01:bond-lead"
            ],
            "any": [],
            "none": []
          },
          "text": "Aulo the carter swore to my husband’s debt. Aulo drowned in the flood two winters before he swore. Ask the advocate how that works. I have."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "They struck us in spring. My husband’s debt was sold with ninety-five others to pay for the bread fund. So the bread fund does not feed us, because we owe it. The clerk says that is not a joke."
        }
      ]
    },
    {
      "id": "z01-claimant",
      "personId": "person:z01-claimant",
      "name": "Liria Castel",
      "beatId": "beat:z01-basilica",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z01:claimant-declared"
            ],
            "any": [],
            "none": []
          },
          "text": "You stood at my dais and the Senate’s clerks wrote it down. The struck households eat from my granary tonight. Remember whose bread it was."
        },
        {
          "prerequisites": {
            "all": [
              "z01:claimant-met",
              "z01:holder-brz"
            ],
            "any": [],
            "none": []
          },
          "text": "The Standard hung its sun over my dais and calls it protection. I feed three hundred households from my own granary. The register feeds fewer this week."
        },
        {
          "prerequisites": {
            "all": [
              "z01:claimant-met"
            ],
            "any": [],
            "none": []
          },
          "text": "I feed three hundred households from my own granary. The Senate calls that buying a crowd. The Senate’s register feeds fewer this week."
        },
        {
          "prerequisites": {
            "all": [
              "past:z01:claimant-declared"
            ],
            "any": [],
            "none": []
          },
          "text": "Liria Castel. An earlier traveller stood at my dais, and the Senate’s clerks wrote it down. Half the queue calls me empress now. The other half is still in it."
        },
        {
          "prerequisites": {
            "all": [
              "z01:holder-brz"
            ],
            "any": [],
            "none": []
          },
          "text": "Liria Castel. The Standard sits beside me now, which the Senate calls proof that I am a pretender. Ask what you like."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Liria Castel. The Senate will tell you I am a pretender. They will say it from the old dais, because I am sitting on the new one."
        }
      ]
    },
    {
      "id": "z01-advocate",
      "personId": "person:z01-testimony-advocate",
      "name": "Advocate Idrin Vasko",
      "beatId": "beat:z01-basilica",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "finale:n03:struck"
            ],
            "any": [],
            "none": []
          },
          "text": "Struck, on a porter’s habit and a woman in a shawl. I will remember her. Next time I buy my witnesses living."
        },
        {
          "prerequisites": {
            "all": [
              "finale:n03:bought"
            ],
            "any": [],
            "none": []
          },
          "text": "We have come to terms, the Silt Stair and I. The reading stays on the roll. Good evidence keeps."
        },
        {
          "prerequisites": {
            "all": [
              "finale:n03:lost"
            ],
            "any": [],
            "none": []
          },
          "text": "The granary is ours. The court heard the dead, as it always has, and nobody answered them."
        },
        {
          "prerequisites": {
            "all": [
              "finale:court-sat"
            ],
            "any": [],
            "none": []
          },
          "text": "The court has heard Leth An. It will wait one sitting for your answer, and so will I."
        },
        {
          "prerequisites": {
            "all": [
              "finale:claim-heard"
            ],
            "any": [],
            "none": []
          },
          "text": "The court sits when the benches are full. Bring whoever you like. Ildren Vos will bring Leth An."
        },
        {
          "prerequisites": {
            "all": [
              "finale:hearing"
            ],
            "any": [],
            "none": []
          },
          "text": "The Silt Stair’s outsider. You will have heard what I claim, and on whose word."
        },
        {
          "prerequisites": {
            "all": [
              "z01:bonds-void"
            ],
            "any": [],
            "none": []
          },
          "text": "Eleven bonds voided on a flood register. I will buy the next eleven more carefully. This court has taken the word of the dead before, and it will again, once the dead are better prepared."
        },
        {
          "prerequisites": {
            "all": [
              "z01:advocate-confronted"
            ],
            "any": [],
            "none": []
          },
          "text": "So Aulo drowned, and yet he swore, and the court accepted it. You find that strange. The court did not."
        },
        {
          "prerequisites": {
            "all": [
              "z01:bond-bought"
            ],
            "any": [],
            "none": []
          },
          "text": "A pleasure. The Senth bond is torn, and I am twelve cuts nearer my next purchase."
        },
        {
          "prerequisites": {
            "all": [
              "z01:runner-beaten"
            ],
            "any": [],
            "none": []
          },
          "text": "My runner died on the archive stair, and I have filed a complaint against a person unknown. This court is patient with the dead. It may yet ask him who.",
          "survives": [
            "z01-advocate-ask"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z01:advocate-met"
            ],
            "any": [],
            "none": []
          },
          "text": "I buy debts the Senate sold, and I see them honoured. Every one of the ninety-six was sworn before this court. If you want to buy one back, I am reasonable."
        },
        {
          "prerequisites": {
            "all": [
              "past:finale:n03:struck"
            ],
            "any": [],
            "none": []
          },
          "text": "Idrin Vasko, advocate. An earlier traveller brought a porter’s friend into this basilica and had my best reading struck. I buy living witnesses now, when I can get them."
        },
        {
          "prerequisites": {
            "all": [
              "past:z01:bonds-void"
            ],
            "any": [],
            "none": []
          },
          "text": "Idrin Vasko, advocate. An earlier traveller had eleven of my bonds voided on a flood register. I buy more carefully now. My witnesses are alive, or at least better prepared."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Idrin Vasko, advocate. If you have come about the bread register, you have come to the wrong dais. I only hold the debts."
        }
      ]
    },
    {
      "id": "z02-sereth",
      "personId": "person:z02-sereth-vann",
      "name": "Hull Delegate Sereth Vann",
      "beatId": "beat:z02-mole-berths",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "errand:z02:grain-hull"
            ],
            "any": [],
            "none": []
          },
          "text": "My crews are paid and the hull is empty. The Namar masters took the rest of the fleet home. Nacre will go short this winter, and the crews will be blamed for it, not you."
        },
        {
          "prerequisites": {
            "all": [
              "z02:redeemed"
            ],
            "any": [],
            "none": []
          },
          "text": "The guarantee holds and the hatches are open. My crews unload for wages again. Your barges go first; the queue here goes after."
        },
        {
          "prerequisites": {
            "all": [
              "z02:gangway-cleared"
            ],
            "any": [],
            "none": []
          },
          "text": "The gangway is clear. Say the word and my crews open her hatches onto your barges."
        },
        {
          "prerequisites": {
            "all": [
              "z02:crew-paid"
            ],
            "any": [],
            "none": []
          },
          "text": "My crews are paid and standing by her hatches. The broker’s hook-hand is still on the gangway, and she is not paid to move.",
          "survives": [
            "z02-tamsa-protect"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:tamsa-protected"
            ],
            "any": [],
            "none": []
          },
          "text": "The crews carry Tamsa Brin’s bond now. The Convener will hear of it by the evening tide, and he will not like the vote he would need to undo it."
        },
        {
          "prerequisites": {
            "all": [
              "z02:guarantee-disputed"
            ],
            "any": [],
            "none": []
          },
          "text": "No guarantee, no unloading. My crews emptied the first lighter for nothing, and the broker holds our wage shares until the guarantee is settled. If you want grain more than you want the Convener’s blessing, talk to me.",
          "survives": [
            "z02-sereth-fleet"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:errand:z02:grain-hull"
            ],
            "any": [],
            "none": []
          },
          "text": "Sereth Vann, hull delegate. The last time an outsider paid my crews, we emptied a Namar hull at this pier and the fleet went home. The masters still talk about it. So do the crews, more kindly.",
          "survives": [
            "z02-sereth-fleet"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:holder-sen"
            ],
            "any": [],
            "none": []
          },
          "text": "Sereth Vann, hull delegate for the crews. The Senate holds the harbour gate now, and still needs Compact shipmasters to bring anything through it. That fleet will not unload. Ask at the sale court why.",
          "survives": [
            "z02-sereth-fleet"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Sereth Vann. I speak for the crews, whose wage shares buy us a small voice in the Compact. That fleet has lain at anchor four days, full, and nobody will say why it will not unload. Ask at the sale court.",
          "survives": [
            "z02-sereth-fleet"
          ]
        }
      ]
    },
    {
      "id": "z02-inspector",
      "personId": "person:z02-quay-inspector",
      "name": "Inspector Garo Tessin",
      "beatId": "beat:z02-sale-court",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "errand:z02:grain-hull"
            ],
            "any": [],
            "none": []
          },
          "text": "A hull emptied at the pier without a guarantee, and three sailing home full. I have written it down as theft, because it is, and as the Silt Stair’s grain, because it is that too.",
          "survives": [
            "continuation-unpaid-sellsword-held",
            "continuation-unpaid-sellsword-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:dead-testimony"
            ],
            "any": [],
            "none": []
          },
          "text": "Redeemed, on the pilot’s word as Vos read it. I wrote it down as his. The court has done that before. After today it will find it easier.",
          "survives": [
            "continuation-unpaid-sellsword-held",
            "continuation-unpaid-sellsword-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:harbour-due"
            ],
            "any": [],
            "none": []
          },
          "text": "Redeemed, less the Senate’s fifth. Your court’s grain is on the balance, and the harbour office thanks you for its due.",
          "survives": [
            "continuation-unpaid-sellsword-held",
            "continuation-unpaid-sellsword-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:redeemed"
            ],
            "any": [],
            "none": []
          },
          "text": "Redeemed, forty measures a note, weighed on the balance in front of everyone. Your grain goes up the canal on the next barges.",
          "survives": [
            "continuation-unpaid-sellsword-held",
            "continuation-unpaid-sellsword-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:guarantee-disputed"
            ],
            "any": [],
            "none": []
          },
          "text": "Your notes are good paper against a disputed guarantee, which makes them paper. Settle the guarantee, and I will weigh your grain myself.",
          "survives": [
            "continuation-unpaid-sellsword-held",
            "continuation-unpaid-sellsword-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "errand:z01:underway"
            ],
            "any": [],
            "none": [
              "z02:guarantee-disputed"
            ]
          },
          "text": "A Caldris docket in your other hand? Caldris counts grain against a bread register; we count it against a guarantee. Neither of us will count yours twice.",
          "survives": [
            "continuation-unpaid-sellsword-held",
            "continuation-unpaid-sellsword-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "story:false-report"
            ],
            "any": [],
            "none": []
          },
          "text": "Inspector Garo Tessin. Your name is on a Silt Stair manifest: a coffin signed out as lost cargo. At Nacre we call that corpse cargo, and we inspect it. What have you brought me?",
          "survives": [
            "continuation-unpaid-sellsword-held",
            "continuation-unpaid-sellsword-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:holder-sen"
            ],
            "any": [],
            "none": []
          },
          "text": "Inspector Garo Tessin, for the Senate’s harbour office now. The Compact kept me on because I can read its notes. Notes for redemption? Bring them to the platform.",
          "survives": [
            "continuation-unpaid-sellsword-held",
            "continuation-unpaid-sellsword-open"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Inspector Garo Tessin. I clear cargo, and I redeem notes when there is a guarantee behind them. Notes for redemption? Bring them to the platform.",
          "survives": [
            "continuation-unpaid-sellsword-held",
            "continuation-unpaid-sellsword-open"
          ]
        }
      ]
    },
    {
      "id": "z02-maurel",
      "personId": "person:z02-maurel-neth",
      "name": "Convener Maurel Neth",
      "beatId": "beat:z02-sale-court",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "errand:z02:concession"
            ],
            "any": [],
            "none": []
          },
          "text": "A good lease, fairly signed. Your court will curse my name for twenty years and use my landing every one of them."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:guarantee-witness"
            ],
            "any": [],
            "none": []
          },
          "text": "The Compact honours what it swears. You made sure the whole sale court watched it do so. I will remember the price of that lesson, and so will your ropemaker."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:dead-testimony"
            ],
            "any": [],
            "none": []
          },
          "text": "You bought a drowned man’s voice to beat me. My clerk tried the same, and Vos charged him more. Now the sale court takes the dead at their word. Remember that you taught it."
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:grain-hull"
            ],
            "any": [],
            "none": []
          },
          "text": "One hull of grain taken at my pier, and three hulls of relief sailing home to Namar. Nacre will be hungry this winter; the Silt Stair will not. I hope your court thinks it a fair trade."
        },
        {
          "prerequisites": {
            "all": [
              "z02:terms-heard"
            ],
            "any": [],
            "none": []
          },
          "text": "Twenty years of berths for one winter’s bread. Ask anyone who was hungry last winter whether that is a fair price.",
          "survives": [
            "z02-maurel-bonds"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:errand:z02:concession"
            ],
            "any": [],
            "none": []
          },
          "text": "Maurel Neth, Convener. An earlier traveller signed your court’s landing to me for twenty years, and my clerk measures its berths every spring. What have you come to sign?",
          "survives": [
            "z02-maurel-bonds"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:holder-sen"
            ],
            "any": [],
            "none": []
          },
          "text": "Maurel Neth. The Senate holds this harbour’s gate, and I hold its guarantees. The Senate cannot sail a fleet. I can. Remember that when you choose whom to ask.",
          "survives": [
            "z02-maurel-bonds"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Maurel Neth, Convener of the Salt Compact. What arrives is worth more than what is promised. You look like someone who has brought a promise.",
          "survives": [
            "z02-maurel-bonds"
          ]
        }
      ]
    },
    {
      "id": "z02-vos",
      "personId": "person:z02-ildren-vos",
      "name": "Ildren Vos",
      "beatId": "beat:z02-bonded-warehouse",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z02:heddo-buried"
            ],
            "any": [],
            "none": []
          },
          "text": "You bought my pilot to bury him. Sentimental, and it cost the Convener’s clerk his reading too. There are other drowned men.",
          "survives": [
            "z02-vos-buyers",
            "continuation-hedge-binder-held",
            "continuation-hedge-binder-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "pressure:z02:dead-testimony"
            ],
            "any": [],
            "none": []
          },
          "text": "The sale court wrote Heddo’s words down as his. Next time it will send me the drowned man itself. You opened that door; I only stood in it.",
          "survives": [
            "z02-vos-buyers",
            "continuation-hedge-binder-held",
            "continuation-hedge-binder-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:vos-hired"
            ],
            "any": [],
            "none": []
          },
          "text": "Heddo is salted and ready. Bring me to the platform when you want him heard.",
          "survives": [
            "z02-vos-buyers",
            "continuation-hedge-binder-held",
            "continuation-hedge-binder-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:tables-seen"
            ],
            "any": [],
            "none": []
          },
          "text": "You have met Heddo. He was a good pilot; his hand still knows the lead line. What he swore is for the court to hear, and for me to read.",
          "survives": [
            "z02-vos-buyers",
            "continuation-hedge-binder-held",
            "continuation-hedge-binder-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:errand:z02:dead-testimony"
            ],
            "any": [],
            "none": []
          },
          "text": "Ildren Vos. An earlier traveller brought my tables onto the sale court’s platform. The court sends me its drowned itself now.",
          "survives": [
            "continuation-hedge-binder-held",
            "continuation-hedge-binder-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:z01:bonds-void"
            ],
            "any": [],
            "none": []
          },
          "text": "Ildren Vos. An earlier traveller had eleven of Advocate Vasko’s bonds voided in Caldris. He buys my readings. He buys more careful ones now.",
          "survives": [
            "continuation-hedge-binder-held",
            "continuation-hedge-binder-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "story:false-report"
            ],
            "any": [],
            "none": []
          },
          "text": "Ildren Vos. You signed a coffin out as lost cargo at the Silt Stair; the manifest came down with the salt. Then you know what paper is for.",
          "survives": [
            "continuation-hedge-binder-held",
            "continuation-hedge-binder-open"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Ildren Vos. I read what the dead keep. Most people stand where you are standing and decide they did not come in.",
          "survives": [
            "continuation-hedge-binder-held",
            "continuation-hedge-binder-open"
          ]
        }
      ]
    },
    {
      "id": "z02-tamsa",
      "personId": "person:z02-bonded-ropemaker",
      "name": "Tamsa Brin",
      "beatId": "beat:z02-rope-walk",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "errand:z02:guarantee-witness"
            ],
            "any": [],
            "none": []
          },
          "text": "I said it on the platform, and the Convener nodded as if he had been waiting for someone to. My bond is on the crews’ roll. I still owe it. Nobody can sell it now.",
          "survives": [
            "z02-heddo-bury",
            "continuation-escaped-worker-held",
            "continuation-escaped-worker-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:dead-testimony"
            ],
            "any": [],
            "none": []
          },
          "text": "They asked Heddo instead of me. Vos moved his hand and said the words for him. They were the right words. I do not know why that is worse.",
          "survives": [
            "z02-heddo-bury",
            "continuation-escaped-worker-held",
            "continuation-escaped-worker-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:concession"
            ],
            "any": [],
            "none": []
          },
          "text": "So the Convener got his landing. The guarantee was sworn plain, and nobody asked me. I suppose that is what witnesses are for: not being asked.",
          "survives": [
            "z02-heddo-bury",
            "continuation-escaped-worker-held",
            "continuation-escaped-worker-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "errand:z02:grain-hull"
            ],
            "any": [],
            "none": []
          },
          "text": "The fleet went home full and the crews got their wages. The rope walk will be quiet this winter. Nobody rigs a ship that is not coming.",
          "survives": [
            "z02-heddo-bury",
            "continuation-escaped-worker-held",
            "continuation-escaped-worker-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:heddo-buried"
            ],
            "any": [],
            "none": [
              "z02:tamsa-witness"
            ]
          },
          "text": "You paid to bury Heddo. He would have laughed at the expense, and then he would have stood you a drink. The crews put him behind the shrine, where the knots are.",
          "survives": [
            "z02-rope-work",
            "continuation-escaped-worker-held",
            "continuation-escaped-worker-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:tamsa-witness"
            ],
            "any": [],
            "none": []
          },
          "text": "I will say it on the platform, in his hearing, the way Heddo made him say it. Take me to the sale court when you are ready.",
          "survives": [
            "z02-rope-work",
            "z02-heddo-bury",
            "continuation-escaped-worker-held",
            "continuation-escaped-worker-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:tamsa-protected"
            ],
            "any": [],
            "none": []
          },
          "text": "Sereth’s people came by. They say the crews carry my bond now. Is that your doing?",
          "survives": [
            "z02-rope-work",
            "continuation-escaped-worker-held",
            "continuation-escaped-worker-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:oath-heard"
            ],
            "any": [],
            "none": []
          },
          "text": "I told you what was sworn. I cannot say it on the platform. Not while the Convener holds my bond.",
          "survives": [
            "z02-rope-work",
            "continuation-escaped-worker-held",
            "continuation-escaped-worker-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z02:rope-walked"
            ],
            "any": [],
            "none": []
          },
          "text": "You walk rope like someone nobody has told how. Keep your hands wet. The hemp takes the skin off dry hands.",
          "survives": [
            "continuation-escaped-worker-held",
            "continuation-escaped-worker-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:errand:z02:guarantee-witness"
            ],
            "any": [],
            "none": []
          },
          "text": "Tamsa Brin. An earlier traveller got my bond onto the crews’ roll and me onto the sale court’s platform. The crews still carry me. I have almost paid it.",
          "survives": [
            "continuation-escaped-worker-held",
            "continuation-escaped-worker-open"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Tamsa Brin. Famine passage from Vannic, on a recovery bond, so I walk rope until the bond is paid. The bond has no end written on it. I have looked.",
          "survives": [
            "continuation-escaped-worker-held",
            "continuation-escaped-worker-open"
          ]
        }
      ]
    },
    {
      "id": "z06-factor",
      "personId": "person:z06-toll-factor",
      "name": "Factor Aurin Tessel",
      "beatId": "beat:z06-toll-shelter",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z06:arch-closed"
            ],
            "any": [],
            "none": []
          },
          "text": "The arch is closed and the lease with it. The Compact will ask me who paid for a keystone it was paying not to lift. I shall tell them the truth: a stranger with a court’s letter and an opinion.",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:guard-beaten"
            ],
            "any": [],
            "none": []
          },
          "text": "You killed a man the Compact hired to stand by a chain. His price will be written against every outsider who comes up this road until somebody pays it.",
          "survives": [
            "z06-carts-through",
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:coffins-held"
            ],
            "any": [],
            "none": []
          },
          "text": "Six bodies under Caldris court seals, sold west as testimony. The Compact does not carry what a court will not bury. Your carts crossed on the Compact’s thanks.",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:coffins-passed"
            ],
            "any": [],
            "none": []
          },
          "text": "Court carriage, your letter says, and I have written court carriage. I have also written the carter’s name, and yours.",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:roll-countersigned"
            ],
            "any": [],
            "none": []
          },
          "text": "The roll stands on your court’s seal now, and the chain came down for it. If a Caldris advocate asks after those bonds, I will send him to the Silt Stair.",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:lease-signed"
            ],
            "any": [],
            "none": []
          },
          "text": "The Silt Stair is a party to the lease. Its carts cross free this season, and it shares the renewal levy when the season turns. Every party does. It is all in the tablet.",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:toll-paid"
            ],
            "any": [],
            "none": []
          },
          "text": "Your toll is entered. The chain came down for the court’s carts as it comes down for anyone’s. I find that restful.",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:travellers-across"
            ],
            "any": [],
            "none": []
          },
          "text": "Thirty-one people and six carts over the old ford, and not a cut paid at my chain. Wenna Coll will hear from the Compact.",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:lease-read",
              "z06:holder-brz"
            ],
            "any": [],
            "none": []
          },
          "text": "Walkers cross the planks for nothing. Wheels pay the repair rate, and the Standard’s depot officer takes a quarter of it for the army. Or the court that owns the wheels becomes a party to the lease, and they cross free.",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:lease-read"
            ],
            "any": [],
            "none": []
          },
          "text": "Walkers cross the planks for nothing. Wheels pay the repair rate until the causeway is sound: {cuts:z06-toll-pay} for six carts. Or the court that owns the wheels becomes a party to the lease, and they cross free. Both are fair. I can explain why at length.",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "legacy:refused:causeway-chain"
            ],
            "any": [],
            "none": []
          },
          "text": "Aurin Tessel, factor. I know your kind by the chalk on my table: the last outsider over this chain came with a blade. The Compact takes no toll from you here until the guard’s price is paid.",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "legacy:took:causeway-chain"
            ],
            "any": [],
            "none": []
          },
          "text": "Aurin Tessel, factor. Somebody paid the dead guard’s price in an outsider’s name, and I have rubbed the chalk off my table. What are you bringing over?",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:z06:lease-signed"
            ],
            "any": [],
            "none": []
          },
          "text": "Aurin Tessel, factor to the Compact. The Silt Stair court is a party to our lease; an earlier traveller signed it in. So you and I are partners, in a small way. It costs you nothing today.",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:z06:guard-beaten"
            ],
            "any": [],
            "none": []
          },
          "text": "Aurin Tessel, factor. Forgive the extra guards. An earlier traveller came over this chain with a blade, and the Compact keeps a long memory for the men it hires.",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:holder-brz"
            ],
            "any": [],
            "none": []
          },
          "text": "Aurin Tessel, factor to the Salt Compact, which holds this causeway’s toll-and-repair lease. The Standard holds the road, for now; it lets me collect and takes a quarter. Walkers cross free. What are you bringing over?",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Aurin Tessel, factor to the Salt Compact, which holds this causeway’s toll-and-repair lease. Walkers cross free. Wheels pay for the repair. What are you bringing over?",
          "survives": [
            "continuation-intelligence-runner-held",
            "continuation-intelligence-runner-open"
          ]
        }
      ]
    },
    {
      "id": "z06-mason",
      "personId": "person:z06-bonded-mason",
      "name": "Temmo Sard",
      "beatId": "beat:z06-broken-span",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z06:arch-closed"
            ],
            "any": [],
            "none": []
          },
          "text": "It holds. I knew it would; I cut that stone in spring. Tomorrow they send us up the quarry road to cut more. The bond does not care where I stand."
        },
        {
          "prerequisites": {
            "all": [
              "z06:roll-countersigned"
            ],
            "any": [],
            "none": []
          },
          "text": "My bond’s on your court’s seal now, under a dead man’s. It was bigger than me before. Now it has a court behind it."
        },
        {
          "prerequisites": {
            "all": [
              "z06:clause-known",
              "z06:bond-heard"
            ],
            "any": [],
            "none": []
          },
          "text": "The stone’s ready, and I’m not going anywhere. Don’t say it where the guard can hear."
        },
        {
          "prerequisites": {
            "all": [
              "z06:clause-known"
            ],
            "any": [],
            "none": []
          },
          "text": "Don’t say it where the guard can hear. The stone’s ready. The lease isn’t."
        },
        {
          "prerequisites": {
            "all": [
              "z06:bond-heard"
            ],
            "any": [],
            "none": []
          },
          "text": "Eleven years on this bond. Ask me about the arch instead. That, at least, could be finished."
        },
        {
          "prerequisites": {
            "all": [
              "past:z06:arch-closed"
            ],
            "any": [],
            "none": []
          },
          "text": "Temmo Sard. I have cut the keystone for this span twice now. An earlier traveller paid to set the first. The rain took the arch beside it, so here I am, with another stone in the yard."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Temmo Sard. I’m on the hoist. Mind the rope; nobody has pulled it since spring, and it has opinions."
        }
      ]
    },
    {
      "id": "z06-contractor",
      "personId": "person:z06-works-contractor",
      "name": "Livra Cantor",
      "beatId": "beat:z06-repair-camp",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z06:arch-closed"
            ],
            "any": [],
            "none": []
          },
          "text": "Closed and sound. Best arch on this road, and I have built four. The Compact won’t hire me again, and I don’t care. The gang cares. They go up the quarry road tomorrow."
        },
        {
          "prerequisites": {
            "all": [
              "z06:carts-across"
            ],
            "any": [],
            "none": []
          },
          "text": "Your lime’s gone over. The court paid for it, I burnt it, it’s theirs. What happens at the chain was never my business.",
          "survives": [
            "z06-contractor-work"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:clause-known"
            ],
            "any": [],
            "none": []
          },
          "text": "Temmo told you about the keystone. Yes: cut, dressed, and under canvas in my yard. The Compact pays me by the season to keep a gang on these works, and the season ends the day that stone goes in. Pay the gang’s day and I’ll set it. I would rather finish it.",
          "survives": [
            "z06-contractor-lime",
            "z06-contractor-work"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:worked"
            ],
            "any": [],
            "none": []
          },
          "text": "You pulled like somebody who has been told how. The gang will talk about you tonight. Not kindly, but they’ll talk.",
          "survives": [
            "z06-contractor-lime"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:lime-seen"
            ],
            "any": [],
            "none": []
          },
          "text": "Six carts, shafts down. The carters eat my lentils while they wait for the chain. It comes down for coin or for a signature on the lease. Or Wenna takes carts round it at the old ford, when the water is low."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [
              "fact:outcome-licensed-atrocity",
              "fact:outcome-departure-failure"
            ],
            "none": []
          },
          "text": "Livra Cantor, works. Your Silt Stair still burns lime at its own kilns, I hear, and sells it cheaper than mine. Your court bought mine anyway. I don’t ask why."
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Livra Cantor, works. The Silt Stair’s kilns have gone cold, I hear. That is why your court is buying my lime."
        }
      ]
    },
    {
      "id": "z06-guide",
      "personId": "person:z06-ford-guide",
      "name": "Wenna Coll",
      "beatId": "beat:z06-old-ford",
      "lines": [
        {
          "prerequisites": {
            "all": [
              "z06:travellers-across"
            ],
            "any": [],
            "none": []
          },
          "text": "Six carts and thirty-one people over on one dry afternoon. The factor will fine me. It was worth a fine.",
          "survives": [
            "continuation-serekh-exile-held",
            "continuation-serekh-exile-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:ford-high"
            ],
            "any": [],
            "none": []
          },
          "text": "Not today. It came up in the night, brown and fast. It’ll drop in a day, or two, or it’ll rain again. I don’t take wheels through that. I pulled a carter out of it once.",
          "survives": [
            "continuation-serekh-exile-held",
            "continuation-serekh-exile-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "legacy:refused:causeway-ford"
            ],
            "any": [],
            "none": []
          },
          "text": "Wenna Coll. There’s a fine on my slate an outsider left me, and I don’t take outsiders’ carts through till it’s paid.",
          "survives": [
            "continuation-serekh-exile-held",
            "continuation-serekh-exile-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "legacy:took:causeway-ford"
            ],
            "any": [],
            "none": []
          },
          "text": "Wenna Coll. Somebody paid the fine an outsider left me, and sent word it was you. Your carts go through cheap, while the water’s low.",
          "survives": [
            "continuation-serekh-exile-held",
            "continuation-serekh-exile-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "past:z06:travellers-across"
            ],
            "any": [],
            "none": []
          },
          "text": "Wenna Coll. I take carts through when the Compact’s man on the stone looks the other way. An earlier traveller brought the whole camp over behind their carts, and I paid the fine. I’d do it again.",
          "survives": [
            "continuation-serekh-exile-held",
            "continuation-serekh-exile-open"
          ]
        },
        {
          "prerequisites": {
            "all": [
              "z06:holder-brz"
            ],
            "any": [],
            "none": []
          },
          "text": "Wenna Coll. I take carts through the ford when the water’s low, for less than the chain costs. The Standard’s men don’t mind. The factor does.",
          "survives": [
            "continuation-serekh-exile-held",
            "continuation-serekh-exile-open"
          ]
        },
        {
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "text": "Wenna Coll. I take carts through the ford when the water’s low, for less than the chain costs. The factor calls that evading his toll. The ford was the road before there was a road.",
          "survives": [
            "continuation-serekh-exile-held",
            "continuation-serekh-exile-open"
          ]
        }
      ]
    }
  ],
  "routes": [
    {
      "fromBeatId": "beat:middle-market-cold-bath",
      "toBeatId": "beat:eastern-road-lock-foot",
      "prerequisites": {
        "all": [
          "story:drain-known"
        ],
        "any": [],
        "none": [
          "side:route-sold",
          "side:sluice-flushed"
        ]
      }
    },
    {
      "fromBeatId": "beat:eastern-road-lock-foot",
      "toBeatId": "beat:middle-market-cold-bath",
      "prerequisites": {
        "all": [
          "story:drain-known"
        ],
        "any": [],
        "none": [
          "side:route-sold",
          "side:sluice-flushed"
        ]
      }
    },
    {
      "fromBeatId": "beat:toll-stair",
      "toBeatId": "beat:middle-market-cold-bath",
      "prerequisites": {
        "all": [
          "story:toll-pass"
        ],
        "any": [],
        "none": []
      },
      "reason": "Pay the toll or agree a service with the guard."
    },
    {
      "fromBeatId": "beat:eastern-road-lock-foot",
      "toBeatId": "z04-gate-of-accounts",
      "prerequisites": {
        "all": [],
        "any": [
          "fact:kiln-access",
          "fact:outcome-departure-failure"
        ],
        "none": []
      },
      "reason": "The kiln gate stays shut without a name for the missing burial. Attach one through the wage tally — or read a deposited comparison at the landing and carry its warrant from Reeve’s Court.",
      "distanceKm": 9
    },
    {
      "fromBeatId": "z04-gate-of-accounts",
      "toBeatId": "beat:eastern-road-lock-foot",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "distanceKm": 9
    },
    {
      "fromBeatId": "z04-gate-of-accounts",
      "toBeatId": "z04-dry-cut",
      "prerequisites": {
        "all": [
          "fact:outcome-departure-failure"
        ],
        "any": [],
        "none": [
          "fact:kiln-access"
        ]
      }
    },
    {
      "fromBeatId": "z04-dry-cut",
      "toBeatId": "z04-gate-of-accounts",
      "prerequisites": {
        "all": [
          "fact:outcome-departure-failure"
        ],
        "any": [],
        "none": [
          "fact:kiln-access"
        ]
      }
    },
    {
      "fromBeatId": "z04-gate-of-accounts",
      "toBeatId": "z04-cooling-court",
      "prerequisites": {
        "all": [
          "fact:kiln-access"
        ],
        "any": [],
        "none": []
      },
      "reason": "The work floors stay closed without a name for the missing burial. The path outside the wall connects the gate and the Dry Cut."
    },
    {
      "fromBeatId": "z04-gate-of-accounts",
      "toBeatId": "z04-cart-ramp-office",
      "prerequisites": {
        "all": [
          "fact:kiln-access"
        ],
        "any": [],
        "none": []
      },
      "reason": "The work floors stay closed without a name for the missing burial. The path outside the wall connects the gate and the Dry Cut."
    },
    {
      "fromBeatId": "z04-dry-cut",
      "toBeatId": "z04-lower-work-gallery",
      "prerequisites": {
        "all": [
          "fact:kiln-access"
        ],
        "any": [],
        "none": []
      },
      "reason": "The work floors stay closed without a name for the missing burial. The path outside the wall connects the gate and the Dry Cut."
    },
    {
      "fromBeatId": "z04-dry-cut",
      "toBeatId": "z04-selas-rooms",
      "prerequisites": {
        "all": [
          "fact:kiln-access"
        ],
        "any": [],
        "none": []
      },
      "reason": "The work floors stay closed without a name for the missing burial. The path outside the wall connects the gate and the Dry Cut."
    },
    {
      "fromBeatId": "beat:eastern-road-lock-foot",
      "toBeatId": "beat:z01-river-bridge",
      "prerequisites": {
        "all": [],
        "any": [
          "z01:docket",
          "z06:errand",
          "finale:hearing"
        ],
        "none": []
      },
      "reason": "The towpath barge to Caldris carries only people on court business: a grain docket, the lime letter, or a summons to the Senate court.",
      "distanceKm": 43
    },
    {
      "fromBeatId": "beat:z01-river-bridge",
      "toBeatId": "beat:eastern-road-lock-foot",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "distanceKm": 43
    },
    {
      "fromBeatId": "beat:lower-landing",
      "toBeatId": "beat:z02-mole-berths",
      "prerequisites": {
        "all": [
          "z02:notes"
        ],
        "any": [],
        "none": []
      },
      "reason": "The canal boat to Nacre Quay carries passengers on the court’s business at the coast, and the court has given you none.",
      "distanceKm": 76
    },
    {
      "fromBeatId": "beat:lower-landing",
      "toBeatId": "beat:z02-mole-berths",
      "prerequisites": {
        "all": [
          "z02:notes",
          "travel:z02-fare"
        ],
        "any": [],
        "none": []
      },
      "reason": "The canal boat to Nacre Quay takes paying or working passengers. Buy passage from the ferry clerk here, or work it at the sweeps.",
      "distanceKm": 76
    },
    {
      "fromBeatId": "beat:z02-mole-berths",
      "toBeatId": "beat:lower-landing",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "distanceKm": 76
    },
    {
      "fromBeatId": "beat:z01-river-bridge",
      "toBeatId": "beat:z06-toll-shelter",
      "prerequisites": {
        "all": [
          "z06:errand"
        ],
        "any": [],
        "none": []
      },
      "reason": "The west imperial road runs forty-four kilometres to the Broken Causeway, and nobody walks it without business. The court at Reeve’s table has carts waiting out there; ask it for its letter.",
      "distanceKm": 44
    },
    {
      "fromBeatId": "beat:z06-toll-shelter",
      "toBeatId": "beat:z01-river-bridge",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "distanceKm": 44
    },
    {
      "fromBeatId": "beat:reeves-court",
      "toBeatId": "beat:z11-comparison-court",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "distanceKm": 118
    },
    {
      "fromBeatId": "beat:z11-comparison-court",
      "toBeatId": "beat:reeves-court",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "distanceKm": 118
    },
    {
      "fromBeatId": "beat:z11-comparison-court",
      "toBeatId": "beat:z12-white-joint",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "distanceKm": 158
    },
    {
      "fromBeatId": "beat:z12-white-joint",
      "toBeatId": "beat:z11-comparison-court",
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      },
      "distanceKm": 158
    }
  ],
  "companionMoments": [
    {
      "templateId": "unpaid-shield",
      "beatId": "beat:reeves-court",
      "kept": [
        "side:fee-exemption"
      ],
      "broken": [
        "side:toll-profit"
      ],
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      }
    },
    {
      "templateId": "towpath-scout",
      "beatId": "beat:middle-market-cold-bath",
      "kept": [
        "side:route-kept"
      ],
      "broken": [
        "side:route-sold",
        "side:sluice-flushed"
      ],
      "prerequisites": {
        "all": [
          "story:drain-known"
        ],
        "any": [],
        "none": []
      }
    },
    {
      "templateId": "displaced-mason",
      "beatId": "beat:eastern-road-lock-foot",
      "kept": [
        "side:walkway-shored"
      ],
      "broken": [
        "side:sluice-flushed"
      ],
      "prerequisites": {
        "all": [],
        "any": [],
        "none": []
      }
    },
    {
      "templateId": "former-mortuary-guard",
      "beatId": "z04-lower-work-gallery",
      "kept": [
        "side:gallery-released"
      ],
      "broken": [
        "fact:operation-supported"
      ],
      "prerequisites": {
        "all": [
          "story:tether-gallery"
        ],
        "any": [],
        "none": []
      }
    }
  ],
  "evidence": [
    {
      "id": "story:wage-tally",
      "caseId": "case:z04-missing-dead",
      "kind": "document",
      "sourceKey": "silt-stair-wage-tally",
      "finding": "Leth An draws wages after his recorded burial; the money buys a lift pin.",
      "verified": true,
      "witnessId": null
    },
    {
      "id": "story:lawful-demonstration",
      "caseId": "case:z04-missing-dead",
      "kind": "lawful-demonstration",
      "sourceKey": "melian-living-treatment",
      "finding": "A living patient receives bounded warmth; no anchor or imposed bodily motion is used.",
      "verified": true,
      "witnessId": null
    },
    {
      "id": "evidence:z04-burial-register-leth",
      "kind": "document",
      "sourceKey": "z04-burial-register",
      "caseId": "case:z04-missing-dead",
      "verified": true,
      "finding": "The burial register line claims Leth An's remains were released to family; no urn was ever received",
      "witnessId": null
    },
    {
      "id": "evidence:z04-leth-grave-token",
      "kind": "physical-remains",
      "sourceKey": "z04-leth-token",
      "caseId": "case:z04-missing-dead",
      "verified": true,
      "finding": "The grave token the waiting family still holds matches the tally-marked body working the lower gallery; record and token disagree",
      "witnessId": null
    },
    {
      "id": "evidence:z04-station-ledgers",
      "kind": "document",
      "sourceKey": "z04-station-ledgers",
      "caseId": "case:z04-missing-dead",
      "verified": true,
      "finding": "Three station ledgers record bodies, patterns and reagent draws; they distinguish prepared corpse-work from ordinary funerary stock",
      "witnessId": null
    },
    {
      "id": "evidence:z04-noll-payments",
      "kind": "document",
      "sourceKey": "z04-noll-payments",
      "caseId": "case:z04-missing-dead",
      "verified": true,
      "finding": "Payments and a plan to relocate equipment; names the buyer and the grain-lift repair advance, not a world-conquering manifesto",
      "witnessId": null
    },
    {
      "id": "evidence:z04-concession-debt-bonds",
      "kind": "document",
      "sourceKey": "z04-concession-debt-bonds",
      "caseId": "case:z04-missing-dead",
      "verified": true,
      "finding": "The debt-bond drawer documents the concession's financing when no factor can be confronted",
      "witnessId": null
    },
    {
      "id": "evidence:z04-odel-testimony",
      "kind": "living-testimony",
      "sourceKey": "z04-odel-testimony",
      "caseId": "case:z04-missing-dead",
      "verified": true,
      "witnessId": "person:odel-thann",
      "finding": "Odel identifies which of the dead were taken from voluntary burial and which papers were forged"
    },
    {
      "id": "evidence:z04-odel-bond-and-tally",
      "kind": "document",
      "sourceKey": "z04-odel-bond",
      "caseId": "case:z04-missing-dead",
      "verified": true,
      "finding": "Odel's annotated work bond and his sister's bond copy name the forged papers when he cannot testify",
      "witnessId": null
    }
  ],
  "aftermath": {
    "public-dismantling": {
      "beat:middle-market-cold-bath": "A closure notice covers Noll’s price board. Two witnesses collect lodging chits at the bath; the crowd leaves a space for them.",
      "beat:reeves-court": "The closure seal has displaced Noll’s requisition. Witness copies lie on the public side of the desk.",
      "z04-gate-of-accounts": "Public clerks sit where the concession guards stood. Families queue beneath nine names. Nessa checks each handover herself."
    },
    "workers-shutdown": {
      "beat:middle-market-cold-bath": "The workers have posted their own custody notice. Odel’s sister carries both cancelled bond copies, folded together.",
      "beat:reeves-court": "The workers keep the original ledger. The official has to request a copy like everyone else.",
      "z04-gate-of-accounts": "Workers sit at the guard table with the original burial ledger. No creditor is admitted to the receiving yard."
    },
    "private-containment": {
      "beat:middle-market-cold-bath": "Trade resumes under an inspector’s seal. Someone has asked for the dead to be named on the notice. The space is still blank.",
      "beat:reeves-court": "The inspector’s agreement is filed face down. A blank space remains where the public finding would go.",
      "z04-gate-of-accounts": "An independent inspector holds the keys. The board calls it a transfer of management. Families still ask who will admit what happened."
    },
    "licensed-atrocity": {
      "beat:middle-market-cold-bath": "Noll’s repair advance is advertised above the grain stall. Melian’s shutter is barred. The space where witnesses waited is empty.",
      "beat:reeves-court": "Your concession pass has a place beside the repair requisition. The missing names do not.",
      "z04-gate-of-accounts": "Your concession pass opens the gate. The returned-token board has been wiped clean. Nine bodies continue working beyond it."
    },
    "violent-destruction": {
      "beat:middle-market-cold-bath": "People read the names of the dead guard and the stolen burial workers on separate sheets. Beside them, a grain notice names who paid.",
      "beat:reeves-court": "The guard’s death and the stolen burials occupy separate sheets. Neither cancels the other.",
      "z04-gate-of-accounts": "The guard post is empty. A burial list marks each stolen body as recoverable or destroyed. No tally gesture continues in the gallery."
    },
    "departure-failure": {
      "beat:middle-market-cold-bath": "The grain queue remains. A porter reads the unresolved burial notice, then goes back to waiting for wages.",
      "beat:reeves-court": "The repair requisition still covers half the desk. Your departure is entered on a separate slip.",
      "z04-gate-of-accounts": "The concession guards remain at their table. A family holds up a token. No one comes out to answer."
    }
  },
  "personalFindings": {
    "abandoned": "You left the Silt Stair with your personal claim unresolved."
  },
  "companionDiscussion": [
    {
      "id": "discuss:guard",
      "goal": "guard",
      "weight": 6,
      "label": "Ask about protecting each other",
      "text": "If this turns ugly, will you stay close enough that we can protect each other?"
    },
    {
      "id": "discuss:engage",
      "goal": "engage",
      "weight": 8,
      "label": "Ask whether they will press the attack",
      "text": "Will you press the attack if the guard gives ground?"
    },
    {
      "id": "discuss:withdraw",
      "goal": "withdraw",
      "weight": 6,
      "label": "Discuss getting out alive",
      "text": "If the cost becomes too high, find your way out. I will look for mine."
    }
  ],
  "personalRecords": {
    "disgraced-legionary": {
      "label": "Recover the pledged muster addendum",
      "text": "Find the order pledged against the repair advance.",
      "reply": "The quartermaster’s addendum is folded behind a loan receipt. It orders the abandonment you were blamed for. You recover the original; the public finding still has to be made.",
      "journal": "Recovered the original muster addendum. It supports the unit’s account but has not yet been entered at Reeve’s Court as a public finding.",
      "partial": "The muster addendum is recovered. The unit still needs a public finding.",
      "achieved": "The muster addendum is entered as a public finding. The Fourth Cohort was ordered to withdraw; its surviving veterans are cleared of desertion.",
      "blocked": "The muster addendum was entered, but the private settlement sealed it with the rest of the case. In public, the unit are still deserters.",
      "holds": {
        "all": [],
        "any": [],
        "none": [
          "fact:outcome-private-containment",
          "fact:outcome-licensed-atrocity",
          "fact:outcome-departure-failure"
        ]
      },
      "warnings": {
        "story:claim-closed": "Registered now, the muster addendum is never entered here for a public finding.",
        "fact:outcome-private-containment": "A private settlement seals your unit’s order with the rest of the case.",
        "fact:outcome-licensed-atrocity": "A court paid to look away never makes your unit’s order public.",
        "fact:outcome-departure-failure": "Leaving now leaves your unit on the record as deserters."
      }
    },
    "unpaid-sellsword": {
      "label": "Recover the employer’s pledged fee tally",
      "text": "Check the fee pledged against my dead employer’s estate.",
      "reply": "The tally still promises eighteen ves. Below it are claims for burials and unpaid porters. You take the original account. A promise is not a purse.",
      "journal": "Recovered the eighteen-ves fee tally. Burial charges and worker wages still compete with the claim; no fee has been paid.",
      "partial": "The fee tally is recovered. Your employer’s estate has not paid the disputed fee.",
      "achieved": "The porters were paid first from your employer’s estate, and Nessa countersigned the rest to you. You leave with nine ves of the eighteen, recorded where no one can argue it.",
      "blocked": "Nessa never countersigned: the porters’ own pouch did not reach them. Your fee tally is one more claim on a stripped estate.",
      "holds": {
        "all": [
          "side:arrears-returned"
        ],
        "any": [],
        "none": [
          "fact:outcome-departure-failure"
        ]
      },
      "warnings": {
        "story:claim-closed": "Registered now, your fee tally never reaches Nessa at the Lower Landing.",
        "side:arrears-returned": "Nessa signs your fee tally only once the porters’ own pouch from the lift yard reaches them.",
        "fact:outcome-departure-failure": "Leaving now leaves your eighteen ves to the burial dues and dock debts."
      }
    },
    "fallen-household": {
      "label": "Recover the residence deed",
      "text": "Find the deed protecting Cessa’s home.",
      "reply": "The deed is here, attached to an older confiscation schedule. You recover both. Returning the first without acknowledging the second would be a comfortable omission.",
      "journal": "Recovered Cessa’s residence deed and the confiscation schedule. Protection from eviction still needs a ruling.",
      "partial": "The deed is recovered. Cessa’s housing claim still needs a ruling on the earlier confiscation.",
      "achieved": "Cessa’s deed stands with its confiscation schedule attached. She cannot be evicted, and the dyer’s heirs draw a quit-rent from the house your family was given.",
      "blocked": "Cessa’s deed was registered, but the court that stamped it now sells its seal to the concession. Her protection is worth what the next bribe is.",
      "holds": {
        "all": [],
        "any": [],
        "none": [
          "fact:outcome-licensed-atrocity",
          "fact:outcome-departure-failure"
        ]
      },
      "warnings": {
        "story:claim-closed": "Registered now, Cessa’s deed is never entered here with its schedule.",
        "fact:outcome-licensed-atrocity": "A court that sells its seal cannot protect Cessa’s deed.",
        "fact:outcome-departure-failure": "Leaving now leaves Cessa’s house without protection."
      }
    },
    "intelligence-runner": {
      "label": "Recover the unaltered witness deposition",
      "text": "Find the original dispatch cylinder before the buyer takes it.",
      "reply": "The seal is intact. The original names your former patron; the buyer’s copy leaves that line out. You take both versions.",
      "journal": "Recovered the unaltered deposition and the manipulated copy. Deciding where to lodge the original remains your responsibility.",
      "partial": "The unaltered deposition is recovered. It has not yet been made safe from suppression.",
      "achieved": "The unaltered deposition sits in public custody with your former patron’s name intact. The buyer’s copy cannot be published against it. Your old contacts have stopped answering.",
      "blocked": "The original was lodged, but no one paid for public custody. It left the court drawer before the case closed, and the buyer’s copy is the one people will read.",
      "holds": {
        "all": [
          "fact:witnesses-protected"
        ],
        "any": [],
        "none": [
          "fact:outcome-departure-failure"
        ]
      },
      "warnings": {
        "story:claim-closed": "Registered now, the original deposition is never lodged here.",
        "fact:witnesses-protected": "The original deposition is safe only if witness custody is paid for at the Reeve’s Court before the settlement is registered.",
        "fact:outcome-departure-failure": "Leaving now leaves the buyer’s copy as the one people read."
      }
    },
    "escaped-worker": {
      "label": "Trace the linked sale copies",
      "text": "Find every broker named on the sale chain.",
      "reply": "Three offices certify the same debt. You copy the chain and recover the kiln copy. Destroying that one sheet would leave two others with the same claim.",
      "journal": "Recovered the kiln sale copy and identified the broker chain. The remaining linked copies still need invalidation.",
      "partial": "The broker chain is known. The refuge is not yet protected from the remaining sale copies.",
      "achieved": "Odel’s crew swore to the broker’s compounded interest, and the court struck all three copies of your sale with his sister’s bond. The Near Table refuge can shelter you lawfully.",
      "blocked": "Odel named the broker’s trick, but his sister’s release was never paid, so nothing went through the drawer. Two copies of your sale still stand.",
      "holds": {
        "all": [
          "fact:workers-protected"
        ],
        "any": [],
        "none": [
          "fact:outcome-departure-failure"
        ]
      },
      "warnings": {
        "story:claim-closed": "Registered now, Odel never sees the broker chain on your sale in the Cooling Court.",
        "fact:workers-protected": "Your sale copies are struck only with Odel’s sister’s bond; pay her release to Odel in the Cooling Court before the settlement is registered.",
        "fact:outcome-departure-failure": "Leaving now leaves all three copies of your sale standing."
      }
    },
    "serekh-exile": {
      "label": "Recover the family transit application",
      "text": "Find the vouchers naming Hazren and the two children.",
      "reply": "The three names are correct. The Lock Foot guarantee is blank; a margin note asks for irrigation information before it is signed. You take the unsigned vouchers.",
      "journal": "Recovered the family’s unsigned vouchers. Passage is not guaranteed; a lawful treaty argument or another agreement is still needed.",
      "partial": "The family’s vouchers are recovered but unsigned. Safe transit remains unsecured.",
      "achieved": "Hazren and the two children crossed the shored walkway on stamped vouchers. The lock has its true water line; Sekhet Anar’s charts stayed with you.",
      "blocked": "The vouchers were stamped, but the low walkway was never made safe. Hazren will not take the children across it, and they are still waiting in the cellar at Lock Foot.",
      "holds": {
        "all": [
          "side:walkway-shored"
        ],
        "any": [],
        "none": [
          "fact:outcome-departure-failure"
        ]
      },
      "warnings": {
        "story:claim-closed": "Registered now, the vouchers at Lock Foot are never answered.",
        "side:walkway-shored": "Hazren will not take the children across the low walkway at Lock Foot unless it is shored.",
        "fact:outcome-departure-failure": "Leaving now leaves Hazren and the children without passage."
      }
    },
    "hedge-binder": {
      "label": "Recover Corren’s original formula notebook",
      "text": "Find the notebook seized from Corren’s workshop.",
      "reply": "Corren’s formula is listed as collateral for the repair advance. The pages describe ordinary washes, with no binding wax. You recover the book for a witnessed comparison.",
      "journal": "Recovered Corren’s original formula notebook. Melian can compare it with a lawful preparation.",
      "partial": "The notebook is recovered. Corren’s work still needs an honest finding.",
      "achieved": "Corren’s original formula was compared with the lawful preparation in front of Melian. The court records an honest finding clearing his work of corpse-binding.",
      "blocked": "Melian witnessed the comparison, but the case never reached an open hearing. The accusation against Corren stays on the record.",
      "holds": {
        "all": [],
        "any": [],
        "none": [
          "fact:outcome-private-containment",
          "fact:outcome-licensed-atrocity",
          "fact:outcome-departure-failure"
        ]
      },
      "warnings": {
        "story:claim-closed": "Registered now, Corren’s formula is never compared with Melian’s at the market.",
        "fact:outcome-private-containment": "A private settlement never gives Corren’s work an open finding.",
        "fact:outcome-licensed-atrocity": "A court paid to look away never clears Corren’s name.",
        "fact:outcome-departure-failure": "Leaving now leaves the accusation on Corren’s name."
      }
    },
    "grave-witness": {
      "label": "Recover Theron’s burial receipt and transfer entry",
      "text": "Find the record for my brother’s paid burial.",
      "reply": "Theron’s receipt bears a reassigned niche number. A transfer entry shows that the paid burial was not honoured, but gives no reliable final location. You take the records, not a claim that you have found him.",
      "journal": "Recovered Theron’s paid burial receipt and the altered transfer entry. The reassigned niche number can be read against the Cooling Court columbarium.",
      "partial": "The false burial account is exposed. Theron’s final resting place remains unverified.",
      "achieved": "Theron’s body was found on the vault station roster and released without fire. It goes into a niche with his own name on it.",
      "blocked": "Theron’s body was named on the vault station roster, but it never came out of the kilns in a state anyone could bury. The receipt still names an empty niche.",
      "holds": {
        "all": [],
        "any": [],
        "none": [
          "story:stations-burned",
          "fact:outcome-licensed-atrocity",
          "fact:outcome-departure-failure"
        ]
      },
      "warnings": {
        "story:claim-closed": "Registered now, Theron’s niche is never read against the vault roster in the Cooling Court.",
        "story:stations-burned": "Fire leaves nothing of Theron’s body to bury.",
        "fact:outcome-licensed-atrocity": "Under a bought court, Theron’s body goes on working.",
        "fact:outcome-departure-failure": "Leaving now leaves Theron unburied."
      }
    }
  },
  "deathFinding": "You died before securing a finding on your personal goal. The claim remains unresolved.",
  "shortNames": {
    "Leth": "Leth An",
    "Nessa": "Nessa Tal",
    "Melian": "Melian Sar",
    "Noll": "Tavren Noll",
    "Sela": "Sela Venn",
    "Odel": "Odel Thann"
  },
  "narration": {
    "deathAccount": "Your death ended the investigation. Funded wages are paid; the grain, workers and nine stolen dead are entered in the failure account.",
    "kitchenOath": "Pay six cuts to the bath kitchen.",
    "sideBread": "The porter handcart supplies the bath bread stall independently of the lift.",
    "gateFamilies": "Families keep a handover watch at the cleared gate.",
    "galleryBurned": "The sorting floor is blackened. The imposed tally motion has stopped; the body cannot be identified.",
    "galleryReleased": "Leth’s hands lie still. His name has been placed beside him. Nobody answers when it is read.",
    "combatWon": "The guard is dead. The stations are reachable; choose controlled force or fire.",
    "legacyRecord": "The public landing holds a comparison deposited by an earlier traveller.",
    "lifeClosed": "This life has closed. Begin another life to continue the chronology.",
    "legacyPromiseKept": "You paid the kitchen. I can stop carrying the receipt now.",
    "legacyName": "The earlier traveller",
    "legacyMemoryLicensed": "Last time I stood in these kilns, I kept the corpse-work running and called it protection. Ask me what that cost once you have paid for something yourself.",
    "legacyMemoryBurned": "Last time I stood in these kilns, I burned the stations rather than release them. The ash settled. The names did not.",
    "legacyMemoryFalse": "Last time I came down those stairs, I signed Nessa's loss as cargo for four cuts. Keep your pen away from her forms.",
    "legacyMemoryMeal": "Last time I came down those stairs, I bought bread for the porters before I asked for anything. Start there if you want them to stay.",
    "legacyPresence": "{name} sits in the dry recess where the light holds steady, {kit}. {hp} of {maxHp} health.",
    "legacyCarrying": "carrying {items}",
    "legacyEmptyHanded": "nothing in their hands",
    "legacyUnremembered": "I have stood in these kilns before. The names on the doors were different.",
    "legacyKilledOutsider": "{name} drew on me where you are standing. I killed them.",
    "legacyKilledSurvivor": "{name} sat here before me. I drew on them, and they did not walk out. I sit where they sat.",
    "legacyWoundKept": "They opened me before they fell. It has not closed.",
    "legacyWounded": "I have not healed since the last fight. I sit where it hurts least.",
    "legacyOutlived": "{name} sat where you are and did not draw on me. They were killed at {ground} by {killer}.",
    "legacyNothingOwed": "Everything I left undone down here, you have already done. I have nothing to ask of you.",
    "deadBy": "“{name}. Killed at {ground} by {killer}.”",
    "deadDrewOn": "“{name}. Drew on {killer} at {ground}, and never walked out.”",
    "deadDrawnOn": "“{name}. Got out once. {killer} killed them at {ground} anyway.”",
    "deadUnknown": "“{name}. Nobody saw how.”",
    "legacyHireLabel": "Ask them to walk with you — 12 cuts",
    "legacyHireText": "Walk with me. Twelve cuts in escrow, the same as anyone I hire.",
    "legacyHireRefused": "You left my debt where it lay. Leave me where I sit.",
    "legacyProvokeLabel": "Draw on them",
    "legacyProvokeText": "You draw your weapon.",
    "legacyProvokeConsequence": "They fight with the health and kit they carry. Whoever falls stays dead."
  },
  "zoneOpenings": {
    "Z04": [
      {
        "id": "z04-gallery-contract",
        "later": true,
        "station": "station-lower-gallery",
        "guarantor": "SEN",
        "facts": [
          "z04:contract-gallery"
        ]
      },
      {
        "id": "z04-vault-contract",
        "later": true,
        "station": "station-columbarium-vault",
        "guarantor": "SAL",
        "facts": [
          "z04:contract-vault"
        ]
      },
      {
        "id": "z04-firing-contract",
        "later": true,
        "station": "station-firing-tunnels",
        "guarantor": "BRZ",
        "facts": [
          "z04:contract-firing"
        ]
      }
    ],
    "Z01": [
      {
        "id": "z01-senate",
        "facts": [
          "z01:holder-sen"
        ]
      },
      {
        "id": "z01-standard",
        "facts": [
          "z01:holder-brz"
        ]
      }
    ],
    "Z02": [
      {
        "id": "z02-compact",
        "facts": [
          "z02:holder-sal"
        ]
      },
      {
        "id": "z02-senate",
        "facts": [
          "z02:holder-sen"
        ]
      }
    ],
    "Z06": [
      {
        "id": "z06-compact-dry",
        "facts": [
          "z06:holder-sal",
          "z06:ford-low"
        ]
      },
      {
        "id": "z06-compact-rain",
        "facts": [
          "z06:holder-sal",
          "z06:ford-high",
          "z06:coffin-cart"
        ]
      },
      {
        "id": "z06-standard",
        "facts": [
          "z06:holder-brz",
          "z06:ford-low",
          "z06:coffin-cart"
        ]
      }
    ]
  },
  "survivorBargains": [
    {
      "id": "causeway-chain",
      "left": {
        "all": [
          "z06:guard-beaten"
        ],
        "any": [],
        "none": []
      },
      "ask": "The Compact chalked my face on the factor’s table, and the guard’s blood-price is still owed. Nobody who looks like an outsider buys passage at that chain until it is paid.",
      "take": {
        "label": "Pay the guard’s blood-price for them — 4 cuts",
        "cost": "Four cuts now, which reach the factor at the Broken Causeway as the dead guard’s price. If you pay his toll for the court’s carts, he counts them: eight, not twelve.",
        "costCuts": 4,
        "rewardCuts": 0,
        "add": [],
        "reply": "“Four. He’ll write it against my face and rub the chalk out.” They watch you count it into a carter’s purse bound west.",
        "journal": "Paid four cuts towards the blood-price an earlier traveller owes the Salt Compact at the Broken Causeway.",
        "effects": [
          {
            "actionId": "z06-toll-pay",
            "costCuts": -4,
            "line": "The factor finds the blood-price in his book and wipes the chalk off his table. “Paid by the next outsider. The rest of the toll, then.”"
          }
        ]
      },
      "refuse": {
        "label": "Leave the chalk where it is",
        "cost": "The factor at the Broken Causeway will not take toll from an outsider while the guard’s price is unpaid. The court’s carts would have to cross some other way.",
        "reply": "“It was my blade. It can be my chalk.”",
        "journal": "Refused to pay the blood-price an earlier traveller owes at the Broken Causeway.",
        "effects": [
          {
            "actionId": "z06-toll-pay",
            "blocked": "The factor reads your face against the chalk on his table. “The last outsider over this chain came with a blade. The Compact takes no toll from your kind until the guard’s price is paid.”"
          }
        ]
      },
      "later": {
        "taken": "You paid the guard’s price at the Broken Causeway. The chalk comes off. The rest does not.",
        "refused": "My face is still chalked on a factor’s table out west. I go round by the ford.",
        "kept": "You paid the chain the guard’s price and your own toll. The Compact has rubbed out the chalk. I haven’t.",
        "keptBy": "z06:toll-paid"
      }
    },
    {
      "id": "causeway-ford",
      "left": {
        "all": [
          "z06:travellers-across"
        ],
        "any": [],
        "none": []
      },
      "ask": "The Compact fined Wenna Coll for the people who waded over behind my carts. The fine is still on her slate: four cuts. She takes no outsider’s carts through until it is paid.",
      "take": {
        "label": "Pay Wenna’s fine for them — 4 cuts",
        "cost": "Four cuts now, sent ahead to Wenna Coll at the old ford. While the water is low, she takes the court’s carts through for two cuts, not six.",
        "costCuts": 4,
        "rewardCuts": 0,
        "add": [],
        "reply": "“Four. That’s the fine, not the favour.” They write Wenna’s name on a scrap for a carter going west.",
        "journal": "Paid four cuts towards the fine Wenna Coll carries for an earlier traveller at the Broken Causeway’s ford.",
        "effects": [
          {
            "actionId": "z06-guide-ford",
            "costCuts": -4,
            "line": "Wenna turns the fine money over in her palm. “The last one’s fine, paid by the next. Two for the carts, then.”"
          }
        ]
      },
      "refuse": {
        "label": "Leave it with them",
        "cost": "Wenna Coll still carries the fine an outsider left her, and she takes no outsider’s carts through the ford.",
        "reply": "“She won’t take it from me anyway.”",
        "journal": "Refused to pay the fine an earlier traveller left the ford guide at the Broken Causeway.",
        "effects": [
          {
            "actionId": "z06-guide-ford",
            "blocked": "Wenna leans on her pole. “The last outsider walked off and left me the Compact’s fine. Take your carts round by the chain.”"
          }
        ]
      },
      "later": {
        "taken": "Wenna’s fine is paid. She’ll still spit when she hears my name.",
        "refused": "Wenna Coll still carries my fine. I carry knowing it.",
        "kept": "Wenna’s ford is busy again, and her slate is clean. That is one debt I can put down.",
        "keptBy": "z06:travellers-across"
      }
    },
    {
      "id": "kitchen",
      "left": {
        "all": [],
        "any": [],
        "none": []
      },
      "ask": "I promised the bath kitchen six cuts after the hearing. The receipt still has my name on it. I never went back.",
      "take": {
        "label": "Carry their promise",
        "cost": "You will owe the bath kitchen six cuts. Their receipt lets the waiting family through the Gate today.",
        "costCuts": 0,
        "rewardCuts": 0,
        "oath": "Pay six cuts to the bath kitchen.",
        "add": [
          "side:kitchen-promised",
          "side:family-admitted",
          "legacy:debt-inherited"
        ],
        "reply": "“Carry it, then. Don’t call it paid.” They write your name over theirs and point you to the family entrance.",
        "journal": "Took over an earlier traveller’s promise to the bath kitchen: six cuts, still owed. Their receipt let the waiting family through the Gate.",
        "effects": [
          {
            "actionId": "kitchen-pay",
            "line": "“Two names on one receipt,” the keeper says. “The one before you said you would come. I didn’t believe them.”"
          }
        ]
      },
      "refuse": {
        "label": "Leave the receipt with them",
        "cost": "The kitchen stays owed in their name, and it will not take another outsider’s surety while that receipt hangs. The family at the Gate keeps waiting unless you pay their fee yourself.",
        "reply": "“Fair enough. It was mine when I made it.” They fold the receipt away.",
        "journal": "Refused an earlier traveller’s kitchen promise. The six cuts stay owed in their name.",
        "effects": [
          {
            "actionId": "kitchen-surety",
            "blocked": "“The bath kitchen already has one outsider’s unpaid receipt on its board,” the official says. “It will not take another.”"
          }
        ]
      },
      "later": {
        "taken": "The kitchen has a new debtor. The six cuts are still unpaid.",
        "kept": "You paid the kitchen. I can stop carrying the receipt now.",
        "keptBy": "side:kitchen-paid",
        "refused": "The kitchen still has my name on its board. I go round the bath the long way now."
      }
    },
    {
      "id": "odel",
      "left": {
        "all": [
          "odel-cooperate"
        ],
        "any": [],
        "none": [
          "worker-guarantee"
        ]
      },
      "ask": "Odel asked me for twelve cuts: his crew’s back pay and his sister’s bond. I set four aside for his crew and never handed them over. His sister is still on the creditor’s list.",
      "take": {
        "label": "Take their four cuts for Odel",
        "cost": "Four cuts now, and their word to Odel goes with them. While you carry that word you cannot threaten him with his sister’s debt.",
        "costCuts": 0,
        "rewardCuts": 4,
        "add": [],
        "reply": "They count four cuts into your hand. “For his crew. Not for bread, not for a guard. For his crew.”",
        "journal": "An earlier traveller gave you four cuts meant for Odel’s crew, and their word to him with it.",
        "effects": [
          {
            "actionId": "worker-guarantee",
            "line": "Odel sets four of the coins apart. “The other one’s four, is it? Tell them I counted it, and that their word reached me.”"
          },
          {
            "actionId": "silence",
            "blocked": "You carry the earlier traveller’s word to Odel. You will not turn it into a threat."
          }
        ]
      },
      "refuse": {
        "label": "Keep to your own purse",
        "cost": "Their four cuts stay with them, and their word to Odel stays unkept. Odel remembers what outsiders owe him: if you pay him, he wants sixteen, not twelve.",
        "reply": "“Then I keep carrying it.” The coins go back into their belt.",
        "journal": "Refused an earlier traveller’s four cuts for Odel’s crew. Their word to him stays theirs.",
        "effects": [
          {
            "actionId": "worker-guarantee",
            "costCuts": 4,
            "line": "Odel counts past twelve before he stops. “Four more. The outsider before you promised my crew four and kept them. You came up the same stair.”"
          }
        ]
      },
      "later": {
        "taken": "You have my four cuts and my word. Odel’s crew is still waiting.",
        "kept": "Odel’s sister came up to see the struck copy. I was there. She didn’t know my face, and that was right.",
        "keptBy": "fact:workers-protected",
        "refused": "I still owe Odel’s crew. I can’t pay it and I can’t put it down."
      }
    },
    {
      "id": "pouch",
      "left": {
        "all": [
          "arrears-pocket"
        ],
        "any": [],
        "none": []
      },
      "ask": "I kept the porters’ pay pouch from under the tally shelf. Eight cuts. They chained their handcart the day they found out.",
      "take": {
        "label": "Pay the porters back for them — 4 cuts",
        "cost": "Four cuts now, into the porters’ tin. They count it toward a crew wage: if you hire them for the grain, you pay twelve, not sixteen.",
        "costCuts": 4,
        "rewardCuts": 0,
        "add": [],
        "reply": "“Four is what I have left of it too.” They walk you to the porters’ tin and watch you pay.",
        "journal": "Paid four cuts to the porters toward the pouch an earlier traveller kept.",
        "effects": [
          {
            "actionId": "porters",
            "costCuts": -4,
            "line": "The eldest porter taps the tin. “Four already in here from you, for the pouch. We count it. Twelve more and we carry.”"
          }
        ]
      },
      "refuse": {
        "label": "Leave it with them",
        "cost": "The porters stay short, and their handcart stays chained. They will not hire out as a grain crew to an outsider.",
        "reply": "“They’ll remember my face either way.”",
        "journal": "Refused to pay for the porters’ pouch an earlier traveller kept.",
        "effects": [
          {
            "actionId": "porters",
            "blocked": "“Not for an outsider,” the eldest porter says, and leaves the handcart chained. “Ask the one who kept our pouch.”"
          }
        ]
      },
      "later": {
        "taken": "The porters took your four. That is four fewer I owe them.",
        "refused": "The porters still chain the handcart when they see me coming."
      }
    },
    {
      "id": "false-report",
      "left": {
        "all": [
          "false-report"
        ],
        "any": [],
        "none": []
      },
      "ask": "I signed Nessa’s loss as lost cargo for four cuts. She has not said my name since.",
      "take": {
        "label": "Pay Nessa’s porters the fee — 4 cuts",
        "cost": "Four cuts now, to the porters Nessa pays. The false entry stays on the form. If you hire them for the grain, they count the four: twelve, not sixteen.",
        "costCuts": 4,
        "rewardCuts": 0,
        "add": [],
        "reply": "“It won’t fix the form.” They watch you count it out. “It might fix the porters’ supper.”",
        "journal": "Paid four cuts to Nessa’s porters for the lost-cargo report an earlier traveller signed.",
        "effects": [
          {
            "actionId": "porters",
            "costCuts": -4,
            "line": "“Nessa told us who paid the four,” a porter says, and pushes it back across the chits. “Twelve more. We carry.”"
          }
        ]
      },
      "refuse": {
        "label": "Leave it with them",
        "cost": "Nessa’s porters stay four cuts short. If you hire them for the grain, they want the four back from you: twenty, not sixteen.",
        "reply": "“She wouldn’t take it from me anyway.”",
        "journal": "Refused to pay back the fee an earlier traveller took for Nessa’s false report.",
        "effects": [
          {
            "actionId": "porters",
            "costCuts": 4,
            "line": "“Twenty,” the porter says. “Sixteen for the grain, and the four an outsider took for Nessa’s loss. Nessa says you all come off the same boat.”"
          }
        ]
      },
      "later": {
        "taken": "Nessa may say my name again, if only to tell me you paid. It is more than I had.",
        "refused": "Nessa still looks straight through me."
      }
    },
    {
      "id": "fire",
      "left": {
        "all": [
          "reckless-end"
        ],
        "any": [],
        "none": []
      },
      "ask": "I burned the stations, and the repair stock with them. The lift stood idle all season. People went short of bread because of me.",
      "take": {
        "label": "Promise them you will not burn",
        "cost": "Fire is closed to you: you can break the stations, never burn them. They give you three cuts toward the bread their fire cost.",
        "costCuts": 0,
        "rewardCuts": 3,
        "add": [],
        "reply": "“Break them if you must. Don’t burn them.” They press three cuts into your hand. “Bread. For the ones I cost.”",
        "journal": "Promised an earlier traveller not to burn the stations. They gave three cuts toward the bread their fire cost.",
        "effects": [
          {
            "actionId": "reckless-end",
            "blocked": "You promised the earlier traveller: break the stations if you must, never burn them."
          }
        ]
      },
      "refuse": {
        "label": "Keep fire as a choice",
        "cost": "Burning stays open to you. Their three cuts stay with them, and they will tell Sela what you would not promise. An outside inspector will cost you twelve, not eight.",
        "reply": "“Then I hope you never need it.”",
        "journal": "Refused an earlier traveller’s plea not to burn the stations.",
        "effects": [
          {
            "actionId": "guarantor",
            "costCuts": 4,
            "line": "“Twelve,” Sela says. “The one who burned my stations tells me you would not promise otherwise. The inspector charges more to stand near fire.”"
          }
        ]
      },
      "later": {
        "taken": "You promised to keep the fire out of it. Keep it, and I won’t have to carry that for both of us.",
        "refused": "You kept the fire. I know what that is to carry.",
        "kept": "You kept the fire out of it. That is one thing I don’t have to carry for both of us.",
        "keptBy": "fact:resolution-chosen"
      }
    },
    {
      "id": "toll",
      "left": {
        "all": [
          "toll-kickback"
        ],
        "any": [],
        "none": []
      },
      "ask": "I took four cuts to keep quiet about the second toll. The porters paid it all season.",
      "take": {
        "label": "Pay the porters’ toll back — 4 cuts",
        "cost": "Four cuts now, entered at the court as a refund to the porters. The refund slip corrects the toll schedule: the waiting family at the Gate goes through without a second fee.",
        "costCuts": 4,
        "rewardCuts": 0,
        "add": [
          "side:fee-exemption"
        ],
        "reply": "“Four. That was the price of my silence.” They sign the refund slip beside you.",
        "journal": "Paid four cuts back to the porters for the toll share an earlier traveller took.",
        "effects": [
          {
            "actionId": "family-exemption",
            "line": "The clerk reads the refund slip twice, then the two names signed on it. “Corrected, then.” He lifts the second charge off the family’s line."
          }
        ]
      },
      "refuse": {
        "label": "Leave it with them",
        "cost": "The porters stay four cuts short. If you hire them for the grain, they want the four back from you: twenty, not sixteen.",
        "reply": "“Keep your coin. I kept mine.”",
        "journal": "Refused to pay back the toll share an earlier traveller took.",
        "effects": [
          {
            "actionId": "porters",
            "costCuts": 4,
            "line": "“Twenty,” the eldest porter says. “Sixteen for the grain, and the four an outsider took off our toll bowl. We paid that toll all season.”"
          }
        ]
      },
      "later": {
        "taken": "The refund is in the court book with my name beside yours. I mean to read it twice.",
        "refused": "What the toll took stays taken. I kept mine, and you kept yours."
      }
    },
    {
      "id": "lamp",
      "left": {
        "all": [],
        "any": [],
        "none": []
      },
      "ask": "I got out. I did what I could and left the rest. Nine names are still on the Gate board, and there is no lamp under them tonight.",
      "take": {
        "label": "Pay for a lamp under the nine names — 2 cuts",
        "cost": "Two cuts now for lamp oil at the Gate. The families will see who paid. The waiting family will take one cut from you for their second fee, not three.",
        "costCuts": 2,
        "rewardCuts": 0,
        "add": [],
        "reply": "“Two cuts. That is what I kept telling myself it would cost.” They walk with you to buy the oil.",
        "journal": "Paid two cuts, with an earlier traveller, for a lamp under the nine names at the Gate.",
        "effects": [
          {
            "actionId": "family-fee",
            "costCuts": -2,
            "line": "The mother looks from the lamp to you. “You paid for that. Put one down. We will find the rest.”"
          }
        ]
      },
      "refuse": {
        "label": "Leave the lamp unlit",
        "cost": "The names stay in the dark. The family waiting at the Gate will see who left it dark, and will not take your money for their fee.",
        "reply": "“Someone will. It won’t be me either.”",
        "journal": "Refused an earlier traveller’s lamp for the nine names.",
        "effects": [
          {
            "actionId": "family-fee",
            "blocked": "“Not from you,” the mother says. “You stood under his name and left it dark.”"
          }
        ]
      },
      "later": {
        "taken": "The lamp is lit. Nine names someone can read again, and we bought the oil.",
        "refused": "The names are still dark. I don’t blame you. I didn’t light it either."
      }
    }
  ],
  "successorNames": [
    "Arel Bel",
    "Arel Gath",
    "Arel Kall",
    "Arel Lann",
    "Arel Menn",
    "Arel Nall",
    "Arel Or",
    "Arel Sarn",
    "Arel Teth",
    "Bessa Bel",
    "Bessa Gath",
    "Bessa Kall",
    "Bessa Lann",
    "Bessa Menn",
    "Bessa Or",
    "Bessa Sarn",
    "Bessa Teth",
    "Bessa Vall",
    "Dema Bel",
    "Dema Gath",
    "Dema Kall",
    "Dema Lann",
    "Dema Menn",
    "Dema Nall",
    "Dema Or",
    "Dema Teth",
    "Dema Vall",
    "Hela Bel",
    "Hela Gath",
    "Hela Lann",
    "Hela Menn",
    "Hela Nall",
    "Hela Or",
    "Hela Sarn",
    "Hela Teth",
    "Hela Vall",
    "Jessa Bel",
    "Jessa Gath",
    "Jessa Kall",
    "Jessa Lann",
    "Jessa Nall",
    "Jessa Or",
    "Jessa Sarn",
    "Jessa Teth",
    "Jessa Vall",
    "Laren Bel",
    "Laren Gath",
    "Laren Kall",
    "Laren Lann",
    "Laren Menn",
    "Laren Nall",
    "Laren Or",
    "Laren Teth",
    "Laren Vall",
    "Nemi Bel",
    "Nemi Gath",
    "Nemi Kall",
    "Nemi Lann",
    "Nemi Menn",
    "Nemi Nall",
    "Nemi Or",
    "Nemi Sarn",
    "Nemi Teth",
    "Nemi Vall",
    "Reth Bel",
    "Reth Gath",
    "Reth Kall",
    "Reth Lann",
    "Reth Menn",
    "Reth Nall",
    "Reth Or",
    "Reth Sarn",
    "Reth Teth",
    "Reth Vall",
    "Senn Bel",
    "Senn Gath",
    "Senn Kall",
    "Senn Lann",
    "Senn Menn",
    "Senn Nall",
    "Senn Or",
    "Senn Sarn",
    "Senn Teth",
    "Senn Vall",
    "Ossa Bel",
    "Ossa Gath",
    "Ossa Kall",
    "Ossa Lann",
    "Ossa Menn",
    "Ossa Nall",
    "Ossa Or",
    "Ossa Sarn",
    "Ossa Teth",
    "Ossa Vall"
  ],
  "survivorVoice": {
    "voiceId": "survivor",
    "care": {
      "offered": "I will carry the {item}. I have learned the cost of needing one too late.",
      "treat": "I have survived worse. A moment for the wound.",
      "remember": "{giver} trusted me with supplies from their own pack. I did not forget.",
      "aid": "You have taken enough for one fight. Sit down; I have supplies to spare.",
      "rememberAid": "I used my supplies to tend {patient}. I know how much can depend on that small pause."
    },
    "manner": "Plain and unhurried; speaks like someone who has already seen how this goes.",
    "temperament": {
      "boldness": 4,
      "loyalty": 6
    },
    "obligation": "Walks with you on their own account. They will not throw away the life they carried out of the Dry Cut.",
    "opening": "Still here. Say what you need.",
    "hire": "Twelve cuts. I know these kilns. I walk beside you, not behind you.",
    "hired": "I am walking with you. Say what you need.",
    "refusal": "No. I have bled in this place once. I choose where I do it again.",
    "afterFight": {
      "guard": "I stood in that doorway once. It went worse for me.",
      "tunnel": "They don’t stop until something stops them. You did."
    },
    "moment": {
      "request": "Keep your word to the people I owed.",
      "kept": "That is paid. Good.",
      "broken": "You broke it. I won’t carry that twice."
    },
    "judgment": {
      "good": "You saw it through to the end. Not everyone who comes up that stair does. I will say so to anyone who asks.",
      "bad": "I have seen this ending. I walked away from it then, and I will now.",
      "depart": "My road goes back down to the Dry Cut. Yours doesn’t.",
      "mourning": "Another outsider in the ground. I knew how it could end. I hoped anyway."
    },
    "discuss": {
      "guard": {
        "accepted": "I’ll keep to your shoulder.",
        "refused": "I keep my own footing. It is how I lived this long."
      },
      "engage": {
        "accepted": "Then we go in together.",
        "refused": "I have charged into this before. Not twice."
      },
      "withdraw": {
        "accepted": "Good. The living get to leave.",
        "refused": "Not while you are still standing there."
      }
    },
    "barks": {
      "engage": "I know this one. Close with me.",
      "guard": "Behind me. I’ve taken worse.",
      "hold": "Wait. Watch the feet, not the blade.",
      "withdraw": "Back. I didn’t get out of here once to die in here now.",
      "defend": "I have seen that swing before. I lived through it."
    },
    "returning": {
      "kept": "You again. Someone like you, anyway.",
      "mourned": "The last one who hired me is dead.",
      "absent": "I walked out on the last one."
    }
  },
  "survivorFight": {
    "disgraced-legionary": {
      "draw": "I held a shield line for eleven years. You are one person with one arm.",
      "answer": "You draw back before every blow. The line taught me what to do with that."
    },
    "unpaid-sellsword": {
      "draw": "Nobody has paid me for a fight since the river. I will take this one for nothing.",
      "answer": "Too slow. I have stepped out of swings like that since before you could lift one."
    },
    "fallen-household": {
      "draw": "My family lost the house, the land and the name. I kept the sword. Think about why.",
      "answer": "My father’s master of arms swung like that. He was old, and so is that swing."
    },
    "intelligence-runner": {
      "draw": "I carried letters that got people killed. I know how this ends for one of us.",
      "answer": "I read people for a living. You are not hard to read."
    },
    "escaped-worker": {
      "draw": "I was bonded in these kilns. Nobody puts me back in them.",
      "answer": "The overseers wound up just like that. I learned to be somewhere else."
    },
    "serekh-exile": {
      "draw": "I walked out of Serekh with a bow and nothing else. I can walk out of here as well.",
      "answer": "Stay out there. I would rather have you there."
    },
    "hedge-binder": {
      "draw": "I have closed the eyes of better-armed people than you. Put it away.",
      "answer": "I watch hands for a living. Yours tell me everything first."
    },
    "grave-witness": {
      "draw": "I have seen what this place does to the dead. I am not joining them for you.",
      "answer": "I saw that swing on the last one who tried it. I am still here."
    }
  },
  "funerals": {
    "beatId": "beat:lower-landing",
    "speakerId": "nessa",
    "costCuts": 6,
    "label": "Arrange a burial for {name} — {cuts} cuts",
    "consequence": "Pay {cuts} cuts for bearers and a marked grave. {name}’s possessions stay with their remains. Their wage belongs to their estate.",
    "reply": "“{name}. I will see it done.” Nessa takes {cuts} cuts for the bearers and a grave at the place they fell. Their possessions go into the grave with them. She enters the burial and your name beside theirs. The wage account stays with their estate.",
    "short": "You need six cuts for the bearers and grave.",
    "rememberLabel": "Ask after the companions who did not come back",
    "rememberConsequence": "Read the public record of their deaths and burials. Nothing is taken or paid.",
    "death": "“{name}. Killed at {ground} by {killer}.”",
    "unknownDeath": "“{name}. Their death is recorded; no witness named the killer.”",
    "exposed": "The burial space beside their name is still blank. Their possessions remain with the body.",
    "buried": "A marked grave is recorded at the place they fell. Their possessions remain with them.",
    "destroyed": "Their remains were destroyed. No body can be recovered for burial.",
    "animated": "Their remains are still bound to work. They cannot be buried while that binding holds.",
    "paid": "{payer} paid for the burial.",
    "lead": "Nessa at the Lower Landing can arrange a marked grave for {name} — {cuts} cuts. Their possessions will stay with them."
  },
  "mystery": {
    "findings": [
      {
        "id": "P-M1",
        "actionId": "mystery-shells",
        "label": "Stone older than the empire",
        "finding": "Two incompatible shell growths share one healed injury.",
        "meaning": "It predates human institutions; it does not settle whether gods exist.",
        "beatId": "beat:z11-comparison-court"
      },
      {
        "id": "P-M2",
        "actionId": "mystery-staple",
        "label": "A new staple in old mortar",
        "finding": "Modern stamped metal lies beneath unbroken old mortar.",
        "meaning": "An object can have a history this arrangement cannot explain.",
        "beatId": "z04-dry-cut"
      },
      {
        "id": "P-T1",
        "actionId": "mystery-compare-points",
        "label": "Two exact surveys that will not join",
        "finding": "Both local surveys are sound; they have no shared continuation.",
        "meaning": "The instruments measure the fault rather than making it.",
        "beatId": "beat:z12-white-joint"
      },
      {
        "id": "P-T2",
        "actionId": "mystery-tides",
        "label": "The same missing day, far away",
        "finding": "Independent road, tide and water records share the missing continuation.",
        "meaning": "The fault reaches beyond the basin and its threats.",
        "beatId": "beat:z11-comparison-court"
      },
      {
        "id": "P-I1",
        "actionId": null,
        "label": "A person who never stopped",
        "finding": "A former outsider retains their lived decisions, possessions and memory.",
        "meaning": "They survived; they were not brought back.",
        "beatId": "z04-dry-cut"
      },
      {
        "id": "P-I2",
        "actionId": "mystery-dead",
        "label": "A death the new roll cannot undo",
        "finding": "A recorded death and the obligations it left persist under a different arrangement.",
        "meaning": "The dead remain dead, even when their bodies are made to work.",
        "beatId": "beat:lower-landing"
      }
    ],
    "ending": {
      "title": "First Ember",
      "lead": "Someone asks the date. The answer is 1 Ember 641 AC.",
      "future": "The living share one future, with their own possessions, promises and loyalties. Their claims still need settling. The dead remain dead. The gods remain a question. The Return does not.",
      "cost": "The western crossing needs forty-eight beams and six hundred worker-days, with food and wages still to find. Tomorrow’s work begins."
    }
  },
  "arc": {
    "id": "arc:unburied",
    "version": 1,
    "caseId": "case:z04-missing-dead",
    "initialFacts": [
      "arrived:silt-stair"
    ],
    "milestones": [
      {
        "id": "slice.M0",
        "label": "The coffin"
      },
      {
        "id": "slice.M1",
        "label": "A name attached"
      },
      {
        "id": "slice.M2",
        "label": "A demonstrated practice"
      },
      {
        "id": "slice.M3",
        "label": "The terms of stopping"
      },
      {
        "id": "slice.M4",
        "label": "Grain and burial"
      },
      {
        "id": "slice.M5",
        "label": "Local aftermath"
      }
    ],
    "removalMilestoneId": "slice.M2-removal-attempt",
    "actions": [
      {
        "id": "slice.M0-inspect-coffin",
        "milestone": "slice.M0",
        "category": "inspection",
        "pressureDelta": 0,
        "label": "Inspect the empty coffin at the Lower Landing",
        "prerequisites": {
          "all": [
            "arrived:silt-stair"
          ],
          "any": [],
          "none": [
            "fact:investigation-opened"
          ]
        },
        "effects": {
          "add": [
            "fact:coffin-inspected",
            "fact:investigation-opened"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M0-hear-porter",
        "milestone": "slice.M0",
        "category": "investigation",
        "pressureDelta": 0,
        "label": "Hear the porter's account of the false cargo report",
        "prerequisites": {
          "all": [
            "arrived:silt-stair"
          ],
          "any": [],
          "none": [
            "fact:investigation-opened"
          ]
        },
        "effects": {
          "add": [
            "fact:porter-heard",
            "fact:investigation-opened"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M0-find-missing-burial",
        "milestone": "slice.M0",
        "category": "investigation",
        "pressureDelta": 0,
        "label": "Discover a missing burial while pursuing the origin goal",
        "prerequisites": {
          "all": [
            "arrived:silt-stair"
          ],
          "any": [],
          "none": [
            "fact:investigation-opened"
          ]
        },
        "effects": {
          "add": [
            "fact:missing-burial-found",
            "fact:investigation-opened"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M1-match-token",
        "milestone": "slice.M1",
        "category": "evidence",
        "pressureDelta": 0,
        "label": "Attach Leth An's name through the burial token",
        "prerequisites": {
          "all": [
            "fact:investigation-opened"
          ],
          "any": [],
          "none": [
            "fact:name-attached"
          ]
        },
        "effects": {
          "add": [
            "fact:name-attached",
            "fact:kiln-access",
            "fact:physical-evidence-secured"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M1-match-wage-tally",
        "milestone": "slice.M1",
        "category": "evidence",
        "pressureDelta": 0,
        "label": "Attach a worker's name through the wage tally",
        "prerequisites": {
          "all": [
            "fact:investigation-opened"
          ],
          "any": [],
          "none": [
            "fact:name-attached"
          ]
        },
        "effects": {
          "add": [
            "fact:name-attached",
            "fact:kiln-access",
            "fact:document-evidence-secured"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M1-trace-workshop-payment",
        "milestone": "slice.M1",
        "category": "evidence",
        "pressureDelta": 0,
        "label": "Attach a name through the workshop payment",
        "prerequisites": {
          "all": [
            "fact:investigation-opened"
          ],
          "any": [],
          "none": [
            "fact:name-attached"
          ]
        },
        "effects": {
          "add": [
            "fact:name-attached",
            "fact:kiln-access",
            "fact:document-evidence-secured"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-observe-working-dead",
        "milestone": "slice.M2",
        "category": "inspection",
        "pressureDelta": 0,
        "label": "Watch Leth An's remains repeat the tally work",
        "prerequisites": {
          "all": [
            "fact:name-attached",
            "fact:kiln-access"
          ],
          "any": [],
          "none": []
        },
        "effects": {
          "add": [
            "fact:necromancy-observed"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-inspect-tethers",
        "milestone": "slice.M2",
        "category": "inspection",
        "pressureDelta": 0,
        "label": "Inspect all three tether arrangements",
        "prerequisites": {
          "all": [
            "fact:necromancy-observed"
          ],
          "any": [],
          "none": []
        },
        "effects": {
          "add": [
            "fact:tethers-inspected"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-take-records",
        "milestone": "slice.M2",
        "category": "evidence",
        "pressureDelta": 0,
        "label": "Secure the station records and matched burial evidence",
        "prerequisites": {
          "all": [
            "fact:necromancy-observed"
          ],
          "any": [],
          "none": []
        },
        "effects": {
          "add": [
            "fact:records-secured",
            "fact:document-evidence-secured",
            "fact:physical-evidence-secured"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-separate-melian",
        "milestone": "slice.M2",
        "category": "evidence",
        "pressureDelta": 0,
        "label": "Record Melian's lawful demonstration separately from corpse-work",
        "prerequisites": {
          "all": [
            "fact:necromancy-observed"
          ],
          "any": [],
          "none": []
        },
        "effects": {
          "add": [
            "fact:melian-separated"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-secure-witnesses",
        "milestone": "slice.M2",
        "category": "preparation",
        "pressureDelta": 0,
        "label": "Secure material protection for the witnesses",
        "prerequisites": {
          "all": [
            "fact:name-attached"
          ],
          "any": [],
          "none": [
            "fact:witnesses-intimidated"
          ]
        },
        "effects": {
          "add": [
            "fact:witnesses-protected"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-win-odel-cooperation",
        "milestone": "slice.M2",
        "category": "preparation",
        "pressureDelta": 0,
        "label": "Win Odel's cooperation without commanding the workers",
        "prerequisites": {
          "all": [
            "fact:name-attached"
          ],
          "any": [],
          "none": []
        },
        "effects": {
          "add": [
            "fact:odel-cooperation"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-guarantee-worker-protection",
        "milestone": "slice.M2",
        "category": "preparation",
        "pressureDelta": 0,
        "label": "Guarantee workers against creditor seizure",
        "prerequisites": {
          "all": [
            "fact:odel-cooperation"
          ],
          "any": [],
          "none": []
        },
        "effects": {
          "add": [
            "fact:workers-protected"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-force-noll-out",
        "milestone": "slice.M2",
        "category": "preparation",
        "pressureDelta": 0,
        "label": "Force Noll out of control of the operation",
        "prerequisites": {
          "all": [
            "fact:necromancy-observed"
          ],
          "any": [],
          "none": []
        },
        "effects": {
          "add": [
            "fact:noll-removed"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-bargain-sela",
        "milestone": "slice.M2",
        "category": "preparation",
        "pressureDelta": 0,
        "label": "Agree supervision or exile with Sela",
        "prerequisites": {
          "all": [
            "fact:noll-removed",
            "fact:necromancy-observed"
          ],
          "any": [],
          "none": []
        },
        "effects": {
          "add": [
            "fact:sela-contained"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-secure-independent-guarantor",
        "milestone": "slice.M2",
        "category": "preparation",
        "pressureDelta": 0,
        "label": "Secure an independent guarantor for containment",
        "prerequisites": {
          "all": [
            "fact:noll-removed"
          ],
          "any": [],
          "none": []
        },
        "effects": {
          "add": [
            "fact:independent-guarantor"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-prepare-combat",
        "milestone": "slice.M2",
        "category": "preparation",
        "pressureDelta": 0,
        "label": "Prepare the fight around the records, workers and station anchors",
        "prerequisites": {
          "all": [
            "fact:necromancy-observed"
          ],
          "any": [],
          "none": []
        },
        "effects": {
          "add": [
            "fact:combat-prepared"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-support-operation",
        "milestone": "slice.M2",
        "category": "support",
        "pressureDelta": 1,
        "label": "Secure reagents for the corpse-work operation",
        "prerequisites": {
          "all": [
            "fact:necromancy-observed"
          ],
          "any": [],
          "none": []
        },
        "effects": {
          "add": [
            "fact:operation-supported"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-intimidate-witnesses",
        "milestone": "slice.M2",
        "category": "intimidation",
        "pressureDelta": 1,
        "label": "Intimidate the witnesses into silence",
        "prerequisites": {
          "all": [
            "fact:necromancy-observed"
          ],
          "any": [],
          "none": [
            "fact:witnesses-protected"
          ]
        },
        "effects": {
          "add": [
            "fact:witnesses-intimidated"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-removal-attempt",
        "milestone": "slice.M2",
        "category": "removal",
        "pressureDelta": 0,
        "label": "The operation attempts its named equipment transfer",
        "prerequisites": {
          "all": [
            "fact:necromancy-observed"
          ],
          "any": [],
          "none": [
            "fact:removal-attempted"
          ]
        },
        "effects": {
          "add": [
            "fact:removal-attempted"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M2-intercept-removal",
        "milestone": "slice.M2",
        "category": "removal",
        "pressureDelta": 0,
        "label": "Intercept the equipment transfer before the records leave",
        "prerequisites": {
          "all": [
            "fact:removal-attempted"
          ],
          "any": [],
          "none": [
            "fact:removal-completed"
          ]
        },
        "effects": {
          "add": [
            "fact:removal-intercepted"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M3-public-dismantling",
        "milestone": "slice.M3",
        "category": "resolution",
        "pressureDelta": 0,
        "outcomeId": "public-dismantling",
        "label": "Present the case and safely dismantle the concession",
        "prerequisites": {
          "all": [
            "fact:necromancy-observed",
            "fact:records-secured",
            "fact:witnesses-protected",
            "fact:tethers-inspected",
            "fact:melian-separated"
          ],
          "any": [],
          "none": [
            "fact:resolution-chosen"
          ]
        },
        "effects": {
          "add": [
            "fact:resolution-chosen",
            "fact:outcome-public-dismantling"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M3-workers-shutdown",
        "milestone": "slice.M3",
        "category": "resolution",
        "pressureDelta": 0,
        "outcomeId": "workers-shutdown",
        "label": "Back the workers' safe shutdown and custody of the records",
        "prerequisites": {
          "all": [
            "fact:odel-cooperation",
            "fact:workers-protected",
            "fact:tethers-inspected",
            "fact:records-secured"
          ],
          "any": [],
          "none": [
            "fact:resolution-chosen"
          ]
        },
        "effects": {
          "add": [
            "fact:resolution-chosen",
            "fact:outcome-workers-shutdown"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M3-private-containment",
        "milestone": "slice.M3",
        "category": "resolution",
        "pressureDelta": 0,
        "outcomeId": "private-containment",
        "label": "Contain the operation under independent supervision",
        "prerequisites": {
          "all": [
            "fact:noll-removed",
            "fact:sela-contained",
            "fact:independent-guarantor",
            "fact:tethers-inspected"
          ],
          "any": [],
          "none": [
            "fact:resolution-chosen"
          ]
        },
        "effects": {
          "add": [
            "fact:resolution-chosen",
            "fact:outcome-private-containment"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M3-licensed-atrocity",
        "milestone": "slice.M3",
        "category": "resolution",
        "pressureDelta": 0,
        "outcomeId": "licensed-atrocity",
        "label": "Protect the corpse-work and suppress its witnesses",
        "prerequisites": {
          "all": [
            "fact:operation-supported",
            "fact:witnesses-intimidated"
          ],
          "any": [],
          "none": [
            "fact:resolution-chosen"
          ]
        },
        "effects": {
          "add": [
            "fact:resolution-chosen",
            "fact:outcome-licensed-atrocity"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M3-violent-destruction",
        "milestone": "slice.M3",
        "category": "resolution",
        "pressureDelta": 0,
        "outcomeId": "violent-destruction",
        "label": "Fight through the concession and destroy the stations",
        "prerequisites": {
          "all": [
            "fact:necromancy-observed",
            "fact:combat-prepared"
          ],
          "any": [],
          "none": [
            "fact:resolution-chosen"
          ]
        },
        "effects": {
          "add": [
            "fact:resolution-chosen",
            "fact:outcome-violent-destruction"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M3-departure-failure",
        "milestone": "slice.M3",
        "category": "resolution",
        "pressureDelta": 0,
        "outcomeId": "departure-failure",
        "label": "Leave with the narrow personal result or after losing access",
        "prerequisites": {
          "all": [
            "arrived:silt-stair"
          ],
          "any": [],
          "none": [
            "fact:resolution-chosen"
          ]
        },
        "effects": {
          "add": [
            "fact:resolution-chosen",
            "fact:outcome-departure-failure"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M4-account-grain-and-burial",
        "milestone": "slice.M4",
        "category": "accounting",
        "pressureDelta": 0,
        "label": "Record grain, workers, Melian, all nine remains and the personal goal",
        "prerequisites": {
          "all": [
            "fact:resolution-chosen"
          ],
          "any": [],
          "none": [
            "fact:terminal-accounting-complete"
          ]
        },
        "effects": {
          "add": [
            "fact:terminal-accounting-complete"
          ],
          "remove": []
        }
      },
      {
        "id": "slice.M5-observe-local-aftermath",
        "milestone": "slice.M5",
        "category": "aftermath",
        "pressureDelta": 0,
        "label": "Return to the changed market and kiln gate",
        "prerequisites": {
          "all": [
            "fact:terminal-accounting-complete"
          ],
          "any": [],
          "none": [
            "fact:local-aftermath-observed"
          ]
        },
        "effects": {
          "add": [
            "fact:local-aftermath-observed"
          ],
          "remove": []
        }
      }
    ],
    "outcomes": [
      {
        "id": "public-dismantling",
        "operationPolicy": "release",
        "grainRequired": true,
        "workerOutcome": "Witnesses and surviving workers leave under public protection; wage claims remain visible in the settlement.",
        "practitionerOutcome": "cleared-if-separated",
        "marketAftermath": "The market posts the closed concession and the lift's new obligation.",
        "gateAftermath": "Families queue for named remains under public custody.",
        "allowedPersonalGoalStatuses": [
          "achieved",
          "compromised",
          "failed"
        ]
      },
      {
        "id": "workers-shutdown",
        "operationPolicy": "release",
        "grainRequired": true,
        "workerOutcome": "The workers make the stations safe and hold the records; creditor protection and arrears remain material terms.",
        "practitionerOutcome": "cleared-if-separated",
        "marketAftermath": "Workers post their own custody notice beside the grain remedy.",
        "gateAftermath": "The concession guard post is replaced by a workers' burial ledger.",
        "allowedPersonalGoalStatuses": [
          "achieved",
          "compromised",
          "failed"
        ]
      },
      {
        "id": "private-containment",
        "operationPolicy": "release",
        "grainRequired": true,
        "workerOutcome": "Surviving workers leave the corpse-work under a private guarantee, without a complete public reckoning.",
        "practitionerOutcome": "unresolved",
        "marketAftermath": "Trade resumes under supervision, but no public confession names the stolen dead.",
        "gateAftermath": "The gate records a private transfer rather than a public closure.",
        "allowedPersonalGoalStatuses": [
          "achieved",
          "compromised",
          "failed"
        ]
      },
      {
        "id": "licensed-atrocity",
        "operationPolicy": "leave-active",
        "grainRequired": true,
        "workerOutcome": "The living workers remain coerced and unpaid while the operation's output is protected.",
        "practitionerOutcome": "accused",
        "marketAftermath": "Grain moves and concession goods remain cheap enough to advertise the practical benefit.",
        "gateAftermath": "Witnesses are absent and the returned-token board is quietly cleared.",
        "allowedPersonalGoalStatuses": [
          "achieved",
          "compromised",
          "failed"
        ]
      },
      {
        "id": "violent-destruction",
        "operationPolicy": "break",
        "grainRequired": true,
        "workerOutcome": "Surviving workers leave the concession; their wage and protection claims depend on the chosen grain settlement.",
        "practitionerOutcome": "clear-if-evidence-preserved",
        "marketAftermath": "The market names the collateral damage and the lift remedy separately.",
        "gateAftermath": "The gate lists every recovered or destroyed body by name.",
        "allowedPersonalGoalStatuses": [
          "achieved",
          "compromised",
          "failed"
        ]
      },
      {
        "id": "departure-failure",
        "operationPolicy": "leave-active",
        "grainRequired": false,
        "workerOutcome": "The workers remain exposed to the concession or to another actor's later raid.",
        "practitionerOutcome": "unresolved",
        "marketAftermath": "The market continues under the unresolved grain shortage.",
        "gateAftermath": "The missing-burial dispute remains open after the outsider leaves.",
        "allowedPersonalGoalStatuses": [
          "achieved",
          "compromised",
          "failed",
          "abandoned"
        ]
      }
    ]
  },
  "openings": [
    {
      "seed": "z04-reference",
      "holder": "REE",
      "concessionGuarantor": "BRZ",
      "guarantorAgreement": "A supply contract guarantees the garrison's burial quota",
      "publicExplanation": "contractor-fraud-quiet",
      "tunnelHazard": "hazard-shallow-seep",
      "evidencePlacement": "gate-strongbox",
      "reagentShortage": "pale-kiln-wax",
      "operatorConfidence": "defiant",
      "upperGateGuardCount": 3,
      "optionalEcho": "eligible-continuant-socket",
      "guardRoster": {
        "count": 3,
        "followsGuarantor": true,
        "sheetId": "actor-mortuary-guard-rotation",
        "markId": "mark-brz-sun-disc"
      },
      "stations": [
        {
          "id": "station-lower-gallery",
          "beat": "z04-lower-work-gallery",
          "anchor": {
            "x": 15000,
            "y": 4000,
            "layer": 2
          },
          "bodies": [
            {
              "remainsId": "remains:leth-an",
              "position": {
                "x": 13000,
                "y": 3000,
                "layer": 2
              },
              "workPatternId": "tally-sort",
              "observable": "The first working dead the player can watch; plainly impossible motion, limited and task-bound"
            },
            {
              "remainsId": "remains:kell-anik",
              "position": {
                "x": 24000,
                "y": 2000,
                "layer": 2
              },
              "workPatternId": "sift-ash",
              "observable": "Screened alcove; found by following the ash drift or the ledger map"
            }
          ]
        },
        {
          "id": "station-columbarium-vault",
          "beat": "z04-cooling-court",
          "anchor": {
            "x": 17000,
            "y": 8000,
            "layer": 1
          },
          "bodies": [
            {
              "remainsId": "remains:ines-var",
              "position": {
                "x": 17000,
                "y": 7000,
                "layer": 1
              },
              "workPatternId": "vault-sort",
              "observable": "Salvage sorting behind the urn shelves"
            },
            {
              "remainsId": "remains:tavi-ren",
              "position": {
                "x": 16000,
                "y": 8000,
                "layer": 1
              },
              "workPatternId": "urn-stack",
              "observable": "Stacking crates that were never buried"
            }
          ]
        },
        {
          "id": "station-firing-tunnels",
          "beat": "z04-cart-ramp-office",
          "anchor": {
            "x": 16000,
            "y": 10000,
            "layer": 4
          },
          "bodies": [
            {
              "remainsId": "remains:sera-tol",
              "position": {
                "x": 19000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "kiln-stoke",
              "observable": "Stoking the old firing tunnel mouth for the lime burn"
            },
            {
              "remainsId": "remains:maren-osk",
              "position": {
                "x": 14000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "lime-haul",
              "observable": "Hauling the lime barrow along the switchback"
            },
            {
              "remainsId": "remains:pel-dau",
              "position": {
                "x": 17000,
                "y": 10000,
                "layer": 4
              },
              "workPatternId": "sack-lift",
              "observable": "Lifting sacks at the cart stand he drove in life"
            }
          ]
        }
      ],
      "storage": [
        {
          "remainsId": "remains:doro-pell",
          "position": {
            "x": 3000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the west storage cell"
        },
        {
          "remainsId": "remains:mila-senn",
          "position": {
            "x": 4000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the east storage cell"
        }
      ],
      "dead": [
        {
          "personId": "person:leth-an",
          "remainsId": "remains:leth-an",
          "name": "Leth An",
          "ageAtDeath": 40,
          "trace": "Granary porter; his repeated tally gesture resembles work habit, not conscious testimony"
        },
        {
          "personId": "person:sera-tol",
          "remainsId": "remains:sera-tol",
          "name": "Sera Tol",
          "ageAtDeath": 52,
          "trace": "Kiln tender; kept the stoker's wrist turn"
        },
        {
          "personId": "person:maren-osk",
          "remainsId": "remains:maren-osk",
          "name": "Maren Osk",
          "ageAtDeath": 45,
          "trace": "Lime burner; pushed the barrow in cough-shortened lengths"
        },
        {
          "personId": "person:pel-dau",
          "remainsId": "remains:pel-dau",
          "name": "Pel Dau",
          "ageAtDeath": 60,
          "trace": "Burial-cart driver; kept the rein-hand habit"
        },
        {
          "personId": "person:ines-var",
          "remainsId": "remains:ines-var",
          "name": "Ines Var",
          "ageAtDeath": 38,
          "trace": "Potter; her thumb still finds the rim of a bowl"
        },
        {
          "personId": "person:kell-anik",
          "remainsId": "remains:kell-anik",
          "name": "Kell Anik",
          "ageAtDeath": 29,
          "trace": "Ash sifter; kept the sieve rhythm"
        },
        {
          "personId": "person:doro-pell",
          "remainsId": "remains:doro-pell",
          "name": "Doro Pell",
          "ageAtDeath": 55,
          "trace": "Grave digger; measured every spade cut"
        },
        {
          "personId": "person:tavi-ren",
          "remainsId": "remains:tavi-ren",
          "name": "Tavi Ren",
          "ageAtDeath": 33,
          "trace": "Token clerk; kept the seal-press motion"
        },
        {
          "personId": "person:mila-senn",
          "remainsId": "remains:mila-senn",
          "name": "Mila Senn",
          "ageAtDeath": 41,
          "trace": "Urn painter; her wrist still turns the brush"
        }
      ],
      "evidencePlacementSocket": {
        "id": "gate-strongbox",
        "beat": "z04-gate-of-accounts",
        "waypoint": "guard-post",
        "locked": true
      }
    },
    {
      "seed": "z04-s01",
      "holder": "SEN",
      "concessionGuarantor": "BRZ",
      "guarantorAgreement": "A supply contract guarantees the garrison's burial quota",
      "publicExplanation": "theft-blamed-on-outsiders",
      "tunnelHazard": "hazard-partial-gallery-collapse",
      "evidencePlacement": "sela-rooms",
      "reagentShortage": "pale-kiln-wax",
      "operatorConfidence": "wavering",
      "upperGateGuardCount": 3,
      "optionalEcho": "eligible-continuant-socket",
      "guardRoster": {
        "count": 3,
        "followsGuarantor": true,
        "sheetId": "actor-mortuary-guard-rotation",
        "markId": "mark-brz-sun-disc"
      },
      "stations": [
        {
          "id": "station-lower-gallery",
          "beat": "z04-lower-work-gallery",
          "anchor": {
            "x": 15000,
            "y": 4000,
            "layer": 2
          },
          "bodies": [
            {
              "remainsId": "remains:leth-an",
              "position": {
                "x": 13000,
                "y": 3000,
                "layer": 2
              },
              "workPatternId": "tally-sort",
              "observable": "The first working dead the player can watch; plainly impossible motion, limited and task-bound"
            },
            {
              "remainsId": "remains:ines-var",
              "position": {
                "x": 24000,
                "y": 2000,
                "layer": 2
              },
              "workPatternId": "sift-ash",
              "observable": "Screened alcove; found by following the ash drift or the ledger map"
            }
          ]
        },
        {
          "id": "station-columbarium-vault",
          "beat": "z04-cooling-court",
          "anchor": {
            "x": 17000,
            "y": 8000,
            "layer": 1
          },
          "bodies": [
            {
              "remainsId": "remains:oda-vren",
              "position": {
                "x": 17000,
                "y": 7000,
                "layer": 1
              },
              "workPatternId": "vault-sort",
              "observable": "Salvage sorting behind the urn shelves"
            },
            {
              "remainsId": "remains:pel-dau",
              "position": {
                "x": 16000,
                "y": 8000,
                "layer": 1
              },
              "workPatternId": "urn-stack",
              "observable": "Stacking crates that were never buried"
            }
          ]
        },
        {
          "id": "station-firing-tunnels",
          "beat": "z04-cart-ramp-office",
          "anchor": {
            "x": 16000,
            "y": 10000,
            "layer": 4
          },
          "bodies": [
            {
              "remainsId": "remains:bran-essel",
              "position": {
                "x": 19000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "kiln-stoke",
              "observable": "Stoking the old firing tunnel mouth for the lime burn"
            },
            {
              "remainsId": "remains:doro-pell",
              "position": {
                "x": 14000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "lime-haul",
              "observable": "Hauling the lime barrow along the switchback"
            },
            {
              "remainsId": "remains:sera-tol",
              "position": {
                "x": 17000,
                "y": 10000,
                "layer": 4
              },
              "workPatternId": "sack-lift",
              "observable": "Lifting sacks at the cart stand he drove in life"
            }
          ]
        }
      ],
      "storage": [
        {
          "remainsId": "remains:maren-osk",
          "position": {
            "x": 3000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the west storage cell"
        },
        {
          "remainsId": "remains:mila-senn",
          "position": {
            "x": 4000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the east storage cell"
        }
      ],
      "dead": [
        {
          "personId": "person:leth-an",
          "remainsId": "remains:leth-an",
          "name": "Leth An",
          "ageAtDeath": 40,
          "trace": "Granary porter; his repeated tally gesture resembles work habit, not conscious testimony"
        },
        {
          "personId": "person:sera-tol",
          "remainsId": "remains:sera-tol",
          "name": "Sera Tol",
          "ageAtDeath": 52,
          "trace": "Kiln tender; kept the stoker's wrist turn"
        },
        {
          "personId": "person:maren-osk",
          "remainsId": "remains:maren-osk",
          "name": "Maren Osk",
          "ageAtDeath": 45,
          "trace": "Lime burner; pushed the barrow in cough-shortened lengths"
        },
        {
          "personId": "person:pel-dau",
          "remainsId": "remains:pel-dau",
          "name": "Pel Dau",
          "ageAtDeath": 60,
          "trace": "Burial-cart driver; kept the rein-hand habit"
        },
        {
          "personId": "person:ines-var",
          "remainsId": "remains:ines-var",
          "name": "Ines Var",
          "ageAtDeath": 38,
          "trace": "Potter; her thumb still finds the rim of a bowl"
        },
        {
          "personId": "person:doro-pell",
          "remainsId": "remains:doro-pell",
          "name": "Doro Pell",
          "ageAtDeath": 55,
          "trace": "Grave digger; measured every spade cut"
        },
        {
          "personId": "person:mila-senn",
          "remainsId": "remains:mila-senn",
          "name": "Mila Senn",
          "ageAtDeath": 41,
          "trace": "Urn painter; her wrist still turns the brush"
        },
        {
          "personId": "person:bran-essel",
          "remainsId": "remains:bran-essel",
          "name": "Bran Essel",
          "ageAtDeath": 47,
          "trace": "Clay hauler; ducked the low lintel out of habit"
        },
        {
          "personId": "person:oda-vren",
          "remainsId": "remains:oda-vren",
          "name": "Oda Vren",
          "ageAtDeath": 58,
          "trace": "Night watch; tapped the doorframe count"
        }
      ],
      "evidencePlacementSocket": {
        "id": "sela-rooms",
        "beat": "z04-selas-rooms",
        "waypoint": "ledger-table",
        "locked": true
      }
    },
    {
      "seed": "z04-s02",
      "holder": "BRZ",
      "concessionGuarantor": "SEN",
      "guarantorAgreement": "Debt-bond patrons hold the concession paper",
      "publicExplanation": "sacrilege-blamed-on-melian",
      "tunnelHazard": "hazard-partial-gallery-collapse",
      "evidencePlacement": "sela-rooms",
      "reagentShortage": "first-cut-lime",
      "operatorConfidence": "steady",
      "upperGateGuardCount": 4,
      "optionalEcho": "eligible-continuant-socket",
      "guardRoster": {
        "count": 4,
        "followsGuarantor": true,
        "sheetId": "actor-mortuary-guard-rotation",
        "markId": "mark-sen-broken-ring"
      },
      "stations": [
        {
          "id": "station-lower-gallery",
          "beat": "z04-lower-work-gallery",
          "anchor": {
            "x": 15000,
            "y": 4000,
            "layer": 2
          },
          "bodies": [
            {
              "remainsId": "remains:leth-an",
              "position": {
                "x": 13000,
                "y": 3000,
                "layer": 2
              },
              "workPatternId": "tally-sort",
              "observable": "The first working dead the player can watch; plainly impossible motion, limited and task-bound"
            },
            {
              "remainsId": "remains:mila-senn",
              "position": {
                "x": 24000,
                "y": 2000,
                "layer": 2
              },
              "workPatternId": "sift-ash",
              "observable": "Screened alcove; found by following the ash drift or the ledger map"
            }
          ]
        },
        {
          "id": "station-columbarium-vault",
          "beat": "z04-cooling-court",
          "anchor": {
            "x": 17000,
            "y": 8000,
            "layer": 1
          },
          "bodies": [
            {
              "remainsId": "remains:kell-anik",
              "position": {
                "x": 17000,
                "y": 7000,
                "layer": 1
              },
              "workPatternId": "vault-sort",
              "observable": "Salvage sorting behind the urn shelves"
            },
            {
              "remainsId": "remains:pel-dau",
              "position": {
                "x": 16000,
                "y": 8000,
                "layer": 1
              },
              "workPatternId": "urn-stack",
              "observable": "Stacking crates that were never buried"
            }
          ]
        },
        {
          "id": "station-firing-tunnels",
          "beat": "z04-cart-ramp-office",
          "anchor": {
            "x": 16000,
            "y": 10000,
            "layer": 4
          },
          "bodies": [
            {
              "remainsId": "remains:cass-ivel",
              "position": {
                "x": 19000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "kiln-stoke",
              "observable": "Stoking the old firing tunnel mouth for the lime burn"
            },
            {
              "remainsId": "remains:oda-vren",
              "position": {
                "x": 14000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "lime-haul",
              "observable": "Hauling the lime barrow along the switchback"
            },
            {
              "remainsId": "remains:maren-osk",
              "position": {
                "x": 17000,
                "y": 10000,
                "layer": 4
              },
              "workPatternId": "sack-lift",
              "observable": "Lifting sacks at the cart stand he drove in life"
            }
          ]
        }
      ],
      "storage": [
        {
          "remainsId": "remains:tavi-ren",
          "position": {
            "x": 3000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the west storage cell"
        },
        {
          "remainsId": "remains:doro-pell",
          "position": {
            "x": 4000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the east storage cell"
        }
      ],
      "dead": [
        {
          "personId": "person:leth-an",
          "remainsId": "remains:leth-an",
          "name": "Leth An",
          "ageAtDeath": 40,
          "trace": "Granary porter; his repeated tally gesture resembles work habit, not conscious testimony"
        },
        {
          "personId": "person:maren-osk",
          "remainsId": "remains:maren-osk",
          "name": "Maren Osk",
          "ageAtDeath": 45,
          "trace": "Lime burner; pushed the barrow in cough-shortened lengths"
        },
        {
          "personId": "person:pel-dau",
          "remainsId": "remains:pel-dau",
          "name": "Pel Dau",
          "ageAtDeath": 60,
          "trace": "Burial-cart driver; kept the rein-hand habit"
        },
        {
          "personId": "person:kell-anik",
          "remainsId": "remains:kell-anik",
          "name": "Kell Anik",
          "ageAtDeath": 29,
          "trace": "Ash sifter; kept the sieve rhythm"
        },
        {
          "personId": "person:doro-pell",
          "remainsId": "remains:doro-pell",
          "name": "Doro Pell",
          "ageAtDeath": 55,
          "trace": "Grave digger; measured every spade cut"
        },
        {
          "personId": "person:tavi-ren",
          "remainsId": "remains:tavi-ren",
          "name": "Tavi Ren",
          "ageAtDeath": 33,
          "trace": "Token clerk; kept the seal-press motion"
        },
        {
          "personId": "person:mila-senn",
          "remainsId": "remains:mila-senn",
          "name": "Mila Senn",
          "ageAtDeath": 41,
          "trace": "Urn painter; her wrist still turns the brush"
        },
        {
          "personId": "person:oda-vren",
          "remainsId": "remains:oda-vren",
          "name": "Oda Vren",
          "ageAtDeath": 58,
          "trace": "Night watch; tapped the doorframe count"
        },
        {
          "personId": "person:cass-ivel",
          "remainsId": "remains:cass-ivel",
          "name": "Cass Ivel",
          "ageAtDeath": 26,
          "trace": "Water carrier; balanced the yoke from memory"
        }
      ],
      "evidencePlacementSocket": {
        "id": "sela-rooms",
        "beat": "z04-selas-rooms",
        "waypoint": "ledger-table",
        "locked": true
      }
    },
    {
      "seed": "z04-s03",
      "holder": "REE",
      "concessionGuarantor": "SEN",
      "guarantorAgreement": "Debt-bond patrons hold the concession paper",
      "publicExplanation": "theft-blamed-on-outsiders",
      "tunnelHazard": "hazard-partial-gallery-collapse",
      "evidencePlacement": "sela-rooms",
      "reagentShortage": "first-cut-lime",
      "operatorConfidence": "defiant",
      "upperGateGuardCount": 2,
      "optionalEcho": "none",
      "guardRoster": {
        "count": 2,
        "followsGuarantor": true,
        "sheetId": "actor-mortuary-guard-rotation",
        "markId": "mark-sen-broken-ring"
      },
      "stations": [
        {
          "id": "station-lower-gallery",
          "beat": "z04-lower-work-gallery",
          "anchor": {
            "x": 15000,
            "y": 4000,
            "layer": 2
          },
          "bodies": [
            {
              "remainsId": "remains:leth-an",
              "position": {
                "x": 13000,
                "y": 3000,
                "layer": 2
              },
              "workPatternId": "tally-sort",
              "observable": "The first working dead the player can watch; plainly impossible motion, limited and task-bound"
            },
            {
              "remainsId": "remains:sera-tol",
              "position": {
                "x": 24000,
                "y": 2000,
                "layer": 2
              },
              "workPatternId": "sift-ash",
              "observable": "Screened alcove; found by following the ash drift or the ledger map"
            }
          ]
        },
        {
          "id": "station-columbarium-vault",
          "beat": "z04-cooling-court",
          "anchor": {
            "x": 17000,
            "y": 8000,
            "layer": 1
          },
          "bodies": [
            {
              "remainsId": "remains:ines-var",
              "position": {
                "x": 17000,
                "y": 7000,
                "layer": 1
              },
              "workPatternId": "vault-sort",
              "observable": "Salvage sorting behind the urn shelves"
            },
            {
              "remainsId": "remains:maren-osk",
              "position": {
                "x": 16000,
                "y": 8000,
                "layer": 1
              },
              "workPatternId": "urn-stack",
              "observable": "Stacking crates that were never buried"
            }
          ]
        },
        {
          "id": "station-firing-tunnels",
          "beat": "z04-cart-ramp-office",
          "anchor": {
            "x": 16000,
            "y": 10000,
            "layer": 4
          },
          "bodies": [
            {
              "remainsId": "remains:oda-vren",
              "position": {
                "x": 19000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "kiln-stoke",
              "observable": "Stoking the old firing tunnel mouth for the lime burn"
            },
            {
              "remainsId": "remains:kell-anik",
              "position": {
                "x": 14000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "lime-haul",
              "observable": "Hauling the lime barrow along the switchback"
            },
            {
              "remainsId": "remains:mila-senn",
              "position": {
                "x": 17000,
                "y": 10000,
                "layer": 4
              },
              "workPatternId": "sack-lift",
              "observable": "Lifting sacks at the cart stand he drove in life"
            }
          ]
        }
      ],
      "storage": [
        {
          "remainsId": "remains:doro-pell",
          "position": {
            "x": 3000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the west storage cell"
        },
        {
          "remainsId": "remains:cass-ivel",
          "position": {
            "x": 4000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the east storage cell"
        }
      ],
      "dead": [
        {
          "personId": "person:leth-an",
          "remainsId": "remains:leth-an",
          "name": "Leth An",
          "ageAtDeath": 40,
          "trace": "Granary porter; his repeated tally gesture resembles work habit, not conscious testimony"
        },
        {
          "personId": "person:sera-tol",
          "remainsId": "remains:sera-tol",
          "name": "Sera Tol",
          "ageAtDeath": 52,
          "trace": "Kiln tender; kept the stoker's wrist turn"
        },
        {
          "personId": "person:maren-osk",
          "remainsId": "remains:maren-osk",
          "name": "Maren Osk",
          "ageAtDeath": 45,
          "trace": "Lime burner; pushed the barrow in cough-shortened lengths"
        },
        {
          "personId": "person:ines-var",
          "remainsId": "remains:ines-var",
          "name": "Ines Var",
          "ageAtDeath": 38,
          "trace": "Potter; her thumb still finds the rim of a bowl"
        },
        {
          "personId": "person:kell-anik",
          "remainsId": "remains:kell-anik",
          "name": "Kell Anik",
          "ageAtDeath": 29,
          "trace": "Ash sifter; kept the sieve rhythm"
        },
        {
          "personId": "person:doro-pell",
          "remainsId": "remains:doro-pell",
          "name": "Doro Pell",
          "ageAtDeath": 55,
          "trace": "Grave digger; measured every spade cut"
        },
        {
          "personId": "person:mila-senn",
          "remainsId": "remains:mila-senn",
          "name": "Mila Senn",
          "ageAtDeath": 41,
          "trace": "Urn painter; her wrist still turns the brush"
        },
        {
          "personId": "person:oda-vren",
          "remainsId": "remains:oda-vren",
          "name": "Oda Vren",
          "ageAtDeath": 58,
          "trace": "Night watch; tapped the doorframe count"
        },
        {
          "personId": "person:cass-ivel",
          "remainsId": "remains:cass-ivel",
          "name": "Cass Ivel",
          "ageAtDeath": 26,
          "trace": "Water carrier; balanced the yoke from memory"
        }
      ],
      "evidencePlacementSocket": {
        "id": "sela-rooms",
        "beat": "z04-selas-rooms",
        "waypoint": "ledger-table",
        "locked": true
      }
    },
    {
      "seed": "z04-s04",
      "holder": "SAL",
      "concessionGuarantor": "SAL",
      "guarantorAgreement": "A shipping house financed the concession against lime futures",
      "publicExplanation": "contractor-fraud-quiet",
      "tunnelHazard": "hazard-shallow-seep",
      "evidencePlacement": "gate-strongbox",
      "reagentShortage": "vannic-holding-salt",
      "operatorConfidence": "wavering",
      "upperGateGuardCount": 2,
      "optionalEcho": "eligible-continuant-socket",
      "guardRoster": {
        "count": 2,
        "followsGuarantor": true,
        "sheetId": "actor-mortuary-guard-rotation",
        "markId": "mark-sal-sail-weight"
      },
      "stations": [
        {
          "id": "station-lower-gallery",
          "beat": "z04-lower-work-gallery",
          "anchor": {
            "x": 15000,
            "y": 4000,
            "layer": 2
          },
          "bodies": [
            {
              "remainsId": "remains:leth-an",
              "position": {
                "x": 13000,
                "y": 3000,
                "layer": 2
              },
              "workPatternId": "tally-sort",
              "observable": "The first working dead the player can watch; plainly impossible motion, limited and task-bound"
            },
            {
              "remainsId": "remains:oda-vren",
              "position": {
                "x": 24000,
                "y": 2000,
                "layer": 2
              },
              "workPatternId": "sift-ash",
              "observable": "Screened alcove; found by following the ash drift or the ledger map"
            }
          ]
        },
        {
          "id": "station-columbarium-vault",
          "beat": "z04-cooling-court",
          "anchor": {
            "x": 17000,
            "y": 8000,
            "layer": 1
          },
          "bodies": [
            {
              "remainsId": "remains:kell-anik",
              "position": {
                "x": 17000,
                "y": 7000,
                "layer": 1
              },
              "workPatternId": "vault-sort",
              "observable": "Salvage sorting behind the urn shelves"
            },
            {
              "remainsId": "remains:pel-dau",
              "position": {
                "x": 16000,
                "y": 8000,
                "layer": 1
              },
              "workPatternId": "urn-stack",
              "observable": "Stacking crates that were never buried"
            }
          ]
        },
        {
          "id": "station-firing-tunnels",
          "beat": "z04-cart-ramp-office",
          "anchor": {
            "x": 16000,
            "y": 10000,
            "layer": 4
          },
          "bodies": [
            {
              "remainsId": "remains:mila-senn",
              "position": {
                "x": 19000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "kiln-stoke",
              "observable": "Stoking the old firing tunnel mouth for the lime burn"
            },
            {
              "remainsId": "remains:tavi-ren",
              "position": {
                "x": 14000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "lime-haul",
              "observable": "Hauling the lime barrow along the switchback"
            },
            {
              "remainsId": "remains:ines-var",
              "position": {
                "x": 17000,
                "y": 10000,
                "layer": 4
              },
              "workPatternId": "sack-lift",
              "observable": "Lifting sacks at the cart stand he drove in life"
            }
          ]
        }
      ],
      "storage": [
        {
          "remainsId": "remains:doro-pell",
          "position": {
            "x": 3000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the west storage cell"
        },
        {
          "remainsId": "remains:sera-tol",
          "position": {
            "x": 4000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the east storage cell"
        }
      ],
      "dead": [
        {
          "personId": "person:leth-an",
          "remainsId": "remains:leth-an",
          "name": "Leth An",
          "ageAtDeath": 40,
          "trace": "Granary porter; his repeated tally gesture resembles work habit, not conscious testimony"
        },
        {
          "personId": "person:sera-tol",
          "remainsId": "remains:sera-tol",
          "name": "Sera Tol",
          "ageAtDeath": 52,
          "trace": "Kiln tender; kept the stoker's wrist turn"
        },
        {
          "personId": "person:pel-dau",
          "remainsId": "remains:pel-dau",
          "name": "Pel Dau",
          "ageAtDeath": 60,
          "trace": "Burial-cart driver; kept the rein-hand habit"
        },
        {
          "personId": "person:ines-var",
          "remainsId": "remains:ines-var",
          "name": "Ines Var",
          "ageAtDeath": 38,
          "trace": "Potter; her thumb still finds the rim of a bowl"
        },
        {
          "personId": "person:kell-anik",
          "remainsId": "remains:kell-anik",
          "name": "Kell Anik",
          "ageAtDeath": 29,
          "trace": "Ash sifter; kept the sieve rhythm"
        },
        {
          "personId": "person:doro-pell",
          "remainsId": "remains:doro-pell",
          "name": "Doro Pell",
          "ageAtDeath": 55,
          "trace": "Grave digger; measured every spade cut"
        },
        {
          "personId": "person:tavi-ren",
          "remainsId": "remains:tavi-ren",
          "name": "Tavi Ren",
          "ageAtDeath": 33,
          "trace": "Token clerk; kept the seal-press motion"
        },
        {
          "personId": "person:mila-senn",
          "remainsId": "remains:mila-senn",
          "name": "Mila Senn",
          "ageAtDeath": 41,
          "trace": "Urn painter; her wrist still turns the brush"
        },
        {
          "personId": "person:oda-vren",
          "remainsId": "remains:oda-vren",
          "name": "Oda Vren",
          "ageAtDeath": 58,
          "trace": "Night watch; tapped the doorframe count"
        }
      ],
      "evidencePlacementSocket": {
        "id": "gate-strongbox",
        "beat": "z04-gate-of-accounts",
        "waypoint": "guard-post",
        "locked": true
      }
    },
    {
      "seed": "z04-s05",
      "holder": "LOC",
      "concessionGuarantor": "SEN",
      "guarantorAgreement": "Debt-bond patrons hold the concession paper",
      "publicExplanation": "sacrilege-blamed-on-melian",
      "tunnelHazard": "hazard-dry-tunnel",
      "evidencePlacement": "sela-rooms",
      "reagentShortage": "first-cut-lime",
      "operatorConfidence": "steady",
      "upperGateGuardCount": 2,
      "optionalEcho": "none",
      "guardRoster": {
        "count": 2,
        "followsGuarantor": true,
        "sheetId": "actor-mortuary-guard-rotation",
        "markId": "mark-sen-broken-ring"
      },
      "stations": [
        {
          "id": "station-lower-gallery",
          "beat": "z04-lower-work-gallery",
          "anchor": {
            "x": 15000,
            "y": 4000,
            "layer": 2
          },
          "bodies": [
            {
              "remainsId": "remains:leth-an",
              "position": {
                "x": 13000,
                "y": 3000,
                "layer": 2
              },
              "workPatternId": "tally-sort",
              "observable": "The first working dead the player can watch; plainly impossible motion, limited and task-bound"
            },
            {
              "remainsId": "remains:oda-vren",
              "position": {
                "x": 24000,
                "y": 2000,
                "layer": 2
              },
              "workPatternId": "sift-ash",
              "observable": "Screened alcove; found by following the ash drift or the ledger map"
            }
          ]
        },
        {
          "id": "station-columbarium-vault",
          "beat": "z04-cooling-court",
          "anchor": {
            "x": 17000,
            "y": 8000,
            "layer": 1
          },
          "bodies": [
            {
              "remainsId": "remains:bran-essel",
              "position": {
                "x": 17000,
                "y": 7000,
                "layer": 1
              },
              "workPatternId": "vault-sort",
              "observable": "Salvage sorting behind the urn shelves"
            },
            {
              "remainsId": "remains:cass-ivel",
              "position": {
                "x": 16000,
                "y": 8000,
                "layer": 1
              },
              "workPatternId": "urn-stack",
              "observable": "Stacking crates that were never buried"
            }
          ]
        },
        {
          "id": "station-firing-tunnels",
          "beat": "z04-cart-ramp-office",
          "anchor": {
            "x": 16000,
            "y": 10000,
            "layer": 4
          },
          "bodies": [
            {
              "remainsId": "remains:maren-osk",
              "position": {
                "x": 19000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "kiln-stoke",
              "observable": "Stoking the old firing tunnel mouth for the lime burn"
            },
            {
              "remainsId": "remains:ines-var",
              "position": {
                "x": 14000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "lime-haul",
              "observable": "Hauling the lime barrow along the switchback"
            },
            {
              "remainsId": "remains:pel-dau",
              "position": {
                "x": 17000,
                "y": 10000,
                "layer": 4
              },
              "workPatternId": "sack-lift",
              "observable": "Lifting sacks at the cart stand he drove in life"
            }
          ]
        }
      ],
      "storage": [
        {
          "remainsId": "remains:doro-pell",
          "position": {
            "x": 3000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the west storage cell"
        },
        {
          "remainsId": "remains:sera-tol",
          "position": {
            "x": 4000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the east storage cell"
        }
      ],
      "dead": [
        {
          "personId": "person:leth-an",
          "remainsId": "remains:leth-an",
          "name": "Leth An",
          "ageAtDeath": 40,
          "trace": "Granary porter; his repeated tally gesture resembles work habit, not conscious testimony"
        },
        {
          "personId": "person:sera-tol",
          "remainsId": "remains:sera-tol",
          "name": "Sera Tol",
          "ageAtDeath": 52,
          "trace": "Kiln tender; kept the stoker's wrist turn"
        },
        {
          "personId": "person:maren-osk",
          "remainsId": "remains:maren-osk",
          "name": "Maren Osk",
          "ageAtDeath": 45,
          "trace": "Lime burner; pushed the barrow in cough-shortened lengths"
        },
        {
          "personId": "person:pel-dau",
          "remainsId": "remains:pel-dau",
          "name": "Pel Dau",
          "ageAtDeath": 60,
          "trace": "Burial-cart driver; kept the rein-hand habit"
        },
        {
          "personId": "person:ines-var",
          "remainsId": "remains:ines-var",
          "name": "Ines Var",
          "ageAtDeath": 38,
          "trace": "Potter; her thumb still finds the rim of a bowl"
        },
        {
          "personId": "person:doro-pell",
          "remainsId": "remains:doro-pell",
          "name": "Doro Pell",
          "ageAtDeath": 55,
          "trace": "Grave digger; measured every spade cut"
        },
        {
          "personId": "person:bran-essel",
          "remainsId": "remains:bran-essel",
          "name": "Bran Essel",
          "ageAtDeath": 47,
          "trace": "Clay hauler; ducked the low lintel out of habit"
        },
        {
          "personId": "person:oda-vren",
          "remainsId": "remains:oda-vren",
          "name": "Oda Vren",
          "ageAtDeath": 58,
          "trace": "Night watch; tapped the doorframe count"
        },
        {
          "personId": "person:cass-ivel",
          "remainsId": "remains:cass-ivel",
          "name": "Cass Ivel",
          "ageAtDeath": 26,
          "trace": "Water carrier; balanced the yoke from memory"
        }
      ],
      "evidencePlacementSocket": {
        "id": "sela-rooms",
        "beat": "z04-selas-rooms",
        "waypoint": "ledger-table",
        "locked": true
      }
    },
    {
      "seed": "z04-s06",
      "holder": "SEN",
      "concessionGuarantor": "BRZ",
      "guarantorAgreement": "A supply contract guarantees the garrison's burial quota",
      "publicExplanation": "contractor-fraud-quiet",
      "tunnelHazard": "hazard-shallow-seep",
      "evidencePlacement": "sela-rooms",
      "reagentShortage": "pale-kiln-wax",
      "operatorConfidence": "defiant",
      "upperGateGuardCount": 4,
      "optionalEcho": "none",
      "guardRoster": {
        "count": 4,
        "followsGuarantor": true,
        "sheetId": "actor-mortuary-guard-rotation",
        "markId": "mark-brz-sun-disc"
      },
      "stations": [
        {
          "id": "station-lower-gallery",
          "beat": "z04-lower-work-gallery",
          "anchor": {
            "x": 15000,
            "y": 4000,
            "layer": 2
          },
          "bodies": [
            {
              "remainsId": "remains:leth-an",
              "position": {
                "x": 13000,
                "y": 3000,
                "layer": 2
              },
              "workPatternId": "tally-sort",
              "observable": "The first working dead the player can watch; plainly impossible motion, limited and task-bound"
            },
            {
              "remainsId": "remains:maren-osk",
              "position": {
                "x": 24000,
                "y": 2000,
                "layer": 2
              },
              "workPatternId": "sift-ash",
              "observable": "Screened alcove; found by following the ash drift or the ledger map"
            }
          ]
        },
        {
          "id": "station-columbarium-vault",
          "beat": "z04-cooling-court",
          "anchor": {
            "x": 17000,
            "y": 8000,
            "layer": 1
          },
          "bodies": [
            {
              "remainsId": "remains:bran-essel",
              "position": {
                "x": 17000,
                "y": 7000,
                "layer": 1
              },
              "workPatternId": "vault-sort",
              "observable": "Salvage sorting behind the urn shelves"
            },
            {
              "remainsId": "remains:mila-senn",
              "position": {
                "x": 16000,
                "y": 8000,
                "layer": 1
              },
              "workPatternId": "urn-stack",
              "observable": "Stacking crates that were never buried"
            }
          ]
        },
        {
          "id": "station-firing-tunnels",
          "beat": "z04-cart-ramp-office",
          "anchor": {
            "x": 16000,
            "y": 10000,
            "layer": 4
          },
          "bodies": [
            {
              "remainsId": "remains:kell-anik",
              "position": {
                "x": 19000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "kiln-stoke",
              "observable": "Stoking the old firing tunnel mouth for the lime burn"
            },
            {
              "remainsId": "remains:sera-tol",
              "position": {
                "x": 14000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "lime-haul",
              "observable": "Hauling the lime barrow along the switchback"
            },
            {
              "remainsId": "remains:ines-var",
              "position": {
                "x": 17000,
                "y": 10000,
                "layer": 4
              },
              "workPatternId": "sack-lift",
              "observable": "Lifting sacks at the cart stand he drove in life"
            }
          ]
        }
      ],
      "storage": [
        {
          "remainsId": "remains:tavi-ren",
          "position": {
            "x": 3000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the west storage cell"
        },
        {
          "remainsId": "remains:cass-ivel",
          "position": {
            "x": 4000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the east storage cell"
        }
      ],
      "dead": [
        {
          "personId": "person:leth-an",
          "remainsId": "remains:leth-an",
          "name": "Leth An",
          "ageAtDeath": 40,
          "trace": "Granary porter; his repeated tally gesture resembles work habit, not conscious testimony"
        },
        {
          "personId": "person:sera-tol",
          "remainsId": "remains:sera-tol",
          "name": "Sera Tol",
          "ageAtDeath": 52,
          "trace": "Kiln tender; kept the stoker's wrist turn"
        },
        {
          "personId": "person:maren-osk",
          "remainsId": "remains:maren-osk",
          "name": "Maren Osk",
          "ageAtDeath": 45,
          "trace": "Lime burner; pushed the barrow in cough-shortened lengths"
        },
        {
          "personId": "person:ines-var",
          "remainsId": "remains:ines-var",
          "name": "Ines Var",
          "ageAtDeath": 38,
          "trace": "Potter; her thumb still finds the rim of a bowl"
        },
        {
          "personId": "person:kell-anik",
          "remainsId": "remains:kell-anik",
          "name": "Kell Anik",
          "ageAtDeath": 29,
          "trace": "Ash sifter; kept the sieve rhythm"
        },
        {
          "personId": "person:tavi-ren",
          "remainsId": "remains:tavi-ren",
          "name": "Tavi Ren",
          "ageAtDeath": 33,
          "trace": "Token clerk; kept the seal-press motion"
        },
        {
          "personId": "person:mila-senn",
          "remainsId": "remains:mila-senn",
          "name": "Mila Senn",
          "ageAtDeath": 41,
          "trace": "Urn painter; her wrist still turns the brush"
        },
        {
          "personId": "person:bran-essel",
          "remainsId": "remains:bran-essel",
          "name": "Bran Essel",
          "ageAtDeath": 47,
          "trace": "Clay hauler; ducked the low lintel out of habit"
        },
        {
          "personId": "person:cass-ivel",
          "remainsId": "remains:cass-ivel",
          "name": "Cass Ivel",
          "ageAtDeath": 26,
          "trace": "Water carrier; balanced the yoke from memory"
        }
      ],
      "evidencePlacementSocket": {
        "id": "sela-rooms",
        "beat": "z04-selas-rooms",
        "waypoint": "ledger-table",
        "locked": true
      }
    },
    {
      "seed": "z04-s07",
      "holder": "BRZ",
      "concessionGuarantor": "SAL",
      "guarantorAgreement": "A shipping house financed the concession against lime futures",
      "publicExplanation": "sacrilege-blamed-on-melian",
      "tunnelHazard": "hazard-dry-tunnel",
      "evidencePlacement": "sela-rooms",
      "reagentShortage": "vannic-holding-salt",
      "operatorConfidence": "defiant",
      "upperGateGuardCount": 4,
      "optionalEcho": "none",
      "guardRoster": {
        "count": 4,
        "followsGuarantor": true,
        "sheetId": "actor-mortuary-guard-rotation",
        "markId": "mark-sal-sail-weight"
      },
      "stations": [
        {
          "id": "station-lower-gallery",
          "beat": "z04-lower-work-gallery",
          "anchor": {
            "x": 15000,
            "y": 4000,
            "layer": 2
          },
          "bodies": [
            {
              "remainsId": "remains:leth-an",
              "position": {
                "x": 13000,
                "y": 3000,
                "layer": 2
              },
              "workPatternId": "tally-sort",
              "observable": "The first working dead the player can watch; plainly impossible motion, limited and task-bound"
            },
            {
              "remainsId": "remains:pel-dau",
              "position": {
                "x": 24000,
                "y": 2000,
                "layer": 2
              },
              "workPatternId": "sift-ash",
              "observable": "Screened alcove; found by following the ash drift or the ledger map"
            }
          ]
        },
        {
          "id": "station-columbarium-vault",
          "beat": "z04-cooling-court",
          "anchor": {
            "x": 17000,
            "y": 8000,
            "layer": 1
          },
          "bodies": [
            {
              "remainsId": "remains:cass-ivel",
              "position": {
                "x": 17000,
                "y": 7000,
                "layer": 1
              },
              "workPatternId": "vault-sort",
              "observable": "Salvage sorting behind the urn shelves"
            },
            {
              "remainsId": "remains:sera-tol",
              "position": {
                "x": 16000,
                "y": 8000,
                "layer": 1
              },
              "workPatternId": "urn-stack",
              "observable": "Stacking crates that were never buried"
            }
          ]
        },
        {
          "id": "station-firing-tunnels",
          "beat": "z04-cart-ramp-office",
          "anchor": {
            "x": 16000,
            "y": 10000,
            "layer": 4
          },
          "bodies": [
            {
              "remainsId": "remains:mila-senn",
              "position": {
                "x": 19000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "kiln-stoke",
              "observable": "Stoking the old firing tunnel mouth for the lime burn"
            },
            {
              "remainsId": "remains:bran-essel",
              "position": {
                "x": 14000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "lime-haul",
              "observable": "Hauling the lime barrow along the switchback"
            },
            {
              "remainsId": "remains:maren-osk",
              "position": {
                "x": 17000,
                "y": 10000,
                "layer": 4
              },
              "workPatternId": "sack-lift",
              "observable": "Lifting sacks at the cart stand he drove in life"
            }
          ]
        }
      ],
      "storage": [
        {
          "remainsId": "remains:oda-vren",
          "position": {
            "x": 3000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the west storage cell"
        },
        {
          "remainsId": "remains:ines-var",
          "position": {
            "x": 4000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the east storage cell"
        }
      ],
      "dead": [
        {
          "personId": "person:leth-an",
          "remainsId": "remains:leth-an",
          "name": "Leth An",
          "ageAtDeath": 40,
          "trace": "Granary porter; his repeated tally gesture resembles work habit, not conscious testimony"
        },
        {
          "personId": "person:sera-tol",
          "remainsId": "remains:sera-tol",
          "name": "Sera Tol",
          "ageAtDeath": 52,
          "trace": "Kiln tender; kept the stoker's wrist turn"
        },
        {
          "personId": "person:maren-osk",
          "remainsId": "remains:maren-osk",
          "name": "Maren Osk",
          "ageAtDeath": 45,
          "trace": "Lime burner; pushed the barrow in cough-shortened lengths"
        },
        {
          "personId": "person:pel-dau",
          "remainsId": "remains:pel-dau",
          "name": "Pel Dau",
          "ageAtDeath": 60,
          "trace": "Burial-cart driver; kept the rein-hand habit"
        },
        {
          "personId": "person:ines-var",
          "remainsId": "remains:ines-var",
          "name": "Ines Var",
          "ageAtDeath": 38,
          "trace": "Potter; her thumb still finds the rim of a bowl"
        },
        {
          "personId": "person:mila-senn",
          "remainsId": "remains:mila-senn",
          "name": "Mila Senn",
          "ageAtDeath": 41,
          "trace": "Urn painter; her wrist still turns the brush"
        },
        {
          "personId": "person:bran-essel",
          "remainsId": "remains:bran-essel",
          "name": "Bran Essel",
          "ageAtDeath": 47,
          "trace": "Clay hauler; ducked the low lintel out of habit"
        },
        {
          "personId": "person:oda-vren",
          "remainsId": "remains:oda-vren",
          "name": "Oda Vren",
          "ageAtDeath": 58,
          "trace": "Night watch; tapped the doorframe count"
        },
        {
          "personId": "person:cass-ivel",
          "remainsId": "remains:cass-ivel",
          "name": "Cass Ivel",
          "ageAtDeath": 26,
          "trace": "Water carrier; balanced the yoke from memory"
        }
      ],
      "evidencePlacementSocket": {
        "id": "sela-rooms",
        "beat": "z04-selas-rooms",
        "waypoint": "ledger-table",
        "locked": true
      }
    },
    {
      "seed": "z04-s08",
      "holder": "REE",
      "concessionGuarantor": "REE",
      "guarantorAgreement": "The measurer's office inherited the concession with the works",
      "publicExplanation": "theft-blamed-on-outsiders",
      "tunnelHazard": "hazard-partial-gallery-collapse",
      "evidencePlacement": "gate-strongbox",
      "reagentShortage": "pale-kiln-wax",
      "operatorConfidence": "steady",
      "upperGateGuardCount": 4,
      "optionalEcho": "eligible-continuant-socket",
      "guardRoster": {
        "count": 4,
        "followsGuarantor": true,
        "sheetId": "actor-mortuary-guard-rotation",
        "markId": "mark-ree-reed-hook"
      },
      "stations": [
        {
          "id": "station-lower-gallery",
          "beat": "z04-lower-work-gallery",
          "anchor": {
            "x": 15000,
            "y": 4000,
            "layer": 2
          },
          "bodies": [
            {
              "remainsId": "remains:leth-an",
              "position": {
                "x": 13000,
                "y": 3000,
                "layer": 2
              },
              "workPatternId": "tally-sort",
              "observable": "The first working dead the player can watch; plainly impossible motion, limited and task-bound"
            },
            {
              "remainsId": "remains:doro-pell",
              "position": {
                "x": 24000,
                "y": 2000,
                "layer": 2
              },
              "workPatternId": "sift-ash",
              "observable": "Screened alcove; found by following the ash drift or the ledger map"
            }
          ]
        },
        {
          "id": "station-columbarium-vault",
          "beat": "z04-cooling-court",
          "anchor": {
            "x": 17000,
            "y": 8000,
            "layer": 1
          },
          "bodies": [
            {
              "remainsId": "remains:pel-dau",
              "position": {
                "x": 17000,
                "y": 7000,
                "layer": 1
              },
              "workPatternId": "vault-sort",
              "observable": "Salvage sorting behind the urn shelves"
            },
            {
              "remainsId": "remains:bran-essel",
              "position": {
                "x": 16000,
                "y": 8000,
                "layer": 1
              },
              "workPatternId": "urn-stack",
              "observable": "Stacking crates that were never buried"
            }
          ]
        },
        {
          "id": "station-firing-tunnels",
          "beat": "z04-cart-ramp-office",
          "anchor": {
            "x": 16000,
            "y": 10000,
            "layer": 4
          },
          "bodies": [
            {
              "remainsId": "remains:maren-osk",
              "position": {
                "x": 19000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "kiln-stoke",
              "observable": "Stoking the old firing tunnel mouth for the lime burn"
            },
            {
              "remainsId": "remains:sera-tol",
              "position": {
                "x": 14000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "lime-haul",
              "observable": "Hauling the lime barrow along the switchback"
            },
            {
              "remainsId": "remains:cass-ivel",
              "position": {
                "x": 17000,
                "y": 10000,
                "layer": 4
              },
              "workPatternId": "sack-lift",
              "observable": "Lifting sacks at the cart stand he drove in life"
            }
          ]
        }
      ],
      "storage": [
        {
          "remainsId": "remains:kell-anik",
          "position": {
            "x": 3000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the west storage cell"
        },
        {
          "remainsId": "remains:tavi-ren",
          "position": {
            "x": 4000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the east storage cell"
        }
      ],
      "dead": [
        {
          "personId": "person:leth-an",
          "remainsId": "remains:leth-an",
          "name": "Leth An",
          "ageAtDeath": 40,
          "trace": "Granary porter; his repeated tally gesture resembles work habit, not conscious testimony"
        },
        {
          "personId": "person:sera-tol",
          "remainsId": "remains:sera-tol",
          "name": "Sera Tol",
          "ageAtDeath": 52,
          "trace": "Kiln tender; kept the stoker's wrist turn"
        },
        {
          "personId": "person:maren-osk",
          "remainsId": "remains:maren-osk",
          "name": "Maren Osk",
          "ageAtDeath": 45,
          "trace": "Lime burner; pushed the barrow in cough-shortened lengths"
        },
        {
          "personId": "person:pel-dau",
          "remainsId": "remains:pel-dau",
          "name": "Pel Dau",
          "ageAtDeath": 60,
          "trace": "Burial-cart driver; kept the rein-hand habit"
        },
        {
          "personId": "person:kell-anik",
          "remainsId": "remains:kell-anik",
          "name": "Kell Anik",
          "ageAtDeath": 29,
          "trace": "Ash sifter; kept the sieve rhythm"
        },
        {
          "personId": "person:doro-pell",
          "remainsId": "remains:doro-pell",
          "name": "Doro Pell",
          "ageAtDeath": 55,
          "trace": "Grave digger; measured every spade cut"
        },
        {
          "personId": "person:tavi-ren",
          "remainsId": "remains:tavi-ren",
          "name": "Tavi Ren",
          "ageAtDeath": 33,
          "trace": "Token clerk; kept the seal-press motion"
        },
        {
          "personId": "person:bran-essel",
          "remainsId": "remains:bran-essel",
          "name": "Bran Essel",
          "ageAtDeath": 47,
          "trace": "Clay hauler; ducked the low lintel out of habit"
        },
        {
          "personId": "person:cass-ivel",
          "remainsId": "remains:cass-ivel",
          "name": "Cass Ivel",
          "ageAtDeath": 26,
          "trace": "Water carrier; balanced the yoke from memory"
        }
      ],
      "evidencePlacementSocket": {
        "id": "gate-strongbox",
        "beat": "z04-gate-of-accounts",
        "waypoint": "guard-post",
        "locked": true
      }
    },
    {
      "seed": "z04-s09",
      "holder": "SAL",
      "concessionGuarantor": "BRZ",
      "guarantorAgreement": "A supply contract guarantees the garrison's burial quota",
      "publicExplanation": "contractor-fraud-quiet",
      "tunnelHazard": "hazard-partial-gallery-collapse",
      "evidencePlacement": "gate-strongbox",
      "reagentShortage": "first-cut-lime",
      "operatorConfidence": "steady",
      "upperGateGuardCount": 4,
      "optionalEcho": "none",
      "guardRoster": {
        "count": 4,
        "followsGuarantor": true,
        "sheetId": "actor-mortuary-guard-rotation",
        "markId": "mark-brz-sun-disc"
      },
      "stations": [
        {
          "id": "station-lower-gallery",
          "beat": "z04-lower-work-gallery",
          "anchor": {
            "x": 15000,
            "y": 4000,
            "layer": 2
          },
          "bodies": [
            {
              "remainsId": "remains:leth-an",
              "position": {
                "x": 13000,
                "y": 3000,
                "layer": 2
              },
              "workPatternId": "tally-sort",
              "observable": "The first working dead the player can watch; plainly impossible motion, limited and task-bound"
            },
            {
              "remainsId": "remains:ines-var",
              "position": {
                "x": 24000,
                "y": 2000,
                "layer": 2
              },
              "workPatternId": "sift-ash",
              "observable": "Screened alcove; found by following the ash drift or the ledger map"
            }
          ]
        },
        {
          "id": "station-columbarium-vault",
          "beat": "z04-cooling-court",
          "anchor": {
            "x": 17000,
            "y": 8000,
            "layer": 1
          },
          "bodies": [
            {
              "remainsId": "remains:doro-pell",
              "position": {
                "x": 17000,
                "y": 7000,
                "layer": 1
              },
              "workPatternId": "vault-sort",
              "observable": "Salvage sorting behind the urn shelves"
            },
            {
              "remainsId": "remains:pel-dau",
              "position": {
                "x": 16000,
                "y": 8000,
                "layer": 1
              },
              "workPatternId": "urn-stack",
              "observable": "Stacking crates that were never buried"
            }
          ]
        },
        {
          "id": "station-firing-tunnels",
          "beat": "z04-cart-ramp-office",
          "anchor": {
            "x": 16000,
            "y": 10000,
            "layer": 4
          },
          "bodies": [
            {
              "remainsId": "remains:bran-essel",
              "position": {
                "x": 19000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "kiln-stoke",
              "observable": "Stoking the old firing tunnel mouth for the lime burn"
            },
            {
              "remainsId": "remains:oda-vren",
              "position": {
                "x": 14000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "lime-haul",
              "observable": "Hauling the lime barrow along the switchback"
            },
            {
              "remainsId": "remains:mila-senn",
              "position": {
                "x": 17000,
                "y": 10000,
                "layer": 4
              },
              "workPatternId": "sack-lift",
              "observable": "Lifting sacks at the cart stand he drove in life"
            }
          ]
        }
      ],
      "storage": [
        {
          "remainsId": "remains:tavi-ren",
          "position": {
            "x": 3000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the west storage cell"
        },
        {
          "remainsId": "remains:cass-ivel",
          "position": {
            "x": 4000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the east storage cell"
        }
      ],
      "dead": [
        {
          "personId": "person:leth-an",
          "remainsId": "remains:leth-an",
          "name": "Leth An",
          "ageAtDeath": 40,
          "trace": "Granary porter; his repeated tally gesture resembles work habit, not conscious testimony"
        },
        {
          "personId": "person:pel-dau",
          "remainsId": "remains:pel-dau",
          "name": "Pel Dau",
          "ageAtDeath": 60,
          "trace": "Burial-cart driver; kept the rein-hand habit"
        },
        {
          "personId": "person:ines-var",
          "remainsId": "remains:ines-var",
          "name": "Ines Var",
          "ageAtDeath": 38,
          "trace": "Potter; her thumb still finds the rim of a bowl"
        },
        {
          "personId": "person:doro-pell",
          "remainsId": "remains:doro-pell",
          "name": "Doro Pell",
          "ageAtDeath": 55,
          "trace": "Grave digger; measured every spade cut"
        },
        {
          "personId": "person:tavi-ren",
          "remainsId": "remains:tavi-ren",
          "name": "Tavi Ren",
          "ageAtDeath": 33,
          "trace": "Token clerk; kept the seal-press motion"
        },
        {
          "personId": "person:mila-senn",
          "remainsId": "remains:mila-senn",
          "name": "Mila Senn",
          "ageAtDeath": 41,
          "trace": "Urn painter; her wrist still turns the brush"
        },
        {
          "personId": "person:bran-essel",
          "remainsId": "remains:bran-essel",
          "name": "Bran Essel",
          "ageAtDeath": 47,
          "trace": "Clay hauler; ducked the low lintel out of habit"
        },
        {
          "personId": "person:oda-vren",
          "remainsId": "remains:oda-vren",
          "name": "Oda Vren",
          "ageAtDeath": 58,
          "trace": "Night watch; tapped the doorframe count"
        },
        {
          "personId": "person:cass-ivel",
          "remainsId": "remains:cass-ivel",
          "name": "Cass Ivel",
          "ageAtDeath": 26,
          "trace": "Water carrier; balanced the yoke from memory"
        }
      ],
      "evidencePlacementSocket": {
        "id": "gate-strongbox",
        "beat": "z04-gate-of-accounts",
        "waypoint": "guard-post",
        "locked": true
      }
    },
    {
      "seed": "z04-s10",
      "holder": "LOC",
      "concessionGuarantor": "BRZ",
      "guarantorAgreement": "A supply contract guarantees the garrison's burial quota",
      "publicExplanation": "contractor-fraud-quiet",
      "tunnelHazard": "hazard-shallow-seep",
      "evidencePlacement": "contractor-office",
      "reagentShortage": "first-cut-lime",
      "operatorConfidence": "defiant",
      "upperGateGuardCount": 2,
      "optionalEcho": "none",
      "guardRoster": {
        "count": 2,
        "followsGuarantor": true,
        "sheetId": "actor-mortuary-guard-rotation",
        "markId": "mark-brz-sun-disc"
      },
      "stations": [
        {
          "id": "station-lower-gallery",
          "beat": "z04-lower-work-gallery",
          "anchor": {
            "x": 15000,
            "y": 4000,
            "layer": 2
          },
          "bodies": [
            {
              "remainsId": "remains:leth-an",
              "position": {
                "x": 13000,
                "y": 3000,
                "layer": 2
              },
              "workPatternId": "tally-sort",
              "observable": "The first working dead the player can watch; plainly impossible motion, limited and task-bound"
            },
            {
              "remainsId": "remains:doro-pell",
              "position": {
                "x": 24000,
                "y": 2000,
                "layer": 2
              },
              "workPatternId": "sift-ash",
              "observable": "Screened alcove; found by following the ash drift or the ledger map"
            }
          ]
        },
        {
          "id": "station-columbarium-vault",
          "beat": "z04-cooling-court",
          "anchor": {
            "x": 17000,
            "y": 8000,
            "layer": 1
          },
          "bodies": [
            {
              "remainsId": "remains:cass-ivel",
              "position": {
                "x": 17000,
                "y": 7000,
                "layer": 1
              },
              "workPatternId": "vault-sort",
              "observable": "Salvage sorting behind the urn shelves"
            },
            {
              "remainsId": "remains:bran-essel",
              "position": {
                "x": 16000,
                "y": 8000,
                "layer": 1
              },
              "workPatternId": "urn-stack",
              "observable": "Stacking crates that were never buried"
            }
          ]
        },
        {
          "id": "station-firing-tunnels",
          "beat": "z04-cart-ramp-office",
          "anchor": {
            "x": 16000,
            "y": 10000,
            "layer": 4
          },
          "bodies": [
            {
              "remainsId": "remains:mila-senn",
              "position": {
                "x": 19000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "kiln-stoke",
              "observable": "Stoking the old firing tunnel mouth for the lime burn"
            },
            {
              "remainsId": "remains:sera-tol",
              "position": {
                "x": 14000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "lime-haul",
              "observable": "Hauling the lime barrow along the switchback"
            },
            {
              "remainsId": "remains:pel-dau",
              "position": {
                "x": 17000,
                "y": 10000,
                "layer": 4
              },
              "workPatternId": "sack-lift",
              "observable": "Lifting sacks at the cart stand he drove in life"
            }
          ]
        }
      ],
      "storage": [
        {
          "remainsId": "remains:maren-osk",
          "position": {
            "x": 3000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the west storage cell"
        },
        {
          "remainsId": "remains:oda-vren",
          "position": {
            "x": 4000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the east storage cell"
        }
      ],
      "dead": [
        {
          "personId": "person:leth-an",
          "remainsId": "remains:leth-an",
          "name": "Leth An",
          "ageAtDeath": 40,
          "trace": "Granary porter; his repeated tally gesture resembles work habit, not conscious testimony"
        },
        {
          "personId": "person:sera-tol",
          "remainsId": "remains:sera-tol",
          "name": "Sera Tol",
          "ageAtDeath": 52,
          "trace": "Kiln tender; kept the stoker's wrist turn"
        },
        {
          "personId": "person:maren-osk",
          "remainsId": "remains:maren-osk",
          "name": "Maren Osk",
          "ageAtDeath": 45,
          "trace": "Lime burner; pushed the barrow in cough-shortened lengths"
        },
        {
          "personId": "person:pel-dau",
          "remainsId": "remains:pel-dau",
          "name": "Pel Dau",
          "ageAtDeath": 60,
          "trace": "Burial-cart driver; kept the rein-hand habit"
        },
        {
          "personId": "person:doro-pell",
          "remainsId": "remains:doro-pell",
          "name": "Doro Pell",
          "ageAtDeath": 55,
          "trace": "Grave digger; measured every spade cut"
        },
        {
          "personId": "person:mila-senn",
          "remainsId": "remains:mila-senn",
          "name": "Mila Senn",
          "ageAtDeath": 41,
          "trace": "Urn painter; her wrist still turns the brush"
        },
        {
          "personId": "person:bran-essel",
          "remainsId": "remains:bran-essel",
          "name": "Bran Essel",
          "ageAtDeath": 47,
          "trace": "Clay hauler; ducked the low lintel out of habit"
        },
        {
          "personId": "person:oda-vren",
          "remainsId": "remains:oda-vren",
          "name": "Oda Vren",
          "ageAtDeath": 58,
          "trace": "Night watch; tapped the doorframe count"
        },
        {
          "personId": "person:cass-ivel",
          "remainsId": "remains:cass-ivel",
          "name": "Cass Ivel",
          "ageAtDeath": 26,
          "trace": "Water carrier; balanced the yoke from memory"
        }
      ],
      "evidencePlacementSocket": {
        "id": "contractor-office",
        "beat": "z04-cart-ramp-office",
        "waypoint": "noll-desk",
        "locked": true
      }
    },
    {
      "seed": "z04-s11",
      "holder": "SEN",
      "concessionGuarantor": "SAL",
      "guarantorAgreement": "A shipping house financed the concession against lime futures",
      "publicExplanation": "theft-blamed-on-outsiders",
      "tunnelHazard": "hazard-partial-gallery-collapse",
      "evidencePlacement": "gate-strongbox",
      "reagentShortage": "vannic-holding-salt",
      "operatorConfidence": "wavering",
      "upperGateGuardCount": 2,
      "optionalEcho": "none",
      "guardRoster": {
        "count": 2,
        "followsGuarantor": true,
        "sheetId": "actor-mortuary-guard-rotation",
        "markId": "mark-sal-sail-weight"
      },
      "stations": [
        {
          "id": "station-lower-gallery",
          "beat": "z04-lower-work-gallery",
          "anchor": {
            "x": 15000,
            "y": 4000,
            "layer": 2
          },
          "bodies": [
            {
              "remainsId": "remains:leth-an",
              "position": {
                "x": 13000,
                "y": 3000,
                "layer": 2
              },
              "workPatternId": "tally-sort",
              "observable": "The first working dead the player can watch; plainly impossible motion, limited and task-bound"
            },
            {
              "remainsId": "remains:kell-anik",
              "position": {
                "x": 24000,
                "y": 2000,
                "layer": 2
              },
              "workPatternId": "sift-ash",
              "observable": "Screened alcove; found by following the ash drift or the ledger map"
            }
          ]
        },
        {
          "id": "station-columbarium-vault",
          "beat": "z04-cooling-court",
          "anchor": {
            "x": 17000,
            "y": 8000,
            "layer": 1
          },
          "bodies": [
            {
              "remainsId": "remains:sera-tol",
              "position": {
                "x": 17000,
                "y": 7000,
                "layer": 1
              },
              "workPatternId": "vault-sort",
              "observable": "Salvage sorting behind the urn shelves"
            },
            {
              "remainsId": "remains:pel-dau",
              "position": {
                "x": 16000,
                "y": 8000,
                "layer": 1
              },
              "workPatternId": "urn-stack",
              "observable": "Stacking crates that were never buried"
            }
          ]
        },
        {
          "id": "station-firing-tunnels",
          "beat": "z04-cart-ramp-office",
          "anchor": {
            "x": 16000,
            "y": 10000,
            "layer": 4
          },
          "bodies": [
            {
              "remainsId": "remains:cass-ivel",
              "position": {
                "x": 19000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "kiln-stoke",
              "observable": "Stoking the old firing tunnel mouth for the lime burn"
            },
            {
              "remainsId": "remains:oda-vren",
              "position": {
                "x": 14000,
                "y": 9000,
                "layer": 4
              },
              "workPatternId": "lime-haul",
              "observable": "Hauling the lime barrow along the switchback"
            },
            {
              "remainsId": "remains:ines-var",
              "position": {
                "x": 17000,
                "y": 10000,
                "layer": 4
              },
              "workPatternId": "sack-lift",
              "observable": "Lifting sacks at the cart stand he drove in life"
            }
          ]
        }
      ],
      "storage": [
        {
          "remainsId": "remains:mila-senn",
          "position": {
            "x": 3000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the west storage cell"
        },
        {
          "remainsId": "remains:doro-pell",
          "position": {
            "x": 4000,
            "y": 8000,
            "layer": 3
          },
          "note": "Incomplete body in the east storage cell"
        }
      ],
      "dead": [
        {
          "personId": "person:leth-an",
          "remainsId": "remains:leth-an",
          "name": "Leth An",
          "ageAtDeath": 40,
          "trace": "Granary porter; his repeated tally gesture resembles work habit, not conscious testimony"
        },
        {
          "personId": "person:sera-tol",
          "remainsId": "remains:sera-tol",
          "name": "Sera Tol",
          "ageAtDeath": 52,
          "trace": "Kiln tender; kept the stoker's wrist turn"
        },
        {
          "personId": "person:pel-dau",
          "remainsId": "remains:pel-dau",
          "name": "Pel Dau",
          "ageAtDeath": 60,
          "trace": "Burial-cart driver; kept the rein-hand habit"
        },
        {
          "personId": "person:ines-var",
          "remainsId": "remains:ines-var",
          "name": "Ines Var",
          "ageAtDeath": 38,
          "trace": "Potter; her thumb still finds the rim of a bowl"
        },
        {
          "personId": "person:kell-anik",
          "remainsId": "remains:kell-anik",
          "name": "Kell Anik",
          "ageAtDeath": 29,
          "trace": "Ash sifter; kept the sieve rhythm"
        },
        {
          "personId": "person:doro-pell",
          "remainsId": "remains:doro-pell",
          "name": "Doro Pell",
          "ageAtDeath": 55,
          "trace": "Grave digger; measured every spade cut"
        },
        {
          "personId": "person:mila-senn",
          "remainsId": "remains:mila-senn",
          "name": "Mila Senn",
          "ageAtDeath": 41,
          "trace": "Urn painter; her wrist still turns the brush"
        },
        {
          "personId": "person:oda-vren",
          "remainsId": "remains:oda-vren",
          "name": "Oda Vren",
          "ageAtDeath": 58,
          "trace": "Night watch; tapped the doorframe count"
        },
        {
          "personId": "person:cass-ivel",
          "remainsId": "remains:cass-ivel",
          "name": "Cass Ivel",
          "ageAtDeath": 26,
          "trace": "Water carrier; balanced the yoke from memory"
        }
      ],
      "evidencePlacementSocket": {
        "id": "gate-strongbox",
        "beat": "z04-gate-of-accounts",
        "waypoint": "guard-post",
        "locked": true
      }
    }
  ],
  "map": {
    "cellSize": 1000,
    "layers": [
      {
        "id": 0,
        "cells": [
          {
            "x": 0,
            "y": 0
          },
          {
            "x": 1000,
            "y": 0
          },
          {
            "x": 2000,
            "y": 0
          },
          {
            "x": 3000,
            "y": 0
          },
          {
            "x": 4000,
            "y": 0
          },
          {
            "x": 5000,
            "y": 0
          },
          {
            "x": 6000,
            "y": 0
          },
          {
            "x": 7000,
            "y": 0
          },
          {
            "x": 8000,
            "y": 0
          },
          {
            "x": 9000,
            "y": 0
          },
          {
            "x": 10000,
            "y": 0
          },
          {
            "x": 11000,
            "y": 0
          },
          {
            "x": 12000,
            "y": 0
          },
          {
            "x": 13000,
            "y": 0
          },
          {
            "x": 14000,
            "y": 0
          },
          {
            "x": 15000,
            "y": 0
          },
          {
            "x": 16000,
            "y": 0
          },
          {
            "x": 17000,
            "y": 0
          },
          {
            "x": 18000,
            "y": 0
          },
          {
            "x": 19000,
            "y": 0
          },
          {
            "x": 0,
            "y": 1000
          },
          {
            "x": 1000,
            "y": 1000
          },
          {
            "x": 2000,
            "y": 1000
          },
          {
            "x": 3000,
            "y": 1000
          },
          {
            "x": 4000,
            "y": 1000
          },
          {
            "x": 5000,
            "y": 1000
          },
          {
            "x": 6000,
            "y": 1000
          },
          {
            "x": 7000,
            "y": 1000
          },
          {
            "x": 8000,
            "y": 1000
          },
          {
            "x": 9000,
            "y": 1000
          },
          {
            "x": 10000,
            "y": 1000
          },
          {
            "x": 11000,
            "y": 1000
          },
          {
            "x": 12000,
            "y": 1000
          },
          {
            "x": 13000,
            "y": 1000
          },
          {
            "x": 14000,
            "y": 1000
          },
          {
            "x": 15000,
            "y": 1000
          },
          {
            "x": 16000,
            "y": 1000
          },
          {
            "x": 17000,
            "y": 1000
          },
          {
            "x": 18000,
            "y": 1000
          },
          {
            "x": 19000,
            "y": 1000
          },
          {
            "x": 0,
            "y": 2000
          },
          {
            "x": 1000,
            "y": 2000
          },
          {
            "x": 2000,
            "y": 2000
          },
          {
            "x": 3000,
            "y": 2000
          },
          {
            "x": 4000,
            "y": 2000
          },
          {
            "x": 5000,
            "y": 2000
          },
          {
            "x": 6000,
            "y": 2000
          },
          {
            "x": 7000,
            "y": 2000
          },
          {
            "x": 8000,
            "y": 2000
          },
          {
            "x": 9000,
            "y": 2000
          },
          {
            "x": 10000,
            "y": 2000
          },
          {
            "x": 11000,
            "y": 2000
          },
          {
            "x": 12000,
            "y": 2000
          },
          {
            "x": 13000,
            "y": 2000
          },
          {
            "x": 14000,
            "y": 2000
          },
          {
            "x": 15000,
            "y": 2000
          },
          {
            "x": 16000,
            "y": 2000
          },
          {
            "x": 17000,
            "y": 2000
          },
          {
            "x": 18000,
            "y": 2000
          },
          {
            "x": 19000,
            "y": 2000
          },
          {
            "x": 0,
            "y": 3000
          },
          {
            "x": 1000,
            "y": 3000
          },
          {
            "x": 2000,
            "y": 3000
          },
          {
            "x": 3000,
            "y": 3000
          },
          {
            "x": 4000,
            "y": 3000
          },
          {
            "x": 5000,
            "y": 3000
          },
          {
            "x": 6000,
            "y": 3000
          },
          {
            "x": 7000,
            "y": 3000
          },
          {
            "x": 8000,
            "y": 3000
          },
          {
            "x": 9000,
            "y": 3000
          },
          {
            "x": 10000,
            "y": 3000
          },
          {
            "x": 11000,
            "y": 3000
          },
          {
            "x": 12000,
            "y": 3000
          },
          {
            "x": 13000,
            "y": 3000
          },
          {
            "x": 14000,
            "y": 3000
          },
          {
            "x": 15000,
            "y": 3000
          },
          {
            "x": 16000,
            "y": 3000
          },
          {
            "x": 17000,
            "y": 3000
          },
          {
            "x": 18000,
            "y": 3000
          },
          {
            "x": 19000,
            "y": 3000
          },
          {
            "x": 0,
            "y": 4000
          },
          {
            "x": 1000,
            "y": 4000
          },
          {
            "x": 2000,
            "y": 4000
          },
          {
            "x": 3000,
            "y": 4000
          },
          {
            "x": 4000,
            "y": 4000
          },
          {
            "x": 5000,
            "y": 4000
          },
          {
            "x": 6000,
            "y": 4000
          },
          {
            "x": 7000,
            "y": 4000
          },
          {
            "x": 8000,
            "y": 4000
          },
          {
            "x": 9000,
            "y": 4000
          },
          {
            "x": 10000,
            "y": 4000
          },
          {
            "x": 11000,
            "y": 4000
          },
          {
            "x": 12000,
            "y": 4000
          },
          {
            "x": 13000,
            "y": 4000
          },
          {
            "x": 14000,
            "y": 4000
          },
          {
            "x": 15000,
            "y": 4000
          },
          {
            "x": 16000,
            "y": 4000
          },
          {
            "x": 17000,
            "y": 4000
          },
          {
            "x": 18000,
            "y": 4000
          },
          {
            "x": 19000,
            "y": 4000
          },
          {
            "x": 0,
            "y": 5000
          },
          {
            "x": 1000,
            "y": 5000
          },
          {
            "x": 2000,
            "y": 5000
          },
          {
            "x": 3000,
            "y": 5000
          },
          {
            "x": 4000,
            "y": 5000
          },
          {
            "x": 5000,
            "y": 5000
          },
          {
            "x": 6000,
            "y": 5000
          },
          {
            "x": 7000,
            "y": 5000
          },
          {
            "x": 8000,
            "y": 5000
          },
          {
            "x": 9000,
            "y": 5000
          },
          {
            "x": 10000,
            "y": 5000
          },
          {
            "x": 11000,
            "y": 5000
          },
          {
            "x": 12000,
            "y": 5000
          },
          {
            "x": 13000,
            "y": 5000
          },
          {
            "x": 14000,
            "y": 5000
          },
          {
            "x": 15000,
            "y": 5000
          },
          {
            "x": 16000,
            "y": 5000
          },
          {
            "x": 17000,
            "y": 5000
          },
          {
            "x": 18000,
            "y": 5000
          },
          {
            "x": 19000,
            "y": 5000
          },
          {
            "x": 0,
            "y": 6000
          },
          {
            "x": 1000,
            "y": 6000
          },
          {
            "x": 2000,
            "y": 6000
          },
          {
            "x": 3000,
            "y": 6000
          },
          {
            "x": 4000,
            "y": 6000
          },
          {
            "x": 5000,
            "y": 6000
          },
          {
            "x": 6000,
            "y": 6000
          },
          {
            "x": 7000,
            "y": 6000
          },
          {
            "x": 8000,
            "y": 6000
          },
          {
            "x": 9000,
            "y": 6000
          },
          {
            "x": 10000,
            "y": 6000
          },
          {
            "x": 11000,
            "y": 6000
          },
          {
            "x": 12000,
            "y": 6000
          },
          {
            "x": 13000,
            "y": 6000
          },
          {
            "x": 14000,
            "y": 6000
          },
          {
            "x": 15000,
            "y": 6000
          },
          {
            "x": 16000,
            "y": 6000
          },
          {
            "x": 17000,
            "y": 6000
          },
          {
            "x": 18000,
            "y": 6000
          },
          {
            "x": 19000,
            "y": 6000
          },
          {
            "x": 0,
            "y": 7000
          },
          {
            "x": 1000,
            "y": 7000
          },
          {
            "x": 2000,
            "y": 7000
          },
          {
            "x": 3000,
            "y": 7000
          },
          {
            "x": 4000,
            "y": 7000
          },
          {
            "x": 5000,
            "y": 7000
          },
          {
            "x": 6000,
            "y": 7000
          },
          {
            "x": 7000,
            "y": 7000
          },
          {
            "x": 8000,
            "y": 7000
          },
          {
            "x": 9000,
            "y": 7000
          },
          {
            "x": 10000,
            "y": 7000
          },
          {
            "x": 11000,
            "y": 7000
          },
          {
            "x": 12000,
            "y": 7000
          },
          {
            "x": 13000,
            "y": 7000
          },
          {
            "x": 14000,
            "y": 7000
          },
          {
            "x": 15000,
            "y": 7000
          },
          {
            "x": 16000,
            "y": 7000
          },
          {
            "x": 17000,
            "y": 7000
          },
          {
            "x": 18000,
            "y": 7000
          },
          {
            "x": 19000,
            "y": 7000
          },
          {
            "x": 0,
            "y": 8000
          },
          {
            "x": 1000,
            "y": 8000
          },
          {
            "x": 2000,
            "y": 8000
          },
          {
            "x": 3000,
            "y": 8000
          },
          {
            "x": 4000,
            "y": 8000
          },
          {
            "x": 5000,
            "y": 8000
          },
          {
            "x": 6000,
            "y": 8000
          },
          {
            "x": 7000,
            "y": 8000
          },
          {
            "x": 8000,
            "y": 8000
          },
          {
            "x": 9000,
            "y": 8000
          },
          {
            "x": 10000,
            "y": 8000
          },
          {
            "x": 11000,
            "y": 8000
          },
          {
            "x": 12000,
            "y": 8000
          },
          {
            "x": 13000,
            "y": 8000
          },
          {
            "x": 14000,
            "y": 8000
          },
          {
            "x": 15000,
            "y": 8000
          },
          {
            "x": 16000,
            "y": 8000
          },
          {
            "x": 17000,
            "y": 8000
          },
          {
            "x": 18000,
            "y": 8000
          },
          {
            "x": 19000,
            "y": 8000
          },
          {
            "x": 0,
            "y": 9000
          },
          {
            "x": 1000,
            "y": 9000
          },
          {
            "x": 2000,
            "y": 9000
          },
          {
            "x": 3000,
            "y": 9000
          },
          {
            "x": 4000,
            "y": 9000
          },
          {
            "x": 5000,
            "y": 9000
          },
          {
            "x": 6000,
            "y": 9000
          },
          {
            "x": 7000,
            "y": 9000
          },
          {
            "x": 8000,
            "y": 9000
          },
          {
            "x": 9000,
            "y": 9000
          },
          {
            "x": 10000,
            "y": 9000
          },
          {
            "x": 11000,
            "y": 9000
          },
          {
            "x": 12000,
            "y": 9000
          },
          {
            "x": 13000,
            "y": 9000
          },
          {
            "x": 14000,
            "y": 9000
          },
          {
            "x": 15000,
            "y": 9000
          },
          {
            "x": 16000,
            "y": 9000
          },
          {
            "x": 17000,
            "y": 9000
          },
          {
            "x": 18000,
            "y": 9000
          },
          {
            "x": 19000,
            "y": 9000
          },
          {
            "x": 0,
            "y": 10000
          },
          {
            "x": 1000,
            "y": 10000
          },
          {
            "x": 2000,
            "y": 10000
          },
          {
            "x": 3000,
            "y": 10000
          },
          {
            "x": 4000,
            "y": 10000
          },
          {
            "x": 5000,
            "y": 10000
          },
          {
            "x": 6000,
            "y": 10000
          },
          {
            "x": 7000,
            "y": 10000
          },
          {
            "x": 8000,
            "y": 10000
          },
          {
            "x": 9000,
            "y": 10000
          },
          {
            "x": 10000,
            "y": 10000
          },
          {
            "x": 11000,
            "y": 10000
          },
          {
            "x": 12000,
            "y": 10000
          },
          {
            "x": 13000,
            "y": 10000
          },
          {
            "x": 14000,
            "y": 10000
          },
          {
            "x": 15000,
            "y": 10000
          },
          {
            "x": 16000,
            "y": 10000
          },
          {
            "x": 17000,
            "y": 10000
          },
          {
            "x": 18000,
            "y": 10000
          },
          {
            "x": 19000,
            "y": 10000
          },
          {
            "x": 0,
            "y": 11000
          },
          {
            "x": 1000,
            "y": 11000
          },
          {
            "x": 2000,
            "y": 11000
          },
          {
            "x": 3000,
            "y": 11000
          },
          {
            "x": 4000,
            "y": 11000
          },
          {
            "x": 5000,
            "y": 11000
          },
          {
            "x": 6000,
            "y": 11000
          },
          {
            "x": 7000,
            "y": 11000
          },
          {
            "x": 8000,
            "y": 11000
          },
          {
            "x": 9000,
            "y": 11000
          },
          {
            "x": 10000,
            "y": 11000
          },
          {
            "x": 11000,
            "y": 11000
          },
          {
            "x": 12000,
            "y": 11000
          },
          {
            "x": 13000,
            "y": 11000
          },
          {
            "x": 14000,
            "y": 11000
          },
          {
            "x": 15000,
            "y": 11000
          },
          {
            "x": 16000,
            "y": 11000
          },
          {
            "x": 17000,
            "y": 11000
          },
          {
            "x": 18000,
            "y": 11000
          },
          {
            "x": 19000,
            "y": 11000
          }
        ]
      },
      {
        "id": 1,
        "cells": [
          {
            "x": 0,
            "y": 0
          },
          {
            "x": 1000,
            "y": 0
          },
          {
            "x": 2000,
            "y": 0
          },
          {
            "x": 3000,
            "y": 0
          },
          {
            "x": 4000,
            "y": 0
          },
          {
            "x": 5000,
            "y": 0
          },
          {
            "x": 6000,
            "y": 0
          },
          {
            "x": 7000,
            "y": 0
          },
          {
            "x": 8000,
            "y": 0
          },
          {
            "x": 9000,
            "y": 0
          },
          {
            "x": 10000,
            "y": 0
          },
          {
            "x": 11000,
            "y": 0
          },
          {
            "x": 12000,
            "y": 0
          },
          {
            "x": 13000,
            "y": 0
          },
          {
            "x": 14000,
            "y": 0
          },
          {
            "x": 15000,
            "y": 0
          },
          {
            "x": 16000,
            "y": 0
          },
          {
            "x": 17000,
            "y": 0
          },
          {
            "x": 18000,
            "y": 0
          },
          {
            "x": 19000,
            "y": 0
          },
          {
            "x": 0,
            "y": 1000
          },
          {
            "x": 1000,
            "y": 1000
          },
          {
            "x": 2000,
            "y": 1000
          },
          {
            "x": 3000,
            "y": 1000
          },
          {
            "x": 4000,
            "y": 1000
          },
          {
            "x": 5000,
            "y": 1000
          },
          {
            "x": 6000,
            "y": 1000
          },
          {
            "x": 7000,
            "y": 1000
          },
          {
            "x": 8000,
            "y": 1000
          },
          {
            "x": 9000,
            "y": 1000
          },
          {
            "x": 10000,
            "y": 1000
          },
          {
            "x": 11000,
            "y": 1000
          },
          {
            "x": 12000,
            "y": 1000
          },
          {
            "x": 13000,
            "y": 1000
          },
          {
            "x": 14000,
            "y": 1000
          },
          {
            "x": 15000,
            "y": 1000
          },
          {
            "x": 16000,
            "y": 1000
          },
          {
            "x": 17000,
            "y": 1000
          },
          {
            "x": 18000,
            "y": 1000
          },
          {
            "x": 19000,
            "y": 1000
          },
          {
            "x": 0,
            "y": 2000
          },
          {
            "x": 1000,
            "y": 2000
          },
          {
            "x": 2000,
            "y": 2000
          },
          {
            "x": 3000,
            "y": 2000
          },
          {
            "x": 4000,
            "y": 2000
          },
          {
            "x": 5000,
            "y": 2000
          },
          {
            "x": 6000,
            "y": 2000
          },
          {
            "x": 7000,
            "y": 2000
          },
          {
            "x": 8000,
            "y": 2000
          },
          {
            "x": 9000,
            "y": 2000
          },
          {
            "x": 10000,
            "y": 2000
          },
          {
            "x": 11000,
            "y": 2000
          },
          {
            "x": 12000,
            "y": 2000
          },
          {
            "x": 13000,
            "y": 2000
          },
          {
            "x": 14000,
            "y": 2000
          },
          {
            "x": 15000,
            "y": 2000
          },
          {
            "x": 16000,
            "y": 2000
          },
          {
            "x": 17000,
            "y": 2000
          },
          {
            "x": 18000,
            "y": 2000
          },
          {
            "x": 19000,
            "y": 2000
          },
          {
            "x": 0,
            "y": 3000
          },
          {
            "x": 1000,
            "y": 3000
          },
          {
            "x": 2000,
            "y": 3000
          },
          {
            "x": 3000,
            "y": 3000
          },
          {
            "x": 4000,
            "y": 3000
          },
          {
            "x": 5000,
            "y": 3000
          },
          {
            "x": 6000,
            "y": 3000
          },
          {
            "x": 7000,
            "y": 3000
          },
          {
            "x": 8000,
            "y": 3000
          },
          {
            "x": 9000,
            "y": 3000
          },
          {
            "x": 10000,
            "y": 3000
          },
          {
            "x": 11000,
            "y": 3000
          },
          {
            "x": 12000,
            "y": 3000
          },
          {
            "x": 13000,
            "y": 3000
          },
          {
            "x": 14000,
            "y": 3000
          },
          {
            "x": 15000,
            "y": 3000
          },
          {
            "x": 16000,
            "y": 3000
          },
          {
            "x": 17000,
            "y": 3000
          },
          {
            "x": 18000,
            "y": 3000
          },
          {
            "x": 19000,
            "y": 3000
          },
          {
            "x": 0,
            "y": 4000
          },
          {
            "x": 1000,
            "y": 4000
          },
          {
            "x": 2000,
            "y": 4000
          },
          {
            "x": 3000,
            "y": 4000
          },
          {
            "x": 4000,
            "y": 4000
          },
          {
            "x": 5000,
            "y": 4000
          },
          {
            "x": 6000,
            "y": 4000
          },
          {
            "x": 7000,
            "y": 4000
          },
          {
            "x": 8000,
            "y": 4000
          },
          {
            "x": 9000,
            "y": 4000
          },
          {
            "x": 10000,
            "y": 4000
          },
          {
            "x": 11000,
            "y": 4000
          },
          {
            "x": 12000,
            "y": 4000
          },
          {
            "x": 13000,
            "y": 4000
          },
          {
            "x": 14000,
            "y": 4000
          },
          {
            "x": 15000,
            "y": 4000
          },
          {
            "x": 16000,
            "y": 4000
          },
          {
            "x": 17000,
            "y": 4000
          },
          {
            "x": 18000,
            "y": 4000
          },
          {
            "x": 19000,
            "y": 4000
          },
          {
            "x": 0,
            "y": 5000
          },
          {
            "x": 1000,
            "y": 5000
          },
          {
            "x": 2000,
            "y": 5000
          },
          {
            "x": 3000,
            "y": 5000
          },
          {
            "x": 4000,
            "y": 5000
          },
          {
            "x": 5000,
            "y": 5000
          },
          {
            "x": 6000,
            "y": 5000
          },
          {
            "x": 7000,
            "y": 5000
          },
          {
            "x": 8000,
            "y": 5000
          },
          {
            "x": 9000,
            "y": 5000
          },
          {
            "x": 10000,
            "y": 5000
          },
          {
            "x": 11000,
            "y": 5000
          },
          {
            "x": 12000,
            "y": 5000
          },
          {
            "x": 13000,
            "y": 5000
          },
          {
            "x": 14000,
            "y": 5000
          },
          {
            "x": 15000,
            "y": 5000
          },
          {
            "x": 16000,
            "y": 5000
          },
          {
            "x": 17000,
            "y": 5000
          },
          {
            "x": 18000,
            "y": 5000
          },
          {
            "x": 19000,
            "y": 5000
          },
          {
            "x": 0,
            "y": 6000
          },
          {
            "x": 1000,
            "y": 6000
          },
          {
            "x": 2000,
            "y": 6000
          },
          {
            "x": 3000,
            "y": 6000
          },
          {
            "x": 4000,
            "y": 6000
          },
          {
            "x": 5000,
            "y": 6000
          },
          {
            "x": 6000,
            "y": 6000
          },
          {
            "x": 7000,
            "y": 6000
          },
          {
            "x": 8000,
            "y": 6000
          },
          {
            "x": 9000,
            "y": 6000
          },
          {
            "x": 10000,
            "y": 6000
          },
          {
            "x": 11000,
            "y": 6000
          },
          {
            "x": 12000,
            "y": 6000
          },
          {
            "x": 13000,
            "y": 6000
          },
          {
            "x": 14000,
            "y": 6000
          },
          {
            "x": 15000,
            "y": 6000
          },
          {
            "x": 16000,
            "y": 6000
          },
          {
            "x": 17000,
            "y": 6000
          },
          {
            "x": 18000,
            "y": 6000
          },
          {
            "x": 19000,
            "y": 6000
          },
          {
            "x": 0,
            "y": 7000
          },
          {
            "x": 1000,
            "y": 7000
          },
          {
            "x": 2000,
            "y": 7000
          },
          {
            "x": 3000,
            "y": 7000
          },
          {
            "x": 4000,
            "y": 7000
          },
          {
            "x": 5000,
            "y": 7000
          },
          {
            "x": 6000,
            "y": 7000
          },
          {
            "x": 7000,
            "y": 7000
          },
          {
            "x": 8000,
            "y": 7000
          },
          {
            "x": 9000,
            "y": 7000
          },
          {
            "x": 10000,
            "y": 7000
          },
          {
            "x": 11000,
            "y": 7000
          },
          {
            "x": 12000,
            "y": 7000
          },
          {
            "x": 13000,
            "y": 7000
          },
          {
            "x": 14000,
            "y": 7000
          },
          {
            "x": 15000,
            "y": 7000
          },
          {
            "x": 16000,
            "y": 7000
          },
          {
            "x": 17000,
            "y": 7000
          },
          {
            "x": 18000,
            "y": 7000
          },
          {
            "x": 19000,
            "y": 7000
          },
          {
            "x": 0,
            "y": 8000
          },
          {
            "x": 1000,
            "y": 8000
          },
          {
            "x": 2000,
            "y": 8000
          },
          {
            "x": 3000,
            "y": 8000
          },
          {
            "x": 4000,
            "y": 8000
          },
          {
            "x": 5000,
            "y": 8000
          },
          {
            "x": 6000,
            "y": 8000
          },
          {
            "x": 7000,
            "y": 8000
          },
          {
            "x": 8000,
            "y": 8000
          },
          {
            "x": 9000,
            "y": 8000
          },
          {
            "x": 10000,
            "y": 8000
          },
          {
            "x": 11000,
            "y": 8000
          },
          {
            "x": 12000,
            "y": 8000
          },
          {
            "x": 13000,
            "y": 8000
          },
          {
            "x": 14000,
            "y": 8000
          },
          {
            "x": 15000,
            "y": 8000
          },
          {
            "x": 16000,
            "y": 8000
          },
          {
            "x": 17000,
            "y": 8000
          },
          {
            "x": 18000,
            "y": 8000
          },
          {
            "x": 19000,
            "y": 8000
          },
          {
            "x": 0,
            "y": 9000
          },
          {
            "x": 1000,
            "y": 9000
          },
          {
            "x": 2000,
            "y": 9000
          },
          {
            "x": 3000,
            "y": 9000
          },
          {
            "x": 4000,
            "y": 9000
          },
          {
            "x": 5000,
            "y": 9000
          },
          {
            "x": 6000,
            "y": 9000
          },
          {
            "x": 7000,
            "y": 9000
          },
          {
            "x": 8000,
            "y": 9000
          },
          {
            "x": 9000,
            "y": 9000
          },
          {
            "x": 10000,
            "y": 9000
          },
          {
            "x": 11000,
            "y": 9000
          },
          {
            "x": 12000,
            "y": 9000
          },
          {
            "x": 13000,
            "y": 9000
          },
          {
            "x": 14000,
            "y": 9000
          },
          {
            "x": 15000,
            "y": 9000
          },
          {
            "x": 16000,
            "y": 9000
          },
          {
            "x": 17000,
            "y": 9000
          },
          {
            "x": 18000,
            "y": 9000
          },
          {
            "x": 19000,
            "y": 9000
          }
        ]
      },
      {
        "id": 2,
        "cells": [
          {
            "x": 0,
            "y": 0
          },
          {
            "x": 1000,
            "y": 0
          },
          {
            "x": 2000,
            "y": 0
          },
          {
            "x": 3000,
            "y": 0
          },
          {
            "x": 4000,
            "y": 0
          },
          {
            "x": 5000,
            "y": 0
          },
          {
            "x": 6000,
            "y": 0
          },
          {
            "x": 7000,
            "y": 0
          },
          {
            "x": 8000,
            "y": 0
          },
          {
            "x": 9000,
            "y": 0
          },
          {
            "x": 10000,
            "y": 0
          },
          {
            "x": 11000,
            "y": 0
          },
          {
            "x": 12000,
            "y": 0
          },
          {
            "x": 13000,
            "y": 0
          },
          {
            "x": 14000,
            "y": 0
          },
          {
            "x": 15000,
            "y": 0
          },
          {
            "x": 16000,
            "y": 0
          },
          {
            "x": 17000,
            "y": 0
          },
          {
            "x": 18000,
            "y": 0
          },
          {
            "x": 19000,
            "y": 0
          },
          {
            "x": 20000,
            "y": 0
          },
          {
            "x": 21000,
            "y": 0
          },
          {
            "x": 22000,
            "y": 0
          },
          {
            "x": 23000,
            "y": 0
          },
          {
            "x": 24000,
            "y": 0
          },
          {
            "x": 25000,
            "y": 0
          },
          {
            "x": 26000,
            "y": 0
          },
          {
            "x": 27000,
            "y": 0
          },
          {
            "x": 28000,
            "y": 0
          },
          {
            "x": 29000,
            "y": 0
          },
          {
            "x": 0,
            "y": 1000
          },
          {
            "x": 1000,
            "y": 1000
          },
          {
            "x": 2000,
            "y": 1000
          },
          {
            "x": 3000,
            "y": 1000
          },
          {
            "x": 4000,
            "y": 1000
          },
          {
            "x": 5000,
            "y": 1000
          },
          {
            "x": 6000,
            "y": 1000
          },
          {
            "x": 7000,
            "y": 1000
          },
          {
            "x": 8000,
            "y": 1000
          },
          {
            "x": 9000,
            "y": 1000
          },
          {
            "x": 10000,
            "y": 1000
          },
          {
            "x": 11000,
            "y": 1000
          },
          {
            "x": 12000,
            "y": 1000
          },
          {
            "x": 13000,
            "y": 1000
          },
          {
            "x": 14000,
            "y": 1000
          },
          {
            "x": 15000,
            "y": 1000
          },
          {
            "x": 16000,
            "y": 1000
          },
          {
            "x": 17000,
            "y": 1000
          },
          {
            "x": 18000,
            "y": 1000
          },
          {
            "x": 19000,
            "y": 1000
          },
          {
            "x": 20000,
            "y": 1000
          },
          {
            "x": 21000,
            "y": 1000
          },
          {
            "x": 22000,
            "y": 1000
          },
          {
            "x": 23000,
            "y": 1000
          },
          {
            "x": 24000,
            "y": 1000
          },
          {
            "x": 25000,
            "y": 1000
          },
          {
            "x": 26000,
            "y": 1000
          },
          {
            "x": 27000,
            "y": 1000
          },
          {
            "x": 28000,
            "y": 1000
          },
          {
            "x": 29000,
            "y": 1000
          },
          {
            "x": 0,
            "y": 2000
          },
          {
            "x": 1000,
            "y": 2000
          },
          {
            "x": 2000,
            "y": 2000
          },
          {
            "x": 3000,
            "y": 2000
          },
          {
            "x": 4000,
            "y": 2000
          },
          {
            "x": 5000,
            "y": 2000
          },
          {
            "x": 6000,
            "y": 2000
          },
          {
            "x": 7000,
            "y": 2000
          },
          {
            "x": 8000,
            "y": 2000
          },
          {
            "x": 9000,
            "y": 2000
          },
          {
            "x": 10000,
            "y": 2000
          },
          {
            "x": 11000,
            "y": 2000
          },
          {
            "x": 12000,
            "y": 2000
          },
          {
            "x": 13000,
            "y": 2000
          },
          {
            "x": 14000,
            "y": 2000
          },
          {
            "x": 15000,
            "y": 2000
          },
          {
            "x": 16000,
            "y": 2000
          },
          {
            "x": 17000,
            "y": 2000
          },
          {
            "x": 18000,
            "y": 2000
          },
          {
            "x": 19000,
            "y": 2000
          },
          {
            "x": 20000,
            "y": 2000
          },
          {
            "x": 21000,
            "y": 2000
          },
          {
            "x": 22000,
            "y": 2000
          },
          {
            "x": 23000,
            "y": 2000
          },
          {
            "x": 24000,
            "y": 2000
          },
          {
            "x": 25000,
            "y": 2000
          },
          {
            "x": 26000,
            "y": 2000
          },
          {
            "x": 27000,
            "y": 2000
          },
          {
            "x": 28000,
            "y": 2000
          },
          {
            "x": 29000,
            "y": 2000
          },
          {
            "x": 0,
            "y": 3000
          },
          {
            "x": 1000,
            "y": 3000
          },
          {
            "x": 2000,
            "y": 3000
          },
          {
            "x": 3000,
            "y": 3000
          },
          {
            "x": 4000,
            "y": 3000
          },
          {
            "x": 5000,
            "y": 3000
          },
          {
            "x": 6000,
            "y": 3000
          },
          {
            "x": 7000,
            "y": 3000
          },
          {
            "x": 8000,
            "y": 3000
          },
          {
            "x": 9000,
            "y": 3000
          },
          {
            "x": 10000,
            "y": 3000
          },
          {
            "x": 11000,
            "y": 3000
          },
          {
            "x": 12000,
            "y": 3000
          },
          {
            "x": 13000,
            "y": 3000
          },
          {
            "x": 14000,
            "y": 3000
          },
          {
            "x": 15000,
            "y": 3000
          },
          {
            "x": 16000,
            "y": 3000
          },
          {
            "x": 17000,
            "y": 3000
          },
          {
            "x": 18000,
            "y": 3000
          },
          {
            "x": 19000,
            "y": 3000
          },
          {
            "x": 20000,
            "y": 3000
          },
          {
            "x": 21000,
            "y": 3000
          },
          {
            "x": 22000,
            "y": 3000
          },
          {
            "x": 23000,
            "y": 3000
          },
          {
            "x": 24000,
            "y": 3000
          },
          {
            "x": 25000,
            "y": 3000
          },
          {
            "x": 26000,
            "y": 3000
          },
          {
            "x": 27000,
            "y": 3000
          },
          {
            "x": 28000,
            "y": 3000
          },
          {
            "x": 29000,
            "y": 3000
          },
          {
            "x": 0,
            "y": 4000
          },
          {
            "x": 1000,
            "y": 4000
          },
          {
            "x": 2000,
            "y": 4000
          },
          {
            "x": 3000,
            "y": 4000
          },
          {
            "x": 4000,
            "y": 4000
          },
          {
            "x": 5000,
            "y": 4000
          },
          {
            "x": 6000,
            "y": 4000
          },
          {
            "x": 7000,
            "y": 4000
          },
          {
            "x": 8000,
            "y": 4000
          },
          {
            "x": 9000,
            "y": 4000
          },
          {
            "x": 10000,
            "y": 4000
          },
          {
            "x": 11000,
            "y": 4000
          },
          {
            "x": 12000,
            "y": 4000
          },
          {
            "x": 13000,
            "y": 4000
          },
          {
            "x": 14000,
            "y": 4000
          },
          {
            "x": 15000,
            "y": 4000
          },
          {
            "x": 16000,
            "y": 4000
          },
          {
            "x": 17000,
            "y": 4000
          },
          {
            "x": 18000,
            "y": 4000
          },
          {
            "x": 19000,
            "y": 4000
          },
          {
            "x": 20000,
            "y": 4000
          },
          {
            "x": 21000,
            "y": 4000
          },
          {
            "x": 22000,
            "y": 4000
          },
          {
            "x": 23000,
            "y": 4000
          },
          {
            "x": 24000,
            "y": 4000
          },
          {
            "x": 25000,
            "y": 4000
          },
          {
            "x": 26000,
            "y": 4000
          },
          {
            "x": 27000,
            "y": 4000
          },
          {
            "x": 28000,
            "y": 4000
          },
          {
            "x": 29000,
            "y": 4000
          },
          {
            "x": 0,
            "y": 5000
          },
          {
            "x": 1000,
            "y": 5000
          },
          {
            "x": 2000,
            "y": 5000
          },
          {
            "x": 3000,
            "y": 5000
          },
          {
            "x": 4000,
            "y": 5000
          },
          {
            "x": 5000,
            "y": 5000
          },
          {
            "x": 6000,
            "y": 5000
          },
          {
            "x": 7000,
            "y": 5000
          },
          {
            "x": 8000,
            "y": 5000
          },
          {
            "x": 9000,
            "y": 5000
          },
          {
            "x": 10000,
            "y": 5000
          },
          {
            "x": 11000,
            "y": 5000
          },
          {
            "x": 12000,
            "y": 5000
          },
          {
            "x": 13000,
            "y": 5000
          },
          {
            "x": 14000,
            "y": 5000
          },
          {
            "x": 15000,
            "y": 5000
          },
          {
            "x": 16000,
            "y": 5000
          },
          {
            "x": 17000,
            "y": 5000
          },
          {
            "x": 18000,
            "y": 5000
          },
          {
            "x": 19000,
            "y": 5000
          },
          {
            "x": 20000,
            "y": 5000
          },
          {
            "x": 21000,
            "y": 5000
          },
          {
            "x": 22000,
            "y": 5000
          },
          {
            "x": 23000,
            "y": 5000
          },
          {
            "x": 24000,
            "y": 5000
          },
          {
            "x": 25000,
            "y": 5000
          },
          {
            "x": 26000,
            "y": 5000
          },
          {
            "x": 27000,
            "y": 5000
          },
          {
            "x": 28000,
            "y": 5000
          },
          {
            "x": 29000,
            "y": 5000
          },
          {
            "x": 0,
            "y": 6000
          },
          {
            "x": 1000,
            "y": 6000
          },
          {
            "x": 2000,
            "y": 6000
          },
          {
            "x": 3000,
            "y": 6000
          },
          {
            "x": 4000,
            "y": 6000
          },
          {
            "x": 5000,
            "y": 6000
          },
          {
            "x": 6000,
            "y": 6000
          },
          {
            "x": 7000,
            "y": 6000
          },
          {
            "x": 8000,
            "y": 6000
          },
          {
            "x": 9000,
            "y": 6000
          },
          {
            "x": 10000,
            "y": 6000
          },
          {
            "x": 11000,
            "y": 6000
          },
          {
            "x": 12000,
            "y": 6000
          },
          {
            "x": 13000,
            "y": 6000
          },
          {
            "x": 14000,
            "y": 6000
          },
          {
            "x": 15000,
            "y": 6000
          },
          {
            "x": 16000,
            "y": 6000
          },
          {
            "x": 17000,
            "y": 6000
          },
          {
            "x": 18000,
            "y": 6000
          },
          {
            "x": 19000,
            "y": 6000
          },
          {
            "x": 20000,
            "y": 6000
          },
          {
            "x": 21000,
            "y": 6000
          },
          {
            "x": 22000,
            "y": 6000
          },
          {
            "x": 23000,
            "y": 6000
          },
          {
            "x": 24000,
            "y": 6000
          },
          {
            "x": 25000,
            "y": 6000
          },
          {
            "x": 26000,
            "y": 6000
          },
          {
            "x": 27000,
            "y": 6000
          },
          {
            "x": 28000,
            "y": 6000
          },
          {
            "x": 29000,
            "y": 6000
          },
          {
            "x": 0,
            "y": 7000
          },
          {
            "x": 1000,
            "y": 7000
          },
          {
            "x": 2000,
            "y": 7000
          },
          {
            "x": 3000,
            "y": 7000
          },
          {
            "x": 4000,
            "y": 7000
          },
          {
            "x": 5000,
            "y": 7000
          },
          {
            "x": 6000,
            "y": 7000
          },
          {
            "x": 7000,
            "y": 7000
          },
          {
            "x": 8000,
            "y": 7000
          },
          {
            "x": 9000,
            "y": 7000
          },
          {
            "x": 10000,
            "y": 7000
          },
          {
            "x": 11000,
            "y": 7000
          },
          {
            "x": 12000,
            "y": 7000
          },
          {
            "x": 13000,
            "y": 7000
          },
          {
            "x": 14000,
            "y": 7000
          },
          {
            "x": 15000,
            "y": 7000
          },
          {
            "x": 16000,
            "y": 7000
          },
          {
            "x": 17000,
            "y": 7000
          },
          {
            "x": 18000,
            "y": 7000
          },
          {
            "x": 19000,
            "y": 7000
          },
          {
            "x": 20000,
            "y": 7000
          },
          {
            "x": 21000,
            "y": 7000
          },
          {
            "x": 22000,
            "y": 7000
          },
          {
            "x": 23000,
            "y": 7000
          },
          {
            "x": 24000,
            "y": 7000
          },
          {
            "x": 25000,
            "y": 7000
          },
          {
            "x": 26000,
            "y": 7000
          },
          {
            "x": 27000,
            "y": 7000
          },
          {
            "x": 28000,
            "y": 7000
          },
          {
            "x": 29000,
            "y": 7000
          }
        ]
      },
      {
        "id": 3,
        "cells": [
          {
            "x": 0,
            "y": 0
          },
          {
            "x": 1000,
            "y": 0
          },
          {
            "x": 2000,
            "y": 0
          },
          {
            "x": 3000,
            "y": 0
          },
          {
            "x": 4000,
            "y": 0
          },
          {
            "x": 5000,
            "y": 0
          },
          {
            "x": 6000,
            "y": 0
          },
          {
            "x": 7000,
            "y": 0
          },
          {
            "x": 8000,
            "y": 0
          },
          {
            "x": 9000,
            "y": 0
          },
          {
            "x": 10000,
            "y": 0
          },
          {
            "x": 11000,
            "y": 0
          },
          {
            "x": 12000,
            "y": 0
          },
          {
            "x": 13000,
            "y": 0
          },
          {
            "x": 14000,
            "y": 0
          },
          {
            "x": 15000,
            "y": 0
          },
          {
            "x": 16000,
            "y": 0
          },
          {
            "x": 17000,
            "y": 0
          },
          {
            "x": 0,
            "y": 1000
          },
          {
            "x": 1000,
            "y": 1000
          },
          {
            "x": 2000,
            "y": 1000
          },
          {
            "x": 3000,
            "y": 1000
          },
          {
            "x": 4000,
            "y": 1000
          },
          {
            "x": 5000,
            "y": 1000
          },
          {
            "x": 6000,
            "y": 1000
          },
          {
            "x": 7000,
            "y": 1000
          },
          {
            "x": 8000,
            "y": 1000
          },
          {
            "x": 9000,
            "y": 1000
          },
          {
            "x": 10000,
            "y": 1000
          },
          {
            "x": 11000,
            "y": 1000
          },
          {
            "x": 12000,
            "y": 1000
          },
          {
            "x": 13000,
            "y": 1000
          },
          {
            "x": 14000,
            "y": 1000
          },
          {
            "x": 15000,
            "y": 1000
          },
          {
            "x": 16000,
            "y": 1000
          },
          {
            "x": 17000,
            "y": 1000
          },
          {
            "x": 0,
            "y": 2000
          },
          {
            "x": 1000,
            "y": 2000
          },
          {
            "x": 2000,
            "y": 2000
          },
          {
            "x": 3000,
            "y": 2000
          },
          {
            "x": 4000,
            "y": 2000
          },
          {
            "x": 5000,
            "y": 2000
          },
          {
            "x": 6000,
            "y": 2000
          },
          {
            "x": 7000,
            "y": 2000
          },
          {
            "x": 8000,
            "y": 2000
          },
          {
            "x": 9000,
            "y": 2000
          },
          {
            "x": 10000,
            "y": 2000
          },
          {
            "x": 11000,
            "y": 2000
          },
          {
            "x": 12000,
            "y": 2000
          },
          {
            "x": 13000,
            "y": 2000
          },
          {
            "x": 14000,
            "y": 2000
          },
          {
            "x": 15000,
            "y": 2000
          },
          {
            "x": 16000,
            "y": 2000
          },
          {
            "x": 17000,
            "y": 2000
          },
          {
            "x": 0,
            "y": 3000
          },
          {
            "x": 1000,
            "y": 3000
          },
          {
            "x": 2000,
            "y": 3000
          },
          {
            "x": 3000,
            "y": 3000
          },
          {
            "x": 4000,
            "y": 3000
          },
          {
            "x": 5000,
            "y": 3000
          },
          {
            "x": 6000,
            "y": 3000
          },
          {
            "x": 7000,
            "y": 3000
          },
          {
            "x": 8000,
            "y": 3000
          },
          {
            "x": 9000,
            "y": 3000
          },
          {
            "x": 10000,
            "y": 3000
          },
          {
            "x": 11000,
            "y": 3000
          },
          {
            "x": 12000,
            "y": 3000
          },
          {
            "x": 13000,
            "y": 3000
          },
          {
            "x": 14000,
            "y": 3000
          },
          {
            "x": 15000,
            "y": 3000
          },
          {
            "x": 16000,
            "y": 3000
          },
          {
            "x": 17000,
            "y": 3000
          },
          {
            "x": 0,
            "y": 4000
          },
          {
            "x": 1000,
            "y": 4000
          },
          {
            "x": 2000,
            "y": 4000
          },
          {
            "x": 3000,
            "y": 4000
          },
          {
            "x": 4000,
            "y": 4000
          },
          {
            "x": 5000,
            "y": 4000
          },
          {
            "x": 6000,
            "y": 4000
          },
          {
            "x": 7000,
            "y": 4000
          },
          {
            "x": 8000,
            "y": 4000
          },
          {
            "x": 9000,
            "y": 4000
          },
          {
            "x": 10000,
            "y": 4000
          },
          {
            "x": 11000,
            "y": 4000
          },
          {
            "x": 12000,
            "y": 4000
          },
          {
            "x": 13000,
            "y": 4000
          },
          {
            "x": 14000,
            "y": 4000
          },
          {
            "x": 15000,
            "y": 4000
          },
          {
            "x": 16000,
            "y": 4000
          },
          {
            "x": 17000,
            "y": 4000
          },
          {
            "x": 0,
            "y": 5000
          },
          {
            "x": 1000,
            "y": 5000
          },
          {
            "x": 2000,
            "y": 5000
          },
          {
            "x": 3000,
            "y": 5000
          },
          {
            "x": 4000,
            "y": 5000
          },
          {
            "x": 5000,
            "y": 5000
          },
          {
            "x": 6000,
            "y": 5000
          },
          {
            "x": 7000,
            "y": 5000
          },
          {
            "x": 8000,
            "y": 5000
          },
          {
            "x": 9000,
            "y": 5000
          },
          {
            "x": 10000,
            "y": 5000
          },
          {
            "x": 11000,
            "y": 5000
          },
          {
            "x": 12000,
            "y": 5000
          },
          {
            "x": 13000,
            "y": 5000
          },
          {
            "x": 14000,
            "y": 5000
          },
          {
            "x": 15000,
            "y": 5000
          },
          {
            "x": 16000,
            "y": 5000
          },
          {
            "x": 17000,
            "y": 5000
          },
          {
            "x": 0,
            "y": 6000
          },
          {
            "x": 1000,
            "y": 6000
          },
          {
            "x": 2000,
            "y": 6000
          },
          {
            "x": 3000,
            "y": 6000
          },
          {
            "x": 4000,
            "y": 6000
          },
          {
            "x": 5000,
            "y": 6000
          },
          {
            "x": 6000,
            "y": 6000
          },
          {
            "x": 7000,
            "y": 6000
          },
          {
            "x": 8000,
            "y": 6000
          },
          {
            "x": 9000,
            "y": 6000
          },
          {
            "x": 10000,
            "y": 6000
          },
          {
            "x": 11000,
            "y": 6000
          },
          {
            "x": 12000,
            "y": 6000
          },
          {
            "x": 13000,
            "y": 6000
          },
          {
            "x": 14000,
            "y": 6000
          },
          {
            "x": 15000,
            "y": 6000
          },
          {
            "x": 16000,
            "y": 6000
          },
          {
            "x": 17000,
            "y": 6000
          },
          {
            "x": 0,
            "y": 7000
          },
          {
            "x": 1000,
            "y": 7000
          },
          {
            "x": 2000,
            "y": 7000
          },
          {
            "x": 3000,
            "y": 7000
          },
          {
            "x": 4000,
            "y": 7000
          },
          {
            "x": 5000,
            "y": 7000
          },
          {
            "x": 6000,
            "y": 7000
          },
          {
            "x": 7000,
            "y": 7000
          },
          {
            "x": 8000,
            "y": 7000
          },
          {
            "x": 9000,
            "y": 7000
          },
          {
            "x": 10000,
            "y": 7000
          },
          {
            "x": 11000,
            "y": 7000
          },
          {
            "x": 12000,
            "y": 7000
          },
          {
            "x": 13000,
            "y": 7000
          },
          {
            "x": 14000,
            "y": 7000
          },
          {
            "x": 15000,
            "y": 7000
          },
          {
            "x": 16000,
            "y": 7000
          },
          {
            "x": 17000,
            "y": 7000
          },
          {
            "x": 0,
            "y": 8000
          },
          {
            "x": 1000,
            "y": 8000
          },
          {
            "x": 2000,
            "y": 8000
          },
          {
            "x": 3000,
            "y": 8000
          },
          {
            "x": 4000,
            "y": 8000
          },
          {
            "x": 5000,
            "y": 8000
          },
          {
            "x": 6000,
            "y": 8000
          },
          {
            "x": 7000,
            "y": 8000
          },
          {
            "x": 8000,
            "y": 8000
          },
          {
            "x": 9000,
            "y": 8000
          },
          {
            "x": 10000,
            "y": 8000
          },
          {
            "x": 11000,
            "y": 8000
          },
          {
            "x": 12000,
            "y": 8000
          },
          {
            "x": 13000,
            "y": 8000
          },
          {
            "x": 14000,
            "y": 8000
          },
          {
            "x": 15000,
            "y": 8000
          },
          {
            "x": 16000,
            "y": 8000
          },
          {
            "x": 17000,
            "y": 8000
          },
          {
            "x": 0,
            "y": 9000
          },
          {
            "x": 1000,
            "y": 9000
          },
          {
            "x": 2000,
            "y": 9000
          },
          {
            "x": 3000,
            "y": 9000
          },
          {
            "x": 4000,
            "y": 9000
          },
          {
            "x": 5000,
            "y": 9000
          },
          {
            "x": 6000,
            "y": 9000
          },
          {
            "x": 7000,
            "y": 9000
          },
          {
            "x": 8000,
            "y": 9000
          },
          {
            "x": 9000,
            "y": 9000
          },
          {
            "x": 10000,
            "y": 9000
          },
          {
            "x": 11000,
            "y": 9000
          },
          {
            "x": 12000,
            "y": 9000
          },
          {
            "x": 13000,
            "y": 9000
          },
          {
            "x": 14000,
            "y": 9000
          },
          {
            "x": 15000,
            "y": 9000
          },
          {
            "x": 16000,
            "y": 9000
          },
          {
            "x": 17000,
            "y": 9000
          }
        ]
      },
      {
        "id": 4,
        "cells": [
          {
            "x": 0,
            "y": 0
          },
          {
            "x": 1000,
            "y": 0
          },
          {
            "x": 2000,
            "y": 0
          },
          {
            "x": 3000,
            "y": 0
          },
          {
            "x": 4000,
            "y": 0
          },
          {
            "x": 5000,
            "y": 0
          },
          {
            "x": 6000,
            "y": 0
          },
          {
            "x": 7000,
            "y": 0
          },
          {
            "x": 8000,
            "y": 0
          },
          {
            "x": 9000,
            "y": 0
          },
          {
            "x": 10000,
            "y": 0
          },
          {
            "x": 11000,
            "y": 0
          },
          {
            "x": 12000,
            "y": 0
          },
          {
            "x": 13000,
            "y": 0
          },
          {
            "x": 14000,
            "y": 0
          },
          {
            "x": 15000,
            "y": 0
          },
          {
            "x": 16000,
            "y": 0
          },
          {
            "x": 17000,
            "y": 0
          },
          {
            "x": 18000,
            "y": 0
          },
          {
            "x": 19000,
            "y": 0
          },
          {
            "x": 20000,
            "y": 0
          },
          {
            "x": 21000,
            "y": 0
          },
          {
            "x": 22000,
            "y": 0
          },
          {
            "x": 23000,
            "y": 0
          },
          {
            "x": 0,
            "y": 1000
          },
          {
            "x": 1000,
            "y": 1000
          },
          {
            "x": 2000,
            "y": 1000
          },
          {
            "x": 3000,
            "y": 1000
          },
          {
            "x": 4000,
            "y": 1000
          },
          {
            "x": 5000,
            "y": 1000
          },
          {
            "x": 6000,
            "y": 1000
          },
          {
            "x": 7000,
            "y": 1000
          },
          {
            "x": 8000,
            "y": 1000
          },
          {
            "x": 9000,
            "y": 1000
          },
          {
            "x": 10000,
            "y": 1000
          },
          {
            "x": 11000,
            "y": 1000
          },
          {
            "x": 12000,
            "y": 1000
          },
          {
            "x": 13000,
            "y": 1000
          },
          {
            "x": 14000,
            "y": 1000
          },
          {
            "x": 15000,
            "y": 1000
          },
          {
            "x": 16000,
            "y": 1000
          },
          {
            "x": 17000,
            "y": 1000
          },
          {
            "x": 18000,
            "y": 1000
          },
          {
            "x": 19000,
            "y": 1000
          },
          {
            "x": 20000,
            "y": 1000
          },
          {
            "x": 21000,
            "y": 1000
          },
          {
            "x": 22000,
            "y": 1000
          },
          {
            "x": 23000,
            "y": 1000
          },
          {
            "x": 0,
            "y": 2000
          },
          {
            "x": 1000,
            "y": 2000
          },
          {
            "x": 2000,
            "y": 2000
          },
          {
            "x": 3000,
            "y": 2000
          },
          {
            "x": 4000,
            "y": 2000
          },
          {
            "x": 5000,
            "y": 2000
          },
          {
            "x": 6000,
            "y": 2000
          },
          {
            "x": 7000,
            "y": 2000
          },
          {
            "x": 8000,
            "y": 2000
          },
          {
            "x": 9000,
            "y": 2000
          },
          {
            "x": 10000,
            "y": 2000
          },
          {
            "x": 11000,
            "y": 2000
          },
          {
            "x": 12000,
            "y": 2000
          },
          {
            "x": 13000,
            "y": 2000
          },
          {
            "x": 14000,
            "y": 2000
          },
          {
            "x": 15000,
            "y": 2000
          },
          {
            "x": 16000,
            "y": 2000
          },
          {
            "x": 17000,
            "y": 2000
          },
          {
            "x": 18000,
            "y": 2000
          },
          {
            "x": 19000,
            "y": 2000
          },
          {
            "x": 20000,
            "y": 2000
          },
          {
            "x": 21000,
            "y": 2000
          },
          {
            "x": 22000,
            "y": 2000
          },
          {
            "x": 23000,
            "y": 2000
          },
          {
            "x": 0,
            "y": 3000
          },
          {
            "x": 1000,
            "y": 3000
          },
          {
            "x": 2000,
            "y": 3000
          },
          {
            "x": 3000,
            "y": 3000
          },
          {
            "x": 4000,
            "y": 3000
          },
          {
            "x": 5000,
            "y": 3000
          },
          {
            "x": 6000,
            "y": 3000
          },
          {
            "x": 7000,
            "y": 3000
          },
          {
            "x": 8000,
            "y": 3000
          },
          {
            "x": 9000,
            "y": 3000
          },
          {
            "x": 10000,
            "y": 3000
          },
          {
            "x": 11000,
            "y": 3000
          },
          {
            "x": 12000,
            "y": 3000
          },
          {
            "x": 13000,
            "y": 3000
          },
          {
            "x": 14000,
            "y": 3000
          },
          {
            "x": 15000,
            "y": 3000
          },
          {
            "x": 16000,
            "y": 3000
          },
          {
            "x": 17000,
            "y": 3000
          },
          {
            "x": 18000,
            "y": 3000
          },
          {
            "x": 19000,
            "y": 3000
          },
          {
            "x": 20000,
            "y": 3000
          },
          {
            "x": 21000,
            "y": 3000
          },
          {
            "x": 22000,
            "y": 3000
          },
          {
            "x": 23000,
            "y": 3000
          },
          {
            "x": 0,
            "y": 4000
          },
          {
            "x": 1000,
            "y": 4000
          },
          {
            "x": 2000,
            "y": 4000
          },
          {
            "x": 3000,
            "y": 4000
          },
          {
            "x": 4000,
            "y": 4000
          },
          {
            "x": 5000,
            "y": 4000
          },
          {
            "x": 6000,
            "y": 4000
          },
          {
            "x": 7000,
            "y": 4000
          },
          {
            "x": 8000,
            "y": 4000
          },
          {
            "x": 9000,
            "y": 4000
          },
          {
            "x": 10000,
            "y": 4000
          },
          {
            "x": 11000,
            "y": 4000
          },
          {
            "x": 12000,
            "y": 4000
          },
          {
            "x": 13000,
            "y": 4000
          },
          {
            "x": 14000,
            "y": 4000
          },
          {
            "x": 15000,
            "y": 4000
          },
          {
            "x": 16000,
            "y": 4000
          },
          {
            "x": 17000,
            "y": 4000
          },
          {
            "x": 18000,
            "y": 4000
          },
          {
            "x": 19000,
            "y": 4000
          },
          {
            "x": 20000,
            "y": 4000
          },
          {
            "x": 21000,
            "y": 4000
          },
          {
            "x": 22000,
            "y": 4000
          },
          {
            "x": 23000,
            "y": 4000
          },
          {
            "x": 0,
            "y": 5000
          },
          {
            "x": 1000,
            "y": 5000
          },
          {
            "x": 2000,
            "y": 5000
          },
          {
            "x": 3000,
            "y": 5000
          },
          {
            "x": 4000,
            "y": 5000
          },
          {
            "x": 5000,
            "y": 5000
          },
          {
            "x": 6000,
            "y": 5000
          },
          {
            "x": 7000,
            "y": 5000
          },
          {
            "x": 8000,
            "y": 5000
          },
          {
            "x": 9000,
            "y": 5000
          },
          {
            "x": 10000,
            "y": 5000
          },
          {
            "x": 11000,
            "y": 5000
          },
          {
            "x": 12000,
            "y": 5000
          },
          {
            "x": 13000,
            "y": 5000
          },
          {
            "x": 14000,
            "y": 5000
          },
          {
            "x": 15000,
            "y": 5000
          },
          {
            "x": 16000,
            "y": 5000
          },
          {
            "x": 17000,
            "y": 5000
          },
          {
            "x": 18000,
            "y": 5000
          },
          {
            "x": 19000,
            "y": 5000
          },
          {
            "x": 20000,
            "y": 5000
          },
          {
            "x": 21000,
            "y": 5000
          },
          {
            "x": 22000,
            "y": 5000
          },
          {
            "x": 23000,
            "y": 5000
          },
          {
            "x": 0,
            "y": 6000
          },
          {
            "x": 1000,
            "y": 6000
          },
          {
            "x": 2000,
            "y": 6000
          },
          {
            "x": 3000,
            "y": 6000
          },
          {
            "x": 4000,
            "y": 6000
          },
          {
            "x": 5000,
            "y": 6000
          },
          {
            "x": 6000,
            "y": 6000
          },
          {
            "x": 7000,
            "y": 6000
          },
          {
            "x": 8000,
            "y": 6000
          },
          {
            "x": 9000,
            "y": 6000
          },
          {
            "x": 10000,
            "y": 6000
          },
          {
            "x": 11000,
            "y": 6000
          },
          {
            "x": 12000,
            "y": 6000
          },
          {
            "x": 13000,
            "y": 6000
          },
          {
            "x": 14000,
            "y": 6000
          },
          {
            "x": 15000,
            "y": 6000
          },
          {
            "x": 16000,
            "y": 6000
          },
          {
            "x": 17000,
            "y": 6000
          },
          {
            "x": 18000,
            "y": 6000
          },
          {
            "x": 19000,
            "y": 6000
          },
          {
            "x": 20000,
            "y": 6000
          },
          {
            "x": 21000,
            "y": 6000
          },
          {
            "x": 22000,
            "y": 6000
          },
          {
            "x": 23000,
            "y": 6000
          },
          {
            "x": 0,
            "y": 7000
          },
          {
            "x": 1000,
            "y": 7000
          },
          {
            "x": 2000,
            "y": 7000
          },
          {
            "x": 3000,
            "y": 7000
          },
          {
            "x": 4000,
            "y": 7000
          },
          {
            "x": 5000,
            "y": 7000
          },
          {
            "x": 6000,
            "y": 7000
          },
          {
            "x": 7000,
            "y": 7000
          },
          {
            "x": 8000,
            "y": 7000
          },
          {
            "x": 9000,
            "y": 7000
          },
          {
            "x": 10000,
            "y": 7000
          },
          {
            "x": 11000,
            "y": 7000
          },
          {
            "x": 12000,
            "y": 7000
          },
          {
            "x": 13000,
            "y": 7000
          },
          {
            "x": 14000,
            "y": 7000
          },
          {
            "x": 15000,
            "y": 7000
          },
          {
            "x": 16000,
            "y": 7000
          },
          {
            "x": 17000,
            "y": 7000
          },
          {
            "x": 18000,
            "y": 7000
          },
          {
            "x": 19000,
            "y": 7000
          },
          {
            "x": 20000,
            "y": 7000
          },
          {
            "x": 21000,
            "y": 7000
          },
          {
            "x": 22000,
            "y": 7000
          },
          {
            "x": 23000,
            "y": 7000
          },
          {
            "x": 0,
            "y": 8000
          },
          {
            "x": 1000,
            "y": 8000
          },
          {
            "x": 2000,
            "y": 8000
          },
          {
            "x": 3000,
            "y": 8000
          },
          {
            "x": 4000,
            "y": 8000
          },
          {
            "x": 5000,
            "y": 8000
          },
          {
            "x": 6000,
            "y": 8000
          },
          {
            "x": 7000,
            "y": 8000
          },
          {
            "x": 8000,
            "y": 8000
          },
          {
            "x": 9000,
            "y": 8000
          },
          {
            "x": 10000,
            "y": 8000
          },
          {
            "x": 11000,
            "y": 8000
          },
          {
            "x": 12000,
            "y": 8000
          },
          {
            "x": 13000,
            "y": 8000
          },
          {
            "x": 14000,
            "y": 8000
          },
          {
            "x": 15000,
            "y": 8000
          },
          {
            "x": 16000,
            "y": 8000
          },
          {
            "x": 17000,
            "y": 8000
          },
          {
            "x": 18000,
            "y": 8000
          },
          {
            "x": 19000,
            "y": 8000
          },
          {
            "x": 20000,
            "y": 8000
          },
          {
            "x": 21000,
            "y": 8000
          },
          {
            "x": 22000,
            "y": 8000
          },
          {
            "x": 23000,
            "y": 8000
          },
          {
            "x": 0,
            "y": 9000
          },
          {
            "x": 1000,
            "y": 9000
          },
          {
            "x": 2000,
            "y": 9000
          },
          {
            "x": 3000,
            "y": 9000
          },
          {
            "x": 4000,
            "y": 9000
          },
          {
            "x": 5000,
            "y": 9000
          },
          {
            "x": 6000,
            "y": 9000
          },
          {
            "x": 7000,
            "y": 9000
          },
          {
            "x": 8000,
            "y": 9000
          },
          {
            "x": 9000,
            "y": 9000
          },
          {
            "x": 10000,
            "y": 9000
          },
          {
            "x": 11000,
            "y": 9000
          },
          {
            "x": 12000,
            "y": 9000
          },
          {
            "x": 13000,
            "y": 9000
          },
          {
            "x": 14000,
            "y": 9000
          },
          {
            "x": 15000,
            "y": 9000
          },
          {
            "x": 16000,
            "y": 9000
          },
          {
            "x": 17000,
            "y": 9000
          },
          {
            "x": 18000,
            "y": 9000
          },
          {
            "x": 19000,
            "y": 9000
          },
          {
            "x": 20000,
            "y": 9000
          },
          {
            "x": 21000,
            "y": 9000
          },
          {
            "x": 22000,
            "y": 9000
          },
          {
            "x": 23000,
            "y": 9000
          },
          {
            "x": 0,
            "y": 10000
          },
          {
            "x": 1000,
            "y": 10000
          },
          {
            "x": 2000,
            "y": 10000
          },
          {
            "x": 3000,
            "y": 10000
          },
          {
            "x": 4000,
            "y": 10000
          },
          {
            "x": 5000,
            "y": 10000
          },
          {
            "x": 6000,
            "y": 10000
          },
          {
            "x": 7000,
            "y": 10000
          },
          {
            "x": 8000,
            "y": 10000
          },
          {
            "x": 9000,
            "y": 10000
          },
          {
            "x": 10000,
            "y": 10000
          },
          {
            "x": 11000,
            "y": 10000
          },
          {
            "x": 12000,
            "y": 10000
          },
          {
            "x": 13000,
            "y": 10000
          },
          {
            "x": 14000,
            "y": 10000
          },
          {
            "x": 15000,
            "y": 10000
          },
          {
            "x": 16000,
            "y": 10000
          },
          {
            "x": 17000,
            "y": 10000
          },
          {
            "x": 18000,
            "y": 10000
          },
          {
            "x": 19000,
            "y": 10000
          },
          {
            "x": 20000,
            "y": 10000
          },
          {
            "x": 21000,
            "y": 10000
          },
          {
            "x": 22000,
            "y": 10000
          },
          {
            "x": 23000,
            "y": 10000
          },
          {
            "x": 0,
            "y": 11000
          },
          {
            "x": 1000,
            "y": 11000
          },
          {
            "x": 2000,
            "y": 11000
          },
          {
            "x": 3000,
            "y": 11000
          },
          {
            "x": 4000,
            "y": 11000
          },
          {
            "x": 5000,
            "y": 11000
          },
          {
            "x": 6000,
            "y": 11000
          },
          {
            "x": 7000,
            "y": 11000
          },
          {
            "x": 8000,
            "y": 11000
          },
          {
            "x": 9000,
            "y": 11000
          },
          {
            "x": 10000,
            "y": 11000
          },
          {
            "x": 11000,
            "y": 11000
          },
          {
            "x": 12000,
            "y": 11000
          },
          {
            "x": 13000,
            "y": 11000
          },
          {
            "x": 14000,
            "y": 11000
          },
          {
            "x": 15000,
            "y": 11000
          },
          {
            "x": 16000,
            "y": 11000
          },
          {
            "x": 17000,
            "y": 11000
          },
          {
            "x": 18000,
            "y": 11000
          },
          {
            "x": 19000,
            "y": 11000
          },
          {
            "x": 20000,
            "y": 11000
          },
          {
            "x": 21000,
            "y": 11000
          },
          {
            "x": 22000,
            "y": 11000
          },
          {
            "x": 23000,
            "y": 11000
          }
        ]
      },
      {
        "id": 5,
        "cells": [
          {
            "x": 0,
            "y": 0
          },
          {
            "x": 1000,
            "y": 0
          },
          {
            "x": 2000,
            "y": 0
          },
          {
            "x": 3000,
            "y": 0
          },
          {
            "x": 4000,
            "y": 0
          },
          {
            "x": 5000,
            "y": 0
          },
          {
            "x": 6000,
            "y": 0
          },
          {
            "x": 7000,
            "y": 0
          },
          {
            "x": 8000,
            "y": 0
          },
          {
            "x": 9000,
            "y": 0
          },
          {
            "x": 10000,
            "y": 0
          },
          {
            "x": 11000,
            "y": 0
          },
          {
            "x": 12000,
            "y": 0
          },
          {
            "x": 13000,
            "y": 0
          },
          {
            "x": 14000,
            "y": 0
          },
          {
            "x": 15000,
            "y": 0
          },
          {
            "x": 0,
            "y": 1000
          },
          {
            "x": 1000,
            "y": 1000
          },
          {
            "x": 2000,
            "y": 1000
          },
          {
            "x": 3000,
            "y": 1000
          },
          {
            "x": 4000,
            "y": 1000
          },
          {
            "x": 5000,
            "y": 1000
          },
          {
            "x": 6000,
            "y": 1000
          },
          {
            "x": 7000,
            "y": 1000
          },
          {
            "x": 8000,
            "y": 1000
          },
          {
            "x": 9000,
            "y": 1000
          },
          {
            "x": 10000,
            "y": 1000
          },
          {
            "x": 11000,
            "y": 1000
          },
          {
            "x": 12000,
            "y": 1000
          },
          {
            "x": 13000,
            "y": 1000
          },
          {
            "x": 14000,
            "y": 1000
          },
          {
            "x": 15000,
            "y": 1000
          },
          {
            "x": 0,
            "y": 2000
          },
          {
            "x": 1000,
            "y": 2000
          },
          {
            "x": 2000,
            "y": 2000
          },
          {
            "x": 3000,
            "y": 2000
          },
          {
            "x": 4000,
            "y": 2000
          },
          {
            "x": 5000,
            "y": 2000
          },
          {
            "x": 6000,
            "y": 2000
          },
          {
            "x": 7000,
            "y": 2000
          },
          {
            "x": 8000,
            "y": 2000
          },
          {
            "x": 9000,
            "y": 2000
          },
          {
            "x": 10000,
            "y": 2000
          },
          {
            "x": 11000,
            "y": 2000
          },
          {
            "x": 12000,
            "y": 2000
          },
          {
            "x": 13000,
            "y": 2000
          },
          {
            "x": 14000,
            "y": 2000
          },
          {
            "x": 15000,
            "y": 2000
          },
          {
            "x": 0,
            "y": 3000
          },
          {
            "x": 1000,
            "y": 3000
          },
          {
            "x": 2000,
            "y": 3000
          },
          {
            "x": 3000,
            "y": 3000
          },
          {
            "x": 4000,
            "y": 3000
          },
          {
            "x": 5000,
            "y": 3000
          },
          {
            "x": 6000,
            "y": 3000
          },
          {
            "x": 7000,
            "y": 3000
          },
          {
            "x": 8000,
            "y": 3000
          },
          {
            "x": 9000,
            "y": 3000
          },
          {
            "x": 10000,
            "y": 3000
          },
          {
            "x": 11000,
            "y": 3000
          },
          {
            "x": 12000,
            "y": 3000
          },
          {
            "x": 13000,
            "y": 3000
          },
          {
            "x": 14000,
            "y": 3000
          },
          {
            "x": 15000,
            "y": 3000
          },
          {
            "x": 0,
            "y": 4000
          },
          {
            "x": 1000,
            "y": 4000
          },
          {
            "x": 2000,
            "y": 4000
          },
          {
            "x": 3000,
            "y": 4000
          },
          {
            "x": 4000,
            "y": 4000
          },
          {
            "x": 5000,
            "y": 4000
          },
          {
            "x": 6000,
            "y": 4000
          },
          {
            "x": 7000,
            "y": 4000
          },
          {
            "x": 8000,
            "y": 4000
          },
          {
            "x": 9000,
            "y": 4000
          },
          {
            "x": 10000,
            "y": 4000
          },
          {
            "x": 11000,
            "y": 4000
          },
          {
            "x": 12000,
            "y": 4000
          },
          {
            "x": 13000,
            "y": 4000
          },
          {
            "x": 14000,
            "y": 4000
          },
          {
            "x": 15000,
            "y": 4000
          },
          {
            "x": 0,
            "y": 5000
          },
          {
            "x": 1000,
            "y": 5000
          },
          {
            "x": 2000,
            "y": 5000
          },
          {
            "x": 3000,
            "y": 5000
          },
          {
            "x": 4000,
            "y": 5000
          },
          {
            "x": 5000,
            "y": 5000
          },
          {
            "x": 6000,
            "y": 5000
          },
          {
            "x": 7000,
            "y": 5000
          },
          {
            "x": 8000,
            "y": 5000
          },
          {
            "x": 9000,
            "y": 5000
          },
          {
            "x": 10000,
            "y": 5000
          },
          {
            "x": 11000,
            "y": 5000
          },
          {
            "x": 12000,
            "y": 5000
          },
          {
            "x": 13000,
            "y": 5000
          },
          {
            "x": 14000,
            "y": 5000
          },
          {
            "x": 15000,
            "y": 5000
          },
          {
            "x": 0,
            "y": 6000
          },
          {
            "x": 1000,
            "y": 6000
          },
          {
            "x": 2000,
            "y": 6000
          },
          {
            "x": 3000,
            "y": 6000
          },
          {
            "x": 4000,
            "y": 6000
          },
          {
            "x": 5000,
            "y": 6000
          },
          {
            "x": 6000,
            "y": 6000
          },
          {
            "x": 7000,
            "y": 6000
          },
          {
            "x": 8000,
            "y": 6000
          },
          {
            "x": 9000,
            "y": 6000
          },
          {
            "x": 10000,
            "y": 6000
          },
          {
            "x": 11000,
            "y": 6000
          },
          {
            "x": 12000,
            "y": 6000
          },
          {
            "x": 13000,
            "y": 6000
          },
          {
            "x": 14000,
            "y": 6000
          },
          {
            "x": 15000,
            "y": 6000
          },
          {
            "x": 0,
            "y": 7000
          },
          {
            "x": 1000,
            "y": 7000
          },
          {
            "x": 2000,
            "y": 7000
          },
          {
            "x": 3000,
            "y": 7000
          },
          {
            "x": 4000,
            "y": 7000
          },
          {
            "x": 5000,
            "y": 7000
          },
          {
            "x": 6000,
            "y": 7000
          },
          {
            "x": 7000,
            "y": 7000
          },
          {
            "x": 8000,
            "y": 7000
          },
          {
            "x": 9000,
            "y": 7000
          },
          {
            "x": 10000,
            "y": 7000
          },
          {
            "x": 11000,
            "y": 7000
          },
          {
            "x": 12000,
            "y": 7000
          },
          {
            "x": 13000,
            "y": 7000
          },
          {
            "x": 14000,
            "y": 7000
          },
          {
            "x": 15000,
            "y": 7000
          }
        ]
      }
    ],
    "links": [
      {
        "from": {
          "x": 10000,
          "y": 6000,
          "layer": 0
        },
        "to": {
          "x": 10000,
          "y": 9000,
          "layer": 1
        },
        "cost": 4000,
        "bidirectional": true
      },
      {
        "from": {
          "x": 2000,
          "y": 2000,
          "layer": 1
        },
        "to": {
          "x": 15000,
          "y": 7000,
          "layer": 2
        },
        "cost": 5000,
        "bidirectional": true
      },
      {
        "from": {
          "x": 24000,
          "y": 2000,
          "layer": 2
        },
        "to": {
          "x": 9000,
          "y": 0,
          "layer": 3
        },
        "cost": 3000,
        "bidirectional": true
      },
      {
        "from": {
          "x": 20000,
          "y": 1000,
          "layer": 2
        },
        "to": {
          "x": 22000,
          "y": 1000,
          "layer": 4
        },
        "cost": 6000,
        "bidirectional": true
      },
      {
        "from": {
          "x": 0,
          "y": 1000,
          "layer": 4
        },
        "to": {
          "x": 12000,
          "y": 2000,
          "layer": 0
        },
        "cost": 6000,
        "bidirectional": true
      },
      {
        "from": {
          "x": 2000,
          "y": 2000,
          "layer": 2
        },
        "to": {
          "x": 2000,
          "y": 2000,
          "layer": 5
        },
        "cost": 8000,
        "bidirectional": true
      },
      {
        "from": {
          "x": 1000,
          "y": 8000,
          "layer": 3
        },
        "to": {
          "x": 2000,
          "y": 6000,
          "layer": 5
        },
        "cost": 7000,
        "bidirectional": true
      }
    ]
  },
  "patterns": [
    {
      "id": "tally-sort",
      "label": "A porter's tally movement over the sorting floor",
      "steps": [
        {
          "x": 13000,
          "y": 3000,
          "layer": 2
        },
        {
          "x": 14000,
          "y": 3000,
          "layer": 2
        },
        {
          "x": 15000,
          "y": 3000,
          "layer": 2
        }
      ]
    },
    {
      "id": "sift-ash",
      "label": "Sifting ash behind the gallery screen",
      "steps": [
        {
          "x": 23000,
          "y": 2000,
          "layer": 2
        },
        {
          "x": 24000,
          "y": 2000,
          "layer": 2
        },
        {
          "x": 25000,
          "y": 2000,
          "layer": 2
        }
      ]
    },
    {
      "id": "vault-sort",
      "label": "Sorting salvage in the columbarium vault annex",
      "steps": [
        {
          "x": 16000,
          "y": 7000,
          "layer": 1
        },
        {
          "x": 17000,
          "y": 7000,
          "layer": 1
        },
        {
          "x": 18000,
          "y": 7000,
          "layer": 1
        }
      ]
    },
    {
      "id": "urn-stack",
      "label": "Stacking urn crates in the vault annex",
      "steps": [
        {
          "x": 16000,
          "y": 8000,
          "layer": 1
        },
        {
          "x": 17000,
          "y": 8000,
          "layer": 1
        }
      ]
    },
    {
      "id": "lime-haul",
      "label": "Hauling the lime barrow along the switchback",
      "steps": [
        {
          "x": 13000,
          "y": 9000,
          "layer": 4
        },
        {
          "x": 14000,
          "y": 9000,
          "layer": 4
        },
        {
          "x": 15000,
          "y": 9000,
          "layer": 4
        }
      ]
    },
    {
      "id": "kiln-stoke",
      "label": "Stoking the firing tunnel mouth",
      "steps": [
        {
          "x": 19000,
          "y": 9000,
          "layer": 4
        },
        {
          "x": 20000,
          "y": 9000,
          "layer": 4
        },
        {
          "x": 19000,
          "y": 10000,
          "layer": 4
        }
      ]
    },
    {
      "id": "sack-lift",
      "label": "Lifting lime sacks at the cart stand",
      "steps": [
        {
          "x": 17000,
          "y": 10000,
          "layer": 4
        },
        {
          "x": 18000,
          "y": 10000,
          "layer": 4
        }
      ]
    }
  ],
  "origins": {
    "disgraced-legionary": {
      "version": 1,
      "id": "origin-recipe:disgraced-legionary",
      "originId": "disgraced-legionary",
      "family": "martial",
      "providerId": "authored-origin-recipe",
      "providerVersion": "1",
      "seed": "origin-disgraced-legionary-v1",
      "license": "Project-authored deterministic origin content recipe",
      "recipeOrigin": "Agent-executed D02.4 origin writing lane",
      "sources": [
        {
          "document": "VISION.md",
          "section": "Non-negotiables"
        },
        {
          "document": "docs/design.md",
          "section": "Lore accessibility (Waseem, 13 Sep — world bible approved)"
        },
        {
          "document": "docs/world/04-zones.md",
          "section": "Eight starting-background hooks"
        },
        {
          "document": "docs/plan/03-content-plan.md",
          "section": "Origins — exact hooks, bounded continuation"
        },
        {
          "document": "docs/world/09-naming-and-tone.md",
          "section": "People by cultural naming tradition"
        }
      ],
      "capsuleId": "capsule:origin:disgraced-legionary",
      "capsuleKind": "origin",
      "title": "The Ordered Abandonment",
      "bibleHook": {
        "openingGoal": "Recover a muster addendum showing the unit was ordered to abandon its post.",
        "complication": "The addendum is pledged against Noll's repair advance; military knowledge identifies a forged seal.",
        "nonCombatLeverage": "Military knowledge and document literacy identify a forged quartermaster seal on the debt pledge.",
        "guardrail": "Show who benefits from its publication and whether the debt against it remains. Military literacy is leverage, not automatic faction loyalty."
      },
      "sourceBoundRelative": {
        "roleId": "role:disgraced-legionary:squad-comrade",
        "relationKind": "squad-comrade",
        "preferredPersonId": "person:kaeso-dareth",
        "preferredName": "Kaeso Dareth",
        "culture": "Orsene",
        "identifyingHistory": "Former Fourth Cohort scout who carried the withdrawal order from the border watch.",
        "deadAlternativeKind": "revised-goal",
        "deadAlternativeSummary": "Recover the post archive roll directly from the quartermaster's impounded chest and deposit the sealed order into the Reeve's public registry to clear the fallen unit's roll posthumously."
      },
      "sourceBoundItems": [
        {
          "id": "item:muster-addendum-roll",
          "name": "Muster addendum for the Fourth Cohort",
          "kind": "quest-right",
          "provenanceKey": "fourth-cohort:abandonment-addendum",
          "description": "A wax-sealed military roll ordering the unit to yield the river redoubt, bearing an irregular quartermaster mark."
        },
        {
          "id": "item:forged-quartermaster-seal",
          "name": "Forged quartermaster wax impression",
          "kind": "tool",
          "provenanceKey": "noll:forged-advance-seal",
          "description": "A cracked wax impression showing where a private merchant signet was used in place of the legionary bronze stamp."
        }
      ],
      "personalGoal": {
        "id": "goal:disgraced-legionary-muster",
        "personId": "person:pc",
        "description": "Recover the muster addendum proving the Fourth Cohort was officially ordered to withdraw from the river redoubt.",
        "prerequisites": {
          "all": [
            "arrived:silt-stair"
          ],
          "any": [],
          "none": []
        }
      },
      "outcomes": [
        {
          "goalId": "goal:disgraced-legionary-muster",
          "status": "achieved",
          "summary": "The authentic muster addendum is recovered with the withdrawal command verified, clearing surviving veterans of desertion.",
          "effects": {
            "add": [
              "muster-addendum:cleared",
              "veterans:honour-restored"
            ],
            "remove": [
              "cohort:branded-deserters"
            ]
          }
        },
        {
          "goalId": "goal:disgraced-legionary-muster",
          "status": "compromised",
          "summary": "You secure the addendum by paying off Noll's repair lien, clearing the company's name while leaving the surviving veterans penniless.",
          "effects": {
            "add": [
              "muster-addendum:redeemed-by-debt",
              "veterans:cleared-but-destitute"
            ],
            "remove": [
              "cohort:branded-deserters"
            ]
          }
        },
        {
          "goalId": "goal:disgraced-legionary-muster",
          "status": "failed",
          "summary": "Concession enforcers destroy the addendum in the kiln furnace to protect the contractor's repair advance.",
          "effects": {
            "add": [
              "muster-addendum:burned",
              "cohort:permanently-disgraced"
            ],
            "remove": []
          }
        },
        {
          "goalId": "goal:disgraced-legionary-muster",
          "status": "abandoned",
          "summary": "You depart the Silt Stair without confronting the toll clerk, leaving the desertion charges unaddressed.",
          "effects": {
            "add": [
              "muster-addendum:abandoned"
            ],
            "remove": []
          }
        }
      ],
      "questRoles": [
        {
          "id": "role:disgraced-legionary:squad-comrade",
          "role": "origin-relative",
          "zone": "Z03",
          "preferredPersonId": "person:kaeso-dareth",
          "alternatives": [
            {
              "kind": "revised-goal",
              "goalId": "goal:disgraced-legionary-posthumous",
              "summary": "Recover the post archive roll directly from the quartermaster's impounded chest and deposit the sealed order into the Reeve's public registry to clear the fallen unit's roll posthumously.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "evidence",
              "evidenceId": "evidence:muster-addendum",
              "prerequisites": {
                "all": [
                  "found:muster-addendum"
                ],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "person",
              "personId": "person:other-veteran",
              "identifyingHistory": "A surviving company quartermaster clerk who witnessed the dispatch.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            }
          ]
        }
      ],
      "questNodes": [
        {
          "id": "node:disgraced-legionary:confront-clerk",
          "label": "Confront the toll clerk regarding the impounded military rolls",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "muster-addendum:located"
            ]
          },
          "effects": {
            "add": [
              "muster-addendum:located"
            ],
            "remove": []
          }
        },
        {
          "id": "node:disgraced-legionary:inspect-chest",
          "label": "Inspect Tavren Noll's pledged dispatch chest",
          "prerequisites": {
            "all": [
              "muster-addendum:located"
            ],
            "any": [
              "clerk:convinced-by-seal",
              "clerk:bribed-or-bypassed"
            ],
            "none": [
              "muster-addendum:secured"
            ]
          },
          "effects": {
            "add": [
              "muster-addendum:secured",
              "found:muster-addendum"
            ],
            "remove": []
          }
        }
      ],
      "dialogueOptions": [
        {
          "id": "opt:disgraced-legionary:ask-chest",
          "intention": {
            "kind": "ask",
            "label": "Ask about the impounded dispatch chest"
          },
          "text": "The Fourth Cohort left a dispatch case with the transit reeve last winter. Where was it inventoried?",
          "disclosure": "essential",
          "firstEncounterSummary": "Locate the military dispatch case held as collateral by Tavren Noll.",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "clerk:asked-about-chest"
            ]
          },
          "effects": {
            "add": [
              "clerk:asked-about-chest",
              "chest:confirmed-with-noll"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:disgraced-legionary:leverage-seal",
          "intention": {
            "kind": "offer",
            "label": "Demonstrate the forged quartermaster seal"
          },
          "text": "Look at the red wax on that receipt. A legionary seal uses bronze intaglio cut in relief. This mark was pressed with a flat signet ring. Your factoring house is holding forged security.",
          "disclosure": "essential",
          "firstEncounterSummary": "Use military document knowledge to prove the collateral seal is fraudulent.",
          "prerequisites": {
            "all": [
              "chest:confirmed-with-noll"
            ],
            "any": [],
            "none": [
              "clerk:convinced-by-seal"
            ]
          },
          "effects": {
            "add": [
              "clerk:convinced-by-seal",
              "leverage:seal-demonstrated"
            ],
            "remove": []
          },
          "requiredIncentives": [
            "knowledge:military-seal-flaw"
          ],
          "requiredProtections": [],
          "socialDifficulty": 2
        },
        {
          "id": "opt:disgraced-legionary:warn-court",
          "intention": {
            "kind": "warn",
            "label": "Warn of Reeve's Court penalties for false custody"
          },
          "text": "If the municipal inspector checks that pledged chest before you record the defect, the concession will claim you certified the forgery yourself.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "leverage:seal-demonstrated"
            ],
            "any": [],
            "none": [
              "clerk:cooperative"
            ]
          },
          "effects": {
            "add": [
              "clerk:cooperative",
              "court-warning:delivered"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": 3
        },
        {
          "id": "opt:disgraced-legionary:deep-abandonment",
          "intention": {
            "kind": "ask",
            "label": "Ask who profited when the border fort was evacuated"
          },
          "text": "Who bought the timber and salt stores after our company marched out? Someone made thirty ves of silver on that empty stockade.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "clerk:cooperative"
            ],
            "any": [],
            "none": [
              "lore:abandonment-profit-known"
            ]
          },
          "effects": {
            "add": [
              "lore:abandonment-profit-known"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:disgraced-legionary:leave-desk",
          "intention": {
            "kind": "leave",
            "label": "Step away from the registry desk"
          },
          "text": "I will return with the company roster before the evening court session.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "effects": {
            "add": [
              "pc:left-registry-desk"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "evidence": [
        {
          "id": "evidence:muster-addendum",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "military-dispatch:fourth-cohort",
          "finding": "The Fourth Cohort was formally ordered to evacuate the border fort to release timber reserves to the canal concession.",
          "verified": true,
          "witnessId": null
        },
        {
          "id": "evidence:noll-pledge-roll",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "noll-advance:pledge-inventory",
          "finding": "Tavren Noll pledged military dispatch property against the lift repair advance using a counterfeit seal.",
          "verified": true,
          "witnessId": null
        }
      ],
      "witnessProtections": [
        {
          "id": "protection:kaeso-dareth",
          "witnessId": "person:kaeso-dareth",
          "kind": "safe-conduct",
          "guarantorId": "institution:reeves-court",
          "commitments": [
            "Issue safe passage past the lift yard guards",
            "Exempt Kaeso from penal labour while the muster hearing proceeds"
          ],
          "secured": true
        }
      ],
      "firstEncounter": {
        "speaker": "Clerk Mereth",
        "location": "Z03 Reeve's Court Lower Registry",
        "context": "You arrive at the Silt Stair seeking the military muster addendum that can clear your former unit of desertion.",
        "initialNpcDialogue": "Every cargo manifest and dispatch chest pledged for the lift repair is recorded in these folios. State your business quickly; Tavren Noll's inspectors arrive at midday.",
        "progressiveDisclosureReview": {
          "immediateObjective": "Inspect the pledged dispatch chest held as collateral by Tavren Noll to recover your cohort's withdrawal order.",
          "nextAction": "Confront Clerk Mereth and point out the forged quartermaster seal on the collateral ledger to gain access.",
          "whoBenefits": "Surviving veterans of the Fourth Cohort whose livelihoods, citizenship, and pensions were stolen.",
          "costOrRisk": "Challenging Tavren Noll's collateral exposes the corruption of his repair advance and risks retaliation from concession guards.",
          "doesDeadPersonReturn": "No. Deceased soldiers stay dead; clearing the muster roll restores honour and pensions to the living and vindicates the fallen."
        }
      },
      "loreAccessibility": {
        "prohibitedJargonChecked": true,
        "intelligentNotGeniusReadingLevel": true,
        "readingLevelNotes": "Focuses immediately on practical needs (military chest, forged wax seal, dock inspection). Avoids imperial constitutional treatise."
      },
      "playerFacingWordCount": 276
    },
    "unpaid-sellsword": {
      "version": 1,
      "id": "origin-recipe:unpaid-sellsword",
      "originId": "unpaid-sellsword",
      "family": "martial",
      "providerId": "authored-origin-recipe",
      "providerVersion": "1",
      "seed": "origin-unpaid-sellsword-v1",
      "license": "Project-authored deterministic origin content recipe",
      "recipeOrigin": "Agent-executed D02.4 origin writing lane",
      "sources": [
        {
          "document": "VISION.md",
          "section": "Non-negotiables"
        },
        {
          "document": "docs/design.md",
          "section": "Lore accessibility (Waseem, 13 Sep — world bible approved)"
        },
        {
          "document": "docs/world/04-zones.md",
          "section": "Eight starting-background hooks"
        },
        {
          "document": "docs/plan/03-content-plan.md",
          "section": "Origins — exact hooks, bounded continuation"
        },
        {
          "document": "docs/world/09-naming-and-tone.md",
          "section": "People by cultural naming tradition"
        }
      ],
      "capsuleId": "capsule:origin:unpaid-sellsword",
      "capsuleKind": "origin",
      "title": "The Dead Factor's Ledger",
      "bibleHook": {
        "openingGoal": "Collect a dead employer's pledged fee before the estate is stripped.",
        "complication": "The fee competes with burial and worker wages; a negotiated division is possible.",
        "nonCombatLeverage": "Commercial contract understanding and payroll reckoning to negotiate a recorded wage division.",
        "guardrail": "Resolve its competition with burial and worker wages; allow a recorded negotiated division rather than a forced 'correct' answer."
      },
      "sourceBoundRelative": {
        "roleId": "role:unpaid-sellsword:estate-factor",
        "relationKind": "estate-factor",
        "preferredPersonId": "person:pelian-dareth",
        "preferredName": "Pelian Dareth",
        "culture": "Orsene",
        "identifyingHistory": "Estate factor overseeing the impounded accounts of the deceased contractor Maro Serrat.",
        "deadAlternativeKind": "revised-goal",
        "deadAlternativeSummary": "Audit the estate dispatch box directly at the cart office and claim the pledged wage share from the primary transshipment ledger."
      },
      "sourceBoundItems": [
        {
          "id": "item:notched-mercenary-tally",
          "name": "Notched guard wage tally",
          "kind": "quest-right",
          "provenanceKey": "maro-serrat:guard-contract-tally",
          "description": "A notched hazelwood tally stick representing 18 ves owed to your mercenary band for three months of convoy defense."
        },
        {
          "id": "item:estate-chits-voucher",
          "name": "Estate escrow voucher",
          "kind": "currency",
          "provenanceKey": "estate:serrat-escrow-chits",
          "description": "A stamped clay chit drawn against Maro Serrat's remaining goods in the lower lock warehouse."
        }
      ],
      "personalGoal": {
        "id": "goal:unpaid-sellsword-fee",
        "personId": "person:pc",
        "description": "Collect the 18 ves, old silver at twelve cuts to the ves, in pledged guard fees from Maro Serrat's estate before burial dues and dock debts consume it.",
        "prerequisites": {
          "all": [
            "arrived:silt-stair"
          ],
          "any": [],
          "none": []
        }
      },
      "outcomes": [
        {
          "goalId": "goal:unpaid-sellsword-fee",
          "status": "achieved",
          "summary": "You negotiate a recorded compromise with the dock porters, securing 9 ves for your company while ensuring living porters receive their overdue grain wages.",
          "effects": {
            "add": [
              "mercenary-pay:settled-compromise",
              "dock-porters:wages-protected"
            ],
            "remove": [
              "estate:unsettled"
            ]
          }
        },
        {
          "goalId": "goal:unpaid-sellsword-fee",
          "status": "compromised",
          "summary": "You accept a third of the pledged coin from the estate factor in cash, leaving the porters and funeral rites unpaid.",
          "effects": {
            "add": [
              "mercenary-pay:partial-cash",
              "dock-porters:unpaid"
            ],
            "remove": [
              "estate:unsettled"
            ]
          }
        },
        {
          "goalId": "goal:unpaid-sellsword-fee",
          "status": "failed",
          "summary": "The mortuary concession claims the entire remaining estate for embalming and interment fees, leaving the guard company with nothing.",
          "effects": {
            "add": [
              "concession:estate-seized",
              "mercenary-pay:lost"
            ],
            "remove": [
              "estate:unsettled"
            ]
          }
        },
        {
          "goalId": "goal:unpaid-sellsword-fee",
          "status": "abandoned",
          "summary": "Seeing the destitution of the dockworkers, you walk away from Serrat's estate without pressing your claim.",
          "effects": {
            "add": [
              "mercenary-pay:abandoned"
            ],
            "remove": []
          }
        }
      ],
      "questRoles": [
        {
          "id": "role:unpaid-sellsword:estate-factor",
          "role": "service",
          "zone": "Z03",
          "preferredPersonId": "person:pelian-dareth",
          "alternatives": [
            {
              "kind": "revised-goal",
              "goalId": "goal:unpaid-sellsword-audit",
              "summary": "Audit the estate dispatch box directly at the cart office and claim the pledged wage share from the primary transshipment ledger.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "person",
              "personId": "person:clerk-dareth",
              "identifyingHistory": "Assistant estate notary handling warehouse liquidations.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "evidence",
              "evidenceId": "evidence:serrat-contract",
              "prerequisites": {
                "all": [
                  "found:serrat-contract"
                ],
                "any": [],
                "none": []
              }
            }
          ]
        }
      ],
      "questNodes": [
        {
          "id": "node:unpaid-sellsword:demand-accounting",
          "label": "Demand formal accounting of Maro Serrat's estate",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "estate:accounting-filed"
            ]
          },
          "effects": {
            "add": [
              "estate:accounting-filed"
            ],
            "remove": []
          }
        },
        {
          "id": "node:unpaid-sellsword:negotiate-split",
          "label": "Negotiate an audited wage division between guards and porters",
          "prerequisites": {
            "all": [
              "estate:accounting-filed"
            ],
            "any": [
              "porters:willing-to-talk"
            ],
            "none": [
              "wage-split:agreed"
            ]
          },
          "effects": {
            "add": [
              "wage-split:agreed",
              "found:serrat-contract"
            ],
            "remove": []
          }
        }
      ],
      "dialogueOptions": [
        {
          "id": "opt:unpaid-sellsword:present-tally",
          "intention": {
            "kind": "ask",
            "label": "Present the notched wage tally"
          },
          "text": "Maro Serrat hired my company to protect his grain convoy from Dovren. His signature and notch marks are on this wood. Where is his liquidation ledger?",
          "disclosure": "essential",
          "firstEncounterSummary": "File your company's notched wage tally against Maro Serrat's estate.",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "clerk:tally-presented"
            ]
          },
          "effects": {
            "add": [
              "clerk:tally-presented",
              "estate:in-competition"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:unpaid-sellsword:leverage-audit",
          "intention": {
            "kind": "offer",
            "label": "Offer an audited division of remaining funds"
          },
          "text": "Serrat left 24 ves in escrow. If the concession takes it all for an ornate burial, neither my guards nor the living warehouse porters get paid. Divide it evenly on the court register: twelve for the guards, twelve for the porters' grain chits.",
          "disclosure": "essential",
          "firstEncounterSummary": "Propose a fair audited division between guard wages and porter payroll.",
          "prerequisites": {
            "all": [
              "estate:in-competition"
            ],
            "any": [],
            "none": [
              "porters:willing-to-talk"
            ]
          },
          "effects": {
            "add": [
              "porters:willing-to-talk",
              "leverage:payroll-audit-offered"
            ],
            "remove": []
          },
          "requiredIncentives": [
            "knowledge:commercial-arbitration"
          ],
          "requiredProtections": [],
          "socialDifficulty": 3
        },
        {
          "id": "opt:unpaid-sellsword:warn-concession",
          "intention": {
            "kind": "warn",
            "label": "Warn that the concession burial claim is inflated"
          },
          "text": "Tavren Noll is billing eight ves for lime and shrouds that cost two cuts in the market. Check the concession monopoly mark-up before you stamp his receipt.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "leverage:payroll-audit-offered"
            ],
            "any": [],
            "none": [
              "factor:scrutinizing-noll"
            ]
          },
          "effects": {
            "add": [
              "factor:scrutinizing-noll"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": 2
        },
        {
          "id": "opt:unpaid-sellsword:deep-convoy",
          "intention": {
            "kind": "ask",
            "label": "Ask why Serrat was liquidating grain at a loss"
          },
          "text": "Serrat told me he was shipping grain east at emergency rates, but the manifests show he was selling below cost to the mortuary kilns. Why would a sane merchant sell food to a brickworks?",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "factor:scrutinizing-noll"
            ],
            "any": [],
            "none": [
              "lore:serrat-kiln-sales"
            ]
          },
          "effects": {
            "add": [
              "lore:serrat-kiln-sales"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:unpaid-sellsword:leave-estate",
          "intention": {
            "kind": "leave",
            "label": "Step away from the factor's table"
          },
          "text": "Keep the tally on your table. I will return when the porter delegate arrives.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "effects": {
            "add": [
              "pc:left-estate-table"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "evidence": [
        {
          "id": "evidence:serrat-contract",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "contractor-records:serrat",
          "finding": "Maro Serrat paid kickbacks to the mortuary concession to secure priority barge berths at the Silt Stair.",
          "verified": true,
          "witnessId": null
        },
        {
          "id": "evidence:porter-payroll",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "dock-register:porter-wages",
          "finding": "Living warehouse porters have not been paid in grain chits for four consecutive weeks.",
          "verified": true,
          "witnessId": null
        }
      ],
      "witnessProtections": [
        {
          "id": "protection:pelian-dareth",
          "witnessId": "person:pelian-dareth",
          "kind": "debt-release",
          "guarantorId": "institution:reeves-court",
          "commitments": [
            "Release Pelian from personal liability for Serrat's contested shipping debts"
          ],
          "secured": true
        }
      ],
      "firstEncounter": {
        "speaker": "Factor Pelian Dareth",
        "location": "Z03 Cold Bath Court",
        "context": "You arrive at the Silt Stair to collect overdue convoy guard wages from your deceased employer's impounded estate.",
        "initialNpcDialogue": "Maro Serrat died two nights ago, and every creditor in the basin is knocking on this table. The mortuary concession wants twelve ves for his burial, and the warehouse porters are threatening to seize the cargo.",
        "progressiveDisclosureReview": {
          "immediateObjective": "Prevent the mortuary concession from stripping Maro Serrat's remaining estate and collect your company's fee.",
          "nextAction": "Present your notched wage tally and negotiate a recorded wage compromise with the estate factor and dock porters.",
          "whoBenefits": "Your mercenary company and the living porters who carried Serrat's grain.",
          "costOrRisk": "Accepting a negotiated split reduces your payout; demanding the full sum leaves porters starving and triggers dock violence.",
          "doesDeadPersonReturn": "No. Maro Serrat is dead; his estate is finite money and cargo, not a living voice."
        }
      },
      "loreAccessibility": {
        "prohibitedJargonChecked": true,
        "intelligentNotGeniusReadingLevel": true,
        "readingLevelNotes": "Grounds the scene in payroll, grain chits, and merchant debts. No abstract economic jargon."
      },
      "playerFacingWordCount": 347
    },
    "fallen-household": {
      "version": 1,
      "id": "origin-recipe:fallen-household",
      "originId": "fallen-household",
      "family": "social",
      "providerId": "authored-origin-recipe",
      "providerVersion": "1",
      "seed": "origin-fallen-household-v1",
      "license": "Project-authored deterministic origin content recipe",
      "recipeOrigin": "Agent-executed D02.4 origin writing lane",
      "sources": [
        {
          "document": "VISION.md",
          "section": "Non-negotiables"
        },
        {
          "document": "docs/design.md",
          "section": "Lore accessibility (Waseem, 13 Sep — world bible approved)"
        },
        {
          "document": "docs/world/04-zones.md",
          "section": "Eight starting-background hooks"
        },
        {
          "document": "docs/plan/03-content-plan.md",
          "section": "Origins — exact hooks, bounded continuation"
        },
        {
          "document": "docs/world/09-naming-and-tone.md",
          "section": "People by cultural naming tradition"
        }
      ],
      "capsuleId": "capsule:origin:fallen-household",
      "capsuleKind": "origin",
      "title": "The Lower Terrace Deed",
      "bibleHook": {
        "openingGoal": "Recover a residence deed protecting a dependent sibling.",
        "complication": "The family obtained the property through an earlier confiscation; legal literacy opens the court.",
        "nonCombatLeverage": "Legal literacy and knowledge of provincial tenure statutes open the Reeve's Court without violence.",
        "guardrail": "Keep the earlier confiscation visible. A recovered deed can protect someone and perpetuate injustice simultaneously."
      },
      "sourceBoundRelative": {
        "roleId": "role:fallen-household:dependent-sibling",
        "relationKind": "dependent-sibling",
        "preferredPersonId": "person:cessa-calven",
        "preferredName": "Cessa Calven",
        "culture": "Veyrathi",
        "identifyingHistory": "Younger sibling sheltering inside the contested family house on the lower canal terrace.",
        "deadAlternativeKind": "revised-goal",
        "deadAlternativeSummary": "Recover the municipal confiscation schedule and clear your family name from the public debt roll, dedicating an honest memorial."
      },
      "sourceBoundItems": [
        {
          "id": "item:residence-deed-parchment",
          "name": "Tenure deed to the lower terrace residence",
          "kind": "quest-right",
          "provenanceKey": "calven-household:tenure-deed",
          "description": "An official provincial deed certifying the Calven family's title to parcel 4 on the lower canal terrace, stamped with the imperial eagle."
        },
        {
          "id": "item:confiscation-register-transcript",
          "name": "Confiscation extract of 628 AC",
          "kind": "tool",
          "provenanceKey": "municipal-court:confiscation-schedule",
          "description": "An ink-stained extract showing that the Calven residence was originally confiscated by the Senate from an exiled dyer."
        }
      ],
      "personalGoal": {
        "id": "goal:fallen-household-residence",
        "personId": "person:pc",
        "description": "Recover the residence deed held among the kiln concession's papers, and have the Reeve's Court protect your sibling Cessa from municipal eviction.",
        "prerequisites": {
          "all": [
            "arrived:silt-stair"
          ],
          "any": [],
          "none": []
        }
      },
      "outcomes": [
        {
          "goalId": "goal:fallen-household-residence",
          "status": "achieved",
          "summary": "You recover the tenure deed and certify your title, protecting Cessa from eviction while acknowledging the older confiscation that gave your family the house.",
          "effects": {
            "add": [
              "residence-deed:secured",
              "cessa:sheltered"
            ],
            "remove": [
              "eviction:pending"
            ]
          }
        },
        {
          "goalId": "goal:fallen-household-residence",
          "status": "compromised",
          "summary": "You negotiate a temporary tenancy lease that protects Cessa for one harvest season in exchange for paying a surcharge to the dyer's heirs.",
          "effects": {
            "add": [
              "residence-deed:temporary-lease",
              "cessa:temporarily-sheltered"
            ],
            "remove": [
              "eviction:pending"
            ]
          }
        },
        {
          "goalId": "goal:fallen-household-residence",
          "status": "failed",
          "summary": "The court magistrate rejects your claim as defective and auctions the residence to fund canal maintenance arrears.",
          "effects": {
            "add": [
              "residence:auctioned",
              "cessa:displaced"
            ],
            "remove": [
              "eviction:pending"
            ]
          }
        },
        {
          "goalId": "goal:fallen-household-residence",
          "status": "abandoned",
          "summary": "Confronted with the injustice of your father's original confiscation, you abandon the deed and relocate your sibling to rented lodgings.",
          "effects": {
            "add": [
              "residence-deed:abandoned"
            ],
            "remove": []
          }
        }
      ],
      "questRoles": [
        {
          "id": "role:fallen-household:dependent-sibling",
          "role": "origin-relative",
          "zone": "Z03",
          "preferredPersonId": "person:cessa-calven",
          "alternatives": [
            {
              "kind": "revised-goal",
              "goalId": "goal:fallen-household-memorial",
              "summary": "Recover the municipal confiscation schedule and clear your family name from the public debt roll, dedicating an honest memorial.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "person",
              "personId": "person:clerk-averin",
              "identifyingHistory": "A municipal notary who holds custody of provincial tenure registers.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "evidence",
              "evidenceId": "evidence:calven-deed",
              "prerequisites": {
                "all": [
                  "found:calven-deed"
                ],
                "any": [],
                "none": []
              }
            }
          ]
        }
      ],
      "questNodes": [
        {
          "id": "node:fallen-household:inspect-registry",
          "label": "Inspect the Reeve's Court land registry",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "registry:inspected"
            ]
          },
          "effects": {
            "add": [
              "registry:inspected"
            ],
            "remove": []
          }
        },
        {
          "id": "node:fallen-household:plead-statute",
          "label": "Plead provincial tenancy statute 14 before the notary",
          "prerequisites": {
            "all": [
              "registry:inspected"
            ],
            "any": [
              "clerk:convinced-by-law"
            ],
            "none": [
              "deed:released"
            ]
          },
          "effects": {
            "add": [
              "deed:released",
              "found:calven-deed"
            ],
            "remove": []
          }
        }
      ],
      "dialogueOptions": [
        {
          "id": "opt:fallen-household:request-folio",
          "intention": {
            "kind": "ask",
            "label": "Request the tenure folio for parcel 4"
          },
          "text": "I am here regarding parcel 4 on the lower terrace, registered to the Calven household. My sister is resident, yet an eviction notice was posted on our door.",
          "disclosure": "essential",
          "firstEncounterSummary": "Demand to see the land registry folio holding the deed to your family home.",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "clerk:folio-requested"
            ]
          },
          "effects": {
            "add": [
              "clerk:folio-requested",
              "folio:located"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:fallen-household:leverage-statute",
          "intention": {
            "kind": "offer",
            "label": "Cite provincial tenancy statute 14"
          },
          "text": "Under provincial tenancy statute 14, summary eviction is barred while an acknowledged heir remains in the district. The notice posted by the bailiff is void on its face. Open the hearing docket.",
          "disclosure": "essential",
          "firstEncounterSummary": "Use legal literacy to invalidate the summary eviction notice.",
          "prerequisites": {
            "all": [
              "folio:located"
            ],
            "any": [],
            "none": [
              "clerk:convinced-by-law"
            ]
          },
          "effects": {
            "add": [
              "clerk:convinced-by-law",
              "leverage:tenancy-statute-applied"
            ],
            "remove": []
          },
          "requiredIncentives": [
            "knowledge:provincial-tenure-law"
          ],
          "requiredProtections": [],
          "socialDifficulty": 2
        },
        {
          "id": "opt:fallen-household:warn-liability",
          "intention": {
            "kind": "warn",
            "label": "Warn the clerk of municipal liability for illegal eviction"
          },
          "text": "If you permit the bailiff to auction that house while an heir is on record, the magistrate will hold your office liable for the full replacement value of the title.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "leverage:tenancy-statute-applied"
            ],
            "any": [],
            "none": [
              "clerk:cooperating-on-deed"
            ]
          },
          "effects": {
            "add": [
              "clerk:cooperating-on-deed"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": 3
        },
        {
          "id": "opt:fallen-household:deep-confiscation",
          "intention": {
            "kind": "ask",
            "label": "Inquire about the original owner of parcel 4"
          },
          "text": "The margin notes say my father bought this title after the Senate seized it in 628 AC. Who was evicted so that my family could live there?",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "clerk:cooperating-on-deed"
            ],
            "any": [],
            "none": [
              "lore:confiscation-history-revealed"
            ]
          },
          "effects": {
            "add": [
              "lore:confiscation-history-revealed"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:fallen-household:leave-court",
          "intention": {
            "kind": "leave",
            "label": "Step away from the court bench"
          },
          "text": "I will return with our household seal before the magistrate calls the noon roll.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "effects": {
            "add": [
              "pc:left-court-bench"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "evidence": [
        {
          "id": "evidence:calven-deed",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "court-register:parcel-4-calven",
          "finding": "The Calven family holds legal title to parcel 4, though the original title was confiscated from a provincial artisan in 628 AC.",
          "verified": true,
          "witnessId": null
        },
        {
          "id": "evidence:bailiff-auction-list",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "bailiff-records:unlawful-auctions",
          "finding": "The Reeve's bailiff has been auctioning occupied parcels to fund emergency lift repairs.",
          "verified": true,
          "witnessId": null
        }
      ],
      "witnessProtections": [
        {
          "id": "protection:cessa-calven",
          "witnessId": "person:cessa-calven",
          "kind": "safe-conduct",
          "guarantorId": "institution:reeves-court",
          "commitments": [
            "Issue an injunction barring bailiffs from entering parcel 4",
            "Guarantee municipal water access during the title dispute"
          ],
          "secured": true
        }
      ],
      "firstEncounter": {
        "speaker": "Notary Averin",
        "location": "Z03 Reeve's Court Hearing Room",
        "context": "You arrive at the court registry to halt the eviction of your sibling from your family's lower-terrace home.",
        "initialNpcDialogue": "The auction list for delinquent lower-terrace holdings is already posted on the church wall. Unless you can show clear title or pay thirty ves in arrears, your sibling must vacate by sundown.",
        "progressiveDisclosureReview": {
          "immediateObjective": "Halt the summary eviction of your sibling Cessa and recover your family's residence deed.",
          "nextAction": "Confront Notary Averin and plead provincial tenancy statute 14 to invalidate the auction notice.",
          "whoBenefits": "Your sibling Cessa, who keeps her home.",
          "costOrRisk": "Upholding the deed preserves property acquired through an unjust historical seizure of an artisan's home.",
          "doesDeadPersonReturn": "No. Deceased parents and prior owners remain dead; legal deeds govern physical possession among the living."
        }
      },
      "loreAccessibility": {
        "prohibitedJargonChecked": true,
        "intelligentNotGeniusReadingLevel": true,
        "readingLevelNotes": "Focuses on eviction, tenancy statutes, deeds, and bailiffs. Avoids dry administrative theory."
      },
      "playerFacingWordCount": 336
    },
    "intelligence-runner": {
      "version": 1,
      "id": "origin-recipe:intelligence-runner",
      "originId": "intelligence-runner",
      "family": "social",
      "providerId": "authored-origin-recipe",
      "providerVersion": "1",
      "seed": "origin-intelligence-runner-v1",
      "license": "Project-authored deterministic origin content recipe",
      "recipeOrigin": "Agent-executed D02.4 origin writing lane",
      "sources": [
        {
          "document": "VISION.md",
          "section": "Non-negotiables"
        },
        {
          "document": "docs/design.md",
          "section": "Lore accessibility (Waseem, 13 Sep — world bible approved)"
        },
        {
          "document": "docs/world/04-zones.md",
          "section": "Eight starting-background hooks"
        },
        {
          "document": "docs/plan/03-content-plan.md",
          "section": "Origins — exact hooks, bounded continuation"
        },
        {
          "document": "docs/world/09-naming-and-tone.md",
          "section": "People by cultural naming tradition"
        }
      ],
      "capsuleId": "capsule:origin:intelligence-runner",
      "capsuleKind": "origin",
      "title": "The Unaltered Deposition",
      "bibleHook": {
        "openingGoal": "Retrieve an unaltered witness statement before a buyer publishes a manipulated copy.",
        "complication": "The statement implicates a former patron; contacts give access, not automatic loyalty.",
        "nonCombatLeverage": "Courier contacts and dispatch trade-craft grant access to sealed postal pouches without violence.",
        "guardrail": "The old patron's implication remains a choice with costs. Do not replace the source with a generic spy mission."
      },
      "sourceBoundRelative": {
        "roleId": "role:intelligence-runner:dispatch-contact",
        "relationKind": "dispatch-contact",
        "preferredPersonId": "person:runner-nemi",
        "preferredName": "Nemi of the Lower Gate",
        "culture": "Orsene",
        "identifyingHistory": "Canal packet runner who held the lockbox containing the unredacted diversion deposition.",
        "deadAlternativeKind": "revised-goal",
        "deadAlternativeSummary": "Deposit the unredacted witness statement directly into the public stone archive at Caldris before the forged redaction enters the gazette."
      },
      "sourceBoundItems": [
        {
          "id": "item:unaltered-deposition-cylinder",
          "name": "Sealed deposition cylinder on canal diversion",
          "kind": "quest-right",
          "provenanceKey": "packet-office:unredacted-deposition",
          "description": "A lead courier cylinder containing the original unedited testimony of an elder sluice engineer regarding the diversion of relief grain."
        },
        {
          "id": "item:courier-relay-signet",
          "name": "Bronze relay runner seal",
          "kind": "tool",
          "provenanceKey": "postal-circuit:relay-stamp",
          "description": "A runner's identification badge granting access to private dispatch boxes at river way-stations."
        }
      ],
      "personalGoal": {
        "id": "goal:intelligence-runner-statement",
        "personId": "person:pc",
        "description": "Retrieve the unaltered witness statement from the courier relay before a buyer doctoring the records publishes a forged copy.",
        "prerequisites": {
          "all": [
            "arrived:silt-stair"
          ],
          "any": [],
          "none": []
        }
      },
      "outcomes": [
        {
          "goalId": "goal:intelligence-runner-statement",
          "status": "achieved",
          "summary": "You retrieve the unaltered deposition roll intact, holding the truth of the diversion without becoming a pawn of your former patron.",
          "effects": {
            "add": [
              "deposition:retrieved-unaltered",
              "truth:preserved"
            ],
            "remove": [
              "statement:threatened"
            ]
          }
        },
        {
          "goalId": "goal:intelligence-runner-statement",
          "status": "compromised",
          "summary": "You sell the cylinder back to Tribune Soreth's factors for safe conduct, burying the scandal to secure your own survival.",
          "effects": {
            "add": [
              "deposition:surrendered-to-patron",
              "patron:protected"
            ],
            "remove": [
              "statement:threatened"
            ]
          }
        },
        {
          "goalId": "goal:intelligence-runner-statement",
          "status": "failed",
          "summary": "The buyer's agents intercept the packet boat and circulate a doctored roll that blames lower canal workers for the theft.",
          "effects": {
            "add": [
              "statement:doctored",
              "workers:falsely-accused"
            ],
            "remove": [
              "statement:threatened"
            ]
          }
        },
        {
          "goalId": "goal:intelligence-runner-statement",
          "status": "abandoned",
          "summary": "You throw your courier signet into the lock water, refusing to involve yourself further in provincial political blackmail.",
          "effects": {
            "add": [
              "statement:abandoned"
            ],
            "remove": []
          }
        }
      ],
      "questRoles": [
        {
          "id": "role:intelligence-runner:dispatch-contact",
          "role": "origin-relative",
          "zone": "Z03",
          "preferredPersonId": "person:runner-nemi",
          "alternatives": [
            {
              "kind": "revised-goal",
              "goalId": "goal:intelligence-runner-archive",
              "summary": "Deposit the unredacted witness statement directly into the public stone archive at Caldris before the forged redaction enters the gazette.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "person",
              "personId": "person:packet-master-reth",
              "identifyingHistory": "Canal packet master holding outgoing dispatch bags.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "evidence",
              "evidenceId": "evidence:unaltered-deposition",
              "prerequisites": {
                "all": [
                  "found:unaltered-deposition"
                ],
                "any": [],
                "none": []
              }
            }
          ]
        }
      ],
      "questNodes": [
        {
          "id": "node:intelligence-runner:locate-cylinder",
          "label": "Locate the lead dispatch cylinder at the packet station",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "cylinder:located"
            ]
          },
          "effects": {
            "add": [
              "cylinder:located"
            ],
            "remove": []
          }
        },
        {
          "id": "node:intelligence-runner:claim-cylinder",
          "label": "Claim the cylinder using courier relay protocols",
          "prerequisites": {
            "all": [
              "cylinder:located"
            ],
            "any": [
              "reth:acknowledged-relay"
            ],
            "none": [
              "cylinder:secured"
            ]
          },
          "effects": {
            "add": [
              "cylinder:secured",
              "found:unaltered-deposition"
            ],
            "remove": []
          }
        }
      ],
      "dialogueOptions": [
        {
          "id": "opt:intelligence-runner:inquire-pouch",
          "intention": {
            "kind": "ask",
            "label": "Ask about the noon dispatch pouch from Caldris"
          },
          "text": "The packet boat from Caldris brought a lead cylinder sealed with green wax. Where was it sorted?",
          "disclosure": "essential",
          "firstEncounterSummary": "Trace the courier dispatch pouch containing the unedited witness statement.",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "reth:pouch-inquired"
            ]
          },
          "effects": {
            "add": [
              "reth:pouch-inquired",
              "cylinder:traced-to-sorting-desk"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:intelligence-runner:leverage-protocol",
          "intention": {
            "kind": "offer",
            "label": "Present runner credentials and relay protocol"
          },
          "text": "Here is my bronze relay seal. That cylinder is logged under circuit code 4. Under postal regulations, an unrouted judicial deposition must be surrendered to the circuit runner on demand.",
          "disclosure": "essential",
          "firstEncounterSummary": "Use courier trade-craft and regulations to claim the cylinder without violence.",
          "prerequisites": {
            "all": [
              "cylinder:traced-to-sorting-desk"
            ],
            "any": [],
            "none": [
              "reth:acknowledged-relay"
            ]
          },
          "effects": {
            "add": [
              "reth:acknowledged-relay",
              "leverage:postal-protocol-applied"
            ],
            "remove": []
          },
          "requiredIncentives": [
            "knowledge:postal-relay-rules"
          ],
          "requiredProtections": [],
          "socialDifficulty": 2
        },
        {
          "id": "opt:intelligence-runner:warn-forgery",
          "intention": {
            "kind": "warn",
            "label": "Warn of the buyer's planned redaction"
          },
          "text": "The private factor offering you twelve cuts for that pouch intends to shave the wax seal and remove the pages naming the Senate contractors. You will be hanged as an accomplice when the forgery is caught.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "leverage:postal-protocol-applied"
            ],
            "any": [],
            "none": [
              "reth:frightened-of-complicity"
            ]
          },
          "effects": {
            "add": [
              "reth:frightened-of-complicity"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": 3
        },
        {
          "id": "opt:intelligence-runner:deep-patron",
          "intention": {
            "kind": "ask",
            "label": "Ask why Tribune Soreth allowed the diversion"
          },
          "text": "Did Tribune Soreth sign the diversion order to line his own purse, or was he coerced by the grain factors in Caldris?",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "reth:frightened-of-complicity"
            ],
            "any": [],
            "none": [
              "lore:soreth-grain-coercion"
            ]
          },
          "effects": {
            "add": [
              "lore:soreth-grain-coercion"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:intelligence-runner:leave-station",
          "intention": {
            "kind": "leave",
            "label": "Step away from the dispatch window"
          },
          "text": "Hold that lead tube in the locked cabinet. I will inspect the logbook before the packet departs.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "effects": {
            "add": [
              "pc:left-dispatch-window"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "evidence": [
        {
          "id": "evidence:unaltered-deposition",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "postal-records:sluice-deposition",
          "finding": "The original deposition shows that municipal grain was diverted by private concession factors rather than lost to canal seepage.",
          "verified": true,
          "witnessId": null
        },
        {
          "id": "evidence:tampered-receipt",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "packet-station:tampered-receipt",
          "finding": "A forged postal receipt was prepared to claim the deposition cylinder had been lost in transit.",
          "verified": true,
          "witnessId": null
        }
      ],
      "witnessProtections": [
        {
          "id": "protection:runner-nemi",
          "witnessId": "person:runner-nemi",
          "kind": "relocation",
          "guarantorId": "institution:reeves-court",
          "commitments": [
            "Provide safe passage to the upper terrace",
            "Transfer Nemi to the western postal circuit"
          ],
          "secured": true
        }
      ],
      "firstEncounter": {
        "speaker": "Packet Master Reth",
        "location": "Z03 Toll Stair Courier Station",
        "context": "You arrive at the packet station to intercept an unredacted witness deposition before private buyers alter the record.",
        "initialNpcDialogue": "Every dispatch tube passing through the Silt Stair is sorted by priority. If you do not have an official courier warrant or coin for the express tariff, step back from the grille.",
        "progressiveDisclosureReview": {
          "immediateObjective": "Intercept the lead cylinder containing the unaltered witness statement before it is sold and doctored.",
          "nextAction": "Present your courier seal to Packet Master Reth and cite postal circuit protocols to claim the cylinder.",
          "whoBenefits": "The public record and truth of the grain diversion, though it risks implicating your former patron.",
          "costOrRisk": "Exposing the deposition invites retribution from the private factors purchasing the altered copy.",
          "doesDeadPersonReturn": "No. Dead witnesses remain dead; written depositions are their only surviving testimony."
        }
      },
      "loreAccessibility": {
        "prohibitedJargonChecked": true,
        "intelligentNotGeniusReadingLevel": true,
        "readingLevelNotes": "Focuses on postal protocols, sealed cylinders, wax stamps, and postal clerks. No spy-fantasy cliches."
      },
      "playerFacingWordCount": 309
    },
    "escaped-worker": {
      "version": 1,
      "id": "origin-recipe:escaped-worker",
      "originId": "escaped-worker",
      "family": "marginal",
      "providerId": "authored-origin-recipe",
      "providerVersion": "1",
      "seed": "origin-escaped-worker-v1",
      "license": "Project-authored deterministic origin content recipe",
      "recipeOrigin": "Agent-executed D02.4 origin writing lane",
      "sources": [
        {
          "document": "VISION.md",
          "section": "Non-negotiables"
        },
        {
          "document": "docs/design.md",
          "section": "Lore accessibility (Waseem, 13 Sep — world bible approved)"
        },
        {
          "document": "docs/world/04-zones.md",
          "section": "Eight starting-background hooks"
        },
        {
          "document": "docs/plan/03-content-plan.md",
          "section": "Origins — exact hooks, bounded continuation"
        },
        {
          "document": "docs/world/09-naming-and-tone.md",
          "section": "People by cultural naming tradition"
        }
      ],
      "capsuleId": "capsule:origin:escaped-worker",
      "capsuleKind": "origin",
      "title": "The Broker's Chain",
      "bibleHook": {
        "openingGoal": "Invalidate linked sale copies so a local refuge can legally shelter them.",
        "complication": "Destroying only one copy is insufficient; workers can identify the broker chain.",
        "nonCombatLeverage": "Workers can identify the broker chain and ledger duplicates across canal factoring houses.",
        "guardrail": "The copy chain matters; destroying one convenient paper is not magical emancipation."
      },
      "sourceBoundRelative": {
        "roleId": "role:escaped-worker:bonded-companion",
        "relationKind": "bonded-companion",
        "preferredPersonId": "person:bessa-nall",
        "preferredName": "Bessa Nall",
        "culture": "Orsene",
        "identifyingHistory": "Fellow bonded labourer sheltering at the Near Table kitchens from concession bailiffs.",
        "deadAlternativeKind": "revised-goal",
        "deadAlternativeSummary": "Strike your deceased companion's posthumous bond from the concession master ledger so the debt cannot be transferred to her surviving children."
      },
      "sourceBoundItems": [
        {
          "id": "item:salt-concession-indenture",
          "name": "Salt Concession bonded indenture roll",
          "kind": "quest-right",
          "provenanceKey": "salt-pans:primary-bond-copy",
          "description": "The primary indenture document recording three seasons of unpaid labour, stamped with the Salt Compact seal."
        },
        {
          "id": "item:broker-tallies-register",
          "name": "Broker's duplicate registry sheet",
          "kind": "tool",
          "provenanceKey": "canal-broker:linked-copies",
          "description": "A notched memorandum identifying the two secondary copies filed with factoring houses at Nacre and the Silt Stair."
        }
      ],
      "personalGoal": {
        "id": "goal:escaped-worker-invalidate",
        "personId": "person:pc",
        "description": "Invalidate all three linked copies of your bonded sale contract so the Near Table refuge can shelter you without legal seizure.",
        "prerequisites": {
          "all": [
            "arrived:silt-stair"
          ],
          "any": [],
          "none": []
        }
      },
      "outcomes": [
        {
          "goalId": "goal:escaped-worker-invalidate",
          "status": "achieved",
          "summary": "You expose the fraudulent compounding of interest across all three broker rolls, voiding the indenture chain and granting lawful sanctuary.",
          "effects": {
            "add": [
              "indenture-chain:voided",
              "workers:lawful-sanctuary"
            ],
            "remove": [
              "bailiffs:hunting-workers"
            ]
          }
        },
        {
          "goalId": "goal:escaped-worker-invalidate",
          "status": "compromised",
          "summary": "A local master agrees to buy out the secondary copies, exchanging penal indenture for a bonded term of ordinary wage labour.",
          "effects": {
            "add": [
              "indenture:transferred-to-fair-master",
              "workers:paroled"
            ],
            "remove": [
              "bailiffs:hunting-workers"
            ]
          }
        },
        {
          "goalId": "goal:escaped-worker-invalidate",
          "status": "failed",
          "summary": "The broker produces a hidden fourth copy from the maritime registry, invalidating the sanctuary and sending bailiffs into the kitchens.",
          "effects": {
            "add": [
              "sanctuary:broken",
              "workers:recaptured"
            ],
            "remove": [
              "bailiffs:hunting-workers"
            ]
          }
        },
        {
          "goalId": "goal:escaped-worker-invalidate",
          "status": "abandoned",
          "summary": "Fearing discovery, you abandon the refuge and flee into the marsh without striking the papers, remaining an outlaw.",
          "effects": {
            "add": [
              "indenture:abandoned-unresolved"
            ],
            "remove": []
          }
        }
      ],
      "questRoles": [
        {
          "id": "role:escaped-worker:bonded-companion",
          "role": "origin-relative",
          "zone": "Z03",
          "preferredPersonId": "person:bessa-nall",
          "alternatives": [
            {
              "kind": "revised-goal",
              "goalId": "goal:escaped-worker-strike-tally",
              "summary": "Strike your deceased companion's posthumous bond from the concession master ledger so the debt cannot be transferred to her surviving children.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "person",
              "personId": "person:helma-oss",
              "identifyingHistory": "Near Table speaker offering conditional kitchen shelter.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "evidence",
              "evidenceId": "evidence:broker-chain",
              "prerequisites": {
                "all": [
                  "found:broker-chain"
                ],
                "any": [],
                "none": []
              }
            }
          ]
        }
      ],
      "questNodes": [
        {
          "id": "node:escaped-worker:seek-sanctuary",
          "label": "Petition the Near Table kitchens for shelter",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "kitchens:petitioned"
            ]
          },
          "effects": {
            "add": [
              "kitchens:petitioned"
            ],
            "remove": []
          }
        },
        {
          "id": "node:escaped-worker:confront-broker",
          "label": "Confront the canal broker with the duplicate tally chain",
          "prerequisites": {
            "all": [
              "kitchens:petitioned"
            ],
            "any": [
              "helma:supported-petition"
            ],
            "none": [
              "chain:voided"
            ]
          },
          "effects": {
            "add": [
              "chain:voided",
              "found:broker-chain"
            ],
            "remove": []
          }
        }
      ],
      "dialogueOptions": [
        {
          "id": "opt:escaped-worker:petition-helma",
          "intention": {
            "kind": "ask",
            "label": "Petition Table Speaker Helma for customary sanctuary"
          },
          "text": "The bailiffs from the salt concession are checking the toll stair. We need shelter at the unseated table while we contest the debt.",
          "disclosure": "essential",
          "firstEncounterSummary": "Petition the Near Table kitchens for customary shelter from concession bailiffs.",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "helma:petitioned"
            ]
          },
          "effects": {
            "add": [
              "helma:petitioned",
              "sanctuary:under-review"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:escaped-worker:leverage-broker-fraud",
          "intention": {
            "kind": "offer",
            "label": "Expose the broker's illegal interest compounding"
          },
          "text": "The broker filed three linked copies of our sale roll. Look at the notch spacing: he added thirty cuts of fictitious grain interest that violates provincial labour edicts. Strike the second copy here and his entire lien collapses.",
          "disclosure": "essential",
          "firstEncounterSummary": "Use knowledge of the broker's fraudulent duplicate chain to void the contract.",
          "prerequisites": {
            "all": [
              "sanctuary:under-review"
            ],
            "any": [],
            "none": [
              "helma:supported-petition"
            ]
          },
          "effects": {
            "add": [
              "helma:supported-petition",
              "leverage:broker-fraud-exposed"
            ],
            "remove": []
          },
          "requiredIncentives": [
            "knowledge:broker-contract-fraud"
          ],
          "requiredProtections": [],
          "socialDifficulty": 2
        },
        {
          "id": "opt:escaped-worker:warn-bailiffs",
          "intention": {
            "kind": "warn",
            "label": "Warn that bailiffs are raiding Near Table kitchens"
          },
          "text": "If the reeve allows concession bailiffs to drag workers from these kitchens, your sanctuary custom will be finished throughout the lower valley.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "leverage:broker-fraud-exposed"
            ],
            "any": [],
            "none": [
              "helma:defending-sanctuary"
            ]
          },
          "effects": {
            "add": [
              "helma:defending-sanctuary"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": 3
        },
        {
          "id": "opt:escaped-worker:deep-salt-pans",
          "intention": {
            "kind": "ask",
            "label": "Ask why the Salt Concession purchases bonded debtors"
          },
          "text": "Why are provincial magistrates allowing the salt pans to buy debt bonds from common farmers? The imperial charter forbids perpetual bonded servitude.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "helma:defending-sanctuary"
            ],
            "any": [],
            "none": [
              "lore:salt-compact-debt-system"
            ]
          },
          "effects": {
            "add": [
              "lore:salt-compact-debt-system"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:escaped-worker:leave-kitchens",
          "intention": {
            "kind": "leave",
            "label": "Step into the courtyard behind the kettles"
          },
          "text": "I will watch the road from the alley while you prepare the bread roll.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "effects": {
            "add": [
              "pc:in-kitchen-courtyard"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "evidence": [
        {
          "id": "evidence:broker-chain",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "broker-ledger:duplicate-bonds",
          "finding": "The labor broker maintained duplicate indenture copies to collect double fees from both salt concession and canal maintenance.",
          "verified": true,
          "witnessId": null
        },
        {
          "id": "evidence:refugee-warrant",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "bailiff-warrants:escaped-debtors",
          "finding": "Concession bailiffs are operating inside municipal bounds without a confirmed warrant from the Reeve.",
          "verified": true,
          "witnessId": null
        }
      ],
      "witnessProtections": [
        {
          "id": "protection:bessa-nall",
          "witnessId": "person:bessa-nall",
          "kind": "public-custody",
          "guarantorId": "institution:reeves-court",
          "commitments": [
            "Grant Near Table customary sanctuary",
            "Prohibit concession bailiffs from entering the kitchen precinct"
          ],
          "secured": true
        }
      ],
      "firstEncounter": {
        "speaker": "Table Speaker Helma Oss",
        "location": "Z03 Near Table Kitchens",
        "context": "You arrive at the kitchen court seeking protection for yourself and Bessa Nall from concession debt bailiffs.",
        "initialNpcDialogue": "The Near Table feeds anyone who works at the pots, but we cannot fight armed bailiffs with soup ladles. If your sale roll has a lawful seal, the Reeve's men will take you before sundown.",
        "progressiveDisclosureReview": {
          "immediateObjective": "Secure legal sanctuary at the Near Table kitchens and invalidate the linked sale contracts.",
          "nextAction": "Show Table Speaker Helma the fraudulent duplicate marks on the broker's contract roll.",
          "whoBenefits": "You and Bessa Nall, who gain lawful freedom from bonded servitude.",
          "costOrRisk": "Challenging the labor broker's ledger risks exposing the entire kitchen refuge to harassment from bailiffs.",
          "doesDeadPersonReturn": "No. Bonded workers who died in the salt beds stay dead; legal release protects only the living."
        }
      },
      "loreAccessibility": {
        "prohibitedJargonChecked": true,
        "intelligentNotGeniusReadingLevel": true,
        "readingLevelNotes": "Focuses on bread kettles, debt tallies, bailiffs, and broker contracts. Avoids economic abstraction."
      },
      "playerFacingWordCount": 314
    },
    "serekh-exile": {
      "version": 1,
      "id": "origin-recipe:serekh-exile",
      "originId": "serekh-exile",
      "family": "marginal",
      "providerId": "authored-origin-recipe",
      "providerVersion": "1",
      "seed": "origin-serekh-exile-v1",
      "license": "Project-authored deterministic origin content recipe",
      "recipeOrigin": "Agent-executed D02.4 origin writing lane",
      "sources": [
        {
          "document": "VISION.md",
          "section": "Non-negotiables"
        },
        {
          "document": "docs/design.md",
          "section": "Lore accessibility (Waseem, 13 Sep — world bible approved)"
        },
        {
          "document": "docs/world/04-zones.md",
          "section": "Eight starting-background hooks"
        },
        {
          "document": "docs/plan/03-content-plan.md",
          "section": "Origins — exact hooks, bounded continuation"
        },
        {
          "document": "docs/world/09-naming-and-tone.md",
          "section": "People by cultural naming tradition"
        }
      ],
      "capsuleId": "capsule:origin:serekh-exile",
      "capsuleKind": "origin",
      "title": "The Serekh Transit Guarantee",
      "bibleHook": {
        "openingGoal": "Secure transit guarantees for an aunt and two children.",
        "complication": "A foreign guarantor demands information in return; language and treaty knowledge help negotiate.",
        "nonCombatLeverage": "Language fluency in Serekh court and treaty dialect and knowledge of frontier concordats.",
        "guardrail": "The guarantor's information demand remains explicit. Foreign identity does not force an invasion allegiance."
      },
      "sourceBoundRelative": {
        "roleId": "role:serekh-exile:aunt",
        "relationKind": "aunt",
        "preferredPersonId": "person:hazren-an-seket",
        "preferredName": "Hazren an-Seket",
        "culture": "Serekh",
        "identifyingHistory": "Elder aunt sheltering with two young children in a dry cellar near Lock Foot.",
        "deadAlternativeKind": "revised-goal",
        "deadAlternativeSummary": "Secure neutral road wardship for your orphaned nieces under the Vadrun road covenant without compromising Serekh irrigation charts."
      },
      "sourceBoundItems": [
        {
          "id": "item:serekh-soapstone-seal",
          "name": "Carved soapstone transit seal of Sekhet Anar",
          "kind": "quest-right",
          "provenanceKey": "serekh-water-court:transit-token",
          "description": "An engraved green soapstone token indicating lawful registered water-house membership in Sekhet Anar."
        },
        {
          "id": "item:frontier-concordat-roll",
          "name": "Bilingual frontier commerce concordat of 612 AC",
          "kind": "tool",
          "provenanceKey": "provincial-archives:serekh-treaty",
          "description": "A dual Veyrathi and Serekh papyrus treaty outlining civilian passage rights across provincial canal locks."
        }
      ],
      "personalGoal": {
        "id": "goal:serekh-exile-transit",
        "personId": "person:pc",
        "description": "Secure stamped safe-conduct transit certificates for Aunt Hazren and her two children past the Silt Stair lock.",
        "prerequisites": {
          "all": [
            "arrived:silt-stair"
          ],
          "any": [],
          "none": []
        }
      },
      "outcomes": [
        {
          "goalId": "goal:serekh-exile-transit",
          "status": "achieved",
          "summary": "You secure stamped transit vouchers under the 612 AC concordat without yielding sensitive irrigation secrets to the commissioner.",
          "effects": {
            "add": [
              "transit-vouchers:secured",
              "family:safe-passage-granted"
            ],
            "remove": [
              "family:unprotected"
            ]
          }
        },
        {
          "goalId": "goal:serekh-exile-transit",
          "status": "compromised",
          "summary": "You trade eastern canal depth tables for immediate passage papers, securing your family while handing over strategic water data.",
          "effects": {
            "add": [
              "transit-vouchers:compromised",
              "water-tables:surrendered"
            ],
            "remove": [
              "family:unprotected"
            ]
          }
        },
        {
          "goalId": "goal:serekh-exile-transit",
          "status": "failed",
          "summary": "The commissioner declares your family unregistered foreign spies and orders the garrison to search the lower cellar.",
          "effects": {
            "add": [
              "family:denounced",
              "garrison:hunting-family"
            ],
            "remove": [
              "family:unprotected"
            ]
          }
        },
        {
          "goalId": "goal:serekh-exile-transit",
          "status": "abandoned",
          "summary": "Refusing to negotiate with the frontier commissioner, you move your family into the marsh shanties outside the law.",
          "effects": {
            "add": [
              "transit:abandoned-unresolved"
            ],
            "remove": []
          }
        }
      ],
      "questRoles": [
        {
          "id": "role:serekh-exile:aunt",
          "role": "origin-relative",
          "zone": "Z03",
          "preferredPersonId": "person:hazren-an-seket",
          "alternatives": [
            {
              "kind": "revised-goal",
              "goalId": "goal:serekh-exile-orphans",
              "summary": "Secure neutral road wardship for your orphaned nieces under the Vadrun road covenant without compromising Serekh irrigation charts.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "person",
              "personId": "person:dorel-kes",
              "identifyingHistory": "Frontier commissioner controlling transit permits.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "evidence",
              "evidenceId": "evidence:treaty-voucher",
              "prerequisites": {
                "all": [
                  "found:treaty-voucher"
                ],
                "any": [],
                "none": []
              }
            }
          ]
        }
      ],
      "questNodes": [
        {
          "id": "node:serekh-exile:approach-commissioner",
          "label": "Approach the frontier commissioner at Lock Foot",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "commissioner:approached"
            ]
          },
          "effects": {
            "add": [
              "commissioner:approached"
            ],
            "remove": []
          }
        },
        {
          "id": "node:serekh-exile:negotiate-treaty-terms",
          "label": "Negotiate civilian passage under the 612 AC concordat",
          "prerequisites": {
            "all": [
              "commissioner:approached"
            ],
            "any": [
              "dorel:treaty-terms-accepted"
            ],
            "none": [
              "vouchers:issued"
            ]
          },
          "effects": {
            "add": [
              "vouchers:issued",
              "found:treaty-voucher"
            ],
            "remove": []
          }
        }
      ],
      "dialogueOptions": [
        {
          "id": "opt:serekh-exile:request-pass",
          "intention": {
            "kind": "ask",
            "label": "Request safe passage for three Serekh travellers"
          },
          "text": "My aunt and two children are waiting below the lock. We require three stamped transit vouchers for the road to Dovren.",
          "disclosure": "essential",
          "firstEncounterSummary": "Request three stamped passage vouchers from Frontier Commissioner Dorel.",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "dorel:petitioned"
            ]
          },
          "effects": {
            "add": [
              "dorel:petitioned",
              "transit:terms-demanded"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:serekh-exile:leverage-treaty-clause",
          "intention": {
            "kind": "offer",
            "label": "Cite clause 9 of the 612 AC Frontier Concordat"
          },
          "text": "Clause 9 of the Concordat between Caldris and Sekhet Anar guarantees unhindered transit for water-house families traveling during peacetime. Your garrison cannot demand military intelligence from civilian refugees.",
          "disclosure": "essential",
          "firstEncounterSummary": "Use treaty knowledge to demand civilian safe conduct without surrendering intelligence.",
          "prerequisites": {
            "all": [
              "transit:terms-demanded"
            ],
            "any": [],
            "none": [
              "dorel:treaty-terms-accepted"
            ]
          },
          "effects": {
            "add": [
              "dorel:treaty-terms-accepted",
              "leverage:treaty-clause-cited"
            ],
            "remove": []
          },
          "requiredIncentives": [
            "knowledge:frontier-treaty-law"
          ],
          "requiredProtections": [],
          "socialDifficulty": 2
        },
        {
          "id": "opt:serekh-exile:warn-retaliation",
          "intention": {
            "kind": "warn",
            "label": "Warn of diplomatic penalties from Sekhet Anar"
          },
          "text": "If you detain kin of the Sekhet water-court, the eastern delegates at Eshmar will shut the headgate sluices for three market days.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "leverage:treaty-clause-cited"
            ],
            "any": [],
            "none": [
              "dorel:respectful-of-treaty"
            ]
          },
          "effects": {
            "add": [
              "dorel:respectful-of-treaty"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": 3
        },
        {
          "id": "opt:serekh-exile:deep-exile-origin",
          "intention": {
            "kind": "ask",
            "label": "Ask why Serekh exiles are targeted for recruitment"
          },
          "text": "Why does the Bronze Standard keep trying to press Serekh craftsmen into their engineering corps? We fled because the water-house lords took our land, not to fight their wars.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "dorel:respectful-of-treaty"
            ],
            "any": [],
            "none": [
              "lore:serekh-conscription-pressure"
            ]
          },
          "effects": {
            "add": [
              "lore:serekh-conscription-pressure"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:serekh-exile:leave-lock-foot",
          "intention": {
            "kind": "leave",
            "label": "Step away toward the towpath"
          },
          "text": "I will consult with my aunt before signing your transit ledger.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "effects": {
            "add": [
              "pc:at-towpath-checkpoint"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "evidence": [
        {
          "id": "evidence:treaty-voucher",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "frontier-records:transit-guarantee",
          "finding": "The frontier commissioner has been extorting strategic sluice data from Serekh refugees under threat of detention.",
          "verified": true,
          "witnessId": null
        },
        {
          "id": "evidence:garrison-intercept",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "garrison-dispatch:unregistered-foreigners",
          "finding": "Bronze Standard officers prepared arbitrary arrest lists targeting eastern artisans in the Silt Stair district.",
          "verified": true,
          "witnessId": null
        }
      ],
      "witnessProtections": [
        {
          "id": "protection:hazren-an-seket",
          "witnessId": "person:hazren-an-seket",
          "kind": "safe-conduct",
          "guarantorId": "institution:reeves-court",
          "commitments": [
            "Issue stamped neutral road vouchers",
            "Exempt the family from garrison interrogation at Lock Foot"
          ],
          "secured": true
        }
      ],
      "firstEncounter": {
        "speaker": "Commissioner Dorel Kes",
        "location": "Z03 Lock Foot Customs Post",
        "context": "You approach the frontier commissioner to secure safe passage for Aunt Hazren and her two children across the canal barrier.",
        "initialNpcDialogue": "The road east is closed to foreigners unless they carry a pass stamped by the garrison. If you want transit for three unmanifested Serekh civilians, tell me how the sluice gates are secured at Sekhet Anar.",
        "progressiveDisclosureReview": {
          "immediateObjective": "Secure legal transit vouchers for Aunt Hazren and two children across the Silt Stair lock.",
          "nextAction": "Confront Commissioner Dorel and cite clause 9 of the 612 AC Frontier Concordat to secure passes without giving military intelligence.",
          "whoBenefits": "Your family members, who can travel safely without detention.",
          "costOrRisk": "Refusing to provide water secrets risks the commissioner branding your family as hostile spies.",
          "doesDeadPersonReturn": "No. Relatives who died in the flight stay dead; transit papers protect the living."
        }
      },
      "loreAccessibility": {
        "prohibitedJargonChecked": true,
        "intelligentNotGeniusReadingLevel": true,
        "readingLevelNotes": "Focuses on transit papers, lock gates, civilian children, and treaty rights. Avoids foreign geopolitical treatises."
      },
      "playerFacingWordCount": 288
    },
    "hedge-binder": {
      "version": 1,
      "id": "origin-recipe:hedge-binder",
      "originId": "hedge-binder",
      "family": "touched",
      "providerId": "authored-origin-recipe",
      "providerVersion": "1",
      "seed": "origin-hedge-binder-v1",
      "license": "Project-authored deterministic origin content recipe",
      "recipeOrigin": "Agent-executed D02.4 origin writing lane",
      "sources": [
        {
          "document": "VISION.md",
          "section": "Non-negotiables"
        },
        {
          "document": "docs/design.md",
          "section": "Lore accessibility (Waseem, 13 Sep — world bible approved)"
        },
        {
          "document": "docs/world/04-zones.md",
          "section": "Eight starting-background hooks"
        },
        {
          "document": "docs/plan/03-content-plan.md",
          "section": "Origins — exact hooks, bounded continuation"
        },
        {
          "document": "docs/world/09-naming-and-tone.md",
          "section": "People by cultural naming tradition"
        }
      ],
      "capsuleId": "capsule:origin:hedge-binder",
      "capsuleKind": "origin",
      "title": "The Distilled Threshold",
      "bibleHook": {
        "openingGoal": "Clear a mentor's name or, if already dead, secure an honest finding about their work.",
        "complication": "The relevant safe ritual shares reagents with corpse-work; practical knowledge can distinguish the process.",
        "nonCombatLeverage": "Practical ritual chemical formula knowledge distinguishes lawful Kept Warmth and Narrow Threshold from illicit necromantic binding salts.",
        "guardrail": "Shared reagents are not proof of corpse-work. A deceased mentor stays dead after exoneration."
      },
      "sourceBoundRelative": {
        "roleId": "role:hedge-binder:mentor",
        "relationKind": "mentor",
        "preferredPersonId": "person:corren-vel",
        "preferredName": "Corren Vel",
        "culture": "Orsene",
        "identifyingHistory": "Elder hedge binder accused of supplying embalming vitriol to illicit corpse-operators.",
        "deadAlternativeKind": "revised-goal",
        "deadAlternativeSummary": "Secure an honest finding clearing your deceased mentor's workshop records and burial registry from the charge of corpse-work."
      },
      "sourceBoundItems": [
        {
          "id": "item:corren-formula-notebook",
          "name": "Corren's workshop notebook of mineral washes",
          "kind": "tool",
          "provenanceKey": "hedge-workshop:corren-formulas",
          "description": "Hand-stitched paper notebook detailing the proportions of bay salt, alum, and calcined lime used in lawful threshold preservation."
        },
        {
          "id": "item:purified-calcined-lime",
          "name": "Sample jar of purified alkaline wash",
          "kind": "quest-right",
          "provenanceKey": "corren-stock:lawful-wash-sample",
          "description": "A sealed earthenware pot containing non-reactive mineral wash prepared for treating fever sores and cooling dead skin."
        }
      ],
      "personalGoal": {
        "id": "goal:hedge-binder-exoneration",
        "personId": "person:pc",
        "description": "Clear Corren Vel's name before the Reeve by proving his seized reagents were prepared for lawful threshold maintenance, not corpse-binding.",
        "prerequisites": {
          "all": [
            "arrived:silt-stair"
          ],
          "any": [],
          "none": []
        }
      },
      "outcomes": [
        {
          "goalId": "goal:hedge-binder-exoneration",
          "status": "achieved",
          "summary": "You demonstrate the chemical distillation before Melian and the court, securing an official acquittal of sacrilege for Corren Vel.",
          "effects": {
            "add": [
              "corren:exonerated",
              "lawful-binding:defended"
            ],
            "remove": [
              "corren:accused-of-necromancy"
            ]
          }
        },
        {
          "goalId": "goal:hedge-binder-exoneration",
          "status": "compromised",
          "summary": "Corren is cleared of necromancy but his shop stock is forfeited to the municipal apothecary for practicing without an imperial license.",
          "effects": {
            "add": [
              "corren:cleared-unlicensed",
              "workshop-stock:forfeited"
            ],
            "remove": [
              "corren:accused-of-necromancy"
            ]
          }
        },
        {
          "goalId": "goal:hedge-binder-exoneration",
          "status": "failed",
          "summary": "The court declares all hedge binding suspect and orders the workshop burned, branding Corren a condemned corpse-worker.",
          "effects": {
            "add": [
              "corren:condemned",
              "workshop:destroyed"
            ],
            "remove": [
              "corren:accused-of-necromancy"
            ]
          }
        },
        {
          "goalId": "goal:hedge-binder-exoneration",
          "status": "abandoned",
          "summary": "Fearing the Reeve's bailiffs, you pack Corren's notebooks and leave the Silt Stair, letting the false accusations stand.",
          "effects": {
            "add": [
              "exoneration:abandoned-unresolved"
            ],
            "remove": []
          }
        }
      ],
      "questRoles": [
        {
          "id": "role:hedge-binder:mentor",
          "role": "origin-relative",
          "zone": "Z03",
          "preferredPersonId": "person:corren-vel",
          "alternatives": [
            {
              "kind": "revised-goal",
              "goalId": "goal:hedge-binder-honest-finding",
              "summary": "Secure an honest finding clearing your deceased mentor's workshop records and burial registry from the charge of corpse-work.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "person",
              "personId": "person:melian-sar",
              "identifyingHistory": "Licensed practitioner at the cold baths who understands lawful rites.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "evidence",
              "evidenceId": "evidence:corren-assay",
              "prerequisites": {
                "all": [
                  "found:corren-assay"
                ],
                "any": [],
                "none": []
              }
            }
          ]
        }
      ],
      "questNodes": [
        {
          "id": "node:hedge-binder:inspect-seized-jars",
          "label": "Inspect the seized reagent jars at Melian's dispensary",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "jars:inspected"
            ]
          },
          "effects": {
            "add": [
              "jars:inspected"
            ],
            "remove": []
          }
        },
        {
          "id": "node:hedge-binder:demonstrate-wash",
          "label": "Demonstrate lawful reagent distillation to the licensed practitioner",
          "prerequisites": {
            "all": [
              "jars:inspected"
            ],
            "any": [
              "melian:distinction-recognized"
            ],
            "none": [
              "corren:demonstrated-innocent"
            ]
          },
          "effects": {
            "add": [
              "corren:demonstrated-innocent",
              "found:corren-assay"
            ],
            "remove": []
          }
        }
      ],
      "dialogueOptions": [
        {
          "id": "opt:hedge-binder:request-inspection",
          "intention": {
            "kind": "ask",
            "label": "Ask Melian Sar to inspect the confiscated jars"
          },
          "text": "The bailiffs seized three jars of mineral salt from Corren Vel's shop and claimed they were bought for the kilns. You are licensed by the court; look at the salt.",
          "disclosure": "essential",
          "firstEncounterSummary": "Ask Melian Sar to inspect your mentor's confiscated reagent jars.",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "melian:jars-requested"
            ]
          },
          "effects": {
            "add": [
              "melian:jars-requested",
              "jars:presented-on-bench"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:hedge-binder:leverage-chemical-assay",
          "intention": {
            "kind": "offer",
            "label": "Demonstrate the alkaline wash distinction"
          },
          "text": "Corren used bay salt and washed chalk to prepare the Narrow Threshold. It stops rot without stiffening muscle. Smell the sulfur in Tavren Noll's kiln jars: that is calcined vitriol and antimony, used to tether nerve tissue. They share raw minerals, but the distillation is completely distinct.",
          "disclosure": "essential",
          "firstEncounterSummary": "Use practical ritual knowledge to prove your mentor's reagents are safe and lawful.",
          "prerequisites": {
            "all": [
              "jars:presented-on-bench"
            ],
            "any": [],
            "none": [
              "melian:distinction-recognized"
            ]
          },
          "effects": {
            "add": [
              "melian:distinction-recognized",
              "leverage:chemical-distinction-proved"
            ],
            "remove": []
          },
          "requiredIncentives": [
            "knowledge:reagent-distillation"
          ],
          "requiredProtections": [],
          "socialDifficulty": 2
        },
        {
          "id": "opt:hedge-binder:warn-false-witch-hunt",
          "intention": {
            "kind": "warn",
            "label": "Warn of indiscriminate persecution against all binders"
          },
          "text": "If you let the Reeve brand every herbal binder as a corpse-worker, the townspeople will tear down your dispensary next when the fever returns.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "leverage:chemical-distinction-proved"
            ],
            "any": [],
            "none": [
              "melian:committed-to-testify"
            ]
          },
          "effects": {
            "add": [
              "melian:committed-to-testify"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": 3
        },
        {
          "id": "opt:hedge-binder:deep-ritual-origins",
          "intention": {
            "kind": "ask",
            "label": "Ask why lawful rites share ingredients with corpse-work"
          },
          "text": "Why do both lawful preservation and the kiln tethers rely on brine and alum? Did the ancient binders discover corpse-work by accident while trying to comfort the dying?",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "melian:committed-to-testify"
            ],
            "any": [],
            "none": [
              "lore:shared-reagent-history"
            ]
          },
          "effects": {
            "add": [
              "lore:shared-reagent-history"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:hedge-binder:leave-dispensary",
          "intention": {
            "kind": "leave",
            "label": "Step outside into the bath court"
          },
          "text": "I will leave Corren's notebook with you while you prepare the test reagents.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "effects": {
            "add": [
              "pc:in-bath-court"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "evidence": [
        {
          "id": "evidence:corren-assay",
          "caseId": "case:unburied",
          "kind": "lawful-demonstration",
          "sourceKey": "chemical-demonstration:corren-salts",
          "finding": "Corren Vel's seized jars contain washed chalk and bay salt for fever relief, completely lacking the vitriol required for necromantic tethers.",
          "verified": true,
          "witnessId": null
        },
        {
          "id": "evidence:seizure-inventory",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "bailiff-inventory:corren-shop",
          "finding": "The bailiff recorded common tanning alum as prohibited necromantic reagent to inflate seizure bounties.",
          "verified": true,
          "witnessId": null
        }
      ],
      "witnessProtections": [
        {
          "id": "protection:corren-vel",
          "witnessId": "person:corren-vel",
          "kind": "public-custody",
          "guarantorId": "institution:reeves-court",
          "commitments": [
            "Suspend sacrilege proceedings during chemical verification",
            "Protect Corren's shop from mob seizure"
          ],
          "secured": true
        }
      ],
      "firstEncounter": {
        "speaker": "Practitioner Melian Sar",
        "location": "Z03 Cold Bath Dispensary",
        "context": "You arrive at Melian's dispensary to clear Corren Vel from the charge of supplying necromancers with binding salts.",
        "initialNpcDialogue": "The bailiffs brought three crates of mineral wash from Corren Vel's workroom. People on the street smell sulfur and call it necromancy. If you cannot prove otherwise, the court will burn his books tomorrow.",
        "progressiveDisclosureReview": {
          "immediateObjective": "Examine the confiscated mineral jars and clear Corren Vel of participating in corpse-work.",
          "nextAction": "Demonstrate the chemical distinction between safe threshold washes and necromantic binding salts to Melian Sar.",
          "whoBenefits": "Your mentor Corren Vel (or his posthumous memory) and ordinary binders who face mob violence.",
          "costOrRisk": "Proving your technical expertise in ritual chemistry invites scrutiny from bailiffs hunting for unlicensed practitioners.",
          "doesDeadPersonReturn": "No. A deceased mentor stays dead after exoneration; clearing their name cleanses their public record, not their breathing."
        }
      },
      "loreAccessibility": {
        "prohibitedJargonChecked": true,
        "intelligentNotGeniusReadingLevel": true,
        "readingLevelNotes": "Focuses on jars, chalk, sulfur, fevers, and bailiffs. Avoids high-fantasy magic explanations."
      },
      "playerFacingWordCount": 332
    },
    "grave-witness": {
      "version": 1,
      "id": "origin-recipe:grave-witness",
      "originId": "grave-witness",
      "family": "touched",
      "providerId": "authored-origin-recipe",
      "providerVersion": "1",
      "seed": "origin-grave-witness-v1",
      "license": "Project-authored deterministic origin content recipe",
      "recipeOrigin": "Agent-executed D02.4 origin writing lane",
      "sources": [
        {
          "document": "VISION.md",
          "section": "Non-negotiables"
        },
        {
          "document": "docs/design.md",
          "section": "Lore accessibility (Waseem, 13 Sep — world bible approved)"
        },
        {
          "document": "docs/world/04-zones.md",
          "section": "Eight starting-background hooks"
        },
        {
          "document": "docs/plan/03-content-plan.md",
          "section": "Origins — exact hooks, bounded continuation"
        },
        {
          "document": "docs/world/09-naming-and-tone.md",
          "section": "People by cultural naming tradition"
        }
      ],
      "capsuleId": "capsule:origin:grave-witness",
      "capsuleKind": "origin",
      "title": "The Empty Alcove",
      "bibleHook": {
        "openingGoal": "Discover what happened to a sibling's paid burial.",
        "complication": "The player knows a bodily gesture but must not confuse it with proof of a returned soul.",
        "nonCombatLeverage": "Intimate knowledge of funerary records, burial tokens, and recognizing bodily mechanical habits without false spiritual belief.",
        "guardrail": "Recognition of a bodily habit does not certify returned consciousness."
      },
      "sourceBoundRelative": {
        "roleId": "role:grave-witness:deceased-sibling",
        "relationKind": "deceased-sibling",
        "preferredPersonId": "person:theron-an",
        "preferredName": "Theron An",
        "culture": "Orsene",
        "identifyingHistory": "Deceased sibling whose paid burial niche in the upper columbarium was found swept empty.",
        "deadAlternativeKind": "revised-goal",
        "deadAlternativeSummary": "Recover Theron's stolen brass burial plate from the concession factor and dedicate an unseated memorial stone at the Near Table shrine."
      },
      "sourceBoundItems": [
        {
          "id": "item:terracotta-burial-token",
          "name": "Stamped terracotta burial token",
          "kind": "quest-right",
          "provenanceKey": "cemetery-registry:theron-paid-burial",
          "description": "A stamped clay receipt certifying three ves paid for Theron An's internment in alcove 12 of the upper columbarium."
        },
        {
          "id": "item:sibling-carved-clasp",
          "name": "Hand-notched bone cloak clasp",
          "kind": "tool",
          "provenanceKey": "theron-possessions:carved-clasp",
          "description": "A bone clasp notched by your brother's left hand, carried as proof of kinship."
        }
      ],
      "personalGoal": {
        "id": "goal:grave-witness-sibling",
        "personId": "person:pc",
        "description": "Discover what happened to your brother Theron's body after your family paid three ves, old silver at twelve cuts to the ves, for his permanent burial in the columbarium.",
        "prerequisites": {
          "all": [
            "arrived:silt-stair"
          ],
          "any": [],
          "none": []
        }
      },
      "outcomes": [
        {
          "goalId": "goal:grave-witness-sibling",
          "status": "achieved",
          "summary": "You locate Theron's remains in the cooling court, release the tether with Melian's aid, and give his flesh a quiet, lawful resting place.",
          "effects": {
            "add": [
              "theron-remains:recovered",
              "honest-burial:completed"
            ],
            "remove": [
              "burial-theft:unresolved"
            ]
          }
        },
        {
          "goalId": "goal:grave-witness-sibling",
          "status": "compromised",
          "summary": "You recover Theron's stolen burial plate and force the concession to refund the three ves, though his physical remains were consumed in the kilns.",
          "effects": {
            "add": [
              "burial-fee:refunded",
              "memorial-stone:dedicated"
            ],
            "remove": [
              "burial-theft:unresolved"
            ]
          }
        },
        {
          "goalId": "goal:grave-witness-sibling",
          "status": "failed",
          "summary": "The mortuary concession claims the empty alcove was a record error and bars you from entering the columbarium under threat of arrest.",
          "effects": {
            "add": [
              "cemetery:barred",
              "burial-truth:buried"
            ],
            "remove": [
              "burial-theft:unresolved"
            ]
          }
        },
        {
          "goalId": "goal:grave-witness-sibling",
          "status": "abandoned",
          "summary": "Sickened by the sight of repetitive bodily motions in the lower court, you flee the Silt Stair without retrieving your sibling's remains.",
          "effects": {
            "add": [
              "burial-quest:abandoned"
            ],
            "remove": []
          }
        }
      ],
      "questRoles": [
        {
          "id": "role:grave-witness:deceased-sibling",
          "role": "origin-relative",
          "zone": "Z03",
          "preferredPersonId": "person:theron-an",
          "alternatives": [
            {
              "kind": "revised-goal",
              "goalId": "goal:grave-witness-memorial",
              "summary": "Recover Theron's stolen brass burial plate from the concession factor and dedicate an unseated memorial stone at the Near Table shrine.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "person",
              "personId": "person:attendant-senn",
              "identifyingHistory": "Columbarium attendant who oversaw the transfer of corpses.",
              "prerequisites": {
                "all": [],
                "any": [],
                "none": []
              }
            },
            {
              "kind": "evidence",
              "evidenceId": "evidence:theron-burial-chit",
              "prerequisites": {
                "all": [
                  "found:theron-burial-chit"
                ],
                "any": [],
                "none": []
              }
            }
          ]
        }
      ],
      "questNodes": [
        {
          "id": "node:grave-witness:inspect-alcove",
          "label": "Inspect alcove 12 in the upper columbarium",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "alcove:inspected"
            ]
          },
          "effects": {
            "add": [
              "alcove:inspected"
            ],
            "remove": []
          }
        },
        {
          "id": "node:grave-witness:confront-attendant",
          "label": "Confront Attendant Senn with the fraudulent niche ledger",
          "prerequisites": {
            "all": [
              "alcove:inspected"
            ],
            "any": [
              "senn:confessed-ledger-mismatch"
            ],
            "none": [
              "theft:confirmed"
            ]
          },
          "effects": {
            "add": [
              "theft:confirmed",
              "found:theron-burial-chit"
            ],
            "remove": []
          }
        }
      ],
      "dialogueOptions": [
        {
          "id": "opt:grave-witness:show-receipt",
          "intention": {
            "kind": "ask",
            "label": "Show the terracotta burial chit for alcove 12"
          },
          "text": "Here is the stamped clay chit. Three ves paid to the Reeve's court for Theron An. Alcove 12 is swept clean and the bronze nameplate is gone. Where is my brother?",
          "disclosure": "essential",
          "firstEncounterSummary": "Confront Columbarium Attendant Senn with your family's paid burial receipt.",
          "prerequisites": {
            "all": [
              "arrived:silt-stair"
            ],
            "any": [],
            "none": [
              "senn:receipt-shown"
            ]
          },
          "effects": {
            "add": [
              "senn:receipt-shown",
              "alcove-theft:questioned"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:grave-witness:leverage-gesture-and-tally",
          "intention": {
            "kind": "offer",
            "label": "Point out the ink mismatch on the registry roll"
          },
          "text": "The ink marking alcove 12 as 'reassigned' is fresh soot from this morning, but your fee register claims he was buried a month ago. Down in the cooling court, a porter with his build was tapping his left thumb against his thigh — Theron's nervous habit when carrying weight. That is not his soul returning; it is his stolen body being worked to death a second time. Give me the transfer sheet.",
          "disclosure": "essential",
          "firstEncounterSummary": "Use ledger discrepancies and recognition of physical habit to expose the body theft.",
          "prerequisites": {
            "all": [
              "alcove-theft:questioned"
            ],
            "any": [],
            "none": [
              "senn:confessed-ledger-mismatch"
            ]
          },
          "effects": {
            "add": [
              "senn:confessed-ledger-mismatch",
              "leverage:funerary-theft-exposed"
            ],
            "remove": []
          },
          "requiredIncentives": [
            "knowledge:cemetery-ledger-forgery"
          ],
          "requiredProtections": [],
          "socialDifficulty": 2
        },
        {
          "id": "opt:grave-witness:warn-desecration",
          "intention": {
            "kind": "warn",
            "label": "Warn of Near Table and Bench sacrilege trials"
          },
          "text": "If the families who buried their kin here learn that Tavren Noll sells the corpses to fuel canal kilns, this cemetery will be torn apart stone by stone.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "leverage:funerary-theft-exposed"
            ],
            "any": [],
            "none": [
              "senn:frightened-by-exposure"
            ]
          },
          "effects": {
            "add": [
              "senn:frightened-by-exposure"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": 3
        },
        {
          "id": "opt:grave-witness:deep-bodily-reflex",
          "intention": {
            "kind": "ask",
            "label": "Ask how the kilns preserve physical gestures"
          },
          "text": "Why does the body remember its living motion after death? If the soul departs with the breath, what power keeps a dead hand tapping at the bone?",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "senn:frightened-by-exposure"
            ],
            "any": [],
            "none": [
              "lore:corpse-reflex-nature"
            ]
          },
          "effects": {
            "add": [
              "lore:corpse-reflex-nature"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "opt:grave-witness:leave-columbarium",
          "intention": {
            "kind": "leave",
            "label": "Step down the columbarium steps"
          },
          "text": "I am going down to the cooling court. Do not wipe that ledger before the magistrate sees it.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [],
            "any": [],
            "none": []
          },
          "effects": {
            "add": [
              "pc:descending-to-cooling-court"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "evidence": [
        {
          "id": "evidence:theron-burial-chit",
          "caseId": "case:unburied",
          "kind": "document",
          "sourceKey": "cemetery-ledger:stolen-niche-12",
          "finding": "The cemetery ledger shows alcove 12 was fraudulently relabeled to conceal the transfer of Theron An's body to the kilns.",
          "verified": true,
          "witnessId": null
        },
        {
          "id": "evidence:stolen-plate-salvage",
          "caseId": "case:unburied",
          "kind": "physical-remains",
          "sourceKey": "concession-salvage:burial-plates",
          "finding": "Theron An's stamped bronze funerary plate was discovered in Tavren Noll's metal salvage crate.",
          "verified": true,
          "witnessId": null
        }
      ],
      "witnessProtections": [
        {
          "id": "protection:attendant-senn",
          "witnessId": "person:attendant-senn",
          "kind": "safe-conduct",
          "guarantorId": "institution:reeves-court",
          "commitments": [
            "Shield Senn from concession retribution for turning over the transfer sheet"
          ],
          "secured": true
        }
      ],
      "firstEncounter": {
        "speaker": "Attendant Senn",
        "location": "Z03 Upper Columbarium",
        "context": "You arrive at the columbarium with your family's paid burial receipt to find your brother's stone niche empty.",
        "initialNpcDialogue": "The upper alcoves are private consecrated grounds. If you have an inquiry about a family burial, the records clerk handles complaints on market mornings. Do not touch the niches.",
        "progressiveDisclosureReview": {
          "immediateObjective": "Confront Attendant Senn and discover why your brother Theron's paid burial niche is empty.",
          "nextAction": "Present your terracotta burial chit and confront Senn with the fresh ink erasure on the alcove ledger.",
          "whoBenefits": "Your family and your deceased sibling, whose body was stolen by the mortuary concession.",
          "costOrRisk": "Investigating the body theft brings you into direct conflict with Tavren Noll's operators at the Quiet Kilns.",
          "doesDeadPersonReturn": "No. Recognizing a bodily gesture in an animated corpse is mechanical nerve memory, never a returned soul."
        }
      },
      "loreAccessibility": {
        "prohibitedJargonChecked": true,
        "intelligentNotGeniusReadingLevel": true,
        "readingLevelNotes": "Grounds the emotional conflict in clay tokens, bronze plates, ink erasures, and cemetery niches. Firmly rejects spiritual revival."
      },
      "playerFacingWordCount": 384
    }
  },
  "companions": {
    "reference": [
      {
        "candidateKey": "former-mortuary-guard-ossa-dareth",
        "templateId": "former-mortuary-guard",
        "templateTitle": "The Former Mortuary Guard",
        "archetype": "A funerary escort who left the concession after a disturbing incident in the Quiet Kilns. Uses a shield and short spear, recognises burial practices, and refuses corpse desecration.",
        "culture": "Veyrathi",
        "name": "Ossa Dareth",
        "equipment": [
          "item:shield-round",
          "item:spear-bronze",
          "item:gambeson",
          "item:oil-flask"
        ],
        "person": {
          "id": "person:companion-former-mortuary-guard-ossa-dareth",
          "lineageKey": "lineage:former-mortuary-guard-ossa-dareth",
          "presentationKey": "presentation:actor-mortuary-guard-rotation",
          "kinshipKeys": [
            "kinship:former-mortuary-guard-ossa-dareth-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Ossa Dareth",
            "origin": "disgraced-legionary",
            "culture": "Veyrathi",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "funerary-vigil",
              "spear-drill"
            ],
            "abilities": [
              "thrust",
              "set-spear"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 9,
            "maxHp": 9,
            "allegiances": [],
            "oaths": [
              "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Conserve strength",
              "Protect the party"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Veyrathi customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-former-mortuary-guard-ossa-dareth",
          "temperament": {
            "boldness": 1,
            "loyalty": 9
          },
          "obligations": [
            {
              "id": "obligation:former-mortuary-guard-burial-sanctity-former-mortuary-guard-ossa-dareth",
              "description": "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "That was a person. I will not put iron into someone who cannot refuse it. Find another way past."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:former-mortuary-guard-refuse-unlawful-desecration-former-mortuary-guard-ossa-dareth",
              "kind": "non-negotiable-topic",
              "topic": "withdraw"
            }
          ],
          "preferences": {
            "engage": 0,
            "guard": 8,
            "hold": 8,
            "withdraw": 9
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:former-mortuary-guard-former-mortuary-guard-ossa-dareth",
          "personId": "person:companion-former-mortuary-guard-ossa-dareth",
          "description": "Recover stolen corpse records and secure honest burial in salted earth for the desecrated kiln remains.",
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-ossa-dareth"
            ],
            "any": [],
            "none": [
              "departed:former-mortuary-guard-ossa-dareth"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:former-mortuary-guard-former-mortuary-guard-ossa-dareth",
            "status": "achieved",
            "summary": "Recovered three stolen corpses from the cooling gallery and saw them properly interred in salted earth.",
            "effects": {
              "add": [
                "obligation-resolved:former-mortuary-guard-ossa-dareth",
                "loyalty-proven:former-mortuary-guard-ossa-dareth"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:former-mortuary-guard-former-mortuary-guard-ossa-dareth",
            "status": "compromised",
            "summary": "Allowed an unverified binder to perform a diagnostic inspection only under direct, armed supervision.",
            "effects": {
              "add": [
                "obligation-compromised:former-mortuary-guard-ossa-dareth"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:former-mortuary-guard-former-mortuary-guard-ossa-dareth",
            "status": "abandoned",
            "summary": "Severed ties after the player attempted to harvest limbs or bones for necromantic reagents.",
            "effects": {
              "add": [
                "departed:former-mortuary-guard-ossa-dareth"
              ],
              "remove": [
                "companion-active:former-mortuary-guard-ossa-dareth"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-former-mortuary-guard-ossa-dareth",
            "intention": {
              "kind": "ask",
              "label": "Speak with Ossa Dareth (The Former Mortuary Guard)"
            },
            "text": "I kept the night watch at the mortuary gate for six years and said the names over every cart. Then the coffins started going in light. I have not stopped saying the names.",
            "disclosure": "essential",
            "firstEncounterSummary": "Hire a grim former necropolis watchman who demands strict reverence for the dead and physical proof of claims.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:former-mortuary-guard-ossa-dareth",
                "rejected:former-mortuary-guard-ossa-dareth",
                "dead:former-mortuary-guard-ossa-dareth"
              ]
            },
            "effects": {
              "add": [
                "met:former-mortuary-guard-ossa-dareth"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-former-mortuary-guard-ossa-dareth",
            "intention": {
              "kind": "offer",
              "label": "Pledge reverence to the mortuary vaults and pay fourteen cuts"
            },
            "text": "Twelve cuts, and a promise. The dead are not freight. Remember that, and my spear is yours to the kilns and back.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Ossa Dareth.",
            "prerequisites": {
              "all": [
                "met:former-mortuary-guard-ossa-dareth"
              ],
              "any": [],
              "none": [
                "hired:former-mortuary-guard-ossa-dareth",
                "dead:former-mortuary-guard-ossa-dareth"
              ]
            },
            "effects": {
              "add": [
                "hired:former-mortuary-guard-ossa-dareth",
                "companion-active:former-mortuary-guard-ossa-dareth"
              ],
              "remove": [
                "available:former-mortuary-guard-ossa-dareth"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "covenant:no-desecration"
            ],
            "socialDifficulty": 3
          },
          {
            "id": "dialogue:approach-engage-former-mortuary-guard-ossa-dareth",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "No. Not in a burial place. I do not hunt men across graves.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-ossa-dareth"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-ossa-dareth",
                "departed:former-mortuary-guard-ossa-dareth"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:former-mortuary-guard-ossa-dareth"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-former-mortuary-guard-ossa-dareth",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "I will stand at your shoulder, as I stood at the gate. Nothing passes.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-ossa-dareth"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-ossa-dareth",
                "departed:former-mortuary-guard-ossa-dareth"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:former-mortuary-guard-ossa-dareth"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-former-mortuary-guard-ossa-dareth",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "Agreed. We cannot carry anyone if we are carried ourselves.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-ossa-dareth"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-ossa-dareth",
                "departed:former-mortuary-guard-ossa-dareth"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:former-mortuary-guard-ossa-dareth"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-former-mortuary-guard-ossa-dareth",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "You have the grooves copied. If the anchor can be undone without breaking him, do it now. His family should not wait for a vote.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-ossa-dareth"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-ossa-dareth"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:former-mortuary-guard-ossa-dareth"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-former-mortuary-guard-ossa-dareth",
            "intention": {
              "kind": "leave",
              "label": "Ossa Dareth departs over contract violation"
            },
            "text": "You bought them more wax. I will guard a body. I will not guard your right to use one. We are done.",
            "disclosure": "essential",
            "firstEncounterSummary": "Ossa Dareth leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-ossa-dareth",
                "boundary-breached:former-mortuary-guard-ossa-dareth"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-ossa-dareth",
                "departed:former-mortuary-guard-ossa-dareth"
              ]
            },
            "effects": {
              "add": [
                "departed:former-mortuary-guard-ossa-dareth"
              ],
              "remove": [
                "companion-active:former-mortuary-guard-ossa-dareth"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-former-mortuary-guard-ossa-dareth",
          "name": "Ossa Dareth",
          "templateId": "former-mortuary-guard",
          "memorialNote": "A bronze shield bearing the faint silhouette of a laurel wreath, tarnished by tomb smoke. Beside it sits a small clay flask of holding salt and an unlit bronze lamp.",
          "campNotice": "The guard's spear is driven upright into the loam. A small pinch of salt has been scattered across the mound.",
          "witnessReaction": "She stood between the animated corpses and the altar until her spear snapped. She died keeping the threshold clean."
        },
        "absenceResponse": {
          "companionId": "person:companion-former-mortuary-guard-ossa-dareth",
          "name": "Ossa Dareth",
          "templateId": "former-mortuary-guard",
          "reason": "Boundary violated: desecration of burial remains or unproven necromantic practice.",
          "departureLine": "You bought them more wax. I will guard a body. I will not guard your right to use one. We are done.",
          "campNotice": "A consecrated funeral tile left standing at the entrance to the abandoned gallery."
        },
        "voice": {
          "voiceId": "guard-vigil",
          "care": {
            "offered": "A {item} for the living. Thank you. We must remember them as well.",
            "treat": "The watch can wait a moment. I mean to keep it longer.",
            "remember": "{giver} gave me supplies from their own keeping. I speak of that when I say their name.",
            "aid": "The fighting is ended. Sit with me; this wound still needs tending.",
            "rememberAid": "I tended {patient} while I still could. I remember the living as well as the names of the dead."
          },
          "manner": "Solemn and liturgical; slow; speaks of the watch and the names; cautious, very loyal.",
          "temperament": {
            "boldness": 1,
            "loyalty": 9
          },
          "obligation": "Stood six years at the mortuary gate. Will see the stolen dead named and carried home.",
          "opening": "I kept the night watch at the mortuary gate for six years and said the names over every cart. Then the coffins started going in light. I have not stopped saying the names.",
          "hire": "Twelve cuts, and a promise. The dead are not freight. Remember that, and my spear is yours to the kilns and back.",
          "hired": "I walk with you, and I keep saying the names. Tell me when we are near the dead.",
          "refusal": "That was a person. I will not put iron into someone who cannot refuse it. Find another way past.",
          "afterFight": {
            "guard": "Close his eyes. Whatever he guarded, he was a man, and he gets the same rite as the rest. Then we go on.",
            "tunnel": "Rest. There is nothing left to stoke. I will say the name when we learn it."
          },
          "moment": {
            "request": "You have the grooves copied. If the anchor can be undone without breaking him, do it now. His family should not wait for a vote.",
            "kept": "He can be carried. That is all the rite asks. The rest is only words, and I have plenty.",
            "broken": "You bought them more wax. I will guard a body. I will not guard your right to use one. We are done."
          },
          "judgment": {
            "good": "Nine names read, nine bodies to carry. It is not a victory. It is the watch, done properly, for once.",
            "bad": "You let the fire take them, or you let the work go on. Either way, they cannot be named. I will say the rite without you.",
            "depart": "Go if you must. I stay with the dead until they are carried. That was always the watch.",
            "mourning": "I will stand the night watch over you, as I did the others. Your name goes on the list with theirs, spoken, not written."
          },
          "discuss": {
            "guard": {
              "accepted": "I will stand at your shoulder, as I stood at the gate. Nothing passes.",
              "refused": "My place is between the living and the dead. Today that is not beside you."
            },
            "engage": {
              "accepted": "If it is a living guard and he gives way, I will close the distance.",
              "refused": "No. Not in a burial place. I do not hunt men across graves."
            },
            "withdraw": {
              "accepted": "Agreed. We cannot carry anyone if we are carried ourselves.",
              "refused": "I do not leave the dead unwatched. Ask anything else of me."
            }
          },
          "barks": {
            "engage": "In the name of the watch.",
            "guard": "At your shoulder. Nothing passes.",
            "hold": "We hold, as the dead hold.",
            "withdraw": "Step back. The watch goes on.",
            "defend": "My watch is not ended. I will meet that blow."
          },
          "returning": {
            "kept": "I stood watch with the outsider before you. They carried the names home and lived to tell it. I say their name too, among the living.",
            "mourned": "I kept the night watch over the last outsider who hired me. Their name is on my list now. Tell me yours, so I know it when I need it.",
            "absent": "Keeping a vigil at the kiln gate and will not leave it. Told the porters no outsider is owed a spear again."
          }
        }
      },
      {
        "candidateKey": "displaced-mason-eshra-ul-anar",
        "templateId": "displaced-mason",
        "templateTitle": "The Displaced Mason",
        "archetype": "A quarry or public-works worker with militia experience, heavy tools, and a family dependent on wages. Understands structures and refuses to destroy infrastructure people need.",
        "culture": "Serekh",
        "name": "Eshra ul-Anar",
        "equipment": [
          "item:blade-iron",
          "item:knife-belt",
          "item:gambeson",
          "item:hook-sluicekeeper"
        ],
        "person": {
          "id": "person:companion-displaced-mason-eshra-ul-anar",
          "lineageKey": "lineage:displaced-mason-eshra-ul-anar",
          "presentationKey": "presentation:actor-outsider-axe-rotation",
          "kinshipKeys": [
            "kinship:displaced-mason-eshra-ul-anar-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Eshra ul-Anar",
            "origin": "escaped-worker",
            "culture": "Serekh",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "quarry-masonry",
              "structural-knowledge"
            ],
            "abilities": [
              "pry-pawl",
              "cleave"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 10,
            "maxHp": 10,
            "allegiances": [],
            "oaths": [
              "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Conserve strength",
              "Preserve independence"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Serekh customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-displaced-mason-eshra-ul-anar",
          "temperament": {
            "boldness": 5,
            "loyalty": 2
          },
          "obligations": [
            {
              "id": "obligation:displaced-mason-civil-infrastructure-displaced-mason-eshra-ul-anar",
              "description": "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "He is on Noll’s wage, same as I was on the quarry’s. I will not kill a worker over a quarrel between his betters."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:displaced-mason-refuse-reckless-charge-displaced-mason-eshra-ul-anar",
              "kind": "refuse-goal",
              "goal": "engage"
            }
          ],
          "preferences": {
            "engage": 6,
            "guard": 1,
            "hold": 6,
            "withdraw": 6
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:displaced-mason-displaced-mason-eshra-ul-anar",
          "personId": "person:companion-displaced-mason-eshra-ul-anar",
          "description": "Earn forty cuts and secure two sacks of flour for the dependents in the lower quarry barracks.",
          "prerequisites": {
            "all": [
              "hired:displaced-mason-eshra-ul-anar"
            ],
            "any": [],
            "none": [
              "departed:displaced-mason-eshra-ul-anar"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:displaced-mason-displaced-mason-eshra-ul-anar",
            "status": "achieved",
            "summary": "Delivered forty cuts and sixty pounds of clean flour to the quarry quarters, securing food through the season.",
            "effects": {
              "add": [
                "obligation-resolved:displaced-mason-eshra-ul-anar",
                "loyalty-proven:displaced-mason-eshra-ul-anar"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:displaced-mason-displaced-mason-eshra-ul-anar",
            "status": "compromised",
            "summary": "Accepted half-pay after refusing to collapse the canal arch, forcing the family onto quarter-rations.",
            "effects": {
              "add": [
                "obligation-compromised:displaced-mason-eshra-ul-anar"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:displaced-mason-displaced-mason-eshra-ul-anar",
            "status": "abandoned",
            "summary": "Walked away from the party after the player ordered the sluice gates smashed to flood the lower market.",
            "effects": {
              "add": [
                "departed:displaced-mason-eshra-ul-anar"
              ],
              "remove": [
                "companion-active:displaced-mason-eshra-ul-anar"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-displaced-mason-eshra-ul-anar",
            "intention": {
              "kind": "ask",
              "label": "Speak with Eshra ul-Anar (The Displaced Mason)"
            },
            "text": "Our crew built half this stair. The quarry killed six of us with a cheap prop and paid the widows in apologies. Ask me what the concession costs, and I will tell you who paid for it.",
            "disclosure": "essential",
            "firstEncounterSummary": "Recruit a muscular stoneworker fighting for family subsistence without compromising civic ethics.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:displaced-mason-eshra-ul-anar",
                "rejected:displaced-mason-eshra-ul-anar",
                "dead:displaced-mason-eshra-ul-anar"
              ]
            },
            "effects": {
              "add": [
                "met:displaced-mason-eshra-ul-anar"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-displaced-mason-eshra-ul-anar",
            "intention": {
              "kind": "offer",
              "label": "Guarantee twelve cuts and swear not to harm civil works"
            },
            "text": "Twelve cuts to the widows’ box, witnessed. I work for you, not for Noll, not for the Senate. The minute that changes, so do I.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Eshra ul-Anar.",
            "prerequisites": {
              "all": [
                "met:displaced-mason-eshra-ul-anar"
              ],
              "any": [],
              "none": [
                "hired:displaced-mason-eshra-ul-anar",
                "dead:displaced-mason-eshra-ul-anar"
              ]
            },
            "effects": {
              "add": [
                "hired:displaced-mason-eshra-ul-anar",
                "companion-active:displaced-mason-eshra-ul-anar"
              ],
              "remove": [
                "available:displaced-mason-eshra-ul-anar"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "guarantee:civil-infrastructure"
            ],
            "socialDifficulty": 3
          },
          {
            "id": "dialogue:approach-engage-displaced-mason-eshra-ul-anar",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "No. He is paid to stand there, same as me. I do not chase working men.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:displaced-mason-eshra-ul-anar"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-eshra-ul-anar",
                "departed:displaced-mason-eshra-ul-anar"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:displaced-mason-eshra-ul-anar"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-displaced-mason-eshra-ul-anar",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "I look after myself first. The crew taught me that too, the hard way.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:displaced-mason-eshra-ul-anar"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-eshra-ul-anar",
                "departed:displaced-mason-eshra-ul-anar"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:displaced-mason-eshra-ul-anar"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-displaced-mason-eshra-ul-anar",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "Good. No crew ever got a medal for staying under a falling roof.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:displaced-mason-eshra-ul-anar"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-eshra-ul-anar",
                "departed:displaced-mason-eshra-ul-anar"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:displaced-mason-eshra-ul-anar"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-displaced-mason-eshra-ul-anar",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "That walkway is a public work. Two cuts of timber keeps it. Lift the pawl for a toll box and you are doing the concession’s job for them.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:displaced-mason-eshra-ul-anar"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-eshra-ul-anar"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:displaced-mason-eshra-ul-anar"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-displaced-mason-eshra-ul-anar",
            "intention": {
              "kind": "leave",
              "label": "Eshra ul-Anar departs over contract violation"
            },
            "text": "You flooded a public way for a tin box of cuts. That is the quarry’s arithmetic. Find another back.",
            "disclosure": "essential",
            "firstEncounterSummary": "Eshra ul-Anar leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:displaced-mason-eshra-ul-anar",
                "boundary-breached:displaced-mason-eshra-ul-anar"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-eshra-ul-anar",
                "departed:displaced-mason-eshra-ul-anar"
              ]
            },
            "effects": {
              "add": [
                "departed:displaced-mason-eshra-ul-anar"
              ],
              "remove": [
                "companion-active:displaced-mason-eshra-ul-anar"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-displaced-mason-eshra-ul-anar",
          "name": "Eshra ul-Anar",
          "templateId": "displaced-mason",
          "memorialNote": "A heavy leather apron crusted with lime and dried sweat. In the pocket is a copper token stamped with the quarry union mark, worn flat by nervous thumbs.",
          "campNotice": "A pile of chipped cobblestones sits neatly stacked by the bedroll. The mason's place in the meal line is vacant.",
          "witnessReaction": "He braced the cracked lintel with his own shoulders while the rest of us scrambled out. When the stone dropped, he didn't scream."
        },
        "absenceResponse": {
          "companionId": "person:companion-displaced-mason-eshra-ul-anar",
          "name": "Eshra ul-Anar",
          "templateId": "displaced-mason",
          "reason": "Boundary violated: deliberate destruction of civilian canal infrastructure.",
          "departureLine": "You flooded a public way for a tin box of cuts. That is the quarry’s arithmetic. Find another back.",
          "campNotice": "A heavy stone mallet laid across an unmortared boundary stone."
        },
        "voice": {
          "voiceId": "mason-crew",
          "care": {
            "offered": "I will take the {item}. The contract never said we had to bleed for free.",
            "treat": "Cover the gap. I am keeping a worker alive.",
            "remember": "{giver} shared the medicine. Owners usually call our wounds a cost of doing business.",
            "aid": "Enough work for now. Sit down. The medicine is mine, and I say you need it.",
            "rememberAid": "I used my supplies on {patient}. Looking after each other was never a wage deduction."
          },
          "manner": "Sharp and political; speaks for 'the crew'; sardonic about owners; independent.",
          "temperament": {
            "boldness": 5,
            "loyalty": 2
          },
          "obligation": "Wages go to the widows of a crew the quarry buried. No breaking what workers built.",
          "opening": "Our crew built half this stair. The quarry killed six of us with a cheap prop and paid the widows in apologies. Ask me what the concession costs, and I will tell you who paid for it.",
          "hire": "Twelve cuts to the widows’ box, witnessed. I work for you, not for Noll, not for the Senate. The minute that changes, so do I.",
          "hired": "The crew’s money is in escrow and I am on your side of it. Ask me who built what we pass. I usually know.",
          "refusal": "He is on Noll’s wage, same as I was on the quarry’s. I will not kill a worker over a quarrel between his betters.",
          "afterFight": {
            "guard": "Paid by Noll, killed by you, buried by nobody. They will enter him as a loss against the concession and call it accounts.",
            "tunnel": "That was a worker before it was a stoker. Still on shift. Nobody ever lets us stop."
          },
          "moment": {
            "request": "That walkway is a public work. Two cuts of timber keeps it. Lift the pawl for a toll box and you are doing the concession’s job for them.",
            "kept": "Two cuts for timber. The walkway belongs to whoever crosses it. That is how it should be.",
            "broken": "You flooded a public way for a tin box of cuts. That is the quarry’s arithmetic. Find another back."
          },
          "judgment": {
            "good": "Wages paid, work standing, nobody owned at the end of it. Write that down; it does not happen often.",
            "bad": "You sided with the owners when it mattered. I have buried men for less. I am done here.",
            "depart": "Walking out before the account closes. Owners do that. I will stay and see it paid.",
            "mourning": "Another name for the wall. The widows’ box gets its twelve cuts. I will say you paid them fairly."
          },
          "discuss": {
            "guard": {
              "accepted": "Fine. We look after each other. That is the only rule the crew ever had.",
              "refused": "I look after myself first. The crew taught me that too, the hard way."
            },
            "engage": {
              "accepted": "If it is him or us, I pick us.",
              "refused": "No. He is paid to stand there, same as me. I do not chase working men."
            },
            "withdraw": {
              "accepted": "Good. No crew ever got a medal for staying under a falling roof.",
              "refused": "I will leave when I choose. I did not sell you my judgement."
            }
          },
          "barks": {
            "engage": "Him or us. Us.",
            "guard": "Close up. Crew rules.",
            "hold": "Stand. Make him come.",
            "withdraw": "Not dying for Noll’s floor.",
            "defend": "I have carried worse than your blade. Come on."
          },
          "returning": {
            "kept": "I worked for the last outsider. Paid fair, left the walkway standing, got out alive. That makes one. Let us see if you make two.",
            "mourned": "The last outsider who hired me is on the wall now, beside my crew. They paid fair. It did not save them.",
            "absent": "Took the widows’ box back to the quarry and stayed there. Said outsiders spend public works like pocket money."
          }
        }
      },
      {
        "candidateKey": "unpaid-shield-erenna-veld",
        "templateId": "unpaid-shield",
        "templateTitle": "The Unpaid Shield",
        "archetype": "A former professional infantry soldier seeking the release of a dependent from a service debt. Usually protects exposed allies, dislikes unnecessary chases, and refuses unpaid military duties.",
        "culture": "Veyrathi",
        "name": "Erenna Veld",
        "equipment": [
          "item:shield-round",
          "item:spear-bronze",
          "item:gambeson",
          "item:knife-belt"
        ],
        "person": {
          "id": "person:companion-unpaid-shield-erenna-veld",
          "lineageKey": "lineage:unpaid-shield-erenna-veld",
          "presentationKey": "presentation:actor-unpaid-shield-rotation",
          "kinshipKeys": [
            "kinship:unpaid-shield-erenna-veld-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Erenna Veld",
            "origin": "disgraced-legionary",
            "culture": "Veyrathi",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "shield-discipline",
              "spear-drill"
            ],
            "abilities": [
              "brace-drill"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 10,
            "maxHp": 10,
            "allegiances": [],
            "oaths": [
              "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Seize the initiative",
              "Preserve independence"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Veyrathi customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-unpaid-shield-erenna-veld",
          "temperament": {
            "boldness": 7,
            "loyalty": 3
          },
          "obligations": [
            {
              "id": "obligation:unpaid-shield-dependent-debt-unpaid-shield-erenna-veld",
              "description": "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "Charge on your own coin. Nobody pays me enough for that."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:unpaid-shield-danger-limit-unpaid-shield-erenna-veld",
              "kind": "danger-limit",
              "dangerLimit": 36
            }
          ],
          "preferences": {
            "engage": 6,
            "guard": 2,
            "hold": 4,
            "withdraw": 3
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:unpaid-shield-unpaid-shield-erenna-veld",
          "personId": "person:companion-unpaid-shield-erenna-veld",
          "description": "Secure 24 cuts to discharge the sister's labour bond from the concession registry.",
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-erenna-veld"
            ],
            "any": [],
            "none": [
              "departed:unpaid-shield-erenna-veld"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:unpaid-shield-unpaid-shield-erenna-veld",
            "status": "achieved",
            "summary": "Paid 24 cuts directly to the concession clerk, securing the stamped deed of release for his sister.",
            "effects": {
              "add": [
                "obligation-resolved:unpaid-shield-erenna-veld",
                "loyalty-proven:unpaid-shield-erenna-veld"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:unpaid-shield-unpaid-shield-erenna-veld",
            "status": "compromised",
            "summary": "Negotiated a half-term deferral with the Reeve in exchange for testimony against the concession bookkeeper.",
            "effects": {
              "add": [
                "obligation-compromised:unpaid-shield-erenna-veld"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:unpaid-shield-unpaid-shield-erenna-veld",
            "status": "abandoned",
            "summary": "Departed after the employer repeatedly refused to allocate contract shares towards the bond.",
            "effects": {
              "add": [
                "departed:unpaid-shield-erenna-veld"
              ],
              "remove": [
                "companion-active:unpaid-shield-erenna-veld"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-unpaid-shield-erenna-veld",
            "intention": {
              "kind": "ask",
              "label": "Speak with Erenna Veld (The Unpaid Shield)"
            },
            "text": "My father signed for army bread in a bad winter. Thirty years on, the depot says he still owes it. I fight for money. I do not fight for officers.",
            "disclosure": "essential",
            "firstEncounterSummary": "Hire an experienced shieldman working to clear a family labour debt.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:unpaid-shield-erenna-veld",
                "rejected:unpaid-shield-erenna-veld",
                "dead:unpaid-shield-erenna-veld"
              ]
            },
            "effects": {
              "add": [
                "met:unpaid-shield-erenna-veld"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-unpaid-shield-erenna-veld",
            "intention": {
              "kind": "offer",
              "label": "Agree to twelve-cut wage in escrow"
            },
            "text": "Done. You point, I decide. Nobody salutes. If the price is wrong, I tell you before the blades come out.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Erenna Veld.",
            "prerequisites": {
              "all": [
                "met:unpaid-shield-erenna-veld"
              ],
              "any": [],
              "none": [
                "hired:unpaid-shield-erenna-veld",
                "dead:unpaid-shield-erenna-veld"
              ]
            },
            "effects": {
              "add": [
                "hired:unpaid-shield-erenna-veld",
                "companion-active:unpaid-shield-erenna-veld"
              ],
              "remove": [
                "available:unpaid-shield-erenna-veld"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "escrow:guaranteed-wage"
            ],
            "socialDifficulty": 3
          },
          {
            "id": "dialogue:approach-engage-unpaid-shield-erenna-veld",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "No chase. A chase is how sergeants get buried and officers get medals.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-erenna-veld"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-erenna-veld",
                "departed:unpaid-shield-erenna-veld"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:unpaid-shield-erenna-veld"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-unpaid-shield-erenna-veld",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "No. I fight where the fight is, not wherever you happen to stand.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-erenna-veld"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-erenna-veld",
                "departed:unpaid-shield-erenna-veld"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:unpaid-shield-erenna-veld"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-unpaid-shield-erenna-veld",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "Good. Best order I have heard all year.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-erenna-veld"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-erenna-veld",
                "departed:unpaid-shield-erenna-veld"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:unpaid-shield-erenna-veld"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-unpaid-shield-erenna-veld",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "At the court there is a second toll on the stair. Get it struck. Officers love striking things when someone else did the reading.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-erenna-veld"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-erenna-veld"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:unpaid-shield-erenna-veld"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-unpaid-shield-erenna-veld",
            "intention": {
              "kind": "leave",
              "label": "Erenna Veld departs over contract violation"
            },
            "text": "You took the porters’ four cuts. That is exactly what the quartermaster did to my father. I am out.",
            "disclosure": "essential",
            "firstEncounterSummary": "Erenna Veld leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-erenna-veld",
                "boundary-breached:unpaid-shield-erenna-veld"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-erenna-veld",
                "departed:unpaid-shield-erenna-veld"
              ]
            },
            "effects": {
              "add": [
                "departed:unpaid-shield-erenna-veld"
              ],
              "remove": [
                "companion-active:unpaid-shield-erenna-veld"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-unpaid-shield-erenna-veld",
          "name": "Erenna Veld",
          "templateId": "unpaid-shield",
          "memorialNote": "The shield is dented along the rim, bearing seven tally cuts. In the tunic is an unsubmitted receipt for eighteen cuts addressed to the Silt Stair labour depot.",
          "campNotice": "The shield stands upright by the tent flap, but no one has checked the strap rivets since dusk.",
          "witnessReaction": "He took two spear points that were meant for the outsider. He never asked whether the coin was real."
        },
        "absenceResponse": {
          "companionId": "person:companion-unpaid-shield-erenna-veld",
          "name": "Erenna Veld",
          "templateId": "unpaid-shield",
          "reason": "Contract breached: unpaid military charges demanded without bond compensation.",
          "departureLine": "You took the porters’ four cuts. That is exactly what the quartermaster did to my father. I am out.",
          "campNotice": "An empty pallet and a neatly stacked pile of ration tins marked 'returned'."
        },
        "voice": {
          "voiceId": "shield-sergeant",
          "care": {
            "offered": "Good. A {item} before the blood starts. Someone has thought ahead.",
            "treat": "Taking a moment. Keep that point away from me.",
            "remember": "{giver} remembered that a shield has a person behind it. Brought supplies for that person.",
            "aid": "Fight is over. Sit down before you fall down. I can dress that.",
            "rememberAid": "I dressed {patient}’s wounds after the fighting. Officers never taught me that part of the job."
          },
          "manner": "Ex-sergeant; blunt, clipped orders; contempt for officers; bold, keeps own counsel.",
          "temperament": {
            "boldness": 7,
            "loyalty": 3
          },
          "obligation": "Wages go against an old man’s ration bond at the depot. Paid to fight, not to charge.",
          "opening": "My father signed for army bread in a bad winter. Thirty years on, the depot says he still owes it. I fight for money. I do not fight for officers.",
          "hire": "Done. You point, I decide. Nobody salutes. If the price is wrong, I tell you before the blades come out.",
          "hired": "Still here. Still paid. You say where; I say whether.",
          "refusal": "Charge on your own coin. Nobody pays me enough for that.",
          "afterFight": {
            "guard": "Clean enough. He waited too long to draw, which means he never meant it. Noll hires men who hope.",
            "tunnel": "Kept stoking with a spear in it. I have had recruits with less discipline. Did not like watching it."
          },
          "moment": {
            "request": "At the court there is a second toll on the stair. Get it struck. Officers love striking things when someone else did the reading.",
            "kept": "Struck. See? Somebody had to put it in front of them. Porters get nothing unless it is written down first.",
            "broken": "You took the porters’ four cuts. That is exactly what the quartermaster did to my father. I am out."
          },
          "judgment": {
            "good": "Paid. The old man’s bond comes down a season. I will tell him an outsider did it. He will not believe me.",
            "bad": "You sold the kilns their protection. I have served men who did that. I do not serve them twice.",
            "depart": "Go, then. I finish contracts. This one ends when the escrow opens, and I am staying until it does.",
            "mourning": "Died on your feet. More than most officers manage. The escrow pays; I will drink the first cut to you."
          },
          "discuss": {
            "guard": {
              "accepted": "Fine. Stay behind my shield and do not wander.",
              "refused": "No. I fight where the fight is, not wherever you happen to stand."
            },
            "engage": {
              "accepted": "If he breaks, I follow. Soldiers who break keep running.",
              "refused": "No chase. A chase is how sergeants get buried and officers get medals."
            },
            "withdraw": {
              "accepted": "Good. Best order I have heard all year.",
              "refused": "I pick my own retreat. I have picked better ones than yours."
            }
          },
          "barks": {
            "engage": "He broke. Going in.",
            "guard": "Behind me. Now.",
            "hold": "Hold. Let him tire.",
            "withdraw": "Pulling out. Not dying here.",
            "defend": "Full swing. I know that drill."
          },
          "returning": {
            "kept": "Another outsider. The last one I worked for lived, paid, and never once asked for a salute. You have a lot to live up to.",
            "mourned": "Last outsider I worked for died at the kilns. Not my fault, not theirs either. Let us see about you.",
            "absent": "Went back to the depot to argue the father’s bond in person. Said outsiders pay late and die early."
          }
        }
      }
    ],
    "military": [
      {
        "candidateKey": "unpaid-shield-ressa-serrat",
        "templateId": "unpaid-shield",
        "templateTitle": "The Unpaid Shield",
        "archetype": "A former professional infantry soldier seeking the release of a dependent from a service debt. Usually protects exposed allies, dislikes unnecessary chases, and refuses unpaid military duties.",
        "culture": "Veyrathi",
        "name": "Ressa Serrat",
        "equipment": [
          "item:shield-round",
          "item:spear-bronze",
          "item:gambeson",
          "item:knife-belt"
        ],
        "person": {
          "id": "person:companion-unpaid-shield-ressa-serrat",
          "lineageKey": "lineage:unpaid-shield-ressa-serrat",
          "presentationKey": "presentation:actor-unpaid-shield-rotation",
          "kinshipKeys": [
            "kinship:unpaid-shield-ressa-serrat-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Ressa Serrat",
            "origin": "disgraced-legionary",
            "culture": "Veyrathi",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "shield-discipline",
              "spear-drill"
            ],
            "abilities": [
              "brace-drill"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 10,
            "maxHp": 10,
            "allegiances": [],
            "oaths": [
              "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Conserve strength",
              "Protect the party"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Veyrathi customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-unpaid-shield-ressa-serrat",
          "temperament": {
            "boldness": 5,
            "loyalty": 9
          },
          "obligations": [
            {
              "id": "obligation:unpaid-shield-dependent-debt-unpaid-shield-ressa-serrat",
              "description": "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "My son needs me whole more than you need that blow landed. I am holding my ground."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:unpaid-shield-danger-limit-unpaid-shield-ressa-serrat",
              "kind": "danger-limit",
              "dangerLimit": 36
            }
          ],
          "preferences": {
            "engage": 5,
            "guard": 8,
            "hold": 5,
            "withdraw": 5
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:unpaid-shield-unpaid-shield-ressa-serrat",
          "personId": "person:companion-unpaid-shield-ressa-serrat",
          "description": "Secure 24 cuts to discharge the sister's labour bond from the concession registry.",
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-ressa-serrat"
            ],
            "any": [],
            "none": [
              "departed:unpaid-shield-ressa-serrat"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:unpaid-shield-unpaid-shield-ressa-serrat",
            "status": "achieved",
            "summary": "Paid 24 cuts directly to the concession clerk, securing the stamped deed of release for his sister.",
            "effects": {
              "add": [
                "obligation-resolved:unpaid-shield-ressa-serrat",
                "loyalty-proven:unpaid-shield-ressa-serrat"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:unpaid-shield-unpaid-shield-ressa-serrat",
            "status": "compromised",
            "summary": "Negotiated a half-term deferral with the Reeve in exchange for testimony against the concession bookkeeper.",
            "effects": {
              "add": [
                "obligation-compromised:unpaid-shield-ressa-serrat"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:unpaid-shield-unpaid-shield-ressa-serrat",
            "status": "abandoned",
            "summary": "Departed after the employer repeatedly refused to allocate contract shares towards the bond.",
            "effects": {
              "add": [
                "departed:unpaid-shield-ressa-serrat"
              ],
              "remove": [
                "companion-active:unpaid-shield-ressa-serrat"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-unpaid-shield-ressa-serrat",
            "intention": {
              "kind": "ask",
              "label": "Speak with Ressa Serrat (The Unpaid Shield)"
            },
            "text": "They took my son into depot service for a debt I signed. In the camps we said a shield is only as good as the arm behind it. Mine is for hire until he is home.",
            "disclosure": "essential",
            "firstEncounterSummary": "Hire an experienced shieldman working to clear a family labour debt.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:unpaid-shield-ressa-serrat",
                "rejected:unpaid-shield-ressa-serrat",
                "dead:unpaid-shield-ressa-serrat"
              ]
            },
            "effects": {
              "add": [
                "met:unpaid-shield-ressa-serrat"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-unpaid-shield-ressa-serrat",
            "intention": {
              "kind": "offer",
              "label": "Agree to twelve-cut wage in escrow"
            },
            "text": "Then we are a pair until the milestone. In the camps that meant something. I will make it mean something here.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Ressa Serrat.",
            "prerequisites": {
              "all": [
                "met:unpaid-shield-ressa-serrat"
              ],
              "any": [],
              "none": [
                "hired:unpaid-shield-ressa-serrat",
                "dead:unpaid-shield-ressa-serrat"
              ]
            },
            "effects": {
              "add": [
                "hired:unpaid-shield-ressa-serrat",
                "companion-active:unpaid-shield-ressa-serrat"
              ],
              "remove": [
                "available:unpaid-shield-ressa-serrat"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "escrow:guaranteed-wage"
            ],
            "socialDifficulty": 3
          },
          {
            "id": "dialogue:approach-engage-unpaid-shield-ressa-serrat",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "No. A chase is how mothers lose sons. I will not run after him.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-ressa-serrat"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-ressa-serrat",
                "departed:unpaid-shield-ressa-serrat"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:unpaid-shield-ressa-serrat"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-unpaid-shield-ressa-serrat",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "Always. Keep my shoulder in sight and we will both see supper.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-ressa-serrat"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-ressa-serrat",
                "departed:unpaid-shield-ressa-serrat"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:unpaid-shield-ressa-serrat"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-unpaid-shield-ressa-serrat",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "Agreed. There is no shame in coming home.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-ressa-serrat"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-ressa-serrat",
                "departed:unpaid-shield-ressa-serrat"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:unpaid-shield-ressa-serrat"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-unpaid-shield-ressa-serrat",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "At the court, ask them to strike the second toll. We used to say an unfair tax is a slow wound. The porters have been bleeding on that stair for a year.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-ressa-serrat"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-ressa-serrat"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:unpaid-shield-ressa-serrat"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-unpaid-shield-ressa-serrat",
            "intention": {
              "kind": "leave",
              "label": "Ressa Serrat departs over contract violation"
            },
            "text": "You took from the porters’ bowl. We never took from our own. I cannot march beside that.",
            "disclosure": "essential",
            "firstEncounterSummary": "Ressa Serrat leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-ressa-serrat",
                "boundary-breached:unpaid-shield-ressa-serrat"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-ressa-serrat",
                "departed:unpaid-shield-ressa-serrat"
              ]
            },
            "effects": {
              "add": [
                "departed:unpaid-shield-ressa-serrat"
              ],
              "remove": [
                "companion-active:unpaid-shield-ressa-serrat"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-unpaid-shield-ressa-serrat",
          "name": "Ressa Serrat",
          "templateId": "unpaid-shield",
          "memorialNote": "The shield is dented along the rim, bearing seven tally cuts. In the tunic is an unsubmitted receipt for eighteen cuts addressed to the Silt Stair labour depot.",
          "campNotice": "The shield stands upright by the tent flap, but no one has checked the strap rivets since dusk.",
          "witnessReaction": "He took two spear points that were meant for the outsider. He never asked whether the coin was real."
        },
        "absenceResponse": {
          "companionId": "person:companion-unpaid-shield-ressa-serrat",
          "name": "Ressa Serrat",
          "templateId": "unpaid-shield",
          "reason": "Contract breached: unpaid military charges demanded without bond compensation.",
          "departureLine": "You took from the porters’ bowl. We never took from our own. I cannot march beside that.",
          "campNotice": "An empty pallet and a neatly stacked pile of ration tins marked 'returned'."
        },
        "voice": {
          "voiceId": "shield-camp",
          "care": {
            "offered": "We pack for the one who falls behind. Thank you for the {item}.",
            "treat": "A little room, friends. We still have walking to do.",
            "remember": "{giver} put medicine in my hand before asking for my shield. Good camp manners.",
            "aid": "The fighting is done, friend. Sit beside me. We tend the one who needs it.",
            "rememberAid": "I tended {patient} after the blades were quiet. That is what a camp is for."
          },
          "manner": "Formal and warm; old camp sayings; talks in 'we'; steady, deeply loyal.",
          "temperament": {
            "boldness": 5,
            "loyalty": 9
          },
          "obligation": "A son bound into depot service for a signed debt; every wage goes toward bringing him home. No unpaid assaults.",
          "opening": "They took my son into depot service for a debt I signed. In the camps we said a shield is only as good as the arm behind it. Mine is for hire until he is home.",
          "hire": "Then we are a pair until the milestone. In the camps that meant something. I will make it mean something here.",
          "hired": "We walk together until the milestone. In the camps we said the second pair of eyes sees the knife. Mine are open.",
          "refusal": "My son needs me whole more than you need that blow landed. I am holding my ground.",
          "afterFight": {
            "guard": "Sit, if you need to. The first one you kill stays with you. Mine still does. We keep going anyway.",
            "tunnel": "Someone’s child, once. Someone’s pair of hands. I hope whoever set it to work has to look at it."
          },
          "moment": {
            "request": "At the court, ask them to strike the second toll. We used to say an unfair tax is a slow wound. The porters have been bleeding on that stair for a year.",
            "kept": "Struck. You have closed a wound, in a small way. The camps would have drunk to you.",
            "broken": "You took from the porters’ bowl. We never took from our own. I cannot march beside that."
          },
          "judgment": {
            "good": "Paid, and to the right desk. My son comes home a season early. You will always have a place at my fire.",
            "bad": "You paid for a repair with the dead. In the camps that was the one thing we buried people for. I am leaving.",
            "depart": "Go safely. I will stay until the account is closed; a pair finishes what it starts, even halved.",
            "mourning": "We were a pair. I brought you this far and no further. I will stand at your name the way we stood for ours."
          },
          "discuss": {
            "guard": {
              "accepted": "Always. Keep my shoulder in sight and we will both see supper.",
              "refused": "Not this time. The ground wants me elsewhere; trust the arm, not the distance."
            },
            "engage": {
              "accepted": "If the gap is honest, we take it together.",
              "refused": "No. A chase is how mothers lose sons. I will not run after him."
            },
            "withdraw": {
              "accepted": "Agreed. There is no shame in coming home.",
              "refused": "I do not leave people behind. Ask me something else."
            }
          },
          "barks": {
            "engage": "With me. Now, together.",
            "guard": "Stay in my shadow.",
            "hold": "Plant your feet. We hold.",
            "withdraw": "Back, slowly. Nobody runs.",
            "defend": "Set your feet, as we did in camp. I remember."
          },
          "returning": {
            "kept": "The outsider before you came through alive, and I was proud to walk beside them. Sit a moment. Tell me what brings you down the same stair.",
            "mourned": "I marched with the last outsider until the kilns took them. I still set a place for that name. I would rather not set another.",
            "absent": "Went north to wait at the depot gate for the son. Left word that outsiders spend their pairs too easily."
          }
        }
      },
      {
        "candidateKey": "displaced-mason-yoren-en-keth",
        "templateId": "displaced-mason",
        "templateTitle": "The Displaced Mason",
        "archetype": "A quarry or public-works worker with militia experience, heavy tools, and a family dependent on wages. Understands structures and refuses to destroy infrastructure people need.",
        "culture": "Talruni",
        "name": "Yoren En Keth",
        "equipment": [
          "item:blade-iron",
          "item:knife-belt",
          "item:gambeson",
          "item:hook-sluicekeeper"
        ],
        "person": {
          "id": "person:companion-displaced-mason-yoren-en-keth",
          "lineageKey": "lineage:displaced-mason-yoren-en-keth",
          "presentationKey": "presentation:actor-outsider-axe-rotation",
          "kinshipKeys": [
            "kinship:displaced-mason-yoren-en-keth-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Yoren En Keth",
            "origin": "escaped-worker",
            "culture": "Talruni",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "quarry-masonry",
              "structural-knowledge"
            ],
            "abilities": [
              "pry-pawl",
              "cleave"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 10,
            "maxHp": 10,
            "allegiances": [],
            "oaths": [
              "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Conserve strength",
              "Protect the party"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Talruni customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-displaced-mason-yoren-en-keth",
          "temperament": {
            "boldness": 2,
            "loyalty": 9
          },
          "obligations": [
            {
              "id": "obligation:displaced-mason-civil-infrastructure-displaced-mason-yoren-en-keth",
              "description": "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "I will not go at him there; the whole floor is poorly footed. I will keep the way back clear."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:displaced-mason-refuse-reckless-charge-displaced-mason-yoren-en-keth",
              "kind": "refuse-goal",
              "goal": "engage"
            }
          ],
          "preferences": {
            "engage": 1,
            "guard": 8,
            "hold": 8,
            "withdraw": 9
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:displaced-mason-displaced-mason-yoren-en-keth",
          "personId": "person:companion-displaced-mason-yoren-en-keth",
          "description": "Earn forty cuts and secure two sacks of flour for the dependents in the lower quarry barracks.",
          "prerequisites": {
            "all": [
              "hired:displaced-mason-yoren-en-keth"
            ],
            "any": [],
            "none": [
              "departed:displaced-mason-yoren-en-keth"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:displaced-mason-displaced-mason-yoren-en-keth",
            "status": "achieved",
            "summary": "Delivered forty cuts and sixty pounds of clean flour to the quarry quarters, securing food through the season.",
            "effects": {
              "add": [
                "obligation-resolved:displaced-mason-yoren-en-keth",
                "loyalty-proven:displaced-mason-yoren-en-keth"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:displaced-mason-displaced-mason-yoren-en-keth",
            "status": "compromised",
            "summary": "Accepted half-pay after refusing to collapse the canal arch, forcing the family onto quarter-rations.",
            "effects": {
              "add": [
                "obligation-compromised:displaced-mason-yoren-en-keth"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:displaced-mason-displaced-mason-yoren-en-keth",
            "status": "abandoned",
            "summary": "Walked away from the party after the player ordered the sluice gates smashed to flood the lower market.",
            "effects": {
              "add": [
                "departed:displaced-mason-yoren-en-keth"
              ],
              "remove": [
                "companion-active:displaced-mason-yoren-en-keth"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-displaced-mason-yoren-en-keth",
            "intention": {
              "kind": "ask",
              "label": "Speak with Yoren En Keth (The Displaced Mason)"
            },
            "text": "Excuse me, are you hiring? I set stone for the public works until the works stopped. I am careful, which is not the same as slow. I only ask that we do not damage anything people need.",
            "disclosure": "essential",
            "firstEncounterSummary": "Recruit a muscular stoneworker fighting for family subsistence without compromising civic ethics.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:displaced-mason-yoren-en-keth",
                "rejected:displaced-mason-yoren-en-keth",
                "dead:displaced-mason-yoren-en-keth"
              ]
            },
            "effects": {
              "add": [
                "met:displaced-mason-yoren-en-keth"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-displaced-mason-yoren-en-keth",
            "intention": {
              "kind": "offer",
              "label": "Guarantee twelve cuts and swear not to harm civil works"
            },
            "text": "Thank you. I will write the twelve cuts down and send them home tonight. If I see a crack, I will say so, even when it is inconvenient.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Yoren En Keth.",
            "prerequisites": {
              "all": [
                "met:displaced-mason-yoren-en-keth"
              ],
              "any": [],
              "none": [
                "hired:displaced-mason-yoren-en-keth",
                "dead:displaced-mason-yoren-en-keth"
              ]
            },
            "effects": {
              "add": [
                "hired:displaced-mason-yoren-en-keth",
                "companion-active:displaced-mason-yoren-en-keth"
              ],
              "remove": [
                "available:displaced-mason-yoren-en-keth"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "guarantee:civil-infrastructure"
            ],
            "socialDifficulty": 3
          },
          {
            "id": "dialogue:approach-engage-displaced-mason-yoren-en-keth",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "I would rather not. Chasing people is how you fall through floors.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:displaced-mason-yoren-en-keth"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-yoren-en-keth",
                "departed:displaced-mason-yoren-en-keth"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:displaced-mason-yoren-en-keth"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-displaced-mason-yoren-en-keth",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "Yes, of course. I will keep to your side and tell you where the floor is soft.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:displaced-mason-yoren-en-keth"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-yoren-en-keth",
                "departed:displaced-mason-yoren-en-keth"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:displaced-mason-yoren-en-keth"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-displaced-mason-yoren-en-keth",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "Yes. Good. I would like that very much.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:displaced-mason-yoren-en-keth"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-yoren-en-keth",
                "departed:displaced-mason-yoren-en-keth"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:displaced-mason-yoren-en-keth"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-displaced-mason-yoren-en-keth",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "That plank is below the red mark. Two cuts buys timber to wedge it. If the pawl goes up instead, the water tears it loose. People live behind there.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:displaced-mason-yoren-en-keth"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-yoren-en-keth"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:displaced-mason-yoren-en-keth"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-displaced-mason-yoren-en-keth",
            "intention": {
              "kind": "leave",
              "label": "Yoren En Keth departs over contract violation"
            },
            "text": "The pawl. I asked you. I cannot stay while the water is in their bedding. I am going to help.",
            "disclosure": "essential",
            "firstEncounterSummary": "Yoren En Keth leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:displaced-mason-yoren-en-keth",
                "boundary-breached:displaced-mason-yoren-en-keth"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-yoren-en-keth",
                "departed:displaced-mason-yoren-en-keth"
              ]
            },
            "effects": {
              "add": [
                "departed:displaced-mason-yoren-en-keth"
              ],
              "remove": [
                "companion-active:displaced-mason-yoren-en-keth"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-displaced-mason-yoren-en-keth",
          "name": "Yoren En Keth",
          "templateId": "displaced-mason",
          "memorialNote": "A heavy leather apron crusted with lime and dried sweat. In the pocket is a copper token stamped with the quarry union mark, worn flat by nervous thumbs.",
          "campNotice": "A pile of chipped cobblestones sits neatly stacked by the bedroll. The mason's place in the meal line is vacant.",
          "witnessReaction": "He braced the cracked lintel with his own shoulders while the rest of us scrambled out. When the stone dropped, he didn't scream."
        },
        "absenceResponse": {
          "companionId": "person:companion-displaced-mason-yoren-en-keth",
          "name": "Yoren En Keth",
          "templateId": "displaced-mason",
          "reason": "Boundary violated: deliberate destruction of civilian canal infrastructure.",
          "departureLine": "The pawl. I asked you. I cannot stay while the water is in their bedding. I am going to help.",
          "campNotice": "A heavy stone mallet laid across an unmortared boundary stone."
        },
        "voice": {
          "voiceId": "mason-plumb",
          "care": {
            "offered": "Thank you for the {item}. I was worried about being a burden if I got hurt.",
            "treat": "Please, just a little space. I can manage the wound.",
            "remember": "{giver} gave up their own supplies for me. I still measure people against that kindness.",
            "aid": "Please sit. You have lost too much blood. I have supplies; let me help.",
            "rememberAid": "I was frightened by how badly {patient} was hurt. I used my supplies to tend the wounds."
          },
          "manner": "Gentle and anxious; exact about loads and measures; apologises; cautious, very loyal.",
          "temperament": {
            "boldness": 2,
            "loyalty": 9
          },
          "obligation": "Wages for a mother and an aunt in the quarry barracks. Refuses to damage walls, drains or walkways.",
          "opening": "Excuse me, are you hiring? I set stone for the public works until the works stopped. I am careful, which is not the same as slow. I only ask that we do not damage anything people need.",
          "hire": "Thank you. I will write the twelve cuts down and send them home tonight. If I see a crack, I will say so, even when it is inconvenient.",
          "hired": "I am here. Sorry. If anything we pass looks cracked, I will tell you, even if it slows us.",
          "refusal": "I will not go at him there; the whole floor is poorly footed. I will keep the way back clear.",
          "afterFight": {
            "guard": "Are you hurt? Let me see the arm. The floor held, at least. I watched the joists the whole time; I could not help it.",
            "tunnel": "The tunnel mouth held, which I was worried about. The body did not. I hope someone knows who it was."
          },
          "moment": {
            "request": "That plank is below the red mark. Two cuts buys timber to wedge it. If the pawl goes up instead, the water tears it loose. People live behind there.",
            "kept": "It sits true. Two cuts. I measured it twice while you were not looking. It will carry a barrow now.",
            "broken": "The pawl. I asked you. I cannot stay while the water is in their bedding. I am going to help."
          },
          "judgment": {
            "good": "Everything I was worried about is still standing. That almost never happens. My mother will say I exaggerated.",
            "bad": "It was not an accident, and it was not necessary. I will take my wages and go. I am sorry.",
            "depart": "You are going now? All right. I will stay and see the escrow closed properly.",
            "mourning": "I was watching the ceiling. I should have been watching you. I will see your name entered correctly."
          },
          "discuss": {
            "guard": {
              "accepted": "Yes, of course. I will keep to your side and tell you where the floor is soft.",
              "refused": "I would, but I am more use watching the roof. Please trust me on that."
            },
            "engage": {
              "accepted": "Only if the footing is good. I will look before I step.",
              "refused": "I would rather not. Chasing people is how you fall through floors."
            },
            "withdraw": {
              "accepted": "Yes. Good. I would like that very much.",
              "refused": "Not while the drain wall is loaded like that. If I leave, it goes."
            }
          },
          "barks": {
            "engage": "Footing is good. Going.",
            "guard": "Stay by me. Mind the slab.",
            "hold": "Holding here. It is sound.",
            "withdraw": "The floor is going. Back, please.",
            "defend": "Wait. I can see where that is going."
          },
          "returning": {
            "kept": "You are the new one? The last outsider who hired me kept every wall standing. I still think about that walkway. Are you careful?",
            "mourned": "I worked for the outsider before you. They died at the kilns. I measured everything and it did not help. Forgive me, that is not your problem.",
            "absent": "Back at the barracks, repairing what the water took. Told Nessa that outsiders pay for damage they could have avoided."
          }
        }
      },
      {
        "candidateKey": "towpath-scout-dema-sarn",
        "templateId": "towpath-scout",
        "templateTitle": "The Towpath Scout",
        "archetype": "A ferry worker or canal guide selling local knowledge after losing regular work. Notices routes, uses a bow or javelins, values discretion, and refuses to expose escape routes used by vulnerable people.",
        "culture": "Orsene",
        "name": "Dema Sarn",
        "equipment": [
          "item:bow-ash",
          "item:knife-belt",
          "item:satchel",
          "item:field-dressing"
        ],
        "person": {
          "id": "person:companion-towpath-scout-dema-sarn",
          "lineageKey": "lineage:towpath-scout-dema-sarn",
          "presentationKey": "presentation:actor-towpath-scout-rotation",
          "kinshipKeys": [
            "kinship:towpath-scout-dema-sarn-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Dema Sarn",
            "origin": "escaped-worker",
            "culture": "Orsene",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "towpath-recon",
              "skirmish-archery"
            ],
            "abilities": [
              "loose-arrow",
              "quick-cut"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 8,
            "maxHp": 8,
            "allegiances": [],
            "oaths": [
              "Shield the hidden towpath cuts and weir crawls used by destitute runaways; refuses any action or disclosure that exposes these paths to the canal bailiffs."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Seize the initiative",
              "Preserve independence"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Orsene customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-towpath-scout-dema-sarn",
          "temperament": {
            "boldness": 7,
            "loyalty": 2
          },
          "obligations": [
            {
              "id": "obligation:towpath-scout-towpath-escape-routes-towpath-scout-dema-sarn",
              "description": "Shield the hidden towpath cuts and weir crawls used by destitute runaways; refuses any action or disclosure that exposes these paths to the canal bailiffs.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "That one is not worth the arrow. Also, I would like to live. Mostly the second thing."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:towpath-scout-refuse-open-charge-towpath-scout-dema-sarn",
              "kind": "non-negotiable-topic",
              "topic": "engage"
            }
          ],
          "preferences": {
            "engage": 6,
            "guard": 2,
            "hold": 3,
            "withdraw": 4
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:towpath-scout-towpath-scout-dema-sarn",
          "personId": "person:companion-towpath-scout-dema-sarn",
          "description": "Guide four fugitive families past the toll chain without exposing the hidden culvert to the bailiffs.",
          "prerequisites": {
            "all": [
              "hired:towpath-scout-dema-sarn"
            ],
            "any": [],
            "none": [
              "departed:towpath-scout-dema-sarn"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:towpath-scout-towpath-scout-dema-sarn",
            "status": "achieved",
            "summary": "Guided four families past the toll chain under cover of morning silt fog without alerting the watch.",
            "effects": {
              "add": [
                "obligation-resolved:towpath-scout-dema-sarn",
                "loyalty-proven:towpath-scout-dema-sarn"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:towpath-scout-towpath-scout-dema-sarn",
            "status": "compromised",
            "summary": "Traded an obsolete bypass route to the customs inspector to divert attention from the active cut.",
            "effects": {
              "add": [
                "obligation-compromised:towpath-scout-dema-sarn"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:towpath-scout-towpath-scout-dema-sarn",
            "status": "abandoned",
            "summary": "Fled into the reeds after the player attempted to sell the towpath map to the basin toll collector.",
            "effects": {
              "add": [
                "departed:towpath-scout-dema-sarn"
              ],
              "remove": [
                "companion-active:towpath-scout-dema-sarn"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-towpath-scout-dema-sarn",
            "intention": {
              "kind": "ask",
              "label": "Speak with Dema Sarn (The Towpath Scout)"
            },
            "text": "You look lost, which is good for business. Directions cost a cut. Short cuts cost more. The one path nobody sells is not for sale at all, so do not ask.",
            "disclosure": "essential",
            "firstEncounterSummary": "Engage a quiet canal guide who knows unseen routes through the flooded terraces.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:towpath-scout-dema-sarn",
                "rejected:towpath-scout-dema-sarn",
                "dead:towpath-scout-dema-sarn"
              ]
            },
            "effects": {
              "add": [
                "met:towpath-scout-dema-sarn"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-towpath-scout-dema-sarn",
            "intention": {
              "kind": "offer",
              "label": "Pledge secrecy regarding escape culverts and pay ten cuts"
            },
            "text": "Twelve cuts! You have bought yourself a guide, a good bow and a terrible sense of humour. The humour is free.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Dema Sarn.",
            "prerequisites": {
              "all": [
                "met:towpath-scout-dema-sarn"
              ],
              "any": [],
              "none": [
                "hired:towpath-scout-dema-sarn",
                "dead:towpath-scout-dema-sarn"
              ]
            },
            "effects": {
              "add": [
                "hired:towpath-scout-dema-sarn",
                "companion-active:towpath-scout-dema-sarn"
              ],
              "remove": [
                "available:towpath-scout-dema-sarn"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "silence:escape-routes"
            ],
            "socialDifficulty": 2
          },
          {
            "id": "dialogue:approach-engage-towpath-scout-dema-sarn",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "Chase him? For twelve cuts? You have seen my prices.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:towpath-scout-dema-sarn"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-dema-sarn",
                "departed:towpath-scout-dema-sarn"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:towpath-scout-dema-sarn"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-towpath-scout-dema-sarn",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "Close is where arrows go. I prefer somewhere arrows are not.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:towpath-scout-dema-sarn"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-dema-sarn",
                "departed:towpath-scout-dema-sarn"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:towpath-scout-dema-sarn"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-towpath-scout-dema-sarn",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "Now that is a plan I can sell. I will even throw in the exit.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:towpath-scout-dema-sarn"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-dema-sarn",
                "departed:towpath-scout-dema-sarn"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:towpath-scout-dema-sarn"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-towpath-scout-dema-sarn",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "Here is some free advice, which is rare from me. The drain path stays off your paper. Sell anything you like. Not that.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:towpath-scout-dema-sarn"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-dema-sarn"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:towpath-scout-dema-sarn"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-towpath-scout-dema-sarn",
            "intention": {
              "kind": "leave",
              "label": "Dema Sarn departs over contract violation"
            },
            "text": "Six cuts for a family’s way home. You undercharged, and you sold the wrong thing. Goodbye.",
            "disclosure": "essential",
            "firstEncounterSummary": "Dema Sarn leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:towpath-scout-dema-sarn",
                "boundary-breached:towpath-scout-dema-sarn"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-dema-sarn",
                "departed:towpath-scout-dema-sarn"
              ]
            },
            "effects": {
              "add": [
                "departed:towpath-scout-dema-sarn"
              ],
              "remove": [
                "companion-active:towpath-scout-dema-sarn"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-towpath-scout-dema-sarn",
          "name": "Dema Sarn",
          "templateId": "towpath-scout",
          "memorialNote": "An ash bow with a worn cord, wrapped in greased oilcloth. Inside the quiver is a charcoal map of water depths, unmarked by any official seal.",
          "campNotice": "A bundle of willow cord hangs by the cold brazier. The scout didn't return from the evening canal watch.",
          "witnessReaction": "She slipped through thirty patrols without a ripple. It took a blind crossbow in the fog to stop her."
        },
        "absenceResponse": {
          "companionId": "person:companion-towpath-scout-dema-sarn",
          "name": "Dema Sarn",
          "templateId": "towpath-scout",
          "reason": "Boundary violated: secret towpath escape route betrayed to canal guards.",
          "departureLine": "Six cuts for a family’s way home. You undercharged, and you sold the wrong thing. Goodbye.",
          "campNotice": "A footprint in wet clay near the canal edge, leading into the deep reed bed."
        },
        "voice": {
          "voiceId": "scout-patter",
          "care": {
            "offered": "A {item}, and no extra charge? Dangerous precedent. I accept.",
            "treat": "One moment. Bleeding is expensive.",
            "remember": "{giver} gave me medicine without adding a term to the contract. I checked.",
            "aid": "You look expensive to replace. Sit down; the medicine is on me.",
            "rememberAid": "I spent my own medicine on {patient}. No invoice. Some things ruin the joke."
          },
          "manner": "Jokey mercenary patter; prices everything; steel about the families; bold, independent.",
          "temperament": {
            "boldness": 7,
            "loyalty": 2
          },
          "obligation": "Pays well, talks cheap, and sells anything except the families’ route.",
          "opening": "You look lost, which is good for business. Directions cost a cut. Short cuts cost more. The one path nobody sells is not for sale at all, so do not ask.",
          "hire": "Twelve cuts! You have bought yourself a guide, a good bow and a terrible sense of humour. The humour is free.",
          "hired": "Your guide, already paid for. Questions are free today. Answers too, mostly.",
          "refusal": "That one is not worth the arrow. Also, I would like to live. Mostly the second thing.",
          "afterFight": {
            "guard": "Well. That was a very expensive doorway. Noll will want a receipt. I would love to watch him write it.",
            "tunnel": "It kept working after it died. I have met foremen like that. Do not tell them I said so."
          },
          "moment": {
            "request": "Here is some free advice, which is rare from me. The drain path stays off your paper. Sell anything you like. Not that.",
            "kept": "Look at you, leaving money on the table. I might have misjudged you. Do not let it go to your head.",
            "broken": "Six cuts for a family’s way home. You undercharged, and you sold the wrong thing. Goodbye."
          },
          "judgment": {
            "good": "Paid in full, and I did not have to steal anything. I feel almost respectable. It will pass.",
            "bad": "I sell a lot of things. I have never sold the dead back to their own town. Keep your pass. I am going.",
            "depart": "Off already? Nobody tips anymore. I will stay and watch the escrow open; I like seeing money move.",
            "mourning": "Well, that is bad for business. And for you, mostly. I will tell them you paid on time. It is the nicest thing I know how to say."
          },
          "discuss": {
            "guard": {
              "accepted": "Fine, I will stay close. Close costs extra; I will put it on your account.",
              "refused": "Close is where arrows go. I prefer somewhere arrows are not."
            },
            "engage": {
              "accepted": "If he runs, I shoot. Running is my favourite kind of target.",
              "refused": "Chase him? For twelve cuts? You have seen my prices."
            },
            "withdraw": {
              "accepted": "Now that is a plan I can sell. I will even throw in the exit.",
              "refused": "I leave when I leave. That part of me is not for hire."
            }
          },
          "barks": {
            "engage": "Open target. Lovely.",
            "guard": "Stay put. I have the angle.",
            "hold": "Nobody move. Especially me.",
            "withdraw": "Time to go. Follow the expensive one.",
            "defend": "You will have to earn that cut."
          },
          "returning": {
            "kept": "Another outsider? The last one paid me well and lived, which is the best review I ever got. Want the same service?",
            "mourned": "My last client died down in the kilns. Paid in advance, luckily. That is a joke. Mostly. Hire me and I will try harder.",
            "absent": "Raised prices past anything an outsider pays, on purpose. Told the stall-keepers the last one sold something that was not for sale."
          }
        }
      }
    ],
    "harbour": [
      {
        "candidateKey": "unpaid-shield-merva-en-or",
        "templateId": "unpaid-shield",
        "templateTitle": "The Unpaid Shield",
        "archetype": "A former professional infantry soldier seeking the release of a dependent from a service debt. Usually protects exposed allies, dislikes unnecessary chases, and refuses unpaid military duties.",
        "culture": "Talruni",
        "name": "Merva En Or",
        "equipment": [
          "item:shield-round",
          "item:spear-bronze",
          "item:gambeson",
          "item:knife-belt"
        ],
        "person": {
          "id": "person:companion-unpaid-shield-merva-en-or",
          "lineageKey": "lineage:unpaid-shield-merva-en-or",
          "presentationKey": "presentation:actor-unpaid-shield-rotation",
          "kinshipKeys": [
            "kinship:unpaid-shield-merva-en-or-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Merva En Or",
            "origin": "disgraced-legionary",
            "culture": "Talruni",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "shield-discipline",
              "spear-drill"
            ],
            "abilities": [
              "brace-drill"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 10,
            "maxHp": 10,
            "allegiances": [],
            "oaths": [
              "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Seize the initiative",
              "Protect the party"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Talruni customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-unpaid-shield-merva-en-or",
          "temperament": {
            "boldness": 8,
            "loyalty": 7
          },
          "obligations": [
            {
              "id": "obligation:unpaid-shield-dependent-debt-unpaid-shield-merva-en-or",
              "description": "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "I would, truly, but my brother does not get paid for my bravery. I am staying out of that one."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:unpaid-shield-refuse-unpaid-slaughter-unpaid-shield-merva-en-or",
              "kind": "refuse-goal",
              "goal": "engage"
            }
          ],
          "preferences": {
            "engage": 7,
            "guard": 7,
            "hold": 3,
            "withdraw": 1
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:unpaid-shield-unpaid-shield-merva-en-or",
          "personId": "person:companion-unpaid-shield-merva-en-or",
          "description": "Secure 24 cuts to discharge the sister's labour bond from the concession registry.",
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-merva-en-or"
            ],
            "any": [],
            "none": [
              "departed:unpaid-shield-merva-en-or"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:unpaid-shield-unpaid-shield-merva-en-or",
            "status": "achieved",
            "summary": "Paid 24 cuts directly to the concession clerk, securing the stamped deed of release for his sister.",
            "effects": {
              "add": [
                "obligation-resolved:unpaid-shield-merva-en-or",
                "loyalty-proven:unpaid-shield-merva-en-or"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:unpaid-shield-unpaid-shield-merva-en-or",
            "status": "compromised",
            "summary": "Negotiated a half-term deferral with the Reeve in exchange for testimony against the concession bookkeeper.",
            "effects": {
              "add": [
                "obligation-compromised:unpaid-shield-merva-en-or"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:unpaid-shield-unpaid-shield-merva-en-or",
            "status": "abandoned",
            "summary": "Departed after the employer repeatedly refused to allocate contract shares towards the bond.",
            "effects": {
              "add": [
                "departed:unpaid-shield-merva-en-or"
              ],
              "remove": [
                "companion-active:unpaid-shield-merva-en-or"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-unpaid-shield-merva-en-or",
            "intention": {
              "kind": "ask",
              "label": "Speak with Merva En Or (The Unpaid Shield)"
            },
            "text": "I have a shield, a good arm, and a brother pushing concession carts until his bond is clear. Ask me anything. Please ask me something.",
            "disclosure": "essential",
            "firstEncounterSummary": "Hire an experienced shieldman working to clear a family labour debt.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:unpaid-shield-merva-en-or",
                "rejected:unpaid-shield-merva-en-or",
                "dead:unpaid-shield-merva-en-or"
              ]
            },
            "effects": {
              "add": [
                "met:unpaid-shield-merva-en-or"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-unpaid-shield-merva-en-or",
            "intention": {
              "kind": "offer",
              "label": "Agree to twelve-cut wage in escrow"
            },
            "text": "Twelve cuts! Right. I will be very good. Useful, I mean. Useful, and I will try not to talk the whole way.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Merva En Or.",
            "prerequisites": {
              "all": [
                "met:unpaid-shield-merva-en-or"
              ],
              "any": [],
              "none": [
                "hired:unpaid-shield-merva-en-or",
                "dead:unpaid-shield-merva-en-or"
              ]
            },
            "effects": {
              "add": [
                "hired:unpaid-shield-merva-en-or",
                "companion-active:unpaid-shield-merva-en-or"
              ],
              "remove": [
                "available:unpaid-shield-merva-en-or"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "escrow:guaranteed-wage"
            ],
            "socialDifficulty": 3
          },
          {
            "id": "dialogue:approach-engage-unpaid-shield-merva-en-or",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "I want to. I really do. But chasing is unpaid, and my brother is not.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-merva-en-or"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-merva-en-or",
                "departed:unpaid-shield-merva-en-or"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:unpaid-shield-merva-en-or"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-unpaid-shield-merva-en-or",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "Yes! I mean, yes. Close. Right beside you.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-merva-en-or"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-merva-en-or",
                "departed:unpaid-shield-merva-en-or"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:unpaid-shield-merva-en-or"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-unpaid-shield-merva-en-or",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "All right. Living is good. My brother would be furious otherwise.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-merva-en-or"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-merva-en-or",
                "departed:unpaid-shield-merva-en-or"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:unpaid-shield-merva-en-or"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-unpaid-shield-merva-en-or",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "At the court, could you ask about the stair toll? They charge it twice. My brother paid it twice on every cart.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-merva-en-or"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-merva-en-or"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:unpaid-shield-merva-en-or"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-unpaid-shield-merva-en-or",
            "intention": {
              "kind": "leave",
              "label": "Merva En Or departs over contract violation"
            },
            "text": "You took money out of the porters’ bowl. My brother’s money, near enough. I cannot stay after that. I am sorry.",
            "disclosure": "essential",
            "firstEncounterSummary": "Merva En Or leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-merva-en-or",
                "boundary-breached:unpaid-shield-merva-en-or"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-merva-en-or",
                "departed:unpaid-shield-merva-en-or"
              ]
            },
            "effects": {
              "add": [
                "departed:unpaid-shield-merva-en-or"
              ],
              "remove": [
                "companion-active:unpaid-shield-merva-en-or"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-unpaid-shield-merva-en-or",
          "name": "Merva En Or",
          "templateId": "unpaid-shield",
          "memorialNote": "The shield is dented along the rim, bearing seven tally cuts. In the tunic is an unsubmitted receipt for eighteen cuts addressed to the Silt Stair labour depot.",
          "campNotice": "The shield stands upright by the tent flap, but no one has checked the strap rivets since dusk.",
          "witnessReaction": "He took two spear points that were meant for the outsider. He never asked whether the coin was real."
        },
        "absenceResponse": {
          "companionId": "person:companion-unpaid-shield-merva-en-or",
          "name": "Merva En Or",
          "templateId": "unpaid-shield",
          "reason": "Contract breached: unpaid military charges demanded without bond compensation.",
          "departureLine": "You took money out of the porters’ bowl. My brother’s money, near enough. I cannot stay after that. I am sorry.",
          "campNotice": "An empty pallet and a neatly stacked pile of ration tins marked 'returned'."
        },
        "voice": {
          "voiceId": "shield-eager",
          "care": {
            "offered": "For me? A {item}. Right. I will try to need it less than you do.",
            "treat": "Still here. Just making sure the blood stays here too.",
            "remember": "{giver} shared their medicine with me. I had thought the twelve cuts were all I mattered for.",
            "aid": "You are bleeding. A lot. Wait, I kept the medicine. Let me help.",
            "rememberAid": "{patient} was badly hurt. I had medicine, and for once I knew exactly what to do."
          },
          "manner": "Young and earnest; talks fast; jokes at his own expense; bold and loyal.",
          "temperament": {
            "boldness": 8,
            "loyalty": 7
          },
          "obligation": "Earning out a brother’s bond on the concession carts. Brave for pay, not for free.",
          "opening": "I have a shield, a good arm, and a brother pushing concession carts until his bond is clear. Ask me anything. Please ask me something.",
          "hire": "Twelve cuts! Right. I will be very good. Useful, I mean. Useful, and I will try not to talk the whole way.",
          "hired": "Still with you! I have not said anything stupid for at least a whole street. Where to?",
          "refusal": "I would, truly, but my brother does not get paid for my bravery. I am staying out of that one.",
          "afterFight": {
            "guard": "Did you see him draw? I did. I thought I would be braver. I was mostly fast. Is that the same thing?",
            "tunnel": "It was still trying to feed the fire. Nobody told it to stop. I keep thinking somebody should have."
          },
          "moment": {
            "request": "At the court, could you ask about the stair toll? They charge it twice. My brother paid it twice on every cart.",
            "kept": "They struck it! I am telling my brother tonight. He will pretend not to care, and then he will tell everyone.",
            "broken": "You took money out of the porters’ bowl. My brother’s money, near enough. I cannot stay after that. I am sorry."
          },
          "judgment": {
            "good": "Paid, and not one lie in the whole account. My brother is off the carts by summer. I owe you a drink I cannot afford.",
            "bad": "You let them keep the bodies working. I thought we were on the other side of this. I am going home.",
            "depart": "You are going? I thought we would finish it. I will stay. Somebody should see the end.",
            "mourning": "I should have been closer. Two paces, like they taught us. I will carry your name to the list myself."
          },
          "discuss": {
            "guard": {
              "accepted": "Yes! I mean, yes. Close. Right beside you.",
              "refused": "Honestly, I am better out in front. Let me take the first blow."
            },
            "engage": {
              "accepted": "If he runs, I run faster. I am good at that part.",
              "refused": "I want to. I really do. But chasing is unpaid, and my brother is not."
            },
            "withdraw": {
              "accepted": "All right. Living is good. My brother would be furious otherwise.",
              "refused": "No, I am not leaving you in there. Do not ask me that again."
            }
          },
          "barks": {
            "engage": "Opening! I have got him!",
            "guard": "I am here, I am here.",
            "hold": "Standing firm. Come on, then.",
            "withdraw": "Back! Back, before it gets worse.",
            "defend": "Saw that one coming. For once."
          },
          "returning": {
            "kept": "You are the new outsider? The last one hired me too. They lived! They paid! I have been hoping someone like that would come down the stair again.",
            "mourned": "The last outsider I worked for did not come back from the kilns. I carried the name to the list. I would like not to do that twice.",
            "absent": "Went to push carts beside the brother instead. Told Melian’s patients that outsiders make promises and spend them elsewhere."
          }
        }
      },
      {
        "candidateKey": "former-mortuary-guard-orun-en-dars",
        "templateId": "former-mortuary-guard",
        "templateTitle": "The Former Mortuary Guard",
        "archetype": "A funerary escort who left the concession after a disturbing incident in the Quiet Kilns. Uses a shield and short spear, recognises burial practices, and refuses corpse desecration.",
        "culture": "Talruni",
        "name": "Orun En Dars",
        "equipment": [
          "item:shield-round",
          "item:spear-bronze",
          "item:gambeson",
          "item:oil-flask"
        ],
        "person": {
          "id": "person:companion-former-mortuary-guard-orun-en-dars",
          "lineageKey": "lineage:former-mortuary-guard-orun-en-dars",
          "presentationKey": "presentation:actor-mortuary-guard-rotation",
          "kinshipKeys": [
            "kinship:former-mortuary-guard-orun-en-dars-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Orun En Dars",
            "origin": "disgraced-legionary",
            "culture": "Talruni",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "funerary-vigil",
              "spear-drill"
            ],
            "abilities": [
              "thrust",
              "set-spear"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 9,
            "maxHp": 9,
            "allegiances": [],
            "oaths": [
              "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Seize the initiative",
              "Protect the party"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Talruni customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-former-mortuary-guard-orun-en-dars",
          "temperament": {
            "boldness": 6,
            "loyalty": 7
          },
          "obligations": [
            {
              "id": "obligation:former-mortuary-guard-burial-sanctity-former-mortuary-guard-orun-en-dars",
              "description": "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "I will not strike a body. I carried too many empty boxes for the people who put it to work."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:former-mortuary-guard-refuse-unlawful-desecration-former-mortuary-guard-orun-en-dars",
              "kind": "non-negotiable-topic",
              "topic": "withdraw"
            }
          ],
          "preferences": {
            "engage": 6,
            "guard": 8,
            "hold": 5,
            "withdraw": 4
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:former-mortuary-guard-former-mortuary-guard-orun-en-dars",
          "personId": "person:companion-former-mortuary-guard-orun-en-dars",
          "description": "Recover stolen corpse records and secure honest burial in salted earth for the desecrated kiln remains.",
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-orun-en-dars"
            ],
            "any": [],
            "none": [
              "departed:former-mortuary-guard-orun-en-dars"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:former-mortuary-guard-former-mortuary-guard-orun-en-dars",
            "status": "achieved",
            "summary": "Recovered three stolen corpses from the cooling gallery and saw them properly interred in salted earth.",
            "effects": {
              "add": [
                "obligation-resolved:former-mortuary-guard-orun-en-dars",
                "loyalty-proven:former-mortuary-guard-orun-en-dars"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:former-mortuary-guard-former-mortuary-guard-orun-en-dars",
            "status": "compromised",
            "summary": "Allowed an unverified binder to perform a diagnostic inspection only under direct, armed supervision.",
            "effects": {
              "add": [
                "obligation-compromised:former-mortuary-guard-orun-en-dars"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:former-mortuary-guard-former-mortuary-guard-orun-en-dars",
            "status": "abandoned",
            "summary": "Severed ties after the player attempted to harvest limbs or bones for necromantic reagents.",
            "effects": {
              "add": [
                "departed:former-mortuary-guard-orun-en-dars"
              ],
              "remove": [
                "companion-active:former-mortuary-guard-orun-en-dars"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-former-mortuary-guard-orun-en-dars",
            "intention": {
              "kind": "ask",
              "label": "Speak with Orun En Dars (The Former Mortuary Guard)"
            },
            "text": "I walked the coffin carts up to the kilns for two years. Light carts. I noticed. I took the wage anyway. So now I am for hire, and I will spend it undoing what I helped carry.",
            "disclosure": "essential",
            "firstEncounterSummary": "Hire a grim former necropolis watchman who demands strict reverence for the dead and physical proof of claims.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:former-mortuary-guard-orun-en-dars",
                "rejected:former-mortuary-guard-orun-en-dars",
                "dead:former-mortuary-guard-orun-en-dars"
              ]
            },
            "effects": {
              "add": [
                "met:former-mortuary-guard-orun-en-dars"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-former-mortuary-guard-orun-en-dars",
            "intention": {
              "kind": "offer",
              "label": "Pledge reverence to the mortuary vaults and pay fourteen cuts"
            },
            "text": "Good. Twelve cuts, and I am yours. Do not tell me a body is evidence. I have heard that one before.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Orun En Dars.",
            "prerequisites": {
              "all": [
                "met:former-mortuary-guard-orun-en-dars"
              ],
              "any": [],
              "none": [
                "hired:former-mortuary-guard-orun-en-dars",
                "dead:former-mortuary-guard-orun-en-dars"
              ]
            },
            "effects": {
              "add": [
                "hired:former-mortuary-guard-orun-en-dars",
                "companion-active:former-mortuary-guard-orun-en-dars"
              ],
              "remove": [
                "available:former-mortuary-guard-orun-en-dars"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "covenant:no-desecration"
            ],
            "socialDifficulty": 3
          },
          {
            "id": "dialogue:approach-engage-former-mortuary-guard-orun-en-dars",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "Not through the stations. I will not chase anyone over the dead.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-orun-en-dars"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-orun-en-dars",
                "departed:former-mortuary-guard-orun-en-dars"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:former-mortuary-guard-orun-en-dars"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-former-mortuary-guard-orun-en-dars",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "Yes. Close. I have walked beside worse things than you.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-orun-en-dars"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-orun-en-dars",
                "departed:former-mortuary-guard-orun-en-dars"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:former-mortuary-guard-orun-en-dars"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-former-mortuary-guard-orun-en-dars",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "Fine. But we come back. We always come back for them.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-orun-en-dars"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-orun-en-dars",
                "departed:former-mortuary-guard-orun-en-dars"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:former-mortuary-guard-orun-en-dars"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-former-mortuary-guard-orun-en-dars",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "You have the anchor copied. Undo it. Right now, while we can. I owe this one more than you do.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-orun-en-dars"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-orun-en-dars"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:former-mortuary-guard-orun-en-dars"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-former-mortuary-guard-orun-en-dars",
            "intention": {
              "kind": "leave",
              "label": "Orun En Dars departs over contract violation"
            },
            "text": "You paid for more wax. I did that once, with my silence. I will not do it again with my spear. Goodbye.",
            "disclosure": "essential",
            "firstEncounterSummary": "Orun En Dars leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-orun-en-dars",
                "boundary-breached:former-mortuary-guard-orun-en-dars"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-orun-en-dars",
                "departed:former-mortuary-guard-orun-en-dars"
              ]
            },
            "effects": {
              "add": [
                "departed:former-mortuary-guard-orun-en-dars"
              ],
              "remove": [
                "companion-active:former-mortuary-guard-orun-en-dars"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-former-mortuary-guard-orun-en-dars",
          "name": "Orun En Dars",
          "templateId": "former-mortuary-guard",
          "memorialNote": "A bronze shield bearing the faint silhouette of a laurel wreath, tarnished by tomb smoke. Beside it sits a small clay flask of holding salt and an unlit bronze lamp.",
          "campNotice": "The guard's spear is driven upright into the loam. A small pinch of salt has been scattered across the mound.",
          "witnessReaction": "She stood between the animated corpses and the altar until her spear snapped. She died keeping the threshold clean."
        },
        "absenceResponse": {
          "companionId": "person:companion-former-mortuary-guard-orun-en-dars",
          "name": "Orun En Dars",
          "templateId": "former-mortuary-guard",
          "reason": "Boundary violated: desecration of burial remains or unproven necromantic practice.",
          "departureLine": "You paid for more wax. I did that once, with my silence. I will not do it again with my spear. Goodbye.",
          "campNotice": "A consecrated funeral tile left standing at the entrance to the abandoned gallery."
        },
        "voice": {
          "voiceId": "guard-carts",
          "care": {
            "offered": "I will take the {item}. Better than pretending the blood is someone else’s problem.",
            "treat": "Not another body for a cart. Give me room.",
            "remember": "{giver} handed me medicine while I could still use it. I have carried worse things than that memory.",
            "aid": "Not another one left bleeding. Sit down. I have something for that wound.",
            "rememberAid": "I used my medicine on {patient}. This time I did more than walk beside a cart."
          },
          "manner": "Direct, confessional, angry with himself; walked the empty coffin carts for pay.",
          "temperament": {
            "boldness": 6,
            "loyalty": 7
          },
          "obligation": "Escorted empty coffins for pay and never asked. Wants the stolen dead returned, names and all.",
          "opening": "I walked the coffin carts up to the kilns for two years. Light carts. I noticed. I took the wage anyway. So now I am for hire, and I will spend it undoing what I helped carry.",
          "hire": "Good. Twelve cuts, and I am yours. Do not tell me a body is evidence. I have heard that one before.",
          "hired": "I am with you. I carried empty coffins up that road for their wage. This time I carry something back.",
          "refusal": "I will not strike a body. I carried too many empty boxes for the people who put it to work.",
          "afterFight": {
            "guard": "I knew him, a little. We drank at the same stall. He knew about the carts too. Neither of us said anything.",
            "tunnel": "I might have walked that one’s empty coffin up to the kilns. I will never know. That is the worst part."
          },
          "moment": {
            "request": "You have the anchor copied. Undo it. Right now, while we can. I owe this one more than you do.",
            "kept": "He is still. He can go home. I cannot give back two years, but I can give back him.",
            "broken": "You paid for more wax. I did that once, with my silence. I will not do it again with my spear. Goodbye."
          },
          "judgment": {
            "good": "Named and carried. It does not make up for the carts. It is still the first good thing I have done here.",
            "bad": "You chose the same thing I chose for two years. I know exactly what it costs. I will not pay it twice.",
            "depart": "Leave, then. I have walked away from this place before. I am not doing it again.",
            "mourning": "Another coffin I will walk out of the kilns. This one will not be empty. I am sorry."
          },
          "discuss": {
            "guard": {
              "accepted": "Yes. Close. I have walked beside worse things than you.",
              "refused": "No. I need room to see what is coming. I missed it once."
            },
            "engage": {
              "accepted": "If he runs, I follow. He has answers.",
              "refused": "Not through the stations. I will not chase anyone over the dead."
            },
            "withdraw": {
              "accepted": "Fine. But we come back. We always come back for them.",
              "refused": "I left once when I should have stayed. I am not leaving now."
            }
          },
          "barks": {
            "engage": "My turn. Going in.",
            "guard": "I have your back. This time.",
            "hold": "Stand here. Nothing gets carried off.",
            "withdraw": "Back. We return for them later.",
            "defend": "No. You are not putting me on that cart."
          },
          "returning": {
            "kept": "The last outsider who hired me got the dead out and walked away whole. I did not think I would see that twice. Maybe I will.",
            "mourned": "I walked the last outsider’s coffin out of the kilns myself. It was heavy. I am glad it was heavy. That is a terrible thing to be glad of.",
            "absent": "Went back to walking the carts, to count what goes into them. Says outsiders only ever look once."
          }
        }
      },
      {
        "candidateKey": "towpath-scout-vesha-an-vesh",
        "templateId": "towpath-scout",
        "templateTitle": "The Towpath Scout",
        "archetype": "A ferry worker or canal guide selling local knowledge after losing regular work. Notices routes, uses a bow or javelins, values discretion, and refuses to expose escape routes used by vulnerable people.",
        "culture": "Serekh",
        "name": "Vesha an-Vesh",
        "equipment": [
          "item:bow-ash",
          "item:knife-belt",
          "item:satchel",
          "item:field-dressing"
        ],
        "person": {
          "id": "person:companion-towpath-scout-vesha-an-vesh",
          "lineageKey": "lineage:towpath-scout-vesha-an-vesh",
          "presentationKey": "presentation:actor-towpath-scout-rotation",
          "kinshipKeys": [
            "kinship:towpath-scout-vesha-an-vesh-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Vesha an-Vesh",
            "origin": "escaped-worker",
            "culture": "Serekh",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "towpath-recon",
              "skirmish-archery"
            ],
            "abilities": [
              "loose-arrow",
              "quick-cut"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 8,
            "maxHp": 8,
            "allegiances": [],
            "oaths": [
              "Shield the hidden towpath cuts and weir crawls used by destitute runaways; refuses any action or disclosure that exposes these paths to the canal bailiffs."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Conserve strength",
              "Protect the party"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Serekh customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-towpath-scout-vesha-an-vesh",
          "temperament": {
            "boldness": 3,
            "loyalty": 8
          },
          "obligations": [
            {
              "id": "obligation:towpath-scout-towpath-escape-routes-towpath-scout-vesha-an-vesh",
              "description": "Shield the hidden towpath cuts and weir crawls used by destitute runaways; refuses any action or disclosure that exposes these paths to the canal bailiffs.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "Not him. Sound travels. If I fight here, every bailiff on the stair learns where we came from."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:towpath-scout-danger-limit-towpath-scout-vesha-an-vesh",
              "kind": "danger-limit",
              "dangerLimit": 26
            }
          ],
          "preferences": {
            "engage": 2,
            "guard": 7,
            "hold": 7,
            "withdraw": 8
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:towpath-scout-towpath-scout-vesha-an-vesh",
          "personId": "person:companion-towpath-scout-vesha-an-vesh",
          "description": "Guide four fugitive families past the toll chain without exposing the hidden culvert to the bailiffs.",
          "prerequisites": {
            "all": [
              "hired:towpath-scout-vesha-an-vesh"
            ],
            "any": [],
            "none": [
              "departed:towpath-scout-vesha-an-vesh"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:towpath-scout-towpath-scout-vesha-an-vesh",
            "status": "achieved",
            "summary": "Guided four families past the toll chain under cover of morning silt fog without alerting the watch.",
            "effects": {
              "add": [
                "obligation-resolved:towpath-scout-vesha-an-vesh",
                "loyalty-proven:towpath-scout-vesha-an-vesh"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:towpath-scout-towpath-scout-vesha-an-vesh",
            "status": "compromised",
            "summary": "Traded an obsolete bypass route to the customs inspector to divert attention from the active cut.",
            "effects": {
              "add": [
                "obligation-compromised:towpath-scout-vesha-an-vesh"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:towpath-scout-towpath-scout-vesha-an-vesh",
            "status": "abandoned",
            "summary": "Fled into the reeds after the player attempted to sell the towpath map to the basin toll collector.",
            "effects": {
              "add": [
                "departed:towpath-scout-vesha-an-vesh"
              ],
              "remove": [
                "companion-active:towpath-scout-vesha-an-vesh"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-towpath-scout-vesha-an-vesh",
            "intention": {
              "kind": "ask",
              "label": "Speak with Vesha an-Vesh (The Towpath Scout)"
            },
            "text": "Walk softly here. The stones carry sound down to the water, and the water carries it further. I can show you the quiet ways, if you can keep them quiet.",
            "disclosure": "essential",
            "firstEncounterSummary": "Engage a quiet canal guide who knows unseen routes through the flooded terraces.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:towpath-scout-vesha-an-vesh",
                "rejected:towpath-scout-vesha-an-vesh",
                "dead:towpath-scout-vesha-an-vesh"
              ]
            },
            "effects": {
              "add": [
                "met:towpath-scout-vesha-an-vesh"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-towpath-scout-vesha-an-vesh",
            "intention": {
              "kind": "offer",
              "label": "Pledge secrecy regarding escape culverts and pay ten cuts"
            },
            "text": "Twelve cuts. And one promise: what I show you, you forget when anyone official asks.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Vesha an-Vesh.",
            "prerequisites": {
              "all": [
                "met:towpath-scout-vesha-an-vesh"
              ],
              "any": [],
              "none": [
                "hired:towpath-scout-vesha-an-vesh",
                "dead:towpath-scout-vesha-an-vesh"
              ]
            },
            "effects": {
              "add": [
                "hired:towpath-scout-vesha-an-vesh",
                "companion-active:towpath-scout-vesha-an-vesh"
              ],
              "remove": [
                "available:towpath-scout-vesha-an-vesh"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "silence:escape-routes"
            ],
            "socialDifficulty": 2
          },
          {
            "id": "dialogue:approach-engage-towpath-scout-vesha-an-vesh",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "No. Noise brings more of them. I will not open that door.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:towpath-scout-vesha-an-vesh"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-vesha-an-vesh",
                "departed:towpath-scout-vesha-an-vesh"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:towpath-scout-vesha-an-vesh"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-towpath-scout-vesha-an-vesh",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "I will stay near. You will not hear me, but I will be there.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:towpath-scout-vesha-an-vesh"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-vesha-an-vesh",
                "departed:towpath-scout-vesha-an-vesh"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:towpath-scout-vesha-an-vesh"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-towpath-scout-vesha-an-vesh",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "Yes. I already know three ways out.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:towpath-scout-vesha-an-vesh"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-vesha-an-vesh",
                "departed:towpath-scout-vesha-an-vesh"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:towpath-scout-vesha-an-vesh"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-towpath-scout-vesha-an-vesh",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "The shoes on that ledge belong to people. When you write your report, leave the drain out. Let the city go on not knowing.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:towpath-scout-vesha-an-vesh"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-vesha-an-vesh"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:towpath-scout-vesha-an-vesh"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-towpath-scout-vesha-an-vesh",
            "intention": {
              "kind": "leave",
              "label": "Vesha an-Vesh departs over contract violation"
            },
            "text": "You gave them the path. Tomorrow there will be a lantern on that ledge. I have to warn them before it arrives.",
            "disclosure": "essential",
            "firstEncounterSummary": "Vesha an-Vesh leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:towpath-scout-vesha-an-vesh",
                "boundary-breached:towpath-scout-vesha-an-vesh"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-vesha-an-vesh",
                "departed:towpath-scout-vesha-an-vesh"
              ]
            },
            "effects": {
              "add": [
                "departed:towpath-scout-vesha-an-vesh"
              ],
              "remove": [
                "companion-active:towpath-scout-vesha-an-vesh"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-towpath-scout-vesha-an-vesh",
          "name": "Vesha an-Vesh",
          "templateId": "towpath-scout",
          "memorialNote": "An ash bow with a worn cord, wrapped in greased oilcloth. Inside the quiver is a charcoal map of water depths, unmarked by any official seal.",
          "campNotice": "A bundle of willow cord hangs by the cold brazier. The scout didn't return from the evening canal watch.",
          "witnessReaction": "She slipped through thirty patrols without a ripple. It took a blind crossbow in the fog to stop her."
        },
        "absenceResponse": {
          "companionId": "person:companion-towpath-scout-vesha-an-vesh",
          "name": "Vesha an-Vesh",
          "templateId": "towpath-scout",
          "reason": "Boundary violated: secret towpath escape route betrayed to canal guards.",
          "departureLine": "You gave them the path. Tomorrow there will be a lantern on that ledge. I have to warn them before it arrives.",
          "campNotice": "A footprint in wet clay near the canal edge, leading into the deep reed bed."
        },
        "voice": {
          "voiceId": "scout-still",
          "care": {
            "offered": "I will keep the {item} dry. You may want it yourself before this is over.",
            "treat": "Quiet now. I can tend this if they stay there.",
            "remember": "When I think of {giver}, I remember the supplies they shared, and the water we crossed.",
            "aid": "Quiet now. The danger has passed. Let me see that wound.",
            "rememberAid": "I remember tending {patient} when the fighting went quiet. I had kept the medicine dry."
          },
          "manner": "Soft-spoken and watchful; talks about sound and water; cautious, loyal.",
          "temperament": {
            "boldness": 3,
            "loyalty": 8
          },
          "obligation": "Keeps the families’ hidden path out of every record. Shows you the water, never the people.",
          "opening": "Walk softly here. The stones carry sound down to the water, and the water carries it further. I can show you the quiet ways, if you can keep them quiet.",
          "hire": "Twelve cuts. And one promise: what I show you, you forget when anyone official asks.",
          "hired": "Listen before you step. The water tells me who is on the stair. I am with you.",
          "refusal": "Not him. Sound travels. If I fight here, every bailiff on the stair learns where we came from.",
          "afterFight": {
            "guard": "Listen. Nothing now. There was one set of boots in that office, and it has stopped. Breathe a little.",
            "tunnel": "The fire is quieter without it. I did not know the dead could be that loud."
          },
          "moment": {
            "request": "The shoes on that ledge belong to people. When you write your report, leave the drain out. Let the city go on not knowing.",
            "kept": "A blank space in your notes. The water keeps it. So will I.",
            "broken": "You gave them the path. Tomorrow there will be a lantern on that ledge. I have to warn them before it arrives."
          },
          "judgment": {
            "good": "The gate changed hands, and the ledge is still nobody’s business. That is the best kind of quiet.",
            "bad": "You made it quieter by removing the people who might have spoken. I know that sort of quiet. I am leaving.",
            "depart": "You go upriver. I stay by the water. Someone has to keep watch on the ledge.",
            "mourning": "I listened for you all the way down the ramp. Then I stopped hearing you. I will tell the water your name."
          },
          "discuss": {
            "guard": {
              "accepted": "I will stay near. You will not hear me, but I will be there.",
              "refused": "I work better at a distance. Close, I am only another target."
            },
            "engage": {
              "accepted": "If the way is clear, I will take the shot.",
              "refused": "No. Noise brings more of them. I will not open that door."
            },
            "withdraw": {
              "accepted": "Yes. I already know three ways out.",
              "refused": "Not yet. The families’ ledge is below us. I do not leave it unwatched."
            }
          },
          "barks": {
            "engage": "Clear line. Loosing.",
            "guard": "Behind you. Quietly.",
            "hold": "Still now. Let them pass.",
            "withdraw": "This way. Soft steps.",
            "defend": "That blade is loud. I heard it coming."
          },
          "returning": {
            "kept": "You walk like the last one. They kept the ledge out of their notes and left the stair alive. I will show you the quiet ways too.",
            "mourned": "The last outsider I guided went down to the kilns and did not come up. I still listen for their step on the ramp.",
            "absent": "Moved the families to a new crossing and has not come back to the bath. Left word: no more outsiders on the water."
          }
        }
      }
    ],
    "seed-alpha": [
      {
        "candidateKey": "displaced-mason-halven-pell",
        "templateId": "displaced-mason",
        "templateTitle": "The Displaced Mason",
        "archetype": "A quarry or public-works worker with militia experience, heavy tools, and a family dependent on wages. Understands structures and refuses to destroy infrastructure people need.",
        "culture": "Veyrathi",
        "name": "Halven Pell",
        "equipment": [
          "item:blade-iron",
          "item:knife-belt",
          "item:gambeson",
          "item:hook-sluicekeeper"
        ],
        "person": {
          "id": "person:companion-displaced-mason-halven-pell",
          "lineageKey": "lineage:displaced-mason-halven-pell",
          "presentationKey": "presentation:actor-outsider-axe-rotation",
          "kinshipKeys": [
            "kinship:displaced-mason-halven-pell-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Halven Pell",
            "origin": "escaped-worker",
            "culture": "Veyrathi",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "quarry-masonry",
              "structural-knowledge"
            ],
            "abilities": [
              "pry-pawl",
              "cleave"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 10,
            "maxHp": 10,
            "allegiances": [],
            "oaths": [
              "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Seize the initiative",
              "Preserve independence"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Veyrathi customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-displaced-mason-halven-pell",
          "temperament": {
            "boldness": 8,
            "loyalty": 5
          },
          "obligations": [
            {
              "id": "obligation:displaced-mason-civil-infrastructure-displaced-mason-halven-pell",
              "description": "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "Not him, not here. I build things. I will stand like a pier and let him wear himself out."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:displaced-mason-refuse-reckless-charge-displaced-mason-halven-pell",
              "kind": "refuse-goal",
              "goal": "engage"
            }
          ],
          "preferences": {
            "engage": 9,
            "guard": 4,
            "hold": 3,
            "withdraw": 1
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:displaced-mason-displaced-mason-halven-pell",
          "personId": "person:companion-displaced-mason-halven-pell",
          "description": "Earn forty cuts and secure two sacks of flour for the dependents in the lower quarry barracks.",
          "prerequisites": {
            "all": [
              "hired:displaced-mason-halven-pell"
            ],
            "any": [],
            "none": [
              "departed:displaced-mason-halven-pell"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:displaced-mason-displaced-mason-halven-pell",
            "status": "achieved",
            "summary": "Delivered forty cuts and sixty pounds of clean flour to the quarry quarters, securing food through the season.",
            "effects": {
              "add": [
                "obligation-resolved:displaced-mason-halven-pell",
                "loyalty-proven:displaced-mason-halven-pell"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:displaced-mason-displaced-mason-halven-pell",
            "status": "compromised",
            "summary": "Accepted half-pay after refusing to collapse the canal arch, forcing the family onto quarter-rations.",
            "effects": {
              "add": [
                "obligation-compromised:displaced-mason-halven-pell"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:displaced-mason-displaced-mason-halven-pell",
            "status": "abandoned",
            "summary": "Walked away from the party after the player ordered the sluice gates smashed to flood the lower market.",
            "effects": {
              "add": [
                "departed:displaced-mason-halven-pell"
              ],
              "remove": [
                "companion-active:displaced-mason-halven-pell"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-displaced-mason-halven-pell",
            "intention": {
              "kind": "ask",
              "label": "Speak with Halven Pell (The Displaced Mason)"
            },
            "text": "Four children, one chisel, and a lift that stopped because somebody bought a cheap bearing. Hire me and I fix your problems. Ask me to break a wall people sleep behind and I fix you instead.",
            "disclosure": "essential",
            "firstEncounterSummary": "Recruit a muscular stoneworker fighting for family subsistence without compromising civic ethics.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:displaced-mason-halven-pell",
                "rejected:displaced-mason-halven-pell",
                "dead:displaced-mason-halven-pell"
              ]
            },
            "effects": {
              "add": [
                "met:displaced-mason-halven-pell"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-displaced-mason-halven-pell",
            "intention": {
              "kind": "offer",
              "label": "Guarantee twelve cuts and swear not to harm civil works"
            },
            "text": "Twelve cuts! The children eat, the stone stands, and you get the best shoulder on the Silt Stair. Everyone wins but the guard.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Halven Pell.",
            "prerequisites": {
              "all": [
                "met:displaced-mason-halven-pell"
              ],
              "any": [],
              "none": [
                "hired:displaced-mason-halven-pell",
                "dead:displaced-mason-halven-pell"
              ]
            },
            "effects": {
              "add": [
                "hired:displaced-mason-halven-pell",
                "companion-active:displaced-mason-halven-pell"
              ],
              "remove": [
                "available:displaced-mason-halven-pell"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "guarantee:civil-infrastructure"
            ],
            "socialDifficulty": 3
          },
          {
            "id": "dialogue:approach-engage-displaced-mason-halven-pell",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "Chasing men down corridors is how walls come down on people. I will hold instead.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:displaced-mason-halven-pell"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-halven-pell",
                "departed:displaced-mason-halven-pell"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:displaced-mason-halven-pell"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-displaced-mason-halven-pell",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "Stand behind me. I am wider than most doors.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:displaced-mason-halven-pell"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-halven-pell",
                "departed:displaced-mason-halven-pell"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:displaced-mason-halven-pell"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-displaced-mason-halven-pell",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "Agreed. Dead masons build nothing.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:displaced-mason-halven-pell"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-halven-pell",
                "departed:displaced-mason-halven-pell"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:displaced-mason-halven-pell"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-displaced-mason-halven-pell",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "See the walkway, under the red mark? A length of timber and a wedge, two cuts, and it holds. Lift that pawl instead and the water takes it, and whoever sleeps behind it.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:displaced-mason-halven-pell"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-halven-pell"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:displaced-mason-halven-pell"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-displaced-mason-halven-pell",
            "intention": {
              "kind": "leave",
              "label": "Halven Pell departs over contract violation"
            },
            "text": "You lifted the pawl. I told you what was behind that plank. Keep the toll box. I am going to help them bail.",
            "disclosure": "essential",
            "firstEncounterSummary": "Halven Pell leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:displaced-mason-halven-pell",
                "boundary-breached:displaced-mason-halven-pell"
              ],
              "any": [],
              "none": [
                "dead:displaced-mason-halven-pell",
                "departed:displaced-mason-halven-pell"
              ]
            },
            "effects": {
              "add": [
                "departed:displaced-mason-halven-pell"
              ],
              "remove": [
                "companion-active:displaced-mason-halven-pell"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-displaced-mason-halven-pell",
          "name": "Halven Pell",
          "templateId": "displaced-mason",
          "memorialNote": "A heavy leather apron crusted with lime and dried sweat. In the pocket is a copper token stamped with the quarry union mark, worn flat by nervous thumbs.",
          "campNotice": "A pile of chipped cobblestones sits neatly stacked by the bedroll. The mason's place in the meal line is vacant.",
          "witnessReaction": "He braced the cracked lintel with his own shoulders while the rest of us scrambled out. When the stone dropped, he didn't scream."
        },
        "absenceResponse": {
          "companionId": "person:companion-displaced-mason-halven-pell",
          "name": "Halven Pell",
          "templateId": "displaced-mason",
          "reason": "Boundary violated: deliberate destruction of civilian canal infrastructure.",
          "departureLine": "You lifted the pawl. I told you what was behind that plank. Keep the toll box. I am going to help them bail.",
          "campNotice": "A heavy stone mallet laid across an unmortared boundary stone."
        },
        "voice": {
          "voiceId": "mason-pier",
          "care": {
            "offered": "You brought a {item} for the mason? Sensible. Even good stone cracks.",
            "treat": "Something needs patching. Happily, it is still attached.",
            "remember": "{giver} shared medicine when I needed looking after. A sound thing to build a memory on.",
            "aid": "That needs patching before you put weight on it. Sit down; I have what we need.",
            "rememberAid": "I patched {patient} after a fight. More blood than a mason likes to see, but my supplies did their work."
          },
          "manner": "Loud, proud craftsman; stone and building metaphors; jokes; bold.",
          "temperament": {
            "boldness": 8,
            "loyalty": 5
          },
          "obligation": "Wages feed four children in the quarry sheds. Will not break anything people live under.",
          "opening": "Four children, one chisel, and a lift that stopped because somebody bought a cheap bearing. Hire me and I fix your problems. Ask me to break a wall people sleep behind and I fix you instead.",
          "hire": "Twelve cuts! The children eat, the stone stands, and you get the best shoulder on the Silt Stair. Everyone wins but the guard.",
          "hired": "Paid and standing, like a good pier. Point me at something that needs holding up.",
          "refusal": "Not him, not here. I build things. I will stand like a pier and let him wear himself out.",
          "afterFight": {
            "guard": "Down like a bad lintel. Too much weight on one side and nothing underneath. Noll never checked what he was building on.",
            "tunnel": "It was still feeding the kiln. Good worker, poor foreman. Whoever set that task should be carrying the coal themselves."
          },
          "moment": {
            "request": "See the walkway, under the red mark? A length of timber and a wedge, two cuts, and it holds. Lift that pawl instead and the water takes it, and whoever sleeps behind it.",
            "kept": "Two cuts and a wedge! Best repair of the week, and I did not even have to swear at it.",
            "broken": "You lifted the pawl. I told you what was behind that plank. Keep the toll box. I am going to help them bail."
          },
          "judgment": {
            "good": "Grain moving, stone standing, children fed. If every job ended like this I would have to find something new to complain about.",
            "bad": "Burned or sold, it comes to the same: people pay for your hurry. My children cannot eat your excuses. I am off.",
            "depart": "Leaving with the lift half an answer? Go on. I will stay until the escrow opens and the arch is still standing.",
            "mourning": "Four children waiting on me, and you are the one who does not go home. I will set a stone for you. A good one."
          },
          "discuss": {
            "guard": {
              "accepted": "Stand behind me. I am wider than most doors.",
              "refused": "I am better at the wall than at your elbow. Let me brace something."
            },
            "engage": {
              "accepted": "If he runs, I will catch him. I carry stone uphill for a living.",
              "refused": "Chasing men down corridors is how walls come down on people. I will hold instead."
            },
            "withdraw": {
              "accepted": "Agreed. Dead masons build nothing.",
              "refused": "Leave? With that wall ready to go? I am staying where I can keep it up."
            }
          },
          "barks": {
            "engage": "Coming through. Mind the stone.",
            "guard": "Behind me. I am wider.",
            "hold": "Feet set, like a pier.",
            "withdraw": "Back off. This span will not hold.",
            "defend": "Too much weight on one side. I can answer that."
          },
          "returning": {
            "kept": "Another outsider on my stair! The last one who hired me left the walkway standing and walked out alive. Buy me a wedge and we will get on.",
            "mourned": "The outsider before you never came back from the kilns. I set a stone for them by the quarry path. Try not to need another.",
            "absent": "Back at the quarry sheds, bailing out the flooded rooms. Told anyone listening that outsiders pay two cuts and cost a wall."
          }
        }
      },
      {
        "candidateKey": "unpaid-shield-daska-en-or",
        "templateId": "unpaid-shield",
        "templateTitle": "The Unpaid Shield",
        "archetype": "A former professional infantry soldier seeking the release of a dependent from a service debt. Usually protects exposed allies, dislikes unnecessary chases, and refuses unpaid military duties.",
        "culture": "Talruni",
        "name": "Daska En Or",
        "equipment": [
          "item:shield-round",
          "item:spear-bronze",
          "item:gambeson",
          "item:knife-belt"
        ],
        "person": {
          "id": "person:companion-unpaid-shield-daska-en-or",
          "lineageKey": "lineage:unpaid-shield-daska-en-or",
          "presentationKey": "presentation:actor-unpaid-shield-rotation",
          "kinshipKeys": [
            "kinship:unpaid-shield-daska-en-or-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Daska En Or",
            "origin": "disgraced-legionary",
            "culture": "Talruni",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "shield-discipline",
              "spear-drill"
            ],
            "abilities": [
              "brace-drill"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 10,
            "maxHp": 10,
            "allegiances": [],
            "oaths": [
              "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Conserve strength",
              "Protect the party"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Talruni customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-unpaid-shield-daska-en-or",
          "temperament": {
            "boldness": 3,
            "loyalty": 8
          },
          "obligations": [
            {
              "id": "obligation:unpaid-shield-dependent-debt-unpaid-shield-daska-en-or",
              "description": "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "That charge is not in the price. I am not paying my sister’s debt with my own blood."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:unpaid-shield-danger-limit-unpaid-shield-daska-en-or",
              "kind": "danger-limit",
              "dangerLimit": 36
            }
          ],
          "preferences": {
            "engage": 4,
            "guard": 9,
            "hold": 6,
            "withdraw": 8
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:unpaid-shield-unpaid-shield-daska-en-or",
          "personId": "person:companion-unpaid-shield-daska-en-or",
          "description": "Secure 24 cuts to discharge the sister's labour bond from the concession registry.",
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-daska-en-or"
            ],
            "any": [],
            "none": [
              "departed:unpaid-shield-daska-en-or"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:unpaid-shield-unpaid-shield-daska-en-or",
            "status": "achieved",
            "summary": "Paid 24 cuts directly to the concession clerk, securing the stamped deed of release for his sister.",
            "effects": {
              "add": [
                "obligation-resolved:unpaid-shield-daska-en-or",
                "loyalty-proven:unpaid-shield-daska-en-or"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:unpaid-shield-unpaid-shield-daska-en-or",
            "status": "compromised",
            "summary": "Negotiated a half-term deferral with the Reeve in exchange for testimony against the concession bookkeeper.",
            "effects": {
              "add": [
                "obligation-compromised:unpaid-shield-daska-en-or"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:unpaid-shield-unpaid-shield-daska-en-or",
            "status": "abandoned",
            "summary": "Departed after the employer repeatedly refused to allocate contract shares towards the bond.",
            "effects": {
              "add": [
                "departed:unpaid-shield-daska-en-or"
              ],
              "remove": [
                "companion-active:unpaid-shield-daska-en-or"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-unpaid-shield-daska-en-or",
            "intention": {
              "kind": "ask",
              "label": "Speak with Daska En Or (The Unpaid Shield)"
            },
            "text": "Eleven cuts and a half. That is what stands between my sister and the end of her bond. I count it every morning. It has not got smaller by itself.",
            "disclosure": "essential",
            "firstEncounterSummary": "Hire an experienced shieldman working to clear a family labour debt.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:unpaid-shield-daska-en-or",
                "rejected:unpaid-shield-daska-en-or",
                "dead:unpaid-shield-daska-en-or"
              ]
            },
            "effects": {
              "add": [
                "met:unpaid-shield-daska-en-or"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-unpaid-shield-daska-en-or",
            "intention": {
              "kind": "offer",
              "label": "Agree to twelve-cut wage in escrow"
            },
            "text": "Twelve. Good. The half-cut goes on the next job. I will keep you standing; I will not charge anything that is not in the price.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Daska En Or.",
            "prerequisites": {
              "all": [
                "met:unpaid-shield-daska-en-or"
              ],
              "any": [],
              "none": [
                "hired:unpaid-shield-daska-en-or",
                "dead:unpaid-shield-daska-en-or"
              ]
            },
            "effects": {
              "add": [
                "hired:unpaid-shield-daska-en-or",
                "companion-active:unpaid-shield-daska-en-or"
              ],
              "remove": [
                "available:unpaid-shield-daska-en-or"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "escrow:guaranteed-wage"
            ],
            "socialDifficulty": 3
          },
          {
            "id": "dialogue:approach-engage-unpaid-shield-daska-en-or",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "A chase is not in the price. My sister’s bond does not get shorter because I ran after somebody.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-daska-en-or"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-daska-en-or",
                "departed:unpaid-shield-daska-en-or"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:unpaid-shield-daska-en-or"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-unpaid-shield-daska-en-or",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "Close. Two paces, left side. Call out if you are hit; I cannot count wounds I cannot see.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-daska-en-or"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-daska-en-or",
                "departed:unpaid-shield-daska-en-or"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:unpaid-shield-daska-en-or"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-unpaid-shield-daska-en-or",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "Agreed. A living guard earns more than a dead one. I have done that sum as well.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-daska-en-or"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-daska-en-or",
                "departed:unpaid-shield-daska-en-or"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:unpaid-shield-daska-en-or"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-unpaid-shield-daska-en-or",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "While you are at the desk, ask about the second toll on the stair. Four cuts a crossing, twice. I have the figures for the porters, if the clerk wants them.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-daska-en-or"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-daska-en-or"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:unpaid-shield-daska-en-or"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-unpaid-shield-daska-en-or",
            "intention": {
              "kind": "leave",
              "label": "Daska En Or departs over contract violation"
            },
            "text": "Four cuts from the porters’ bowl. I know exactly what four cuts buys. Pay me out; I am finished counting for you.",
            "disclosure": "essential",
            "firstEncounterSummary": "Daska En Or leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-daska-en-or",
                "boundary-breached:unpaid-shield-daska-en-or"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-daska-en-or",
                "departed:unpaid-shield-daska-en-or"
              ]
            },
            "effects": {
              "add": [
                "departed:unpaid-shield-daska-en-or"
              ],
              "remove": [
                "companion-active:unpaid-shield-daska-en-or"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-unpaid-shield-daska-en-or",
          "name": "Daska En Or",
          "templateId": "unpaid-shield",
          "memorialNote": "The shield is dented along the rim, bearing seven tally cuts. In the tunic is an unsubmitted receipt for eighteen cuts addressed to the Silt Stair labour depot.",
          "campNotice": "The shield stands upright by the tent flap, but no one has checked the strap rivets since dusk.",
          "witnessReaction": "He took two spear points that were meant for the outsider. He never asked whether the coin was real."
        },
        "absenceResponse": {
          "companionId": "person:companion-unpaid-shield-daska-en-or",
          "name": "Daska En Or",
          "templateId": "unpaid-shield",
          "reason": "Contract breached: unpaid military charges demanded without bond compensation.",
          "departureLine": "Four cuts from the porters’ bowl. I know exactly what four cuts buys. Pay me out; I am finished counting for you.",
          "campNotice": "An empty pallet and a neatly stacked pile of ration tins marked 'returned'."
        },
        "voice": {
          "voiceId": "shield-tally",
          "care": {
            "offered": "One {item}. I will count it among the things that get us home.",
            "treat": "Hold your ground. I need one moment for this wound.",
            "remember": "{giver} gave me supplies out of their own pack. That debt is on my tally.",
            "aid": "One wound still open. Yours. Sit down; I have supplies for it.",
            "rememberAid": "I used my supplies on {patient} after a fight. Two people still standing was the better tally."
          },
          "manner": "Counts everything aloud; dry; fond of her sister; cautious, stays close.",
          "temperament": {
            "boldness": 3,
            "loyalty": 8
          },
          "obligation": "Wages paid straight to the depot clerk, against a sister’s bond. No unpaid assaults.",
          "opening": "Eleven cuts and a half. That is what stands between my sister and the end of her bond. I count it every morning. It has not got smaller by itself.",
          "hire": "Twelve. Good. The half-cut goes on the next job. I will keep you standing; I will not charge anything that is not in the price.",
          "hired": "Twelve paid, eleven and a half still owed on my sister. I stay close. Tell me where we are going and I will count the steps.",
          "refusal": "That charge is not in the price. I am not paying my sister’s debt with my own blood.",
          "afterFight": {
            "guard": "One guard, one doorway. I counted his breaths before he drew: eleven, then nothing. Are you hurt, or only shaking?",
            "tunnel": "It kept stoking until it could not. Somebody set it that task and never came back to count the cost."
          },
          "moment": {
            "request": "While you are at the desk, ask about the second toll on the stair. Four cuts a crossing, twice. I have the figures for the porters, if the clerk wants them.",
            "kept": "Struck from the schedule. Four cuts a crossing the porters keep. I will add that up again tonight, just to hear the sum.",
            "broken": "Four cuts from the porters’ bowl. I know exactly what four cuts buys. Pay me out; I am finished counting for you."
          },
          "judgment": {
            "good": "Paid in full, to the clerk, stamped. My sister walks out of the depot on her own feet. I will not forget whose cuts they were.",
            "bad": "You kept the kilns working for a repair fund. There is no column in any ledger for that. I am going.",
            "depart": "You are leaving before the account is closed. I am not. Somebody has to be here when the clerk opens.",
            "mourning": "Twelve cuts in escrow, and one outsider on the floor. The clerk will pay the first. I will make sure someone hears about the second."
          },
          "discuss": {
            "guard": {
              "accepted": "Close. Two paces, left side. Call out if you are hit; I cannot count wounds I cannot see.",
              "refused": "I stay where the shield does some good. That is not always beside you."
            },
            "engage": {
              "accepted": "If he gives ground and the ground is paid for, yes.",
              "refused": "A chase is not in the price. My sister’s bond does not get shorter because I ran after somebody."
            },
            "withdraw": {
              "accepted": "Agreed. A living guard earns more than a dead one. I have done that sum as well.",
              "refused": "I leave when the contract ends, not when it gets frightening. Otherwise the numbers mean nothing."
            }
          },
          "barks": {
            "engage": "He is open. Taking it.",
            "guard": "On your left. Two paces.",
            "hold": "Holding. Let them come to the rim.",
            "withdraw": "Too many. Stepping back to count.",
            "defend": "Too much weight in that swing. I mean to get home."
          },
          "returning": {
            "kept": "You came down the same stair as the last outsider who hired me. That one paid to the cut and walked out alive. I remember both. Do you mean to match them?",
            "mourned": "The outsider before you died on the kiln ramp. The escrow still paid; I still counted it. Tell me you plan better.",
            "absent": "Took paid work at the depot instead. Told Melian that clerks at least write down what they take."
          }
        }
      },
      {
        "candidateKey": "towpath-scout-arel-vall",
        "templateId": "towpath-scout",
        "templateTitle": "The Towpath Scout",
        "archetype": "A ferry worker or canal guide selling local knowledge after losing regular work. Notices routes, uses a bow or javelins, values discretion, and refuses to expose escape routes used by vulnerable people.",
        "culture": "Orsene",
        "name": "Arel Vall",
        "equipment": [
          "item:bow-ash",
          "item:knife-belt",
          "item:satchel",
          "item:field-dressing"
        ],
        "person": {
          "id": "person:companion-towpath-scout-arel-vall",
          "lineageKey": "lineage:towpath-scout-arel-vall",
          "presentationKey": "presentation:actor-towpath-scout-rotation",
          "kinshipKeys": [
            "kinship:towpath-scout-arel-vall-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Arel Vall",
            "origin": "escaped-worker",
            "culture": "Orsene",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "towpath-recon",
              "skirmish-archery"
            ],
            "abilities": [
              "loose-arrow",
              "quick-cut"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 8,
            "maxHp": 8,
            "allegiances": [],
            "oaths": [
              "Shield the hidden towpath cuts and weir crawls used by destitute runaways; refuses any action or disclosure that exposes these paths to the canal bailiffs."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Conserve strength",
              "Preserve independence"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Orsene customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-towpath-scout-arel-vall",
          "temperament": {
            "boldness": 1,
            "loyalty": 5
          },
          "obligations": [
            {
              "id": "obligation:towpath-scout-towpath-escape-routes-towpath-scout-arel-vall",
              "description": "Shield the hidden towpath cuts and weir crawls used by destitute runaways; refuses any action or disclosure that exposes these paths to the canal bailiffs.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "I cannot. If they see my face they will know where I came from. I am staying back."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:towpath-scout-danger-limit-towpath-scout-arel-vall",
              "kind": "danger-limit",
              "dangerLimit": 26
            }
          ],
          "preferences": {
            "engage": 1,
            "guard": 6,
            "hold": 9,
            "withdraw": 10
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:towpath-scout-towpath-scout-arel-vall",
          "personId": "person:companion-towpath-scout-arel-vall",
          "description": "Guide four fugitive families past the toll chain without exposing the hidden culvert to the bailiffs.",
          "prerequisites": {
            "all": [
              "hired:towpath-scout-arel-vall"
            ],
            "any": [],
            "none": [
              "departed:towpath-scout-arel-vall"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:towpath-scout-towpath-scout-arel-vall",
            "status": "achieved",
            "summary": "Guided four families past the toll chain under cover of morning silt fog without alerting the watch.",
            "effects": {
              "add": [
                "obligation-resolved:towpath-scout-arel-vall",
                "loyalty-proven:towpath-scout-arel-vall"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:towpath-scout-towpath-scout-arel-vall",
            "status": "compromised",
            "summary": "Traded an obsolete bypass route to the customs inspector to divert attention from the active cut.",
            "effects": {
              "add": [
                "obligation-compromised:towpath-scout-arel-vall"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:towpath-scout-towpath-scout-arel-vall",
            "status": "abandoned",
            "summary": "Fled into the reeds after the player attempted to sell the towpath map to the basin toll collector.",
            "effects": {
              "add": [
                "departed:towpath-scout-arel-vall"
              ],
              "remove": [
                "companion-active:towpath-scout-arel-vall"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-towpath-scout-arel-vall",
            "intention": {
              "kind": "ask",
              "label": "Speak with Arel Vall (The Towpath Scout)"
            },
            "text": "I came up through that drain myself, three winters ago. I know every step of it in the dark. I will guide you. I will not be seen doing it.",
            "disclosure": "essential",
            "firstEncounterSummary": "Engage a quiet canal guide who knows unseen routes through the flooded terraces.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:towpath-scout-arel-vall",
                "rejected:towpath-scout-arel-vall",
                "dead:towpath-scout-arel-vall"
              ]
            },
            "effects": {
              "add": [
                "met:towpath-scout-arel-vall"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-towpath-scout-arel-vall",
            "intention": {
              "kind": "offer",
              "label": "Pledge secrecy regarding escape culverts and pay ten cuts"
            },
            "text": "All right. Twelve cuts. I stay behind you, and if the bailiffs come, I was never here.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Arel Vall.",
            "prerequisites": {
              "all": [
                "met:towpath-scout-arel-vall"
              ],
              "any": [],
              "none": [
                "hired:towpath-scout-arel-vall",
                "dead:towpath-scout-arel-vall"
              ]
            },
            "effects": {
              "add": [
                "hired:towpath-scout-arel-vall",
                "companion-active:towpath-scout-arel-vall"
              ],
              "remove": [
                "available:towpath-scout-arel-vall"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "silence:escape-routes"
            ],
            "socialDifficulty": 2
          },
          {
            "id": "dialogue:approach-engage-towpath-scout-arel-vall",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "No. I do not chase people. People chased me.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:towpath-scout-arel-vall"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-arel-vall",
                "departed:towpath-scout-arel-vall"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:towpath-scout-arel-vall"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-towpath-scout-arel-vall",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "I will try. I will be close. I might shake.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:towpath-scout-arel-vall"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-arel-vall",
                "departed:towpath-scout-arel-vall"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:towpath-scout-arel-vall"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-towpath-scout-arel-vall",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "Yes. Yes, please. I know where.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:towpath-scout-arel-vall"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-arel-vall",
                "departed:towpath-scout-arel-vall"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:towpath-scout-arel-vall"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-towpath-scout-arel-vall",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "Please. The shoes on the ledge. Do not put it in the report. I was one of those shoes.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:towpath-scout-arel-vall"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-arel-vall"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:towpath-scout-arel-vall"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-towpath-scout-arel-vall",
            "intention": {
              "kind": "leave",
              "label": "Arel Vall departs over contract violation"
            },
            "text": "You told them. You told them about the ledge. I have to go and warn them. Do not follow me.",
            "disclosure": "essential",
            "firstEncounterSummary": "Arel Vall leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:towpath-scout-arel-vall",
                "boundary-breached:towpath-scout-arel-vall"
              ],
              "any": [],
              "none": [
                "dead:towpath-scout-arel-vall",
                "departed:towpath-scout-arel-vall"
              ]
            },
            "effects": {
              "add": [
                "departed:towpath-scout-arel-vall"
              ],
              "remove": [
                "companion-active:towpath-scout-arel-vall"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-towpath-scout-arel-vall",
          "name": "Arel Vall",
          "templateId": "towpath-scout",
          "memorialNote": "An ash bow with a worn cord, wrapped in greased oilcloth. Inside the quiver is a charcoal map of water depths, unmarked by any official seal.",
          "campNotice": "A bundle of willow cord hangs by the cold brazier. The scout didn't return from the evening canal watch.",
          "witnessReaction": "She slipped through thirty patrols without a ripple. It took a blind crossbow in the fog to stop her."
        },
        "absenceResponse": {
          "companionId": "person:companion-towpath-scout-arel-vall",
          "name": "Arel Vall",
          "templateId": "towpath-scout",
          "reason": "Boundary violated: secret towpath escape route betrayed to canal guards.",
          "departureLine": "You told them. You told them about the ledge. I have to go and warn them. Do not follow me.",
          "campNotice": "A footprint in wet clay near the canal edge, leading into the deep reed bed."
        },
        "voice": {
          "voiceId": "scout-drain",
          "care": {
            "offered": "I can carry the {item}. Thank you. I know when to stop and use it.",
            "treat": "I found room. Let me stop this bleeding.",
            "remember": "{giver} gave me supplies for my wounds. Nobody asked me to earn them back.",
            "aid": "You are hurt. I can help now. Please, sit still.",
            "rememberAid": "{patient} needed help after the fight. I had something to give. I remember that."
          },
          "manner": "Nervous former runaway; short sentences; frank; timid in a fight but fiercely protective.",
          "temperament": {
            "boldness": 1,
            "loyalty": 5
          },
          "obligation": "Came up through the drain as a runaway. Guards the path for those still running; will not be seen by bailiffs.",
          "opening": "I came up through that drain myself, three winters ago. I know every step of it in the dark. I will guide you. I will not be seen doing it.",
          "hire": "All right. Twelve cuts. I stay behind you, and if the bailiffs come, I was never here.",
          "hired": "I am here. Behind you. Keep off the main stair if you can.",
          "refusal": "I cannot. If they see my face they will know where I came from. I am staying back.",
          "afterFight": {
            "guard": "I closed my eyes. I heard it, though. Is it over? It is over.",
            "tunnel": "It might have been someone from the drain. Some of us never got out. I keep thinking that."
          },
          "moment": {
            "request": "Please. The shoes on the ledge. Do not put it in the report. I was one of those shoes.",
            "kept": "Thank you. They will never know it was you. That is how it is supposed to work.",
            "broken": "You told them. You told them about the ledge. I have to go and warn them. Do not follow me."
          },
          "judgment": {
            "good": "Paid, and the ledge still hidden. I did not think outsiders did both. I am glad I was wrong.",
            "bad": "You kept it all running. You are no better than the people I ran from. I am going.",
            "depart": "You are leaving? I am not. This is the only place I know how to hide.",
            "mourning": "I hid while you died. I always hide. I will take your name down the drain and say it where it is safe."
          },
          "discuss": {
            "guard": {
              "accepted": "I will try. I will be close. I might shake.",
              "refused": "I cannot be seen next to you. Please do not ask that."
            },
            "engage": {
              "accepted": "If he is running away, maybe. Running is different.",
              "refused": "No. I do not chase people. People chased me."
            },
            "withdraw": {
              "accepted": "Yes. Yes, please. I know where.",
              "refused": "Not without the others. I left people once already."
            }
          },
          "barks": {
            "engage": "Now, while he is turned.",
            "guard": "Here. Right behind you.",
            "hold": "Stay down. Do not move.",
            "withdraw": "Out. Through here, quickly.",
            "defend": "I saw the shoulder turn. Not this time."
          },
          "returning": {
            "kept": "You are not the last one, are you? The last outsider kept the ledge secret and got away. I still owe them for that.",
            "mourned": "The outsider I guided before you died at the kilns. I hid. I am trying not to hide this time.",
            "absent": "Went back down the drain and has not come up. Left a note under the bath step: outsiders tell."
          }
        }
      }
    ],
    "seed-beta": [
      {
        "candidateKey": "former-mortuary-guard-jessa-menn",
        "templateId": "former-mortuary-guard",
        "templateTitle": "The Former Mortuary Guard",
        "archetype": "A funerary escort who left the concession after a disturbing incident in the Quiet Kilns. Uses a shield and short spear, recognises burial practices, and refuses corpse desecration.",
        "culture": "Orsene",
        "name": "Jessa Menn",
        "equipment": [
          "item:shield-round",
          "item:spear-bronze",
          "item:gambeson",
          "item:oil-flask"
        ],
        "person": {
          "id": "person:companion-former-mortuary-guard-jessa-menn",
          "lineageKey": "lineage:former-mortuary-guard-jessa-menn",
          "presentationKey": "presentation:actor-mortuary-guard-rotation",
          "kinshipKeys": [
            "kinship:former-mortuary-guard-jessa-menn-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Jessa Menn",
            "origin": "disgraced-legionary",
            "culture": "Orsene",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "funerary-vigil",
              "spear-drill"
            ],
            "abilities": [
              "thrust",
              "set-spear"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 9,
            "maxHp": 9,
            "allegiances": [],
            "oaths": [
              "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Seize the initiative",
              "Preserve independence"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Orsene customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-former-mortuary-guard-jessa-menn",
          "temperament": {
            "boldness": 9,
            "loyalty": 3
          },
          "obligations": [
            {
              "id": "obligation:former-mortuary-guard-burial-sanctity-former-mortuary-guard-jessa-menn",
              "description": "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "I do not stab the dead. Rude, pointless, and they never stay down anyway. Go round."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:former-mortuary-guard-danger-limit-former-mortuary-guard-jessa-menn",
              "kind": "danger-limit",
              "dangerLimit": 34
            }
          ],
          "preferences": {
            "engage": 9,
            "guard": 3,
            "hold": 0,
            "withdraw": 1
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:former-mortuary-guard-former-mortuary-guard-jessa-menn",
          "personId": "person:companion-former-mortuary-guard-jessa-menn",
          "description": "Recover stolen corpse records and secure honest burial in salted earth for the desecrated kiln remains.",
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-jessa-menn"
            ],
            "any": [],
            "none": [
              "departed:former-mortuary-guard-jessa-menn"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:former-mortuary-guard-former-mortuary-guard-jessa-menn",
            "status": "achieved",
            "summary": "Recovered three stolen corpses from the cooling gallery and saw them properly interred in salted earth.",
            "effects": {
              "add": [
                "obligation-resolved:former-mortuary-guard-jessa-menn",
                "loyalty-proven:former-mortuary-guard-jessa-menn"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:former-mortuary-guard-former-mortuary-guard-jessa-menn",
            "status": "compromised",
            "summary": "Allowed an unverified binder to perform a diagnostic inspection only under direct, armed supervision.",
            "effects": {
              "add": [
                "obligation-compromised:former-mortuary-guard-jessa-menn"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:former-mortuary-guard-former-mortuary-guard-jessa-menn",
            "status": "abandoned",
            "summary": "Severed ties after the player attempted to harvest limbs or bones for necromantic reagents.",
            "effects": {
              "add": [
                "departed:former-mortuary-guard-jessa-menn"
              ],
              "remove": [
                "companion-active:former-mortuary-guard-jessa-menn"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-former-mortuary-guard-jessa-menn",
            "intention": {
              "kind": "ask",
              "label": "Speak with Jessa Menn (The Former Mortuary Guard)"
            },
            "text": "Burial escort, retired, badly. I have guarded the dead from grave robbers, family, priests and once a goat. Somebody down in the kilns is worse than the goat. I would like to meet them.",
            "disclosure": "essential",
            "firstEncounterSummary": "Hire a grim former necropolis watchman who demands strict reverence for the dead and physical proof of claims.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:former-mortuary-guard-jessa-menn",
                "rejected:former-mortuary-guard-jessa-menn",
                "dead:former-mortuary-guard-jessa-menn"
              ]
            },
            "effects": {
              "add": [
                "met:former-mortuary-guard-jessa-menn"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-former-mortuary-guard-jessa-menn",
            "intention": {
              "kind": "offer",
              "label": "Pledge reverence to the mortuary vaults and pay fourteen cuts"
            },
            "text": "Twelve cuts and I am yours until the dead are sorted. I fight hard, talk too much and never touch a body without asking it first.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Jessa Menn.",
            "prerequisites": {
              "all": [
                "met:former-mortuary-guard-jessa-menn"
              ],
              "any": [],
              "none": [
                "hired:former-mortuary-guard-jessa-menn",
                "dead:former-mortuary-guard-jessa-menn"
              ]
            },
            "effects": {
              "add": [
                "hired:former-mortuary-guard-jessa-menn",
                "companion-active:former-mortuary-guard-jessa-menn"
              ],
              "remove": [
                "available:former-mortuary-guard-jessa-menn"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "covenant:no-desecration"
            ],
            "socialDifficulty": 3
          },
          {
            "id": "dialogue:approach-engage-former-mortuary-guard-jessa-menn",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "Not among the stations. Dead folk underfoot. I will not dance on them.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-jessa-menn"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-jessa-menn",
                "departed:former-mortuary-guard-jessa-menn"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:former-mortuary-guard-jessa-menn"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-former-mortuary-guard-jessa-menn",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "I fight better loose. Stand where you like; I will be where it is loud.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-jessa-menn"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-jessa-menn",
                "departed:former-mortuary-guard-jessa-menn"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:former-mortuary-guard-jessa-menn"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-former-mortuary-guard-jessa-menn",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "Retreat? Now you are talking my language. The living one, I mean.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-jessa-menn"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-jessa-menn",
                "departed:former-mortuary-guard-jessa-menn"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:former-mortuary-guard-jessa-menn"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-former-mortuary-guard-jessa-menn",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "You have the pattern. Take the anchor off him. Gently, mind; he has done enough work for three men.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-jessa-menn"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-jessa-menn"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:former-mortuary-guard-jessa-menn"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-former-mortuary-guard-jessa-menn",
            "intention": {
              "kind": "leave",
              "label": "Jessa Menn departs over contract violation"
            },
            "text": "More wax. So the dead get another shift. I have a limit, and it is right there. I am off.",
            "disclosure": "essential",
            "firstEncounterSummary": "Jessa Menn leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:former-mortuary-guard-jessa-menn",
                "boundary-breached:former-mortuary-guard-jessa-menn"
              ],
              "any": [],
              "none": [
                "dead:former-mortuary-guard-jessa-menn",
                "departed:former-mortuary-guard-jessa-menn"
              ]
            },
            "effects": {
              "add": [
                "departed:former-mortuary-guard-jessa-menn"
              ],
              "remove": [
                "companion-active:former-mortuary-guard-jessa-menn"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-former-mortuary-guard-jessa-menn",
          "name": "Jessa Menn",
          "templateId": "former-mortuary-guard",
          "memorialNote": "A bronze shield bearing the faint silhouette of a laurel wreath, tarnished by tomb smoke. Beside it sits a small clay flask of holding salt and an unlit bronze lamp.",
          "campNotice": "The guard's spear is driven upright into the loam. A small pinch of salt has been scattered across the mound.",
          "witnessReaction": "She stood between the animated corpses and the altar until her spear snapped. She died keeping the threshold clean."
        },
        "absenceResponse": {
          "companionId": "person:companion-former-mortuary-guard-jessa-menn",
          "name": "Jessa Menn",
          "templateId": "former-mortuary-guard",
          "reason": "Boundary violated: desecration of burial remains or unproven necromantic practice.",
          "departureLine": "More wax. So the dead get another shift. I have a limit, and it is right there. I am off.",
          "campNotice": "A consecrated funeral tile left standing at the entrance to the abandoned gallery."
        },
        "voice": {
          "voiceId": "guard-gallows",
          "care": {
            "offered": "A {item}. Lovely. I prefer my wages without a funeral deduction.",
            "treat": "Still breathing. Planning to keep the habit.",
            "remember": "{giver} shared their supplies. Very inconsiderate of them; now I have to remember someone fondly.",
            "aid": "Sit down. You are making a poor case for keeping your blood. I can help with that.",
            "rememberAid": "I dressed {patient}’s wounds. They were very inconsiderate wounds. Used up my medicine."
          },
          "manner": "Old hand with gallows humour; blunt; never jokes about the dead themselves; bold, independent.",
          "temperament": {
            "boldness": 9,
            "loyalty": 3
          },
          "obligation": "An old hand of the burial escort. Protects the dead from the living, for a fee.",
          "opening": "Burial escort, retired, badly. I have guarded the dead from grave robbers, family, priests and once a goat. Somebody down in the kilns is worse than the goat. I would like to meet them.",
          "hire": "Twelve cuts and I am yours until the dead are sorted. I fight hard, talk too much and never touch a body without asking it first.",
          "hired": "Still hired, still breathing, still no goats. Where next?",
          "refusal": "I do not stab the dead. Rude, pointless, and they never stay down anyway. Go round.",
          "afterFight": {
            "guard": "There. He is dead and we are not. That is the whole of my trade, really. Someone will want the boots.",
            "tunnel": "Poor devil kept stoking with half its ribs gone. Better worker than most of the living. Let us see it gets paid in rest."
          },
          "moment": {
            "request": "You have the pattern. Take the anchor off him. Gently, mind; he has done enough work for three men.",
            "kept": "Down he goes, polite as you like. That is how the dead ought to leave. Nobody shouting.",
            "broken": "More wax. So the dead get another shift. I have a limit, and it is right there. I am off."
          },
          "judgment": {
            "good": "Nine names, nine bodies, one very tired escort. I have had worse jobs. I have been paid worse, too.",
            "bad": "You let the dead keep working, or you burned them faceless. I do not joke about that. I am going.",
            "depart": "Off you go. I will stay for the carrying. Somebody has to make sure nobody steals the coffins twice.",
            "mourning": "Well. I have escorted a lot of people to their graves. I did not plan to start on my employer. I will walk you there properly."
          },
          "discuss": {
            "guard": {
              "accepted": "I will stay close. Try not to die; it makes the paperwork dreadful.",
              "refused": "I fight better loose. Stand where you like; I will be where it is loud."
            },
            "engage": {
              "accepted": "If he gives ground, I take it, and whatever he is holding.",
              "refused": "Not among the stations. Dead folk underfoot. I will not dance on them."
            },
            "withdraw": {
              "accepted": "Retreat? Now you are talking my language. The living one, I mean.",
              "refused": "I go when I go. Nobody has buried me yet and you are not starting."
            }
          },
          "barks": {
            "engage": "Here we go, then!",
            "guard": "Stay behind the old dog.",
            "hold": "Nobody move. Dead folk underfoot.",
            "withdraw": "Back up. Not ready to be buried.",
            "defend": "A generous swing. Far too generous."
          },
          "returning": {
            "kept": "Ha! Another outsider. The last one hired me, sorted the dead and walked out breathing. Rare. Let us try for twice.",
            "mourned": "The outsider before you, I walked to the grave myself. Did it properly, too. I would rather not get the practice.",
            "absent": "Took a job guarding a cemetery upriver. Said the dead there at least stay where you put them, and outsiders do not."
          }
        }
      },
      {
        "candidateKey": "unpaid-shield-velka-en-taren",
        "templateId": "unpaid-shield",
        "templateTitle": "The Unpaid Shield",
        "archetype": "A former professional infantry soldier seeking the release of a dependent from a service debt. Usually protects exposed allies, dislikes unnecessary chases, and refuses unpaid military duties.",
        "culture": "Talruni",
        "name": "Velka En Taren",
        "equipment": [
          "item:shield-round",
          "item:spear-bronze",
          "item:gambeson",
          "item:knife-belt"
        ],
        "person": {
          "id": "person:companion-unpaid-shield-velka-en-taren",
          "lineageKey": "lineage:unpaid-shield-velka-en-taren",
          "presentationKey": "presentation:actor-unpaid-shield-rotation",
          "kinshipKeys": [
            "kinship:unpaid-shield-velka-en-taren-dependent"
          ],
          "lifecycle": "active",
          "location": "Z03",
          "current": {
            "name": "Velka En Taren",
            "origin": "disgraced-legionary",
            "culture": "Talruni",
            "originalRunId": "run:1",
            "latestRunId": "run:1",
            "equipment": [],
            "inventory": [],
            "skills": [
              "shield-discipline",
              "spear-drill"
            ],
            "abilities": [
              "brace-drill"
            ],
            "preparedRites": [],
            "reagents": [],
            "hp": 10,
            "maxHp": 10,
            "allegiances": [],
            "oaths": [
              "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond."
            ],
            "reputation": [],
            "personalOutcome": "Unresolved",
            "relationships": [
              {
                "personId": "person:pc",
                "fact": "prospective-hireling"
              }
            ],
            "deeds": [],
            "values": [
              "Conserve strength",
              "Preserve independence"
            ],
            "memories": [
              "Arrived at Silt Stair seeking work under Talruni customs."
            ],
            "evidence": []
          },
          "original": null,
          "deathEventId": null
        },
        "contract": {
          "companionId": "person:companion-unpaid-shield-velka-en-taren",
          "temperament": {
            "boldness": 2,
            "loyalty": 2
          },
          "obligations": [
            {
              "id": "obligation:unpaid-shield-dependent-debt-unpaid-shield-velka-en-taren",
              "description": "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond.",
              "forbiddenGoals": [
                "engage"
              ],
              "refusal": "Not that one. Not for this pay."
            }
          ],
          "boundaries": [
            {
              "id": "boundary:unpaid-shield-danger-limit-unpaid-shield-velka-en-taren",
              "kind": "danger-limit",
              "dangerLimit": 36
            }
          ],
          "preferences": {
            "engage": 2,
            "guard": 1,
            "hold": 9,
            "withdraw": 9
          },
          "refusals": [],
          "discussionSequence": 0
        },
        "personalGoal": {
          "id": "goal:unpaid-shield-unpaid-shield-velka-en-taren",
          "personId": "person:companion-unpaid-shield-velka-en-taren",
          "description": "Secure 24 cuts to discharge the sister's labour bond from the concession registry.",
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-velka-en-taren"
            ],
            "any": [],
            "none": [
              "departed:unpaid-shield-velka-en-taren"
            ]
          }
        },
        "personalGoalOutcomes": {
          "achieved": {
            "goalId": "goal:unpaid-shield-unpaid-shield-velka-en-taren",
            "status": "achieved",
            "summary": "Paid 24 cuts directly to the concession clerk, securing the stamped deed of release for his sister.",
            "effects": {
              "add": [
                "obligation-resolved:unpaid-shield-velka-en-taren",
                "loyalty-proven:unpaid-shield-velka-en-taren"
              ],
              "remove": []
            }
          },
          "compromised": {
            "goalId": "goal:unpaid-shield-unpaid-shield-velka-en-taren",
            "status": "compromised",
            "summary": "Negotiated a half-term deferral with the Reeve in exchange for testimony against the concession bookkeeper.",
            "effects": {
              "add": [
                "obligation-compromised:unpaid-shield-velka-en-taren"
              ],
              "remove": []
            }
          },
          "abandoned": {
            "goalId": "goal:unpaid-shield-unpaid-shield-velka-en-taren",
            "status": "abandoned",
            "summary": "Departed after the employer repeatedly refused to allocate contract shares towards the bond.",
            "effects": {
              "add": [
                "departed:unpaid-shield-velka-en-taren"
              ],
              "remove": [
                "companion-active:unpaid-shield-velka-en-taren"
              ]
            }
          }
        },
        "dialogueOptions": [
          {
            "id": "dialogue:intro-unpaid-shield-velka-en-taren",
            "intention": {
              "kind": "ask",
              "label": "Speak with Velka En Taren (The Unpaid Shield)"
            },
            "text": "Daughter’s bonded. I guard. You pay. That is all of it.",
            "disclosure": "essential",
            "firstEncounterSummary": "Hire an experienced shieldman working to clear a family labour debt.",
            "prerequisites": {
              "all": [],
              "any": [],
              "none": [
                "hired:unpaid-shield-velka-en-taren",
                "rejected:unpaid-shield-velka-en-taren",
                "dead:unpaid-shield-velka-en-taren"
              ]
            },
            "effects": {
              "add": [
                "met:unpaid-shield-velka-en-taren"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:contract-unpaid-shield-velka-en-taren",
            "intention": {
              "kind": "offer",
              "label": "Agree to twelve-cut wage in escrow"
            },
            "text": "Coin first. Then I walk behind you.",
            "disclosure": "essential",
            "firstEncounterSummary": "Agree to hiring terms and milestone pay with Velka En Taren.",
            "prerequisites": {
              "all": [
                "met:unpaid-shield-velka-en-taren"
              ],
              "any": [],
              "none": [
                "hired:unpaid-shield-velka-en-taren",
                "dead:unpaid-shield-velka-en-taren"
              ]
            },
            "effects": {
              "add": [
                "hired:unpaid-shield-velka-en-taren",
                "companion-active:unpaid-shield-velka-en-taren"
              ],
              "remove": [
                "available:unpaid-shield-velka-en-taren"
              ]
            },
            "requiredIncentives": [
              "payment:advance-cuts"
            ],
            "requiredProtections": [
              "escrow:guaranteed-wage"
            ],
            "socialDifficulty": 3
          },
          {
            "id": "dialogue:approach-engage-unpaid-shield-velka-en-taren",
            "intention": {
              "kind": "promise",
              "label": "Propose aggressive engagement"
            },
            "text": "No chasing. Not paid for it.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-velka-en-taren"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-velka-en-taren",
                "departed:unpaid-shield-velka-en-taren"
              ]
            },
            "effects": {
              "add": [
                "discussed:engage:unpaid-shield-velka-en-taren"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-guard-unpaid-shield-velka-en-taren",
            "intention": {
              "kind": "promise",
              "label": "Propose guarded positioning"
            },
            "text": "I keep my own distance.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-velka-en-taren"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-velka-en-taren",
                "departed:unpaid-shield-velka-en-taren"
              ]
            },
            "effects": {
              "add": [
                "discussed:guard:unpaid-shield-velka-en-taren"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:approach-withdraw-unpaid-shield-velka-en-taren",
            "intention": {
              "kind": "promise",
              "label": "Propose measured withdrawal"
            },
            "text": "Yes. Always.",
            "disclosure": "supporting",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-velka-en-taren"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-velka-en-taren",
                "departed:unpaid-shield-velka-en-taren"
              ]
            },
            "effects": {
              "add": [
                "discussed:withdraw:unpaid-shield-velka-en-taren"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:boundary-warn-unpaid-shield-velka-en-taren",
            "intention": {
              "kind": "warn",
              "label": "Acknowledge boundary terms"
            },
            "text": "Court. Second toll on the stair. Get it struck.",
            "disclosure": "deep",
            "firstEncounterSummary": null,
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-velka-en-taren"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-velka-en-taren"
              ]
            },
            "effects": {
              "add": [
                "boundary-acknowledged:unpaid-shield-velka-en-taren"
              ],
              "remove": []
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          },
          {
            "id": "dialogue:departure-unpaid-shield-velka-en-taren",
            "intention": {
              "kind": "leave",
              "label": "Velka En Taren departs over contract violation"
            },
            "text": "Porters’ bowl. No. Pay me out.",
            "disclosure": "essential",
            "firstEncounterSummary": "Velka En Taren leaves the party after a non-negotiable boundary was violated.",
            "prerequisites": {
              "all": [
                "hired:unpaid-shield-velka-en-taren",
                "boundary-breached:unpaid-shield-velka-en-taren"
              ],
              "any": [],
              "none": [
                "dead:unpaid-shield-velka-en-taren",
                "departed:unpaid-shield-velka-en-taren"
              ]
            },
            "effects": {
              "add": [
                "departed:unpaid-shield-velka-en-taren"
              ],
              "remove": [
                "companion-active:unpaid-shield-velka-en-taren"
              ]
            },
            "requiredIncentives": [],
            "requiredProtections": [],
            "socialDifficulty": null
          }
        ],
        "deathResponse": {
          "companionId": "person:companion-unpaid-shield-velka-en-taren",
          "name": "Velka En Taren",
          "templateId": "unpaid-shield",
          "memorialNote": "The shield is dented along the rim, bearing seven tally cuts. In the tunic is an unsubmitted receipt for eighteen cuts addressed to the Silt Stair labour depot.",
          "campNotice": "The shield stands upright by the tent flap, but no one has checked the strap rivets since dusk.",
          "witnessReaction": "He took two spear points that were meant for the outsider. He never asked whether the coin was real."
        },
        "absenceResponse": {
          "companionId": "person:companion-unpaid-shield-velka-en-taren",
          "name": "Velka En Taren",
          "templateId": "unpaid-shield",
          "reason": "Contract breached: unpaid military charges demanded without bond compensation.",
          "departureLine": "Porters’ bowl. No. Pay me out.",
          "campNotice": "An empty pallet and a neatly stacked pile of ration tins marked 'returned'."
        },
        "voice": {
          "voiceId": "shield-silent",
          "care": {
            "offered": "The {item} is welcome. I choose the moment.",
            "treat": "Need room. This wound first.",
            "remember": "{giver} spared supplies. I remember that.",
            "aid": "Sit. Your wound needs this more than mine.",
            "rememberAid": "I bound {patient}’s wound. My supplies. My choice."
          },
          "manner": "Very few words; fatalist; trusts coin, not people; cautious and independent.",
          "temperament": {
            "boldness": 2,
            "loyalty": 2
          },
          "obligation": "Paid by the hour, against a daughter’s bond. Stays out of charges.",
          "opening": "Daughter’s bonded. I guard. You pay. That is all of it.",
          "hire": "Coin first. Then I walk behind you.",
          "hired": "Paid. Here. Go on.",
          "refusal": "Not that one. Not for this pay.",
          "afterFight": {
            "guard": "He is dead. You are not. Count that and move.",
            "tunnel": "It did not know it was dead. Lucky."
          },
          "moment": {
            "request": "Court. Second toll on the stair. Get it struck.",
            "kept": "Struck. Good.",
            "broken": "Porters’ bowl. No. Pay me out."
          },
          "judgment": {
            "good": "Paid. Daughter’s bond is shorter. Thank you.",
            "bad": "You kept it running for a repair fund. I am done.",
            "depart": "You go. I stay till the escrow opens.",
            "mourning": "Shame. You paid on time."
          },
          "discuss": {
            "guard": {
              "accepted": "Close. Fine.",
              "refused": "I keep my own distance."
            },
            "engage": {
              "accepted": "If it is safe.",
              "refused": "No chasing. Not paid for it."
            },
            "withdraw": {
              "accepted": "Yes. Always.",
              "refused": "I choose when I go."
            }
          },
          "barks": {
            "engage": "Now.",
            "guard": "Behind me.",
            "hold": "Holding.",
            "withdraw": "Going. Follow or don’t.",
            "defend": "Saw it. Ready."
          },
          "returning": {
            "kept": "Worked for the last outsider. Paid on time. Lived. You?",
            "mourned": "Last outsider died at the kilns. Paid on time, though.",
            "absent": "Gone. Said the last outsider cost more than they paid."
          }
        }
      }
    ]
  },
  "locals": [
    {
      "candidateKey": "unpaid-shield-serun-an-anar",
      "templateId": "unpaid-shield",
      "templateTitle": "The Unpaid Shield",
      "archetype": "A former professional infantry soldier seeking the release of a dependent from a service debt. Usually protects exposed allies, dislikes unnecessary chases, and refuses unpaid military duties.",
      "culture": "Serekh",
      "name": "Serun an-Anar",
      "equipment": [
        "item:shield-round",
        "item:spear-bronze",
        "item:gambeson",
        "item:knife-belt"
      ],
      "person": {
        "id": "person:companion-unpaid-shield-serun-an-anar",
        "lineageKey": "lineage:unpaid-shield-serun-an-anar",
        "presentationKey": "presentation:actor-unpaid-shield-rotation",
        "kinshipKeys": [
          "kinship:unpaid-shield-serun-an-anar-dependent"
        ],
        "lifecycle": "active",
        "location": "Z01",
        "current": {
          "name": "Serun an-Anar",
          "origin": "disgraced-legionary",
          "culture": "Serekh",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "shield-discipline",
            "spear-drill"
          ],
          "abilities": [
            "brace-drill"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 10,
          "maxHp": 10,
          "allegiances": [],
          "oaths": [
            "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Conserve strength",
            "Protect the party"
          ],
          "memories": [
            "Arrived at Caldris seeking work under Serekh customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-unpaid-shield-serun-an-anar",
        "temperament": {
          "boldness": 4,
          "loyalty": 7
        },
        "obligations": [
          {
            "id": "obligation:unpaid-shield-dependent-debt-unpaid-shield-serun-an-anar",
            "description": "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "Nobody is paying for that charge. I will not buy my sister’s bread with a hole in me."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:unpaid-shield-danger-limit-unpaid-shield-serun-an-anar",
            "kind": "danger-limit",
            "dangerLimit": 36
          }
        ],
        "preferences": {
          "engage": 4,
          "guard": 7,
          "hold": 7,
          "withdraw": 7
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:unpaid-shield-unpaid-shield-serun-an-anar",
        "personId": "person:companion-unpaid-shield-serun-an-anar",
        "description": "Secure 24 cuts to discharge the sister's labour bond from the concession registry.",
        "prerequisites": {
          "all": [
            "hired:unpaid-shield-serun-an-anar"
          ],
          "any": [],
          "none": [
            "departed:unpaid-shield-serun-an-anar"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:unpaid-shield-unpaid-shield-serun-an-anar",
          "status": "achieved",
          "summary": "Paid 24 cuts directly to the concession clerk, securing the stamped deed of release for his sister.",
          "effects": {
            "add": [
              "obligation-resolved:unpaid-shield-serun-an-anar",
              "loyalty-proven:unpaid-shield-serun-an-anar"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:unpaid-shield-unpaid-shield-serun-an-anar",
          "status": "compromised",
          "summary": "Negotiated a half-term deferral with the Reeve in exchange for testimony against the concession bookkeeper.",
          "effects": {
            "add": [
              "obligation-compromised:unpaid-shield-serun-an-anar"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:unpaid-shield-unpaid-shield-serun-an-anar",
          "status": "abandoned",
          "summary": "Departed after the employer repeatedly refused to allocate contract shares towards the bond.",
          "effects": {
            "add": [
              "departed:unpaid-shield-serun-an-anar"
            ],
            "remove": [
              "companion-active:unpaid-shield-serun-an-anar"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-unpaid-shield-serun-an-anar",
          "intention": {
            "kind": "ask",
            "label": "Speak with Serun an-Anar (The Unpaid Shield)"
          },
          "text": "Forum watch, bridge end. We have not been paid in four months, so I stand here for nothing and count the captain’s sacks twice. My sister’s household was struck from the bread register in spring. If you are hiring, I cost less than the advocate’s men and I do not lie about a count.",
          "disclosure": "essential",
          "firstEncounterSummary": "Hire an experienced shieldman working to clear a family labour debt.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:unpaid-shield-serun-an-anar",
              "rejected:unpaid-shield-serun-an-anar",
              "dead:unpaid-shield-serun-an-anar"
            ]
          },
          "effects": {
            "add": [
              "met:unpaid-shield-serun-an-anar"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-unpaid-shield-serun-an-anar",
          "intention": {
            "kind": "offer",
            "label": "Agree to twelve-cut wage in escrow"
          },
          "text": "Twelve into escrow, paid out when the court’s errand is done. Good. I keep your left side, and I keep my hands off the archive grille. Those are my terms.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Serun an-Anar.",
          "prerequisites": {
            "all": [
              "met:unpaid-shield-serun-an-anar"
            ],
            "any": [],
            "none": [
              "hired:unpaid-shield-serun-an-anar",
              "dead:unpaid-shield-serun-an-anar"
            ]
          },
          "effects": {
            "add": [
              "hired:unpaid-shield-serun-an-anar",
              "companion-active:unpaid-shield-serun-an-anar"
            ],
            "remove": [
              "available:unpaid-shield-serun-an-anar"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "escrow:guaranteed-wage"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-unpaid-shield-serun-an-anar",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "Running a man down is the watch’s work when the watch is paid. It is not paid.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-serun-an-anar"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-serun-an-anar",
              "departed:unpaid-shield-serun-an-anar"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:unpaid-shield-serun-an-anar"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-unpaid-shield-serun-an-anar",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "Left side, one pace back. If I shout ‘stair’, step down, not back.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-serun-an-anar"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-serun-an-anar",
              "departed:unpaid-shield-serun-an-anar"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:unpaid-shield-serun-an-anar"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-unpaid-shield-serun-an-anar",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Agreed. Back to the bridge end; it is narrow, and narrow suits a shield.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-serun-an-anar"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-serun-an-anar",
              "departed:unpaid-shield-serun-an-anar"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:unpaid-shield-serun-an-anar"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-unpaid-shield-serun-an-anar",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "At the grain court, ask the registrar why the bonded households are struck. My sister’s name is on that list. Ask it where the queue can hear.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-serun-an-anar"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-serun-an-anar"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:unpaid-shield-serun-an-anar"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-unpaid-shield-serun-an-anar",
          "intention": {
            "kind": "leave",
            "label": "Serun an-Anar departs over contract violation"
          },
          "text": "You had the docket sealed over the struck names, my sister’s among them. I stood that bridge unpaid for that register. Find another shield.",
          "disclosure": "essential",
          "firstEncounterSummary": "Serun an-Anar leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-serun-an-anar",
              "boundary-breached:unpaid-shield-serun-an-anar"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-serun-an-anar",
              "departed:unpaid-shield-serun-an-anar"
            ]
          },
          "effects": {
            "add": [
              "departed:unpaid-shield-serun-an-anar"
            ],
            "remove": [
              "companion-active:unpaid-shield-serun-an-anar"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-unpaid-shield-serun-an-anar",
        "name": "Serun an-Anar",
        "templateId": "unpaid-shield",
        "memorialNote": "The shield is dented along the rim, bearing seven tally cuts. In the tunic is an unsubmitted receipt for eighteen cuts addressed to the Silt Stair labour depot.",
        "campNotice": "The shield stands upright by the tent flap, but no one has checked the strap rivets since dusk.",
        "witnessReaction": "He took two spear points that were meant for the outsider. He never asked whether the coin was real."
      },
      "absenceResponse": {
        "companionId": "person:companion-unpaid-shield-serun-an-anar",
        "name": "Serun an-Anar",
        "templateId": "unpaid-shield",
        "reason": "Contract breached: unpaid military charges demanded without bond compensation.",
        "departureLine": "You had the docket sealed over the struck names, my sister’s among them. I stood that bridge unpaid for that register. Find another shield.",
        "campNotice": "An empty pallet and a neatly stacked pile of ration tins marked 'returned'."
      },
      "voice": {
        "voiceId": "shield-bridge",
        "care": {
          "offered": "A {item}. The watch has waited four months for less useful pay.",
          "treat": "Someone else watch the crossing. I need a moment.",
          "remember": "{giver} supplied what the watch would not. That belongs in the account too.",
          "aid": "The crossing can wait. Sit here; I have supplies for that wound.",
          "rememberAid": "I tended {patient} after the fighting. My supplies, freely given. Put that in the account."
        },
        "manner": "Caldris bridge watchman, four months unpaid; wry, exact about hours and counts; proud the watch does not lie; steady, stays close.",
        "temperament": {
          "boldness": 4,
          "loyalty": 7
        },
        "obligation": "Wages to the register table, against my sister’s bond. No unpaid charges, and no breaking what the watch guards.",
        "opening": "Forum watch, bridge end. We have not been paid in four months, so I stand here for nothing and count the captain’s sacks twice. My sister’s household was struck from the bread register in spring. If you are hiring, I cost less than the advocate’s men and I do not lie about a count.",
        "hire": "Twelve into escrow, paid out when the court’s errand is done. Good. I keep your left side, and I keep my hands off the archive grille. Those are my terms.",
        "hired": "The watch will not miss me; it has not noticed me in four months. Where to? I know every stair in Caldris and which ones the clerks use.",
        "after": "Caldris is behind us. The watch still owes me four months; you owe me to the end of the road.",
        "refusal": "Nobody is paying for that charge. I will not buy my sister’s bread with a hole in me.",
        "moment": {
          "request": "At the grain court, ask the registrar why the bonded households are struck. My sister’s name is on that list. Ask it where the queue can hear.",
          "kept": "Read out first, before the seal went on. My sister heard her own name called from the table. I will stand any bridge you like.",
          "broken": "You had the docket sealed over the struck names, my sister’s among them. I stood that bridge unpaid for that register. Find another shield.",
          "heard": "They read the struck names out at the grain court before the seal went on, and my sister heard her own. They say that was you. If you are hiring, I will stand any bridge you like.",
          "standAside": "That grille is the watch’s post, paid or not. I will not break into the archive I am sworn to stand at. I will wait at the stair foot."
        },
        "judgment": {
          "good": "Paid, to the table, stamped. My sister eats from the register this winter. Tell the next outsider the bridge watch keeps its count.",
          "bad": "You fed the dead-work in Caldris to get what you came for. I will take the wage. I will not take the next job.",
          "depart": "You go through the cut; I go back to the bridge. The river keeps the same hours either way.",
          "mourning": "The escrow pays out whether you live or not. I will see the table gets it. Somebody should have told you how steep the archive stair is."
        },
        "discuss": {
          "guard": {
            "accepted": "Left side, one pace back. If I shout ‘stair’, step down, not back.",
            "refused": "Tied to your shoulder I cannot watch the stair behind us. I stand where I can see both."
          },
          "engage": {
            "accepted": "If he runs at us, yes. Chasing him across the forum, no.",
            "refused": "Running a man down is the watch’s work when the watch is paid. It is not paid."
          },
          "withdraw": {
            "accepted": "Agreed. Back to the bridge end; it is narrow, and narrow suits a shield.",
            "refused": "Not yet. The stair is behind us and it is steep. We hold here, or we fall down it."
          }
        },
        "barks": {
          "engage": "Now, while he is off his feet.",
          "guard": "Beside you. Keep moving.",
          "hold": "Holding the step.",
          "withdraw": "Down the stair. Slowly.",
          "defend": "That is the stroke they taught us at the crossing."
        },
        "returning": {
          "kept": "The last outsider I walked with paid the register table to the cut and went home alive. I told my sister about them. What are you here for?",
          "mourned": "The outsider before you died with my wage still in escrow. The table got it anyway. I would rather have had them back.",
          "absent": "Back with the forum watch, asking the captain for arrears. Paid in bread, the watch says."
        }
      },
      "beatId": "beat:z01-river-bridge",
      "moment": {
        "beatId": "beat:z01-grain-court",
        "prerequisites": {
          "all": [
            "z01:docket-read"
          ],
          "any": [],
          "none": [
            "z01:docket-sealed"
          ]
        },
        "kept": [
          "z01:households-restored"
        ],
        "broken": [
          "z01:register-standing"
        ],
        "sitsOut": [
          "z01-runner"
        ]
      }
    },
    {
      "candidateKey": "former-mortuary-guard-hela-kall",
      "templateId": "former-mortuary-guard",
      "templateTitle": "The Former Mortuary Guard",
      "archetype": "A funerary escort who left the concession after a disturbing incident in the Quiet Kilns. Uses a shield and short spear, recognises burial practices, and refuses corpse desecration.",
      "culture": "Orsene",
      "name": "Hela Kall",
      "equipment": [
        "item:shield-round",
        "item:spear-bronze",
        "item:gambeson",
        "item:oil-flask"
      ],
      "person": {
        "id": "person:companion-former-mortuary-guard-hela-kall",
        "lineageKey": "lineage:former-mortuary-guard-hela-kall",
        "presentationKey": "presentation:actor-mortuary-guard-rotation",
        "kinshipKeys": [
          "kinship:former-mortuary-guard-hela-kall-dependent"
        ],
        "lifecycle": "active",
        "location": "Z02",
        "current": {
          "name": "Hela Kall",
          "origin": "disgraced-legionary",
          "culture": "Orsene",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "funerary-vigil",
            "spear-drill"
          ],
          "abilities": [
            "thrust",
            "set-spear"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 9,
          "maxHp": 9,
          "allegiances": [],
          "oaths": [
            "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Seize the initiative",
            "Preserve independence"
          ],
          "memories": [
            "Arrived at Nacre Quay seeking work under Orsene customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-former-mortuary-guard-hela-kall",
        "temperament": {
          "boldness": 6,
          "loyalty": 5
        },
        "obligations": [
          {
            "id": "obligation:former-mortuary-guard-burial-sanctity-former-mortuary-guard-hela-kall",
            "description": "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "Not that. I have carried enough people who went in after somebody else’s cargo."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:former-mortuary-guard-danger-limit-former-mortuary-guard-hela-kall",
            "kind": "danger-limit",
            "dangerLimit": 34
          }
        ],
        "preferences": {
          "engage": 7,
          "guard": 4,
          "hold": 3,
          "withdraw": 3
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:former-mortuary-guard-former-mortuary-guard-hela-kall",
        "personId": "person:companion-former-mortuary-guard-hela-kall",
        "description": "Recover stolen corpse records and secure honest burial in salted earth for the desecrated kiln remains.",
        "prerequisites": {
          "all": [
            "hired:former-mortuary-guard-hela-kall"
          ],
          "any": [],
          "none": [
            "departed:former-mortuary-guard-hela-kall"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:former-mortuary-guard-former-mortuary-guard-hela-kall",
          "status": "achieved",
          "summary": "Recovered three stolen corpses from the cooling gallery and saw them properly interred in salted earth.",
          "effects": {
            "add": [
              "obligation-resolved:former-mortuary-guard-hela-kall",
              "loyalty-proven:former-mortuary-guard-hela-kall"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:former-mortuary-guard-former-mortuary-guard-hela-kall",
          "status": "compromised",
          "summary": "Allowed an unverified binder to perform a diagnostic inspection only under direct, armed supervision.",
          "effects": {
            "add": [
              "obligation-compromised:former-mortuary-guard-hela-kall"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:former-mortuary-guard-former-mortuary-guard-hela-kall",
          "status": "abandoned",
          "summary": "Severed ties after the player attempted to harvest limbs or bones for necromantic reagents.",
          "effects": {
            "add": [
              "departed:former-mortuary-guard-hela-kall"
            ],
            "remove": [
              "companion-active:former-mortuary-guard-hela-kall"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-former-mortuary-guard-hela-kall",
          "intention": {
            "kind": "ask",
            "label": "Speak with Hela Kall (The Former Mortuary Guard)"
          },
          "text": "I carry the drowned off the mole. Eleven this month. The Compact’s salvage clerk tags them and sells the ones with a story in them to the woman at the trestle tables. I stopped taking his wage. I will take yours, if you keep the dead out of it.",
          "disclosure": "essential",
          "firstEncounterSummary": "Hire a grim former necropolis watchman who demands strict reverence for the dead and physical proof of claims.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:former-mortuary-guard-hela-kall",
              "rejected:former-mortuary-guard-hela-kall",
              "dead:former-mortuary-guard-hela-kall"
            ]
          },
          "effects": {
            "add": [
              "met:former-mortuary-guard-hela-kall"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-former-mortuary-guard-hela-kall",
          "intention": {
            "kind": "offer",
            "label": "Pledge reverence to the mortuary vaults and pay fourteen cuts"
          },
          "text": "Twelve in escrow, paid when your business on this coast is done. I carry a spear as well as a bier. Do not ask me to carry either one for the tables.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Hela Kall.",
          "prerequisites": {
            "all": [
              "met:former-mortuary-guard-hela-kall"
            ],
            "any": [],
            "none": [
              "hired:former-mortuary-guard-hela-kall",
              "dead:former-mortuary-guard-hela-kall"
            ]
          },
          "effects": {
            "add": [
              "hired:former-mortuary-guard-hela-kall",
              "companion-active:former-mortuary-guard-hela-kall"
            ],
            "remove": [
              "available:former-mortuary-guard-hela-kall"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "covenant:no-desecration"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-former-mortuary-guard-hela-kall",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "I carry people off the mole. I do not put them in the water for a wage.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-hela-kall"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-hela-kall",
              "departed:former-mortuary-guard-hela-kall"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:former-mortuary-guard-hela-kall"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-former-mortuary-guard-hela-kall",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "I will walk at your shoulder. I have done it for coffins; you are lighter.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-hela-kall"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-hela-kall",
              "departed:former-mortuary-guard-hela-kall"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:former-mortuary-guard-hela-kall"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-former-mortuary-guard-hela-kall",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Back along the mole, then. Mind the weed on the steps.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-hela-kall"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-hela-kall",
              "departed:former-mortuary-guard-hela-kall"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:former-mortuary-guard-hela-kall"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-former-mortuary-guard-hela-kall",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "The pilot they pulled off the bar, Heddo, lies in the salvage shed with a price tied to his ankle. Claim him, and I will carry him up to the shrine myself.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-hela-kall"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-hela-kall"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:former-mortuary-guard-hela-kall"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-former-mortuary-guard-hela-kall",
          "intention": {
            "kind": "leave",
            "label": "Hela Kall departs over contract violation"
          },
          "text": "You paid the reader to put words in a drowned man’s mouth. I carried him out of the water. I will not walk behind you.",
          "disclosure": "essential",
          "firstEncounterSummary": "Hela Kall leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-hela-kall",
              "boundary-breached:former-mortuary-guard-hela-kall"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-hela-kall",
              "departed:former-mortuary-guard-hela-kall"
            ]
          },
          "effects": {
            "add": [
              "departed:former-mortuary-guard-hela-kall"
            ],
            "remove": [
              "companion-active:former-mortuary-guard-hela-kall"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-former-mortuary-guard-hela-kall",
        "name": "Hela Kall",
        "templateId": "former-mortuary-guard",
        "memorialNote": "A bronze shield bearing the faint silhouette of a laurel wreath, tarnished by tomb smoke. Beside it sits a small clay flask of holding salt and an unlit bronze lamp.",
        "campNotice": "The guard's spear is driven upright into the loam. A small pinch of salt has been scattered across the mound.",
        "witnessReaction": "She stood between the animated corpses and the altar until her spear snapped. She died keeping the threshold clean."
      },
      "absenceResponse": {
        "companionId": "person:companion-former-mortuary-guard-hela-kall",
        "name": "Hela Kall",
        "templateId": "former-mortuary-guard",
        "reason": "Boundary violated: desecration of burial remains or unproven necromantic practice.",
        "departureLine": "You paid the reader to put words in a drowned man’s mouth. I carried him out of the water. I will not walk behind you.",
        "campNotice": "A consecrated funeral tile left standing at the entrance to the abandoned gallery."
      },
      "voice": {
        "voiceId": "guard-mole",
        "care": {
          "offered": "I will keep the {item} above the tideline. Thank you.",
          "treat": "Enough blood for the water. I can stop this.",
          "remember": "{giver} brought medicine for me. Most people on the mole only count a body’s salvage.",
          "aid": "Sit above the wet stones. I kept the medicine dry. Let me see the wound.",
          "rememberAid": "I used my supplies on {patient}. No salvage claim. Just someone who needed tending."
        },
        "manner": "Drowned-bearer on the Nacre mole; plain-spoken, reads the tide like a clock, angry at the salvage trade; willing in a fight, keeps own counsel.",
        "temperament": {
          "boldness": 6,
          "loyalty": 5
        },
        "obligation": "Wages as agreed, and the drowned go into the ground, not onto the reading tables. I will not stand by while the dead are made to talk.",
        "opening": "I carry the drowned off the mole. Eleven this month. The Compact’s salvage clerk tags them and sells the ones with a story in them to the woman at the trestle tables. I stopped taking his wage. I will take yours, if you keep the dead out of it.",
        "hire": "Twelve in escrow, paid when your business on this coast is done. I carry a spear as well as a bier. Do not ask me to carry either one for the tables.",
        "hired": "Tide’s turning. If we go near the bonded warehouse, walk past the back wall quickly. I do not look at those tables any more.",
        "after": "The coast is behind us, and the tide will not miss me for a while. I walk with you as far as the cut.",
        "refusal": "Not that. I have carried enough people who went in after somebody else’s cargo.",
        "moment": {
          "request": "The pilot they pulled off the bar, Heddo, lies in the salvage shed with a price tied to his ankle. Claim him, and I will carry him up to the shrine myself.",
          "kept": "Heddo is in the ground above the tide line, under his own name. Nobody reads him now. That was all I wanted from this job.",
          "broken": "You paid the reader to put words in a drowned man’s mouth. I carried him out of the water. I will not walk behind you.",
          "heard": "You are the one who claimed Heddo from the salvage shed. I carried him up to the shrine myself, and nobody reads him now. If you are hiring, I will take your wage."
        },
        "judgment": {
          "good": "Paid, and the tide still comes in twice a day. Back to the mole. The drowned still need carrying; at least now they get a name first.",
          "bad": "You let the dead be read on this coast. I kept my side of the contract. Do not come looking for me on the mole.",
          "depart": "You go on. I stay with the water; it keeps bringing me work.",
          "mourning": "The escrow paid out to an empty hand. I have carried enough of those up from the water to know the weight."
        },
        "discuss": {
          "guard": {
            "accepted": "I will walk at your shoulder. I have done it for coffins; you are lighter.",
            "refused": "I fight where I can see the water. Your shoulder is not always near it."
          },
          "engage": {
            "accepted": "If he comes at us on the gangway, I will meet him there.",
            "refused": "I carry people off the mole. I do not put them in the water for a wage."
          },
          "withdraw": {
            "accepted": "Back along the mole, then. Mind the weed on the steps.",
            "refused": "Not with the dead lying unclaimed behind us. A bearer does not leave the bier in the road."
          }
        },
        "barks": {
          "engage": "Coming through.",
          "guard": "At your shoulder.",
          "hold": "Set. Let him come to the point.",
          "withdraw": "Off the gangway. Now.",
          "defend": "A wave gives warning. So do you."
        },
        "returning": {
          "kept": "The outsider before you paid me to the cut and never once asked me near the tables. I remember that. Do you mean to do the same?",
          "mourned": "The last outsider who hired me died before the tide turned. I carried them to the shrine. I would rather not do that twice.",
          "absent": "Back at the salvage shed on the clerk’s wage. The clerk, at least, admits what he sells."
        }
      },
      "beatId": "beat:z02-mole-berths",
      "moment": {
        "beatId": "beat:z02-bonded-warehouse",
        "prerequisites": {
          "all": [
            "z02:tables-seen"
          ],
          "any": [],
          "none": [
            "z02:heddo-buried",
            "z02:vos-hired"
          ]
        },
        "kept": [
          "z02:heddo-buried"
        ],
        "broken": [
          "z02:vos-hired"
        ]
      }
    },
    {
      "candidateKey": "displaced-mason-laren-sarn",
      "templateId": "displaced-mason",
      "templateTitle": "The Displaced Mason",
      "archetype": "A quarry or public-works worker with militia experience, heavy tools, and a family dependent on wages. Understands structures and refuses to destroy infrastructure people need.",
      "culture": "Orsene",
      "name": "Laren Sarn",
      "equipment": [
        "item:blade-iron",
        "item:knife-belt",
        "item:gambeson",
        "item:hook-sluicekeeper"
      ],
      "person": {
        "id": "person:companion-displaced-mason-laren-sarn",
        "lineageKey": "lineage:displaced-mason-laren-sarn",
        "presentationKey": "presentation:actor-outsider-axe-rotation",
        "kinshipKeys": [
          "kinship:displaced-mason-laren-sarn-dependent"
        ],
        "lifecycle": "active",
        "location": "Z06",
        "current": {
          "name": "Laren Sarn",
          "origin": "escaped-worker",
          "culture": "Orsene",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "quarry-masonry",
            "structural-knowledge"
          ],
          "abilities": [
            "pry-pawl",
            "cleave"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 10,
          "maxHp": 10,
          "allegiances": [],
          "oaths": [
            "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Seize the initiative",
            "Preserve independence"
          ],
          "memories": [
            "Arrived at the Broken Causeway seeking work under Orsene customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-displaced-mason-laren-sarn",
        "temperament": {
          "boldness": 7,
          "loyalty": 4
        },
        "obligations": [
          {
            "id": "obligation:displaced-mason-civil-infrastructure-displaced-mason-laren-sarn",
            "description": "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "No. I break stone for a living. I am not breaking my own neck for a day’s pay."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:displaced-mason-danger-limit-displaced-mason-laren-sarn",
            "kind": "danger-limit",
            "dangerLimit": 38
          }
        ],
        "preferences": {
          "engage": 7,
          "guard": 4,
          "hold": 3,
          "withdraw": 4
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:displaced-mason-displaced-mason-laren-sarn",
        "personId": "person:companion-displaced-mason-laren-sarn",
        "description": "Earn forty cuts and secure two sacks of flour for the dependents in the lower quarry barracks.",
        "prerequisites": {
          "all": [
            "hired:displaced-mason-laren-sarn"
          ],
          "any": [],
          "none": [
            "departed:displaced-mason-laren-sarn"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:displaced-mason-displaced-mason-laren-sarn",
          "status": "achieved",
          "summary": "Delivered forty cuts and sixty pounds of clean flour to the quarry quarters, securing food through the season.",
          "effects": {
            "add": [
              "obligation-resolved:displaced-mason-laren-sarn",
              "loyalty-proven:displaced-mason-laren-sarn"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:displaced-mason-displaced-mason-laren-sarn",
          "status": "compromised",
          "summary": "Accepted half-pay after refusing to collapse the canal arch, forcing the family onto quarter-rations.",
          "effects": {
            "add": [
              "obligation-compromised:displaced-mason-laren-sarn"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:displaced-mason-displaced-mason-laren-sarn",
          "status": "abandoned",
          "summary": "Walked away from the party after the player ordered the sluice gates smashed to flood the lower market.",
          "effects": {
            "add": [
              "departed:displaced-mason-laren-sarn"
            ],
            "remove": [
              "companion-active:displaced-mason-laren-sarn"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-displaced-mason-laren-sarn",
          "intention": {
            "kind": "ask",
            "label": "Speak with Laren Sarn (The Displaced Mason)"
          },
          "text": "Four years on this hoist. The keystone is cut, dressed and sitting in the yard, and every day we leave it there the lease pays the gang another day. Six at home eat off that day. I would still rather set it. If you are hiring, I lift, I hit hard, and I do not call a toll a job.",
          "disclosure": "essential",
          "firstEncounterSummary": "Recruit a muscular stoneworker fighting for family subsistence without compromising civic ethics.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:displaced-mason-laren-sarn",
              "rejected:displaced-mason-laren-sarn",
              "dead:displaced-mason-laren-sarn"
            ]
          },
          "effects": {
            "add": [
              "met:displaced-mason-laren-sarn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-displaced-mason-laren-sarn",
          "intention": {
            "kind": "offer",
            "label": "Guarantee twelve cuts and swear not to harm civil works"
          },
          "text": "Twelve in escrow, paid when your road work is done. Fair. I come as far as the court’s carts go. Past that, you are paying me for a walk.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Laren Sarn.",
          "prerequisites": {
            "all": [
              "met:displaced-mason-laren-sarn"
            ],
            "any": [],
            "none": [
              "hired:displaced-mason-laren-sarn",
              "dead:displaced-mason-laren-sarn"
            ]
          },
          "effects": {
            "add": [
              "hired:displaced-mason-laren-sarn",
              "companion-active:displaced-mason-laren-sarn"
            ],
            "remove": [
              "available:displaced-mason-laren-sarn"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "guarantee:civil-infrastructure"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-displaced-mason-laren-sarn",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "I hit what comes at us. I do not go looking for it; I am paid by the day, not by the skull.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-laren-sarn"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-laren-sarn",
              "departed:displaced-mason-laren-sarn"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:displaced-mason-laren-sarn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-displaced-mason-laren-sarn",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "I do not do shoulders. I stand where the weight comes down. Stand where you like.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-laren-sarn"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-laren-sarn",
              "departed:displaced-mason-laren-sarn"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:displaced-mason-laren-sarn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-displaced-mason-laren-sarn",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Back to the trestles. If he follows us onto the planks, he will regret the planks.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-laren-sarn"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-laren-sarn",
              "departed:displaced-mason-laren-sarn"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:displaced-mason-laren-sarn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-displaced-mason-laren-sarn",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "At the span, ask the mason on the hoist why the last arch has no keystone. He knows the clause better than I do, and he has more reason to be angry about it.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-laren-sarn"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-laren-sarn"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:displaced-mason-laren-sarn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-displaced-mason-laren-sarn",
          "intention": {
            "kind": "leave",
            "label": "Laren Sarn departs over contract violation"
          },
          "text": "You signed the court into the lease. That bridge stays broken now so somebody can bill for it. I am done lifting for you.",
          "disclosure": "essential",
          "firstEncounterSummary": "Laren Sarn leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:displaced-mason-laren-sarn",
              "boundary-breached:displaced-mason-laren-sarn"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-laren-sarn",
              "departed:displaced-mason-laren-sarn"
            ]
          },
          "effects": {
            "add": [
              "departed:displaced-mason-laren-sarn"
            ],
            "remove": [
              "companion-active:displaced-mason-laren-sarn"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-displaced-mason-laren-sarn",
        "name": "Laren Sarn",
        "templateId": "displaced-mason",
        "memorialNote": "A heavy leather apron crusted with lime and dried sweat. In the pocket is a copper token stamped with the quarry union mark, worn flat by nervous thumbs.",
        "campNotice": "A pile of chipped cobblestones sits neatly stacked by the bedroll. The mason's place in the meal line is vacant.",
        "witnessReaction": "He braced the cracked lintel with his own shoulders while the rest of us scrambled out. When the stone dropped, he didn't scream."
      },
      "absenceResponse": {
        "companionId": "person:companion-displaced-mason-laren-sarn",
        "name": "Laren Sarn",
        "templateId": "displaced-mason",
        "reason": "Boundary violated: deliberate destruction of civilian canal infrastructure.",
        "departureLine": "You signed the court into the lease. That bridge stays broken now so somebody can bill for it. I am done lifting for you.",
        "campNotice": "A heavy stone mallet laid across an unmortared boundary stone."
      },
      "voice": {
        "voiceId": "mason-hoist",
        "care": {
          "offered": "Put the {item} here. A crew ought to carry enough for each other.",
          "treat": "Hold that space. I have a wound to see to.",
          "remember": "{giver} shared supplies, without a lease or a receipt. That is how a crew ought to work.",
          "aid": "Set your weight down. The crew carries supplies for this. Let me help.",
          "rememberAid": "{patient} was hurt, and I had medicine. I did not need a lease to know what to do with it."
        },
        "manner": "Setter on the causeway hoist gang; blunt, counts in courses of stone, scorns the lease that pays for a bridge never finished; bold, keeps own counsel.",
        "temperament": {
          "boldness": 7,
          "loyalty": 4
        },
        "obligation": "Bread wages for six in the Dovren quarry huts, paid when the job ends. I will not help anyone keep a bridge broken, or break one.",
        "opening": "Four years on this hoist. The keystone is cut, dressed and sitting in the yard, and every day we leave it there the lease pays the gang another day. Six at home eat off that day. I would still rather set it. If you are hiring, I lift, I hit hard, and I do not call a toll a job.",
        "hire": "Twelve in escrow, paid when your road work is done. Fair. I come as far as the court’s carts go. Past that, you are paying me for a walk.",
        "hired": "Right. The plank bridge takes one cart at a time and complains about it. So do I. Where first?",
        "after": "The court’s carts are across. From here you are paying me for a walk, and I will take the walk.",
        "refusal": "No. I break stone for a living. I am not breaking my own neck for a day’s pay.",
        "moment": {
          "request": "At the span, ask the mason on the hoist why the last arch has no keystone. He knows the clause better than I do, and he has more reason to be angry about it.",
          "kept": "Keystone’s in. Four years of lease ended in an afternoon, and I will be out of work by the new moon. Worth it. My father set the first arch.",
          "broken": "You signed the court into the lease. That bridge stays broken now so somebody can bill for it. I am done lifting for you.",
          "heard": "You paid for the keystone. Four years of lease ended in an afternoon, and I am out of work by the new moon. My father set the first arch. If you want a mason at your back, I am cheap now."
        },
        "judgment": {
          "good": "Paid. Back to the stone, wherever there is stone to lift. I tell them who paid me in full.",
          "bad": "Coffins over my causeway and nobody looking under the canvas. I took your wage. I will not take your next job.",
          "depart": "You go on west, or wherever outsiders go. I go back to the stone.",
          "mourning": "The escrow paid out and nobody came to collect it. I set a stone at the end of the causeway for the last outsider. It sits level."
        },
        "discuss": {
          "guard": {
            "accepted": "I can stand near you. I am wide; get behind me if it helps.",
            "refused": "I do not do shoulders. I stand where the weight comes down. Stand where you like."
          },
          "engage": {
            "accepted": "Gladly. He is standing on my causeway.",
            "refused": "I hit what comes at us. I do not go looking for it; I am paid by the day, not by the skull."
          },
          "withdraw": {
            "accepted": "Back to the trestles. If he follows us onto the planks, he will regret the planks.",
            "refused": "Four years I have not backed off this causeway. I am not starting for a toll guard."
          }
        },
        "barks": {
          "engage": "Mine.",
          "guard": "Behind me.",
          "hold": "Stand. Let him come to the stone.",
          "withdraw": "Back. Mind the planks.",
          "defend": "Keep your balance. I am keeping mine."
        },
        "returning": {
          "kept": "The outsider before you paid me in full and never asked me to lie about a bridge. That is rarer than keystones. What do you want lifted?",
          "mourned": "I set a stone for the last outsider who hired me. It is at the end of the causeway, level. I would rather not set another.",
          "absent": "Took a place on the Compact’s gang, the one that never finishes. Steady pay. Unsteady work."
        }
      },
      "beatId": "beat:z06-repair-camp",
      "moment": {
        "beatId": "beat:z06-broken-span",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": [
            "z06:arch-closed",
            "z06:carts-across"
          ]
        },
        "kept": [
          "z06:arch-closed"
        ],
        "broken": [
          "z06:lease-signed"
        ]
      }
    }
  ]
}
